//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import moment from 'moment';
import { BaseService } from "./BaseService";
export module ClientService {

export class APIClient extends BaseService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param includeTypes (optional) 
     * @return OK
     */
    apiDefinition(includeTypes: boolean | undefined): Promise<ApplicationApiDescriptionModel> {
        let url_ = this.baseUrl + "/api/abp/api-definition?";
        if (includeTypes === null)
            throw new Error("The parameter 'includeTypes' cannot be null.");
        else if (includeTypes !== undefined)
            url_ += "IncludeTypes=" + encodeURIComponent("" + includeTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiDefinition(_response);
        });
    }

    protected processApiDefinition(response: Response): Promise<ApplicationApiDescriptionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationApiDescriptionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationApiDescriptionModel>(null as any);
    }

    /**
     * @param includeLocalizationResources (optional) 
     * @return OK
     */
    applicationConfiguration(includeLocalizationResources: boolean | undefined): Promise<ApplicationConfigurationDto> {
        let url_ = this.baseUrl + "/api/abp/application-configuration?";
        if (includeLocalizationResources === null)
            throw new Error("The parameter 'includeLocalizationResources' cannot be null.");
        else if (includeLocalizationResources !== undefined)
            url_ += "IncludeLocalizationResources=" + encodeURIComponent("" + includeLocalizationResources) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationConfiguration(_response);
        });
    }

    protected processApplicationConfiguration(response: Response): Promise<ApplicationConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationConfigurationDto>(null as any);
    }

    /**
     * @param onlyDynamics (optional) 
     * @return OK
     */
    applicationLocalization(cultureName: string | null, onlyDynamics: boolean | undefined): Promise<ApplicationLocalizationDto> {
        let url_ = this.baseUrl + "/api/abp/application-localization?";
        if (cultureName === undefined)
            throw new Error("The parameter 'cultureName' must be defined.");
        else if(cultureName !== null)
            url_ += "CultureName=" + encodeURIComponent("" + cultureName) + "&";
        if (onlyDynamics === null)
            throw new Error("The parameter 'onlyDynamics' cannot be null.");
        else if (onlyDynamics !== undefined)
            url_ += "OnlyDynamics=" + encodeURIComponent("" + onlyDynamics) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationLocalization(_response);
        });
    }

    protected processApplicationLocalization(response: Response): Promise<ApplicationLocalizationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationLocalizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationLocalizationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bankingPUT(id: string, body: AdminInfoBankingUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankingPUT(_response);
        });
    }

    protected processBankingPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    padInfoChangeRequestAll(fileId: string): Promise<PADInfoChangeRequestDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-info-change-request";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfoChangeRequestAll(_response);
        });
    }

    protected processPadInfoChangeRequestAll(response: Response): Promise<PADInfoChangeRequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PADInfoChangeRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADInfoChangeRequestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    padInfoChangeRequestPOST(fileId: string, body: PADInfoChangeRequestCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-info-change-request";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfoChangeRequestPOST(_response);
        });
    }

    protected processPadInfoChangeRequestPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    padInfoChangeRequestGET(id: string, fileId: string): Promise<PADInfoChangeRequestDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-info-change-request/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfoChangeRequestGET(_response);
        });
    }

    protected processPadInfoChangeRequestGET(response: Response): Promise<PADInfoChangeRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PADInfoChangeRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADInfoChangeRequestDto>(null as any);
    }

    /**
     * @param reviewStatus (optional) 
     * @param rejectionReason (optional) 
     * @param body (optional) 
     * @return OK
     */
    padInfoChangeRequestPUT(id: string, reviewStatus: PADRequestReviewStatusEnum | undefined, rejectionReason: string | null | undefined, fileId: string, body: PADInfoChangeRequestUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-info-change-request/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (reviewStatus === null)
            throw new Error("The parameter 'reviewStatus' cannot be null.");
        else if (reviewStatus !== undefined)
            url_ += "reviewStatus=" + encodeURIComponent("" + reviewStatus) + "&";
        if (rejectionReason !== undefined && rejectionReason !== null)
            url_ += "rejectionReason=" + encodeURIComponent("" + rejectionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfoChangeRequestPUT(_response);
        });
    }

    protected processPadInfoChangeRequestPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    bankingGET(fileId: string): Promise<AdminInfoBankingDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankingGET(_response);
        });
    }

    protected processBankingGET(response: Response): Promise<AdminInfoBankingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoBankingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoBankingDto>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleAll(fileId: string): Promise<PADScheduleDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleAll(_response);
        });
    }

    protected processPadScheduleAll(response: Response): Promise<PADScheduleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PADScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    padSchedulePUT(fileId: string, body: PADScheduleUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadSchedulePUT(_response);
        });
    }

    protected processPadSchedulePUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleSelectlist(fileId: string): Promise<PadScheduleSelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule-selectlist";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleSelectlist(_response);
        });
    }

    protected processPadScheduleSelectlist(response: Response): Promise<PadScheduleSelectListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PadScheduleSelectListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PadScheduleSelectListItemDto[]>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleGET(id: string, fileId: string): Promise<PADScheduleDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleGET(_response);
        });
    }

    protected processPadScheduleGET(response: Response): Promise<PADScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PADScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleDto>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleHistoryAll(fileId: string): Promise<PADScheduleHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule-history";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleHistoryAll(_response);
        });
    }

    protected processPadScheduleHistoryAll(response: Response): Promise<PADScheduleHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PADScheduleHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleHistoryDto[]>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleHistory(id: string, fileId: string): Promise<PADScheduleHistoryDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/pad-schedule-history/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleHistory(_response);
        });
    }

    protected processPadScheduleHistory(response: Response): Promise<PADScheduleHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PADScheduleHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleHistoryDto>(null as any);
    }

    /**
     * @param padScheduleId (optional) 
     * @return OK
     */
    padScheduleStateTypes(padScheduleId: string | undefined): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/pad-schedule-state-types?";
        if (padScheduleId === null)
            throw new Error("The parameter 'padScheduleId' cannot be null.");
        else if (padScheduleId !== undefined)
            url_ += "padScheduleId=" + encodeURIComponent("" + padScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleStateTypes(_response);
        });
    }

    protected processPadScheduleStateTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getBalanceInfo(fileId: string): Promise<BalanceInfoDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/banking/{fileId}/get-balance-info";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBalanceInfo(_response);
        });
    }

    protected processGetBalanceInfo(response: Response): Promise<BalanceInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BalanceInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BalanceInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    unsecuredGET(id: string): Promise<AdminInfoClaimsDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/unsecured";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsecuredGET(_response);
        });
    }

    protected processUnsecuredGET(response: Response): Promise<AdminInfoClaimsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoClaimsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoClaimsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unsecuredPUT(id: string, body: AdminInfoClaimsUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/unsecured";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsecuredPUT(_response);
        });
    }

    protected processUnsecuredPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    securedGET(id: string): Promise<AdminInfoAssetRealizationDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/secured";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSecuredGET(_response);
        });
    }

    protected processSecuredGET(response: Response): Promise<AdminInfoAssetRealizationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoAssetRealizationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoAssetRealizationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    securedPUT(id: string, body: AdminInfoAssetRealizationUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/secured";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSecuredPUT(_response);
        });
    }

    protected processSecuredPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param estateNumber (optional) 
     * @param sIN (optional) 
     * @param debtorName (optional) 
     * @param dateOfInsolvency (optional) 
     * @param creditorName (optional) 
     * @param accountNumber (optional) 
     * @return OK
     */
    searchExternal(estateNumber: string | null | undefined, sIN: string | null | undefined, debtorName: string | null | undefined, dateOfInsolvency: moment.Moment | undefined, creditorName: string | null | undefined, accountNumber: string | null | undefined): Promise<SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/search-external?";
        if (estateNumber !== undefined && estateNumber !== null)
            url_ += "EstateNumber=" + encodeURIComponent("" + estateNumber) + "&";
        if (sIN !== undefined && sIN !== null)
            url_ += "SIN=" + encodeURIComponent("" + sIN) + "&";
        if (debtorName !== undefined && debtorName !== null)
            url_ += "DebtorName=" + encodeURIComponent("" + debtorName) + "&";
        if (dateOfInsolvency === null)
            throw new Error("The parameter 'dateOfInsolvency' cannot be null.");
        else if (dateOfInsolvency !== undefined)
            url_ += "DateOfInsolvency=" + encodeURIComponent(dateOfInsolvency ? "" + dateOfInsolvency.toISOString() : "") + "&";
        if (creditorName !== undefined && creditorName !== null)
            url_ += "CreditorName=" + encodeURIComponent("" + creditorName) + "&";
        if (accountNumber !== undefined && accountNumber !== null)
            url_ += "AccountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchExternal(_response);
        });
    }

    protected processSearchExternal(response: Response): Promise<SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    receivedClaim(id: string): Promise<AppTaskActionDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/received-claim/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceivedClaim(_response);
        });
    }

    protected processReceivedClaim(response: Response): Promise<AppTaskActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskActionDto>(null as any);
    }

    /**
     * @return OK
     */
    claimFileGET(id: string): Promise<ClaimFileDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClaimFileGET(_response);
        });
    }

    protected processClaimFileGET(response: Response): Promise<ClaimFileDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimFileDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimFileDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    claimFilePUT(id: string, body: ClaimFileUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClaimFilePUT(_response);
        });
    }

    protected processClaimFilePUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    makeActive(id: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/{id}/make-active";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeActive(_response);
        });
    }

    protected processMakeActive(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkTaskAction(body: ClaimFileLinkInputDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/link-task-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkTaskAction(_response);
        });
    }

    protected processLinkTaskAction(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateChecklistDocuments(id: string | undefined, body: string[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/claim-file/update-checklist-documents?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateChecklistDocuments(_response);
        });
    }

    protected processUpdateChecklistDocuments(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param estateNumber (optional) 
     * @param isCompleted (optional) 
     * @param isSecured (optional) 
     * @param creditorName (optional) 
     * @param accountNumber (optional) 
     * @param externalLiabilityClaimIds (optional) 
     * @param externalDebtorFileId (optional) 
     * @param externalAssetId (optional) 
     * @param isSecuredWithoutAssets (optional) 
     * @param isLetterSent (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    liabilities(id: string, fileName: string | null | undefined, estateNumber: string | null | undefined, isCompleted: boolean | undefined, isSecured: boolean | undefined, creditorName: string | null | undefined, accountNumber: string | null | undefined, externalLiabilityClaimIds: (string | undefined)[] | undefined, externalDebtorFileId: string | null | undefined, externalAssetId: string | null | undefined, isSecuredWithoutAssets: boolean | undefined, isLetterSent: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<LiabilityClaimDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/liabilities?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (estateNumber !== undefined && estateNumber !== null)
            url_ += "EstateNumber=" + encodeURIComponent("" + estateNumber) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "IsCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (isSecured === null)
            throw new Error("The parameter 'isSecured' cannot be null.");
        else if (isSecured !== undefined)
            url_ += "IsSecured=" + encodeURIComponent("" + isSecured) + "&";
        if (creditorName !== undefined && creditorName !== null)
            url_ += "CreditorName=" + encodeURIComponent("" + creditorName) + "&";
        if (accountNumber !== undefined && accountNumber !== null)
            url_ += "AccountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (externalLiabilityClaimIds === null)
            throw new Error("The parameter 'externalLiabilityClaimIds' cannot be null.");
        else if (externalLiabilityClaimIds !== undefined)
            externalLiabilityClaimIds && externalLiabilityClaimIds.forEach(item => { url_ += "ExternalLiabilityClaimIds=" + encodeURIComponent("" + item) + "&"; });
        if (externalDebtorFileId !== undefined && externalDebtorFileId !== null)
            url_ += "ExternalDebtorFileId=" + encodeURIComponent("" + externalDebtorFileId) + "&";
        if (externalAssetId !== undefined && externalAssetId !== null)
            url_ += "ExternalAssetId=" + encodeURIComponent("" + externalAssetId) + "&";
        if (isSecuredWithoutAssets === null)
            throw new Error("The parameter 'isSecuredWithoutAssets' cannot be null.");
        else if (isSecuredWithoutAssets !== undefined)
            url_ += "IsSecuredWithoutAssets=" + encodeURIComponent("" + isSecuredWithoutAssets) + "&";
        if (isLetterSent === null)
            throw new Error("The parameter 'isLetterSent' cannot be null.");
        else if (isLetterSent !== undefined)
            url_ += "IsLetterSent=" + encodeURIComponent("" + isLetterSent) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLiabilities(_response);
        });
    }

    protected processLiabilities(response: Response): Promise<LiabilityClaimDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiabilityClaimDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiabilityClaimDto[]>(null as any);
    }

    /**
     * @param isSecured (optional) 
     * @param fileName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    assets(id: string, isSecured: boolean | undefined, fileName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<AssetDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/assets?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isSecured === null)
            throw new Error("The parameter 'isSecured' cannot be null.");
        else if (isSecured !== undefined)
            url_ += "IsSecured=" + encodeURIComponent("" + isSecured) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssets(_response);
        });
    }

    protected processAssets(response: Response): Promise<AssetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto[]>(null as any);
    }

    /**
     * @return OK
     */
    claimFiles(id: string, externalLiabilityClaimId: string | null): Promise<ClaimFileDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/{id}/liabilities/{externalLiabilityClaimId}/claim-files";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalLiabilityClaimId === undefined || externalLiabilityClaimId === null)
            throw new Error("The parameter 'externalLiabilityClaimId' must be defined.");
        url_ = url_.replace("{externalLiabilityClaimId}", encodeURIComponent("" + externalLiabilityClaimId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClaimFiles(_response);
        });
    }

    protected processClaimFiles(response: Response): Promise<ClaimFileDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClaimFileDto[]>(null as any);
    }

    /**
     * @param groupEnum (optional) 
     * @return OK
     */
    statusTypes(groupEnum: ClaimFileStatusGroupEnum | undefined): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/claims/status-types?";
        if (groupEnum === null)
            throw new Error("The parameter 'groupEnum' cannot be null.");
        else if (groupEnum !== undefined)
            url_ += "groupEnum=" + encodeURIComponent("" + groupEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStatusTypes(_response);
        });
    }

    protected processStatusTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    counsellingGET(id: string): Promise<AdminInfoCounsellingDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCounsellingGET(_response);
        });
    }

    protected processCounsellingGET(response: Response): Promise<AdminInfoCounsellingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoCounsellingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoCounsellingDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    counsellingPUT(id: string, body: AdminInfoCounsellingUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCounsellingPUT(_response);
        });
    }

    protected processCounsellingPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sessionPOST(id: string, body: AdminInfoCounsellingSessionCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}/session";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSessionPOST(_response);
        });
    }

    protected processSessionPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sessionPUT(id: string, body: AdminInfoCounsellingSessionUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}/session";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSessionPUT(_response);
        });
    }

    protected processSessionPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param sessionNumber (optional) 
     * @param includeRelatedDebtor (optional) 
     * @param relatedDebtorId (optional) 
     * @return OK
     */
    validateCreateSession(id: string, sessionNumber: number | undefined, includeRelatedDebtor: boolean | undefined, relatedDebtorId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}/validateCreateSession?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sessionNumber === null)
            throw new Error("The parameter 'sessionNumber' cannot be null.");
        else if (sessionNumber !== undefined)
            url_ += "SessionNumber=" + encodeURIComponent("" + sessionNumber) + "&";
        if (includeRelatedDebtor === null)
            throw new Error("The parameter 'includeRelatedDebtor' cannot be null.");
        else if (includeRelatedDebtor !== undefined)
            url_ += "IncludeRelatedDebtor=" + encodeURIComponent("" + includeRelatedDebtor) + "&";
        if (relatedDebtorId === null)
            throw new Error("The parameter 'relatedDebtorId' cannot be null.");
        else if (relatedDebtorId !== undefined)
            url_ += "RelatedDebtorId=" + encodeURIComponent("" + relatedDebtorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateCreateSession(_response);
        });
    }

    protected processValidateCreateSession(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    manual(id: string, body: AdminInfoCounsellingManualSessionCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/{id}/session/manual";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processManual(_response);
        });
    }

    protected processManual(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    dischargeGET(id: string): Promise<AdminInfoDischargeDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDischargeGET(_response);
        });
    }

    protected processDischargeGET(response: Response): Promise<AdminInfoDischargeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoDischargeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoDischargeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dischargePUT(id: string, body: AdminInfoDischargeUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDischargePUT(_response);
        });
    }

    protected processDischargePUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    fileDischargeFormGET(fileId: string): Promise<FileDischargeFormDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{fileId}/file-discharge-form";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFileDischargeFormGET(_response);
        });
    }

    protected processFileDischargeFormGET(response: Response): Promise<FileDischargeFormDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDischargeFormDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDischargeFormDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileDischargeFormPUT(fileId: string, body: FileDischargeFormUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{fileId}/file-discharge-form";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFileDischargeFormPUT(_response);
        });
    }

    protected processFileDischargeFormPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    mediationOfMode(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/lookup/mediation-of-mode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMediationOfMode(_response);
        });
    }

    protected processMediationOfMode(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    mediationStatus(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/lookup/mediation-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMediationStatus(_response);
        });
    }

    protected processMediationStatus(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    filingDate(fileId: string, body: DischargeFilingDateUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{fileId}/file-discharge-form/filing-date";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFilingDate(_response);
        });
    }

    protected processFilingDate(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    courtApperanceRequest(fileId: string, body: DischargeCourtApperanceRequestCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{fileId}/file-discharge-form/court-apperance-request";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCourtApperanceRequest(_response);
        });
    }

    protected processCourtApperanceRequest(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    courtApperanceResponse(fileId: string, body: DischargeCourtApperanceResponseCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/discharge/{fileId}/file-discharge-form/court-apperance-response";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCourtApperanceResponse(_response);
        });
    }

    protected processCourtApperanceResponse(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    generalGET(id: string): Promise<AdminInfoGeneralDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/general/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeneralGET(_response);
        });
    }

    protected processGeneralGET(response: Response): Promise<AdminInfoGeneralDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoGeneralDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoGeneralDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generalPUT(id: string, body: AdminInfoGeneralUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/general/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeneralPUT(_response);
        });
    }

    protected processGeneralPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    partialUpdateGeneralInfo(id: string, body: AdminInfoGeneralUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/general/{id}/partial-update-general-info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPartialUpdateGeneralInfo(_response);
        });
    }

    protected processPartialUpdateGeneralInfo(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    newIncomeExpense(appTaskActionId: string): Promise<AppTaskActionDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/new-income-expense/{appTaskActionId}";
        if (appTaskActionId === undefined || appTaskActionId === null)
            throw new Error("The parameter 'appTaskActionId' must be defined.");
        url_ = url_.replace("{appTaskActionId}", encodeURIComponent("" + appTaskActionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewIncomeExpense(_response);
        });
    }

    protected processNewIncomeExpense(response: Response): Promise<AppTaskActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskActionDto>(null as any);
    }

    /**
     * @return OK
     */
    incomeExpenseGET(id: string): Promise<AdminInfoIncomeExpenseDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeExpenseGET(_response);
        });
    }

    protected processIncomeExpenseGET(response: Response): Promise<AdminInfoIncomeExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoIncomeExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoIncomeExpenseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    incomeExpensePUT(id: string, body: AdminInfoIncomeExpenseUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeExpensePUT(_response);
        });
    }

    protected processIncomeExpensePUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    periods(id: string): Promise<IncomeExpenseSubmissionPeriodListItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/periods";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPeriods(_response);
        });
    }

    protected processPeriods(response: Response): Promise<IncomeExpenseSubmissionPeriodListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomeExpenseSubmissionPeriodListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPeriodListItemDto[]>(null as any);
    }

    /**
     * @return OK
     */
    schedulesAll(id: string): Promise<IncomeExpenseSubmissionPeriodDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/schedules";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSchedulesAll(_response);
        });
    }

    protected processSchedulesAll(response: Response): Promise<IncomeExpenseSubmissionPeriodDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomeExpenseSubmissionPeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPeriodDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkTaskAction2(body: IncomeExpenseSubmissionLinkDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/link-task-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkTaskAction2(_response);
        });
    }

    protected processLinkTaskAction2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    submissionsGET(id: string, submissionId: string): Promise<IncomeExpenseSubmissionDetailsDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmissionsGET(_response);
        });
    }

    protected processSubmissionsGET(response: Response): Promise<IncomeExpenseSubmissionDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeExpenseSubmissionDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionDetailsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submissionsPUT(id: string, submissionId: string, body: IncomeExpenseSubmissionUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmissionsPUT(_response);
        });
    }

    protected processSubmissionsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    doucmentIds(id: string, submissionId: string, body: UpdateSubmissionDocumentIdsDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/doucment-ids";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDoucmentIds(_response);
        });
    }

    protected processDoucmentIds(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    period(id: string, submissionId: string, body: MoveIncomeExpenseSubmissionPeriodDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/period";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPeriod(_response);
        });
    }

    protected processPeriod(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param externalIeScheduleId (optional) 
     * @return OK
     */
    submissionsAll(id: string, externalIeScheduleId: string | null | undefined): Promise<IncomeExpenseSubmissionDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalIeScheduleId !== undefined && externalIeScheduleId !== null)
            url_ += "externalIeScheduleId=" + encodeURIComponent("" + externalIeScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmissionsAll(_response);
        });
    }

    protected processSubmissionsAll(response: Response): Promise<IncomeExpenseSubmissionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomeExpenseSubmissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionDto[]>(null as any);
    }

    /**
     * @return OK
     */
    incomeItemsGET(id: string, submissionId: string): Promise<IncomeSubmissionDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/income-items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeItemsGET(_response);
        });
    }

    protected processIncomeItemsGET(response: Response): Promise<IncomeSubmissionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeSubmissionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeSubmissionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    incomeItemsPOST(id: string, submissionId: string, body: IncomeSubmissionItemUpsertDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/income-items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeItemsPOST(_response);
        });
    }

    protected processIncomeItemsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    expenseItemsGET(id: string, submissionId: string): Promise<ExpenseSubmissionDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/expense-items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpenseItemsGET(_response);
        });
    }

    protected processExpenseItemsGET(response: Response): Promise<ExpenseSubmissionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseSubmissionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseSubmissionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    expenseItemsPOST(id: string, submissionId: string, body: ExpenseSubmissionItemUpsertDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/expense-items";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpenseItemsPOST(_response);
        });
    }

    protected processExpenseItemsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    incomeSummary(id: string, submissionId: string): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/income-summary";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeSummary(_response);
        });
    }

    protected processIncomeSummary(response: Response): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @return OK
     */
    expenseSummary(id: string, submissionId: string): Promise<{ [key: string]: { [key: string]: number; }; }> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/expense-summary";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpenseSummary(_response);
        });
    }

    protected processExpenseSummary(response: Response): Promise<{ [key: string]: { [key: string]: number; }; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: { [key: string]: number; }; }>(null as any);
    }

    /**
     * @param superintendentStandard (optional) 
     * @return OK
     */
    incomeExpenseInfo(id: string, submissionId: string, superintendentStandard: number | undefined): Promise<IncomeExpenseInfoDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/income-expense-info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        if (superintendentStandard === null)
            throw new Error("The parameter 'superintendentStandard' cannot be null.");
        else if (superintendentStandard !== undefined)
            url_ += "superintendentStandard=" + encodeURIComponent("" + superintendentStandard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeExpenseInfo(_response);
        });
    }

    protected processIncomeExpenseInfo(response: Response): Promise<IncomeExpenseInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeExpenseInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    incomeItemsDELETE(id: string, submissionId: string, itemId: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/income-items/{itemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeItemsDELETE(_response);
        });
    }

    protected processIncomeItemsDELETE(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    expenseItemsDELETE(id: string, submissionId: string, itemId: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/income-expense/{id}/submissions/{submissionId}/expense-items/{itemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpenseItemsDELETE(_response);
        });
    }

    protected processExpenseItemsDELETE(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    receiptsDisbursementsGET(id: string): Promise<AdminInfoReceiptsDisbursementsDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/receipts-disbursements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsDisbursementsGET(_response);
        });
    }

    protected processReceiptsDisbursementsGET(response: Response): Promise<AdminInfoReceiptsDisbursementsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoReceiptsDisbursementsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoReceiptsDisbursementsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    receiptsDisbursementsPUT(id: string, body: AdminInfoReceiptsDisbursementsUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/receipts-disbursements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsDisbursementsPUT(_response);
        });
    }

    protected processReceiptsDisbursementsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    fileReceiptsDisbursementsFormGET(fileId: string): Promise<FileReceiptsDisbursementsFormDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/receipts-disbursements/{fileId}/file-receipts-disbursements-form";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFileReceiptsDisbursementsFormGET(_response);
        });
    }

    protected processFileReceiptsDisbursementsFormGET(response: Response): Promise<FileReceiptsDisbursementsFormDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileReceiptsDisbursementsFormDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileReceiptsDisbursementsFormDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileReceiptsDisbursementsFormPUT(fileId: string, body: FileReceiptsDisbursementsFormUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/receipts-disbursements/{fileId}/file-receipts-disbursements-form";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFileReceiptsDisbursementsFormPUT(_response);
        });
    }

    protected processFileReceiptsDisbursementsFormPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    filingDate2(fileId: string, body: ReceiptsDisbursementsFilingDateUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/receipts-disbursements/{fileId}/file-receipts-disbursements-form/filing-date";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFilingDate2(_response);
        });
    }

    protected processFilingDate2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    signUpGET(id: string): Promise<AdminInfoSignupDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/sign-up/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUpGET(_response);
        });
    }

    protected processSignUpGET(response: Response): Promise<AdminInfoSignupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoSignupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoSignupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signUpPUT(id: string, body: AdminInfoSignupUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/sign-up/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUpPUT(_response);
        });
    }

    protected processSignUpPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    newTaxReturn(appTaskActionId: string): Promise<AppTaskActionDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/new-tax-return/{appTaskActionId}";
        if (appTaskActionId === undefined || appTaskActionId === null)
            throw new Error("The parameter 'appTaskActionId' must be defined.");
        url_ = url_.replace("{appTaskActionId}", encodeURIComponent("" + appTaskActionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewTaxReturn(_response);
        });
    }

    protected processNewTaxReturn(response: Response): Promise<AppTaskActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskActionDto>(null as any);
    }

    /**
     * @return OK
     */
    taxReturnGET(id: string): Promise<AdminInfoTaxReturnDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnGET(_response);
        });
    }

    protected processTaxReturnGET(response: Response): Promise<AdminInfoTaxReturnDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoTaxReturnDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoTaxReturnDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taxReturnPUT(id: string, body: AdminInfoTaxReturnUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnPUT(_response);
        });
    }

    protected processTaxReturnPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    taxPeriods(id: string): Promise<TaxPeriodDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/{id}/tax-periods";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxPeriods(_response);
        });
    }

    protected processTaxPeriods(response: Response): Promise<TaxPeriodDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxPeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxPeriodDto[]>(null as any);
    }

    /**
     * @return OK
     */
    taxReturnPeriod(id: string): Promise<TaxReturnPeriodListItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/{id}/tax-return-period";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnPeriod(_response);
        });
    }

    protected processTaxReturnPeriod(response: Response): Promise<TaxReturnPeriodListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxReturnPeriodListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxReturnPeriodListItemDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    taxReturnPeriod2(fileId: string | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<TaxReturnPeriodListItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/tax-return-period?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnPeriod2(_response);
        });
    }

    protected processTaxReturnPeriod2(response: Response): Promise<TaxReturnPeriodListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxReturnPeriodListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxReturnPeriodListItemDto[]>(null as any);
    }

    /**
     * @return OK
     */
    taxReturnSubmissionGET(id: string): Promise<TaxReturnSubmissionDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/tax-return-submission/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnSubmissionGET(_response);
        });
    }

    protected processTaxReturnSubmissionGET(response: Response): Promise<TaxReturnSubmissionDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxReturnSubmissionDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxReturnSubmissionDetailDto>(null as any);
    }

    /**
     * @param taxReturnPeriodId (optional) 
     * @return OK
     */
    taxReturnSubmissionAll(taxReturnPeriodId: string | undefined): Promise<TaxReturnSubmissionListItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/tax-return-submission?";
        if (taxReturnPeriodId === null)
            throw new Error("The parameter 'taxReturnPeriodId' cannot be null.");
        else if (taxReturnPeriodId !== undefined)
            url_ += "taxReturnPeriodId=" + encodeURIComponent("" + taxReturnPeriodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnSubmissionAll(_response);
        });
    }

    protected processTaxReturnSubmissionAll(response: Response): Promise<TaxReturnSubmissionListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxReturnSubmissionListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxReturnSubmissionListItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taxReturnSubmissionPUT(body: TaxReturnSubmissionUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/tax-return-submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxReturnSubmissionPUT(_response);
        });
    }

    protected processTaxReturnSubmissionPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    sourceTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/source-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSourceTypes(_response);
        });
    }

    protected processSourceTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    submissionTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/submission-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmissionTypes(_response);
        });
    }

    protected processSubmissionTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    taxStatusTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/tax-status-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaxStatusTypes(_response);
        });
    }

    protected processTaxStatusTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    dispositionTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/disposition-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDispositionTypes(_response);
        });
    }

    protected processDispositionTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkTaskAction3(body: TaxReturnSubmissionLinkDto | undefined): Promise<SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/tax-return/link-task-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkTaskAction3(_response);
        });
    }

    protected processLinkTaskAction3(response: Response): Promise<SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(null as any);
    }

    /**
     * @param fileID (optional) 
     * @return OK
     */
    getOppositionLetter(fileID: string | undefined): Promise<OppositionLetterUpdateDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/GetOppositionLetter?";
        if (fileID === null)
            throw new Error("The parameter 'fileID' cannot be null.");
        else if (fileID !== undefined)
            url_ += "fileID=" + encodeURIComponent("" + fileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOppositionLetter(_response);
        });
    }

    protected processGetOppositionLetter(response: Response): Promise<OppositionLetterUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OppositionLetterUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OppositionLetterUpdateDto>(null as any);
    }

    /**
     * @param fileID (optional) 
     * @return OK
     */
    getOppositionLetterResponse(fileID: string | undefined): Promise<OppositionLetterResponseDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/GetOppositionLetterResponse?";
        if (fileID === null)
            throw new Error("The parameter 'fileID' cannot be null.");
        else if (fileID !== undefined)
            url_ += "fileID=" + encodeURIComponent("" + fileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOppositionLetterResponse(_response);
        });
    }

    protected processGetOppositionLetterResponse(response: Response): Promise<OppositionLetterResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OppositionLetterResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OppositionLetterResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOppositionLetter(body: OppositionLetterUpdateDto | undefined): Promise<FileDischargeFormDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/UpdateOppositionLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOppositionLetter(_response);
        });
    }

    protected processUpdateOppositionLetter(response: Response): Promise<FileDischargeFormDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDischargeFormDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDischargeFormDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOppositionLetterResponse(body: OppositionLetterResponseUpdateDto | undefined): Promise<FileDischargeFormDto> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/UpdateOppositionLetterResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOppositionLetterResponse(_response);
        });
    }

    protected processUpdateOppositionLetterResponse(response: Response): Promise<FileDischargeFormDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDischargeFormDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDischargeFormDto>(null as any);
    }

    /**
     * @return OK
     */
    padInfo(fileId: string): Promise<PublicPADInfoDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/{fileId}/pad-info";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfo(_response);
        });
    }

    protected processPadInfo(response: Response): Promise<PublicPADInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPADInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicPADInfoDto>(null as any);
    }

    /**
     * @param receiptDateFrom (optional) 
     * @param receiptDateTo (optional) 
     * @param isDeposited (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    padScheduleAll2(fileId: string, receiptDateFrom: moment.Moment | undefined, receiptDateTo: moment.Moment | undefined, isDeposited: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PADScheduleDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/{fileId}/pad-schedule?";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (receiptDateFrom === null)
            throw new Error("The parameter 'receiptDateFrom' cannot be null.");
        else if (receiptDateFrom !== undefined)
            url_ += "ReceiptDateFrom=" + encodeURIComponent(receiptDateFrom ? "" + receiptDateFrom.toISOString() : "") + "&";
        if (receiptDateTo === null)
            throw new Error("The parameter 'receiptDateTo' cannot be null.");
        else if (receiptDateTo !== undefined)
            url_ += "ReceiptDateTo=" + encodeURIComponent(receiptDateTo ? "" + receiptDateTo.toISOString() : "") + "&";
        if (isDeposited === null)
            throw new Error("The parameter 'isDeposited' cannot be null.");
        else if (isDeposited !== undefined)
            url_ += "IsDeposited=" + encodeURIComponent("" + isDeposited) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleAll2(_response);
        });
    }

    protected processPadScheduleAll2(response: Response): Promise<PADScheduleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PADScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    padSchedulePUT2(fileId: string, body: PADScheduleUpdatePublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/{fileId}/pad-schedule";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadSchedulePUT2(_response);
        });
    }

    protected processPadSchedulePUT2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    padScheduleGET2(id: string, fileId: string): Promise<PADScheduleDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/{fileId}/pad-schedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadScheduleGET2(_response);
        });
    }

    protected processPadScheduleGET2(response: Response): Promise<PADScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PADScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PADScheduleDto>(null as any);
    }

    /**
     * @param receiptDateFrom (optional) 
     * @param receiptDateTo (optional) 
     * @param isDeposited (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    count(receiptDateFrom: moment.Moment | undefined, receiptDateTo: moment.Moment | undefined, isDeposited: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/pad-schedule/count?";
        if (receiptDateFrom === null)
            throw new Error("The parameter 'receiptDateFrom' cannot be null.");
        else if (receiptDateFrom !== undefined)
            url_ += "ReceiptDateFrom=" + encodeURIComponent(receiptDateFrom ? "" + receiptDateFrom.toISOString() : "") + "&";
        if (receiptDateTo === null)
            throw new Error("The parameter 'receiptDateTo' cannot be null.");
        else if (receiptDateTo !== undefined)
            url_ += "ReceiptDateTo=" + encodeURIComponent(receiptDateTo ? "" + receiptDateTo.toISOString() : "") + "&";
        if (isDeposited === null)
            throw new Error("The parameter 'isDeposited' cannot be null.");
        else if (isDeposited !== undefined)
            url_ += "IsDeposited=" + encodeURIComponent("" + isDeposited) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    padInfoChangeRequestPOST2(fileId: string, body: PADInfoChangeRequestCreatePublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/{fileId}/pad-info-change-request";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPadInfoChangeRequestPOST2(_response);
        });
    }

    protected processPadInfoChangeRequestPOST2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    balanceInfo(): Promise<BalanceInfoDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/banking/balance-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBalanceInfo(_response);
        });
    }

    protected processBalanceInfo(response: Response): Promise<BalanceInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BalanceInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BalanceInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    dischargeGET2(id: string): Promise<AdminInfoDischargeDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/discharge/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDischargeGET2(_response);
        });
    }

    protected processDischargeGET2(response: Response): Promise<AdminInfoDischargeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoDischargeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoDischargeDto>(null as any);
    }

    /**
     * @param dueDate (optional) 
     * @param dueDateStart (optional) 
     * @param dueDateEnd (optional) 
     * @param statuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    schedulesAll2(dueDate: moment.Moment | undefined, dueDateStart: moment.Moment | undefined, dueDateEnd: moment.Moment | undefined, statuses: IncomeExpensePeriodStatusEnum[] | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<IncomeExpenseSubmissionPeriodDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/schedules?";
        if (dueDate === null)
            throw new Error("The parameter 'dueDate' cannot be null.");
        else if (dueDate !== undefined)
            url_ += "DueDate=" + encodeURIComponent(dueDate ? "" + dueDate.toISOString() : "") + "&";
        if (dueDateStart === null)
            throw new Error("The parameter 'dueDateStart' cannot be null.");
        else if (dueDateStart !== undefined)
            url_ += "DueDateStart=" + encodeURIComponent(dueDateStart ? "" + dueDateStart.toISOString() : "") + "&";
        if (dueDateEnd === null)
            throw new Error("The parameter 'dueDateEnd' cannot be null.");
        else if (dueDateEnd !== undefined)
            url_ += "DueDateEnd=" + encodeURIComponent(dueDateEnd ? "" + dueDateEnd.toISOString() : "") + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSchedulesAll2(_response);
        });
    }

    protected processSchedulesAll2(response: Response): Promise<IncomeExpenseSubmissionPeriodDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomeExpenseSubmissionPeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPeriodDto[]>(null as any);
    }

    /**
     * @return OK
     */
    schedules(periodId: string | null): Promise<IncomeExpenseSubmissionPeriodDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/schedules/{periodId}";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSchedules(_response);
        });
    }

    protected processSchedules(response: Response): Promise<IncomeExpenseSubmissionPeriodDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeExpenseSubmissionPeriodDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPeriodDto>(null as any);
    }

    /**
     * @return OK
     */
    activeSubmission(periodId: string | null): Promise<IncomeExpenseSubmissionPublicDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/schedules/{periodId}/active-submission";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActiveSubmission(_response);
        });
    }

    protected processActiveSubmission(response: Response): Promise<IncomeExpenseSubmissionPublicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeExpenseSubmissionPublicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPublicDto>(null as any);
    }

    /**
     * @return OK
     */
    previousActiveSubmission(periodId: string | null): Promise<IncomeExpenseSubmissionPublicDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/schedules/{periodId}/previous-active-submission";
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviousActiveSubmission(_response);
        });
    }

    protected processPreviousActiveSubmission(response: Response): Promise<IncomeExpenseSubmissionPublicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeExpenseSubmissionPublicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomeExpenseSubmissionPublicDto>(null as any);
    }

    /**
     * @return OK
     */
    periodStatus(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/lookup/period-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPeriodStatus(_response);
        });
    }

    protected processPeriodStatus(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body: IncomeExpenseSubmissionPublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/submissions/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPOST(body: IncomeExpenseSubmissionCreatePublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/income-expense/submissions/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitPOST(_response);
        });
    }

    protected processSubmitPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    signUpGET2(): Promise<AdminInfoSignupPublicDto> {
        let url_ = this.baseUrl + "/api/client-service-public/admin-info/sign-up";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignUpGET2(_response);
        });
    }

    protected processSignUpGET2(response: Response): Promise<AdminInfoSignupPublicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoSignupPublicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoSignupPublicDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addDocumentPrefix(body: DocumentPrefixDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/AddDocumentPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddDocumentPrefix(_response);
        });
    }

    protected processAddDocumentPrefix(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editDocumentPrefix(body: DocumentPrefixDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/EditDocumentPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditDocumentPrefix(_response);
        });
    }

    protected processEditDocumentPrefix(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDocumentPrefix(id: string | undefined): Promise<DocumentPrefixDto> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetDocumentPrefix?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentPrefix(_response);
        });
    }

    protected processGetDocumentPrefix(response: Response): Promise<DocumentPrefixDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPrefixDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentPrefixDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getDocumentPrefixList(filterText: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetDocumentPrefixList?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentPrefixList(_response);
        });
    }

    protected processGetDocumentPrefixList(response: Response): Promise<PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addHoliday(body: HolidayDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/AddHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddHoliday(_response);
        });
    }

    protected processAddHoliday(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editHoliday(body: HolidayDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/EditHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditHoliday(_response);
        });
    }

    protected processEditHoliday(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getHoliday(id: string | undefined): Promise<HolidayDto> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetHoliday?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHoliday(_response);
        });
    }

    protected processGetHoliday(response: Response): Promise<HolidayDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getHolidayList(filterText: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetHolidayList?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHolidayList(_response);
        });
    }

    protected processGetHolidayList(response: Response): Promise<PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    getMessageTemplateSystemFields(): Promise<MessageTemplateSystemFieldsDto> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetMessageTemplateSystemFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessageTemplateSystemFields(_response);
        });
    }

    protected processGetMessageTemplateSystemFields(response: Response): Promise<MessageTemplateSystemFieldsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageTemplateSystemFieldsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTemplateSystemFieldsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addMessageTemplate(body: MessageTemplateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/AddMessageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMessageTemplate(_response);
        });
    }

    protected processAddMessageTemplate(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editMessageTemplate(body: MessageTemplateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/EditMessageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditMessageTemplate(_response);
        });
    }

    protected processEditMessageTemplate(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMessageTemplate(id: string | undefined): Promise<MessageTemplateDto> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetMessageTemplate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessageTemplate(_response);
        });
    }

    protected processGetMessageTemplate(response: Response): Promise<MessageTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTemplateDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getMessageTemplateList(filterText: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/Administration/GetMessageTemplateList?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessageTemplateList(_response);
        });
    }

    protected processGetMessageTemplateList(response: Response): Promise<PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param year (optional) 
     * @param month (optional) 
     * @return OK
     */
    getAgentAvailability(year: number | undefined, month: number | undefined): Promise<AgentAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/GetAgentAvailability?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentAvailability(_response);
        });
    }

    protected processGetAgentAvailability(response: Response): Promise<AgentAvailabilityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentAvailabilityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentAvailabilityDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAgentAvailability(body: AgentAvailabilityDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/UpdateAgentAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAgentAvailability(_response);
        });
    }

    protected processUpdateAgentAvailability(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getWeeklySchedule(): Promise<WeeklyScheduleDto> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/GetWeeklySchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWeeklySchedule(_response);
        });
    }

    protected processGetWeeklySchedule(response: Response): Promise<WeeklyScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeeklyScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeeklyScheduleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertWeeklySchedule(body: WeeklyScheduleDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/UpsertWeeklySchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertWeeklySchedule(_response);
        });
    }

    protected processUpsertWeeklySchedule(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertWeeklyScheduleByUserId(userId: string, body: WeeklyScheduleDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/UpsertWeeklyScheduleByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertWeeklyScheduleByUserId(_response);
        });
    }

    protected processUpsertWeeklyScheduleByUserId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getWeeklyScheduleByUserId(userId: string): Promise<WeeklyScheduleDto> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/GetWeeklyScheduleByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWeeklyScheduleByUserId(_response);
        });
    }

    protected processGetWeeklyScheduleByUserId(response: Response): Promise<WeeklyScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeeklyScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeeklyScheduleDto>(null as any);
    }

    /**
     * @return OK
     */
    getAvailabilityOverridesByUserId(userId: string): Promise<AvailabilityOverrideDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/GetAvailabilityOverridesByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailabilityOverridesByUserId(_response);
        });
    }

    protected processGetAvailabilityOverridesByUserId(response: Response): Promise<AvailabilityOverrideDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityOverrideDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailabilityOverrideDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addAvailabilityOverrideByUserId(userId: string, body: AvailabilityOverrideDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/AddAvailabilityOverrideByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAvailabilityOverrideByUserId(_response);
        });
    }

    protected processAddAvailabilityOverrideByUserId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addAvailabilityOverridesByUserId(userId: string, body: AvailabilityOverrideDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/AddAvailabilityOverridesByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAvailabilityOverridesByUserId(_response);
        });
    }

    protected processAddAvailabilityOverridesByUserId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getAvailabilityOverrides(): Promise<AvailabilityOverrideDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/GetAvailabilityOverrides";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailabilityOverrides(_response);
        });
    }

    protected processGetAvailabilityOverrides(response: Response): Promise<AvailabilityOverrideDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityOverrideDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailabilityOverrideDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addAvailabilityOverride(body: AvailabilityOverrideDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/AddAvailabilityOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAvailabilityOverride(_response);
        });
    }

    protected processAddAvailabilityOverride(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param overrideId (optional) 
     * @return OK
     */
    deleteAvailabilityOverrideByUserId(userId: string | undefined, overrideId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/DeleteAvailabilityOverrideByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (overrideId === null)
            throw new Error("The parameter 'overrideId' cannot be null.");
        else if (overrideId !== undefined)
            url_ += "overrideId=" + encodeURIComponent("" + overrideId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAvailabilityOverrideByUserId(_response);
        });
    }

    protected processDeleteAvailabilityOverrideByUserId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param overrideId (optional) 
     * @return OK
     */
    deleteAvailabilityOverride(overrideId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/agent-availability/DeleteAvailabilityOverride?";
        if (overrideId === null)
            throw new Error("The parameter 'overrideId' cannot be null.");
        else if (overrideId !== undefined)
            url_ += "overrideId=" + encodeURIComponent("" + overrideId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAvailabilityOverride(_response);
        });
    }

    protected processDeleteAvailabilityOverride(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param fullName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    searchAgent(isActive: boolean | undefined, fullName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/SearchAgent?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (fullName !== undefined && fullName !== null)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAgent(_response);
        });
    }

    protected processSearchAgent(response: Response): Promise<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param fullName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(isActive: boolean | undefined, fullName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/GetList?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (fullName !== undefined && fullName !== null)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    get(id: string): Promise<AgentDto> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AgentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param teamTypes (optional) 
     * @return OK
     */
    isPartOfTeamTypes(id: string | undefined, teamTypes: TeamTypeEnum[] | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/IsPartOfTeamTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (teamTypes === null)
            throw new Error("The parameter 'teamTypes' cannot be null.");
        else if (teamTypes !== undefined)
            teamTypes && teamTypes.forEach(item => { url_ += "TeamTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsPartOfTeamTypes(_response);
        });
    }

    protected processIsPartOfTeamTypes(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    getAgentInfo(ids: string[] | undefined): Promise<AgentInfoDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/GetAgentInfo?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentInfo(_response);
        });
    }

    protected processGetAgentInfo(response: Response): Promise<AgentInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentInfoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAgentInfoBatch(body: GetAgentInfoInput | undefined): Promise<AgentInfoDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/GetAgentInfoBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentInfoBatch(_response);
        });
    }

    protected processGetAgentInfoBatch(response: Response): Promise<AgentInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentInfoDto[]>(null as any);
    }

    /**
     * @param oldAgentId (optional) 
     * @param newAgentId (optional) 
     * @return OK
     */
    assignTasksToAgent(oldAgentId: string | undefined, newAgentId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/AssignTasksToAgent?";
        if (oldAgentId === null)
            throw new Error("The parameter 'oldAgentId' cannot be null.");
        else if (oldAgentId !== undefined)
            url_ += "oldAgentId=" + encodeURIComponent("" + oldAgentId) + "&";
        if (newAgentId === null)
            throw new Error("The parameter 'newAgentId' cannot be null.");
        else if (newAgentId !== undefined)
            url_ += "newAgentId=" + encodeURIComponent("" + newAgentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignTasksToAgent(_response);
        });
    }

    protected processAssignTasksToAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param oldAgentId (optional) 
     * @param newAgentId (optional) 
     * @return OK
     */
    assignActionsToAgent(oldAgentId: string | undefined, newAgentId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/AssignActionsToAgent?";
        if (oldAgentId === null)
            throw new Error("The parameter 'oldAgentId' cannot be null.");
        else if (oldAgentId !== undefined)
            url_ += "oldAgentId=" + encodeURIComponent("" + oldAgentId) + "&";
        if (newAgentId === null)
            throw new Error("The parameter 'newAgentId' cannot be null.");
        else if (newAgentId !== undefined)
            url_ += "newAgentId=" + encodeURIComponent("" + newAgentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignActionsToAgent(_response);
        });
    }

    protected processAssignActionsToAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param oldAgentId (optional) 
     * @param newAgentId (optional) 
     * @return OK
     */
    assignAppointmentsToAgent(oldAgentId: string | undefined, newAgentId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/AssignAppointmentsToAgent?";
        if (oldAgentId === null)
            throw new Error("The parameter 'oldAgentId' cannot be null.");
        else if (oldAgentId !== undefined)
            url_ += "oldAgentId=" + encodeURIComponent("" + oldAgentId) + "&";
        if (newAgentId === null)
            throw new Error("The parameter 'newAgentId' cannot be null.");
        else if (newAgentId !== undefined)
            url_ += "newAgentId=" + encodeURIComponent("" + newAgentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignAppointmentsToAgent(_response);
        });
    }

    protected processAssignAppointmentsToAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param oldUserId (optional) 
     * @param estateAdminId (optional) 
     * @param trusteeId (optional) 
     * @param courtTrusteeId (optional) 
     * @return OK
     */
    updateEstatesAndTrustees(oldUserId: string | undefined, estateAdminId: string | undefined, trusteeId: string | undefined, courtTrusteeId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/UpdateEstatesAndTrustees?";
        if (oldUserId === null)
            throw new Error("The parameter 'oldUserId' cannot be null.");
        else if (oldUserId !== undefined)
            url_ += "oldUserId=" + encodeURIComponent("" + oldUserId) + "&";
        if (estateAdminId === null)
            throw new Error("The parameter 'estateAdminId' cannot be null.");
        else if (estateAdminId !== undefined)
            url_ += "estateAdminId=" + encodeURIComponent("" + estateAdminId) + "&";
        if (trusteeId === null)
            throw new Error("The parameter 'trusteeId' cannot be null.");
        else if (trusteeId !== undefined)
            url_ += "trusteeId=" + encodeURIComponent("" + trusteeId) + "&";
        if (courtTrusteeId === null)
            throw new Error("The parameter 'courtTrusteeId' cannot be null.");
        else if (courtTrusteeId !== undefined)
            url_ += "courtTrusteeId=" + encodeURIComponent("" + courtTrusteeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEstatesAndTrustees(_response);
        });
    }

    protected processUpdateEstatesAndTrustees(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    enqueueBulkTransfer(body: PdsUserBulkTransferInput | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/EnqueueBulkTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnqueueBulkTransfer(_response);
        });
    }

    protected processEnqueueBulkTransfer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAgent(body: AgentInput | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/CreateAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAgent(_response);
        });
    }

    protected processCreateAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAgent(body: AgentInput | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/UpdateAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAgent(_response);
        });
    }

    protected processUpdateAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    hasAgents(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasAgents?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasAgents(_response);
        });
    }

    protected processHasAgents(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    hasTaskActions(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasTaskActions?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasTaskActions(_response);
        });
    }

    protected processHasTaskActions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    hasEstateAdministratorFiles(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasEstateAdministratorFiles?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasEstateAdministratorFiles(_response);
        });
    }

    protected processHasEstateAdministratorFiles(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    hasAppointments(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasAppointments?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasAppointments(_response);
        });
    }

    protected processHasAppointments(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @return OK
     */
    hasTasks(agentId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasTasks?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasTasks(_response);
        });
    }

    protected processHasTasks(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    hasTrusteeCourts(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/HasTrusteeCourts?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasTrusteeCourts(_response);
        });
    }

    protected processHasTrusteeCourts(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @return OK
     */
    checkAgentIsEstateAdmin(agentId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/CheckAgentIsEstateAdmin?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAgentIsEstateAdmin(_response);
        });
    }

    protected processCheckAgentIsEstateAdmin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @return OK
     */
    checkAgentIsTrustee(agentId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-info/CheckAgentIsTrustee?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAgentIsTrustee(_response);
        });
    }

    protected processCheckAgentIsTrustee(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAgentSignatures(): Promise<AgentSignatureDto[]> {
        let url_ = this.baseUrl + "/api/client-service/agent-signature/GetAgentSignatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentSignatures(_response);
        });
    }

    protected processGetAgentSignatures(response: Response): Promise<AgentSignatureDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentSignatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentSignatureDto[]>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param signatureHash (optional) 
     * @param signature (optional) 
     * @return OK
     */
    assignAgentSignatureToDocument(documentId: string | undefined, signatureHash: string | null | undefined, signature: FileParameter | null | undefined): Promise<AssignSignatureStatusEnum> {
        let url_ = this.baseUrl + "/api/client-service/agent-signature/AssignAgentSignatureToDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (documentId === null || documentId === undefined)
            throw new Error("The parameter 'documentId' cannot be null.");
        else
            content_.append("DocumentId", documentId.toString());
        if (signatureHash !== null && signatureHash !== undefined)
            content_.append("SignatureHash", signatureHash.toString());
        if (signature !== null && signature !== undefined)
            content_.append("Signature", signature.data, signature.fileName ? signature.fileName : "Signature");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignAgentSignatureToDocument(_response);
        });
    }

    protected processAssignAgentSignatureToDocument(response: Response): Promise<AssignSignatureStatusEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignSignatureStatusEnum>(null as any);
    }

    /**
     * @param signatureSize (optional) 
     * @return OK
     */
    deleteAgentSignature(signatureSize: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-signature/DeleteAgentSignature?";
        if (signatureSize === null)
            throw new Error("The parameter 'signatureSize' cannot be null.");
        else if (signatureSize !== undefined)
            url_ += "signatureSize=" + encodeURIComponent("" + signatureSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAgentSignature(_response);
        });
    }

    protected processDeleteAgentSignature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param signatureHash (optional) 
     * @return OK
     */
    deleteSignature(signatureHash: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-signature/DeleteSignature?";
        if (signatureHash !== undefined && signatureHash !== null)
            url_ += "signatureHash=" + encodeURIComponent("" + signatureHash) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSignature(_response);
        });
    }

    protected processDeleteSignature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param signatureSize (optional) 
     * @return OK
     */
    deleteDocumentAgetnSignature(documentId: string | undefined, signatureSize: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/agent-signature/DeleteDocumentAgetnSignature?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (signatureSize === null)
            throw new Error("The parameter 'signatureSize' cannot be null.");
        else if (signatureSize !== undefined)
            url_ += "signatureSize=" + encodeURIComponent("" + signatureSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocumentAgetnSignature(_response);
        });
    }

    protected processDeleteDocumentAgetnSignature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @return OK
     */
    getNextAgent(teamId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/client-service/allocation/GetNextAgent?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextAgent(_response);
        });
    }

    protected processGetNextAgent(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @return OK
     */
    listAllocations(teamId: string | undefined): Promise<AgentAllocationDto> {
        let url_ = this.baseUrl + "/api/client-service/allocation/ListAllocations?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAllocations(_response);
        });
    }

    protected processListAllocations(response: Response): Promise<AgentAllocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgentAllocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentAllocationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllocations(body: AgentAllocationDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/allocation/UpdateAllocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAllocations(_response);
        });
    }

    protected processUpdateAllocations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param taskActionId (optional) 
     * @param teamId (optional) 
     * @return OK
     */
    distributeAllocations(taskActionId: string | undefined, teamId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/allocation/DistributeAllocations?";
        if (taskActionId === null)
            throw new Error("The parameter 'taskActionId' cannot be null.");
        else if (taskActionId !== undefined)
            url_ += "taskActionId=" + encodeURIComponent("" + taskActionId) + "&";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDistributeAllocations(_response);
        });
    }

    protected processDistributeAllocations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param inputTaskActionId (optional) 
     * @param inputTeamId (optional) 
     * @return OK
     */
    getAgentIdWithVacancy(inputTaskActionId: string | undefined, inputTeamId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/client-service/allocation/GetAgentIdWithVacancy?";
        if (inputTaskActionId === null)
            throw new Error("The parameter 'inputTaskActionId' cannot be null.");
        else if (inputTaskActionId !== undefined)
            url_ += "inputTaskActionId=" + encodeURIComponent("" + inputTaskActionId) + "&";
        if (inputTeamId === null)
            throw new Error("The parameter 'inputTeamId' cannot be null.");
        else if (inputTeamId !== undefined)
            url_ += "inputTeamId=" + encodeURIComponent("" + inputTeamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgentIdWithVacancy(_response);
        });
    }

    protected processGetAgentIdWithVacancy(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param createdDateMin (optional) 
     * @param createdDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList2(fileId: string | undefined, createdDateMin: moment.Moment | undefined, createdDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/emails/GetList?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (createdDateMin === null)
            throw new Error("The parameter 'createdDateMin' cannot be null.");
        else if (createdDateMin !== undefined)
            url_ += "CreatedDateMin=" + encodeURIComponent(createdDateMin ? "" + createdDateMin.toISOString() : "") + "&";
        if (createdDateMax === null)
            throw new Error("The parameter 'createdDateMax' cannot be null.");
        else if (createdDateMax !== undefined)
            url_ += "CreatedDateMax=" + encodeURIComponent(createdDateMax ? "" + createdDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList2(_response);
        });
    }

    protected processGetList2(response: Response): Promise<PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get2(id: string | undefined): Promise<AppEmailDto> {
        let url_ = this.baseUrl + "/api/client-service/emails/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<AppEmailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppEmailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppEmailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: AppEmailCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/emails/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resend(body: AppEmailResendDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/emails/Resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResend(_response);
        });
    }

    protected processResend(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update(id: string | undefined, body: AppEmailUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/emails/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/emails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileEmailAddress(fileId: string | undefined): Promise<FileEmailDto> {
        let url_ = this.baseUrl + "/api/client-service/emails/GetFileEmailAddress?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileEmailAddress(_response);
        });
    }

    protected processGetFileEmailAddress(response: Response): Promise<FileEmailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileEmailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileEmailDto>(null as any);
    }

    /**
     * @param fileID (optional) 
     * @param emailBody (optional) 
     * @return OK
     */
    applySystemfields(fileID: string | undefined, emailBody: string | null | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/client-service/emails/ApplySystemfields?";
        if (fileID === null)
            throw new Error("The parameter 'fileID' cannot be null.");
        else if (fileID !== undefined)
            url_ += "fileID=" + encodeURIComponent("" + fileID) + "&";
        if (emailBody !== undefined && emailBody !== null)
            url_ += "EmailBody=" + encodeURIComponent("" + emailBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplySystemfields(_response);
        });
    }

    protected processApplySystemfields(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param createdDateMin (optional) 
     * @param createdDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    emailTemplates(filterText: string | null | undefined, createdDateMin: moment.Moment | undefined, createdDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/email-templates?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (createdDateMin === null)
            throw new Error("The parameter 'createdDateMin' cannot be null.");
        else if (createdDateMin !== undefined)
            url_ += "CreatedDateMin=" + encodeURIComponent(createdDateMin ? "" + createdDateMin.toISOString() : "") + "&";
        if (createdDateMax === null)
            throw new Error("The parameter 'createdDateMax' cannot be null.");
        else if (createdDateMax !== undefined)
            url_ += "CreatedDateMax=" + encodeURIComponent(createdDateMax ? "" + createdDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailTemplates(_response);
        });
    }

    protected processEmailTemplates(response: Response): Promise<PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    emailTemplates2(id: string): Promise<AppEmailTemplateDto> {
        let url_ = this.baseUrl + "/api/client-service/email-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailTemplates2(_response);
        });
    }

    protected processEmailTemplates2(response: Response): Promise<AppEmailTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppEmailTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppEmailTemplateDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormAssets(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetListItem[]> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/ListAppFormAssets?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormAssets(_response);
        });
    }

    protected processListAppFormAssets(response: Response): Promise<AppFormAssetsDebtsAssetListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormAssetsDebtsAssetListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormAssetConfig(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetConfig> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/GetAppFormAssetConfig?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormAssetConfig(_response);
        });
    }

    protected processGetAppFormAssetConfig(response: Response): Promise<AppFormAssetsDebtsAssetConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsAssetConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetConfig>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    getAppFormAsset(assetId: string | undefined): Promise<AppFormAssetsDebtsAssetDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/GetAppFormAsset?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormAsset(_response);
        });
    }

    protected processGetAppFormAsset(response: Response): Promise<AppFormAssetsDebtsAssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsAssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAppFormAsset(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/CreateAppFormAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAppFormAsset(_response);
        });
    }

    protected processCreateAppFormAsset(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormAsset(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/UpdateAppFormAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormAsset(_response);
        });
    }

    protected processUpdateAppFormAsset(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    deleteAppFormAsset(assetId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/DeleteAppFormAsset?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormAsset(_response);
        });
    }

    protected processDeleteAppFormAsset(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormDebts(fileId: string | undefined): Promise<AppFormAssetsDebtsDebtListItem[]> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/ListAppFormDebts?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormDebts(_response);
        });
    }

    protected processListAppFormDebts(response: Response): Promise<AppFormAssetsDebtsDebtListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormAssetsDebtsDebtListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsDebtListItem[]>(null as any);
    }

    /**
     * @param debtId (optional) 
     * @return OK
     */
    getAppFormDebt(debtId: string | undefined): Promise<AppFormAssetsDebtsDebtDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/GetAppFormDebt?";
        if (debtId === null)
            throw new Error("The parameter 'debtId' cannot be null.");
        else if (debtId !== undefined)
            url_ += "debtId=" + encodeURIComponent("" + debtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormDebt(_response);
        });
    }

    protected processGetAppFormDebt(response: Response): Promise<AppFormAssetsDebtsDebtDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsDebtDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsDebtDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAppFormDebt(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/CreateAppFormDebt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAppFormDebt(_response);
        });
    }

    protected processCreateAppFormDebt(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormDebt(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/UpdateAppFormDebt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormDebt(_response);
        });
    }

    protected processUpdateAppFormDebt(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param debtId (optional) 
     * @return OK
     */
    deleteAppFormDebt(debtId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/DeleteAppFormDebt?";
        if (debtId === null)
            throw new Error("The parameter 'debtId' cannot be null.");
        else if (debtId !== undefined)
            url_ += "debtId=" + encodeURIComponent("" + debtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormDebt(_response);
        });
    }

    protected processDeleteAppFormDebt(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAssetsDebtsStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/GetAssetsDebtsStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsDebtsStatus(_response);
        });
    }

    protected processGetAssetsDebtsStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    assetsDebtsMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/AssetsDebtsMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssetsDebtsMarkAsComplete(_response);
        });
    }

    protected processAssetsDebtsMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    assetsDebtsMarkAsReviewed(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormAssetsDebts/AssetsDebtsMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssetsDebtsMarkAsReviewed(_response);
        });
    }

    protected processAssetsDebtsMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormAssets2(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetListItem[]> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/ListAppFormAssets?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormAssets2(_response);
        });
    }

    protected processListAppFormAssets2(response: Response): Promise<AppFormAssetsDebtsAssetListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormAssetsDebtsAssetListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormAssetConfig2(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetConfig> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/GetAppFormAssetConfig?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormAssetConfig2(_response);
        });
    }

    protected processGetAppFormAssetConfig2(response: Response): Promise<AppFormAssetsDebtsAssetConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsAssetConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetConfig>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    getAppFormAsset2(assetId: string | undefined): Promise<AppFormAssetsDebtsAssetDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/GetAppFormAsset?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormAsset2(_response);
        });
    }

    protected processGetAppFormAsset2(response: Response): Promise<AppFormAssetsDebtsAssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsAssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsAssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAppFormAsset2(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/CreateAppFormAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAppFormAsset2(_response);
        });
    }

    protected processCreateAppFormAsset2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormAsset2(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/UpdateAppFormAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormAsset2(_response);
        });
    }

    protected processUpdateAppFormAsset2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return OK
     */
    deleteAppFormAsset2(assetId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/DeleteAppFormAsset?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormAsset2(_response);
        });
    }

    protected processDeleteAppFormAsset2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormDebts2(fileId: string | undefined): Promise<AppFormAssetsDebtsDebtListItem[]> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/ListAppFormDebts?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormDebts2(_response);
        });
    }

    protected processListAppFormDebts2(response: Response): Promise<AppFormAssetsDebtsDebtListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormAssetsDebtsDebtListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsDebtListItem[]>(null as any);
    }

    /**
     * @param debtId (optional) 
     * @return OK
     */
    getAppFormDebt2(debtId: string | undefined): Promise<AppFormAssetsDebtsDebtDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/GetAppFormDebt?";
        if (debtId === null)
            throw new Error("The parameter 'debtId' cannot be null.");
        else if (debtId !== undefined)
            url_ += "debtId=" + encodeURIComponent("" + debtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormDebt2(_response);
        });
    }

    protected processGetAppFormDebt2(response: Response): Promise<AppFormAssetsDebtsDebtDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormAssetsDebtsDebtDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormAssetsDebtsDebtDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAppFormDebt2(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/CreateAppFormDebt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAppFormDebt2(_response);
        });
    }

    protected processCreateAppFormDebt2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormDebt2(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/UpdateAppFormDebt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormDebt2(_response);
        });
    }

    protected processUpdateAppFormDebt2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param debtId (optional) 
     * @return OK
     */
    deleteAppFormDebt2(debtId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/DeleteAppFormDebt?";
        if (debtId === null)
            throw new Error("The parameter 'debtId' cannot be null.");
        else if (debtId !== undefined)
            url_ += "debtId=" + encodeURIComponent("" + debtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormDebt2(_response);
        });
    }

    protected processDeleteAppFormDebt2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAssetsDebtsStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/GetAssetsDebtsStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsDebtsStatus2(_response);
        });
    }

    protected processGetAssetsDebtsStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    assetsDebtsMarkAsComplete2(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormAssetsDebts/AssetsDebtsMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssetsDebtsMarkAsComplete2(_response);
        });
    }

    protected processAssetsDebtsMarkAsComplete2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormBankingInfo(fileId: string | undefined): Promise<AppFormBankingInfoDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormBankingInfo/GetAppFormBankingInfo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormBankingInfo(_response);
        });
    }

    protected processGetAppFormBankingInfo(response: Response): Promise<AppFormBankingInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormBankingInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormBankingInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormBankingInfo(body: AppFormBankingInfoDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormBankingInfo/UpdateAppFormBankingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormBankingInfo(_response);
        });
    }

    protected processUpdateAppFormBankingInfo(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getBankingInfoStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormBankingInfo/GetBankingInfoStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBankingInfoStatus(_response);
        });
    }

    protected processGetBankingInfoStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    bankingInfoMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormBankingInfo/BankingInfoMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankingInfoMarkAsComplete(_response);
        });
    }

    protected processBankingInfoMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    bankingInfoMarkAsReviewed(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormBankingInfo/BankingInfoMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankingInfoMarkAsReviewed(_response);
        });
    }

    protected processBankingInfoMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormBankingInfo2(fileId: string | undefined): Promise<AppFormBankingInfoDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormBankingInfo/GetAppFormBankingInfo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormBankingInfo2(_response);
        });
    }

    protected processGetAppFormBankingInfo2(response: Response): Promise<AppFormBankingInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormBankingInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormBankingInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormBankingInfo2(body: AppFormBankingInfoDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormBankingInfo/UpdateAppFormBankingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormBankingInfo2(_response);
        });
    }

    protected processUpdateAppFormBankingInfo2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getBankingInfoStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormBankingInfo/GetBankingInfoStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBankingInfoStatus2(_response);
        });
    }

    protected processGetBankingInfoStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    bankingInfoMarkAsComplete2(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormBankingInfo/BankingInfoMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankingInfoMarkAsComplete2(_response);
        });
    }

    protected processBankingInfoMarkAsComplete2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormIncomeDetails(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/ListAppFormIncomeDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormIncomeDetails(_response);
        });
    }

    protected processListAppFormIncomeDetails(response: Response): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormIncomeExpenseIncomeDetailListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseIncomeDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormIncome(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/GetAppFormIncome?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormIncome(_response);
        });
    }

    protected processGetAppFormIncome(response: Response): Promise<AppFormIncomeExpenseIncomeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeExpenseIncomeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseIncomeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormIncome(body: AppFormIncomeExpenseIncomeDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/UpdateAppFormIncome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormIncome(_response);
        });
    }

    protected processUpdateAppFormIncome(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param incomeId (optional) 
     * @return OK
     */
    deleteAppFormIncome(incomeId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/DeleteAppFormIncome?";
        if (incomeId === null)
            throw new Error("The parameter 'incomeId' cannot be null.");
        else if (incomeId !== undefined)
            url_ += "incomeId=" + encodeURIComponent("" + incomeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormIncome(_response);
        });
    }

    protected processDeleteAppFormIncome(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormExpenseDetails(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/ListAppFormExpenseDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormExpenseDetails(_response);
        });
    }

    protected processListAppFormExpenseDetails(response: Response): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormIncomeExpenseExpenseDetailListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseExpenseDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormExpense(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/GetAppFormExpense?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormExpense(_response);
        });
    }

    protected processGetAppFormExpense(response: Response): Promise<AppFormIncomeExpenseExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeExpenseExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseExpenseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormExpense(body: AppFormIncomeExpenseExpenseDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/UpdateAppFormExpense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormExpense(_response);
        });
    }

    protected processUpdateAppFormExpense(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param expenseId (optional) 
     * @return OK
     */
    deleteAppFormExpense(expenseId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/DeleteAppFormExpense?";
        if (expenseId === null)
            throw new Error("The parameter 'expenseId' cannot be null.");
        else if (expenseId !== undefined)
            url_ += "expenseId=" + encodeURIComponent("" + expenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormExpense(_response);
        });
    }

    protected processDeleteAppFormExpense(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getIncomeExpenseStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/GetIncomeExpenseStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncomeExpenseStatus(_response);
        });
    }

    protected processGetIncomeExpenseStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    incomeExpenseMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/IncomeExpenseMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeExpenseMarkAsComplete(_response);
        });
    }

    protected processIncomeExpenseMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param markAsReviewType (optional) 
     * @return OK
     */
    incomeExpenseMarkAsReviewed(fileId: string | undefined, markAsReviewType: IncomeExpenseMarkAsReviewTypeEnum | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeExpense/IncomeExpenseMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (markAsReviewType === null)
            throw new Error("The parameter 'markAsReviewType' cannot be null.");
        else if (markAsReviewType !== undefined)
            url_ += "markAsReviewType=" + encodeURIComponent("" + markAsReviewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeExpenseMarkAsReviewed(_response);
        });
    }

    protected processIncomeExpenseMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormIncomeDetails2(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/ListAppFormIncomeDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormIncomeDetails2(_response);
        });
    }

    protected processListAppFormIncomeDetails2(response: Response): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormIncomeExpenseIncomeDetailListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseIncomeDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormIncome2(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/GetAppFormIncome?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormIncome2(_response);
        });
    }

    protected processGetAppFormIncome2(response: Response): Promise<AppFormIncomeExpenseIncomeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeExpenseIncomeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseIncomeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormIncome2(body: AppFormIncomeExpenseIncomeDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/UpdateAppFormIncome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormIncome2(_response);
        });
    }

    protected processUpdateAppFormIncome2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param incomeId (optional) 
     * @return OK
     */
    deleteAppFormIncome2(incomeId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/DeleteAppFormIncome?";
        if (incomeId === null)
            throw new Error("The parameter 'incomeId' cannot be null.");
        else if (incomeId !== undefined)
            url_ += "incomeId=" + encodeURIComponent("" + incomeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormIncome2(_response);
        });
    }

    protected processDeleteAppFormIncome2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppFormExpenseDetails2(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/ListAppFormExpenseDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppFormExpenseDetails2(_response);
        });
    }

    protected processListAppFormExpenseDetails2(response: Response): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFormIncomeExpenseExpenseDetailListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseExpenseDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormExpense2(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/GetAppFormExpense?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormExpense2(_response);
        });
    }

    protected processGetAppFormExpense2(response: Response): Promise<AppFormIncomeExpenseExpenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeExpenseExpenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeExpenseExpenseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormExpense2(body: AppFormIncomeExpenseExpenseDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/UpdateAppFormExpense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormExpense2(_response);
        });
    }

    protected processUpdateAppFormExpense2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param expenseId (optional) 
     * @return OK
     */
    deleteAppFormExpense2(expenseId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/DeleteAppFormExpense?";
        if (expenseId === null)
            throw new Error("The parameter 'expenseId' cannot be null.");
        else if (expenseId !== undefined)
            url_ += "expenseId=" + encodeURIComponent("" + expenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAppFormExpense2(_response);
        });
    }

    protected processDeleteAppFormExpense2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getIncomeExpenseStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeExpense/GetIncomeExpenseStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncomeExpenseStatus2(_response);
        });
    }

    protected processGetIncomeExpenseStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormIncomeTax(fileId: string | undefined): Promise<AppFormIncomeTaxDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeTax/GetAppFormIncomeTax?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormIncomeTax(_response);
        });
    }

    protected processGetAppFormIncomeTax(response: Response): Promise<AppFormIncomeTaxDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeTaxDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeTaxDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormIncomeTax(body: AppFormIncomeTaxDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeTax/UpdateAppFormIncomeTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormIncomeTax(_response);
        });
    }

    protected processUpdateAppFormIncomeTax(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getIncomeTaxStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeTax/GetIncomeTaxStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncomeTaxStatus(_response);
        });
    }

    protected processGetIncomeTaxStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    incomeTaxMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeTax/IncomeTaxMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeTaxMarkAsComplete(_response);
        });
    }

    protected processIncomeTaxMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    incomeTaxMarkAsReviewed(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormIncomeTax/IncomeTaxMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncomeTaxMarkAsReviewed(_response);
        });
    }

    protected processIncomeTaxMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormIncomeTax2(fileId: string | undefined): Promise<AppFormIncomeTaxDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeTax/GetAppFormIncomeTax?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormIncomeTax2(_response);
        });
    }

    protected processGetAppFormIncomeTax2(response: Response): Promise<AppFormIncomeTaxDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormIncomeTaxDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormIncomeTaxDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormIncomeTax2(body: AppFormIncomeTaxDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeTax/UpdateAppFormIncomeTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormIncomeTax2(_response);
        });
    }

    protected processUpdateAppFormIncomeTax2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getIncomeTaxStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormIncomeTax/GetIncomeTaxStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncomeTaxStatus2(_response);
        });
    }

    protected processGetIncomeTaxStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormPersonalInfo(fileId: string | undefined): Promise<AppFormPersonalInfoDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/GetAppFormPersonalInfo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormPersonalInfo(_response);
        });
    }

    protected processGetAppFormPersonalInfo(response: Response): Promise<AppFormPersonalInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormPersonalInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormPersonalInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormPersonalInfo(body: AppFormPersonalInfoDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/UpdateAppFormPersonalInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormPersonalInfo(_response);
        });
    }

    protected processUpdateAppFormPersonalInfo(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getPersonalInfoStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/GetPersonalInfoStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPersonalInfoStatus(_response);
        });
    }

    protected processGetPersonalInfoStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    personalInfoMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/PersonalInfoMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPersonalInfoMarkAsComplete(_response);
        });
    }

    protected processPersonalInfoMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormStatus(fileId: string | undefined): Promise<AppFormStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/GetAppFormStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormStatus(_response);
        });
    }

    protected processGetAppFormStatus(response: Response): Promise<AppFormStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    personalInfoMarkAsReviewed(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormPersonalInfo/PersonalInfoMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPersonalInfoMarkAsReviewed(_response);
        });
    }

    protected processPersonalInfoMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormPersonalInfo2(fileId: string | undefined): Promise<AppFormPersonalInfoDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormPersonalInfo/GetAppFormPersonalInfo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormPersonalInfo2(_response);
        });
    }

    protected processGetAppFormPersonalInfo2(response: Response): Promise<AppFormPersonalInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormPersonalInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormPersonalInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormPersonalInfo2(body: AppFormPersonalInfoDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormPersonalInfo/UpdateAppFormPersonalInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormPersonalInfo2(_response);
        });
    }

    protected processUpdateAppFormPersonalInfo2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getPersonalInfoStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormPersonalInfo/GetPersonalInfoStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPersonalInfoStatus2(_response);
        });
    }

    protected processGetPersonalInfoStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    personalInfoMarkAsComplete2(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormPersonalInfo/PersonalInfoMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPersonalInfoMarkAsComplete2(_response);
        });
    }

    protected processPersonalInfoMarkAsComplete2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormStatus2(fileId: string | undefined): Promise<AppFormStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormPersonalInfo/GetAppFormStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormStatus2(_response);
        });
    }

    protected processGetAppFormStatus2(response: Response): Promise<AppFormStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormQuestionnaire(fileId: string | undefined): Promise<AppFormQuestionnaireDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormQuestionnaire/GetAppFormQuestionnaire?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormQuestionnaire(_response);
        });
    }

    protected processGetAppFormQuestionnaire(response: Response): Promise<AppFormQuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormQuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormQuestionnaireDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormQuestionnaire(body: AppFormQuestionnaireDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormQuestionnaire/UpdateAppFormQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormQuestionnaire(_response);
        });
    }

    protected processUpdateAppFormQuestionnaire(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getQuestionnaireStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/AppFormQuestionnaire/GetQuestionnaireStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionnaireStatus(_response);
        });
    }

    protected processGetQuestionnaireStatus(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    questionnaireMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormQuestionnaire/QuestionnaireMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuestionnaireMarkAsComplete(_response);
        });
    }

    protected processQuestionnaireMarkAsComplete(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    questionnaireMarkAsReviewed(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/AppFormQuestionnaire/QuestionnaireMarkAsReviewed?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuestionnaireMarkAsReviewed(_response);
        });
    }

    protected processQuestionnaireMarkAsReviewed(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAppFormQuestionnaire2(fileId: string | undefined): Promise<AppFormQuestionnaireDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormQuestionnaire/GetAppFormQuestionnaire?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppFormQuestionnaire2(_response);
        });
    }

    protected processGetAppFormQuestionnaire2(response: Response): Promise<AppFormQuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormQuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormQuestionnaireDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppFormQuestionnaire2(body: AppFormQuestionnaireDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormQuestionnaire/UpdateAppFormQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppFormQuestionnaire2(_response);
        });
    }

    protected processUpdateAppFormQuestionnaire2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getQuestionnaireStatus2(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormQuestionnaire/GetQuestionnaireStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionnaireStatus2(_response);
        });
    }

    protected processGetQuestionnaireStatus2(response: Response): Promise<AppFormSectionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFormSectionStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    questionnaireMarkAsComplete2(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/AppFormQuestionnaire/QuestionnaireMarkAsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuestionnaireMarkAsComplete2(_response);
        });
    }

    protected processQuestionnaireMarkAsComplete2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param fileNames (optional) 
     * @param ids (optional) 
     * @param debtorName (optional) 
     * @param debtorFullNameSearch (optional) 
     * @param estateNumber (optional) 
     * @param dateOfInsolvency (optional) 
     * @param dischargeDate (optional) 
     * @param form15FilingDate (optional) 
     * @param form16FilingDate (optional) 
     * @param form58FilingDate (optional) 
     * @param isTrusteeDischarged (optional) 
     * @param isFileClosed (optional) 
     * @param dischargeTypeName (optional) 
     * @param dischargeTypeLastUpdateDate (optional) 
     * @param isActive (optional) 
     * @param sIN (optional) 
     * @param hasCompletedSignup (optional) 
     * @param fileProcess (optional) 
     * @param fileProcessStatus (optional) 
     * @param isFileProcessNotComplete (optional) 
     * @param daysSinceFileProcessStatusUpdated (optional) 
     * @param filingTypes (optional) 
     * @param fileStage (optional) 
     * @param fileStages (optional) 
     * @param emailAddresses (optional) 
     * @param isAuth0UserCreatedForLegacyFile (optional) 
     * @param mainPhoneDoNotSMS (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    applicationFileGET(fileName: string | null | undefined, fileNames: (string | undefined)[] | undefined, ids: string[] | undefined, debtorName: string | null | undefined, debtorFullNameSearch: string | null | undefined, estateNumber: string | null | undefined, dateOfInsolvency: moment.Moment | undefined, dischargeDate: moment.Moment | undefined, form15FilingDate: moment.Moment | undefined, form16FilingDate: moment.Moment | undefined, form58FilingDate: moment.Moment | undefined, isTrusteeDischarged: boolean | undefined, isFileClosed: boolean | undefined, dischargeTypeName: string | null | undefined, dischargeTypeLastUpdateDate: moment.Moment | undefined, isActive: boolean | undefined, sIN: string | null | undefined, hasCompletedSignup: boolean | undefined, fileProcess: FileProcessEnum | undefined, fileProcessStatus: FileProcessStatusEnum | undefined, isFileProcessNotComplete: boolean | undefined, daysSinceFileProcessStatusUpdated: number | undefined, filingTypes: FilingTypeEnum[] | undefined, fileStage: FileStageEnum | undefined, fileStages: FileStageEnum[] | undefined, emailAddresses: (string | undefined)[] | undefined, isAuth0UserCreatedForLegacyFile: boolean | undefined, mainPhoneDoNotSMS: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/application-file?";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileNames === null)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else if (fileNames !== undefined)
            fileNames && fileNames.forEach(item => { url_ += "FileNames=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (debtorName !== undefined && debtorName !== null)
            url_ += "DebtorName=" + encodeURIComponent("" + debtorName) + "&";
        if (debtorFullNameSearch !== undefined && debtorFullNameSearch !== null)
            url_ += "DebtorFullNameSearch=" + encodeURIComponent("" + debtorFullNameSearch) + "&";
        if (estateNumber !== undefined && estateNumber !== null)
            url_ += "EstateNumber=" + encodeURIComponent("" + estateNumber) + "&";
        if (dateOfInsolvency === null)
            throw new Error("The parameter 'dateOfInsolvency' cannot be null.");
        else if (dateOfInsolvency !== undefined)
            url_ += "DateOfInsolvency=" + encodeURIComponent(dateOfInsolvency ? "" + dateOfInsolvency.toISOString() : "") + "&";
        if (dischargeDate === null)
            throw new Error("The parameter 'dischargeDate' cannot be null.");
        else if (dischargeDate !== undefined)
            url_ += "DischargeDate=" + encodeURIComponent(dischargeDate ? "" + dischargeDate.toISOString() : "") + "&";
        if (form15FilingDate === null)
            throw new Error("The parameter 'form15FilingDate' cannot be null.");
        else if (form15FilingDate !== undefined)
            url_ += "Form15FilingDate=" + encodeURIComponent(form15FilingDate ? "" + form15FilingDate.toISOString() : "") + "&";
        if (form16FilingDate === null)
            throw new Error("The parameter 'form16FilingDate' cannot be null.");
        else if (form16FilingDate !== undefined)
            url_ += "Form16FilingDate=" + encodeURIComponent(form16FilingDate ? "" + form16FilingDate.toISOString() : "") + "&";
        if (form58FilingDate === null)
            throw new Error("The parameter 'form58FilingDate' cannot be null.");
        else if (form58FilingDate !== undefined)
            url_ += "Form58FilingDate=" + encodeURIComponent(form58FilingDate ? "" + form58FilingDate.toISOString() : "") + "&";
        if (isTrusteeDischarged === null)
            throw new Error("The parameter 'isTrusteeDischarged' cannot be null.");
        else if (isTrusteeDischarged !== undefined)
            url_ += "IsTrusteeDischarged=" + encodeURIComponent("" + isTrusteeDischarged) + "&";
        if (isFileClosed === null)
            throw new Error("The parameter 'isFileClosed' cannot be null.");
        else if (isFileClosed !== undefined)
            url_ += "IsFileClosed=" + encodeURIComponent("" + isFileClosed) + "&";
        if (dischargeTypeName !== undefined && dischargeTypeName !== null)
            url_ += "DischargeTypeName=" + encodeURIComponent("" + dischargeTypeName) + "&";
        if (dischargeTypeLastUpdateDate === null)
            throw new Error("The parameter 'dischargeTypeLastUpdateDate' cannot be null.");
        else if (dischargeTypeLastUpdateDate !== undefined)
            url_ += "DischargeTypeLastUpdateDate=" + encodeURIComponent(dischargeTypeLastUpdateDate ? "" + dischargeTypeLastUpdateDate.toISOString() : "") + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sIN !== undefined && sIN !== null)
            url_ += "SIN=" + encodeURIComponent("" + sIN) + "&";
        if (hasCompletedSignup === null)
            throw new Error("The parameter 'hasCompletedSignup' cannot be null.");
        else if (hasCompletedSignup !== undefined)
            url_ += "HasCompletedSignup=" + encodeURIComponent("" + hasCompletedSignup) + "&";
        if (fileProcess === null)
            throw new Error("The parameter 'fileProcess' cannot be null.");
        else if (fileProcess !== undefined)
            url_ += "FileProcess=" + encodeURIComponent("" + fileProcess) + "&";
        if (fileProcessStatus === null)
            throw new Error("The parameter 'fileProcessStatus' cannot be null.");
        else if (fileProcessStatus !== undefined)
            url_ += "FileProcessStatus=" + encodeURIComponent("" + fileProcessStatus) + "&";
        if (isFileProcessNotComplete === null)
            throw new Error("The parameter 'isFileProcessNotComplete' cannot be null.");
        else if (isFileProcessNotComplete !== undefined)
            url_ += "IsFileProcessNotComplete=" + encodeURIComponent("" + isFileProcessNotComplete) + "&";
        if (daysSinceFileProcessStatusUpdated === null)
            throw new Error("The parameter 'daysSinceFileProcessStatusUpdated' cannot be null.");
        else if (daysSinceFileProcessStatusUpdated !== undefined)
            url_ += "DaysSinceFileProcessStatusUpdated=" + encodeURIComponent("" + daysSinceFileProcessStatusUpdated) + "&";
        if (filingTypes === null)
            throw new Error("The parameter 'filingTypes' cannot be null.");
        else if (filingTypes !== undefined)
            filingTypes && filingTypes.forEach(item => { url_ += "FilingTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fileStage === null)
            throw new Error("The parameter 'fileStage' cannot be null.");
        else if (fileStage !== undefined)
            url_ += "FileStage=" + encodeURIComponent("" + fileStage) + "&";
        if (fileStages === null)
            throw new Error("The parameter 'fileStages' cannot be null.");
        else if (fileStages !== undefined)
            fileStages && fileStages.forEach(item => { url_ += "FileStages=" + encodeURIComponent("" + item) + "&"; });
        if (emailAddresses === null)
            throw new Error("The parameter 'emailAddresses' cannot be null.");
        else if (emailAddresses !== undefined)
            emailAddresses && emailAddresses.forEach(item => { url_ += "EmailAddresses=" + encodeURIComponent("" + item) + "&"; });
        if (isAuth0UserCreatedForLegacyFile === null)
            throw new Error("The parameter 'isAuth0UserCreatedForLegacyFile' cannot be null.");
        else if (isAuth0UserCreatedForLegacyFile !== undefined)
            url_ += "IsAuth0UserCreatedForLegacyFile=" + encodeURIComponent("" + isAuth0UserCreatedForLegacyFile) + "&";
        if (mainPhoneDoNotSMS === null)
            throw new Error("The parameter 'mainPhoneDoNotSMS' cannot be null.");
        else if (mainPhoneDoNotSMS !== undefined)
            url_ += "MainPhoneDoNotSMS=" + encodeURIComponent("" + mainPhoneDoNotSMS) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationFileGET(_response);
        });
    }

    protected processApplicationFileGET(response: Response): Promise<PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    applicationFileGET2(id: string): Promise<ApplicationFileDto> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationFileGET2(_response);
        });
    }

    protected processApplicationFileGET2(response: Response): Promise<ApplicationFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationFileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationFileDto>(null as any);
    }

    /**
     * @return OK
     */
    applicationFileDELETE(id: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationFileDELETE(_response);
        });
    }

    protected processApplicationFileDELETE(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    checklistProgress(id: string): Promise<ChecklistProgressDto[]> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/checklist-progress";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChecklistProgress(_response);
        });
    }

    protected processChecklistProgress(response: Response): Promise<ChecklistProgressDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistProgressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistProgressDto[]>(null as any);
    }

    /**
     * @param checklistType (optional) 
     * @return OK
     */
    checklistGET(id: string, checklistType: ChecklistTypeEnum | undefined): Promise<ChecklistDto> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/checklist?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (checklistType === null)
            throw new Error("The parameter 'checklistType' cannot be null.");
        else if (checklistType !== undefined)
            url_ += "checklistType=" + encodeURIComponent("" + checklistType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChecklistGET(_response);
        });
    }

    protected processChecklistGET(response: Response): Promise<ChecklistDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChecklistDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChecklistDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checklistPUT(id: string, body: ChecklistUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/checklist";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChecklistPUT(_response);
        });
    }

    protected processChecklistPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    processStatus(id: string): Promise<AdminInfoFileProcessStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/process-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessStatus(_response);
        });
    }

    protected processProcessStatus(response: Response): Promise<AdminInfoFileProcessStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminInfoFileProcessStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminInfoFileProcessStatusDto>(null as any);
    }

    /**
     * @param estateNumber (optional) 
     * @param sIN (optional) 
     * @param debtorName (optional) 
     * @param dateOfInsolvency (optional) 
     * @return OK
     */
    search(estateNumber: string | null | undefined, sIN: string | null | undefined, debtorName: string | null | undefined, dateOfInsolvency: moment.Moment | undefined): Promise<SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/application-file/search?";
        if (estateNumber !== undefined && estateNumber !== null)
            url_ += "EstateNumber=" + encodeURIComponent("" + estateNumber) + "&";
        if (sIN !== undefined && sIN !== null)
            url_ += "SIN=" + encodeURIComponent("" + sIN) + "&";
        if (debtorName !== undefined && debtorName !== null)
            url_ += "DebtorName=" + encodeURIComponent("" + debtorName) + "&";
        if (dateOfInsolvency === null)
            throw new Error("The parameter 'dateOfInsolvency' cannot be null.");
        else if (dateOfInsolvency !== undefined)
            url_ += "DateOfInsolvency=" + encodeURIComponent(dateOfInsolvency ? "" + dateOfInsolvency.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param isLocked (optional) 
     * @param isManualLocking (optional) 
     * @return OK
     */
    lockAppform(id: string, isLocked: boolean | undefined, isManualLocking: boolean | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/lock-appform?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isLocked === null)
            throw new Error("The parameter 'isLocked' cannot be null.");
        else if (isLocked !== undefined)
            url_ += "isLocked=" + encodeURIComponent("" + isLocked) + "&";
        if (isManualLocking === null)
            throw new Error("The parameter 'isManualLocking' cannot be null.");
        else if (isManualLocking !== undefined)
            url_ += "isManualLocking=" + encodeURIComponent("" + isManualLocking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLockAppform(_response);
        });
    }

    protected processLockAppform(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    isDuplicateFilename(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/is-duplicate-filename";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsDuplicateFilename(_response);
        });
    }

    protected processIsDuplicateFilename(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param newFileName (optional) 
     * @return OK
     */
    rename(id: string, newFileName: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/rename?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newFileName !== undefined && newFileName !== null)
            url_ += "newFileName=" + encodeURIComponent("" + newFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param newEstateNumber (optional) 
     * @return OK
     */
    estateNumber(id: string, newEstateNumber: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/estate-number?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newEstateNumber !== undefined && newEstateNumber !== null)
            url_ += "newEstateNumber=" + encodeURIComponent("" + newEstateNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEstateNumber(_response);
        });
    }

    protected processEstateNumber(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param newSIN (optional) 
     * @return OK
     */
    sin(id: string, newSIN: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/sin?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newSIN !== undefined && newSIN !== null)
            url_ += "newSIN=" + encodeURIComponent("" + newSIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSin(_response);
        });
    }

    protected processSin(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param newSpouseSIN (optional) 
     * @return OK
     */
    spouseSin(id: string, newSpouseSIN: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/spouse-sin?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newSpouseSIN !== undefined && newSpouseSIN !== null)
            url_ += "newSpouseSIN=" + encodeURIComponent("" + newSpouseSIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSpouseSin(_response);
        });
    }

    protected processSpouseSin(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    canDelete(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/application-file/{id}/can-delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCanDelete(_response);
        });
    }

    protected processCanDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    applicationFileGET3(): Promise<ApplicationFileDto> {
        let url_ = this.baseUrl + "/api/client-service-public/application-file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplicationFileGET3(_response);
        });
    }

    protected processApplicationFileGET3(response: Response): Promise<ApplicationFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationFileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationFileDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getReadOnlyFieldsDetails(fileId: string | undefined): Promise<ReadOnlyFieldsDto> {
        let url_ = this.baseUrl + "/api/client-service/ApplicationOverview/GetReadOnlyFieldsDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReadOnlyFieldsDetails(_response);
        });
    }

    protected processGetReadOnlyFieldsDetails(response: Response): Promise<ReadOnlyFieldsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReadOnlyFieldsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReadOnlyFieldsDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getQuickActionsConfig(fileId: string | undefined): Promise<QuickActionsConfigDto> {
        let url_ = this.baseUrl + "/api/client-service/ApplicationOverview/GetQuickActionsConfig?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuickActionsConfig(_response);
        });
    }

    protected processGetQuickActionsConfig(response: Response): Promise<QuickActionsConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuickActionsConfigDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickActionsConfigDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getInitialAppointmentTimes(fileId: string | undefined): Promise<InitialAppointmentsDto> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetInitialAppointmentTimes?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInitialAppointmentTimes(_response);
        });
    }

    protected processGetInitialAppointmentTimes(response: Response): Promise<InitialAppointmentsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitialAppointmentsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitialAppointmentsDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param date (optional) 
     * @param officeLocationId (optional) 
     * @param timeRange (optional) 
     * @return OK
     */
    getAvailableTimeSlotsAll(fileId: string | undefined, date: moment.Moment | undefined, officeLocationId: string | undefined, timeRange: AppointmentTimeRangeEnum | undefined): Promise<AppointmentTimeSlotDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetAvailableTimeSlots?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "officeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (timeRange === null)
            throw new Error("The parameter 'timeRange' cannot be null.");
        else if (timeRange !== undefined)
            url_ += "timeRange=" + encodeURIComponent("" + timeRange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableTimeSlotsAll(_response);
        });
    }

    protected processGetAvailableTimeSlotsAll(response: Response): Promise<AppointmentTimeSlotDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentTimeSlotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentTimeSlotDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param date (optional) 
     * @param officeLocationId (optional) 
     * @param timeRange (optional) 
     * @param meetingTypeId (optional) 
     * @param appointmentTypeId (optional) 
     * @param teamNames (optional) 
     * @param duration (optional) 
     * @return OK
     */
    getAvailableTimeSlotsByTeam(fileId: string | undefined, date: moment.Moment | undefined, officeLocationId: string | undefined, timeRange: AppointmentTimeRangeEnum | undefined, meetingTypeId: string | undefined, appointmentTypeId: string | undefined, teamNames: (string | undefined)[] | undefined, duration: number | undefined): Promise<AppointmentTimeSlotDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetAvailableTimeSlotsByTeam?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "officeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (timeRange === null)
            throw new Error("The parameter 'timeRange' cannot be null.");
        else if (timeRange !== undefined)
            url_ += "timeRange=" + encodeURIComponent("" + timeRange) + "&";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "meetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        if (appointmentTypeId === null)
            throw new Error("The parameter 'appointmentTypeId' cannot be null.");
        else if (appointmentTypeId !== undefined)
            url_ += "appointmentTypeId=" + encodeURIComponent("" + appointmentTypeId) + "&";
        if (teamNames === null)
            throw new Error("The parameter 'teamNames' cannot be null.");
        else if (teamNames !== undefined)
            teamNames && teamNames.forEach(item => { url_ += "teamNames=" + encodeURIComponent("" + item) + "&"; });
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableTimeSlotsByTeam(_response);
        });
    }

    protected processGetAvailableTimeSlotsByTeam(response: Response): Promise<AppointmentTimeSlotDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentTimeSlotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentTimeSlotDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param appointmentTypeId (optional) 
     * @return OK
     */
    getDefaultAppointmentLength(fileId: string | undefined, appointmentTypeId: string | undefined): Promise<AppointmentDefaultDurationDto> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetDefaultAppointmentLength?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (appointmentTypeId === null)
            throw new Error("The parameter 'appointmentTypeId' cannot be null.");
        else if (appointmentTypeId !== undefined)
            url_ += "appointmentTypeId=" + encodeURIComponent("" + appointmentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultAppointmentLength(_response);
        });
    }

    protected processGetDefaultAppointmentLength(response: Response): Promise<AppointmentDefaultDurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDefaultDurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentDefaultDurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bookAppointment(body: BookAppointmentInput | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/BookAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBookAppointment(_response);
        });
    }

    protected processBookAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @return OK
     */
    listPendingAppointmentDetailsByAgentId(agentId: string | undefined): Promise<ViewAppointmentsResultDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/ListPendingAppointmentDetailsByAgentId?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPendingAppointmentDetailsByAgentId(_response);
        });
    }

    protected processListPendingAppointmentDetailsByAgentId(response: Response): Promise<ViewAppointmentsResultDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewAppointmentsResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewAppointmentsResultDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param isAllAppointments (optional) 
     * @return OK
     */
    listAppointmentDetails(fileId: string | undefined, isAllAppointments: boolean | undefined): Promise<ViewAppointmentsResultDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/ListAppointmentDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (isAllAppointments === null)
            throw new Error("The parameter 'isAllAppointments' cannot be null.");
        else if (isAllAppointments !== undefined)
            url_ += "isAllAppointments=" + encodeURIComponent("" + isAllAppointments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentDetails(_response);
        });
    }

    protected processListAppointmentDetails(response: Response): Promise<ViewAppointmentsResultDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewAppointmentsResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewAppointmentsResultDto[]>(null as any);
    }

    /**
     * @param appointmentId (optional) 
     * @return OK
     */
    getAppointmentDetails(appointmentId: string | undefined): Promise<InitialAppointmentsDto> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetAppointmentDetails?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppointmentDetails(_response);
        });
    }

    protected processGetAppointmentDetails(response: Response): Promise<InitialAppointmentsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitialAppointmentsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitialAppointmentsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editAppointment(body: EditAppointmentInput | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/EditAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditAppointment(_response);
        });
    }

    protected processEditAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param isPreferedLanguageEnglish (optional) 
     * @param meetingTypeEnum (optional) 
     * @return OK
     */
    getInitialAppointmentTimeSlots(officeLocationId: string | undefined, isPreferedLanguageEnglish: boolean | undefined, meetingTypeEnum: MeetingTypeEnum | undefined): Promise<AvailableTimeSlotsDto> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/GetInitialAppointmentTimeSlots?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "officeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (isPreferedLanguageEnglish === null)
            throw new Error("The parameter 'isPreferedLanguageEnglish' cannot be null.");
        else if (isPreferedLanguageEnglish !== undefined)
            url_ += "isPreferedLanguageEnglish=" + encodeURIComponent("" + isPreferedLanguageEnglish) + "&";
        if (meetingTypeEnum === null)
            throw new Error("The parameter 'meetingTypeEnum' cannot be null.");
        else if (meetingTypeEnum !== undefined)
            url_ += "meetingTypeEnum=" + encodeURIComponent("" + meetingTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInitialAppointmentTimeSlots(_response);
        });
    }

    protected processGetInitialAppointmentTimeSlots(response: Response): Promise<AvailableTimeSlotsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableTimeSlotsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableTimeSlotsDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @param officeLocationId (optional) 
     * @param isPreferedLanguageEnglish (optional) 
     * @param meetingTypeEnum (optional) 
     * @return OK
     */
    getAvailableTimeSlots(date: moment.Moment | undefined, officeLocationId: string | undefined, isPreferedLanguageEnglish: boolean | undefined, meetingTypeEnum: MeetingTypeEnum | undefined): Promise<AvailableTimeSlotsDto> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/GetAvailableTimeSlots?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "officeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (isPreferedLanguageEnglish === null)
            throw new Error("The parameter 'isPreferedLanguageEnglish' cannot be null.");
        else if (isPreferedLanguageEnglish !== undefined)
            url_ += "isPreferedLanguageEnglish=" + encodeURIComponent("" + isPreferedLanguageEnglish) + "&";
        if (meetingTypeEnum === null)
            throw new Error("The parameter 'meetingTypeEnum' cannot be null.");
        else if (meetingTypeEnum !== undefined)
            url_ += "meetingTypeEnum=" + encodeURIComponent("" + meetingTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableTimeSlots(_response);
        });
    }

    protected processGetAvailableTimeSlots(response: Response): Promise<AvailableTimeSlotsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableTimeSlotsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableTimeSlotsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAppointment(body: UpdateAppointmentPublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/UpdateAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppointment(_response);
        });
    }

    protected processUpdateAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appointmentId (optional) 
     * @return OK
     */
    cancelAppointment(appointmentId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/CancelAppointment?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelAppointment(_response);
        });
    }

    protected processCancelAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appointmentId (optional) 
     * @return OK
     */
    getAppointmentInfo(appointmentId: string | undefined): Promise<AppointmentInfoDto> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/GetAppointmentInfo?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppointmentInfo(_response);
        });
    }

    protected processGetAppointmentInfo(response: Response): Promise<AppointmentInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentInfoDto>(null as any);
    }

    /**
     * @param isAllAppointments (optional) 
     * @param appointmentStatusEnums (optional) 
     * @param appointmentTypeEnums (optional) 
     * @param startDateTimeBefore (optional) 
     * @param startDateTimeAfter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAppointmentInfoList(isAllAppointments: boolean | undefined, appointmentStatusEnums: AppointmentStatusEnum[] | undefined, appointmentTypeEnums: AppointmentTypeEnum[] | undefined, startDateTimeBefore: moment.Moment | undefined, startDateTimeAfter: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/GetAppointmentInfoList?";
        if (isAllAppointments === null)
            throw new Error("The parameter 'isAllAppointments' cannot be null.");
        else if (isAllAppointments !== undefined)
            url_ += "IsAllAppointments=" + encodeURIComponent("" + isAllAppointments) + "&";
        if (appointmentStatusEnums === null)
            throw new Error("The parameter 'appointmentStatusEnums' cannot be null.");
        else if (appointmentStatusEnums !== undefined)
            appointmentStatusEnums && appointmentStatusEnums.forEach(item => { url_ += "AppointmentStatusEnums=" + encodeURIComponent("" + item) + "&"; });
        if (appointmentTypeEnums === null)
            throw new Error("The parameter 'appointmentTypeEnums' cannot be null.");
        else if (appointmentTypeEnums !== undefined)
            appointmentTypeEnums && appointmentTypeEnums.forEach(item => { url_ += "AppointmentTypeEnums=" + encodeURIComponent("" + item) + "&"; });
        if (startDateTimeBefore === null)
            throw new Error("The parameter 'startDateTimeBefore' cannot be null.");
        else if (startDateTimeBefore !== undefined)
            url_ += "StartDateTimeBefore=" + encodeURIComponent(startDateTimeBefore ? "" + startDateTimeBefore.toISOString() : "") + "&";
        if (startDateTimeAfter === null)
            throw new Error("The parameter 'startDateTimeAfter' cannot be null.");
        else if (startDateTimeAfter !== undefined)
            url_ += "StartDateTimeAfter=" + encodeURIComponent(startDateTimeAfter ? "" + startDateTimeAfter.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppointmentInfoList(_response);
        });
    }

    protected processGetAppointmentInfoList(response: Response): Promise<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reserveAppointment(body: ReserveAppointmentDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/ReserveAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReserveAppointment(_response);
        });
    }

    protected processReserveAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAppointmentAndFile(body: BookInitialAppointmenInputPublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/CreateAppointmentAndFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAppointmentAndFile(_response);
        });
    }

    protected processCreateAppointmentAndFile(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bookAppointment2(body: BookAppointmentInputPublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/BookAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBookAppointment2(_response);
        });
    }

    protected processBookAppointment2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param dateTime (optional) 
     * @param officeLocationId (optional) 
     * @return OK
     */
    unreserveAppointment(agentId: string | undefined, dateTime: moment.Moment | undefined, officeLocationId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/Appointment/UnreserveAppointment?";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "DateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnreserveAppointment(_response);
        });
    }

    protected processUnreserveAppointment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getSMSTemplates(): Promise<AppSMSTemplateDto[]> {
        let url_ = this.baseUrl + "/api/client-service/AppSMSTemplate/GetSMSTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSMSTemplates(_response);
        });
    }

    protected processGetSMSTemplates(response: Response): Promise<AppSMSTemplateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppSMSTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSMSTemplateDto[]>(null as any);
    }

    /**
     * @param smsTemplateId (optional) 
     * @return OK
     */
    getSMSTemplate(smsTemplateId: string | undefined): Promise<AppSMSTemplateDto> {
        let url_ = this.baseUrl + "/api/client-service/AppSMSTemplate/GetSMSTemplate?";
        if (smsTemplateId === null)
            throw new Error("The parameter 'smsTemplateId' cannot be null.");
        else if (smsTemplateId !== undefined)
            url_ += "smsTemplateId=" + encodeURIComponent("" + smsTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSMSTemplate(_response);
        });
    }

    protected processGetSMSTemplate(response: Response): Promise<AppSMSTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSMSTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSMSTemplateDto>(null as any);
    }

    /**
     * @param appTaskId (optional) 
     * @param appTaskIds (optional) 
     * @param filterText (optional) 
     * @param description (optional) 
     * @param openDateMin (optional) 
     * @param openDateMax (optional) 
     * @param closeDateMin (optional) 
     * @param closeDateMax (optional) 
     * @param assignedAgentIds (optional) 
     * @param assignedTeamIds (optional) 
     * @param appTaskNames (optional) 
     * @param appTaskStatuses (optional) 
     * @param fileId (optional) 
     * @param fileStages (optional) 
     * @param fileProcesses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    tasksGET(appTaskId: string | undefined, appTaskIds: string[] | undefined, filterText: string | null | undefined, description: string | null | undefined, openDateMin: moment.Moment | undefined, openDateMax: moment.Moment | undefined, closeDateMin: moment.Moment | undefined, closeDateMax: moment.Moment | undefined, assignedAgentIds: string[] | undefined, assignedTeamIds: string[] | undefined, appTaskNames: AppTaskNameEnum[] | undefined, appTaskStatuses: AppTaskStatusEnum[] | undefined, fileId: string | undefined, fileStages: FileStageEnum[] | undefined, fileProcesses: FileProcessEnum[] | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/tasks?";
        if (appTaskId === null)
            throw new Error("The parameter 'appTaskId' cannot be null.");
        else if (appTaskId !== undefined)
            url_ += "AppTaskId=" + encodeURIComponent("" + appTaskId) + "&";
        if (appTaskIds === null)
            throw new Error("The parameter 'appTaskIds' cannot be null.");
        else if (appTaskIds !== undefined)
            appTaskIds && appTaskIds.forEach(item => { url_ += "AppTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (openDateMin === null)
            throw new Error("The parameter 'openDateMin' cannot be null.");
        else if (openDateMin !== undefined)
            url_ += "OpenDateMin=" + encodeURIComponent(openDateMin ? "" + openDateMin.toISOString() : "") + "&";
        if (openDateMax === null)
            throw new Error("The parameter 'openDateMax' cannot be null.");
        else if (openDateMax !== undefined)
            url_ += "OpenDateMax=" + encodeURIComponent(openDateMax ? "" + openDateMax.toISOString() : "") + "&";
        if (closeDateMin === null)
            throw new Error("The parameter 'closeDateMin' cannot be null.");
        else if (closeDateMin !== undefined)
            url_ += "CloseDateMin=" + encodeURIComponent(closeDateMin ? "" + closeDateMin.toISOString() : "") + "&";
        if (closeDateMax === null)
            throw new Error("The parameter 'closeDateMax' cannot be null.");
        else if (closeDateMax !== undefined)
            url_ += "CloseDateMax=" + encodeURIComponent(closeDateMax ? "" + closeDateMax.toISOString() : "") + "&";
        if (assignedAgentIds === null)
            throw new Error("The parameter 'assignedAgentIds' cannot be null.");
        else if (assignedAgentIds !== undefined)
            assignedAgentIds && assignedAgentIds.forEach(item => { url_ += "AssignedAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignedTeamIds === null)
            throw new Error("The parameter 'assignedTeamIds' cannot be null.");
        else if (assignedTeamIds !== undefined)
            assignedTeamIds && assignedTeamIds.forEach(item => { url_ += "AssignedTeamIds=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskNames === null)
            throw new Error("The parameter 'appTaskNames' cannot be null.");
        else if (appTaskNames !== undefined)
            appTaskNames && appTaskNames.forEach(item => { url_ += "AppTaskNames=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskStatuses === null)
            throw new Error("The parameter 'appTaskStatuses' cannot be null.");
        else if (appTaskStatuses !== undefined)
            appTaskStatuses && appTaskStatuses.forEach(item => { url_ += "AppTaskStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (fileStages === null)
            throw new Error("The parameter 'fileStages' cannot be null.");
        else if (fileStages !== undefined)
            fileStages && fileStages.forEach(item => { url_ += "FileStages=" + encodeURIComponent("" + item) + "&"; });
        if (fileProcesses === null)
            throw new Error("The parameter 'fileProcesses' cannot be null.");
        else if (fileProcesses !== undefined)
            fileProcesses && fileProcesses.forEach(item => { url_ += "FileProcesses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksGET(_response);
        });
    }

    protected processTasksGET(response: Response): Promise<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tasksPOST(body: AppTaskCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksPOST(_response);
        });
    }

    protected processTasksPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    tasksGET2(id: string): Promise<AppTaskDto> {
        let url_ = this.baseUrl + "/api/client-service/tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksGET2(_response);
        });
    }

    protected processTasksGET2(response: Response): Promise<AppTaskDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tasksPUT(id: string, body: AppTaskUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksPUT(_response);
        });
    }

    protected processTasksPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    tasksDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksDELETE(_response);
        });
    }

    protected processTasksDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAll(body: AppTaskUpdateManyDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/tasks/update-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAll(_response);
        });
    }

    protected processUpdateAll(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param filterSubjectText (optional) 
     * @param filterEmailSenderEmailAddressText (optional) 
     * @param fileId (optional) 
     * @param description (optional) 
     * @param followUpDateMin (optional) 
     * @param followUpDateMax (optional) 
     * @param openDateMin (optional) 
     * @param openDateMax (optional) 
     * @param closeDateMin (optional) 
     * @param closeDateMax (optional) 
     * @param assignedAgentId (optional) 
     * @param assignedTeamId (optional) 
     * @param appTaskId (optional) 
     * @param appTaskActionIds (optional) 
     * @param appTaskActionId (optional) 
     * @param appTaskActionNameId (optional) 
     * @param appTaskActionStatusId (optional) 
     * @param appTaskActionStatus (optional) 
     * @param teamTypes (optional) 
     * @param appTaskActionNames (optional) 
     * @param calledFromDashboard (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    taskActionsGET(filterText: string | null | undefined, filterSubjectText: string | null | undefined, filterEmailSenderEmailAddressText: string | null | undefined, fileId: string | undefined, description: string | null | undefined, followUpDateMin: moment.Moment | undefined, followUpDateMax: moment.Moment | undefined, openDateMin: moment.Moment | undefined, openDateMax: moment.Moment | undefined, closeDateMin: moment.Moment | undefined, closeDateMax: moment.Moment | undefined, assignedAgentId: string | undefined, assignedTeamId: string | undefined, appTaskId: string | undefined, appTaskActionIds: string[] | undefined, appTaskActionId: string | undefined, appTaskActionNameId: string | undefined, appTaskActionStatusId: string | undefined, appTaskActionStatus: AppTaskActionStatusEnum | undefined, teamTypes: TeamTypeEnum[] | undefined, appTaskActionNames: AppTaskActionNameEnum[] | undefined, calledFromDashboard: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/task-actions?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (filterSubjectText !== undefined && filterSubjectText !== null)
            url_ += "FilterSubjectText=" + encodeURIComponent("" + filterSubjectText) + "&";
        if (filterEmailSenderEmailAddressText !== undefined && filterEmailSenderEmailAddressText !== null)
            url_ += "FilterEmailSenderEmailAddressText=" + encodeURIComponent("" + filterEmailSenderEmailAddressText) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (followUpDateMin === null)
            throw new Error("The parameter 'followUpDateMin' cannot be null.");
        else if (followUpDateMin !== undefined)
            url_ += "FollowUpDateMin=" + encodeURIComponent(followUpDateMin ? "" + followUpDateMin.toISOString() : "") + "&";
        if (followUpDateMax === null)
            throw new Error("The parameter 'followUpDateMax' cannot be null.");
        else if (followUpDateMax !== undefined)
            url_ += "FollowUpDateMax=" + encodeURIComponent(followUpDateMax ? "" + followUpDateMax.toISOString() : "") + "&";
        if (openDateMin === null)
            throw new Error("The parameter 'openDateMin' cannot be null.");
        else if (openDateMin !== undefined)
            url_ += "OpenDateMin=" + encodeURIComponent(openDateMin ? "" + openDateMin.toISOString() : "") + "&";
        if (openDateMax === null)
            throw new Error("The parameter 'openDateMax' cannot be null.");
        else if (openDateMax !== undefined)
            url_ += "OpenDateMax=" + encodeURIComponent(openDateMax ? "" + openDateMax.toISOString() : "") + "&";
        if (closeDateMin === null)
            throw new Error("The parameter 'closeDateMin' cannot be null.");
        else if (closeDateMin !== undefined)
            url_ += "CloseDateMin=" + encodeURIComponent(closeDateMin ? "" + closeDateMin.toISOString() : "") + "&";
        if (closeDateMax === null)
            throw new Error("The parameter 'closeDateMax' cannot be null.");
        else if (closeDateMax !== undefined)
            url_ += "CloseDateMax=" + encodeURIComponent(closeDateMax ? "" + closeDateMax.toISOString() : "") + "&";
        if (assignedAgentId === null)
            throw new Error("The parameter 'assignedAgentId' cannot be null.");
        else if (assignedAgentId !== undefined)
            url_ += "AssignedAgentId=" + encodeURIComponent("" + assignedAgentId) + "&";
        if (assignedTeamId === null)
            throw new Error("The parameter 'assignedTeamId' cannot be null.");
        else if (assignedTeamId !== undefined)
            url_ += "AssignedTeamId=" + encodeURIComponent("" + assignedTeamId) + "&";
        if (appTaskId === null)
            throw new Error("The parameter 'appTaskId' cannot be null.");
        else if (appTaskId !== undefined)
            url_ += "AppTaskId=" + encodeURIComponent("" + appTaskId) + "&";
        if (appTaskActionIds === null)
            throw new Error("The parameter 'appTaskActionIds' cannot be null.");
        else if (appTaskActionIds !== undefined)
            appTaskActionIds && appTaskActionIds.forEach(item => { url_ += "AppTaskActionIds=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskActionId === null)
            throw new Error("The parameter 'appTaskActionId' cannot be null.");
        else if (appTaskActionId !== undefined)
            url_ += "AppTaskActionId=" + encodeURIComponent("" + appTaskActionId) + "&";
        if (appTaskActionNameId === null)
            throw new Error("The parameter 'appTaskActionNameId' cannot be null.");
        else if (appTaskActionNameId !== undefined)
            url_ += "AppTaskActionNameId=" + encodeURIComponent("" + appTaskActionNameId) + "&";
        if (appTaskActionStatusId === null)
            throw new Error("The parameter 'appTaskActionStatusId' cannot be null.");
        else if (appTaskActionStatusId !== undefined)
            url_ += "AppTaskActionStatusId=" + encodeURIComponent("" + appTaskActionStatusId) + "&";
        if (appTaskActionStatus === null)
            throw new Error("The parameter 'appTaskActionStatus' cannot be null.");
        else if (appTaskActionStatus !== undefined)
            url_ += "AppTaskActionStatus=" + encodeURIComponent("" + appTaskActionStatus) + "&";
        if (teamTypes === null)
            throw new Error("The parameter 'teamTypes' cannot be null.");
        else if (teamTypes !== undefined)
            teamTypes && teamTypes.forEach(item => { url_ += "TeamTypes=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskActionNames === null)
            throw new Error("The parameter 'appTaskActionNames' cannot be null.");
        else if (appTaskActionNames !== undefined)
            appTaskActionNames && appTaskActionNames.forEach(item => { url_ += "AppTaskActionNames=" + encodeURIComponent("" + item) + "&"; });
        if (calledFromDashboard === null)
            throw new Error("The parameter 'calledFromDashboard' cannot be null.");
        else if (calledFromDashboard !== undefined)
            url_ += "CalledFromDashboard=" + encodeURIComponent("" + calledFromDashboard) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskActionsGET(_response);
        });
    }

    protected processTaskActionsGET(response: Response): Promise<PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taskActionsPOST(body: AppTaskActionCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskActionsPOST(_response);
        });
    }

    protected processTaskActionsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    taskActionsGET2(id: string): Promise<AppTaskActionDto> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskActionsGET2(_response);
        });
    }

    protected processTaskActionsGET2(response: Response): Promise<AppTaskActionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskActionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskActionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taskActionsPUT(id: string, body: AppTaskActionUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskActionsPUT(_response);
        });
    }

    protected processTaskActionsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    taskActionsDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskActionsDELETE(_response);
        });
    }

    protected processTaskActionsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAll2(body: AppTaskActionUpdateManyDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/update-all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAll2(_response);
        });
    }

    protected processUpdateAll2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateClaim(body: AppTaskActionClaimUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/update-claim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClaim(_response);
        });
    }

    protected processUpdateClaim(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateIncomeExpense(body: AppTaskActionIncomeExpenseUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/update-income-expense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIncomeExpense(_response);
        });
    }

    protected processUpdateIncomeExpense(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTaxReturn(body: AppTaskActionTaxReturnUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/update-tax-return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaxReturn(_response);
        });
    }

    protected processUpdateTaxReturn(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    appTaskActionNavigation(id: string): Promise<AppTaskActionNavigationDto> {
        let url_ = this.baseUrl + "/api/client-service/task-actions/{id}/app-task-action-navigation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAppTaskActionNavigation(_response);
        });
    }

    protected processAppTaskActionNavigation(response: Response): Promise<AppTaskActionNavigationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppTaskActionNavigationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppTaskActionNavigationDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param filterSubjectText (optional) 
     * @param filterEmailSenderEmailAddressText (optional) 
     * @param fileId (optional) 
     * @param description (optional) 
     * @param followUpDateMin (optional) 
     * @param followUpDateMax (optional) 
     * @param openDateMin (optional) 
     * @param openDateMax (optional) 
     * @param closeDateMin (optional) 
     * @param closeDateMax (optional) 
     * @param assignedAgentId (optional) 
     * @param assignedTeamId (optional) 
     * @param appTaskId (optional) 
     * @param appTaskActionIds (optional) 
     * @param appTaskActionId (optional) 
     * @param appTaskActionNameId (optional) 
     * @param appTaskActionStatusId (optional) 
     * @param appTaskActionStatus (optional) 
     * @param teamTypes (optional) 
     * @param appTaskActionNames (optional) 
     * @param calledFromDashboard (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    count2(filterText: string | null | undefined, filterSubjectText: string | null | undefined, filterEmailSenderEmailAddressText: string | null | undefined, fileId: string | undefined, description: string | null | undefined, followUpDateMin: moment.Moment | undefined, followUpDateMax: moment.Moment | undefined, openDateMin: moment.Moment | undefined, openDateMax: moment.Moment | undefined, closeDateMin: moment.Moment | undefined, closeDateMax: moment.Moment | undefined, assignedAgentId: string | undefined, assignedTeamId: string | undefined, appTaskId: string | undefined, appTaskActionIds: string[] | undefined, appTaskActionId: string | undefined, appTaskActionNameId: string | undefined, appTaskActionStatusId: string | undefined, appTaskActionStatus: AppTaskActionStatusEnum | undefined, teamTypes: TeamTypeEnum[] | undefined, appTaskActionNames: AppTaskActionNameEnum[] | undefined, calledFromDashboard: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service-public/task-actions/count?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (filterSubjectText !== undefined && filterSubjectText !== null)
            url_ += "FilterSubjectText=" + encodeURIComponent("" + filterSubjectText) + "&";
        if (filterEmailSenderEmailAddressText !== undefined && filterEmailSenderEmailAddressText !== null)
            url_ += "FilterEmailSenderEmailAddressText=" + encodeURIComponent("" + filterEmailSenderEmailAddressText) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (followUpDateMin === null)
            throw new Error("The parameter 'followUpDateMin' cannot be null.");
        else if (followUpDateMin !== undefined)
            url_ += "FollowUpDateMin=" + encodeURIComponent(followUpDateMin ? "" + followUpDateMin.toISOString() : "") + "&";
        if (followUpDateMax === null)
            throw new Error("The parameter 'followUpDateMax' cannot be null.");
        else if (followUpDateMax !== undefined)
            url_ += "FollowUpDateMax=" + encodeURIComponent(followUpDateMax ? "" + followUpDateMax.toISOString() : "") + "&";
        if (openDateMin === null)
            throw new Error("The parameter 'openDateMin' cannot be null.");
        else if (openDateMin !== undefined)
            url_ += "OpenDateMin=" + encodeURIComponent(openDateMin ? "" + openDateMin.toISOString() : "") + "&";
        if (openDateMax === null)
            throw new Error("The parameter 'openDateMax' cannot be null.");
        else if (openDateMax !== undefined)
            url_ += "OpenDateMax=" + encodeURIComponent(openDateMax ? "" + openDateMax.toISOString() : "") + "&";
        if (closeDateMin === null)
            throw new Error("The parameter 'closeDateMin' cannot be null.");
        else if (closeDateMin !== undefined)
            url_ += "CloseDateMin=" + encodeURIComponent(closeDateMin ? "" + closeDateMin.toISOString() : "") + "&";
        if (closeDateMax === null)
            throw new Error("The parameter 'closeDateMax' cannot be null.");
        else if (closeDateMax !== undefined)
            url_ += "CloseDateMax=" + encodeURIComponent(closeDateMax ? "" + closeDateMax.toISOString() : "") + "&";
        if (assignedAgentId === null)
            throw new Error("The parameter 'assignedAgentId' cannot be null.");
        else if (assignedAgentId !== undefined)
            url_ += "AssignedAgentId=" + encodeURIComponent("" + assignedAgentId) + "&";
        if (assignedTeamId === null)
            throw new Error("The parameter 'assignedTeamId' cannot be null.");
        else if (assignedTeamId !== undefined)
            url_ += "AssignedTeamId=" + encodeURIComponent("" + assignedTeamId) + "&";
        if (appTaskId === null)
            throw new Error("The parameter 'appTaskId' cannot be null.");
        else if (appTaskId !== undefined)
            url_ += "AppTaskId=" + encodeURIComponent("" + appTaskId) + "&";
        if (appTaskActionIds === null)
            throw new Error("The parameter 'appTaskActionIds' cannot be null.");
        else if (appTaskActionIds !== undefined)
            appTaskActionIds && appTaskActionIds.forEach(item => { url_ += "AppTaskActionIds=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskActionId === null)
            throw new Error("The parameter 'appTaskActionId' cannot be null.");
        else if (appTaskActionId !== undefined)
            url_ += "AppTaskActionId=" + encodeURIComponent("" + appTaskActionId) + "&";
        if (appTaskActionNameId === null)
            throw new Error("The parameter 'appTaskActionNameId' cannot be null.");
        else if (appTaskActionNameId !== undefined)
            url_ += "AppTaskActionNameId=" + encodeURIComponent("" + appTaskActionNameId) + "&";
        if (appTaskActionStatusId === null)
            throw new Error("The parameter 'appTaskActionStatusId' cannot be null.");
        else if (appTaskActionStatusId !== undefined)
            url_ += "AppTaskActionStatusId=" + encodeURIComponent("" + appTaskActionStatusId) + "&";
        if (appTaskActionStatus === null)
            throw new Error("The parameter 'appTaskActionStatus' cannot be null.");
        else if (appTaskActionStatus !== undefined)
            url_ += "AppTaskActionStatus=" + encodeURIComponent("" + appTaskActionStatus) + "&";
        if (teamTypes === null)
            throw new Error("The parameter 'teamTypes' cannot be null.");
        else if (teamTypes !== undefined)
            teamTypes && teamTypes.forEach(item => { url_ += "TeamTypes=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskActionNames === null)
            throw new Error("The parameter 'appTaskActionNames' cannot be null.");
        else if (appTaskActionNames !== undefined)
            appTaskActionNames && appTaskActionNames.forEach(item => { url_ += "AppTaskActionNames=" + encodeURIComponent("" + item) + "&"; });
        if (calledFromDashboard === null)
            throw new Error("The parameter 'calledFromDashboard' cannot be null.");
        else if (calledFromDashboard !== undefined)
            url_ += "CalledFromDashboard=" + encodeURIComponent("" + calledFromDashboard) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCount2(_response);
        });
    }

    protected processCount2(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    taskAndAction(body: AppTaskAndTaskActionCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/task-actions/task-and-action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTaskAndAction(_response);
        });
    }

    protected processTaskAndAction(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    followUpRequest(): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/task-actions/follow-up-request";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFollowUpRequest(_response);
        });
    }

    protected processFollowUpRequest(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appTaskNames (optional) 
     * @param appTaskStatuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    countTasks(appTaskNames: AppTaskNameEnum[] | undefined, appTaskStatuses: AppTaskStatusEnum[] | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service-public/tasks/count-tasks?";
        if (appTaskNames === null)
            throw new Error("The parameter 'appTaskNames' cannot be null.");
        else if (appTaskNames !== undefined)
            appTaskNames && appTaskNames.forEach(item => { url_ += "AppTaskNames=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskStatuses === null)
            throw new Error("The parameter 'appTaskStatuses' cannot be null.");
        else if (appTaskStatuses !== undefined)
            appTaskStatuses && appTaskStatuses.forEach(item => { url_ += "AppTaskStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountTasks(_response);
        });
    }

    protected processCountTasks(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    counsellingFollowUp(): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/tasks/counselling-follow-up";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCounsellingFollowUp(_response);
        });
    }

    protected processCounsellingFollowUp(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    runDischargeOppositionProcess(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunDischargeOppositionProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunDischargeOppositionProcess(_response);
        });
    }

    protected processRunDischargeOppositionProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runDischargeCourtCompliance(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunDischargeCourtCompliance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunDischargeCourtCompliance(_response);
        });
    }

    protected processRunDischargeCourtCompliance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runDischarge60DayProcess(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunDischarge60DayProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunDischarge60DayProcess(_response);
        });
    }

    protected processRunDischarge60DayProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runGetPaymentPadSchedule(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunGetPaymentPadSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunGetPaymentPadSchedule(_response);
        });
    }

    protected processRunGetPaymentPadSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runPadInformationUpdatedAlert(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunPadInformationUpdatedAlert";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunPadInformationUpdatedAlert(_response);
        });
    }

    protected processRunPadInformationUpdatedAlert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runPadScheduleHoldUpdater(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunPadScheduleHoldUpdater";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunPadScheduleHoldUpdater(_response);
        });
    }

    protected processRunPadScheduleHoldUpdater(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runPaymentStatusSummary(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunPaymentStatusSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunPaymentStatusSummary(_response);
        });
    }

    protected processRunPaymentStatusSummary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runUpdateProposalProcessStatus(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunUpdateProposalProcessStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunUpdateProposalProcessStatus(_response);
        });
    }

    protected processRunUpdateProposalProcessStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runProposalStatus(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunProposalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunProposalStatus(_response);
        });
    }

    protected processRunProposalStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runProposalMonthlyIssueWarningLetter(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunProposalMonthlyIssueWarningLetter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunProposalMonthlyIssueWarningLetter(_response);
        });
    }

    protected processRunProposalMonthlyIssueWarningLetter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runReceiptsDisbursements30DayNotice(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunReceiptsDisbursements30DayNotice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunReceiptsDisbursements30DayNotice(_response);
        });
    }

    protected processRunReceiptsDisbursements30DayNotice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runIncomeExpenseScheduleUpdateNotification(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunIncomeExpenseScheduleUpdateNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunIncomeExpenseScheduleUpdateNotification(_response);
        });
    }

    protected processRunIncomeExpenseScheduleUpdateNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportAscendTaxReturnPeriod(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportAscendTaxReturnPeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportAscendTaxReturnPeriod(_response);
        });
    }

    protected processRunImportAscendTaxReturnPeriod(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportAscendEstateInformation(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportAscendEstateInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportAscendEstateInformation(_response);
        });
    }

    protected processRunImportAscendEstateInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportReferralSources(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportReferralSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportReferralSources(_response);
        });
    }

    protected processRunImportReferralSources(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportIncomeExpenseSubmissionEmail(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportIncomeExpenseSubmissionEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportIncomeExpenseSubmissionEmail(_response);
        });
    }

    protected processRunImportIncomeExpenseSubmissionEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportTaxReturnEmail(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportTaxReturnEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportTaxReturnEmail(_response);
        });
    }

    protected processRunImportTaxReturnEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runImportClaimEmail(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunImportClaimEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunImportClaimEmail(_response);
        });
    }

    protected processRunImportClaimEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runAscendDeletedLinks(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunAscendDeletedLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunAscendDeletedLinks(_response);
        });
    }

    protected processRunAscendDeletedLinks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runCreateAuth0UsersForExistingDebtors(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunCreateAuth0UsersForExistingDebtors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunCreateAuth0UsersForExistingDebtors(_response);
        });
    }

    protected processRunCreateAuth0UsersForExistingDebtors(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    runInitialConsultationReminder(): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-internal/background-job/RunInitialConsultationReminder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunInitialConsultationReminder(_response);
        });
    }

    protected processRunInitialConsultationReminder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    createFourthMonthReminder(fileId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/background-worker/CreateFourthMonthReminder?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFourthMonthReminder(_response);
        });
    }

    protected processCreateFourthMonthReminder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    create30DaysReminder(fileId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/background-worker/Create30DaysReminder?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate30DaysReminder(_response);
        });
    }

    protected processCreate30DaysReminder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param externalIeScheduleId (optional) 
     * @return OK
     */
    sendDueDateReminderNotifications(externalIeScheduleId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/background-worker/SendDueDateReminderNotifications?";
        if (externalIeScheduleId !== undefined && externalIeScheduleId !== null)
            url_ += "externalIeScheduleId=" + encodeURIComponent("" + externalIeScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendDueDateReminderNotifications(_response);
        });
    }

    protected processSendDueDateReminderNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param externalIeScheduleId (optional) 
     * @return OK
     */
    sendDaysReminderNotifications(externalIeScheduleId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/background-worker/SendDaysReminderNotifications?";
        if (externalIeScheduleId !== undefined && externalIeScheduleId !== null)
            url_ += "externalIeScheduleId=" + encodeURIComponent("" + externalIeScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendDaysReminderNotifications(_response);
        });
    }

    protected processSendDaysReminderNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    createAuth0UserAndSendRegisterationEmail(fileId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/background-worker/CreateAuth0UserAndSendRegisterationEmail?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAuth0UserAndSendRegisterationEmail(_response);
        });
    }

    protected processCreateAuth0UserAndSendRegisterationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    dashboardGetAppTasksInputGET(): Promise<GetAppTasksInput> {
        let url_ = this.baseUrl + "/api/client-service/caching/dashboard-get-app-tasks-input";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardGetAppTasksInputGET(_response);
        });
    }

    protected processDashboardGetAppTasksInputGET(response: Response): Promise<GetAppTasksInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppTasksInput.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAppTasksInput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dashboardGetAppTasksInputPUT(body: GetAppTasksInput | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/caching/dashboard-get-app-tasks-input";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDashboardGetAppTasksInputPUT(_response);
        });
    }

    protected processDashboardGetAppTasksInputPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPersonalDetails(body: PersonalDetailsDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/CreatePersonalDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePersonalDetails(_response);
        });
    }

    protected processCreatePersonalDetails(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPersonalDetailsWithFollowUpTask(body: PersonalDetailsDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/CreatePersonalDetailsWithFollowUpTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePersonalDetailsWithFollowUpTask(_response);
        });
    }

    protected processCreatePersonalDetailsWithFollowUpTask(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param mainPhoneNumber (optional) 
     * @param emailAddress (optional) 
     * @param excludedClientIds (optional) 
     * @return OK
     */
    checkForDuplicates(firstName: string | null | undefined, lastName: string | null | undefined, mainPhoneNumber: string | null | undefined, emailAddress: string | null | undefined, excludedClientIds: string[] | undefined): Promise<DuplicateClientDto[]> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/CheckForDuplicates?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (mainPhoneNumber !== undefined && mainPhoneNumber !== null)
            url_ += "MainPhoneNumber=" + encodeURIComponent("" + mainPhoneNumber) + "&";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (excludedClientIds === null)
            throw new Error("The parameter 'excludedClientIds' cannot be null.");
        else if (excludedClientIds !== undefined)
            excludedClientIds && excludedClientIds.forEach(item => { url_ += "ExcludedClientIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckForDuplicates(_response);
        });
    }

    protected processCheckForDuplicates(response: Response): Promise<DuplicateClientDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicateClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicateClientDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getDebtorProfile(fileId: string | undefined): Promise<DebtorProfilePageDto> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/GetDebtorProfile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDebtorProfile(_response);
        });
    }

    protected processGetDebtorProfile(response: Response): Promise<DebtorProfilePageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtorProfilePageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorProfilePageDto>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param fullName (optional) 
     * @param hasActiveFiles (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param clientStatus (optional) 
     * @param fileStage (optional) 
     * @param filingType (optional) 
     * @param trustee (optional) 
     * @param serviceLocation (optional) 
     * @param estateAdmin (optional) 
     * @param isEmailChecked (optional) 
     * @param isEstateNumberChecked (optional) 
     * @param sortingFieldName (optional) 
     * @param isAscending (optional) 
     * @param includeFileIds (optional) 
     * @param fileStageId (optional) 
     * @param fillingTypeId (optional) 
     * @param debtorId (optional) 
     * @param trusteeId (optional) 
     * @param officeId (optional) 
     * @param estateAdminId (optional) 
     * @return OK
     */
    getDebtorSearchResults(searchString: string | null | undefined, fullName: string | null | undefined, hasActiveFiles: boolean | undefined, pageSize: number | undefined, pageIndex: number | undefined, clientStatus: string[] | undefined, fileStage: string[] | undefined, filingType: (string | undefined)[] | undefined, trustee: (string | undefined)[] | undefined, serviceLocation: (string | undefined)[] | undefined, estateAdmin: (string | undefined)[] | undefined, isEmailChecked: boolean | undefined, isEstateNumberChecked: boolean | undefined, sortingFieldName: SortingFieldEnum | undefined, isAscending: boolean | undefined, includeFileIds: string[] | undefined, fileStageId: string | undefined, fillingTypeId: string | undefined, debtorId: string | undefined, trusteeId: string | undefined, officeId: string | undefined, estateAdminId: string | undefined): Promise<DebtorSearchResultsDto> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/GetDebtorSearchResults?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (fullName !== undefined && fullName !== null)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (hasActiveFiles === null)
            throw new Error("The parameter 'hasActiveFiles' cannot be null.");
        else if (hasActiveFiles !== undefined)
            url_ += "HasActiveFiles=" + encodeURIComponent("" + hasActiveFiles) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (clientStatus === null)
            throw new Error("The parameter 'clientStatus' cannot be null.");
        else if (clientStatus !== undefined)
            clientStatus && clientStatus.forEach(item => { url_ += "ClientStatus=" + encodeURIComponent("" + item) + "&"; });
        if (fileStage === null)
            throw new Error("The parameter 'fileStage' cannot be null.");
        else if (fileStage !== undefined)
            fileStage && fileStage.forEach(item => { url_ += "FileStage=" + encodeURIComponent("" + item) + "&"; });
        if (filingType === null)
            throw new Error("The parameter 'filingType' cannot be null.");
        else if (filingType !== undefined)
            filingType && filingType.forEach(item => { url_ += "FilingType=" + encodeURIComponent("" + item) + "&"; });
        if (trustee === null)
            throw new Error("The parameter 'trustee' cannot be null.");
        else if (trustee !== undefined)
            trustee && trustee.forEach(item => { url_ += "Trustee=" + encodeURIComponent("" + item) + "&"; });
        if (serviceLocation === null)
            throw new Error("The parameter 'serviceLocation' cannot be null.");
        else if (serviceLocation !== undefined)
            serviceLocation && serviceLocation.forEach(item => { url_ += "ServiceLocation=" + encodeURIComponent("" + item) + "&"; });
        if (estateAdmin === null)
            throw new Error("The parameter 'estateAdmin' cannot be null.");
        else if (estateAdmin !== undefined)
            estateAdmin && estateAdmin.forEach(item => { url_ += "EstateAdmin=" + encodeURIComponent("" + item) + "&"; });
        if (isEmailChecked === null)
            throw new Error("The parameter 'isEmailChecked' cannot be null.");
        else if (isEmailChecked !== undefined)
            url_ += "IsEmailChecked=" + encodeURIComponent("" + isEmailChecked) + "&";
        if (isEstateNumberChecked === null)
            throw new Error("The parameter 'isEstateNumberChecked' cannot be null.");
        else if (isEstateNumberChecked !== undefined)
            url_ += "IsEstateNumberChecked=" + encodeURIComponent("" + isEstateNumberChecked) + "&";
        if (sortingFieldName === null)
            throw new Error("The parameter 'sortingFieldName' cannot be null.");
        else if (sortingFieldName !== undefined)
            url_ += "SortingFieldName=" + encodeURIComponent("" + sortingFieldName) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (includeFileIds === null)
            throw new Error("The parameter 'includeFileIds' cannot be null.");
        else if (includeFileIds !== undefined)
            includeFileIds && includeFileIds.forEach(item => { url_ += "IncludeFileIds=" + encodeURIComponent("" + item) + "&"; });
        if (fileStageId === null)
            throw new Error("The parameter 'fileStageId' cannot be null.");
        else if (fileStageId !== undefined)
            url_ += "FileStageId=" + encodeURIComponent("" + fileStageId) + "&";
        if (fillingTypeId === null)
            throw new Error("The parameter 'fillingTypeId' cannot be null.");
        else if (fillingTypeId !== undefined)
            url_ += "FillingTypeId=" + encodeURIComponent("" + fillingTypeId) + "&";
        if (debtorId === null)
            throw new Error("The parameter 'debtorId' cannot be null.");
        else if (debtorId !== undefined)
            url_ += "DebtorId=" + encodeURIComponent("" + debtorId) + "&";
        if (trusteeId === null)
            throw new Error("The parameter 'trusteeId' cannot be null.");
        else if (trusteeId !== undefined)
            url_ += "TrusteeId=" + encodeURIComponent("" + trusteeId) + "&";
        if (officeId === null)
            throw new Error("The parameter 'officeId' cannot be null.");
        else if (officeId !== undefined)
            url_ += "OfficeId=" + encodeURIComponent("" + officeId) + "&";
        if (estateAdminId === null)
            throw new Error("The parameter 'estateAdminId' cannot be null.");
        else if (estateAdminId !== undefined)
            url_ += "EstateAdminId=" + encodeURIComponent("" + estateAdminId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDebtorSearchResults(_response);
        });
    }

    protected processGetDebtorSearchResults(response: Response): Promise<DebtorSearchResultsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtorSearchResultsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorSearchResultsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateDebtorProfile(body: DebtorProfileDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/ValidateDebtorProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateDebtorProfile(_response);
        });
    }

    protected processValidateDebtorProfile(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param createTask (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateDebtorProfilePOST(createTask: boolean | undefined, body: DebtorProfileDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/UpdateDebtorProfile?";
        if (createTask === null)
            throw new Error("The parameter 'createTask' cannot be null.");
        else if (createTask !== undefined)
            url_ += "createTask=" + encodeURIComponent("" + createTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDebtorProfilePOST(_response);
        });
    }

    protected processUpdateDebtorProfilePOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    resetPassword(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/ResetPassword?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @return OK
     */
    createNewApplicationFile(clientId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/CreateNewApplicationFile?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewApplicationFile(_response);
        });
    }

    protected processCreateNewApplicationFile(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    sendClientPortalResetPasswordEmail(fileId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/SendClientPortalResetPasswordEmail?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendClientPortalResetPasswordEmail(_response);
        });
    }

    protected processSendClientPortalResetPasswordEmail(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createDuplicateProspect(body: CreateDuplicateProspectDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/ClientInfo/CreateDuplicateProspect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDuplicateProspect(_response);
        });
    }

    protected processCreateDuplicateProspect(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getDebtorProfile2(): Promise<DebtorProfilePageDto> {
        let url_ = this.baseUrl + "/api/client-service-public/ClientInfo/GetDebtorProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDebtorProfile2(_response);
        });
    }

    protected processGetDebtorProfile2(response: Response): Promise<DebtorProfilePageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtorProfilePageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorProfilePageDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDebtorProfilePUT(fileId: string, body: DebtorProfileUpdatePublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/ClientInfo/UpdateDebtorProfile/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDebtorProfilePUT(_response);
        });
    }

    protected processUpdateDebtorProfilePUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    settings(fileId: string, body: DebtorSettingsPublicUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/ClientInfo/UpdateDebtorSettings/settings/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSettings(_response);
        });
    }

    protected processSettings(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDebtorPassword(body: DebtorPasswordUpdatePublicDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/ClientInfo/UpdateDebtorPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDebtorPassword(_response);
        });
    }

    protected processUpdateDebtorPassword(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleApiKey(): Promise<GoogleApiKeyDto> {
        let url_ = this.baseUrl + "/api/client-service/config/GetGoogleApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGoogleApiKey(_response);
        });
    }

    protected processGetGoogleApiKey(response: Response): Promise<GoogleApiKeyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleApiKeyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoogleApiKeyDto>(null as any);
    }

    /**
     * @return OK
     */
    getPDFTronKey(): Promise<PDFTronKeyDto> {
        let url_ = this.baseUrl + "/api/client-service/config/GetPDFTronKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPDFTronKey(_response);
        });
    }

    protected processGetPDFTronKey(response: Response): Promise<PDFTronKeyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PDFTronKeyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PDFTronKeyDto>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleApiKey2(): Promise<GoogleApiKeyDto> {
        let url_ = this.baseUrl + "/api/client-service-public/config/GetGoogleApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGoogleApiKey2(_response);
        });
    }

    protected processGetGoogleApiKey2(response: Response): Promise<GoogleApiKeyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoogleApiKeyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoogleApiKeyDto>(null as any);
    }

    verifyReCaptchaToken(body: VerifyReCaptchaTokenDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-public/config/VerifyReCaptchaToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyReCaptchaToken(_response);
        });
    }

    protected processVerifyReCaptchaToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllCPCTeams(): Promise<TeamDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/contact-staff/GetAllCPCTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCPCTeams(_response);
        });
    }

    protected processGetAllCPCTeams(response: Response): Promise<TeamDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendMessage(body: ContactStaffDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/contact-staff/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSupport(body: ContactSupportFormDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-public/contact-staff/ContactSupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processContactSupport(_response);
        });
    }

    protected processContactSupport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assignTrustee(body: CourtInputDetailsDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/courts/AssignTrustee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignTrustee(_response);
        });
    }

    protected processAssignTrustee(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    editTrusteeAssignment(body: CourtInputDetailsDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/courts/EditTrusteeAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditTrusteeAssignment(_response);
        });
    }

    protected processEditTrusteeAssignment(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param externalCourtId (optional) 
     * @param status (optional) 
     * @return OK
     */
    getCourtsSearchResults(searchString: string | null | undefined, externalCourtId: string | null | undefined, status: boolean | undefined): Promise<CourtDto> {
        let url_ = this.baseUrl + "/api/client-service/courts/GetCourtsSearchResults?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (externalCourtId !== undefined && externalCourtId !== null)
            url_ += "ExternalCourtId=" + encodeURIComponent("" + externalCourtId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourtsSearchResults(_response);
        });
    }

    protected processGetCourtsSearchResults(response: Response): Promise<CourtDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourtDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourtDto>(null as any);
    }

    /**
     * @return OK
     */
    getCourtList(): Promise<CourtOfficeDto[]> {
        let url_ = this.baseUrl + "/api/client-service/courts/GetCourtList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourtList(_response);
        });
    }

    protected processGetCourtList(response: Response): Promise<CourtOfficeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourtOfficeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourtOfficeDto[]>(null as any);
    }

    /**
     * @return OK
     */
    deleteTrustee(trusteeId: string, courtId: number): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/courts/DeleteTrustee/{TrusteeId}/{CourtId}";
        if (trusteeId === undefined || trusteeId === null)
            throw new Error("The parameter 'trusteeId' must be defined.");
        url_ = url_.replace("{TrusteeId}", encodeURIComponent("" + trusteeId));
        if (courtId === undefined || courtId === null)
            throw new Error("The parameter 'courtId' must be defined.");
        url_ = url_.replace("{CourtId}", encodeURIComponent("" + courtId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrustee(_response);
        });
    }

    protected processDeleteTrustee(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    runCreditCheckReport(body: CreditReportRequestDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/RunCreditCheckReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunCreditCheckReport(_response);
        });
    }

    protected processRunCreditCheckReport(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getCreditReportHistoryListByClientId(clientId: string): Promise<CreditReportHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetCreditReportHistoryListByClientId/GetCreditReportHistoryListByClientId/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditReportHistoryListByClientId(_response);
        });
    }

    protected processGetCreditReportHistoryListByClientId(response: Response): Promise<CreditReportHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getCreditReportHistoryListByFileId(fileId: string): Promise<CreditReportHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetCreditReportHistoryListByFileId/GetCreditReportHistoryListByFileId/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditReportHistoryListByFileId(_response);
        });
    }

    protected processGetCreditReportHistoryListByFileId(response: Response): Promise<CreditReportHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getCreditReportHistoryDetail(creditReportHistoryId: string): Promise<CreditReportHistoryDto> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetCreditReportHistoryDetail/GetCreditReportHistoryDetail/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditReportHistoryDetail(_response);
        });
    }

    protected processGetCreditReportHistoryDetail(response: Response): Promise<CreditReportHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditReportHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryDto>(null as any);
    }

    /**
     * @return OK
     */
    getAddressListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryAddressDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetAddressListByCreditReportHistoryId/GetAddressListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAddressListByCreditReportHistoryId(_response);
        });
    }

    protected processGetAddressListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryAddressDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryAddressDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getNameListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryNameDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetNameListByCreditReportHistoryId/GetNameListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNameListByCreditReportHistoryId(_response);
        });
    }

    protected processGetNameListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryNameDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryNameDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlertListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryAlertDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetAlertListByCreditReportHistoryId/GetAlertListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertListByCreditReportHistoryId(_response);
        });
    }

    protected processGetAlertListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryAlertDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryAlertDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryAlertDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getTradeListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryTradeDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetTradeListByCreditReportHistoryId/GetTradeListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTradeListByCreditReportHistoryId(_response);
        });
    }

    protected processGetTradeListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryTradeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryTradeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryTradeDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getProductScoreListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryProductScoreDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetProductScoreListByCreditReportHistoryId/GetProductScoreListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductScoreListByCreditReportHistoryId(_response);
        });
    }

    protected processGetProductScoreListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryProductScoreDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryProductScoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryProductScoreDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getPhoneListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryPhoneDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetPhoneListByCreditReportHistoryId/GetPhoneListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPhoneListByCreditReportHistoryId(_response);
        });
    }

    protected processGetPhoneListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryPhoneDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryPhoneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryPhoneDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getMessageListByCreditReportHistoryId(creditReportHistoryId: string): Promise<CreditReportHistoryMessageDto[]> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/GetMessageListByCreditReportHistoryId/GetMessageListByCreditReportHistoryId/{creditReportHistoryId}";
        if (creditReportHistoryId === undefined || creditReportHistoryId === null)
            throw new Error("The parameter 'creditReportHistoryId' must be defined.");
        url_ = url_.replace("{creditReportHistoryId}", encodeURIComponent("" + creditReportHistoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessageListByCreditReportHistoryId(_response);
        });
    }

    protected processGetMessageListByCreditReportHistoryId(response: Response): Promise<CreditReportHistoryMessageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditReportHistoryMessageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditReportHistoryMessageDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCreditReportHistoryById(body: CreditReportHistoryDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateCreditReportHistoryById/UpdateCreditReportHistoryByIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCreditReportHistoryById(_response);
        });
    }

    protected processUpdateCreditReportHistoryById(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAddressListByCreditReportHistoryId(body: CreditReportHistoryAddressDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateAddressListByCreditReportHistoryId/UpdateAddressListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAddressListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateAddressListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAlertListByCreditReportHistoryId(body: CreditReportHistoryAlertDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateAlertListByCreditReportHistoryId/UpdateAlertListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAlertListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateAlertListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNameListByCreditReportHistoryId(body: CreditReportHistoryNameDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateNameListByCreditReportHistoryId/UpdateNameListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNameListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateNameListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMessageListByCreditReportHistoryId(body: CreditReportHistoryMessageDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateMessageListByCreditReportHistoryId/UpdateMessageListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMessageListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateMessageListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePhoneListByCreditReportHistoryId(body: CreditReportHistoryPhoneDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdatePhoneListByCreditReportHistoryId/UpdatePhoneListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePhoneListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdatePhoneListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTradeListByCreditReportHistoryId(body: CreditReportHistoryTradeDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateTradeListByCreditReportHistoryId/UpdateTradeListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTradeListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateTradeListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProductScoreListByCreditReportHistoryId(body: CreditReportHistoryProductScoreDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/credit-report/UpdateProductScoreListByCreditReportHistoryId/UpdateProductScoreListByCreditReportHistoryIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProductScoreListByCreditReportHistoryId(_response);
        });
    }

    protected processUpdateProductScoreListByCreditReportHistoryId(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appTaskId (optional) 
     * @param appTaskIds (optional) 
     * @param filterText (optional) 
     * @param description (optional) 
     * @param openDateMin (optional) 
     * @param openDateMax (optional) 
     * @param closeDateMin (optional) 
     * @param closeDateMax (optional) 
     * @param assignedAgentIds (optional) 
     * @param assignedTeamIds (optional) 
     * @param appTaskNames (optional) 
     * @param appTaskStatuses (optional) 
     * @param fileId (optional) 
     * @param fileStages (optional) 
     * @param fileProcesses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    listAssignedTasks(appTaskId: string | undefined, appTaskIds: string[] | undefined, filterText: string | null | undefined, description: string | null | undefined, openDateMin: moment.Moment | undefined, openDateMax: moment.Moment | undefined, closeDateMin: moment.Moment | undefined, closeDateMax: moment.Moment | undefined, assignedAgentIds: string[] | undefined, assignedTeamIds: string[] | undefined, appTaskNames: AppTaskNameEnum[] | undefined, appTaskStatuses: AppTaskStatusEnum[] | undefined, fileId: string | undefined, fileStages: FileStageEnum[] | undefined, fileProcesses: FileProcessEnum[] | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/Dashboard/ListAssignedTasks?";
        if (appTaskId === null)
            throw new Error("The parameter 'appTaskId' cannot be null.");
        else if (appTaskId !== undefined)
            url_ += "AppTaskId=" + encodeURIComponent("" + appTaskId) + "&";
        if (appTaskIds === null)
            throw new Error("The parameter 'appTaskIds' cannot be null.");
        else if (appTaskIds !== undefined)
            appTaskIds && appTaskIds.forEach(item => { url_ += "AppTaskIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (openDateMin === null)
            throw new Error("The parameter 'openDateMin' cannot be null.");
        else if (openDateMin !== undefined)
            url_ += "OpenDateMin=" + encodeURIComponent(openDateMin ? "" + openDateMin.toISOString() : "") + "&";
        if (openDateMax === null)
            throw new Error("The parameter 'openDateMax' cannot be null.");
        else if (openDateMax !== undefined)
            url_ += "OpenDateMax=" + encodeURIComponent(openDateMax ? "" + openDateMax.toISOString() : "") + "&";
        if (closeDateMin === null)
            throw new Error("The parameter 'closeDateMin' cannot be null.");
        else if (closeDateMin !== undefined)
            url_ += "CloseDateMin=" + encodeURIComponent(closeDateMin ? "" + closeDateMin.toISOString() : "") + "&";
        if (closeDateMax === null)
            throw new Error("The parameter 'closeDateMax' cannot be null.");
        else if (closeDateMax !== undefined)
            url_ += "CloseDateMax=" + encodeURIComponent(closeDateMax ? "" + closeDateMax.toISOString() : "") + "&";
        if (assignedAgentIds === null)
            throw new Error("The parameter 'assignedAgentIds' cannot be null.");
        else if (assignedAgentIds !== undefined)
            assignedAgentIds && assignedAgentIds.forEach(item => { url_ += "AssignedAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (assignedTeamIds === null)
            throw new Error("The parameter 'assignedTeamIds' cannot be null.");
        else if (assignedTeamIds !== undefined)
            assignedTeamIds && assignedTeamIds.forEach(item => { url_ += "AssignedTeamIds=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskNames === null)
            throw new Error("The parameter 'appTaskNames' cannot be null.");
        else if (appTaskNames !== undefined)
            appTaskNames && appTaskNames.forEach(item => { url_ += "AppTaskNames=" + encodeURIComponent("" + item) + "&"; });
        if (appTaskStatuses === null)
            throw new Error("The parameter 'appTaskStatuses' cannot be null.");
        else if (appTaskStatuses !== undefined)
            appTaskStatuses && appTaskStatuses.forEach(item => { url_ += "AppTaskStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (fileStages === null)
            throw new Error("The parameter 'fileStages' cannot be null.");
        else if (fileStages !== undefined)
            fileStages && fileStages.forEach(item => { url_ += "FileStages=" + encodeURIComponent("" + item) + "&"; });
        if (fileProcesses === null)
            throw new Error("The parameter 'fileProcesses' cannot be null.");
        else if (fileProcesses !== undefined)
            fileProcesses && fileProcesses.forEach(item => { url_ += "FileProcesses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssignedTasks(_response);
        });
    }

    protected processListAssignedTasks(response: Response): Promise<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param ids (optional) 
     * @param newStatusId (optional) 
     * @return OK
     */
    updateTaskStatuses(ids: string[] | undefined, newStatusId: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Dashboard/UpdateTaskStatuses?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (newStatusId === null)
            throw new Error("The parameter 'newStatusId' cannot be null.");
        else if (newStatusId !== undefined)
            url_ += "NewStatusId=" + encodeURIComponent("" + newStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskStatuses(_response);
        });
    }

    protected processUpdateTaskStatuses(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param filterTextlang (optional) 
     * @param fileId (optional) 
     * @param documentId (optional) 
     * @param documentIds (optional) 
     * @param documentFolderId (optional) 
     * @param documentVerificationStatusId (optional) 
     * @param documentVerificationStatuses (optional) 
     * @param documentTypeId (optional) 
     * @param documentTypes (optional) 
     * @param documentPrefixes (optional) 
     * @param documentPrefixCodes (optional) 
     * @param documentFolders (optional) 
     * @param isVisible (optional) 
     * @param isDeleted (optional) 
     * @param modifiedDateMin (optional) 
     * @param modifiedDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    documentsGET(filterText: string | null | undefined, filterTextlang: LanguageEnum | undefined, fileId: string | undefined, documentId: string | undefined, documentIds: string[] | undefined, documentFolderId: string | undefined, documentVerificationStatusId: string | undefined, documentVerificationStatuses: DocumentVerificationStatusEnum[] | undefined, documentTypeId: string | undefined, documentTypes: DocumentTypeEnum[] | undefined, documentPrefixes: string[] | undefined, documentPrefixCodes: (string | undefined)[] | undefined, documentFolders: string[] | undefined, isVisible: boolean | undefined, isDeleted: boolean | undefined, modifiedDateMin: moment.Moment | undefined, modifiedDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/documents?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (filterTextlang === null)
            throw new Error("The parameter 'filterTextlang' cannot be null.");
        else if (filterTextlang !== undefined)
            url_ += "FilterTextlang=" + encodeURIComponent("" + filterTextlang) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentIds === null)
            throw new Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "DocumentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (documentVerificationStatusId === null)
            throw new Error("The parameter 'documentVerificationStatusId' cannot be null.");
        else if (documentVerificationStatusId !== undefined)
            url_ += "DocumentVerificationStatusId=" + encodeURIComponent("" + documentVerificationStatusId) + "&";
        if (documentVerificationStatuses === null)
            throw new Error("The parameter 'documentVerificationStatuses' cannot be null.");
        else if (documentVerificationStatuses !== undefined)
            documentVerificationStatuses && documentVerificationStatuses.forEach(item => { url_ += "DocumentVerificationStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (documentTypes === null)
            throw new Error("The parameter 'documentTypes' cannot be null.");
        else if (documentTypes !== undefined)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixes === null)
            throw new Error("The parameter 'documentPrefixes' cannot be null.");
        else if (documentPrefixes !== undefined)
            documentPrefixes && documentPrefixes.forEach(item => { url_ += "DocumentPrefixes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixCodes === null)
            throw new Error("The parameter 'documentPrefixCodes' cannot be null.");
        else if (documentPrefixCodes !== undefined)
            documentPrefixCodes && documentPrefixCodes.forEach(item => { url_ += "DocumentPrefixCodes=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolders === null)
            throw new Error("The parameter 'documentFolders' cannot be null.");
        else if (documentFolders !== undefined)
            documentFolders && documentFolders.forEach(item => { url_ += "DocumentFolders=" + encodeURIComponent("" + item) + "&"; });
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "IsVisible=" + encodeURIComponent("" + isVisible) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (modifiedDateMin === null)
            throw new Error("The parameter 'modifiedDateMin' cannot be null.");
        else if (modifiedDateMin !== undefined)
            url_ += "ModifiedDateMin=" + encodeURIComponent(modifiedDateMin ? "" + modifiedDateMin.toISOString() : "") + "&";
        if (modifiedDateMax === null)
            throw new Error("The parameter 'modifiedDateMax' cannot be null.");
        else if (modifiedDateMax !== undefined)
            url_ += "ModifiedDateMax=" + encodeURIComponent(modifiedDateMax ? "" + modifiedDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsGET(_response);
        });
    }

    protected processDocumentsGET(response: Response): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param documentFolderId (optional) 
     * @param documentPrefixId (optional) 
     * @param additionalInformation (optional) 
     * @param isVisible (optional) 
     * @param fileModifiedDate (optional) 
     * @param content (optional) 
     * @param isForSpouse (optional) 
     * @param businessName (optional) 
     * @return OK
     */
    documentsPOST(fileId: string | undefined, documentFolderId: string | undefined, documentPrefixId: string | undefined, additionalInformation: string | null | undefined, isVisible: boolean | undefined, fileModifiedDate: moment.Moment | undefined, content: FileParameter | null | undefined, isForSpouse: boolean | undefined, businessName: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileId === null || fileId === undefined)
            throw new Error("The parameter 'fileId' cannot be null.");
        else
            content_.append("FileId", fileId.toString());
        if (documentFolderId === null || documentFolderId === undefined)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else
            content_.append("DocumentFolderId", documentFolderId.toString());
        if (documentPrefixId === null || documentPrefixId === undefined)
            throw new Error("The parameter 'documentPrefixId' cannot be null.");
        else
            content_.append("DocumentPrefixId", documentPrefixId.toString());
        if (additionalInformation !== null && additionalInformation !== undefined)
            content_.append("AdditionalInformation", additionalInformation.toString());
        if (isVisible === null || isVisible === undefined)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else
            content_.append("IsVisible", isVisible.toString());
        if (fileModifiedDate === null || fileModifiedDate === undefined)
            throw new Error("The parameter 'fileModifiedDate' cannot be null.");
        else
            content_.append("FileModifiedDate", fileModifiedDate.toJSON());
        if (content !== null && content !== undefined)
            content_.append("Content", content.data, content.fileName ? content.fileName : "Content");
        if (isForSpouse === null || isForSpouse === undefined)
            throw new Error("The parameter 'isForSpouse' cannot be null.");
        else
            content_.append("IsForSpouse", isForSpouse.toString());
        if (businessName !== null && businessName !== undefined)
            content_.append("BusinessName", businessName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsPOST(_response);
        });
    }

    protected processDocumentsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    documentsDELETE(ids: string[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsDELETE(_response);
        });
    }

    protected processDocumentsDELETE(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param filterTextlang (optional) 
     * @param fileId (optional) 
     * @param documentId (optional) 
     * @param documentIds (optional) 
     * @param documentFolderId (optional) 
     * @param documentVerificationStatusId (optional) 
     * @param documentVerificationStatuses (optional) 
     * @param documentTypeId (optional) 
     * @param documentTypes (optional) 
     * @param documentPrefixes (optional) 
     * @param documentPrefixCodes (optional) 
     * @param documentFolders (optional) 
     * @param isVisible (optional) 
     * @param isDeleted (optional) 
     * @param modifiedDateMin (optional) 
     * @param modifiedDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    count3(filterText: string | null | undefined, filterTextlang: LanguageEnum | undefined, fileId: string | undefined, documentId: string | undefined, documentIds: string[] | undefined, documentFolderId: string | undefined, documentVerificationStatusId: string | undefined, documentVerificationStatuses: DocumentVerificationStatusEnum[] | undefined, documentTypeId: string | undefined, documentTypes: DocumentTypeEnum[] | undefined, documentPrefixes: string[] | undefined, documentPrefixCodes: (string | undefined)[] | undefined, documentFolders: string[] | undefined, isVisible: boolean | undefined, isDeleted: boolean | undefined, modifiedDateMin: moment.Moment | undefined, modifiedDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service/documents/count?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (filterTextlang === null)
            throw new Error("The parameter 'filterTextlang' cannot be null.");
        else if (filterTextlang !== undefined)
            url_ += "FilterTextlang=" + encodeURIComponent("" + filterTextlang) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentIds === null)
            throw new Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "DocumentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (documentVerificationStatusId === null)
            throw new Error("The parameter 'documentVerificationStatusId' cannot be null.");
        else if (documentVerificationStatusId !== undefined)
            url_ += "DocumentVerificationStatusId=" + encodeURIComponent("" + documentVerificationStatusId) + "&";
        if (documentVerificationStatuses === null)
            throw new Error("The parameter 'documentVerificationStatuses' cannot be null.");
        else if (documentVerificationStatuses !== undefined)
            documentVerificationStatuses && documentVerificationStatuses.forEach(item => { url_ += "DocumentVerificationStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (documentTypes === null)
            throw new Error("The parameter 'documentTypes' cannot be null.");
        else if (documentTypes !== undefined)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixes === null)
            throw new Error("The parameter 'documentPrefixes' cannot be null.");
        else if (documentPrefixes !== undefined)
            documentPrefixes && documentPrefixes.forEach(item => { url_ += "DocumentPrefixes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixCodes === null)
            throw new Error("The parameter 'documentPrefixCodes' cannot be null.");
        else if (documentPrefixCodes !== undefined)
            documentPrefixCodes && documentPrefixCodes.forEach(item => { url_ += "DocumentPrefixCodes=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolders === null)
            throw new Error("The parameter 'documentFolders' cannot be null.");
        else if (documentFolders !== undefined)
            documentFolders && documentFolders.forEach(item => { url_ += "DocumentFolders=" + encodeURIComponent("" + item) + "&"; });
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "IsVisible=" + encodeURIComponent("" + isVisible) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (modifiedDateMin === null)
            throw new Error("The parameter 'modifiedDateMin' cannot be null.");
        else if (modifiedDateMin !== undefined)
            url_ += "ModifiedDateMin=" + encodeURIComponent(modifiedDateMin ? "" + modifiedDateMin.toISOString() : "") + "&";
        if (modifiedDateMax === null)
            throw new Error("The parameter 'modifiedDateMax' cannot be null.");
        else if (modifiedDateMax !== undefined)
            url_ += "ModifiedDateMax=" + encodeURIComponent(modifiedDateMax ? "" + modifiedDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCount3(_response);
        });
    }

    protected processCount3(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param documentPrefixId (optional) 
     * @param additionalInformation (optional) 
     * @param fileModifiedDate (optional) 
     * @param content (optional) 
     * @param isVisible (optional) 
     * @return OK
     */
    documentsPUT(id: string, documentFolderId: string | undefined, documentPrefixId: string | undefined, additionalInformation: string | null | undefined, fileModifiedDate: moment.Moment | undefined, content: FileParameter | null | undefined, isVisible: boolean | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (documentFolderId === null || documentFolderId === undefined)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else
            content_.append("DocumentFolderId", documentFolderId.toString());
        if (documentPrefixId === null || documentPrefixId === undefined)
            throw new Error("The parameter 'documentPrefixId' cannot be null.");
        else
            content_.append("DocumentPrefixId", documentPrefixId.toString());
        if (additionalInformation !== null && additionalInformation !== undefined)
            content_.append("AdditionalInformation", additionalInformation.toString());
        if (fileModifiedDate === null || fileModifiedDate === undefined)
            throw new Error("The parameter 'fileModifiedDate' cannot be null.");
        else
            content_.append("FileModifiedDate", fileModifiedDate.toJSON());
        if (content !== null && content !== undefined)
            content_.append("Content", content.data, content.fileName ? content.fileName : "Content");
        if (isVisible === null || isVisible === undefined)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else
            content_.append("IsVisible", isVisible.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsPUT(_response);
        });
    }

    protected processDocumentsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    documentsGET2(id: string): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsGET2(_response);
        });
    }

    protected processDocumentsGET2(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    /**
     * @return OK
     */
    documentsDELETE2(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsDELETE2(_response);
        });
    }

    protected processDocumentsDELETE2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    downloadAsPdf(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}/download-as-pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAsPdf(_response);
        });
    }

    protected processDownloadAsPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download2(id: string, versionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}/download/{versionId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload2(_response);
        });
    }

    protected processDownload2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download3(documentIds: string[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/download?";
        if (documentIds === null)
            throw new Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload3(_response);
        });
    }

    protected processDownload3(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    copy(id: string, body: DocumentCopyDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    restore(id: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents/{id}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param modifiedDateMin (optional) 
     * @param modifiedDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    versionsGET(documentId: string | undefined, modifiedDateMin: moment.Moment | undefined, modifiedDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/documents/versions?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (modifiedDateMin === null)
            throw new Error("The parameter 'modifiedDateMin' cannot be null.");
        else if (modifiedDateMin !== undefined)
            url_ += "ModifiedDateMin=" + encodeURIComponent(modifiedDateMin ? "" + modifiedDateMin.toISOString() : "") + "&";
        if (modifiedDateMax === null)
            throw new Error("The parameter 'modifiedDateMax' cannot be null.");
        else if (modifiedDateMax !== undefined)
            url_ += "ModifiedDateMax=" + encodeURIComponent(modifiedDateMax ? "" + modifiedDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVersionsGET(_response);
        });
    }

    protected processVersionsGET(response: Response): Promise<PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    versionsDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/versions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVersionsDELETE(_response);
        });
    }

    protected processVersionsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    restore2(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/documents/versions/{id}/restore";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestore2(_response);
        });
    }

    protected processRestore2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bundle(body: DocumentBundleDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/documents/bundle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBundle(_response);
        });
    }

    protected processBundle(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    listTypes(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/documents/list-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTypes(_response);
        });
    }

    protected processListTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listFolders(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/documents/list-folders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFolders(_response);
        });
    }

    protected processListFolders(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param prefixCodes (optional) 
     * @return OK
     */
    listPrefixes(documentFolderId: string | undefined, prefixCodes: (string | undefined)[] | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/documents/list-prefixes?";
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "documentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (prefixCodes === null)
            throw new Error("The parameter 'prefixCodes' cannot be null.");
        else if (prefixCodes !== undefined)
            prefixCodes && prefixCodes.forEach(item => { url_ += "prefixCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPrefixes(_response);
        });
    }

    protected processListPrefixes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param context (optional) 
     * @return OK
     */
    listDocumentPrefixesByContext(documentFolderId: string | undefined, context: DocumentPrefixContextEnum | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/documents/ListDocumentPrefixesByContext?";
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "documentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (context === null)
            throw new Error("The parameter 'context' cannot be null.");
        else if (context !== undefined)
            url_ += "context=" + encodeURIComponent("" + context) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDocumentPrefixesByContext(_response);
        });
    }

    protected processListDocumentPrefixesByContext(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param documentFolderEnum (optional) 
     * @param documentPrefixCode (optional) 
     * @return OK
     */
    checkDocumentsUploaded(fileId: string | undefined, documentFolderEnum: DocumentFolderEnum | undefined, documentPrefixCode: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/documents/check-documents-uploaded?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentFolderEnum === null)
            throw new Error("The parameter 'documentFolderEnum' cannot be null.");
        else if (documentFolderEnum !== undefined)
            url_ += "documentFolderEnum=" + encodeURIComponent("" + documentFolderEnum) + "&";
        if (documentPrefixCode !== undefined && documentPrefixCode !== null)
            url_ += "documentPrefixCode=" + encodeURIComponent("" + documentPrefixCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckDocumentsUploaded(_response);
        });
    }

    protected processCheckDocumentsUploaded(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param appFormAssetsDebtsAssetId (optional) 
     * @param documentFolderId (optional) 
     * @return OK
     */
    getApplicabilityOverride(fileId: string | undefined, appFormAssetsDebtsAssetId: string | undefined, documentFolderId: string | undefined): Promise<SupportingDocumentApplicabilityOverrideItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/documents/get-applicability-override?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (appFormAssetsDebtsAssetId === null)
            throw new Error("The parameter 'appFormAssetsDebtsAssetId' cannot be null.");
        else if (appFormAssetsDebtsAssetId !== undefined)
            url_ += "appFormAssetsDebtsAssetId=" + encodeURIComponent("" + appFormAssetsDebtsAssetId) + "&";
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "documentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicabilityOverride(_response);
        });
    }

    protected processGetApplicabilityOverride(response: Response): Promise<SupportingDocumentApplicabilityOverrideItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportingDocumentApplicabilityOverrideItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentApplicabilityOverrideItemDto[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    convertHeicToPdf(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/client-service/documents/convert-heic-to-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConvertHeicToPdf(_response);
        });
    }

    protected processConvertHeicToPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    requestCode(): Promise<RequestDocumentDownloadCodeResultDto> {
        let url_ = this.baseUrl + "/api/client-service-public/document-download-mfa/request-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestCode(_response);
        });
    }

    protected processRequestCode(response: Response): Promise<RequestDocumentDownloadCodeResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDocumentDownloadCodeResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDocumentDownloadCodeResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyCode(body: VerifyDocumentDownloadCodeInputDto | undefined): Promise<VerifyDocumentDownloadCodeResultDto> {
        let url_ = this.baseUrl + "/api/client-service-public/document-download-mfa/verify-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyCode(_response);
        });
    }

    protected processVerifyCode(response: Response): Promise<VerifyDocumentDownloadCodeResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyDocumentDownloadCodeResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyDocumentDownloadCodeResultDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param filterTextlang (optional) 
     * @param fileId (optional) 
     * @param documentId (optional) 
     * @param documentIds (optional) 
     * @param documentFolderId (optional) 
     * @param documentVerificationStatusId (optional) 
     * @param documentVerificationStatuses (optional) 
     * @param documentTypeId (optional) 
     * @param documentTypes (optional) 
     * @param documentPrefixes (optional) 
     * @param documentPrefixCodes (optional) 
     * @param documentFolders (optional) 
     * @param isVisible (optional) 
     * @param isDeleted (optional) 
     * @param modifiedDateMin (optional) 
     * @param modifiedDateMax (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    documentsGET3(filterText: string | null | undefined, filterTextlang: LanguageEnum | undefined, fileId: string | undefined, documentId: string | undefined, documentIds: string[] | undefined, documentFolderId: string | undefined, documentVerificationStatusId: string | undefined, documentVerificationStatuses: DocumentVerificationStatusEnum[] | undefined, documentTypeId: string | undefined, documentTypes: DocumentTypeEnum[] | undefined, documentPrefixes: string[] | undefined, documentPrefixCodes: (string | undefined)[] | undefined, documentFolders: string[] | undefined, isVisible: boolean | undefined, isDeleted: boolean | undefined, modifiedDateMin: moment.Moment | undefined, modifiedDateMax: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service-public/documents?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (filterTextlang === null)
            throw new Error("The parameter 'filterTextlang' cannot be null.");
        else if (filterTextlang !== undefined)
            url_ += "FilterTextlang=" + encodeURIComponent("" + filterTextlang) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentIds === null)
            throw new Error("The parameter 'documentIds' cannot be null.");
        else if (documentIds !== undefined)
            documentIds && documentIds.forEach(item => { url_ += "DocumentIds=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "DocumentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (documentVerificationStatusId === null)
            throw new Error("The parameter 'documentVerificationStatusId' cannot be null.");
        else if (documentVerificationStatusId !== undefined)
            url_ += "DocumentVerificationStatusId=" + encodeURIComponent("" + documentVerificationStatusId) + "&";
        if (documentVerificationStatuses === null)
            throw new Error("The parameter 'documentVerificationStatuses' cannot be null.");
        else if (documentVerificationStatuses !== undefined)
            documentVerificationStatuses && documentVerificationStatuses.forEach(item => { url_ += "DocumentVerificationStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (documentTypes === null)
            throw new Error("The parameter 'documentTypes' cannot be null.");
        else if (documentTypes !== undefined)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixes === null)
            throw new Error("The parameter 'documentPrefixes' cannot be null.");
        else if (documentPrefixes !== undefined)
            documentPrefixes && documentPrefixes.forEach(item => { url_ += "DocumentPrefixes=" + encodeURIComponent("" + item) + "&"; });
        if (documentPrefixCodes === null)
            throw new Error("The parameter 'documentPrefixCodes' cannot be null.");
        else if (documentPrefixCodes !== undefined)
            documentPrefixCodes && documentPrefixCodes.forEach(item => { url_ += "DocumentPrefixCodes=" + encodeURIComponent("" + item) + "&"; });
        if (documentFolders === null)
            throw new Error("The parameter 'documentFolders' cannot be null.");
        else if (documentFolders !== undefined)
            documentFolders && documentFolders.forEach(item => { url_ += "DocumentFolders=" + encodeURIComponent("" + item) + "&"; });
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "IsVisible=" + encodeURIComponent("" + isVisible) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (modifiedDateMin === null)
            throw new Error("The parameter 'modifiedDateMin' cannot be null.");
        else if (modifiedDateMin !== undefined)
            url_ += "ModifiedDateMin=" + encodeURIComponent(modifiedDateMin ? "" + modifiedDateMin.toISOString() : "") + "&";
        if (modifiedDateMax === null)
            throw new Error("The parameter 'modifiedDateMax' cannot be null.");
        else if (modifiedDateMax !== undefined)
            url_ += "ModifiedDateMax=" + encodeURIComponent(modifiedDateMax ? "" + modifiedDateMax.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsGET3(_response);
        });
    }

    protected processDocumentsGET3(response: Response): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param documentPrefixId (optional) 
     * @param additionalInformation (optional) 
     * @param isVisible (optional) 
     * @param fileModifiedDate (optional) 
     * @param content (optional) 
     * @param isForSpouse (optional) 
     * @param businessName (optional) 
     * @return OK
     */
    documentsPOST2(documentFolderId: string | undefined, documentPrefixId: string | undefined, additionalInformation: string | null | undefined, isVisible: boolean | undefined, fileModifiedDate: moment.Moment | undefined, content: FileParameter | null | undefined, isForSpouse: boolean | undefined, businessName: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (documentFolderId === null || documentFolderId === undefined)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else
            content_.append("DocumentFolderId", documentFolderId.toString());
        if (documentPrefixId === null || documentPrefixId === undefined)
            throw new Error("The parameter 'documentPrefixId' cannot be null.");
        else
            content_.append("DocumentPrefixId", documentPrefixId.toString());
        if (additionalInformation !== null && additionalInformation !== undefined)
            content_.append("AdditionalInformation", additionalInformation.toString());
        if (isVisible === null || isVisible === undefined)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else
            content_.append("IsVisible", isVisible.toString());
        if (fileModifiedDate === null || fileModifiedDate === undefined)
            throw new Error("The parameter 'fileModifiedDate' cannot be null.");
        else
            content_.append("FileModifiedDate", fileModifiedDate.toJSON());
        if (content !== null && content !== undefined)
            content_.append("Content", content.data, content.fileName ? content.fileName : "Content");
        if (isForSpouse === null || isForSpouse === undefined)
            throw new Error("The parameter 'isForSpouse' cannot be null.");
        else
            content_.append("IsForSpouse", isForSpouse.toString());
        if (businessName !== null && businessName !== undefined)
            content_.append("BusinessName", businessName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsPOST2(_response);
        });
    }

    protected processDocumentsPOST2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    documentsDELETE3(ids: string[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/documents?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentsDELETE3(_response);
        });
    }

    protected processDocumentsDELETE3(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    download4(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload4(_response);
        });
    }

    protected processDownload4(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    listTypes2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/list-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTypes2(_response);
        });
    }

    protected processListTypes2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listFolders2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/list-folders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFolders2(_response);
        });
    }

    protected processListFolders2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param assetId (optional) 
     * @param prefixCodes (optional) 
     * @return OK
     */
    listPrefixes2(documentFolderId: string | undefined, assetId: string | undefined, prefixCodes: (string | undefined)[] | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/list-prefixes?";
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "documentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (prefixCodes === null)
            throw new Error("The parameter 'prefixCodes' cannot be null.");
        else if (prefixCodes !== undefined)
            prefixCodes && prefixCodes.forEach(item => { url_ += "prefixCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPrefixes2(_response);
        });
    }

    protected processListPrefixes2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional) 
     * @param context (optional) 
     * @return OK
     */
    listDocumentPrefixesByContext2(documentFolderId: string | undefined, context: DocumentPrefixContextEnum | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/ListDocumentPrefixesByContext?";
        if (documentFolderId === null)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else if (documentFolderId !== undefined)
            url_ += "documentFolderId=" + encodeURIComponent("" + documentFolderId) + "&";
        if (context === null)
            throw new Error("The parameter 'context' cannot be null.");
        else if (context !== undefined)
            url_ += "context=" + encodeURIComponent("" + context) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDocumentPrefixesByContext2(_response);
        });
    }

    protected processListDocumentPrefixesByContext2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    convertHeicToJpg(file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/client-service-public/documents/convert-heic-to-jpg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConvertHeicToJpg(_response);
        });
    }

    protected processConvertHeicToJpg(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : <any>null;
    
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    documentVerificationsGET(id: string): Promise<DocumentVerificationDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentVerificationsGET(_response);
        });
    }

    protected processDocumentVerificationsGET(response: Response): Promise<DocumentVerificationDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentVerificationDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentVerificationDetailDto>(null as any);
    }

    /**
     * @return OK
     */
    documentVerificationsDELETE(id: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentVerificationsDELETE(_response);
        });
    }

    protected processDocumentVerificationsDELETE(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    documentVerificationFromApptaskaction(appTaskActionId: string): Promise<DocumentVerificationDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/document-verification-from-apptaskaction/{appTaskActionId}";
        if (appTaskActionId === undefined || appTaskActionId === null)
            throw new Error("The parameter 'appTaskActionId' must be defined.");
        url_ = url_.replace("{appTaskActionId}", encodeURIComponent("" + appTaskActionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentVerificationFromApptaskaction(_response);
        });
    }

    protected processDocumentVerificationFromApptaskaction(response: Response): Promise<DocumentVerificationDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentVerificationDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentVerificationDetailDto>(null as any);
    }

    /**
     * @return OK
     */
    pendingVerificationCount(id: string): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/{id}/pending-verification-count";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPendingVerificationCount(_response);
        });
    }

    protected processPendingVerificationCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param fileId (optional) 
     * @param documentId (optional) 
     * @param documentFolders (optional) 
     * @param assignedToCurrentUser (optional) 
     * @param assignedToAgentId (optional) 
     * @param includeOnlyPending (optional) 
     * @param documentTypes (optional) 
     * @param verificationStatuses (optional) 
     * @param isUrgent (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    documentVerificationsGET2(filterText: string | null | undefined, fileId: string | undefined, documentId: string | undefined, documentFolders: string[] | undefined, assignedToCurrentUser: boolean | undefined, assignedToAgentId: string | undefined, includeOnlyPending: boolean | undefined, documentTypes: DocumentTypeEnum[] | undefined, verificationStatuses: DocumentVerificationStatusEnum[] | undefined, isUrgent: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentFolders === null)
            throw new Error("The parameter 'documentFolders' cannot be null.");
        else if (documentFolders !== undefined)
            documentFolders && documentFolders.forEach(item => { url_ += "DocumentFolders=" + encodeURIComponent("" + item) + "&"; });
        if (assignedToCurrentUser === null)
            throw new Error("The parameter 'assignedToCurrentUser' cannot be null.");
        else if (assignedToCurrentUser !== undefined)
            url_ += "AssignedToCurrentUser=" + encodeURIComponent("" + assignedToCurrentUser) + "&";
        if (assignedToAgentId === null)
            throw new Error("The parameter 'assignedToAgentId' cannot be null.");
        else if (assignedToAgentId !== undefined)
            url_ += "AssignedToAgentId=" + encodeURIComponent("" + assignedToAgentId) + "&";
        if (includeOnlyPending === null)
            throw new Error("The parameter 'includeOnlyPending' cannot be null.");
        else if (includeOnlyPending !== undefined)
            url_ += "IncludeOnlyPending=" + encodeURIComponent("" + includeOnlyPending) + "&";
        if (documentTypes === null)
            throw new Error("The parameter 'documentTypes' cannot be null.");
        else if (documentTypes !== undefined)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (verificationStatuses === null)
            throw new Error("The parameter 'verificationStatuses' cannot be null.");
        else if (verificationStatuses !== undefined)
            verificationStatuses && verificationStatuses.forEach(item => { url_ += "VerificationStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (isUrgent === null)
            throw new Error("The parameter 'isUrgent' cannot be null.");
        else if (isUrgent !== undefined)
            url_ += "IsUrgent=" + encodeURIComponent("" + isUrgent) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentVerificationsGET2(_response);
        });
    }

    protected processDocumentVerificationsGET2(response: Response): Promise<PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentVerificationsPOST(body: DocumentVerificationCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDocumentVerificationsPOST(_response);
        });
    }

    protected processDocumentVerificationsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param documentFolderEnum (optional) 
     * @param documentPrefix (optional) 
     * @param verificationRoleType (optional) 
     * @param isApproved (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    history(fileId: string | undefined, documentFolderEnum: DocumentFolderEnum | undefined, documentPrefix: string | null | undefined, verificationRoleType: DocumentVerificationRoleTypeEnum | undefined, isApproved: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<DocumentVerificationHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/history?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (documentFolderEnum === null)
            throw new Error("The parameter 'documentFolderEnum' cannot be null.");
        else if (documentFolderEnum !== undefined)
            url_ += "DocumentFolderEnum=" + encodeURIComponent("" + documentFolderEnum) + "&";
        if (documentPrefix !== undefined && documentPrefix !== null)
            url_ += "DocumentPrefix=" + encodeURIComponent("" + documentPrefix) + "&";
        if (verificationRoleType === null)
            throw new Error("The parameter 'verificationRoleType' cannot be null.");
        else if (verificationRoleType !== undefined)
            url_ += "VerificationRoleType=" + encodeURIComponent("" + verificationRoleType) + "&";
        if (isApproved === null)
            throw new Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "IsApproved=" + encodeURIComponent("" + isApproved) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: Response): Promise<DocumentVerificationHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentVerificationHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentVerificationHistoryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPUT(id: string, body: DocumentVerificationSubmitDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/document-verifications/{id}/submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitPUT(_response);
        });
    }

    protected processSubmitPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisBankruptcyDetails(body: FileAnalysisBankruptcyDetailDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisBankruptcyDetail/UpdateFileAnalysisBankruptcyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisBankruptcyDetails(_response);
        });
    }

    protected processUpdateFileAnalysisBankruptcyDetails(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisBankruptcyDetails(fileId: string | undefined): Promise<FileAnalysisBankruptcyDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisBankruptcyDetail/GetFileAnalysisBankruptcyDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisBankruptcyDetails(_response);
        });
    }

    protected processGetFileAnalysisBankruptcyDetails(response: Response): Promise<FileAnalysisBankruptcyDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisBankruptcyDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisBankruptcyDetailDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisCalculations(fileId: string | undefined): Promise<FileAnalysisCalculationsDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisCalculations/GetFileAnalysisCalculations?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisCalculations(_response);
        });
    }

    protected processGetFileAnalysisCalculations(response: Response): Promise<FileAnalysisCalculationsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisCalculationsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisCalculationsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisSurplusIncomeConfigurations(body: FileAnalysisSurplusIncomeConfigurationInputDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/UpdateFileAnalysisSurplusIncomeConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisSurplusIncomeConfigurations(_response);
        });
    }

    protected processUpdateFileAnalysisSurplusIncomeConfigurations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getFileAnalysisSurplusIncomeConfigurationsList(): Promise<FileAnalysisSurplusIncomeConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/GetFileAnalysisSurplusIncomeConfigurationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisSurplusIncomeConfigurationsList(_response);
        });
    }

    protected processGetFileAnalysisSurplusIncomeConfigurationsList(response: Response): Promise<FileAnalysisSurplusIncomeConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAnalysisSurplusIncomeConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisSurplusIncomeConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisNWTerritoryMultiplesConfigurations(body: FileAnalysisNWTerritoryMultiplesConfigurationInputDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/UpdateFileAnalysisNWTerritoryMultiplesConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisNWTerritoryMultiplesConfigurations(_response);
        });
    }

    protected processUpdateFileAnalysisNWTerritoryMultiplesConfigurations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getFileAnalysisNWTerritoryMultiplesConfigurationsList(): Promise<FileAnalysisNWTerritoryMultiplesConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/GetFileAnalysisNWTerritoryMultiplesConfigurationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisNWTerritoryMultiplesConfigurationsList(_response);
        });
    }

    protected processGetFileAnalysisNWTerritoryMultiplesConfigurationsList(response: Response): Promise<FileAnalysisNWTerritoryMultiplesConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAnalysisNWTerritoryMultiplesConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisNWTerritoryMultiplesConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisOSBFilingAndOtherFeeConfigurations(body: FileAnalysisOSBFilingAndOtherFeeConfigurationInputDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/UpdateFileAnalysisOSBFilingAndOtherFeeConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisOSBFilingAndOtherFeeConfigurations(_response);
        });
    }

    protected processUpdateFileAnalysisOSBFilingAndOtherFeeConfigurations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getFileAnalysisOSBFilingAndOtherFeeConfigurationsList(): Promise<FileAnalysisOSBFilingAndOtherFeeConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/GetFileAnalysisOSBFilingAndOtherFeeConfigurationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisOSBFilingAndOtherFeeConfigurationsList(_response);
        });
    }

    protected processGetFileAnalysisOSBFilingAndOtherFeeConfigurationsList(response: Response): Promise<FileAnalysisOSBFilingAndOtherFeeConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAnalysisOSBFilingAndOtherFeeConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisOSBFilingAndOtherFeeConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisRealEstateFeeConfigurations(body: FileAnalysisRealEstateFeeConfigurationInputDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/UpdateFileAnalysisRealEstateFeeConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisRealEstateFeeConfigurations(_response);
        });
    }

    protected processUpdateFileAnalysisRealEstateFeeConfigurations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getFileAnalysisRealEstateFeeConfigurationsList(): Promise<FileAnalysisRealEstateFeeConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/GetFileAnalysisRealEstateFeeConfigurationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisRealEstateFeeConfigurationsList(_response);
        });
    }

    protected processGetFileAnalysisRealEstateFeeConfigurationsList(response: Response): Promise<FileAnalysisRealEstateFeeConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAnalysisRealEstateFeeConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisRealEstateFeeConfigurationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisProvincialExemptionsTaxRateConfigurations(body: FileAnalysisProvincialExemptionsTaxRateConfigurationInputDto[] | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/UpdateFileAnalysisProvincialExemptionsTaxRateConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisProvincialExemptionsTaxRateConfigurations(_response);
        });
    }

    protected processUpdateFileAnalysisProvincialExemptionsTaxRateConfigurations(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    getFileAnalysisProvincialExemptionsTaxRateConfigurationsList(): Promise<FileAnalysisProvincialExemptionsTaxRateConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisConfigurations/GetFileAnalysisProvincialExemptionsTaxRateConfigurationsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisProvincialExemptionsTaxRateConfigurationsList(_response);
        });
    }

    protected processGetFileAnalysisProvincialExemptionsTaxRateConfigurationsList(response: Response): Promise<FileAnalysisProvincialExemptionsTaxRateConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileAnalysisProvincialExemptionsTaxRateConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisProvincialExemptionsTaxRateConfigurationDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisDebtsCreditors(fileId: string | undefined): Promise<FileAnalysisDebtsCreditorsDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisDebtsCreditors/GetFileAnalysisDebtsCreditors?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisDebtsCreditors(_response);
        });
    }

    protected processGetFileAnalysisDebtsCreditors(response: Response): Promise<FileAnalysisDebtsCreditorsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisDebtsCreditorsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisDebtsCreditorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisProposalDetails(body: FileAnalysisProposalDetailInputDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisProposalDetail/UpdateFileAnalysisProposalDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisProposalDetails(_response);
        });
    }

    protected processUpdateFileAnalysisProposalDetails(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteFileAnalysisProposalMonthlyPaymentDetails(id: string | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisProposalDetail/DeleteFileAnalysisProposalMonthlyPaymentDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFileAnalysisProposalMonthlyPaymentDetails(_response);
        });
    }

    protected processDeleteFileAnalysisProposalMonthlyPaymentDetails(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisProposalDetails(fileId: string | undefined): Promise<FileAnalysisProposalDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisProposalDetail/GetFileAnalysisProposalDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisProposalDetails(_response);
        });
    }

    protected processGetFileAnalysisProposalDetails(response: Response): Promise<FileAnalysisProposalDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisProposalDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisProposalDetailDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisSurplusIncomeDetails(fileId: string | undefined): Promise<FileAnalysisSurplusIncomeDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisSurplusIncomeDetail/GetFileAnalysisSurplusIncomeDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisSurplusIncomeDetails(_response);
        });
    }

    protected processGetFileAnalysisSurplusIncomeDetails(response: Response): Promise<FileAnalysisSurplusIncomeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisSurplusIncomeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisSurplusIncomeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFileAnalysisTrusteeReportDetails(body: FileAnalysisTrusteeReportDetailDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisTrusteeReportDetail/UpdateFileAnalysisTrusteeReportDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileAnalysisTrusteeReportDetails(_response);
        });
    }

    protected processUpdateFileAnalysisTrusteeReportDetails(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFileAnalysisTrusteeReportDetails(fileId: string | undefined): Promise<FileAnalysisTrusteeReportDetailDto> {
        let url_ = this.baseUrl + "/api/client-service/FileAnalysisTrusteeReportDetail/GetFileAnalysisTrusteeReportDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileAnalysisTrusteeReportDetails(_response);
        });
    }

    protected processGetFileAnalysisTrusteeReportDetails(response: Response): Promise<FileAnalysisTrusteeReportDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAnalysisTrusteeReportDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileAnalysisTrusteeReportDetailDto>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param dayNum (optional) 
     * @return OK
     */
    getNextBusinessDay(officeLocationId: string | undefined, dayNum: number | undefined): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/GetNextBusinessDay?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (dayNum === null)
            throw new Error("The parameter 'dayNum' cannot be null.");
        else if (dayNum !== undefined)
            url_ += "DayNum=" + encodeURIComponent("" + dayNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextBusinessDay(_response);
        });
    }

    protected processGetNextBusinessDay(response: Response): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param dayNum (optional) 
     * @return OK
     */
    getNextBusinessDates(officeLocationId: string | undefined, dayNum: number | undefined): Promise<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/GetNextBusinessDates?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (dayNum === null)
            throw new Error("The parameter 'dayNum' cannot be null.");
        else if (dayNum !== undefined)
            url_ += "DayNum=" + encodeURIComponent("" + dayNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextBusinessDates(_response);
        });
    }

    protected processGetNextBusinessDates(response: Response): Promise<moment.Moment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment[]>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param dayNum (optional) 
     * @return OK
     */
    getPrevBusinessDay(officeLocationId: string | undefined, dayNum: number | undefined): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/GetPrevBusinessDay?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (dayNum === null)
            throw new Error("The parameter 'dayNum' cannot be null.");
        else if (dayNum !== undefined)
            url_ += "DayNum=" + encodeURIComponent("" + dayNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrevBusinessDay(_response);
        });
    }

    protected processGetPrevBusinessDay(response: Response): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param dayNum (optional) 
     * @return OK
     */
    getPrevBusinessDates(officeLocationId: string | undefined, dayNum: number | undefined): Promise<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/GetPrevBusinessDates?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (dayNum === null)
            throw new Error("The parameter 'dayNum' cannot be null.");
        else if (dayNum !== undefined)
            url_ += "DayNum=" + encodeURIComponent("" + dayNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrevBusinessDates(_response);
        });
    }

    protected processGetPrevBusinessDates(response: Response): Promise<moment.Moment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment[]>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return OK
     */
    getBusinessDates(officeLocationId: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Promise<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/GetBusinessDates?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessDates(_response);
        });
    }

    protected processGetBusinessDates(response: Response): Promise<moment.Moment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment[]>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @param currentDate (optional) 
     * @return OK
     */
    isBusinessDay(officeLocationId: string | undefined, currentDate: moment.Moment | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/holiday-logic/IsBusinessDay?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        if (currentDate === null)
            throw new Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsBusinessDay(_response);
        });
    }

    protected processIsBusinessDay(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listCreditors(searchTerm: string | null | undefined, pageSize: number | undefined): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCreditors?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCreditors(_response);
        });
    }

    protected processListCreditors(response: Response): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]>(null as any);
    }

    /**
     * @param externalId (optional) 
     * @return OK
     */
    getCreditor(externalId: string | null | undefined): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetCreditor?";
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditor(_response);
        });
    }

    protected processGetCreditor(response: Response): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listDebtors(searchTerm: string | null | undefined, pageSize: number | undefined): Promise<LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListDebtors?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDebtors(_response);
        });
    }

    protected processListDebtors(response: Response): Promise<LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppointmentTypes(fileId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppointmentTypes?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentTypes(_response);
        });
    }

    protected processListAppointmentTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listLanguages(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListLanguages(_response);
        });
    }

    protected processListLanguages(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listCountries(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCountries(_response);
        });
    }

    protected processListCountries(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listIntakeSources(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListIntakeSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListIntakeSources(_response);
        });
    }

    protected processListIntakeSources(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listMeetingTypes(): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListMeetingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMeetingTypes(_response);
        });
    }

    protected processListMeetingTypes(response: Response): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param meetingTypeId (optional) 
     * @return OK
     */
    getMeetingTypeById(meetingTypeId: string | undefined): Promise<LookupDto> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetMeetingTypeById?";
        if (meetingTypeId === null)
            throw new Error("The parameter 'meetingTypeId' cannot be null.");
        else if (meetingTypeId !== undefined)
            url_ += "MeetingTypeId=" + encodeURIComponent("" + meetingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingTypeById(_response);
        });
    }

    protected processGetMeetingTypeById(response: Response): Promise<LookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto>(null as any);
    }

    /**
     * @param officeLocationId (optional) 
     * @return OK
     */
    getOfficeLocationMeetingType(officeLocationId: string | undefined): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetOfficeLocationMeetingType?";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "officeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOfficeLocationMeetingType(_response);
        });
    }

    protected processGetOfficeLocationMeetingType(response: Response): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param appointmentTypeId (optional) 
     * @return OK
     */
    getAppointmentTypeById(appointmentTypeId: string | undefined): Promise<LookupDto> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetAppointmentTypeById?";
        if (appointmentTypeId === null)
            throw new Error("The parameter 'appointmentTypeId' cannot be null.");
        else if (appointmentTypeId !== undefined)
            url_ += "appointmentTypeId=" + encodeURIComponent("" + appointmentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppointmentTypeById(_response);
        });
    }

    protected processGetAppointmentTypeById(response: Response): Promise<LookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto>(null as any);
    }

    /**
     * @param timeZoneId (optional) 
     * @return OK
     */
    getTimeZoneById(timeZoneId: string | undefined): Promise<LookupDto> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetTimeZoneById?";
        if (timeZoneId === null)
            throw new Error("The parameter 'timeZoneId' cannot be null.");
        else if (timeZoneId !== undefined)
            url_ += "TimeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimeZoneById(_response);
        });
    }

    protected processGetTimeZoneById(response: Response): Promise<LookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto>(null as any);
    }

    /**
     * @param regionId (optional) 
     * @return OK
     */
    getTimeZoneByRegionId(regionId: string | undefined): Promise<LookupDto> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetTimeZoneByRegionId?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimeZoneByRegionId(_response);
        });
    }

    protected processGetTimeZoneByRegionId(response: Response): Promise<LookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto>(null as any);
    }

    /**
     * @return OK
     */
    listTimeZones(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTimeZones(_response);
        });
    }

    protected processListTimeZones(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listPhoneTypes(): Promise<PhoneTypeLookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListPhoneTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPhoneTypes(_response);
        });
    }

    protected processListPhoneTypes(response: Response): Promise<PhoneTypeLookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhoneTypeLookupDto[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @return OK
     */
    listProvinces(countryId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListProvinces?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProvinces(_response);
        });
    }

    protected processListProvinces(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param sourceTypeId (optional) 
     * @return OK
     */
    listReferralSourceDetails(sourceTypeId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListReferralSourceDetails?";
        if (sourceTypeId === null)
            throw new Error("The parameter 'sourceTypeId' cannot be null.");
        else if (sourceTypeId !== undefined)
            url_ += "sourceTypeId=" + encodeURIComponent("" + sourceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListReferralSourceDetails(_response);
        });
    }

    protected processListReferralSourceDetails(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listReferralSourceTypes(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListReferralSourceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListReferralSourceTypes(_response);
        });
    }

    protected processListReferralSourceTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listActiveReferralSourceTypes(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListActiveReferralSourceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListActiveReferralSourceTypes(_response);
        });
    }

    protected processListActiveReferralSourceTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param fileProcessId (optional) 
     * @param taskNameId (optional) 
     * @param isActive (optional) 
     * @return OK
     */
    listAppTaskActionNames(fileProcessId: string | undefined, taskNameId: string | undefined, isActive: boolean | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppTaskActionNames?";
        if (fileProcessId === null)
            throw new Error("The parameter 'fileProcessId' cannot be null.");
        else if (fileProcessId !== undefined)
            url_ += "fileProcessId=" + encodeURIComponent("" + fileProcessId) + "&";
        if (taskNameId === null)
            throw new Error("The parameter 'taskNameId' cannot be null.");
        else if (taskNameId !== undefined)
            url_ += "taskNameId=" + encodeURIComponent("" + taskNameId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppTaskActionNames(_response);
        });
    }

    protected processListAppTaskActionNames(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param fileProcessId (optional) 
     * @param isActive (optional) 
     * @return OK
     */
    listAppTaskNames(fileProcessId: string | undefined, isActive: boolean | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppTaskNames?";
        if (fileProcessId === null)
            throw new Error("The parameter 'fileProcessId' cannot be null.");
        else if (fileProcessId !== undefined)
            url_ += "fileProcessId=" + encodeURIComponent("" + fileProcessId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppTaskNames(_response);
        });
    }

    protected processListAppTaskNames(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param fileStageId (optional) 
     * @return OK
     */
    listFileProcessesByFileStage(fileStageId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListFileProcessesByFileStage?";
        if (fileStageId === null)
            throw new Error("The parameter 'fileStageId' cannot be null.");
        else if (fileStageId !== undefined)
            url_ += "fileStageId=" + encodeURIComponent("" + fileStageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFileProcessesByFileStage(_response);
        });
    }

    protected processListFileProcessesByFileStage(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listFileProcesses(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListFileProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFileProcesses(_response);
        });
    }

    protected processListFileProcesses(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAppTaskStatuses(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppTaskStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppTaskStatuses(_response);
        });
    }

    protected processListAppTaskStatuses(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param appTaskActionStatus (optional) 
     * @return OK
     */
    getAppTaskActionStatus(appTaskActionStatus: AppTaskActionStatusEnum | undefined): Promise<LookupDto> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/GetAppTaskActionStatus?";
        if (appTaskActionStatus === null)
            throw new Error("The parameter 'appTaskActionStatus' cannot be null.");
        else if (appTaskActionStatus !== undefined)
            url_ += "appTaskActionStatus=" + encodeURIComponent("" + appTaskActionStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppTaskActionStatus(_response);
        });
    }

    protected processGetAppTaskActionStatus(response: Response): Promise<LookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto>(null as any);
    }

    /**
     * @return OK
     */
    listAppointmentStatuses(): Promise<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppointmentStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentStatuses(_response);
        });
    }

    protected processListAppointmentStatuses(response: Response): Promise<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listClientStatuses(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListClientStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListClientStatuses(_response);
        });
    }

    protected processListClientStatuses(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listFileStages(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListFileStages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFileStages(_response);
        });
    }

    protected processListFileStages(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listFilingTypes(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListFilingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListFilingTypes(_response);
        });
    }

    protected processListFilingTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAgents(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAgents(_response);
        });
    }

    protected processListAgents(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listActiveAgents(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListActiveAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListActiveAgents(_response);
        });
    }

    protected processListActiveAgents(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listCourtAgentsForFile(fileId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCourtAgentsForFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCourtAgentsForFile(_response);
        });
    }

    protected processListCourtAgentsForFile(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listMaritalStatuses(): Promise<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListMaritalStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMaritalStatuses(_response);
        });
    }

    protected processListMaritalStatuses(response: Response): Promise<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listEducationLevels(): Promise<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListEducationLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListEducationLevels(_response);
        });
    }

    protected processListEducationLevels(response: Response): Promise<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listEmploymentStatuses(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListEmploymentStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListEmploymentStatuses(_response);
        });
    }

    protected processListEmploymentStatuses(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listRelationshipTypes(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListRelationshipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRelationshipTypes(_response);
        });
    }

    protected processListRelationshipTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listInsolvencyTypes(): Promise<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListInsolvencyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListInsolvencyTypes(_response);
        });
    }

    protected processListInsolvencyTypes(response: Response): Promise<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listProposalResults(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListProposalResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProposalResults(_response);
        });
    }

    protected processListProposalResults(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAssetDebtOwnershipTypes(): Promise<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAssetDebtOwnershipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetDebtOwnershipTypes(_response);
        });
    }

    protected processListAssetDebtOwnershipTypes(response: Response): Promise<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listAssetTypes(): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAssetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetTypes(_response);
        });
    }

    protected processListAssetTypes(response: Response): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param assetTypeId (optional) 
     * @return OK
     */
    listAssetDescriptions(assetTypeId: string | undefined): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAssetDescriptions?";
        if (assetTypeId === null)
            throw new Error("The parameter 'assetTypeId' cannot be null.");
        else if (assetTypeId !== undefined)
            url_ += "assetTypeId=" + encodeURIComponent("" + assetTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetDescriptions(_response);
        });
    }

    protected processListAssetDescriptions(response: Response): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listDebtDescriptions(): Promise<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListDebtDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDebtDescriptions(_response);
        });
    }

    protected processListDebtDescriptions(response: Response): Promise<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listCreditorTypes(): Promise<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCreditorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCreditorTypes(_response);
        });
    }

    protected processListCreditorTypes(response: Response): Promise<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listLTPCodes(): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListLTPCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListLTPCodes(_response);
        });
    }

    protected processListLTPCodes(response: Response): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listIncomeTypes(): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListIncomeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListIncomeTypes(_response);
        });
    }

    protected processListIncomeTypes(response: Response): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listReasonForPreferreds(): Promise<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListReasonForPreferreds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListReasonForPreferreds(_response);
        });
    }

    protected processListReasonForPreferreds(response: Response): Promise<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listExpenseTypes(): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListExpenseTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListExpenseTypes(_response);
        });
    }

    protected processListExpenseTypes(response: Response): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param expenseTypeId (optional) 
     * @return OK
     */
    listExpenseDescriptions(expenseTypeId: string | undefined): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListExpenseDescriptions?";
        if (expenseTypeId === null)
            throw new Error("The parameter 'expenseTypeId' cannot be null.");
        else if (expenseTypeId !== undefined)
            url_ += "expenseTypeId=" + encodeURIComponent("" + expenseTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListExpenseDescriptions(_response);
        });
    }

    protected processListExpenseDescriptions(response: Response): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listAdminConsumerProposals(): Promise<LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAdminConsumerProposals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAdminConsumerProposals(_response);
        });
    }

    protected processListAdminConsumerProposals(response: Response): Promise<LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listResidenceAppliesTo(): Promise<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListResidenceAppliesTo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListResidenceAppliesTo(_response);
        });
    }

    protected processListResidenceAppliesTo(response: Response): Promise<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listResidenceAvailable(): Promise<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListResidenceAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListResidenceAvailable(_response);
        });
    }

    protected processListResidenceAvailable(response: Response): Promise<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listRESPs(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListRESPs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRESPs(_response);
        });
    }

    protected processListRESPs(response: Response): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listRRSPs(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListRRSPs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRRSPs(_response);
        });
    }

    protected processListRRSPs(response: Response): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listTaxTypes(): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListTaxTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTaxTypes(_response);
        });
    }

    protected processListTaxTypes(response: Response): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBusinessOwnershipTypes(): Promise<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListBusinessOwnershipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBusinessOwnershipTypes(_response);
        });
    }

    protected processListBusinessOwnershipTypes(response: Response): Promise<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBusinessTypes(): Promise<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListBusinessTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBusinessTypes(_response);
        });
    }

    protected processListBusinessTypes(response: Response): Promise<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @return OK
     */
    listOfficeLocations(includeInactive: boolean | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListOfficeLocations?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListOfficeLocations(_response);
        });
    }

    protected processListOfficeLocations(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listOfficeRegions(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListOfficeRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListOfficeRegions(_response);
        });
    }

    protected processListOfficeRegions(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listProposalProcessStatuses(): Promise<LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListProposalProcessStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProposalProcessStatuses(_response);
        });
    }

    protected processListProposalProcessStatuses(response: Response): Promise<LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listProposalStates(): Promise<LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListProposalStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProposalStates(_response);
        });
    }

    protected processListProposalStates(response: Response): Promise<LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param teamTypeId (optional) 
     * @return OK
     */
    listTeams(teamTypeId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListTeams?";
        if (teamTypeId === null)
            throw new Error("The parameter 'teamTypeId' cannot be null.");
        else if (teamTypeId !== undefined)
            url_ += "teamTypeId=" + encodeURIComponent("" + teamTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTeams(_response);
        });
    }

    protected processListTeams(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param roleIds (optional) 
     * @return OK
     */
    listTeamTypes(roleIds: string[] | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListTeamTypes?";
        if (roleIds === null)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "roleIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTeamTypes(_response);
        });
    }

    protected processListTeamTypes(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listDocumentFolders(): Promise<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListDocumentFolders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDocumentFolders(_response);
        });
    }

    protected processListDocumentFolders(response: Response): Promise<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listMessageTemplateTypes(): Promise<LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListMessageTemplateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMessageTemplateTypes(_response);
        });
    }

    protected processListMessageTemplateTypes(response: Response): Promise<LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listMethodOfDeliveries(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListMethodOfDeliveries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMethodOfDeliveries(_response);
        });
    }

    protected processListMethodOfDeliveries(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listCounsellingSessionTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCounsellingSessionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCounsellingSessionTypes(_response);
        });
    }

    protected processListCounsellingSessionTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param currentFileStage (optional) 
     * @return OK
     */
    listAppointmentTypesByFileStage(currentFileStage: FileStageEnum | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAppointmentTypesByFileStage?";
        if (currentFileStage === null)
            throw new Error("The parameter 'currentFileStage' cannot be null.");
        else if (currentFileStage !== undefined)
            url_ += "currentFileStage=" + encodeURIComponent("" + currentFileStage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentTypesByFileStage(_response);
        });
    }

    protected processListAppointmentTypesByFileStage(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @return OK
     */
    listIndustries(searchText: string | null | undefined): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListIndustries?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListIndustries(_response);
        });
    }

    protected processListIndustries(response: Response): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listAnswerTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListAnswerTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAnswerTypes(_response);
        });
    }

    protected processListAnswerTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listGenderOptions(): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListGenderOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListGenderOptions(_response);
        });
    }

    protected processListGenderOptions(response: Response): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listCityTypes(): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListCityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCityTypes(_response);
        });
    }

    protected processListCityTypes(response: Response): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBankruptcyDischargeTypes(): Promise<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service/Lookup/ListBankruptcyDischargeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBankruptcyDischargeTypes(_response);
        });
    }

    protected processListBankruptcyDischargeTypes(response: Response): Promise<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listAppointmentTypes2(fileId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAppointmentTypes?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentTypes2(_response);
        });
    }

    protected processListAppointmentTypes2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listCountries2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCountries2(_response);
        });
    }

    protected processListCountries2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listMeetingTypes2(): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListMeetingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMeetingTypes2(_response);
        });
    }

    protected processListMeetingTypes2(response: Response): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listPhoneTypes2(): Promise<PhoneTypeLookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListPhoneTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPhoneTypes2(_response);
        });
    }

    protected processListPhoneTypes2(response: Response): Promise<PhoneTypeLookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneTypeLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhoneTypeLookupDto[]>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @return OK
     */
    listReferralSourceTypes2(isActive: boolean | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListReferralSourceTypes?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListReferralSourceTypes2(_response);
        });
    }

    protected processListReferralSourceTypes2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @return OK
     */
    listProvinces2(countryId: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListProvinces?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProvinces2(_response);
        });
    }

    protected processListProvinces2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAppointmentStatuses2(): Promise<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAppointmentStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentStatuses2(_response);
        });
    }

    protected processListAppointmentStatuses2(response: Response): Promise<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listMaritalStatuses2(): Promise<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListMaritalStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListMaritalStatuses2(_response);
        });
    }

    protected processListMaritalStatuses2(response: Response): Promise<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listEducationLevels2(): Promise<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListEducationLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListEducationLevels2(_response);
        });
    }

    protected processListEducationLevels2(response: Response): Promise<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listEmploymentStatuses2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListEmploymentStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListEmploymentStatuses2(_response);
        });
    }

    protected processListEmploymentStatuses2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listRelationshipTypes2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListRelationshipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRelationshipTypes2(_response);
        });
    }

    protected processListRelationshipTypes2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param currentFileStage (optional) 
     * @return OK
     */
    listAppointmentTypesByFileStage2(currentFileStage: FileStageEnum | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAppointmentTypesByFileStage?";
        if (currentFileStage === null)
            throw new Error("The parameter 'currentFileStage' cannot be null.");
        else if (currentFileStage !== undefined)
            url_ += "currentFileStage=" + encodeURIComponent("" + currentFileStage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAppointmentTypesByFileStage2(_response);
        });
    }

    protected processListAppointmentTypesByFileStage2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAssetDebtOwnershipTypes2(): Promise<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAssetDebtOwnershipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetDebtOwnershipTypes2(_response);
        });
    }

    protected processListAssetDebtOwnershipTypes2(response: Response): Promise<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listAssetTypes2(): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAssetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetTypes2(_response);
        });
    }

    protected processListAssetTypes2(response: Response): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param assetTypeId (optional) 
     * @return OK
     */
    listAssetDescriptions2(assetTypeId: string | undefined): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAssetDescriptions?";
        if (assetTypeId === null)
            throw new Error("The parameter 'assetTypeId' cannot be null.");
        else if (assetTypeId !== undefined)
            url_ += "assetTypeId=" + encodeURIComponent("" + assetTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAssetDescriptions2(_response);
        });
    }

    protected processListAssetDescriptions2(response: Response): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listDebtDescriptions2(): Promise<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListDebtDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDebtDescriptions2(_response);
        });
    }

    protected processListDebtDescriptions2(response: Response): Promise<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listCreditorTypes2(): Promise<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListCreditorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCreditorTypes2(_response);
        });
    }

    protected processListCreditorTypes2(response: Response): Promise<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listLTPCodes2(): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListLTPCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListLTPCodes2(_response);
        });
    }

    protected processListLTPCodes2(response: Response): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listReasonForPreferreds2(): Promise<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListReasonForPreferreds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListReasonForPreferreds2(_response);
        });
    }

    protected processListReasonForPreferreds2(response: Response): Promise<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listDocumentFolders2(): Promise<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListDocumentFolders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListDocumentFolders2(_response);
        });
    }

    protected processListDocumentFolders2(response: Response): Promise<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @return OK
     */
    listIndustries2(searchText: string | null | undefined): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListIndustries?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListIndustries2(_response);
        });
    }

    protected processListIndustries2(response: Response): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listInsolvencyTypes2(): Promise<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListInsolvencyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListInsolvencyTypes2(_response);
        });
    }

    protected processListInsolvencyTypes2(response: Response): Promise<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listIncomeTypes2(): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListIncomeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListIncomeTypes2(_response);
        });
    }

    protected processListIncomeTypes2(response: Response): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listExpenseTypes2(): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListExpenseTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListExpenseTypes2(_response);
        });
    }

    protected processListExpenseTypes2(response: Response): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param expenseTypeId (optional) 
     * @return OK
     */
    listExpenseDescriptions2(expenseTypeId: string | undefined): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListExpenseDescriptions?";
        if (expenseTypeId === null)
            throw new Error("The parameter 'expenseTypeId' cannot be null.");
        else if (expenseTypeId !== undefined)
            url_ += "expenseTypeId=" + encodeURIComponent("" + expenseTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListExpenseDescriptions2(_response);
        });
    }

    protected processListExpenseDescriptions2(response: Response): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listResidenceAppliesTo2(): Promise<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListResidenceAppliesTo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListResidenceAppliesTo2(_response);
        });
    }

    protected processListResidenceAppliesTo2(response: Response): Promise<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listResidenceAvailable2(): Promise<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListResidenceAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListResidenceAvailable2(_response);
        });
    }

    protected processListResidenceAvailable2(response: Response): Promise<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listRESPs2(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListRESPs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRESPs2(_response);
        });
    }

    protected processListRESPs2(response: Response): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listRRSPs2(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListRRSPs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListRRSPs2(_response);
        });
    }

    protected processListRRSPs2(response: Response): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listTaxTypes2(): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListTaxTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListTaxTypes2(_response);
        });
    }

    protected processListTaxTypes2(response: Response): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBusinessOwnershipTypes2(): Promise<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListBusinessOwnershipTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBusinessOwnershipTypes2(_response);
        });
    }

    protected processListBusinessOwnershipTypes2(response: Response): Promise<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBusinessTypes2(): Promise<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListBusinessTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBusinessTypes2(_response);
        });
    }

    protected processListBusinessTypes2(response: Response): Promise<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listProposalResults2(): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListProposalResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListProposalResults2(_response);
        });
    }

    protected processListProposalResults2(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listAnswerTypes2(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListAnswerTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAnswerTypes2(_response);
        });
    }

    protected processListAnswerTypes2(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return OK
     */
    listGenderOptions2(): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListGenderOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListGenderOptions2(_response);
        });
    }

    protected processListGenderOptions2(response: Response): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listCityTypes2(): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListCityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListCityTypes2(_response);
        });
    }

    protected processListCityTypes2(response: Response): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @return OK
     */
    listBankruptcyDischargeTypes2(): Promise<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        let url_ = this.baseUrl + "/api/client-service-public/Lookup/ListBankruptcyDischargeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListBankruptcyDischargeTypes2(_response);
        });
    }

    protected processListBankruptcyDischargeTypes2(response: Response): Promise<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param noteId (optional) 
     * @param fileId (optional) 
     * @param isPinned (optional) 
     * @param creationTimeMin (optional) 
     * @param creationTimeMax (optional) 
     * @param creatorId (optional) 
     * @param documentId (optional) 
     * @param documentVerificationId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    notesGET(filterText: string | null | undefined, noteId: string | undefined, fileId: string | undefined, isPinned: boolean | undefined, creationTimeMin: moment.Moment | undefined, creationTimeMax: moment.Moment | undefined, creatorId: string | undefined, documentId: string | undefined, documentVerificationId: string | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/notes?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "NoteId=" + encodeURIComponent("" + noteId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (isPinned === null)
            throw new Error("The parameter 'isPinned' cannot be null.");
        else if (isPinned !== undefined)
            url_ += "IsPinned=" + encodeURIComponent("" + isPinned) + "&";
        if (creationTimeMin === null)
            throw new Error("The parameter 'creationTimeMin' cannot be null.");
        else if (creationTimeMin !== undefined)
            url_ += "CreationTimeMin=" + encodeURIComponent(creationTimeMin ? "" + creationTimeMin.toISOString() : "") + "&";
        if (creationTimeMax === null)
            throw new Error("The parameter 'creationTimeMax' cannot be null.");
        else if (creationTimeMax !== undefined)
            url_ += "CreationTimeMax=" + encodeURIComponent(creationTimeMax ? "" + creationTimeMax.toISOString() : "") + "&";
        if (creatorId === null)
            throw new Error("The parameter 'creatorId' cannot be null.");
        else if (creatorId !== undefined)
            url_ += "CreatorId=" + encodeURIComponent("" + creatorId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentVerificationId === null)
            throw new Error("The parameter 'documentVerificationId' cannot be null.");
        else if (documentVerificationId !== undefined)
            url_ += "DocumentVerificationId=" + encodeURIComponent("" + documentVerificationId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesGET(_response);
        });
    }

    protected processNotesGET(response: Response): Promise<PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    notesPOST(body: NoteCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesPOST(_response);
        });
    }

    protected processNotesPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    notesGET2(id: string): Promise<NoteDto> {
        let url_ = this.baseUrl + "/api/client-service/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesGET2(_response);
        });
    }

    protected processNotesGET2(response: Response): Promise<NoteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    notesPUT(id: string, body: NoteUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesPUT(_response);
        });
    }

    protected processNotesPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    notesDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotesDELETE(_response);
        });
    }

    protected processNotesDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isPinned (optional) 
     * @return OK
     */
    pin(id: string, isPinned: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/notes/{id}/pin?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isPinned === null)
            throw new Error("The parameter 'isPinned' cannot be null.");
        else if (isPinned !== undefined)
            url_ += "isPinned=" + encodeURIComponent("" + isPinned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPin(_response);
        });
    }

    protected processPin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isUnread (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    notificationsGET(isUnread: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service-public/notifications?";
        if (isUnread === null)
            throw new Error("The parameter 'isUnread' cannot be null.");
        else if (isUnread !== undefined)
            url_ += "IsUnread=" + encodeURIComponent("" + isUnread) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotificationsGET(_response);
        });
    }

    protected processNotificationsGET(response: Response): Promise<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    notificationsPUT(): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotificationsPUT(_response);
        });
    }

    protected processNotificationsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    newExist(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service-public/notifications/new-exist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNewExist(_response);
        });
    }

    protected processNewExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param nearbyLatitude (optional) 
     * @param nearbyLongitude (optional) 
     * @param includeInactive (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    officeLocationsGET(filterText: string | null | undefined, nearbyLatitude: number | undefined, nearbyLongitude: number | undefined, includeInactive: boolean | undefined, isActive: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/office-locations?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (nearbyLatitude === null)
            throw new Error("The parameter 'nearbyLatitude' cannot be null.");
        else if (nearbyLatitude !== undefined)
            url_ += "NearbyLatitude=" + encodeURIComponent("" + nearbyLatitude) + "&";
        if (nearbyLongitude === null)
            throw new Error("The parameter 'nearbyLongitude' cannot be null.");
        else if (nearbyLongitude !== undefined)
            url_ += "NearbyLongitude=" + encodeURIComponent("" + nearbyLongitude) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsGET(_response);
        });
    }

    protected processOfficeLocationsGET(response: Response): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    officeLocationsPOST(body: OfficeLocationCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/office-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsPOST(_response);
        });
    }

    protected processOfficeLocationsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    officeLocationsGET2(id: string): Promise<OfficeLocationDto> {
        let url_ = this.baseUrl + "/api/client-service/office-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsGET2(_response);
        });
    }

    protected processOfficeLocationsGET2(response: Response): Promise<OfficeLocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeLocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficeLocationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    officeLocationsPUT(id: string, body: OfficeLocationUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/office-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsPUT(_response);
        });
    }

    protected processOfficeLocationsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    officeLocationsDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/office-locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsDELETE(_response);
        });
    }

    protected processOfficeLocationsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param nearbyLatitude (optional) 
     * @param nearbyLongitude (optional) 
     * @param includeInactive (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    officeLocationsGET3(filterText: string | null | undefined, nearbyLatitude: number | undefined, nearbyLongitude: number | undefined, includeInactive: boolean | undefined, isActive: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service-public/office-locations?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (nearbyLatitude === null)
            throw new Error("The parameter 'nearbyLatitude' cannot be null.");
        else if (nearbyLatitude !== undefined)
            url_ += "NearbyLatitude=" + encodeURIComponent("" + nearbyLatitude) + "&";
        if (nearbyLongitude === null)
            throw new Error("The parameter 'nearbyLongitude' cannot be null.");
        else if (nearbyLongitude !== undefined)
            url_ += "NearbyLongitude=" + encodeURIComponent("" + nearbyLongitude) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOfficeLocationsGET3(_response);
        });
    }

    protected processOfficeLocationsGET3(response: Response): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param status (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    pendingAuth0Changes(status: Auth0ChangeStatusEnum | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Promise<PendingAuth0ChangeListDto> {
        let url_ = this.baseUrl + "/api/client-service/PendingAuth0Changes?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPendingAuth0Changes(_response);
        });
    }

    protected processPendingAuth0Changes(response: Response): Promise<PendingAuth0ChangeListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingAuth0ChangeListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingAuth0ChangeListDto>(null as any);
    }

    /**
     * @return OK
     */
    approve(id: string): Promise<PendingAuth0ChangeDto> {
        let url_ = this.baseUrl + "/api/client-service/PendingAuth0Changes/approve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<PendingAuth0ChangeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingAuth0ChangeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingAuth0ChangeDto>(null as any);
    }

    /**
     * @return OK
     */
    reject(id: string): Promise<PendingAuth0ChangeDto> {
        let url_ = this.baseUrl + "/api/client-service/PendingAuth0Changes/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: Response): Promise<PendingAuth0ChangeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingAuth0ChangeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingAuth0ChangeDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getProposalGraphData(fileId: string | undefined): Promise<ProposalGraphDataDto> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetProposalGraphData?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposalGraphData(_response);
        });
    }

    protected processGetProposalGraphData(response: Response): Promise<ProposalGraphDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProposalGraphDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalGraphDataDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getProposalInfo(fileId: string | undefined): Promise<ProposalInfoDto> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetProposalInfo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposalInfo(_response);
        });
    }

    protected processGetProposalInfo(response: Response): Promise<ProposalInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProposalInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProposalStatuses(body: ProposalStatusUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateProposalStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProposalStatuses(_response);
        });
    }

    protected processUpdateProposalStatuses(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCourtRevival(body: ProposalCourtRevivalDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateCourtRevival";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCourtRevival(_response);
        });
    }

    protected processUpdateCourtRevival(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForm56Filing(body: ProposalFormFilingDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateForm56Filing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm56Filing(_response);
        });
    }

    protected processUpdateForm56Filing(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForm93Filing(body: ProposalFormFilingDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateForm93Filing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm93Filing(_response);
        });
    }

    protected processUpdateForm93Filing(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForm95Filing(body: ProposalFormFilingDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateForm95Filing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm95Filing(_response);
        });
    }

    protected processUpdateForm95Filing(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForm96Filing(body: ProposalFormFilingDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/proposal/UpdateForm96Filing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm96Filing(_response);
        });
    }

    protected processUpdateForm96Filing(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getForm56History(fileId: string | undefined): Promise<ProposalFormFilingHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetForm56History?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForm56History(_response);
        });
    }

    protected processGetForm56History(response: Response): Promise<ProposalFormFilingHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProposalFormFilingHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalFormFilingHistoryDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getForm93History(fileId: string | undefined): Promise<ProposalFormFilingHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetForm93History?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForm93History(_response);
        });
    }

    protected processGetForm93History(response: Response): Promise<ProposalFormFilingHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProposalFormFilingHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalFormFilingHistoryDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getForm95History(fileId: string | undefined): Promise<ProposalFormFilingHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetForm95History?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForm95History(_response);
        });
    }

    protected processGetForm95History(response: Response): Promise<ProposalFormFilingHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProposalFormFilingHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalFormFilingHistoryDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getForm96History(fileId: string | undefined): Promise<ProposalFormFilingHistoryDto[]> {
        let url_ = this.baseUrl + "/api/client-service/proposal/GetForm96History?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForm96History(_response);
        });
    }

    protected processGetForm96History(response: Response): Promise<ProposalFormFilingHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProposalFormFilingHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProposalFormFilingHistoryDto[]>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    triggerProposalRejectedNotification(fileId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/proposal/TriggerProposalRejectedNotification?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerProposalRejectedNotification(_response);
        });
    }

    protected processTriggerProposalRejectedNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    triggerProposalWithdrawnNotification(fileId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/proposal/TriggerProposalWithdrawnNotification?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerProposalWithdrawnNotification(_response);
        });
    }

    protected processTriggerProposalWithdrawnNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    validateMeetingWithCreditorsCompleted(fileId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/proposal/ValidateMeetingWithCreditorsCompleted?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateMeetingWithCreditorsCompleted(_response);
        });
    }

    protected processValidateMeetingWithCreditorsCompleted(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    validateHasAttachedChecklistDocument(fileId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/proposal/ValidateHasAttachedChecklistDocument?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateHasAttachedChecklistDocument(_response);
        });
    }

    protected processValidateHasAttachedChecklistDocument(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    validateIsAllLiabilityClaimsComplete(fileId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/client-service/proposal/ValidateIsAllLiabilityClaimsComplete?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateIsAllLiabilityClaimsComplete(_response);
        });
    }

    protected processValidateIsAllLiabilityClaimsComplete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    receiptTypes(): Promise<LookupReadOnlyDto[]> {
        let url_ = this.baseUrl + "/api/client-service/receipts/receipt-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptTypes(_response);
        });
    }

    protected processReceiptTypes(response: Response): Promise<LookupReadOnlyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupReadOnlyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param fileId (optional) 
     * @param paymentDateMin (optional) 
     * @param paymentDateMax (optional) 
     * @param receiptPaymentMethod (optional) 
     * @param receiptType (optional) 
     * @param excludeVoided (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    receiptsGET(id: string | undefined, fileId: string | undefined, paymentDateMin: moment.Moment | undefined, paymentDateMax: moment.Moment | undefined, receiptPaymentMethod: ReceiptPaymentMethodEnum | undefined, receiptType: ReceiptTypeEnum | undefined, excludeVoided: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/receipts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (paymentDateMin === null)
            throw new Error("The parameter 'paymentDateMin' cannot be null.");
        else if (paymentDateMin !== undefined)
            url_ += "PaymentDateMin=" + encodeURIComponent(paymentDateMin ? "" + paymentDateMin.toISOString() : "") + "&";
        if (paymentDateMax === null)
            throw new Error("The parameter 'paymentDateMax' cannot be null.");
        else if (paymentDateMax !== undefined)
            url_ += "PaymentDateMax=" + encodeURIComponent(paymentDateMax ? "" + paymentDateMax.toISOString() : "") + "&";
        if (receiptPaymentMethod === null)
            throw new Error("The parameter 'receiptPaymentMethod' cannot be null.");
        else if (receiptPaymentMethod !== undefined)
            url_ += "ReceiptPaymentMethod=" + encodeURIComponent("" + receiptPaymentMethod) + "&";
        if (receiptType === null)
            throw new Error("The parameter 'receiptType' cannot be null.");
        else if (receiptType !== undefined)
            url_ += "ReceiptType=" + encodeURIComponent("" + receiptType) + "&";
        if (excludeVoided === null)
            throw new Error("The parameter 'excludeVoided' cannot be null.");
        else if (excludeVoided !== undefined)
            url_ += "ExcludeVoided=" + encodeURIComponent("" + excludeVoided) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsGET(_response);
        });
    }

    protected processReceiptsGET(response: Response): Promise<PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    receiptsPOST(body: ReceiptCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/receipts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsPOST(_response);
        });
    }

    protected processReceiptsPOST(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    receiptsGET2(id: string): Promise<ReceiptDto> {
        let url_ = this.baseUrl + "/api/client-service/receipts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsGET2(_response);
        });
    }

    protected processReceiptsGET2(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    receiptsPUT(id: string, body: ReceiptUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/receipts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsPUT(_response);
        });
    }

    protected processReceiptsPUT(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return OK
     */
    receiptsDELETE(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/receipts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiptsDELETE(_response);
        });
    }

    protected processReceiptsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    void(id: string): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/receipts/{id}/void";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVoid(_response);
        });
    }

    protected processVoid(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    download5(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/receipts/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload5(_response);
        });
    }

    protected processDownload5(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download6(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service-public/receipts/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload6(_response);
        });
    }

    protected processDownload6(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAll(padScheduleId: string): Promise<ReceiptPublicDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/receipts/get-all/{padScheduleId}";
        if (padScheduleId === undefined || padScheduleId === null)
            throw new Error("The parameter 'padScheduleId' must be defined.");
        url_ = url_.replace("{padScheduleId}", encodeURIComponent("" + padScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ReceiptPublicDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReceiptPublicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptPublicDto[]>(null as any);
    }

    /**
     * @param createdFrom (optional) 
     * @param createdTo (optional) 
     * @param isOfficeSelected (optional) 
     * @param isEstateAdminSelected (optional) 
     * @param isTrusteeSelected (optional) 
     * @return OK
     */
    report(createdFrom: moment.Moment | undefined, createdTo: moment.Moment | undefined, isOfficeSelected: boolean | undefined, isEstateAdminSelected: boolean | undefined, isTrusteeSelected: boolean | undefined): Promise<DebtorConversionDto> {
        let url_ = this.baseUrl + "/api/client-service/report?";
        if (createdFrom === null)
            throw new Error("The parameter 'createdFrom' cannot be null.");
        else if (createdFrom !== undefined)
            url_ += "CreatedFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo === null)
            throw new Error("The parameter 'createdTo' cannot be null.");
        else if (createdTo !== undefined)
            url_ += "CreatedTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (isOfficeSelected === null)
            throw new Error("The parameter 'isOfficeSelected' cannot be null.");
        else if (isOfficeSelected !== undefined)
            url_ += "IsOfficeSelected=" + encodeURIComponent("" + isOfficeSelected) + "&";
        if (isEstateAdminSelected === null)
            throw new Error("The parameter 'isEstateAdminSelected' cannot be null.");
        else if (isEstateAdminSelected !== undefined)
            url_ += "IsEstateAdminSelected=" + encodeURIComponent("" + isEstateAdminSelected) + "&";
        if (isTrusteeSelected === null)
            throw new Error("The parameter 'isTrusteeSelected' cannot be null.");
        else if (isTrusteeSelected !== undefined)
            url_ += "IsTrusteeSelected=" + encodeURIComponent("" + isTrusteeSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: Response): Promise<DebtorConversionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtorConversionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtorConversionDto>(null as any);
    }

    /**
     * @param appointmentDate_FromDate (optional) 
     * @param appointmentDate_ToDate (optional) 
     * @param appointmentCreationDate_FromDate (optional) 
     * @param appointmentCreationDate_ToDate (optional) 
     * @param prospectCreationDate_FromDate (optional) 
     * @param prospectCreationDate_ToDate (optional) 
     * @return OK
     */
    getMarketingReport(appointmentDate_FromDate: moment.Moment | undefined, appointmentDate_ToDate: moment.Moment | undefined, appointmentCreationDate_FromDate: moment.Moment | undefined, appointmentCreationDate_ToDate: moment.Moment | undefined, prospectCreationDate_FromDate: moment.Moment | undefined, prospectCreationDate_ToDate: moment.Moment | undefined): Promise<ReportDataItemDto[]> {
        let url_ = this.baseUrl + "/api/client-service/report/GetMarketingReport?";
        if (appointmentDate_FromDate === null)
            throw new Error("The parameter 'appointmentDate_FromDate' cannot be null.");
        else if (appointmentDate_FromDate !== undefined)
            url_ += "AppointmentDate.FromDate=" + encodeURIComponent(appointmentDate_FromDate ? "" + appointmentDate_FromDate.toISOString() : "") + "&";
        if (appointmentDate_ToDate === null)
            throw new Error("The parameter 'appointmentDate_ToDate' cannot be null.");
        else if (appointmentDate_ToDate !== undefined)
            url_ += "AppointmentDate.ToDate=" + encodeURIComponent(appointmentDate_ToDate ? "" + appointmentDate_ToDate.toISOString() : "") + "&";
        if (appointmentCreationDate_FromDate === null)
            throw new Error("The parameter 'appointmentCreationDate_FromDate' cannot be null.");
        else if (appointmentCreationDate_FromDate !== undefined)
            url_ += "AppointmentCreationDate.FromDate=" + encodeURIComponent(appointmentCreationDate_FromDate ? "" + appointmentCreationDate_FromDate.toISOString() : "") + "&";
        if (appointmentCreationDate_ToDate === null)
            throw new Error("The parameter 'appointmentCreationDate_ToDate' cannot be null.");
        else if (appointmentCreationDate_ToDate !== undefined)
            url_ += "AppointmentCreationDate.ToDate=" + encodeURIComponent(appointmentCreationDate_ToDate ? "" + appointmentCreationDate_ToDate.toISOString() : "") + "&";
        if (prospectCreationDate_FromDate === null)
            throw new Error("The parameter 'prospectCreationDate_FromDate' cannot be null.");
        else if (prospectCreationDate_FromDate !== undefined)
            url_ += "ProspectCreationDate.FromDate=" + encodeURIComponent(prospectCreationDate_FromDate ? "" + prospectCreationDate_FromDate.toISOString() : "") + "&";
        if (prospectCreationDate_ToDate === null)
            throw new Error("The parameter 'prospectCreationDate_ToDate' cannot be null.");
        else if (prospectCreationDate_ToDate !== undefined)
            url_ += "ProspectCreationDate.ToDate=" + encodeURIComponent(prospectCreationDate_ToDate ? "" + prospectCreationDate_ToDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketingReport(_response);
        });
    }

    protected processGetMarketingReport(response: Response): Promise<ReportDataItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportDataItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportDataItemDto[]>(null as any);
    }

    postAscendSyncStatus(body: PostAscendSyncStatusInputDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/rpa-integration/PostAscendSyncStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostAscendSyncStatus(_response);
        });
    }

    protected processPostAscendSyncStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendSMS(body: SMSAttributesDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/SMS/SendSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendSMS(_response);
        });
    }

    protected processSendSMS(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resendSMS(body: SmsResendDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/SMS/ResendSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendSMS(_response);
        });
    }

    protected processResendSMS(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    listSMSDetails(fileId: string | undefined): Promise<ViewSMSResultDto[]> {
        let url_ = this.baseUrl + "/api/client-service/SMS/ListSMSDetails?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListSMSDetails(_response);
        });
    }

    protected processListSMSDetails(response: Response): Promise<ViewSMSResultDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewSMSResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewSMSResultDto[]>(null as any);
    }

    /**
     * @param smsId (optional) 
     * @return OK
     */
    getSMSAttributes(smsId: string | undefined): Promise<SMSAttributesDto> {
        let url_ = this.baseUrl + "/api/client-service/SMS/GetSMSAttributes?";
        if (smsId === null)
            throw new Error("The parameter 'smsId' cannot be null.");
        else if (smsId !== undefined)
            url_ += "smsId=" + encodeURIComponent("" + smsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSMSAttributes(_response);
        });
    }

    protected processGetSMSAttributes(response: Response): Promise<SMSAttributesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSAttributesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMSAttributesDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getFilePhoneNumbers(fileId: string | undefined): Promise<GetFilePhoneNumbersDto> {
        let url_ = this.baseUrl + "/api/client-service/SMS/GetFilePhoneNumbers?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilePhoneNumbers(_response);
        });
    }

    protected processGetFilePhoneNumbers(response: Response): Promise<GetFilePhoneNumbersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFilePhoneNumbersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFilePhoneNumbersDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getAllSupportingDocumentsByFileId(fileId: string | undefined): Promise<SupportingDocumentStaffPortalDto[]> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/GetAllSupportingDocumentsByFileId?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSupportingDocumentsByFileId(_response);
        });
    }

    protected processGetAllSupportingDocumentsByFileId(response: Response): Promise<SupportingDocumentStaffPortalDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportingDocumentStaffPortalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentStaffPortalDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSupportingDocumentById(id: string | undefined): Promise<SupportingDocumentStaffPortalDto> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/GetSupportingDocumentById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportingDocumentById(_response);
        });
    }

    protected processGetSupportingDocumentById(response: Response): Promise<SupportingDocumentStaffPortalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingDocumentStaffPortalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentStaffPortalDto>(null as any);
    }

    /**
     * @param supportingDocumentId (optional) 
     * @param documentFolderId (optional) 
     * @param documentPrefixId (optional) 
     * @param additionalInformation (optional) 
     * @param isVisible (optional) 
     * @param fileModifiedDate (optional) 
     * @param content (optional) 
     * @param isForSpouse (optional) 
     * @param businessName (optional) 
     * @return OK
     */
    uploadsupportingDocument(supportingDocumentId: string | undefined, documentFolderId: string | undefined, documentPrefixId: string | undefined, additionalInformation: string | null | undefined, isVisible: boolean | undefined, fileModifiedDate: moment.Moment | undefined, content: FileParameter | null | undefined, isForSpouse: boolean | undefined, businessName: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/UploadsupportingDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (supportingDocumentId === null || supportingDocumentId === undefined)
            throw new Error("The parameter 'supportingDocumentId' cannot be null.");
        else
            content_.append("SupportingDocumentId", supportingDocumentId.toString());
        if (documentFolderId === null || documentFolderId === undefined)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else
            content_.append("DocumentFolderId", documentFolderId.toString());
        if (documentPrefixId === null || documentPrefixId === undefined)
            throw new Error("The parameter 'documentPrefixId' cannot be null.");
        else
            content_.append("DocumentPrefixId", documentPrefixId.toString());
        if (additionalInformation !== null && additionalInformation !== undefined)
            content_.append("AdditionalInformation", additionalInformation.toString());
        if (isVisible === null || isVisible === undefined)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else
            content_.append("IsVisible", isVisible.toString());
        if (fileModifiedDate === null || fileModifiedDate === undefined)
            throw new Error("The parameter 'fileModifiedDate' cannot be null.");
        else
            content_.append("FileModifiedDate", fileModifiedDate.toJSON());
        if (content !== null && content !== undefined)
            content_.append("Content", content.data, content.fileName ? content.fileName : "Content");
        if (isForSpouse === null || isForSpouse === undefined)
            throw new Error("The parameter 'isForSpouse' cannot be null.");
        else
            content_.append("IsForSpouse", isForSpouse.toString());
        if (businessName !== null && businessName !== undefined)
            content_.append("BusinessName", businessName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadsupportingDocument(_response);
        });
    }

    protected processUploadsupportingDocument(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReviewStatus(body: SupportingDocumentDocumentReviewStatusUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/UpdateReviewStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateReviewStatus(_response);
        });
    }

    protected processUpdateReviewStatus(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOverrideStatus(body: UpdateOverrideStatusDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/UpdateOverrideStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOverrideStatus(_response);
        });
    }

    protected processUpdateOverrideStatus(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return OK
     */
    getSupportingDocumentStatus(fileId: string | undefined): Promise<SupportingDocumentStatusDto> {
        let url_ = this.baseUrl + "/api/client-service/supporting-documents/GetSupportingDocumentStatus?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportingDocumentStatus(_response);
        });
    }

    protected processGetSupportingDocumentStatus(response: Response): Promise<SupportingDocumentStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingDocumentStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentStatusDto>(null as any);
    }

    /**
     * @param supportingDocumentStatus (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSupportingdocuments(supportingDocumentStatus: SupportingDocumentStatusEnum | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/get-all-supportingdocuments?";
        if (supportingDocumentStatus === null)
            throw new Error("The parameter 'supportingDocumentStatus' cannot be null.");
        else if (supportingDocumentStatus !== undefined)
            url_ += "SupportingDocumentStatus=" + encodeURIComponent("" + supportingDocumentStatus) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSupportingdocuments(_response);
        });
    }

    protected processGetAllSupportingdocuments(response: Response): Promise<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getSupportingdocument(id: string | undefined): Promise<SupportingDocumentDto> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/get-supportingdocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportingdocument(_response);
        });
    }

    protected processGetSupportingdocument(response: Response): Promise<SupportingDocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingDocumentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    listPrefixesForAsset(id: string | undefined): Promise<LookupDto[]> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/list-prefixes-for-asset?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListPrefixesForAsset(_response);
        });
    }

    protected processListPrefixesForAsset(response: Response): Promise<LookupDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param appFormAssetsDebtsAssetId (optional) 
     * @param fileId (optional) 
     * @param isDeleted (optional) 
     * @param isUploaded (optional) 
     * @param isReviewd (optional) 
     * @param isOverridden (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    count4(appFormAssetsDebtsAssetId: string | undefined, fileId: string | undefined, isDeleted: boolean | undefined, isUploaded: boolean | undefined, isReviewd: boolean | undefined, isOverridden: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/count?";
        if (appFormAssetsDebtsAssetId === null)
            throw new Error("The parameter 'appFormAssetsDebtsAssetId' cannot be null.");
        else if (appFormAssetsDebtsAssetId !== undefined)
            url_ += "AppFormAssetsDebtsAssetId=" + encodeURIComponent("" + appFormAssetsDebtsAssetId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (isUploaded === null)
            throw new Error("The parameter 'isUploaded' cannot be null.");
        else if (isUploaded !== undefined)
            url_ += "IsUploaded=" + encodeURIComponent("" + isUploaded) + "&";
        if (isReviewd === null)
            throw new Error("The parameter 'isReviewd' cannot be null.");
        else if (isReviewd !== undefined)
            url_ += "IsReviewd=" + encodeURIComponent("" + isReviewd) + "&";
        if (isOverridden === null)
            throw new Error("The parameter 'isOverridden' cannot be null.");
        else if (isOverridden !== undefined)
            url_ += "IsOverridden=" + encodeURIComponent("" + isOverridden) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCount4(_response);
        });
    }

    protected processCount4(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param supportingDocumentId (optional) 
     * @param documentFolderId (optional) 
     * @param documentPrefixId (optional) 
     * @param additionalInformation (optional) 
     * @param isVisible (optional) 
     * @param fileModifiedDate (optional) 
     * @param content (optional) 
     * @param isForSpouse (optional) 
     * @param businessName (optional) 
     * @return OK
     */
    upload(supportingDocumentId: string | undefined, documentFolderId: string | undefined, documentPrefixId: string | undefined, additionalInformation: string | null | undefined, isVisible: boolean | undefined, fileModifiedDate: moment.Moment | undefined, content: FileParameter | null | undefined, isForSpouse: boolean | undefined, businessName: string | null | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (supportingDocumentId === null || supportingDocumentId === undefined)
            throw new Error("The parameter 'supportingDocumentId' cannot be null.");
        else
            content_.append("SupportingDocumentId", supportingDocumentId.toString());
        if (documentFolderId === null || documentFolderId === undefined)
            throw new Error("The parameter 'documentFolderId' cannot be null.");
        else
            content_.append("DocumentFolderId", documentFolderId.toString());
        if (documentPrefixId === null || documentPrefixId === undefined)
            throw new Error("The parameter 'documentPrefixId' cannot be null.");
        else
            content_.append("DocumentPrefixId", documentPrefixId.toString());
        if (additionalInformation !== null && additionalInformation !== undefined)
            content_.append("AdditionalInformation", additionalInformation.toString());
        if (isVisible === null || isVisible === undefined)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else
            content_.append("IsVisible", isVisible.toString());
        if (fileModifiedDate === null || fileModifiedDate === undefined)
            throw new Error("The parameter 'fileModifiedDate' cannot be null.");
        else
            content_.append("FileModifiedDate", fileModifiedDate.toJSON());
        if (content !== null && content !== undefined)
            content_.append("Content", content.data, content.fileName ? content.fileName : "Content");
        if (isForSpouse === null || isForSpouse === undefined)
            throw new Error("The parameter 'isForSpouse' cannot be null.");
        else
            content_.append("IsForSpouse", isForSpouse.toString());
        if (businessName !== null && businessName !== undefined)
            content_.append("BusinessName", businessName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDocumentsMany(body: SupportingDocumentDocumentUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service-public/supporting-documents/update-documents-many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDocumentsMany(_response);
        });
    }

    protected processUpdateDocumentsMany(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param name (optional) 
     * @param agentIdToBeIgnored (optional) 
     * @param teamTypeEnum (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList3(name: string | null | undefined, agentIdToBeIgnored: string | undefined, teamTypeEnum: TeamTypeEnum | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/team/GetList?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (agentIdToBeIgnored === null)
            throw new Error("The parameter 'agentIdToBeIgnored' cannot be null.");
        else if (agentIdToBeIgnored !== undefined)
            url_ += "AgentIdToBeIgnored=" + encodeURIComponent("" + agentIdToBeIgnored) + "&";
        if (teamTypeEnum === null)
            throw new Error("The parameter 'teamTypeEnum' cannot be null.");
        else if (teamTypeEnum !== undefined)
            url_ += "TeamTypeEnum=" + encodeURIComponent("" + teamTypeEnum) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList3(_response);
        });
    }

    protected processGetList3(response: Response): Promise<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @return OK
     */
    getProfileInfo(): Promise<ProfileInfoDto[]> {
        let url_ = this.baseUrl + "/api/client-service/team/GetProfileInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfileInfo(_response);
        });
    }

    protected processGetProfileInfo(response: Response): Promise<ProfileInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileInfoDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList4(id: string | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Promise<PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/client-service/Administration/WorkflowTemplate/GetList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetList4(_response);
        });
    }

    protected processGetList4(response: Response): Promise<PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get3(id: string | undefined): Promise<WorkflowTemplateDto> {
        let url_ = this.baseUrl + "/api/client-service/Administration/WorkflowTemplate/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: Response): Promise<WorkflowTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowTemplateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create2(body: WorkflowTemplateCreateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/WorkflowTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate2(_response);
        });
    }

    protected processCreate2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    update2(id: string | undefined, body: WorkflowTemplateUpdateDto | undefined): Promise<SaveResult> {
        let url_ = this.baseUrl + "/api/client-service/Administration/WorkflowTemplate/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: Response): Promise<SaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete2(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/client-service/Administration/WorkflowTemplate/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CounsellingAPIClient extends BaseService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    types(): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/counselling_types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTypes(_response);
        });
    }

    protected processTypes(response: Response): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]>(null as any);
    }
}

export class DeliveryAPIClient extends BaseService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    methods(): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        let url_ = this.baseUrl + "/api/client-service/admin-info/counselling/delivery_methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMethods(_response);
        });
    }

    protected processMethods(response: Response): Promise<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]>(null as any);
    }
}

export class GetPreSelectedAppointmentDateAPIClient extends BaseService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param fileID (optional) 
     * @param officeLocationId (optional) 
     * @return OK
     */
    session1(fileID: string | undefined, officeLocationId: string | undefined): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/client-service/Appointment/GetPreSelectedAppointmentDate_Session1?";
        if (fileID === null)
            throw new Error("The parameter 'fileID' cannot be null.");
        else if (fileID !== undefined)
            url_ += "FileID=" + encodeURIComponent("" + fileID) + "&";
        if (officeLocationId === null)
            throw new Error("The parameter 'officeLocationId' cannot be null.");
        else if (officeLocationId !== undefined)
            url_ += "OfficeLocationId=" + encodeURIComponent("" + officeLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSession1(_response);
        });
    }

    protected processSession1(response: Response): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Not Implemented", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment>(null as any);
    }
}

export class AgentAllocationDto implements IAgentAllocationDto {
    teamId?: string;
    isAutoAssign?: boolean;
    agents?: AgentAllocationItemDto[] | undefined;

    constructor(data?: IAgentAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.isAutoAssign = _data["isAutoAssign"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentAllocationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["isAutoAssign"] = this.isAutoAssign;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentAllocationDto {
    teamId?: string;
    isAutoAssign?: boolean;
    agents?: AgentAllocationItemDto[] | undefined;
}

export class AgentAllocationItemDto implements IAgentAllocationItemDto {
    id?: string;
    teamId?: string;
    agentId?: string;
    agentName?: string | undefined;
    defaultOfficeName?: string | undefined;
    originalAllocationPercentage?: number | undefined;
    calculatedAllocationPercentage?: number | undefined;
    allocationPercentage?: number | undefined;
    pendingActions?: AgentTaskActionDto[] | undefined;
    pendingActionsAmount?: number;
    readonly pendingActionsDiff?: number;
    readonly allocationPercentageDiff?: number | undefined;

    constructor(data?: IAgentAllocationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.defaultOfficeName = _data["defaultOfficeName"];
            this.originalAllocationPercentage = _data["originalAllocationPercentage"];
            this.calculatedAllocationPercentage = _data["calculatedAllocationPercentage"];
            this.allocationPercentage = _data["allocationPercentage"];
            if (Array.isArray(_data["pendingActions"])) {
                this.pendingActions = [] as any;
                for (let item of _data["pendingActions"])
                    this.pendingActions!.push(AgentTaskActionDto.fromJS(item));
            }
            this.pendingActionsAmount = _data["pendingActionsAmount"];
            (<any>this).pendingActionsDiff = _data["pendingActionsDiff"];
            (<any>this).allocationPercentageDiff = _data["allocationPercentageDiff"];
        }
    }

    static fromJS(data: any): AgentAllocationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAllocationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["defaultOfficeName"] = this.defaultOfficeName;
        data["originalAllocationPercentage"] = this.originalAllocationPercentage;
        data["calculatedAllocationPercentage"] = this.calculatedAllocationPercentage;
        data["allocationPercentage"] = this.allocationPercentage;
        if (Array.isArray(this.pendingActions)) {
            data["pendingActions"] = [];
            for (let item of this.pendingActions)
                data["pendingActions"].push(item.toJSON());
        }
        data["pendingActionsAmount"] = this.pendingActionsAmount;
        data["pendingActionsDiff"] = this.pendingActionsDiff;
        data["allocationPercentageDiff"] = this.allocationPercentageDiff;
        return data;
    }
}

export interface IAgentAllocationItemDto {
    id?: string;
    teamId?: string;
    agentId?: string;
    agentName?: string | undefined;
    defaultOfficeName?: string | undefined;
    originalAllocationPercentage?: number | undefined;
    calculatedAllocationPercentage?: number | undefined;
    allocationPercentage?: number | undefined;
    pendingActions?: AgentTaskActionDto[] | undefined;
    pendingActionsAmount?: number;
    pendingActionsDiff?: number;
    allocationPercentageDiff?: number | undefined;
}

export class AgentTaskActionDto implements IAgentTaskActionDto {
    id?: string;
    agentId?: string;
    creationTime?: moment.Moment;

    constructor(data?: IAgentTaskActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentTaskActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgentTaskActionDto {
    id?: string;
    agentId?: string;
    creationTime?: moment.Moment;
}

export class DocumentPrefixDto implements IDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;
    frenchName?: string | undefined;

    constructor(data?: IDocumentPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentPrefixName = _data["documentPrefixName"];
            this.documentFolderId = _data["documentFolderId"];
            this.documentFolderName = _data["documentFolderName"];
            this.isCustom = _data["isCustom"];
            this.isActive = _data["isActive"];
            this.frenchName = _data["frenchName"];
        }
    }

    static fromJS(data: any): DocumentPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentPrefixName"] = this.documentPrefixName;
        data["documentFolderId"] = this.documentFolderId;
        data["documentFolderName"] = this.documentFolderName;
        data["isCustom"] = this.isCustom;
        data["isActive"] = this.isActive;
        data["frenchName"] = this.frenchName;
        return data;
    }
}

export interface IDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;
    frenchName?: string | undefined;
}

export class HolidayDto implements IHolidayDto {
    id?: string;
    holidayDate?: moment.Moment;
    isForAllOffices?: boolean;
    officeLocationIds?: string[] | undefined;
    officeLocationNames?: (string | undefined)[] | undefined;
    isActive?: boolean;

    constructor(data?: IHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.isForAllOffices = _data["isForAllOffices"];
            if (Array.isArray(_data["officeLocationIds"])) {
                this.officeLocationIds = [] as any;
                for (let item of _data["officeLocationIds"])
                    this.officeLocationIds!.push(item);
            }
            if (Array.isArray(_data["officeLocationNames"])) {
                this.officeLocationNames = [] as any;
                for (let item of _data["officeLocationNames"])
                    this.officeLocationNames!.push(item);
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["isForAllOffices"] = this.isForAllOffices;
        if (Array.isArray(this.officeLocationIds)) {
            data["officeLocationIds"] = [];
            for (let item of this.officeLocationIds)
                data["officeLocationIds"].push(item);
        }
        if (Array.isArray(this.officeLocationNames)) {
            data["officeLocationNames"] = [];
            for (let item of this.officeLocationNames)
                data["officeLocationNames"].push(item);
        }
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IHolidayDto {
    id?: string;
    holidayDate?: moment.Moment;
    isForAllOffices?: boolean;
    officeLocationIds?: string[] | undefined;
    officeLocationNames?: (string | undefined)[] | undefined;
    isActive?: boolean;
}

export class MessageTemplateDto implements IMessageTemplateDto {
    id?: string;
    typeId?: string;
    typeName?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMessageTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MessageTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMessageTemplateDto {
    id?: string;
    typeId?: string;
    typeName?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isActive?: boolean;
}

export class MessageTemplateSystemFieldsDto implements IMessageTemplateSystemFieldsDto {
    fields?: string | undefined;

    constructor(data?: IMessageTemplateSystemFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fields = _data["fields"];
        }
    }

    static fromJS(data: any): MessageTemplateSystemFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTemplateSystemFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fields"] = this.fields;
        return data;
    }
}

export interface IMessageTemplateSystemFieldsDto {
    fields?: string | undefined;
}

export class WorkflowTemplateCreateDto implements IWorkflowTemplateCreateDto {
    isActive?: boolean | undefined;
    option?: string | undefined;
    ascendClaimStatusId?: string;
    teamTypeId?: string;
    teamIds?: string[] | undefined;
    isCreditorEmail?: boolean | undefined;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean | undefined;
    markCompleteInAscend?: boolean | undefined;

    constructor(data?: IWorkflowTemplateCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.option = _data["option"];
            this.ascendClaimStatusId = _data["ascendClaimStatusId"];
            this.teamTypeId = _data["teamTypeId"];
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            this.isCreditorEmail = _data["isCreditorEmail"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.doNotAllowClaimDiscrepancy = _data["doNotAllowClaimDiscrepancy"];
            this.markCompleteInAscend = _data["markCompleteInAscend"];
        }
    }

    static fromJS(data: any): WorkflowTemplateCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTemplateCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["option"] = this.option;
        data["ascendClaimStatusId"] = this.ascendClaimStatusId;
        data["teamTypeId"] = this.teamTypeId;
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        data["isCreditorEmail"] = this.isCreditorEmail;
        data["messageTemplateId"] = this.messageTemplateId;
        data["doNotAllowClaimDiscrepancy"] = this.doNotAllowClaimDiscrepancy;
        data["markCompleteInAscend"] = this.markCompleteInAscend;
        return data;
    }
}

export interface IWorkflowTemplateCreateDto {
    isActive?: boolean | undefined;
    option?: string | undefined;
    ascendClaimStatusId?: string;
    teamTypeId?: string;
    teamIds?: string[] | undefined;
    isCreditorEmail?: boolean | undefined;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean | undefined;
    markCompleteInAscend?: boolean | undefined;
}

export class WorkflowTemplateDto implements IWorkflowTemplateDto {
    id?: string;
    isActive?: boolean;
    option?: string | undefined;
    teamType?: TeamTypeDto;
    teams?: TeamDto[] | undefined;
    isCreditorEmail?: boolean;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean;
    markCompleteInAscend?: boolean;

    constructor(data?: IWorkflowTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.option = _data["option"];
            this.teamType = _data["teamType"] ? TeamTypeDto.fromJS(_data["teamType"]) : <any>undefined;
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamDto.fromJS(item));
            }
            this.isCreditorEmail = _data["isCreditorEmail"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.doNotAllowClaimDiscrepancy = _data["doNotAllowClaimDiscrepancy"];
            this.markCompleteInAscend = _data["markCompleteInAscend"];
        }
    }

    static fromJS(data: any): WorkflowTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["option"] = this.option;
        data["teamType"] = this.teamType ? this.teamType.toJSON() : <any>undefined;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["isCreditorEmail"] = this.isCreditorEmail;
        data["messageTemplateId"] = this.messageTemplateId;
        data["doNotAllowClaimDiscrepancy"] = this.doNotAllowClaimDiscrepancy;
        data["markCompleteInAscend"] = this.markCompleteInAscend;
        return data;
    }
}

export interface IWorkflowTemplateDto {
    id?: string;
    isActive?: boolean;
    option?: string | undefined;
    teamType?: TeamTypeDto;
    teams?: TeamDto[] | undefined;
    isCreditorEmail?: boolean;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean;
    markCompleteInAscend?: boolean;
}

export class WorkflowTemplateUpdateDto implements IWorkflowTemplateUpdateDto {
    isActive?: boolean | undefined;
    option?: string | undefined;
    ascendClaimStatusId?: string;
    teamTypeId?: string;
    teamIds?: string[] | undefined;
    isCreditorEmail?: boolean;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean;
    markCompleteInAscend?: boolean;

    constructor(data?: IWorkflowTemplateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.option = _data["option"];
            this.ascendClaimStatusId = _data["ascendClaimStatusId"];
            this.teamTypeId = _data["teamTypeId"];
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            this.isCreditorEmail = _data["isCreditorEmail"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.doNotAllowClaimDiscrepancy = _data["doNotAllowClaimDiscrepancy"];
            this.markCompleteInAscend = _data["markCompleteInAscend"];
        }
    }

    static fromJS(data: any): WorkflowTemplateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTemplateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["option"] = this.option;
        data["ascendClaimStatusId"] = this.ascendClaimStatusId;
        data["teamTypeId"] = this.teamTypeId;
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        data["isCreditorEmail"] = this.isCreditorEmail;
        data["messageTemplateId"] = this.messageTemplateId;
        data["doNotAllowClaimDiscrepancy"] = this.doNotAllowClaimDiscrepancy;
        data["markCompleteInAscend"] = this.markCompleteInAscend;
        return data;
    }
}

export interface IWorkflowTemplateUpdateDto {
    isActive?: boolean | undefined;
    option?: string | undefined;
    ascendClaimStatusId?: string;
    teamTypeId?: string;
    teamIds?: string[] | undefined;
    isCreditorEmail?: boolean;
    messageTemplateId?: string | undefined;
    doNotAllowClaimDiscrepancy?: boolean;
    markCompleteInAscend?: boolean;
}

export class AgentAvailabilityDto implements IAgentAvailabilityDto {
    date?: moment.Moment;
    availabilityEntries?: AgentAvailabilityEntryDto[] | undefined;

    constructor(data?: IAgentAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["availabilityEntries"])) {
                this.availabilityEntries = [] as any;
                for (let item of _data["availabilityEntries"])
                    this.availabilityEntries!.push(AgentAvailabilityEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.availabilityEntries)) {
            data["availabilityEntries"] = [];
            for (let item of this.availabilityEntries)
                data["availabilityEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentAvailabilityDto {
    date?: moment.Moment;
    availabilityEntries?: AgentAvailabilityEntryDto[] | undefined;
}

export class AgentAvailabilityEntryDto implements IAgentAvailabilityEntryDto {
    startTime?: moment.Moment;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;

    constructor(data?: IAgentAvailabilityEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.rawStartTime = _data["rawStartTime"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.rawEndTime = _data["rawEndTime"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.officeLocationId = _data["officeLocationId"];
            this.officeRegionId = _data["officeRegionId"];
        }
    }

    static fromJS(data: any): AgentAvailabilityEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAvailabilityEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["rawStartTime"] = this.rawStartTime;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["rawEndTime"] = this.rawEndTime;
        data["meetingTypeId"] = this.meetingTypeId;
        data["officeLocationId"] = this.officeLocationId;
        data["officeRegionId"] = this.officeRegionId;
        return data;
    }
}

export interface IAgentAvailabilityEntryDto {
    startTime?: moment.Moment;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;
}

export class AgentDto implements IAgentDto {
    id?: string;
    fullName?: string | undefined;
    teams?: TeamDto[] | undefined;

    constructor(data?: IAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentDto {
    id?: string;
    fullName?: string | undefined;
    teams?: TeamDto[] | undefined;
}

export class AgentInfoDto implements IAgentInfoDto {
    id?: string;
    preferredLanguageId?: string | undefined;
    preferredLanguageName?: string | undefined;
    officeLocationId?: string | undefined;
    officeLocationName?: string | undefined;
    teamTypeIds?: string[] | undefined;
    teamTypeNames?: (string | undefined)[] | undefined;
    teamIds?: string[] | undefined;
    teamNames?: (string | undefined)[] | undefined;
    stationId?: string | undefined;

    constructor(data?: IAgentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.preferredLanguageName = _data["preferredLanguageName"];
            this.officeLocationId = _data["officeLocationId"];
            this.officeLocationName = _data["officeLocationName"];
            if (Array.isArray(_data["teamTypeIds"])) {
                this.teamTypeIds = [] as any;
                for (let item of _data["teamTypeIds"])
                    this.teamTypeIds!.push(item);
            }
            if (Array.isArray(_data["teamTypeNames"])) {
                this.teamTypeNames = [] as any;
                for (let item of _data["teamTypeNames"])
                    this.teamTypeNames!.push(item);
            }
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            if (Array.isArray(_data["teamNames"])) {
                this.teamNames = [] as any;
                for (let item of _data["teamNames"])
                    this.teamNames!.push(item);
            }
            this.stationId = _data["stationId"];
        }
    }

    static fromJS(data: any): AgentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["preferredLanguageName"] = this.preferredLanguageName;
        data["officeLocationId"] = this.officeLocationId;
        data["officeLocationName"] = this.officeLocationName;
        if (Array.isArray(this.teamTypeIds)) {
            data["teamTypeIds"] = [];
            for (let item of this.teamTypeIds)
                data["teamTypeIds"].push(item);
        }
        if (Array.isArray(this.teamTypeNames)) {
            data["teamTypeNames"] = [];
            for (let item of this.teamTypeNames)
                data["teamTypeNames"].push(item);
        }
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        if (Array.isArray(this.teamNames)) {
            data["teamNames"] = [];
            for (let item of this.teamNames)
                data["teamNames"].push(item);
        }
        data["stationId"] = this.stationId;
        return data;
    }
}

export interface IAgentInfoDto {
    id?: string;
    preferredLanguageId?: string | undefined;
    preferredLanguageName?: string | undefined;
    officeLocationId?: string | undefined;
    officeLocationName?: string | undefined;
    teamTypeIds?: string[] | undefined;
    teamTypeNames?: (string | undefined)[] | undefined;
    teamIds?: string[] | undefined;
    teamNames?: (string | undefined)[] | undefined;
    stationId?: string | undefined;
}

export class AgentInput implements IAgentInput {
    id?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    preferredLanguageId?: string;
    officeLocationId?: string;
    teamTypeIds?: string[] | undefined;
    teamIds?: string[] | undefined;
    isActive?: boolean;
    stationId?: string | undefined;
    estateAdministratorId?: string | undefined;
    trusteeId?: string | undefined;
    courtTrusteeId?: string | undefined;
    azObjectId?: string | undefined;

    constructor(data?: IAgentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.officeLocationId = _data["officeLocationId"];
            if (Array.isArray(_data["teamTypeIds"])) {
                this.teamTypeIds = [] as any;
                for (let item of _data["teamTypeIds"])
                    this.teamTypeIds!.push(item);
            }
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            this.isActive = _data["isActive"];
            this.stationId = _data["stationId"];
            this.estateAdministratorId = _data["estateAdministratorId"];
            this.trusteeId = _data["trusteeId"];
            this.courtTrusteeId = _data["courtTrusteeId"];
            this.azObjectId = _data["azObjectId"];
        }
    }

    static fromJS(data: any): AgentInput {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["officeLocationId"] = this.officeLocationId;
        if (Array.isArray(this.teamTypeIds)) {
            data["teamTypeIds"] = [];
            for (let item of this.teamTypeIds)
                data["teamTypeIds"].push(item);
        }
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        data["isActive"] = this.isActive;
        data["stationId"] = this.stationId;
        data["estateAdministratorId"] = this.estateAdministratorId;
        data["trusteeId"] = this.trusteeId;
        data["courtTrusteeId"] = this.courtTrusteeId;
        data["azObjectId"] = this.azObjectId;
        return data;
    }
}

export interface IAgentInput {
    id?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    preferredLanguageId?: string;
    officeLocationId?: string;
    teamTypeIds?: string[] | undefined;
    teamIds?: string[] | undefined;
    isActive?: boolean;
    stationId?: string | undefined;
    estateAdministratorId?: string | undefined;
    trusteeId?: string | undefined;
    courtTrusteeId?: string | undefined;
    azObjectId?: string | undefined;
}

export class AvailabilityOverrideDto implements IAvailabilityOverrideDto {
    id?: string;
    isAvailable?: boolean;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    entries?: AvailabilityOverrideEntryDto[] | undefined;

    constructor(data?: IAvailabilityOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAvailable = _data["isAvailable"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(AvailabilityOverrideEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAvailable"] = this.isAvailable;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityOverrideDto {
    id?: string;
    isAvailable?: boolean;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    entries?: AvailabilityOverrideEntryDto[] | undefined;
}

export class AvailabilityOverrideEntryDto implements IAvailabilityOverrideEntryDto {
    id?: string;
    startTime?: moment.Moment;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    meetingTypeName?: string | undefined;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;
    locationName?: string | undefined;

    constructor(data?: IAvailabilityOverrideEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.rawStartTime = _data["rawStartTime"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.rawEndTime = _data["rawEndTime"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.meetingTypeName = _data["meetingTypeName"];
            this.officeLocationId = _data["officeLocationId"];
            this.officeRegionId = _data["officeRegionId"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): AvailabilityOverrideEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityOverrideEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["rawStartTime"] = this.rawStartTime;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["rawEndTime"] = this.rawEndTime;
        data["meetingTypeId"] = this.meetingTypeId;
        data["meetingTypeName"] = this.meetingTypeName;
        data["officeLocationId"] = this.officeLocationId;
        data["officeRegionId"] = this.officeRegionId;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IAvailabilityOverrideEntryDto {
    id?: string;
    startTime?: moment.Moment;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    meetingTypeName?: string | undefined;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;
    locationName?: string | undefined;
}

export class GetAgentInfoInput implements IGetAgentInfoInput {
    ids?: string[] | undefined;

    constructor(data?: IGetAgentInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAgentInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IGetAgentInfoInput {
    ids?: string[] | undefined;
}

export class PdsUserBulkTransferInput implements IPdsUserBulkTransferInput {
    oldUserId?: string;
    taskUserId?: string | undefined;
    actionsUserId?: string | undefined;
    estateAdminUserId?: string | undefined;
    trusteeUserId?: string | undefined;
    courtTrusteeUserId?: string | undefined;
    appointmentsUserId?: string | undefined;

    constructor(data?: IPdsUserBulkTransferInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldUserId = _data["oldUserId"];
            this.taskUserId = _data["taskUserId"];
            this.actionsUserId = _data["actionsUserId"];
            this.estateAdminUserId = _data["estateAdminUserId"];
            this.trusteeUserId = _data["trusteeUserId"];
            this.courtTrusteeUserId = _data["courtTrusteeUserId"];
            this.appointmentsUserId = _data["appointmentsUserId"];
        }
    }

    static fromJS(data: any): PdsUserBulkTransferInput {
        data = typeof data === 'object' ? data : {};
        let result = new PdsUserBulkTransferInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldUserId"] = this.oldUserId;
        data["taskUserId"] = this.taskUserId;
        data["actionsUserId"] = this.actionsUserId;
        data["estateAdminUserId"] = this.estateAdminUserId;
        data["trusteeUserId"] = this.trusteeUserId;
        data["courtTrusteeUserId"] = this.courtTrusteeUserId;
        data["appointmentsUserId"] = this.appointmentsUserId;
        return data;
    }
}

export interface IPdsUserBulkTransferInput {
    oldUserId?: string;
    taskUserId?: string | undefined;
    actionsUserId?: string | undefined;
    estateAdminUserId?: string | undefined;
    trusteeUserId?: string | undefined;
    courtTrusteeUserId?: string | undefined;
    appointmentsUserId?: string | undefined;
}

export class TeamDto implements ITeamDto {
    id?: string;
    name?: string | undefined;
    teamType?: TeamTypeDto;
    agents?: AgentDto[] | undefined;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.teamType = _data["teamType"] ? TeamTypeDto.fromJS(_data["teamType"]) : <any>undefined;
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["teamType"] = this.teamType ? this.teamType.toJSON() : <any>undefined;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamDto {
    id?: string;
    name?: string | undefined;
    teamType?: TeamTypeDto;
    agents?: AgentDto[] | undefined;
}

export class TeamTypeDto implements ITeamTypeDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITeamTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TeamTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITeamTypeDto {
    id?: string;
    name?: string | undefined;
}

export class WeeklyScheduleDto implements IWeeklyScheduleDto {
    sundayEntries?: WeeklyScheduleEntryDto[] | undefined;
    mondayEntries?: WeeklyScheduleEntryDto[] | undefined;
    tuesdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    wednesdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    thursdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    fridayEntries?: WeeklyScheduleEntryDto[] | undefined;
    saturdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    schedulingNote?: string | undefined;

    constructor(data?: IWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sundayEntries"])) {
                this.sundayEntries = [] as any;
                for (let item of _data["sundayEntries"])
                    this.sundayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["mondayEntries"])) {
                this.mondayEntries = [] as any;
                for (let item of _data["mondayEntries"])
                    this.mondayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["tuesdayEntries"])) {
                this.tuesdayEntries = [] as any;
                for (let item of _data["tuesdayEntries"])
                    this.tuesdayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["wednesdayEntries"])) {
                this.wednesdayEntries = [] as any;
                for (let item of _data["wednesdayEntries"])
                    this.wednesdayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["thursdayEntries"])) {
                this.thursdayEntries = [] as any;
                for (let item of _data["thursdayEntries"])
                    this.thursdayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["fridayEntries"])) {
                this.fridayEntries = [] as any;
                for (let item of _data["fridayEntries"])
                    this.fridayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["saturdayEntries"])) {
                this.saturdayEntries = [] as any;
                for (let item of _data["saturdayEntries"])
                    this.saturdayEntries!.push(WeeklyScheduleEntryDto.fromJS(item));
            }
            this.schedulingNote = _data["schedulingNote"];
        }
    }

    static fromJS(data: any): WeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sundayEntries)) {
            data["sundayEntries"] = [];
            for (let item of this.sundayEntries)
                data["sundayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.mondayEntries)) {
            data["mondayEntries"] = [];
            for (let item of this.mondayEntries)
                data["mondayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.tuesdayEntries)) {
            data["tuesdayEntries"] = [];
            for (let item of this.tuesdayEntries)
                data["tuesdayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.wednesdayEntries)) {
            data["wednesdayEntries"] = [];
            for (let item of this.wednesdayEntries)
                data["wednesdayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.thursdayEntries)) {
            data["thursdayEntries"] = [];
            for (let item of this.thursdayEntries)
                data["thursdayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.fridayEntries)) {
            data["fridayEntries"] = [];
            for (let item of this.fridayEntries)
                data["fridayEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.saturdayEntries)) {
            data["saturdayEntries"] = [];
            for (let item of this.saturdayEntries)
                data["saturdayEntries"].push(item.toJSON());
        }
        data["schedulingNote"] = this.schedulingNote;
        return data;
    }
}

export interface IWeeklyScheduleDto {
    sundayEntries?: WeeklyScheduleEntryDto[] | undefined;
    mondayEntries?: WeeklyScheduleEntryDto[] | undefined;
    tuesdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    wednesdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    thursdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    fridayEntries?: WeeklyScheduleEntryDto[] | undefined;
    saturdayEntries?: WeeklyScheduleEntryDto[] | undefined;
    schedulingNote?: string | undefined;
}

export class WeeklyScheduleEntryDto implements IWeeklyScheduleEntryDto {
    id?: string;
    startTime?: moment.Moment | undefined;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment | undefined;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;

    constructor(data?: IWeeklyScheduleEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.rawStartTime = _data["rawStartTime"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.rawEndTime = _data["rawEndTime"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.officeLocationId = _data["officeLocationId"];
            this.officeRegionId = _data["officeRegionId"];
        }
    }

    static fromJS(data: any): WeeklyScheduleEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyScheduleEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["rawStartTime"] = this.rawStartTime;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["rawEndTime"] = this.rawEndTime;
        data["meetingTypeId"] = this.meetingTypeId;
        data["officeLocationId"] = this.officeLocationId;
        data["officeRegionId"] = this.officeRegionId;
        return data;
    }
}

export interface IWeeklyScheduleEntryDto {
    id?: string;
    startTime?: moment.Moment | undefined;
    rawStartTime?: string | undefined;
    endTime?: moment.Moment | undefined;
    rawEndTime?: string | undefined;
    meetingTypeId?: string;
    officeLocationId?: string | undefined;
    officeRegionId?: string | undefined;
}

export class AppEmailTemplateDto implements IAppEmailTemplateDto {
    id?: string;
    name?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IAppEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): AppEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IAppEmailTemplateDto {
    id?: string;
    name?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class AppEmailCreateDto implements IAppEmailCreateDto {
    fileId!: string;
    messageTemplateId?: string | undefined;
    toEmailAddress!: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
    claimId?: string | undefined;
    ignoreDoNotEmail?: boolean;

    constructor(data?: IAppEmailCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.toEmailAddress = _data["toEmailAddress"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
            this.claimId = _data["claimId"];
            this.ignoreDoNotEmail = _data["ignoreDoNotEmail"];
        }
    }

    static fromJS(data: any): AppEmailCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["messageTemplateId"] = this.messageTemplateId;
        data["toEmailAddress"] = this.toEmailAddress;
        data["subject"] = this.subject;
        data["body"] = this.body;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        data["claimId"] = this.claimId;
        data["ignoreDoNotEmail"] = this.ignoreDoNotEmail;
        return data;
    }
}

export interface IAppEmailCreateDto {
    fileId: string;
    messageTemplateId?: string | undefined;
    toEmailAddress: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
    claimId?: string | undefined;
    ignoreDoNotEmail?: boolean;
}

export class AppEmailDto implements IAppEmailDto {
    id?: string;
    messageTemplateId?: string | undefined;
    messageTemplateName?: string | undefined;
    fileId?: string;
    fromEmailAddress?: string | undefined;
    toEmailAddress?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    messageTemplateBody?: string | undefined;
    creationTime?: moment.Moment;
    attachmentDocumentIds?: string[] | undefined;

    constructor(data?: IAppEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.messageTemplateName = _data["messageTemplateName"];
            this.fileId = _data["fileId"];
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.toEmailAddress = _data["toEmailAddress"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.messageTemplateBody = _data["messageTemplateBody"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachmentDocumentIds"])) {
                this.attachmentDocumentIds = [] as any;
                for (let item of _data["attachmentDocumentIds"])
                    this.attachmentDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageTemplateId"] = this.messageTemplateId;
        data["messageTemplateName"] = this.messageTemplateName;
        data["fileId"] = this.fileId;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["toEmailAddress"] = this.toEmailAddress;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["messageTemplateBody"] = this.messageTemplateBody;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.attachmentDocumentIds)) {
            data["attachmentDocumentIds"] = [];
            for (let item of this.attachmentDocumentIds)
                data["attachmentDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppEmailDto {
    id?: string;
    messageTemplateId?: string | undefined;
    messageTemplateName?: string | undefined;
    fileId?: string;
    fromEmailAddress?: string | undefined;
    toEmailAddress?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    messageTemplateBody?: string | undefined;
    creationTime?: moment.Moment;
    attachmentDocumentIds?: string[] | undefined;
}

export class AppEmailResendDto implements IAppEmailResendDto {
    emailId!: string;

    constructor(data?: IAppEmailResendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
        }
    }

    static fromJS(data: any): AppEmailResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailResendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        return data;
    }
}

export interface IAppEmailResendDto {
    emailId: string;
}

export class AppEmailUpdateDto implements IAppEmailUpdateDto {
    fileId!: string;
    messageTemplateId?: string | undefined;
    fromEmailAddress!: string | undefined;
    toEmailAddress!: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IAppEmailUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.messageTemplateId = _data["messageTemplateId"];
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.toEmailAddress = _data["toEmailAddress"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): AppEmailUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppEmailUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["messageTemplateId"] = this.messageTemplateId;
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["toEmailAddress"] = this.toEmailAddress;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IAppEmailUpdateDto {
    fileId: string;
    messageTemplateId?: string | undefined;
    fromEmailAddress: string | undefined;
    toEmailAddress: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class FileEmailDto implements IFileEmailDto {
    email?: string | undefined;

    constructor(data?: IFileEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): FileEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IFileEmailDto {
    email?: string | undefined;
}

export class AppFormAssetsDebtsAssetConfig implements IAppFormAssetsDebtsAssetConfig {
    isJointFile?: boolean;
    isManitoba?: boolean;
    hasPrincipalResidence?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isJointFile = _data["isJointFile"];
            this.isManitoba = _data["isManitoba"];
            this.hasPrincipalResidence = _data["hasPrincipalResidence"];
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsAssetConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isJointFile"] = this.isJointFile;
        data["isManitoba"] = this.isManitoba;
        data["hasPrincipalResidence"] = this.hasPrincipalResidence;
        return data;
    }
}

export interface IAppFormAssetsDebtsAssetConfig {
    isJointFile?: boolean;
    isManitoba?: boolean;
    hasPrincipalResidence?: boolean;
}

export class AppFormAssetsDebtsAssetDto implements IAppFormAssetsDebtsAssetDto {
    id?: string;
    fileId?: string;
    assetType?: AssetTypeEnum;
    assetDescription?: AssetDescriptionEnum;
    assetDescriptionName?: string | undefined;
    assetTypeId?: string | undefined;
    assetDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    ownershipTypeId?: string | undefined;
    comments?: string | undefined;
    isExempt?: boolean;
    isForeignAsset?: boolean;
    securedToDebts?: AppFormAssetsDebtsDebtListItem[] | undefined;
    basisOfValue?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    applicantOwnershipPercentage?: number | undefined;
    spouseOwnershipPercentage?: number | undefined;
    otherOwnershipPercentage?: number | undefined;
    totalNumberOfOwners?: number | undefined;
    isOwnershipHeldInJointTenancy?: boolean | undefined;
    isPrincipalResidence?: boolean | undefined;
    nameOfInstitution?: string | undefined;
    policyNumber?: string | undefined;
    contributionsInLast12Months?: number | undefined;
    grantToBeRepaid?: number | undefined;
    estimatedTaxOnDisposition?: number | undefined;
    debtorsOwnershipInterest?: number | undefined;
    year?: moment.Moment | undefined;
    make?: string | undefined;
    model?: string | undefined;
    trim?: string | undefined;
    style?: string | undefined;
    kilometers?: number | undefined;
    vin?: string | undefined;
    isVehicleNeededForEmployment?: boolean | undefined;
    documentIds?: string[] | undefined;
    supportingDocumentOverrideInfo?: SupportingDocumentApplicabilityOverrideDto;
    clientUpdatedFields?: AppFormAssetsDebtsAssetUpdatedFieldsDto;

    constructor(data?: IAppFormAssetsDebtsAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.assetType = _data["assetType"];
            this.assetDescription = _data["assetDescription"];
            this.assetDescriptionName = _data["assetDescriptionName"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetDescriptionId = _data["assetDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.value = _data["value"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.comments = _data["comments"];
            this.isExempt = _data["isExempt"];
            this.isForeignAsset = _data["isForeignAsset"];
            if (Array.isArray(_data["securedToDebts"])) {
                this.securedToDebts = [] as any;
                for (let item of _data["securedToDebts"])
                    this.securedToDebts!.push(AppFormAssetsDebtsDebtListItem.fromJS(item));
            }
            this.basisOfValue = _data["basisOfValue"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.applicantOwnershipPercentage = _data["applicantOwnershipPercentage"];
            this.spouseOwnershipPercentage = _data["spouseOwnershipPercentage"];
            this.otherOwnershipPercentage = _data["otherOwnershipPercentage"];
            this.totalNumberOfOwners = _data["totalNumberOfOwners"];
            this.isOwnershipHeldInJointTenancy = _data["isOwnershipHeldInJointTenancy"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.nameOfInstitution = _data["nameOfInstitution"];
            this.policyNumber = _data["policyNumber"];
            this.contributionsInLast12Months = _data["contributionsInLast12Months"];
            this.grantToBeRepaid = _data["grantToBeRepaid"];
            this.estimatedTaxOnDisposition = _data["estimatedTaxOnDisposition"];
            this.debtorsOwnershipInterest = _data["debtorsOwnershipInterest"];
            this.year = _data["year"] ? moment(_data["year"].toString()) : <any>undefined;
            this.make = _data["make"];
            this.model = _data["model"];
            this.trim = _data["trim"];
            this.style = _data["style"];
            this.kilometers = _data["kilometers"];
            this.vin = _data["vin"];
            this.isVehicleNeededForEmployment = _data["isVehicleNeededForEmployment"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.supportingDocumentOverrideInfo = _data["supportingDocumentOverrideInfo"] ? SupportingDocumentApplicabilityOverrideDto.fromJS(_data["supportingDocumentOverrideInfo"]) : <any>undefined;
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormAssetsDebtsAssetUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["assetType"] = this.assetType;
        data["assetDescription"] = this.assetDescription;
        data["assetDescriptionName"] = this.assetDescriptionName;
        data["assetTypeId"] = this.assetTypeId;
        data["assetDescriptionId"] = this.assetDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["value"] = this.value;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["comments"] = this.comments;
        data["isExempt"] = this.isExempt;
        data["isForeignAsset"] = this.isForeignAsset;
        if (Array.isArray(this.securedToDebts)) {
            data["securedToDebts"] = [];
            for (let item of this.securedToDebts)
                data["securedToDebts"].push(item.toJSON());
        }
        data["basisOfValue"] = this.basisOfValue;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["applicantOwnershipPercentage"] = this.applicantOwnershipPercentage;
        data["spouseOwnershipPercentage"] = this.spouseOwnershipPercentage;
        data["otherOwnershipPercentage"] = this.otherOwnershipPercentage;
        data["totalNumberOfOwners"] = this.totalNumberOfOwners;
        data["isOwnershipHeldInJointTenancy"] = this.isOwnershipHeldInJointTenancy;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["nameOfInstitution"] = this.nameOfInstitution;
        data["policyNumber"] = this.policyNumber;
        data["contributionsInLast12Months"] = this.contributionsInLast12Months;
        data["grantToBeRepaid"] = this.grantToBeRepaid;
        data["estimatedTaxOnDisposition"] = this.estimatedTaxOnDisposition;
        data["debtorsOwnershipInterest"] = this.debtorsOwnershipInterest;
        data["year"] = this.year ? this.year.toISOString() : <any>undefined;
        data["make"] = this.make;
        data["model"] = this.model;
        data["trim"] = this.trim;
        data["style"] = this.style;
        data["kilometers"] = this.kilometers;
        data["vin"] = this.vin;
        data["isVehicleNeededForEmployment"] = this.isVehicleNeededForEmployment;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["supportingDocumentOverrideInfo"] = this.supportingDocumentOverrideInfo ? this.supportingDocumentOverrideInfo.toJSON() : <any>undefined;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormAssetsDebtsAssetDto {
    id?: string;
    fileId?: string;
    assetType?: AssetTypeEnum;
    assetDescription?: AssetDescriptionEnum;
    assetDescriptionName?: string | undefined;
    assetTypeId?: string | undefined;
    assetDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    ownershipTypeId?: string | undefined;
    comments?: string | undefined;
    isExempt?: boolean;
    isForeignAsset?: boolean;
    securedToDebts?: AppFormAssetsDebtsDebtListItem[] | undefined;
    basisOfValue?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    applicantOwnershipPercentage?: number | undefined;
    spouseOwnershipPercentage?: number | undefined;
    otherOwnershipPercentage?: number | undefined;
    totalNumberOfOwners?: number | undefined;
    isOwnershipHeldInJointTenancy?: boolean | undefined;
    isPrincipalResidence?: boolean | undefined;
    nameOfInstitution?: string | undefined;
    policyNumber?: string | undefined;
    contributionsInLast12Months?: number | undefined;
    grantToBeRepaid?: number | undefined;
    estimatedTaxOnDisposition?: number | undefined;
    debtorsOwnershipInterest?: number | undefined;
    year?: moment.Moment | undefined;
    make?: string | undefined;
    model?: string | undefined;
    trim?: string | undefined;
    style?: string | undefined;
    kilometers?: number | undefined;
    vin?: string | undefined;
    isVehicleNeededForEmployment?: boolean | undefined;
    documentIds?: string[] | undefined;
    supportingDocumentOverrideInfo?: SupportingDocumentApplicabilityOverrideDto;
    clientUpdatedFields?: AppFormAssetsDebtsAssetUpdatedFieldsDto;
}

export class AppFormAssetsDebtsAssetListItem implements IAppFormAssetsDebtsAssetListItem {
    id?: string;
    assetType?: LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    assetDescription?: LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    isMissingSupportingDocuments?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType = _data["assetType"] ? LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["assetType"]) : <any>undefined;
            this.assetDescription = _data["assetDescription"] ? LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["assetDescription"]) : <any>undefined;
            this.specifiedDescription = _data["specifiedDescription"];
            this.value = _data["value"];
            this.displayName = _data["displayName"];
            this.isMissingDetails = _data["isMissingDetails"];
            this.isMissingSupportingDocuments = _data["isMissingSupportingDocuments"];
            this.updatedByClient = _data["updatedByClient"];
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsAssetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType"] = this.assetType ? this.assetType.toJSON() : <any>undefined;
        data["assetDescription"] = this.assetDescription ? this.assetDescription.toJSON() : <any>undefined;
        data["specifiedDescription"] = this.specifiedDescription;
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        data["isMissingDetails"] = this.isMissingDetails;
        data["isMissingSupportingDocuments"] = this.isMissingSupportingDocuments;
        data["updatedByClient"] = this.updatedByClient;
        return data;
    }
}

export interface IAppFormAssetsDebtsAssetListItem {
    id?: string;
    assetType?: LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    assetDescription?: LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    isMissingSupportingDocuments?: boolean;
    updatedByClient?: boolean;
}

export class AppFormAssetsDebtsDebtDto implements IAppFormAssetsDebtsDebtDto {
    id?: string;
    fileId?: string;
    debtDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    creditorName?: string | undefined;
    amount?: number | undefined;
    ownershipTypeId?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isBusinessDebt?: boolean;
    creditorAddress?: string | undefined;
    creditorStreetNumber?: string | undefined;
    creditorStreetName?: string | undefined;
    creditorUnit?: string | undefined;
    creditorCity?: string | undefined;
    creditorPostalCode?: string | undefined;
    creditorProvinceCode?: string | undefined;
    creditorCountryCode?: string | undefined;
    creditorEmailAddress?: string | undefined;
    isUniqueCreditor?: boolean;
    externalCreditorNameId?: string | undefined;
    creditorTypeId?: string | undefined;
    unsecuredAmount?: number | undefined;
    isIncludeInProposal?: boolean;
    isCreditorNotParticipatingInProposal?: boolean;
    reasonForPreferredId?: string | undefined;
    ltpCodeId?: string | undefined;
    isPotentiallyStatuteBarred?: boolean;
    securedByAssetIds?: string[] | undefined;
    clientUpdatedFields?: AppFormAssetsDebtsDebtUpdatedFieldsDto;

    constructor(data?: IAppFormAssetsDebtsDebtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.debtDescriptionId = _data["debtDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.creditorName = _data["creditorName"];
            this.amount = _data["amount"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.accountNumber = _data["accountNumber"];
            this.comments = _data["comments"];
            this.isBusinessDebt = _data["isBusinessDebt"];
            this.creditorAddress = _data["creditorAddress"];
            this.creditorStreetNumber = _data["creditorStreetNumber"];
            this.creditorStreetName = _data["creditorStreetName"];
            this.creditorUnit = _data["creditorUnit"];
            this.creditorCity = _data["creditorCity"];
            this.creditorPostalCode = _data["creditorPostalCode"];
            this.creditorProvinceCode = _data["creditorProvinceCode"];
            this.creditorCountryCode = _data["creditorCountryCode"];
            this.creditorEmailAddress = _data["creditorEmailAddress"];
            this.isUniqueCreditor = _data["isUniqueCreditor"];
            this.externalCreditorNameId = _data["externalCreditorNameId"];
            this.creditorTypeId = _data["creditorTypeId"];
            this.unsecuredAmount = _data["unsecuredAmount"];
            this.isIncludeInProposal = _data["isIncludeInProposal"];
            this.isCreditorNotParticipatingInProposal = _data["isCreditorNotParticipatingInProposal"];
            this.reasonForPreferredId = _data["reasonForPreferredId"];
            this.ltpCodeId = _data["ltpCodeId"];
            this.isPotentiallyStatuteBarred = _data["isPotentiallyStatuteBarred"];
            if (Array.isArray(_data["securedByAssetIds"])) {
                this.securedByAssetIds = [] as any;
                for (let item of _data["securedByAssetIds"])
                    this.securedByAssetIds!.push(item);
            }
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormAssetsDebtsDebtUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsDebtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["debtDescriptionId"] = this.debtDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["creditorName"] = this.creditorName;
        data["amount"] = this.amount;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["accountNumber"] = this.accountNumber;
        data["comments"] = this.comments;
        data["isBusinessDebt"] = this.isBusinessDebt;
        data["creditorAddress"] = this.creditorAddress;
        data["creditorStreetNumber"] = this.creditorStreetNumber;
        data["creditorStreetName"] = this.creditorStreetName;
        data["creditorUnit"] = this.creditorUnit;
        data["creditorCity"] = this.creditorCity;
        data["creditorPostalCode"] = this.creditorPostalCode;
        data["creditorProvinceCode"] = this.creditorProvinceCode;
        data["creditorCountryCode"] = this.creditorCountryCode;
        data["creditorEmailAddress"] = this.creditorEmailAddress;
        data["isUniqueCreditor"] = this.isUniqueCreditor;
        data["externalCreditorNameId"] = this.externalCreditorNameId;
        data["creditorTypeId"] = this.creditorTypeId;
        data["unsecuredAmount"] = this.unsecuredAmount;
        data["isIncludeInProposal"] = this.isIncludeInProposal;
        data["isCreditorNotParticipatingInProposal"] = this.isCreditorNotParticipatingInProposal;
        data["reasonForPreferredId"] = this.reasonForPreferredId;
        data["ltpCodeId"] = this.ltpCodeId;
        data["isPotentiallyStatuteBarred"] = this.isPotentiallyStatuteBarred;
        if (Array.isArray(this.securedByAssetIds)) {
            data["securedByAssetIds"] = [];
            for (let item of this.securedByAssetIds)
                data["securedByAssetIds"].push(item);
        }
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormAssetsDebtsDebtDto {
    id?: string;
    fileId?: string;
    debtDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    creditorName?: string | undefined;
    amount?: number | undefined;
    ownershipTypeId?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isBusinessDebt?: boolean;
    creditorAddress?: string | undefined;
    creditorStreetNumber?: string | undefined;
    creditorStreetName?: string | undefined;
    creditorUnit?: string | undefined;
    creditorCity?: string | undefined;
    creditorPostalCode?: string | undefined;
    creditorProvinceCode?: string | undefined;
    creditorCountryCode?: string | undefined;
    creditorEmailAddress?: string | undefined;
    isUniqueCreditor?: boolean;
    externalCreditorNameId?: string | undefined;
    creditorTypeId?: string | undefined;
    unsecuredAmount?: number | undefined;
    isIncludeInProposal?: boolean;
    isCreditorNotParticipatingInProposal?: boolean;
    reasonForPreferredId?: string | undefined;
    ltpCodeId?: string | undefined;
    isPotentiallyStatuteBarred?: boolean;
    securedByAssetIds?: string[] | undefined;
    clientUpdatedFields?: AppFormAssetsDebtsDebtUpdatedFieldsDto;
}

export class AppFormAssetsDebtsDebtListItem implements IAppFormAssetsDebtsDebtListItem {
    id?: string;
    debtDescription?: LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    creditorName?: string | undefined;
    amount?: number | undefined;
    isSecured?: boolean;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormAssetsDebtsDebtListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.debtDescription = _data["debtDescription"] ? LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["debtDescription"]) : <any>undefined;
            this.creditorName = _data["creditorName"];
            this.amount = _data["amount"];
            this.isSecured = _data["isSecured"];
            this.displayName = _data["displayName"];
            this.isMissingDetails = _data["isMissingDetails"];
            this.updatedByClient = _data["updatedByClient"];
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsDebtListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["debtDescription"] = this.debtDescription ? this.debtDescription.toJSON() : <any>undefined;
        data["creditorName"] = this.creditorName;
        data["amount"] = this.amount;
        data["isSecured"] = this.isSecured;
        data["displayName"] = this.displayName;
        data["isMissingDetails"] = this.isMissingDetails;
        data["updatedByClient"] = this.updatedByClient;
        return data;
    }
}

export interface IAppFormAssetsDebtsDebtListItem {
    id?: string;
    debtDescription?: LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    creditorName?: string | undefined;
    amount?: number | undefined;
    isSecured?: boolean;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    updatedByClient?: boolean;
}

export class AppFormBankingInfoDetailDto implements IAppFormBankingInfoDetailDto {
    id?: string;
    institution?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isOverdraftOwed?: boolean | undefined;
    isJointAccount?: boolean | undefined;
    clientUpdatedFields?: AppFormBankingInfoDetailUpdatedFieldsDto;

    constructor(data?: IAppFormBankingInfoDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.institution = _data["institution"];
            this.transitNumber = _data["transitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.comments = _data["comments"];
            this.isOverdraftOwed = _data["isOverdraftOwed"];
            this.isJointAccount = _data["isJointAccount"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormBankingInfoDetailUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormBankingInfoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormBankingInfoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["institution"] = this.institution;
        data["transitNumber"] = this.transitNumber;
        data["accountNumber"] = this.accountNumber;
        data["comments"] = this.comments;
        data["isOverdraftOwed"] = this.isOverdraftOwed;
        data["isJointAccount"] = this.isJointAccount;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormBankingInfoDetailDto {
    id?: string;
    institution?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isOverdraftOwed?: boolean | undefined;
    isJointAccount?: boolean | undefined;
    clientUpdatedFields?: AppFormBankingInfoDetailUpdatedFieldsDto;
}

export class AppFormBankingInfoDto implements IAppFormBankingInfoDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    details?: AppFormBankingInfoDetailDto[] | undefined;
    spouseDetails?: AppFormBankingInfoDetailDto[] | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IAppFormBankingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(AppFormBankingInfoDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["spouseDetails"])) {
                this.spouseDetails = [] as any;
                for (let item of _data["spouseDetails"])
                    this.spouseDetails!.push(AppFormBankingInfoDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppFormBankingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormBankingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        if (Array.isArray(this.spouseDetails)) {
            data["spouseDetails"] = [];
            for (let item of this.spouseDetails)
                data["spouseDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IAppFormBankingInfoDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    details?: AppFormBankingInfoDetailDto[] | undefined;
    spouseDetails?: AppFormBankingInfoDetailDto[] | undefined;
    documentIds?: string[] | undefined;
}

export class AppFormIncomeExpenseExpenseDetailDto implements IAppFormIncomeExpenseExpenseDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    clientUpdatedFields?: AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInitial = _data["isInitial"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseDescriptionId = _data["expenseDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
            this.isSupportingDocumentsIncomplete = _data["isSupportingDocumentsIncomplete"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseExpenseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInitial"] = this.isInitial;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseDescriptionId"] = this.expenseDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        data["isSupportingDocumentsIncomplete"] = this.isSupportingDocumentsIncomplete;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormIncomeExpenseExpenseDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    clientUpdatedFields?: AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto;
}

export class AppFormIncomeExpenseExpenseDetailListItem implements IAppFormIncomeExpenseExpenseDetailListItem {
    id?: string;
    expenseType?: LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    expenseDescription?: LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expenseType = _data["expenseType"] ? LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["expenseType"]) : <any>undefined;
            this.expenseDescription = _data["expenseDescription"] ? LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["expenseDescription"]) : <any>undefined;
            this.specifiedDescription = _data["specifiedDescription"];
            this.amount = _data["amount"];
            this.isSupportingDocumentsIncomplete = _data["isSupportingDocumentsIncomplete"];
            this.updatedByClient = _data["updatedByClient"];
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseExpenseDetailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        data["expenseDescription"] = this.expenseDescription ? this.expenseDescription.toJSON() : <any>undefined;
        data["specifiedDescription"] = this.specifiedDescription;
        data["amount"] = this.amount;
        data["isSupportingDocumentsIncomplete"] = this.isSupportingDocumentsIncomplete;
        data["updatedByClient"] = this.updatedByClient;
        return data;
    }
}

export interface IAppFormIncomeExpenseExpenseDetailListItem {
    id?: string;
    expenseType?: LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    expenseDescription?: LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;
}

export class AppFormIncomeExpenseExpenseDto implements IAppFormIncomeExpenseExpenseDto {
    fileId?: string;
    isMarried?: boolean;
    documentIds?: string[] | undefined;
    expenseDetails?: AppFormIncomeExpenseExpenseDetailDto[] | undefined;

    constructor(data?: IAppFormIncomeExpenseExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["expenseDetails"])) {
                this.expenseDetails = [] as any;
                for (let item of _data["expenseDetails"])
                    this.expenseDetails!.push(AppFormIncomeExpenseExpenseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.expenseDetails)) {
            data["expenseDetails"] = [];
            for (let item of this.expenseDetails)
                data["expenseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppFormIncomeExpenseExpenseDto {
    fileId?: string;
    isMarried?: boolean;
    documentIds?: string[] | undefined;
    expenseDetails?: AppFormIncomeExpenseExpenseDetailDto[] | undefined;
}

export class AppFormIncomeExpenseIncomeDetailDto implements IAppFormIncomeExpenseIncomeDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    clientUpdatedFields?: AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInitial = _data["isInitial"];
            this.incomeTypeId = _data["incomeTypeId"];
            this.description = _data["description"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseIncomeDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInitial"] = this.isInitial;
        data["incomeTypeId"] = this.incomeTypeId;
        data["description"] = this.description;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormIncomeExpenseIncomeDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    clientUpdatedFields?: AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto;
}

export class AppFormIncomeExpenseIncomeDetailListItem implements IAppFormIncomeExpenseIncomeDetailListItem {
    id?: string;
    incomeType?: LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    description?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomeType = _data["incomeType"] ? LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data["incomeType"]) : <any>undefined;
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.isSupportingDocumentsIncomplete = _data["isSupportingDocumentsIncomplete"];
            this.updatedByClient = _data["updatedByClient"];
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseIncomeDetailListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomeType"] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["isSupportingDocumentsIncomplete"] = this.isSupportingDocumentsIncomplete;
        data["updatedByClient"] = this.updatedByClient;
        return data;
    }
}

export interface IAppFormIncomeExpenseIncomeDetailListItem {
    id?: string;
    incomeType?: LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    description?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;
}

export class AppFormIncomeExpenseIncomeDto implements IAppFormIncomeExpenseIncomeDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    documentIds?: string[] | undefined;
    incomeDetails?: AppFormIncomeExpenseIncomeDetailDto[] | undefined;

    constructor(data?: IAppFormIncomeExpenseIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            this.isSpouseRefusedToProvideIncomeData = _data["isSpouseRefusedToProvideIncomeData"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["incomeDetails"])) {
                this.incomeDetails = [] as any;
                for (let item of _data["incomeDetails"])
                    this.incomeDetails!.push(AppFormIncomeExpenseIncomeDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        data["isSpouseRefusedToProvideIncomeData"] = this.isSpouseRefusedToProvideIncomeData;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.incomeDetails)) {
            data["incomeDetails"] = [];
            for (let item of this.incomeDetails)
                data["incomeDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppFormIncomeExpenseIncomeDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    documentIds?: string[] | undefined;
    incomeDetails?: AppFormIncomeExpenseIncomeDetailDto[] | undefined;
}

export class AppFormIncomeTaxDto implements IAppFormIncomeTaxDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    yearLastReturnFiled?: moment.Moment | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: moment.Moment | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormIncomeTaxUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            this.yearLastReturnFiled = _data["yearLastReturnFiled"] ? moment(_data["yearLastReturnFiled"].toString()) : <any>undefined;
            this.refundAmount = _data["refundAmount"];
            this.amountOwing = _data["amountOwing"];
            this.spouseYearLastReturnFiled = _data["spouseYearLastReturnFiled"] ? moment(_data["spouseYearLastReturnFiled"].toString()) : <any>undefined;
            this.spouseRefundAmount = _data["spouseRefundAmount"];
            this.spouseAmountOwing = _data["spouseAmountOwing"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormIncomeTaxUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormIncomeTaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        data["yearLastReturnFiled"] = this.yearLastReturnFiled ? this.yearLastReturnFiled.toISOString() : <any>undefined;
        data["refundAmount"] = this.refundAmount;
        data["amountOwing"] = this.amountOwing;
        data["spouseYearLastReturnFiled"] = this.spouseYearLastReturnFiled ? this.spouseYearLastReturnFiled.toISOString() : <any>undefined;
        data["spouseRefundAmount"] = this.spouseRefundAmount;
        data["spouseAmountOwing"] = this.spouseAmountOwing;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormIncomeTaxDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    yearLastReturnFiled?: moment.Moment | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: moment.Moment | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormIncomeTaxUpdatedFieldsDto;
}

export class AppFormPersonalInfoAlternatePhoneDto implements IAppFormPersonalInfoAlternatePhoneDto {
    id?: string;
    phoneTypeId?: string | undefined;
    phoneNumber?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoAlternatePhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneTypeId = _data["phoneTypeId"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoAlternatePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoAlternatePhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneTypeId"] = this.phoneTypeId;
        data["phoneNumber"] = this.phoneNumber;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoAlternatePhoneDto {
    id?: string;
    phoneTypeId?: string | undefined;
    phoneNumber?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto;
}

export class AppFormPersonalInfoDependantDto implements IAppFormPersonalInfoDependantDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationshipTypeId?: string | undefined;
    birthDate?: moment.Moment | undefined;
    isSameAsApplicantsContactInfo?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoDependantUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoDependantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relationshipTypeId = _data["relationshipTypeId"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.isSameAsApplicantsContactInfo = _data["isSameAsApplicantsContactInfo"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoDependantUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoDependantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoDependantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relationshipTypeId"] = this.relationshipTypeId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["isSameAsApplicantsContactInfo"] = this.isSameAsApplicantsContactInfo;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoDependantDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationshipTypeId?: string | undefined;
    birthDate?: moment.Moment | undefined;
    isSameAsApplicantsContactInfo?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoDependantUpdatedFieldsDto;
}

export class AppFormPersonalInfoDto implements IAppFormPersonalInfoDto {
    id?: string;
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    akaFirstName?: string | undefined;
    akaMiddleName?: string | undefined;
    akaLastName?: string | undefined;
    birthDate?: moment.Moment | undefined;
    sin?: string | undefined;
    maritalStatusId?: string | undefined;
    marriageDate?: moment.Moment | undefined;
    educationLevelId?: string | undefined;
    spouseFirstName?: string | undefined;
    spouseMiddleName?: string | undefined;
    spouseLastName?: string | undefined;
    spouseAkaFirstName?: string | undefined;
    spouseAkaMiddleName?: string | undefined;
    spouseAkaLastName?: string | undefined;
    spouseBirthDate?: moment.Moment | undefined;
    spouseSIN?: string | undefined;
    spouseEducationLevelId?: string | undefined;
    isJointFile?: boolean;
    additionalNotes?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    residenceDate?: moment.Moment | undefined;
    previousAddresses?: AppFormPersonalInfoPreviousAddressDto[] | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    alternatePhones?: AppFormPersonalInfoAlternatePhoneDto[] | undefined;
    emailAddress?: string | undefined;
    isSpouseAddressSame?: boolean;
    spouseAddress?: string | undefined;
    spouseStreetNumber?: string | undefined;
    spouseStreetName?: string | undefined;
    spouseUnit?: string | undefined;
    spouseCity?: string | undefined;
    spousePostalCode?: string | undefined;
    spouseProvinceId?: string | undefined;
    spouseCountryId?: string | undefined;
    spouseResidenceDate?: moment.Moment | undefined;
    spouseMainPhoneTypeId?: string | undefined;
    spouseMainPhoneNumber?: string | undefined;
    spouseEmailAddress?: string | undefined;
    isEmployedPastTwoYears?: boolean | undefined;
    employmentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    employmentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    isSpouseEmployedPastTwoYears?: boolean | undefined;
    spouseEmploymentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    spouseEmploymentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: string | undefined;
    reasonForNeedingFinancialHelp?: string | undefined;
    numberOfPersonsInHousehold?: number | undefined;
    hasDependants?: boolean | undefined;
    dependants?: AppFormPersonalInfoDependantDto[] | undefined;
    hasPreviousInsolvency?: boolean | undefined;
    previousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    hasSpousePreviousInsolvency?: boolean | undefined;
    spousePreviousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormPersonalInfoUpdatedFieldsDto;
    isPersoanlDetailUpdatedByClient?: boolean | undefined;
    isContactInformationUpdatedByClient?: boolean | undefined;
    isEmploymentUpdatedByClient?: boolean | undefined;
    isFinancialDifficultyByClient?: boolean | undefined;
    isFinancialDifficultyByClientSpouse?: boolean | undefined;
    isDependantsUpdatedByClient?: boolean | undefined;
    isPreviousInsolvencyUpdatedByClient?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    specifyFDReasonLegalMatters?: string | undefined;
    hasFDReasonLossOfIncome?: boolean;
    hasFDReasonMedicalReasons?: boolean;
    hasFDReasonTaxLiabilities?: boolean;
    hasFDReasonFinancialSupportOfOthers?: boolean;
    hasFDReasonStudentDebt?: boolean;
    hasFDReasonMovingOrRelocationExpenses?: boolean;
    hasFDReasonFailedProposal?: boolean;
    hasFDReasonFinancialMismanagement?: boolean;
    spouseHasFDReasonLossOfIncome?: boolean | undefined;
    spouseHasFDReasonMedicalReasons?: boolean | undefined;
    spouseHasFDReasonBusinessFailure?: boolean | undefined;
    spouseHasFDReasonGambling?: boolean | undefined;
    spouseHasFDReasonDrugAlcoholAddicition?: boolean | undefined;
    spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean | undefined;
    spouseHasFDReasonTaxLiabilities?: boolean | undefined;
    spouseHasFDReasonFinancialSupportOfOthers?: boolean | undefined;
    spouseHasFDReasonStudentDebt?: boolean | undefined;
    spouseHasFDReasonLitigationIssues?: boolean | undefined;
    spouseHasFDReasonMovingOrRelocationExpenses?: boolean | undefined;
    spouseHasFDReasonFailedProposal?: boolean | undefined;
    spouseHasFDReasonFinancialMismanagement?: boolean | undefined;
    spouseHasFDReasonOther?: boolean | undefined;
    spouseSpecifyFDReasonLegalMatters?: string | undefined;
    spouseSpecifiedFDReason?: string | undefined;
    spouseReasonForNeedingFinancialHelp?: string | undefined;
    isSelfIdentificationUpdatedByClient?: boolean | undefined;
    consentToSelfIdentification?: boolean | undefined;
    consentToSelfIdentificationSpouse?: boolean | undefined;
    selfIdentifications?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
    selfIdentificationsSpouse?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;

    constructor(data?: IAppFormPersonalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.akaFirstName = _data["akaFirstName"];
            this.akaMiddleName = _data["akaMiddleName"];
            this.akaLastName = _data["akaLastName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sin = _data["sin"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            this.educationLevelId = _data["educationLevelId"];
            this.spouseFirstName = _data["spouseFirstName"];
            this.spouseMiddleName = _data["spouseMiddleName"];
            this.spouseLastName = _data["spouseLastName"];
            this.spouseAkaFirstName = _data["spouseAkaFirstName"];
            this.spouseAkaMiddleName = _data["spouseAkaMiddleName"];
            this.spouseAkaLastName = _data["spouseAkaLastName"];
            this.spouseBirthDate = _data["spouseBirthDate"] ? moment(_data["spouseBirthDate"].toString()) : <any>undefined;
            this.spouseSIN = _data["spouseSIN"];
            this.spouseEducationLevelId = _data["spouseEducationLevelId"];
            this.isJointFile = _data["isJointFile"];
            this.additionalNotes = _data["additionalNotes"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.cityTypeId = _data["cityTypeId"];
            this.postalCode = _data["postalCode"];
            this.provinceCode = _data["provinceCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.residenceDate = _data["residenceDate"] ? moment(_data["residenceDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["previousAddresses"])) {
                this.previousAddresses = [] as any;
                for (let item of _data["previousAddresses"])
                    this.previousAddresses!.push(AppFormPersonalInfoPreviousAddressDto.fromJS(item));
            }
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            if (Array.isArray(_data["alternatePhones"])) {
                this.alternatePhones = [] as any;
                for (let item of _data["alternatePhones"])
                    this.alternatePhones!.push(AppFormPersonalInfoAlternatePhoneDto.fromJS(item));
            }
            this.emailAddress = _data["emailAddress"];
            this.isSpouseAddressSame = _data["isSpouseAddressSame"];
            this.spouseAddress = _data["spouseAddress"];
            this.spouseStreetNumber = _data["spouseStreetNumber"];
            this.spouseStreetName = _data["spouseStreetName"];
            this.spouseUnit = _data["spouseUnit"];
            this.spouseCity = _data["spouseCity"];
            this.spousePostalCode = _data["spousePostalCode"];
            this.spouseProvinceId = _data["spouseProvinceId"];
            this.spouseCountryId = _data["spouseCountryId"];
            this.spouseResidenceDate = _data["spouseResidenceDate"] ? moment(_data["spouseResidenceDate"].toString()) : <any>undefined;
            this.spouseMainPhoneTypeId = _data["spouseMainPhoneTypeId"];
            this.spouseMainPhoneNumber = _data["spouseMainPhoneNumber"];
            this.spouseEmailAddress = _data["spouseEmailAddress"];
            this.isEmployedPastTwoYears = _data["isEmployedPastTwoYears"];
            if (Array.isArray(_data["employmentDetails"])) {
                this.employmentDetails = [] as any;
                for (let item of _data["employmentDetails"])
                    this.employmentDetails!.push(AppFormPersonalInfoEmploymentDetailDto.fromJS(item));
            }
            this.isReceivedEmploymentInsurancePastTwoYears = _data["isReceivedEmploymentInsurancePastTwoYears"];
            if (Array.isArray(_data["employmentInsurancePeriods"])) {
                this.employmentInsurancePeriods = [] as any;
                for (let item of _data["employmentInsurancePeriods"])
                    this.employmentInsurancePeriods!.push(AppFormPersonalInfoEmploymentInsurancePeriodDto.fromJS(item));
            }
            this.isSpouseEmployedPastTwoYears = _data["isSpouseEmployedPastTwoYears"];
            if (Array.isArray(_data["spouseEmploymentDetails"])) {
                this.spouseEmploymentDetails = [] as any;
                for (let item of _data["spouseEmploymentDetails"])
                    this.spouseEmploymentDetails!.push(AppFormPersonalInfoEmploymentDetailDto.fromJS(item));
            }
            this.isSpouseReceivedEmploymentInsurancePastTwoYears = _data["isSpouseReceivedEmploymentInsurancePastTwoYears"];
            if (Array.isArray(_data["spouseEmploymentInsurancePeriods"])) {
                this.spouseEmploymentInsurancePeriods = [] as any;
                for (let item of _data["spouseEmploymentInsurancePeriods"])
                    this.spouseEmploymentInsurancePeriods!.push(AppFormPersonalInfoEmploymentInsurancePeriodDto.fromJS(item));
            }
            this.hasFDReasonBusinessFailure = _data["hasFDReasonBusinessFailure"];
            this.hasFDReasonMaritalSeparationOrRelationshipBreakdown = _data["hasFDReasonMaritalSeparationOrRelationshipBreakdown"];
            this.hasFDReasonGambling = _data["hasFDReasonGambling"];
            this.hasFDReasonLitigationIssues = _data["hasFDReasonLitigationIssues"];
            this.hasFDReasonDrugAlcoholAddicition = _data["hasFDReasonDrugAlcoholAddicition"];
            this.hasFDReasonOther = _data["hasFDReasonOther"];
            this.specifiedFDReason = _data["specifiedFDReason"];
            this.reasonForNeedingFinancialHelp = _data["reasonForNeedingFinancialHelp"];
            this.numberOfPersonsInHousehold = _data["numberOfPersonsInHousehold"];
            this.hasDependants = _data["hasDependants"];
            if (Array.isArray(_data["dependants"])) {
                this.dependants = [] as any;
                for (let item of _data["dependants"])
                    this.dependants!.push(AppFormPersonalInfoDependantDto.fromJS(item));
            }
            this.hasPreviousInsolvency = _data["hasPreviousInsolvency"];
            if (Array.isArray(_data["previousInsolvencies"])) {
                this.previousInsolvencies = [] as any;
                for (let item of _data["previousInsolvencies"])
                    this.previousInsolvencies!.push(AppFormPersonalInfoPreviousInsolvencyDto.fromJS(item));
            }
            this.hasSpousePreviousInsolvency = _data["hasSpousePreviousInsolvency"];
            if (Array.isArray(_data["spousePreviousInsolvencies"])) {
                this.spousePreviousInsolvencies = [] as any;
                for (let item of _data["spousePreviousInsolvencies"])
                    this.spousePreviousInsolvencies!.push(AppFormPersonalInfoPreviousInsolvencyDto.fromJS(item));
            }
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
            this.isPersoanlDetailUpdatedByClient = _data["isPersoanlDetailUpdatedByClient"];
            this.isContactInformationUpdatedByClient = _data["isContactInformationUpdatedByClient"];
            this.isEmploymentUpdatedByClient = _data["isEmploymentUpdatedByClient"];
            this.isFinancialDifficultyByClient = _data["isFinancialDifficultyByClient"];
            this.isFinancialDifficultyByClientSpouse = _data["isFinancialDifficultyByClientSpouse"];
            this.isDependantsUpdatedByClient = _data["isDependantsUpdatedByClient"];
            this.isPreviousInsolvencyUpdatedByClient = _data["isPreviousInsolvencyUpdatedByClient"];
            this.isRegisteredToClientPortal = _data["isRegisteredToClientPortal"];
            this.specifyFDReasonLegalMatters = _data["specifyFDReasonLegalMatters"];
            this.hasFDReasonLossOfIncome = _data["hasFDReasonLossOfIncome"];
            this.hasFDReasonMedicalReasons = _data["hasFDReasonMedicalReasons"];
            this.hasFDReasonTaxLiabilities = _data["hasFDReasonTaxLiabilities"];
            this.hasFDReasonFinancialSupportOfOthers = _data["hasFDReasonFinancialSupportOfOthers"];
            this.hasFDReasonStudentDebt = _data["hasFDReasonStudentDebt"];
            this.hasFDReasonMovingOrRelocationExpenses = _data["hasFDReasonMovingOrRelocationExpenses"];
            this.hasFDReasonFailedProposal = _data["hasFDReasonFailedProposal"];
            this.hasFDReasonFinancialMismanagement = _data["hasFDReasonFinancialMismanagement"];
            this.spouseHasFDReasonLossOfIncome = _data["spouseHasFDReasonLossOfIncome"];
            this.spouseHasFDReasonMedicalReasons = _data["spouseHasFDReasonMedicalReasons"];
            this.spouseHasFDReasonBusinessFailure = _data["spouseHasFDReasonBusinessFailure"];
            this.spouseHasFDReasonGambling = _data["spouseHasFDReasonGambling"];
            this.spouseHasFDReasonDrugAlcoholAddicition = _data["spouseHasFDReasonDrugAlcoholAddicition"];
            this.spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown = _data["spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown"];
            this.spouseHasFDReasonTaxLiabilities = _data["spouseHasFDReasonTaxLiabilities"];
            this.spouseHasFDReasonFinancialSupportOfOthers = _data["spouseHasFDReasonFinancialSupportOfOthers"];
            this.spouseHasFDReasonStudentDebt = _data["spouseHasFDReasonStudentDebt"];
            this.spouseHasFDReasonLitigationIssues = _data["spouseHasFDReasonLitigationIssues"];
            this.spouseHasFDReasonMovingOrRelocationExpenses = _data["spouseHasFDReasonMovingOrRelocationExpenses"];
            this.spouseHasFDReasonFailedProposal = _data["spouseHasFDReasonFailedProposal"];
            this.spouseHasFDReasonFinancialMismanagement = _data["spouseHasFDReasonFinancialMismanagement"];
            this.spouseHasFDReasonOther = _data["spouseHasFDReasonOther"];
            this.spouseSpecifyFDReasonLegalMatters = _data["spouseSpecifyFDReasonLegalMatters"];
            this.spouseSpecifiedFDReason = _data["spouseSpecifiedFDReason"];
            this.spouseReasonForNeedingFinancialHelp = _data["spouseReasonForNeedingFinancialHelp"];
            this.isSelfIdentificationUpdatedByClient = _data["isSelfIdentificationUpdatedByClient"];
            this.consentToSelfIdentification = _data["consentToSelfIdentification"];
            this.consentToSelfIdentificationSpouse = _data["consentToSelfIdentificationSpouse"];
            if (Array.isArray(_data["selfIdentifications"])) {
                this.selfIdentifications = [] as any;
                for (let item of _data["selfIdentifications"])
                    this.selfIdentifications!.push(AppFormPersonalInfoSelfIdentificationDto.fromJS(item));
            }
            if (Array.isArray(_data["selfIdentificationsSpouse"])) {
                this.selfIdentificationsSpouse = [] as any;
                for (let item of _data["selfIdentificationsSpouse"])
                    this.selfIdentificationsSpouse!.push(AppFormPersonalInfoSelfIdentificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppFormPersonalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["akaFirstName"] = this.akaFirstName;
        data["akaMiddleName"] = this.akaMiddleName;
        data["akaLastName"] = this.akaLastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sin"] = this.sin;
        data["maritalStatusId"] = this.maritalStatusId;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["educationLevelId"] = this.educationLevelId;
        data["spouseFirstName"] = this.spouseFirstName;
        data["spouseMiddleName"] = this.spouseMiddleName;
        data["spouseLastName"] = this.spouseLastName;
        data["spouseAkaFirstName"] = this.spouseAkaFirstName;
        data["spouseAkaMiddleName"] = this.spouseAkaMiddleName;
        data["spouseAkaLastName"] = this.spouseAkaLastName;
        data["spouseBirthDate"] = this.spouseBirthDate ? this.spouseBirthDate.toISOString() : <any>undefined;
        data["spouseSIN"] = this.spouseSIN;
        data["spouseEducationLevelId"] = this.spouseEducationLevelId;
        data["isJointFile"] = this.isJointFile;
        data["additionalNotes"] = this.additionalNotes;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["cityTypeId"] = this.cityTypeId;
        data["postalCode"] = this.postalCode;
        data["provinceCode"] = this.provinceCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["residenceDate"] = this.residenceDate ? this.residenceDate.toISOString() : <any>undefined;
        if (Array.isArray(this.previousAddresses)) {
            data["previousAddresses"] = [];
            for (let item of this.previousAddresses)
                data["previousAddresses"].push(item.toJSON());
        }
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        if (Array.isArray(this.alternatePhones)) {
            data["alternatePhones"] = [];
            for (let item of this.alternatePhones)
                data["alternatePhones"].push(item.toJSON());
        }
        data["emailAddress"] = this.emailAddress;
        data["isSpouseAddressSame"] = this.isSpouseAddressSame;
        data["spouseAddress"] = this.spouseAddress;
        data["spouseStreetNumber"] = this.spouseStreetNumber;
        data["spouseStreetName"] = this.spouseStreetName;
        data["spouseUnit"] = this.spouseUnit;
        data["spouseCity"] = this.spouseCity;
        data["spousePostalCode"] = this.spousePostalCode;
        data["spouseProvinceId"] = this.spouseProvinceId;
        data["spouseCountryId"] = this.spouseCountryId;
        data["spouseResidenceDate"] = this.spouseResidenceDate ? this.spouseResidenceDate.toISOString() : <any>undefined;
        data["spouseMainPhoneTypeId"] = this.spouseMainPhoneTypeId;
        data["spouseMainPhoneNumber"] = this.spouseMainPhoneNumber;
        data["spouseEmailAddress"] = this.spouseEmailAddress;
        data["isEmployedPastTwoYears"] = this.isEmployedPastTwoYears;
        if (Array.isArray(this.employmentDetails)) {
            data["employmentDetails"] = [];
            for (let item of this.employmentDetails)
                data["employmentDetails"].push(item.toJSON());
        }
        data["isReceivedEmploymentInsurancePastTwoYears"] = this.isReceivedEmploymentInsurancePastTwoYears;
        if (Array.isArray(this.employmentInsurancePeriods)) {
            data["employmentInsurancePeriods"] = [];
            for (let item of this.employmentInsurancePeriods)
                data["employmentInsurancePeriods"].push(item.toJSON());
        }
        data["isSpouseEmployedPastTwoYears"] = this.isSpouseEmployedPastTwoYears;
        if (Array.isArray(this.spouseEmploymentDetails)) {
            data["spouseEmploymentDetails"] = [];
            for (let item of this.spouseEmploymentDetails)
                data["spouseEmploymentDetails"].push(item.toJSON());
        }
        data["isSpouseReceivedEmploymentInsurancePastTwoYears"] = this.isSpouseReceivedEmploymentInsurancePastTwoYears;
        if (Array.isArray(this.spouseEmploymentInsurancePeriods)) {
            data["spouseEmploymentInsurancePeriods"] = [];
            for (let item of this.spouseEmploymentInsurancePeriods)
                data["spouseEmploymentInsurancePeriods"].push(item.toJSON());
        }
        data["hasFDReasonBusinessFailure"] = this.hasFDReasonBusinessFailure;
        data["hasFDReasonMaritalSeparationOrRelationshipBreakdown"] = this.hasFDReasonMaritalSeparationOrRelationshipBreakdown;
        data["hasFDReasonGambling"] = this.hasFDReasonGambling;
        data["hasFDReasonLitigationIssues"] = this.hasFDReasonLitigationIssues;
        data["hasFDReasonDrugAlcoholAddicition"] = this.hasFDReasonDrugAlcoholAddicition;
        data["hasFDReasonOther"] = this.hasFDReasonOther;
        data["specifiedFDReason"] = this.specifiedFDReason;
        data["reasonForNeedingFinancialHelp"] = this.reasonForNeedingFinancialHelp;
        data["numberOfPersonsInHousehold"] = this.numberOfPersonsInHousehold;
        data["hasDependants"] = this.hasDependants;
        if (Array.isArray(this.dependants)) {
            data["dependants"] = [];
            for (let item of this.dependants)
                data["dependants"].push(item.toJSON());
        }
        data["hasPreviousInsolvency"] = this.hasPreviousInsolvency;
        if (Array.isArray(this.previousInsolvencies)) {
            data["previousInsolvencies"] = [];
            for (let item of this.previousInsolvencies)
                data["previousInsolvencies"].push(item.toJSON());
        }
        data["hasSpousePreviousInsolvency"] = this.hasSpousePreviousInsolvency;
        if (Array.isArray(this.spousePreviousInsolvencies)) {
            data["spousePreviousInsolvencies"] = [];
            for (let item of this.spousePreviousInsolvencies)
                data["spousePreviousInsolvencies"].push(item.toJSON());
        }
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        data["isPersoanlDetailUpdatedByClient"] = this.isPersoanlDetailUpdatedByClient;
        data["isContactInformationUpdatedByClient"] = this.isContactInformationUpdatedByClient;
        data["isEmploymentUpdatedByClient"] = this.isEmploymentUpdatedByClient;
        data["isFinancialDifficultyByClient"] = this.isFinancialDifficultyByClient;
        data["isFinancialDifficultyByClientSpouse"] = this.isFinancialDifficultyByClientSpouse;
        data["isDependantsUpdatedByClient"] = this.isDependantsUpdatedByClient;
        data["isPreviousInsolvencyUpdatedByClient"] = this.isPreviousInsolvencyUpdatedByClient;
        data["isRegisteredToClientPortal"] = this.isRegisteredToClientPortal;
        data["specifyFDReasonLegalMatters"] = this.specifyFDReasonLegalMatters;
        data["hasFDReasonLossOfIncome"] = this.hasFDReasonLossOfIncome;
        data["hasFDReasonMedicalReasons"] = this.hasFDReasonMedicalReasons;
        data["hasFDReasonTaxLiabilities"] = this.hasFDReasonTaxLiabilities;
        data["hasFDReasonFinancialSupportOfOthers"] = this.hasFDReasonFinancialSupportOfOthers;
        data["hasFDReasonStudentDebt"] = this.hasFDReasonStudentDebt;
        data["hasFDReasonMovingOrRelocationExpenses"] = this.hasFDReasonMovingOrRelocationExpenses;
        data["hasFDReasonFailedProposal"] = this.hasFDReasonFailedProposal;
        data["hasFDReasonFinancialMismanagement"] = this.hasFDReasonFinancialMismanagement;
        data["spouseHasFDReasonLossOfIncome"] = this.spouseHasFDReasonLossOfIncome;
        data["spouseHasFDReasonMedicalReasons"] = this.spouseHasFDReasonMedicalReasons;
        data["spouseHasFDReasonBusinessFailure"] = this.spouseHasFDReasonBusinessFailure;
        data["spouseHasFDReasonGambling"] = this.spouseHasFDReasonGambling;
        data["spouseHasFDReasonDrugAlcoholAddicition"] = this.spouseHasFDReasonDrugAlcoholAddicition;
        data["spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown"] = this.spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown;
        data["spouseHasFDReasonTaxLiabilities"] = this.spouseHasFDReasonTaxLiabilities;
        data["spouseHasFDReasonFinancialSupportOfOthers"] = this.spouseHasFDReasonFinancialSupportOfOthers;
        data["spouseHasFDReasonStudentDebt"] = this.spouseHasFDReasonStudentDebt;
        data["spouseHasFDReasonLitigationIssues"] = this.spouseHasFDReasonLitigationIssues;
        data["spouseHasFDReasonMovingOrRelocationExpenses"] = this.spouseHasFDReasonMovingOrRelocationExpenses;
        data["spouseHasFDReasonFailedProposal"] = this.spouseHasFDReasonFailedProposal;
        data["spouseHasFDReasonFinancialMismanagement"] = this.spouseHasFDReasonFinancialMismanagement;
        data["spouseHasFDReasonOther"] = this.spouseHasFDReasonOther;
        data["spouseSpecifyFDReasonLegalMatters"] = this.spouseSpecifyFDReasonLegalMatters;
        data["spouseSpecifiedFDReason"] = this.spouseSpecifiedFDReason;
        data["spouseReasonForNeedingFinancialHelp"] = this.spouseReasonForNeedingFinancialHelp;
        data["isSelfIdentificationUpdatedByClient"] = this.isSelfIdentificationUpdatedByClient;
        data["consentToSelfIdentification"] = this.consentToSelfIdentification;
        data["consentToSelfIdentificationSpouse"] = this.consentToSelfIdentificationSpouse;
        if (Array.isArray(this.selfIdentifications)) {
            data["selfIdentifications"] = [];
            for (let item of this.selfIdentifications)
                data["selfIdentifications"].push(item.toJSON());
        }
        if (Array.isArray(this.selfIdentificationsSpouse)) {
            data["selfIdentificationsSpouse"] = [];
            for (let item of this.selfIdentificationsSpouse)
                data["selfIdentificationsSpouse"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppFormPersonalInfoDto {
    id?: string;
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    akaFirstName?: string | undefined;
    akaMiddleName?: string | undefined;
    akaLastName?: string | undefined;
    birthDate?: moment.Moment | undefined;
    sin?: string | undefined;
    maritalStatusId?: string | undefined;
    marriageDate?: moment.Moment | undefined;
    educationLevelId?: string | undefined;
    spouseFirstName?: string | undefined;
    spouseMiddleName?: string | undefined;
    spouseLastName?: string | undefined;
    spouseAkaFirstName?: string | undefined;
    spouseAkaMiddleName?: string | undefined;
    spouseAkaLastName?: string | undefined;
    spouseBirthDate?: moment.Moment | undefined;
    spouseSIN?: string | undefined;
    spouseEducationLevelId?: string | undefined;
    isJointFile?: boolean;
    additionalNotes?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    residenceDate?: moment.Moment | undefined;
    previousAddresses?: AppFormPersonalInfoPreviousAddressDto[] | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    alternatePhones?: AppFormPersonalInfoAlternatePhoneDto[] | undefined;
    emailAddress?: string | undefined;
    isSpouseAddressSame?: boolean;
    spouseAddress?: string | undefined;
    spouseStreetNumber?: string | undefined;
    spouseStreetName?: string | undefined;
    spouseUnit?: string | undefined;
    spouseCity?: string | undefined;
    spousePostalCode?: string | undefined;
    spouseProvinceId?: string | undefined;
    spouseCountryId?: string | undefined;
    spouseResidenceDate?: moment.Moment | undefined;
    spouseMainPhoneTypeId?: string | undefined;
    spouseMainPhoneNumber?: string | undefined;
    spouseEmailAddress?: string | undefined;
    isEmployedPastTwoYears?: boolean | undefined;
    employmentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    employmentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    isSpouseEmployedPastTwoYears?: boolean | undefined;
    spouseEmploymentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    spouseEmploymentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: string | undefined;
    reasonForNeedingFinancialHelp?: string | undefined;
    numberOfPersonsInHousehold?: number | undefined;
    hasDependants?: boolean | undefined;
    dependants?: AppFormPersonalInfoDependantDto[] | undefined;
    hasPreviousInsolvency?: boolean | undefined;
    previousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    hasSpousePreviousInsolvency?: boolean | undefined;
    spousePreviousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormPersonalInfoUpdatedFieldsDto;
    isPersoanlDetailUpdatedByClient?: boolean | undefined;
    isContactInformationUpdatedByClient?: boolean | undefined;
    isEmploymentUpdatedByClient?: boolean | undefined;
    isFinancialDifficultyByClient?: boolean | undefined;
    isFinancialDifficultyByClientSpouse?: boolean | undefined;
    isDependantsUpdatedByClient?: boolean | undefined;
    isPreviousInsolvencyUpdatedByClient?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    specifyFDReasonLegalMatters?: string | undefined;
    hasFDReasonLossOfIncome?: boolean;
    hasFDReasonMedicalReasons?: boolean;
    hasFDReasonTaxLiabilities?: boolean;
    hasFDReasonFinancialSupportOfOthers?: boolean;
    hasFDReasonStudentDebt?: boolean;
    hasFDReasonMovingOrRelocationExpenses?: boolean;
    hasFDReasonFailedProposal?: boolean;
    hasFDReasonFinancialMismanagement?: boolean;
    spouseHasFDReasonLossOfIncome?: boolean | undefined;
    spouseHasFDReasonMedicalReasons?: boolean | undefined;
    spouseHasFDReasonBusinessFailure?: boolean | undefined;
    spouseHasFDReasonGambling?: boolean | undefined;
    spouseHasFDReasonDrugAlcoholAddicition?: boolean | undefined;
    spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean | undefined;
    spouseHasFDReasonTaxLiabilities?: boolean | undefined;
    spouseHasFDReasonFinancialSupportOfOthers?: boolean | undefined;
    spouseHasFDReasonStudentDebt?: boolean | undefined;
    spouseHasFDReasonLitigationIssues?: boolean | undefined;
    spouseHasFDReasonMovingOrRelocationExpenses?: boolean | undefined;
    spouseHasFDReasonFailedProposal?: boolean | undefined;
    spouseHasFDReasonFinancialMismanagement?: boolean | undefined;
    spouseHasFDReasonOther?: boolean | undefined;
    spouseSpecifyFDReasonLegalMatters?: string | undefined;
    spouseSpecifiedFDReason?: string | undefined;
    spouseReasonForNeedingFinancialHelp?: string | undefined;
    isSelfIdentificationUpdatedByClient?: boolean | undefined;
    consentToSelfIdentification?: boolean | undefined;
    consentToSelfIdentificationSpouse?: boolean | undefined;
    selfIdentifications?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
    selfIdentificationsSpouse?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
}

export class AppFormPersonalInfoEmploymentDetailDto implements IAppFormPersonalInfoEmploymentDetailDto {
    id?: string;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerStreetNumber?: string | undefined;
    employerStreetName?: string | undefined;
    employerUnit?: string | undefined;
    employerCity?: string | undefined;
    employerPostalCode?: string | undefined;
    employerProvinceId?: string | undefined;
    employerCountryId?: string | undefined;
    occupationName?: string | undefined;
    industryId?: string | undefined;
    employmentStatusId?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentEmployer?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoEmploymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerName = _data["employerName"];
            this.employerAddress = _data["employerAddress"];
            this.employerStreetNumber = _data["employerStreetNumber"];
            this.employerStreetName = _data["employerStreetName"];
            this.employerUnit = _data["employerUnit"];
            this.employerCity = _data["employerCity"];
            this.employerPostalCode = _data["employerPostalCode"];
            this.employerProvinceId = _data["employerProvinceId"];
            this.employerCountryId = _data["employerCountryId"];
            this.occupationName = _data["occupationName"];
            this.industryId = _data["industryId"];
            this.employmentStatusId = _data["employmentStatusId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isCurrentEmployer = _data["isCurrentEmployer"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoEmploymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerName"] = this.employerName;
        data["employerAddress"] = this.employerAddress;
        data["employerStreetNumber"] = this.employerStreetNumber;
        data["employerStreetName"] = this.employerStreetName;
        data["employerUnit"] = this.employerUnit;
        data["employerCity"] = this.employerCity;
        data["employerPostalCode"] = this.employerPostalCode;
        data["employerProvinceId"] = this.employerProvinceId;
        data["employerCountryId"] = this.employerCountryId;
        data["occupationName"] = this.occupationName;
        data["industryId"] = this.industryId;
        data["employmentStatusId"] = this.employmentStatusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isCurrentEmployer"] = this.isCurrentEmployer;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoEmploymentDetailDto {
    id?: string;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerStreetNumber?: string | undefined;
    employerStreetName?: string | undefined;
    employerUnit?: string | undefined;
    employerCity?: string | undefined;
    employerPostalCode?: string | undefined;
    employerProvinceId?: string | undefined;
    employerCountryId?: string | undefined;
    occupationName?: string | undefined;
    industryId?: string | undefined;
    employmentStatusId?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentEmployer?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto;
}

export class AppFormPersonalInfoEmploymentInsurancePeriodDto implements IAppFormPersonalInfoEmploymentInsurancePeriodDto {
    id?: string;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentPeriod?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoEmploymentInsurancePeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isCurrentPeriod = _data["isCurrentPeriod"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentInsurancePeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoEmploymentInsurancePeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isCurrentPeriod"] = this.isCurrentPeriod;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoEmploymentInsurancePeriodDto {
    id?: string;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentPeriod?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto;
}

export class AppFormPersonalInfoPreviousAddressDto implements IAppFormPersonalInfoPreviousAddressDto {
    id?: string;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousAddressUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoPreviousAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoPreviousAddressUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoPreviousAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoPreviousAddressDto {
    id?: string;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousAddressUpdatedFieldsDto;
}

export class AppFormPersonalInfoPreviousInsolvencyDto implements IAppFormPersonalInfoPreviousInsolvencyDto {
    id?: string;
    insolvencyTypeId?: string | undefined;
    applicantName?: string | undefined;
    trusteeName?: string | undefined;
    estateNumber?: string | undefined;
    bankruptcyDate?: moment.Moment | undefined;
    dischargeDate?: moment.Moment | undefined;
    proposalDate?: moment.Moment | undefined;
    proposalResultId?: string | undefined;
    filingLocation?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    bankruptcyDischargeTypeId?: string | undefined;
    proposalDischargeDate?: moment.Moment | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoPreviousInsolvencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insolvencyTypeId = _data["insolvencyTypeId"];
            this.applicantName = _data["applicantName"];
            this.trusteeName = _data["trusteeName"];
            this.estateNumber = _data["estateNumber"];
            this.bankruptcyDate = _data["bankruptcyDate"] ? moment(_data["bankruptcyDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : <any>undefined;
            this.proposalDate = _data["proposalDate"] ? moment(_data["proposalDate"].toString()) : <any>undefined;
            this.proposalResultId = _data["proposalResultId"];
            this.filingLocation = _data["filingLocation"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.bankruptcyDischargeTypeId = _data["bankruptcyDischargeTypeId"];
            this.proposalDischargeDate = _data["proposalDischargeDate"] ? moment(_data["proposalDischargeDate"].toString()) : <any>undefined;
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousInsolvencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoPreviousInsolvencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insolvencyTypeId"] = this.insolvencyTypeId;
        data["applicantName"] = this.applicantName;
        data["trusteeName"] = this.trusteeName;
        data["estateNumber"] = this.estateNumber;
        data["bankruptcyDate"] = this.bankruptcyDate ? this.bankruptcyDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["proposalDate"] = this.proposalDate ? this.proposalDate.toISOString() : <any>undefined;
        data["proposalResultId"] = this.proposalResultId;
        data["filingLocation"] = this.filingLocation;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["bankruptcyDischargeTypeId"] = this.bankruptcyDischargeTypeId;
        data["proposalDischargeDate"] = this.proposalDischargeDate ? this.proposalDischargeDate.toISOString() : <any>undefined;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormPersonalInfoPreviousInsolvencyDto {
    id?: string;
    insolvencyTypeId?: string | undefined;
    applicantName?: string | undefined;
    trusteeName?: string | undefined;
    estateNumber?: string | undefined;
    bankruptcyDate?: moment.Moment | undefined;
    dischargeDate?: moment.Moment | undefined;
    proposalDate?: moment.Moment | undefined;
    proposalResultId?: string | undefined;
    filingLocation?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    bankruptcyDischargeTypeId?: string | undefined;
    proposalDischargeDate?: moment.Moment | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto;
}

export class AppFormPersonalInfoSelfIdentificationDto implements IAppFormPersonalInfoSelfIdentificationDto {
    id?: string;
    appFormPersonalInfoId?: string;
    isForSpouse?: boolean;
    genderId?: string | undefined;
    educationLevelId?: string | undefined;
    isAboriginal?: AnswerEnum;
    isNorthAmericanIndianFirstNation?: boolean;
    isInuit?: boolean;
    isMétis?: boolean;
    hasDisability?: AnswerEnum;
    hasDisabilityCoordinationOrDexterity?: boolean;
    hasDisabilityMobility?: boolean;
    hasDisabilityBlindOrVisualImpairment?: boolean;
    hasDisabilityDeafOrHardOfHearing?: boolean;
    hasDisabilitySpeechImpairment?: boolean;
    hasDisabilityOther?: boolean;
    disabilityOtherDescription?: string | undefined;
    isMemberOfMinorityGroup?: AnswerEnum;
    isBlack?: boolean;
    isChinese?: boolean;
    isFilipino?: boolean;
    isJapanese?: boolean;
    isKorean?: boolean;
    isSouthAsianEastIndian?: boolean;
    isSoutheastAsian?: boolean;
    isNonWhiteWestAsianNorthAfricanOrArab?: boolean;
    isNonWhiteLatinAmerican?: boolean;
    isPersonOfMixedOrigin?: boolean;
    isOtherVisibleMinorityGroup?: boolean;
    otherVisibleMinorityGroupDescription?: string | undefined;
    consentDate?: moment.Moment | undefined;
    consentCity?: string | undefined;
    consentProvinceId?: string | undefined;

    constructor(data?: IAppFormPersonalInfoSelfIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appFormPersonalInfoId = _data["appFormPersonalInfoId"];
            this.isForSpouse = _data["isForSpouse"];
            this.genderId = _data["genderId"];
            this.educationLevelId = _data["educationLevelId"];
            this.isAboriginal = _data["isAboriginal"];
            this.isNorthAmericanIndianFirstNation = _data["isNorthAmericanIndianFirstNation"];
            this.isInuit = _data["isInuit"];
            this.isMétis = _data["isMétis"];
            this.hasDisability = _data["hasDisability"];
            this.hasDisabilityCoordinationOrDexterity = _data["hasDisabilityCoordinationOrDexterity"];
            this.hasDisabilityMobility = _data["hasDisabilityMobility"];
            this.hasDisabilityBlindOrVisualImpairment = _data["hasDisabilityBlindOrVisualImpairment"];
            this.hasDisabilityDeafOrHardOfHearing = _data["hasDisabilityDeafOrHardOfHearing"];
            this.hasDisabilitySpeechImpairment = _data["hasDisabilitySpeechImpairment"];
            this.hasDisabilityOther = _data["hasDisabilityOther"];
            this.disabilityOtherDescription = _data["disabilityOtherDescription"];
            this.isMemberOfMinorityGroup = _data["isMemberOfMinorityGroup"];
            this.isBlack = _data["isBlack"];
            this.isChinese = _data["isChinese"];
            this.isFilipino = _data["isFilipino"];
            this.isJapanese = _data["isJapanese"];
            this.isKorean = _data["isKorean"];
            this.isSouthAsianEastIndian = _data["isSouthAsianEastIndian"];
            this.isSoutheastAsian = _data["isSoutheastAsian"];
            this.isNonWhiteWestAsianNorthAfricanOrArab = _data["isNonWhiteWestAsianNorthAfricanOrArab"];
            this.isNonWhiteLatinAmerican = _data["isNonWhiteLatinAmerican"];
            this.isPersonOfMixedOrigin = _data["isPersonOfMixedOrigin"];
            this.isOtherVisibleMinorityGroup = _data["isOtherVisibleMinorityGroup"];
            this.otherVisibleMinorityGroupDescription = _data["otherVisibleMinorityGroupDescription"];
            this.consentDate = _data["consentDate"] ? moment(_data["consentDate"].toString()) : <any>undefined;
            this.consentCity = _data["consentCity"];
            this.consentProvinceId = _data["consentProvinceId"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoSelfIdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoSelfIdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appFormPersonalInfoId"] = this.appFormPersonalInfoId;
        data["isForSpouse"] = this.isForSpouse;
        data["genderId"] = this.genderId;
        data["educationLevelId"] = this.educationLevelId;
        data["isAboriginal"] = this.isAboriginal;
        data["isNorthAmericanIndianFirstNation"] = this.isNorthAmericanIndianFirstNation;
        data["isInuit"] = this.isInuit;
        data["isMétis"] = this.isMétis;
        data["hasDisability"] = this.hasDisability;
        data["hasDisabilityCoordinationOrDexterity"] = this.hasDisabilityCoordinationOrDexterity;
        data["hasDisabilityMobility"] = this.hasDisabilityMobility;
        data["hasDisabilityBlindOrVisualImpairment"] = this.hasDisabilityBlindOrVisualImpairment;
        data["hasDisabilityDeafOrHardOfHearing"] = this.hasDisabilityDeafOrHardOfHearing;
        data["hasDisabilitySpeechImpairment"] = this.hasDisabilitySpeechImpairment;
        data["hasDisabilityOther"] = this.hasDisabilityOther;
        data["disabilityOtherDescription"] = this.disabilityOtherDescription;
        data["isMemberOfMinorityGroup"] = this.isMemberOfMinorityGroup;
        data["isBlack"] = this.isBlack;
        data["isChinese"] = this.isChinese;
        data["isFilipino"] = this.isFilipino;
        data["isJapanese"] = this.isJapanese;
        data["isKorean"] = this.isKorean;
        data["isSouthAsianEastIndian"] = this.isSouthAsianEastIndian;
        data["isSoutheastAsian"] = this.isSoutheastAsian;
        data["isNonWhiteWestAsianNorthAfricanOrArab"] = this.isNonWhiteWestAsianNorthAfricanOrArab;
        data["isNonWhiteLatinAmerican"] = this.isNonWhiteLatinAmerican;
        data["isPersonOfMixedOrigin"] = this.isPersonOfMixedOrigin;
        data["isOtherVisibleMinorityGroup"] = this.isOtherVisibleMinorityGroup;
        data["otherVisibleMinorityGroupDescription"] = this.otherVisibleMinorityGroupDescription;
        data["consentDate"] = this.consentDate ? this.consentDate.toISOString() : <any>undefined;
        data["consentCity"] = this.consentCity;
        data["consentProvinceId"] = this.consentProvinceId;
        return data;
    }
}

export interface IAppFormPersonalInfoSelfIdentificationDto {
    id?: string;
    appFormPersonalInfoId?: string;
    isForSpouse?: boolean;
    genderId?: string | undefined;
    educationLevelId?: string | undefined;
    isAboriginal?: AnswerEnum;
    isNorthAmericanIndianFirstNation?: boolean;
    isInuit?: boolean;
    isMétis?: boolean;
    hasDisability?: AnswerEnum;
    hasDisabilityCoordinationOrDexterity?: boolean;
    hasDisabilityMobility?: boolean;
    hasDisabilityBlindOrVisualImpairment?: boolean;
    hasDisabilityDeafOrHardOfHearing?: boolean;
    hasDisabilitySpeechImpairment?: boolean;
    hasDisabilityOther?: boolean;
    disabilityOtherDescription?: string | undefined;
    isMemberOfMinorityGroup?: AnswerEnum;
    isBlack?: boolean;
    isChinese?: boolean;
    isFilipino?: boolean;
    isJapanese?: boolean;
    isKorean?: boolean;
    isSouthAsianEastIndian?: boolean;
    isSoutheastAsian?: boolean;
    isNonWhiteWestAsianNorthAfricanOrArab?: boolean;
    isNonWhiteLatinAmerican?: boolean;
    isPersonOfMixedOrigin?: boolean;
    isOtherVisibleMinorityGroup?: boolean;
    otherVisibleMinorityGroupDescription?: string | undefined;
    consentDate?: moment.Moment | undefined;
    consentCity?: string | undefined;
    consentProvinceId?: string | undefined;
}

export class AppFormQuestionnaireBusinessDto implements IAppFormQuestionnaireBusinessDto {
    id?: string;
    businessName?: string | undefined;
    businessAddress?: string | undefined;
    businessStreetNumber?: string | undefined;
    businessStreetName?: string | undefined;
    businessUnit?: string | undefined;
    businessCity?: string | undefined;
    businessPostalCode?: string | undefined;
    businessProvinceId?: string | undefined;
    businessCountryId?: string | undefined;
    businessOwnershipTypeId?: string | undefined;
    businessTypeId?: string | undefined;
    isDirector?: boolean | undefined;
    nameOfPartnersOrDirectors?: string | undefined;
    startDate?: moment.Moment | undefined;
    dateOperationsCeased?: moment.Moment | undefined;
    isCorporationBankrupt?: boolean | undefined;
    hasEmployeesOrSubContractors?: boolean | undefined;
    isOwingWagesToEmployees?: boolean | undefined;
    isOwingSourceDeductionOnWages?: boolean | undefined;
    otherDetails?: string | undefined;
    maximumNumberOfEmployeesInThePast12Months?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireBusinessUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.businessAddress = _data["businessAddress"];
            this.businessStreetNumber = _data["businessStreetNumber"];
            this.businessStreetName = _data["businessStreetName"];
            this.businessUnit = _data["businessUnit"];
            this.businessCity = _data["businessCity"];
            this.businessPostalCode = _data["businessPostalCode"];
            this.businessProvinceId = _data["businessProvinceId"];
            this.businessCountryId = _data["businessCountryId"];
            this.businessOwnershipTypeId = _data["businessOwnershipTypeId"];
            this.businessTypeId = _data["businessTypeId"];
            this.isDirector = _data["isDirector"];
            this.nameOfPartnersOrDirectors = _data["nameOfPartnersOrDirectors"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.dateOperationsCeased = _data["dateOperationsCeased"] ? moment(_data["dateOperationsCeased"].toString()) : <any>undefined;
            this.isCorporationBankrupt = _data["isCorporationBankrupt"];
            this.hasEmployeesOrSubContractors = _data["hasEmployeesOrSubContractors"];
            this.isOwingWagesToEmployees = _data["isOwingWagesToEmployees"];
            this.isOwingSourceDeductionOnWages = _data["isOwingSourceDeductionOnWages"];
            this.otherDetails = _data["otherDetails"];
            this.maximumNumberOfEmployeesInThePast12Months = _data["maximumNumberOfEmployeesInThePast12Months"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormQuestionnaireBusinessUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormQuestionnaireBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["businessAddress"] = this.businessAddress;
        data["businessStreetNumber"] = this.businessStreetNumber;
        data["businessStreetName"] = this.businessStreetName;
        data["businessUnit"] = this.businessUnit;
        data["businessCity"] = this.businessCity;
        data["businessPostalCode"] = this.businessPostalCode;
        data["businessProvinceId"] = this.businessProvinceId;
        data["businessCountryId"] = this.businessCountryId;
        data["businessOwnershipTypeId"] = this.businessOwnershipTypeId;
        data["businessTypeId"] = this.businessTypeId;
        data["isDirector"] = this.isDirector;
        data["nameOfPartnersOrDirectors"] = this.nameOfPartnersOrDirectors;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dateOperationsCeased"] = this.dateOperationsCeased ? this.dateOperationsCeased.toISOString() : <any>undefined;
        data["isCorporationBankrupt"] = this.isCorporationBankrupt;
        data["hasEmployeesOrSubContractors"] = this.hasEmployeesOrSubContractors;
        data["isOwingWagesToEmployees"] = this.isOwingWagesToEmployees;
        data["isOwingSourceDeductionOnWages"] = this.isOwingSourceDeductionOnWages;
        data["otherDetails"] = this.otherDetails;
        data["maximumNumberOfEmployeesInThePast12Months"] = this.maximumNumberOfEmployeesInThePast12Months;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormQuestionnaireBusinessDto {
    id?: string;
    businessName?: string | undefined;
    businessAddress?: string | undefined;
    businessStreetNumber?: string | undefined;
    businessStreetName?: string | undefined;
    businessUnit?: string | undefined;
    businessCity?: string | undefined;
    businessPostalCode?: string | undefined;
    businessProvinceId?: string | undefined;
    businessCountryId?: string | undefined;
    businessOwnershipTypeId?: string | undefined;
    businessTypeId?: string | undefined;
    isDirector?: boolean | undefined;
    nameOfPartnersOrDirectors?: string | undefined;
    startDate?: moment.Moment | undefined;
    dateOperationsCeased?: moment.Moment | undefined;
    isCorporationBankrupt?: boolean | undefined;
    hasEmployeesOrSubContractors?: boolean | undefined;
    isOwingWagesToEmployees?: boolean | undefined;
    isOwingSourceDeductionOnWages?: boolean | undefined;
    otherDetails?: string | undefined;
    maximumNumberOfEmployeesInThePast12Months?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireBusinessUpdatedFieldsDto;
}

export class AppFormQuestionnaireCoSignOrGuaranteedLoanDto implements IAppFormQuestionnaireCoSignOrGuaranteedLoanDto {
    id?: string;
    isBySpouse?: boolean;
    lendersName?: string | undefined;
    lendersAddress?: string | undefined;
    lendersStreetNumber?: string | undefined;
    lendersStreetName?: string | undefined;
    lendersUnit?: string | undefined;
    lendersCity?: string | undefined;
    lendersPostalCode?: string | undefined;
    lendersProvinceId?: string | undefined;
    lendersCountryId?: string | undefined;
    borrowersName?: string | undefined;
    borrowersAddress?: string | undefined;
    borrowersStreetNumber?: string | undefined;
    borrowersStreetName?: string | undefined;
    borrowersUnit?: string | undefined;
    borrowersCity?: string | undefined;
    borrowersPostalCode?: string | undefined;
    borrowersProvinceId?: string | undefined;
    borrowersCountryId?: string | undefined;
    clientUpdatedFields?: AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireCoSignOrGuaranteedLoanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBySpouse = _data["isBySpouse"];
            this.lendersName = _data["lendersName"];
            this.lendersAddress = _data["lendersAddress"];
            this.lendersStreetNumber = _data["lendersStreetNumber"];
            this.lendersStreetName = _data["lendersStreetName"];
            this.lendersUnit = _data["lendersUnit"];
            this.lendersCity = _data["lendersCity"];
            this.lendersPostalCode = _data["lendersPostalCode"];
            this.lendersProvinceId = _data["lendersProvinceId"];
            this.lendersCountryId = _data["lendersCountryId"];
            this.borrowersName = _data["borrowersName"];
            this.borrowersAddress = _data["borrowersAddress"];
            this.borrowersStreetNumber = _data["borrowersStreetNumber"];
            this.borrowersStreetName = _data["borrowersStreetName"];
            this.borrowersUnit = _data["borrowersUnit"];
            this.borrowersCity = _data["borrowersCity"];
            this.borrowersPostalCode = _data["borrowersPostalCode"];
            this.borrowersProvinceId = _data["borrowersProvinceId"];
            this.borrowersCountryId = _data["borrowersCountryId"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormQuestionnaireCoSignOrGuaranteedLoanDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireCoSignOrGuaranteedLoanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBySpouse"] = this.isBySpouse;
        data["lendersName"] = this.lendersName;
        data["lendersAddress"] = this.lendersAddress;
        data["lendersStreetNumber"] = this.lendersStreetNumber;
        data["lendersStreetName"] = this.lendersStreetName;
        data["lendersUnit"] = this.lendersUnit;
        data["lendersCity"] = this.lendersCity;
        data["lendersPostalCode"] = this.lendersPostalCode;
        data["lendersProvinceId"] = this.lendersProvinceId;
        data["lendersCountryId"] = this.lendersCountryId;
        data["borrowersName"] = this.borrowersName;
        data["borrowersAddress"] = this.borrowersAddress;
        data["borrowersStreetNumber"] = this.borrowersStreetNumber;
        data["borrowersStreetName"] = this.borrowersStreetName;
        data["borrowersUnit"] = this.borrowersUnit;
        data["borrowersCity"] = this.borrowersCity;
        data["borrowersPostalCode"] = this.borrowersPostalCode;
        data["borrowersProvinceId"] = this.borrowersProvinceId;
        data["borrowersCountryId"] = this.borrowersCountryId;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormQuestionnaireCoSignOrGuaranteedLoanDto {
    id?: string;
    isBySpouse?: boolean;
    lendersName?: string | undefined;
    lendersAddress?: string | undefined;
    lendersStreetNumber?: string | undefined;
    lendersStreetName?: string | undefined;
    lendersUnit?: string | undefined;
    lendersCity?: string | undefined;
    lendersPostalCode?: string | undefined;
    lendersProvinceId?: string | undefined;
    lendersCountryId?: string | undefined;
    borrowersName?: string | undefined;
    borrowersAddress?: string | undefined;
    borrowersStreetNumber?: string | undefined;
    borrowersStreetName?: string | undefined;
    borrowersUnit?: string | undefined;
    borrowersCity?: string | undefined;
    borrowersPostalCode?: string | undefined;
    borrowersProvinceId?: string | undefined;
    borrowersCountryId?: string | undefined;
    clientUpdatedFields?: AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto;
}

export class AppFormQuestionnaireDto implements IAppFormQuestionnaireDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    debtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isDebtFromRecognizanceOfBailBond?: boolean | undefined;
    debtFromRecognizanceOfBailBondDetails?: string | undefined;
    isDebtFromAlimony?: boolean | undefined;
    debtFromAlimonyDetails?: string | undefined;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    debtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isDebtFromFraud?: boolean | undefined;
    debtFromFraudDetails?: string | undefined;
    isDebtFromEmbezzlement?: boolean | undefined;
    debtFromEmbezzlementDetails?: string | undefined;
    isDebtFromMisappropriation?: boolean | undefined;
    debtFromMisappropriationDetails?: string | undefined;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isDebtFromStudentLoansOutstanding?: boolean | undefined;
    debtFromStudentLoansOutstandingDetails?: string | undefined;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean | undefined;
    spouseDebtFromRecognizanceOfBailBondDetails?: string | undefined;
    isSpouseDebtFromAlimony?: boolean | undefined;
    spouseDebtFromAlimonyDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isSpouseDebtFromFraud?: boolean | undefined;
    spouseDebtFromFraudDetails?: string | undefined;
    isSpouseDebtFromEmbezzlement?: boolean | undefined;
    spouseDebtFromEmbezzlementDetails?: string | undefined;
    isSpouseDebtFromMisappropriation?: boolean | undefined;
    spouseDebtFromMisappropriationDetails?: string | undefined;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isSpouseDebtFromStudentLoansOutstanding?: boolean | undefined;
    spouseDebtFromStudentLoansOutstandingDetails?: string | undefined;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    hasCoSignedOrGuaranteedLoan?: boolean | undefined;
    coSignedOrGuaranteedLoans?: AppFormQuestionnaireCoSignOrGuaranteedLoanDto[] | undefined;
    hasMadeExessPaymentsPast12Months?: boolean | undefined;
    hasMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasSpouseMadeExessPaymentsPast12Months?: boolean | undefined;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasOwnedBusinessPast5Years?: boolean | undefined;
    doesBusinessAccountForHalfOfDebt?: boolean | undefined;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean | undefined;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean | undefined;
    spouseNAICSCode?: string | undefined;
    businesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    spouseBusinesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    debtorHasAFinancialAdviceProvider?: boolean | undefined;
    debtorSpouseHasAFinancialAdviceProvider?: boolean | undefined;
    financialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    spouseFinancialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    isConsentChecked?: boolean | undefined;
    consentDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormQuestionnaireUpdatedFieldsDto;
    isDebtAreasApplicantUpdatedByClient?: boolean | undefined;
    isDebtAreasSpouseUpdatedByClient?: boolean | undefined;
    isCoSignsGuaranteedLoansUpdatedByClient?: boolean | undefined;
    isTransactionsApplicantUpdatedByClient?: boolean | undefined;
    isTransactionsSpouseUpdatedByClient?: boolean | undefined;
    isBusinessUpdatedByClient?: boolean | undefined;
    isCreditBureauConsentUpdatedByClient?: boolean | undefined;
    isAdviceReceivedApplicantUpdatedByClient?: boolean | undefined;

    constructor(data?: IAppFormQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            this.isDebtFromFineOrPenaltyImposedByCourt = _data["isDebtFromFineOrPenaltyImposedByCourt"];
            this.debtFromFineOrPenaltyImposedByCourtDetails = _data["debtFromFineOrPenaltyImposedByCourtDetails"];
            this.isDebtFromRecognizanceOfBailBond = _data["isDebtFromRecognizanceOfBailBond"];
            this.debtFromRecognizanceOfBailBondDetails = _data["debtFromRecognizanceOfBailBondDetails"];
            this.isDebtFromAlimony = _data["isDebtFromAlimony"];
            this.debtFromAlimonyDetails = _data["debtFromAlimonyDetails"];
            this.isDebtFromMaintenanceOfAffiliationOrder = _data["isDebtFromMaintenanceOfAffiliationOrder"];
            this.debtFromMaintenanceOfAffiliationOrderDetails = _data["debtFromMaintenanceOfAffiliationOrderDetails"];
            this.isDebtFromMaintenanceOfSupportOfSeparatedFamily = _data["isDebtFromMaintenanceOfSupportOfSeparatedFamily"];
            this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails = _data["debtFromMaintenanceOfSupportOfSeparatedFamilyDetails"];
            this.isDebtFromFraud = _data["isDebtFromFraud"];
            this.debtFromFraudDetails = _data["debtFromFraudDetails"];
            this.isDebtFromEmbezzlement = _data["isDebtFromEmbezzlement"];
            this.debtFromEmbezzlementDetails = _data["debtFromEmbezzlementDetails"];
            this.isDebtFromMisappropriation = _data["isDebtFromMisappropriation"];
            this.debtFromMisappropriationDetails = _data["debtFromMisappropriationDetails"];
            this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity = _data["isDebtFromDefalcationWhileActingInAFiduciaryCapacity"];
            this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails = _data["debtFromDefalcationWhileActingInAFiduciaryCapacityDetails"];
            this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud = _data["isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"];
            this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails = _data["debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"];
            this.isDebtFromStudentLoansOutstanding = _data["isDebtFromStudentLoansOutstanding"];
            this.debtFromStudentLoansOutstandingDetails = _data["debtFromStudentLoansOutstandingDetails"];
            this.debtFromStudentLoansOutstandingDateCeasedBeingStudent = _data["debtFromStudentLoansOutstandingDateCeasedBeingStudent"] ? moment(_data["debtFromStudentLoansOutstandingDateCeasedBeingStudent"].toString()) : <any>undefined;
            this.isSpouseDebtFromFineOrPenaltyImposedByCourt = _data["isSpouseDebtFromFineOrPenaltyImposedByCourt"];
            this.spouseDebtFromFineOrPenaltyImposedByCourtDetails = _data["spouseDebtFromFineOrPenaltyImposedByCourtDetails"];
            this.isSpouseDebtFromRecognizanceOfBailBond = _data["isSpouseDebtFromRecognizanceOfBailBond"];
            this.spouseDebtFromRecognizanceOfBailBondDetails = _data["spouseDebtFromRecognizanceOfBailBondDetails"];
            this.isSpouseDebtFromAlimony = _data["isSpouseDebtFromAlimony"];
            this.spouseDebtFromAlimonyDetails = _data["spouseDebtFromAlimonyDetails"];
            this.isSpouseDebtFromMaintenanceOfAffiliationOrder = _data["isSpouseDebtFromMaintenanceOfAffiliationOrder"];
            this.spouseDebtFromMaintenanceOfAffiliationOrderDetails = _data["spouseDebtFromMaintenanceOfAffiliationOrderDetails"];
            this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily = _data["isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily"];
            this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails = _data["spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails"];
            this.isSpouseDebtFromFraud = _data["isSpouseDebtFromFraud"];
            this.spouseDebtFromFraudDetails = _data["spouseDebtFromFraudDetails"];
            this.isSpouseDebtFromEmbezzlement = _data["isSpouseDebtFromEmbezzlement"];
            this.spouseDebtFromEmbezzlementDetails = _data["spouseDebtFromEmbezzlementDetails"];
            this.isSpouseDebtFromMisappropriation = _data["isSpouseDebtFromMisappropriation"];
            this.spouseDebtFromMisappropriationDetails = _data["spouseDebtFromMisappropriationDetails"];
            this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity = _data["isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity"];
            this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails = _data["spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails"];
            this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud = _data["isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"];
            this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails = _data["spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"];
            this.isSpouseDebtFromStudentLoansOutstanding = _data["isSpouseDebtFromStudentLoansOutstanding"];
            this.spouseDebtFromStudentLoansOutstandingDetails = _data["spouseDebtFromStudentLoansOutstandingDetails"];
            this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent = _data["spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent"] ? moment(_data["spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent"].toString()) : <any>undefined;
            this.hasCoSignedOrGuaranteedLoan = _data["hasCoSignedOrGuaranteedLoan"];
            if (Array.isArray(_data["coSignedOrGuaranteedLoans"])) {
                this.coSignedOrGuaranteedLoans = [] as any;
                for (let item of _data["coSignedOrGuaranteedLoans"])
                    this.coSignedOrGuaranteedLoans!.push(AppFormQuestionnaireCoSignOrGuaranteedLoanDto.fromJS(item));
            }
            this.hasMadeExessPaymentsPast12Months = _data["hasMadeExessPaymentsPast12Months"];
            this.hasMadeExessPaymentsPast12MonthsDetails = _data["hasMadeExessPaymentsPast12MonthsDetails"];
            this.hasAssetsSiezedOrGarnishedPast12Months = _data["hasAssetsSiezedOrGarnishedPast12Months"];
            this.hasAssetsSiezedOrGarnishedPast12MonthsDetail = _data["hasAssetsSiezedOrGarnishedPast12MonthsDetail"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"];
            this.hasGivenGiftsOver500WhileInsolventPast5Years = _data["hasGivenGiftsOver500WhileInsolventPast5Years"];
            this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails = _data["hasGivenGiftsOver500WhileInsolventPast5YearsDetails"];
            this.isExpectedToReceiveNonIncomeFundsNext12Months = _data["isExpectedToReceiveNonIncomeFundsNext12Months"];
            this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails = _data["isExpectedToReceiveNonIncomeFundsNext12MonthsDetails"];
            this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty = _data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"];
            this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails = _data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"];
            this.hasMadeArragementsToContinuePayingCreditors = _data["hasMadeArragementsToContinuePayingCreditors"];
            this.hasMadeArragementsToContinuePayingCreditorsDetails = _data["hasMadeArragementsToContinuePayingCreditorsDetails"];
            this.hasSpouseMadeExessPaymentsPast12Months = _data["hasSpouseMadeExessPaymentsPast12Months"];
            this.hasSpouseMadeExessPaymentsPast12MonthsDetails = _data["hasSpouseMadeExessPaymentsPast12MonthsDetails"];
            this.hasSpouseAssetsSiezedOrGarnishedPast12Months = _data["hasSpouseAssetsSiezedOrGarnishedPast12Months"];
            this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail = _data["hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"];
            this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years = _data["hasSpouseGivenGiftsOver500WhileInsolventPast5Years"];
            this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails = _data["hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails"];
            this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months = _data["isSpouseExpectedToReceiveNonIncomeFundsNext12Months"];
            this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails = _data["isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails"];
            this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty = _data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"];
            this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails = _data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"];
            this.hasSpouseMadeArragementsToContinuePayingCreditors = _data["hasSpouseMadeArragementsToContinuePayingCreditors"];
            this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails = _data["hasSpouseMadeArragementsToContinuePayingCreditorsDetails"];
            this.hasOwnedBusinessPast5Years = _data["hasOwnedBusinessPast5Years"];
            this.doesBusinessAccountForHalfOfDebt = _data["doesBusinessAccountForHalfOfDebt"];
            this.naicsCode = _data["naicsCode"];
            this.hasSpouseOwnedBusinessPast5Years = _data["hasSpouseOwnedBusinessPast5Years"];
            this.doesSpouseBusinessAccountForHalfOfDebt = _data["doesSpouseBusinessAccountForHalfOfDebt"];
            this.spouseNAICSCode = _data["spouseNAICSCode"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(AppFormQuestionnaireBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["spouseBusinesses"])) {
                this.spouseBusinesses = [] as any;
                for (let item of _data["spouseBusinesses"])
                    this.spouseBusinesses!.push(AppFormQuestionnaireBusinessDto.fromJS(item));
            }
            this.debtorHasAFinancialAdviceProvider = _data["debtorHasAFinancialAdviceProvider"];
            this.debtorSpouseHasAFinancialAdviceProvider = _data["debtorSpouseHasAFinancialAdviceProvider"];
            if (Array.isArray(_data["financialAdvices"])) {
                this.financialAdvices = [] as any;
                for (let item of _data["financialAdvices"])
                    this.financialAdvices!.push(AppFormQuestionnaireFinancialAdviceProviderDto.fromJS(item));
            }
            if (Array.isArray(_data["spouseFinancialAdvices"])) {
                this.spouseFinancialAdvices = [] as any;
                for (let item of _data["spouseFinancialAdvices"])
                    this.spouseFinancialAdvices!.push(AppFormQuestionnaireFinancialAdviceProviderDto.fromJS(item));
            }
            this.isConsentChecked = _data["isConsentChecked"];
            this.consentDate = _data["consentDate"] ? moment(_data["consentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormQuestionnaireUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
            this.isDebtAreasApplicantUpdatedByClient = _data["isDebtAreasApplicantUpdatedByClient"];
            this.isDebtAreasSpouseUpdatedByClient = _data["isDebtAreasSpouseUpdatedByClient"];
            this.isCoSignsGuaranteedLoansUpdatedByClient = _data["isCoSignsGuaranteedLoansUpdatedByClient"];
            this.isTransactionsApplicantUpdatedByClient = _data["isTransactionsApplicantUpdatedByClient"];
            this.isTransactionsSpouseUpdatedByClient = _data["isTransactionsSpouseUpdatedByClient"];
            this.isBusinessUpdatedByClient = _data["isBusinessUpdatedByClient"];
            this.isCreditBureauConsentUpdatedByClient = _data["isCreditBureauConsentUpdatedByClient"];
            this.isAdviceReceivedApplicantUpdatedByClient = _data["isAdviceReceivedApplicantUpdatedByClient"];
        }
    }

    static fromJS(data: any): AppFormQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        data["isDebtFromFineOrPenaltyImposedByCourt"] = this.isDebtFromFineOrPenaltyImposedByCourt;
        data["debtFromFineOrPenaltyImposedByCourtDetails"] = this.debtFromFineOrPenaltyImposedByCourtDetails;
        data["isDebtFromRecognizanceOfBailBond"] = this.isDebtFromRecognizanceOfBailBond;
        data["debtFromRecognizanceOfBailBondDetails"] = this.debtFromRecognizanceOfBailBondDetails;
        data["isDebtFromAlimony"] = this.isDebtFromAlimony;
        data["debtFromAlimonyDetails"] = this.debtFromAlimonyDetails;
        data["isDebtFromMaintenanceOfAffiliationOrder"] = this.isDebtFromMaintenanceOfAffiliationOrder;
        data["debtFromMaintenanceOfAffiliationOrderDetails"] = this.debtFromMaintenanceOfAffiliationOrderDetails;
        data["isDebtFromMaintenanceOfSupportOfSeparatedFamily"] = this.isDebtFromMaintenanceOfSupportOfSeparatedFamily;
        data["debtFromMaintenanceOfSupportOfSeparatedFamilyDetails"] = this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
        data["isDebtFromFraud"] = this.isDebtFromFraud;
        data["debtFromFraudDetails"] = this.debtFromFraudDetails;
        data["isDebtFromEmbezzlement"] = this.isDebtFromEmbezzlement;
        data["debtFromEmbezzlementDetails"] = this.debtFromEmbezzlementDetails;
        data["isDebtFromMisappropriation"] = this.isDebtFromMisappropriation;
        data["debtFromMisappropriationDetails"] = this.debtFromMisappropriationDetails;
        data["isDebtFromDefalcationWhileActingInAFiduciaryCapacity"] = this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity;
        data["debtFromDefalcationWhileActingInAFiduciaryCapacityDetails"] = this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
        data["isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"] = this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
        data["debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"] = this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
        data["isDebtFromStudentLoansOutstanding"] = this.isDebtFromStudentLoansOutstanding;
        data["debtFromStudentLoansOutstandingDetails"] = this.debtFromStudentLoansOutstandingDetails;
        data["debtFromStudentLoansOutstandingDateCeasedBeingStudent"] = this.debtFromStudentLoansOutstandingDateCeasedBeingStudent ? this.debtFromStudentLoansOutstandingDateCeasedBeingStudent.toISOString() : <any>undefined;
        data["isSpouseDebtFromFineOrPenaltyImposedByCourt"] = this.isSpouseDebtFromFineOrPenaltyImposedByCourt;
        data["spouseDebtFromFineOrPenaltyImposedByCourtDetails"] = this.spouseDebtFromFineOrPenaltyImposedByCourtDetails;
        data["isSpouseDebtFromRecognizanceOfBailBond"] = this.isSpouseDebtFromRecognizanceOfBailBond;
        data["spouseDebtFromRecognizanceOfBailBondDetails"] = this.spouseDebtFromRecognizanceOfBailBondDetails;
        data["isSpouseDebtFromAlimony"] = this.isSpouseDebtFromAlimony;
        data["spouseDebtFromAlimonyDetails"] = this.spouseDebtFromAlimonyDetails;
        data["isSpouseDebtFromMaintenanceOfAffiliationOrder"] = this.isSpouseDebtFromMaintenanceOfAffiliationOrder;
        data["spouseDebtFromMaintenanceOfAffiliationOrderDetails"] = this.spouseDebtFromMaintenanceOfAffiliationOrderDetails;
        data["isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily"] = this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily;
        data["spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails"] = this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
        data["isSpouseDebtFromFraud"] = this.isSpouseDebtFromFraud;
        data["spouseDebtFromFraudDetails"] = this.spouseDebtFromFraudDetails;
        data["isSpouseDebtFromEmbezzlement"] = this.isSpouseDebtFromEmbezzlement;
        data["spouseDebtFromEmbezzlementDetails"] = this.spouseDebtFromEmbezzlementDetails;
        data["isSpouseDebtFromMisappropriation"] = this.isSpouseDebtFromMisappropriation;
        data["spouseDebtFromMisappropriationDetails"] = this.spouseDebtFromMisappropriationDetails;
        data["isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity"] = this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity;
        data["spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails"] = this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
        data["isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"] = this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
        data["spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"] = this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
        data["isSpouseDebtFromStudentLoansOutstanding"] = this.isSpouseDebtFromStudentLoansOutstanding;
        data["spouseDebtFromStudentLoansOutstandingDetails"] = this.spouseDebtFromStudentLoansOutstandingDetails;
        data["spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent"] = this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent ? this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent.toISOString() : <any>undefined;
        data["hasCoSignedOrGuaranteedLoan"] = this.hasCoSignedOrGuaranteedLoan;
        if (Array.isArray(this.coSignedOrGuaranteedLoans)) {
            data["coSignedOrGuaranteedLoans"] = [];
            for (let item of this.coSignedOrGuaranteedLoans)
                data["coSignedOrGuaranteedLoans"].push(item.toJSON());
        }
        data["hasMadeExessPaymentsPast12Months"] = this.hasMadeExessPaymentsPast12Months;
        data["hasMadeExessPaymentsPast12MonthsDetails"] = this.hasMadeExessPaymentsPast12MonthsDetails;
        data["hasAssetsSiezedOrGarnishedPast12Months"] = this.hasAssetsSiezedOrGarnishedPast12Months;
        data["hasAssetsSiezedOrGarnishedPast12MonthsDetail"] = this.hasAssetsSiezedOrGarnishedPast12MonthsDetail;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
        data["hasGivenGiftsOver500WhileInsolventPast5Years"] = this.hasGivenGiftsOver500WhileInsolventPast5Years;
        data["hasGivenGiftsOver500WhileInsolventPast5YearsDetails"] = this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails;
        data["isExpectedToReceiveNonIncomeFundsNext12Months"] = this.isExpectedToReceiveNonIncomeFundsNext12Months;
        data["isExpectedToReceiveNonIncomeFundsNext12MonthsDetails"] = this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
        data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"] = this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
        data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"] = this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
        data["hasMadeArragementsToContinuePayingCreditors"] = this.hasMadeArragementsToContinuePayingCreditors;
        data["hasMadeArragementsToContinuePayingCreditorsDetails"] = this.hasMadeArragementsToContinuePayingCreditorsDetails;
        data["hasSpouseMadeExessPaymentsPast12Months"] = this.hasSpouseMadeExessPaymentsPast12Months;
        data["hasSpouseMadeExessPaymentsPast12MonthsDetails"] = this.hasSpouseMadeExessPaymentsPast12MonthsDetails;
        data["hasSpouseAssetsSiezedOrGarnishedPast12Months"] = this.hasSpouseAssetsSiezedOrGarnishedPast12Months;
        data["hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail"] = this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
        data["hasSpouseGivenGiftsOver500WhileInsolventPast5Years"] = this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years;
        data["hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails"] = this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails;
        data["isSpouseExpectedToReceiveNonIncomeFundsNext12Months"] = this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months;
        data["isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails"] = this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
        data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"] = this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
        data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"] = this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
        data["hasSpouseMadeArragementsToContinuePayingCreditors"] = this.hasSpouseMadeArragementsToContinuePayingCreditors;
        data["hasSpouseMadeArragementsToContinuePayingCreditorsDetails"] = this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails;
        data["hasOwnedBusinessPast5Years"] = this.hasOwnedBusinessPast5Years;
        data["doesBusinessAccountForHalfOfDebt"] = this.doesBusinessAccountForHalfOfDebt;
        data["naicsCode"] = this.naicsCode;
        data["hasSpouseOwnedBusinessPast5Years"] = this.hasSpouseOwnedBusinessPast5Years;
        data["doesSpouseBusinessAccountForHalfOfDebt"] = this.doesSpouseBusinessAccountForHalfOfDebt;
        data["spouseNAICSCode"] = this.spouseNAICSCode;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.spouseBusinesses)) {
            data["spouseBusinesses"] = [];
            for (let item of this.spouseBusinesses)
                data["spouseBusinesses"].push(item.toJSON());
        }
        data["debtorHasAFinancialAdviceProvider"] = this.debtorHasAFinancialAdviceProvider;
        data["debtorSpouseHasAFinancialAdviceProvider"] = this.debtorSpouseHasAFinancialAdviceProvider;
        if (Array.isArray(this.financialAdvices)) {
            data["financialAdvices"] = [];
            for (let item of this.financialAdvices)
                data["financialAdvices"].push(item.toJSON());
        }
        if (Array.isArray(this.spouseFinancialAdvices)) {
            data["spouseFinancialAdvices"] = [];
            for (let item of this.spouseFinancialAdvices)
                data["spouseFinancialAdvices"].push(item.toJSON());
        }
        data["isConsentChecked"] = this.isConsentChecked;
        data["consentDate"] = this.consentDate ? this.consentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        data["isDebtAreasApplicantUpdatedByClient"] = this.isDebtAreasApplicantUpdatedByClient;
        data["isDebtAreasSpouseUpdatedByClient"] = this.isDebtAreasSpouseUpdatedByClient;
        data["isCoSignsGuaranteedLoansUpdatedByClient"] = this.isCoSignsGuaranteedLoansUpdatedByClient;
        data["isTransactionsApplicantUpdatedByClient"] = this.isTransactionsApplicantUpdatedByClient;
        data["isTransactionsSpouseUpdatedByClient"] = this.isTransactionsSpouseUpdatedByClient;
        data["isBusinessUpdatedByClient"] = this.isBusinessUpdatedByClient;
        data["isCreditBureauConsentUpdatedByClient"] = this.isCreditBureauConsentUpdatedByClient;
        data["isAdviceReceivedApplicantUpdatedByClient"] = this.isAdviceReceivedApplicantUpdatedByClient;
        return data;
    }
}

export interface IAppFormQuestionnaireDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    debtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isDebtFromRecognizanceOfBailBond?: boolean | undefined;
    debtFromRecognizanceOfBailBondDetails?: string | undefined;
    isDebtFromAlimony?: boolean | undefined;
    debtFromAlimonyDetails?: string | undefined;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    debtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isDebtFromFraud?: boolean | undefined;
    debtFromFraudDetails?: string | undefined;
    isDebtFromEmbezzlement?: boolean | undefined;
    debtFromEmbezzlementDetails?: string | undefined;
    isDebtFromMisappropriation?: boolean | undefined;
    debtFromMisappropriationDetails?: string | undefined;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isDebtFromStudentLoansOutstanding?: boolean | undefined;
    debtFromStudentLoansOutstandingDetails?: string | undefined;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean | undefined;
    spouseDebtFromRecognizanceOfBailBondDetails?: string | undefined;
    isSpouseDebtFromAlimony?: boolean | undefined;
    spouseDebtFromAlimonyDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isSpouseDebtFromFraud?: boolean | undefined;
    spouseDebtFromFraudDetails?: string | undefined;
    isSpouseDebtFromEmbezzlement?: boolean | undefined;
    spouseDebtFromEmbezzlementDetails?: string | undefined;
    isSpouseDebtFromMisappropriation?: boolean | undefined;
    spouseDebtFromMisappropriationDetails?: string | undefined;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isSpouseDebtFromStudentLoansOutstanding?: boolean | undefined;
    spouseDebtFromStudentLoansOutstandingDetails?: string | undefined;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    hasCoSignedOrGuaranteedLoan?: boolean | undefined;
    coSignedOrGuaranteedLoans?: AppFormQuestionnaireCoSignOrGuaranteedLoanDto[] | undefined;
    hasMadeExessPaymentsPast12Months?: boolean | undefined;
    hasMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasSpouseMadeExessPaymentsPast12Months?: boolean | undefined;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasOwnedBusinessPast5Years?: boolean | undefined;
    doesBusinessAccountForHalfOfDebt?: boolean | undefined;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean | undefined;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean | undefined;
    spouseNAICSCode?: string | undefined;
    businesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    spouseBusinesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    debtorHasAFinancialAdviceProvider?: boolean | undefined;
    debtorSpouseHasAFinancialAdviceProvider?: boolean | undefined;
    financialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    spouseFinancialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    isConsentChecked?: boolean | undefined;
    consentDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormQuestionnaireUpdatedFieldsDto;
    isDebtAreasApplicantUpdatedByClient?: boolean | undefined;
    isDebtAreasSpouseUpdatedByClient?: boolean | undefined;
    isCoSignsGuaranteedLoansUpdatedByClient?: boolean | undefined;
    isTransactionsApplicantUpdatedByClient?: boolean | undefined;
    isTransactionsSpouseUpdatedByClient?: boolean | undefined;
    isBusinessUpdatedByClient?: boolean | undefined;
    isCreditBureauConsentUpdatedByClient?: boolean | undefined;
    isAdviceReceivedApplicantUpdatedByClient?: boolean | undefined;
}

export class AppFormQuestionnaireFinancialAdviceProviderDto implements IAppFormQuestionnaireFinancialAdviceProviderDto {
    id?: string;
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    firmStreetNumber?: string | undefined;
    firmStreetName?: string | undefined;
    firmCity?: string | undefined;
    firmPostalCode?: string | undefined;
    firmProvinceId?: string | undefined;
    firmCountryId?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireFinancialAdviceProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSpouse = _data["isSpouse"];
            this.surname = _data["surname"];
            this.givenName = _data["givenName"];
            this.firmName = _data["firmName"];
            this.firmAddress = _data["firmAddress"];
            this.addressUnit = _data["addressUnit"];
            this.firmStreetNumber = _data["firmStreetNumber"];
            this.firmStreetName = _data["firmStreetName"];
            this.firmCity = _data["firmCity"];
            this.firmPostalCode = _data["firmPostalCode"];
            this.firmProvinceId = _data["firmProvinceId"];
            this.firmCountryId = _data["firmCountryId"];
            this.totalAmountPaidToDate = _data["totalAmountPaidToDate"];
            this.totalRemainingAmountToBePaid = _data["totalRemainingAmountToBePaid"];
            this.clientUpdatedFields = _data["clientUpdatedFields"] ? AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto.fromJS(_data["clientUpdatedFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppFormQuestionnaireFinancialAdviceProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireFinancialAdviceProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSpouse"] = this.isSpouse;
        data["surname"] = this.surname;
        data["givenName"] = this.givenName;
        data["firmName"] = this.firmName;
        data["firmAddress"] = this.firmAddress;
        data["addressUnit"] = this.addressUnit;
        data["firmStreetNumber"] = this.firmStreetNumber;
        data["firmStreetName"] = this.firmStreetName;
        data["firmCity"] = this.firmCity;
        data["firmPostalCode"] = this.firmPostalCode;
        data["firmProvinceId"] = this.firmProvinceId;
        data["firmCountryId"] = this.firmCountryId;
        data["totalAmountPaidToDate"] = this.totalAmountPaidToDate;
        data["totalRemainingAmountToBePaid"] = this.totalRemainingAmountToBePaid;
        data["clientUpdatedFields"] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppFormQuestionnaireFinancialAdviceProviderDto {
    id?: string;
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    firmStreetNumber?: string | undefined;
    firmStreetName?: string | undefined;
    firmCity?: string | undefined;
    firmPostalCode?: string | undefined;
    firmProvinceId?: string | undefined;
    firmCountryId?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto;
}

export class AppFormSectionStatusDto implements IAppFormSectionStatusDto {
    status?: AppFormStatusEnum;

    constructor(data?: IAppFormSectionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AppFormSectionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormSectionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IAppFormSectionStatusDto {
    status?: AppFormStatusEnum;
}

export class AppFormStatusDto implements IAppFormStatusDto {
    personalInfoStatus?: AppFormStatusEnum;
    assetsDebtsStatus?: AppFormStatusEnum;
    incomeExpenseStatus?: AppFormStatusEnum;
    incomeTaxStatus?: AppFormStatusEnum;
    bankingInformationStatus?: AppFormStatusEnum;
    questionnaireStatus?: AppFormStatusEnum;
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;

    constructor(data?: IAppFormStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalInfoStatus = _data["personalInfoStatus"];
            this.assetsDebtsStatus = _data["assetsDebtsStatus"];
            this.incomeExpenseStatus = _data["incomeExpenseStatus"];
            this.incomeTaxStatus = _data["incomeTaxStatus"];
            this.bankingInformationStatus = _data["bankingInformationStatus"];
            this.questionnaireStatus = _data["questionnaireStatus"];
            this.supportingDocumentStatus = _data["supportingDocumentStatus"];
            this.numberOfRequiredSupportingDocuments = _data["numberOfRequiredSupportingDocuments"];
            this.numberOfUploadedSupportingDocuments = _data["numberOfUploadedSupportingDocuments"];
        }
    }

    static fromJS(data: any): AppFormStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalInfoStatus"] = this.personalInfoStatus;
        data["assetsDebtsStatus"] = this.assetsDebtsStatus;
        data["incomeExpenseStatus"] = this.incomeExpenseStatus;
        data["incomeTaxStatus"] = this.incomeTaxStatus;
        data["bankingInformationStatus"] = this.bankingInformationStatus;
        data["questionnaireStatus"] = this.questionnaireStatus;
        data["supportingDocumentStatus"] = this.supportingDocumentStatus;
        data["numberOfRequiredSupportingDocuments"] = this.numberOfRequiredSupportingDocuments;
        data["numberOfUploadedSupportingDocuments"] = this.numberOfUploadedSupportingDocuments;
        return data;
    }
}

export interface IAppFormStatusDto {
    personalInfoStatus?: AppFormStatusEnum;
    assetsDebtsStatus?: AppFormStatusEnum;
    incomeExpenseStatus?: AppFormStatusEnum;
    incomeTaxStatus?: AppFormStatusEnum;
    bankingInformationStatus?: AppFormStatusEnum;
    questionnaireStatus?: AppFormStatusEnum;
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;
}

export class AppFormAssetsDebtsAssetUpdatedFieldsDto implements IAppFormAssetsDebtsAssetUpdatedFieldsDto {
    assetType?: boolean;
    assetDescription?: boolean;
    assetDescriptionName?: boolean;
    assetTypeId?: boolean;
    assetDescriptionId?: boolean;
    specifiedDescription?: boolean;
    value?: boolean;
    ownershipTypeId?: boolean;
    comments?: boolean;
    isExempt?: boolean;
    basisOfValue?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    applicantOwnershipPercentage?: boolean;
    spouseOwnershipPercentage?: boolean;
    otherOwnershipPercentage?: boolean;
    totalNumberOfOwners?: boolean;
    isOwnershipHeldInJointTenancy?: boolean;
    isPrincipalResidence?: boolean;
    nameOfInstitution?: boolean;
    policyNumber?: boolean;
    contributionsInLast12Months?: boolean;
    grantToBeRepaid?: boolean;
    estimatedTaxOnDisposition?: boolean;
    debtorsOwnershipInterest?: boolean;
    year?: boolean;
    make?: boolean;
    model?: boolean;
    trim?: boolean;
    style?: boolean;
    kilometers?: boolean;
    vin?: boolean;
    isVehicleNeededForEmployment?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.assetDescription = _data["assetDescription"];
            this.assetDescriptionName = _data["assetDescriptionName"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetDescriptionId = _data["assetDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.value = _data["value"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.comments = _data["comments"];
            this.isExempt = _data["isExempt"];
            this.basisOfValue = _data["basisOfValue"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.applicantOwnershipPercentage = _data["applicantOwnershipPercentage"];
            this.spouseOwnershipPercentage = _data["spouseOwnershipPercentage"];
            this.otherOwnershipPercentage = _data["otherOwnershipPercentage"];
            this.totalNumberOfOwners = _data["totalNumberOfOwners"];
            this.isOwnershipHeldInJointTenancy = _data["isOwnershipHeldInJointTenancy"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.nameOfInstitution = _data["nameOfInstitution"];
            this.policyNumber = _data["policyNumber"];
            this.contributionsInLast12Months = _data["contributionsInLast12Months"];
            this.grantToBeRepaid = _data["grantToBeRepaid"];
            this.estimatedTaxOnDisposition = _data["estimatedTaxOnDisposition"];
            this.debtorsOwnershipInterest = _data["debtorsOwnershipInterest"];
            this.year = _data["year"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.trim = _data["trim"];
            this.style = _data["style"];
            this.kilometers = _data["kilometers"];
            this.vin = _data["vin"];
            this.isVehicleNeededForEmployment = _data["isVehicleNeededForEmployment"];
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsAssetUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["assetDescription"] = this.assetDescription;
        data["assetDescriptionName"] = this.assetDescriptionName;
        data["assetTypeId"] = this.assetTypeId;
        data["assetDescriptionId"] = this.assetDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["value"] = this.value;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["comments"] = this.comments;
        data["isExempt"] = this.isExempt;
        data["basisOfValue"] = this.basisOfValue;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["applicantOwnershipPercentage"] = this.applicantOwnershipPercentage;
        data["spouseOwnershipPercentage"] = this.spouseOwnershipPercentage;
        data["otherOwnershipPercentage"] = this.otherOwnershipPercentage;
        data["totalNumberOfOwners"] = this.totalNumberOfOwners;
        data["isOwnershipHeldInJointTenancy"] = this.isOwnershipHeldInJointTenancy;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["nameOfInstitution"] = this.nameOfInstitution;
        data["policyNumber"] = this.policyNumber;
        data["contributionsInLast12Months"] = this.contributionsInLast12Months;
        data["grantToBeRepaid"] = this.grantToBeRepaid;
        data["estimatedTaxOnDisposition"] = this.estimatedTaxOnDisposition;
        data["debtorsOwnershipInterest"] = this.debtorsOwnershipInterest;
        data["year"] = this.year;
        data["make"] = this.make;
        data["model"] = this.model;
        data["trim"] = this.trim;
        data["style"] = this.style;
        data["kilometers"] = this.kilometers;
        data["vin"] = this.vin;
        data["isVehicleNeededForEmployment"] = this.isVehicleNeededForEmployment;
        return data;
    }
}

export interface IAppFormAssetsDebtsAssetUpdatedFieldsDto {
    assetType?: boolean;
    assetDescription?: boolean;
    assetDescriptionName?: boolean;
    assetTypeId?: boolean;
    assetDescriptionId?: boolean;
    specifiedDescription?: boolean;
    value?: boolean;
    ownershipTypeId?: boolean;
    comments?: boolean;
    isExempt?: boolean;
    basisOfValue?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    applicantOwnershipPercentage?: boolean;
    spouseOwnershipPercentage?: boolean;
    otherOwnershipPercentage?: boolean;
    totalNumberOfOwners?: boolean;
    isOwnershipHeldInJointTenancy?: boolean;
    isPrincipalResidence?: boolean;
    nameOfInstitution?: boolean;
    policyNumber?: boolean;
    contributionsInLast12Months?: boolean;
    grantToBeRepaid?: boolean;
    estimatedTaxOnDisposition?: boolean;
    debtorsOwnershipInterest?: boolean;
    year?: boolean;
    make?: boolean;
    model?: boolean;
    trim?: boolean;
    style?: boolean;
    kilometers?: boolean;
    vin?: boolean;
    isVehicleNeededForEmployment?: boolean;
}

export class AppFormAssetsDebtsDebtUpdatedFieldsDto implements IAppFormAssetsDebtsDebtUpdatedFieldsDto {
    debtDescriptionId?: boolean;
    specifiedDescription?: boolean;
    creditorName?: boolean;
    amount?: boolean;
    ownershipTypeId?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isBusinessDebt?: boolean;
    creditorAddress?: boolean;
    creditorStreetNumber?: boolean;
    creditorStreetName?: boolean;
    creditorUnit?: boolean;
    creditorCity?: boolean;
    creditorPostalCode?: boolean;
    creditorProvinceCode?: boolean;
    creditorCountryCode?: boolean;
    creditorEmailAddress?: boolean;

    constructor(data?: IAppFormAssetsDebtsDebtUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.debtDescriptionId = _data["debtDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.creditorName = _data["creditorName"];
            this.amount = _data["amount"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.accountNumber = _data["accountNumber"];
            this.comments = _data["comments"];
            this.isBusinessDebt = _data["isBusinessDebt"];
            this.creditorAddress = _data["creditorAddress"];
            this.creditorStreetNumber = _data["creditorStreetNumber"];
            this.creditorStreetName = _data["creditorStreetName"];
            this.creditorUnit = _data["creditorUnit"];
            this.creditorCity = _data["creditorCity"];
            this.creditorPostalCode = _data["creditorPostalCode"];
            this.creditorProvinceCode = _data["creditorProvinceCode"];
            this.creditorCountryCode = _data["creditorCountryCode"];
            this.creditorEmailAddress = _data["creditorEmailAddress"];
        }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormAssetsDebtsDebtUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["debtDescriptionId"] = this.debtDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["creditorName"] = this.creditorName;
        data["amount"] = this.amount;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["accountNumber"] = this.accountNumber;
        data["comments"] = this.comments;
        data["isBusinessDebt"] = this.isBusinessDebt;
        data["creditorAddress"] = this.creditorAddress;
        data["creditorStreetNumber"] = this.creditorStreetNumber;
        data["creditorStreetName"] = this.creditorStreetName;
        data["creditorUnit"] = this.creditorUnit;
        data["creditorCity"] = this.creditorCity;
        data["creditorPostalCode"] = this.creditorPostalCode;
        data["creditorProvinceCode"] = this.creditorProvinceCode;
        data["creditorCountryCode"] = this.creditorCountryCode;
        data["creditorEmailAddress"] = this.creditorEmailAddress;
        return data;
    }
}

export interface IAppFormAssetsDebtsDebtUpdatedFieldsDto {
    debtDescriptionId?: boolean;
    specifiedDescription?: boolean;
    creditorName?: boolean;
    amount?: boolean;
    ownershipTypeId?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isBusinessDebt?: boolean;
    creditorAddress?: boolean;
    creditorStreetNumber?: boolean;
    creditorStreetName?: boolean;
    creditorUnit?: boolean;
    creditorCity?: boolean;
    creditorPostalCode?: boolean;
    creditorProvinceCode?: boolean;
    creditorCountryCode?: boolean;
    creditorEmailAddress?: boolean;
}

export class AppFormBankingInfoDetailUpdatedFieldsDto implements IAppFormBankingInfoDetailUpdatedFieldsDto {
    institution?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isOverdraftOwed?: boolean;
    isJointAccount?: boolean;

    constructor(data?: IAppFormBankingInfoDetailUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.institution = _data["institution"];
            this.accountNumber = _data["accountNumber"];
            this.comments = _data["comments"];
            this.isOverdraftOwed = _data["isOverdraftOwed"];
            this.isJointAccount = _data["isJointAccount"];
        }
    }

    static fromJS(data: any): AppFormBankingInfoDetailUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormBankingInfoDetailUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institution"] = this.institution;
        data["accountNumber"] = this.accountNumber;
        data["comments"] = this.comments;
        data["isOverdraftOwed"] = this.isOverdraftOwed;
        data["isJointAccount"] = this.isJointAccount;
        return data;
    }
}

export interface IAppFormBankingInfoDetailUpdatedFieldsDto {
    institution?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isOverdraftOwed?: boolean;
    isJointAccount?: boolean;
}

export class AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto implements IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto {
    isInitial?: boolean;
    expenseTypeId?: boolean;
    expenseDescriptionId?: boolean;
    specifiedDescription?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInitial = _data["isInitial"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseDescriptionId = _data["expenseDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInitial"] = this.isInitial;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseDescriptionId"] = this.expenseDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        return data;
    }
}

export interface IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto {
    isInitial?: boolean;
    expenseTypeId?: boolean;
    expenseDescriptionId?: boolean;
    specifiedDescription?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;
}

export class AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto implements IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto {
    isInitial?: boolean;
    incomeTypeId?: boolean;
    description?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInitial = _data["isInitial"];
            this.incomeTypeId = _data["incomeTypeId"];
            this.description = _data["description"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
        }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInitial"] = this.isInitial;
        data["incomeTypeId"] = this.incomeTypeId;
        data["description"] = this.description;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        return data;
    }
}

export interface IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto {
    isInitial?: boolean;
    incomeTypeId?: boolean;
    description?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;
}

export class AppFormIncomeTaxUpdatedFieldsDto implements IAppFormIncomeTaxUpdatedFieldsDto {
    isMarried?: boolean;
    yearLastReturnFiled?: boolean;
    refundAmount?: boolean;
    amountOwing?: boolean;
    spouseYearLastReturnFiled?: boolean;
    spouseRefundAmount?: boolean;
    spouseAmountOwing?: boolean;

    constructor(data?: IAppFormIncomeTaxUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMarried = _data["isMarried"];
            this.yearLastReturnFiled = _data["yearLastReturnFiled"];
            this.refundAmount = _data["refundAmount"];
            this.amountOwing = _data["amountOwing"];
            this.spouseYearLastReturnFiled = _data["spouseYearLastReturnFiled"];
            this.spouseRefundAmount = _data["spouseRefundAmount"];
            this.spouseAmountOwing = _data["spouseAmountOwing"];
        }
    }

    static fromJS(data: any): AppFormIncomeTaxUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormIncomeTaxUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMarried"] = this.isMarried;
        data["yearLastReturnFiled"] = this.yearLastReturnFiled;
        data["refundAmount"] = this.refundAmount;
        data["amountOwing"] = this.amountOwing;
        data["spouseYearLastReturnFiled"] = this.spouseYearLastReturnFiled;
        data["spouseRefundAmount"] = this.spouseRefundAmount;
        data["spouseAmountOwing"] = this.spouseAmountOwing;
        return data;
    }
}

export interface IAppFormIncomeTaxUpdatedFieldsDto {
    isMarried?: boolean;
    yearLastReturnFiled?: boolean;
    refundAmount?: boolean;
    amountOwing?: boolean;
    spouseYearLastReturnFiled?: boolean;
    spouseRefundAmount?: boolean;
    spouseAmountOwing?: boolean;
}

export class AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto implements IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto {
    phoneTypeId?: boolean;
    phoneNumber?: boolean;

    constructor(data?: IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneTypeId = _data["phoneTypeId"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneTypeId"] = this.phoneTypeId;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto {
    phoneTypeId?: boolean;
    phoneNumber?: boolean;
}

export class AppFormPersonalInfoDependantUpdatedFieldsDto implements IAppFormPersonalInfoDependantUpdatedFieldsDto {
    firstName?: boolean;
    lastName?: boolean;
    relationshipTypeId?: boolean;
    birthDate?: boolean;

    constructor(data?: IAppFormPersonalInfoDependantUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relationshipTypeId = _data["relationshipTypeId"];
            this.birthDate = _data["birthDate"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoDependantUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoDependantUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relationshipTypeId"] = this.relationshipTypeId;
        data["birthDate"] = this.birthDate;
        return data;
    }
}

export interface IAppFormPersonalInfoDependantUpdatedFieldsDto {
    firstName?: boolean;
    lastName?: boolean;
    relationshipTypeId?: boolean;
    birthDate?: boolean;
}

export class AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto implements IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto {
    employerName?: boolean;
    employerAddress?: boolean;
    employerStreetNumber?: boolean;
    employerStreetName?: boolean;
    employerUnit?: boolean;
    employerCity?: boolean;
    employerPostalCode?: boolean;
    employerProvinceId?: boolean;
    employerCountryId?: boolean;
    employmentStatusId?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    isCurrentEmployer?: boolean;

    constructor(data?: IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerName = _data["employerName"];
            this.employerAddress = _data["employerAddress"];
            this.employerStreetNumber = _data["employerStreetNumber"];
            this.employerStreetName = _data["employerStreetName"];
            this.employerUnit = _data["employerUnit"];
            this.employerCity = _data["employerCity"];
            this.employerPostalCode = _data["employerPostalCode"];
            this.employerProvinceId = _data["employerProvinceId"];
            this.employerCountryId = _data["employerCountryId"];
            this.employmentStatusId = _data["employmentStatusId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isCurrentEmployer = _data["isCurrentEmployer"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerName"] = this.employerName;
        data["employerAddress"] = this.employerAddress;
        data["employerStreetNumber"] = this.employerStreetNumber;
        data["employerStreetName"] = this.employerStreetName;
        data["employerUnit"] = this.employerUnit;
        data["employerCity"] = this.employerCity;
        data["employerPostalCode"] = this.employerPostalCode;
        data["employerProvinceId"] = this.employerProvinceId;
        data["employerCountryId"] = this.employerCountryId;
        data["employmentStatusId"] = this.employmentStatusId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isCurrentEmployer"] = this.isCurrentEmployer;
        return data;
    }
}

export interface IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto {
    employerName?: boolean;
    employerAddress?: boolean;
    employerStreetNumber?: boolean;
    employerStreetName?: boolean;
    employerUnit?: boolean;
    employerCity?: boolean;
    employerPostalCode?: boolean;
    employerProvinceId?: boolean;
    employerCountryId?: boolean;
    employmentStatusId?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    isCurrentEmployer?: boolean;
}

export class AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto implements IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto {
    startDate?: boolean;
    endDate?: boolean;
    isCurrentPeriod?: boolean;

    constructor(data?: IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isCurrentPeriod = _data["isCurrentPeriod"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isCurrentPeriod"] = this.isCurrentPeriod;
        return data;
    }
}

export interface IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto {
    startDate?: boolean;
    endDate?: boolean;
    isCurrentPeriod?: boolean;
}

export class AppFormPersonalInfoPreviousAddressUpdatedFieldsDto implements IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto {
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;

    constructor(data?: IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousAddressUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoPreviousAddressUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto {
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
}

export class AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto implements IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto {
    insolvencyTypeId?: boolean;
    applicantName?: boolean;
    trusteeName?: boolean;
    estateNumber?: boolean;
    bankruptcyDate?: boolean;
    dischargeDate?: boolean;
    proposalDate?: boolean;
    proposalResultId?: boolean;
    filingLocation?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;

    constructor(data?: IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insolvencyTypeId = _data["insolvencyTypeId"];
            this.applicantName = _data["applicantName"];
            this.trusteeName = _data["trusteeName"];
            this.estateNumber = _data["estateNumber"];
            this.bankruptcyDate = _data["bankruptcyDate"];
            this.dischargeDate = _data["dischargeDate"];
            this.proposalDate = _data["proposalDate"];
            this.proposalResultId = _data["proposalResultId"];
            this.filingLocation = _data["filingLocation"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insolvencyTypeId"] = this.insolvencyTypeId;
        data["applicantName"] = this.applicantName;
        data["trusteeName"] = this.trusteeName;
        data["estateNumber"] = this.estateNumber;
        data["bankruptcyDate"] = this.bankruptcyDate;
        data["dischargeDate"] = this.dischargeDate;
        data["proposalDate"] = this.proposalDate;
        data["proposalResultId"] = this.proposalResultId;
        data["filingLocation"] = this.filingLocation;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto {
    insolvencyTypeId?: boolean;
    applicantName?: boolean;
    trusteeName?: boolean;
    estateNumber?: boolean;
    bankruptcyDate?: boolean;
    dischargeDate?: boolean;
    proposalDate?: boolean;
    proposalResultId?: boolean;
    filingLocation?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
}

export class AppFormPersonalInfoUpdatedFieldsDto implements IAppFormPersonalInfoUpdatedFieldsDto {
    firstName?: boolean;
    middleName?: boolean;
    lastName?: boolean;
    akaFirstName?: boolean;
    akaMiddleName?: boolean;
    akaLastName?: boolean;
    birthDate?: boolean;
    sin?: boolean;
    maritalStatusId?: boolean;
    marriageDate?: boolean;
    educationLevelId?: boolean;
    spouseFirstName?: boolean;
    spouseMiddleName?: boolean;
    spouseLastName?: boolean;
    spouseAkaFirstName?: boolean;
    spouseAkaMiddleName?: boolean;
    spouseAkaLastName?: boolean;
    spouseBirthDate?: boolean;
    spouseSIN?: boolean;
    spouseEducationLevelId?: boolean;
    isJointFile?: boolean;
    additionalNotes?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    residenceDate?: boolean;
    mainPhoneTypeId?: boolean;
    mainPhoneNumber?: boolean;
    emailAddress?: boolean;
    isSpouseAddressSame?: boolean;
    spouseAddress?: boolean;
    spouseStreetNumber?: boolean;
    spouseStreetName?: boolean;
    spouseUnit?: boolean;
    spouseCity?: boolean;
    spousePostalCode?: boolean;
    spouseProvinceId?: boolean;
    spouseCountryId?: boolean;
    spouseResidenceDate?: boolean;
    spouseMainPhoneTypeId?: boolean;
    spouseMainPhoneNumber?: boolean;
    spouseEmailAddress?: boolean;
    isEmployedPastTwoYears?: boolean;
    isReceivedEmploymentInsurancePastTwoYears?: boolean;
    isSpouseEmployedPastTwoYears?: boolean;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean;
    hasFDReasonOverExtensionOfCredit?: boolean;
    hasFDReasonInconsistentEmployment?: boolean;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMismanagementOfFinances?: boolean;
    hasFDReasonReductionInIncome?: boolean;
    hasFDReasonJobLoss?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonMedicalRelatedIssue?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonInsolvencyOfCoSignor?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: boolean;
    reasonForNeedingFinancialHelp?: boolean;
    numberOfPersonsInHousehold?: boolean;
    hasDependants?: boolean;
    hasPreviousInsolvency?: boolean;
    hasSpousePreviousInsolvency?: boolean;

    constructor(data?: IAppFormPersonalInfoUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.akaFirstName = _data["akaFirstName"];
            this.akaMiddleName = _data["akaMiddleName"];
            this.akaLastName = _data["akaLastName"];
            this.birthDate = _data["birthDate"];
            this.sin = _data["sin"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.marriageDate = _data["marriageDate"];
            this.educationLevelId = _data["educationLevelId"];
            this.spouseFirstName = _data["spouseFirstName"];
            this.spouseMiddleName = _data["spouseMiddleName"];
            this.spouseLastName = _data["spouseLastName"];
            this.spouseAkaFirstName = _data["spouseAkaFirstName"];
            this.spouseAkaMiddleName = _data["spouseAkaMiddleName"];
            this.spouseAkaLastName = _data["spouseAkaLastName"];
            this.spouseBirthDate = _data["spouseBirthDate"];
            this.spouseSIN = _data["spouseSIN"];
            this.spouseEducationLevelId = _data["spouseEducationLevelId"];
            this.isJointFile = _data["isJointFile"];
            this.additionalNotes = _data["additionalNotes"];
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceCode = _data["provinceCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.residenceDate = _data["residenceDate"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.isSpouseAddressSame = _data["isSpouseAddressSame"];
            this.spouseAddress = _data["spouseAddress"];
            this.spouseStreetNumber = _data["spouseStreetNumber"];
            this.spouseStreetName = _data["spouseStreetName"];
            this.spouseUnit = _data["spouseUnit"];
            this.spouseCity = _data["spouseCity"];
            this.spousePostalCode = _data["spousePostalCode"];
            this.spouseProvinceId = _data["spouseProvinceId"];
            this.spouseCountryId = _data["spouseCountryId"];
            this.spouseResidenceDate = _data["spouseResidenceDate"];
            this.spouseMainPhoneTypeId = _data["spouseMainPhoneTypeId"];
            this.spouseMainPhoneNumber = _data["spouseMainPhoneNumber"];
            this.spouseEmailAddress = _data["spouseEmailAddress"];
            this.isEmployedPastTwoYears = _data["isEmployedPastTwoYears"];
            this.isReceivedEmploymentInsurancePastTwoYears = _data["isReceivedEmploymentInsurancePastTwoYears"];
            this.isSpouseEmployedPastTwoYears = _data["isSpouseEmployedPastTwoYears"];
            this.isSpouseReceivedEmploymentInsurancePastTwoYears = _data["isSpouseReceivedEmploymentInsurancePastTwoYears"];
            this.hasFDReasonOverExtensionOfCredit = _data["hasFDReasonOverExtensionOfCredit"];
            this.hasFDReasonInconsistentEmployment = _data["hasFDReasonInconsistentEmployment"];
            this.hasFDReasonBusinessFailure = _data["hasFDReasonBusinessFailure"];
            this.hasFDReasonMismanagementOfFinances = _data["hasFDReasonMismanagementOfFinances"];
            this.hasFDReasonReductionInIncome = _data["hasFDReasonReductionInIncome"];
            this.hasFDReasonJobLoss = _data["hasFDReasonJobLoss"];
            this.hasFDReasonMaritalSeparationOrRelationshipBreakdown = _data["hasFDReasonMaritalSeparationOrRelationshipBreakdown"];
            this.hasFDReasonMedicalRelatedIssue = _data["hasFDReasonMedicalRelatedIssue"];
            this.hasFDReasonGambling = _data["hasFDReasonGambling"];
            this.hasFDReasonInsolvencyOfCoSignor = _data["hasFDReasonInsolvencyOfCoSignor"];
            this.hasFDReasonLitigationIssues = _data["hasFDReasonLitigationIssues"];
            this.hasFDReasonDrugAlcoholAddicition = _data["hasFDReasonDrugAlcoholAddicition"];
            this.hasFDReasonOther = _data["hasFDReasonOther"];
            this.specifiedFDReason = _data["specifiedFDReason"];
            this.reasonForNeedingFinancialHelp = _data["reasonForNeedingFinancialHelp"];
            this.numberOfPersonsInHousehold = _data["numberOfPersonsInHousehold"];
            this.hasDependants = _data["hasDependants"];
            this.hasPreviousInsolvency = _data["hasPreviousInsolvency"];
            this.hasSpousePreviousInsolvency = _data["hasSpousePreviousInsolvency"];
        }
    }

    static fromJS(data: any): AppFormPersonalInfoUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormPersonalInfoUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["akaFirstName"] = this.akaFirstName;
        data["akaMiddleName"] = this.akaMiddleName;
        data["akaLastName"] = this.akaLastName;
        data["birthDate"] = this.birthDate;
        data["sin"] = this.sin;
        data["maritalStatusId"] = this.maritalStatusId;
        data["marriageDate"] = this.marriageDate;
        data["educationLevelId"] = this.educationLevelId;
        data["spouseFirstName"] = this.spouseFirstName;
        data["spouseMiddleName"] = this.spouseMiddleName;
        data["spouseLastName"] = this.spouseLastName;
        data["spouseAkaFirstName"] = this.spouseAkaFirstName;
        data["spouseAkaMiddleName"] = this.spouseAkaMiddleName;
        data["spouseAkaLastName"] = this.spouseAkaLastName;
        data["spouseBirthDate"] = this.spouseBirthDate;
        data["spouseSIN"] = this.spouseSIN;
        data["spouseEducationLevelId"] = this.spouseEducationLevelId;
        data["isJointFile"] = this.isJointFile;
        data["additionalNotes"] = this.additionalNotes;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceCode"] = this.provinceCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["residenceDate"] = this.residenceDate;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["isSpouseAddressSame"] = this.isSpouseAddressSame;
        data["spouseAddress"] = this.spouseAddress;
        data["spouseStreetNumber"] = this.spouseStreetNumber;
        data["spouseStreetName"] = this.spouseStreetName;
        data["spouseUnit"] = this.spouseUnit;
        data["spouseCity"] = this.spouseCity;
        data["spousePostalCode"] = this.spousePostalCode;
        data["spouseProvinceId"] = this.spouseProvinceId;
        data["spouseCountryId"] = this.spouseCountryId;
        data["spouseResidenceDate"] = this.spouseResidenceDate;
        data["spouseMainPhoneTypeId"] = this.spouseMainPhoneTypeId;
        data["spouseMainPhoneNumber"] = this.spouseMainPhoneNumber;
        data["spouseEmailAddress"] = this.spouseEmailAddress;
        data["isEmployedPastTwoYears"] = this.isEmployedPastTwoYears;
        data["isReceivedEmploymentInsurancePastTwoYears"] = this.isReceivedEmploymentInsurancePastTwoYears;
        data["isSpouseEmployedPastTwoYears"] = this.isSpouseEmployedPastTwoYears;
        data["isSpouseReceivedEmploymentInsurancePastTwoYears"] = this.isSpouseReceivedEmploymentInsurancePastTwoYears;
        data["hasFDReasonOverExtensionOfCredit"] = this.hasFDReasonOverExtensionOfCredit;
        data["hasFDReasonInconsistentEmployment"] = this.hasFDReasonInconsistentEmployment;
        data["hasFDReasonBusinessFailure"] = this.hasFDReasonBusinessFailure;
        data["hasFDReasonMismanagementOfFinances"] = this.hasFDReasonMismanagementOfFinances;
        data["hasFDReasonReductionInIncome"] = this.hasFDReasonReductionInIncome;
        data["hasFDReasonJobLoss"] = this.hasFDReasonJobLoss;
        data["hasFDReasonMaritalSeparationOrRelationshipBreakdown"] = this.hasFDReasonMaritalSeparationOrRelationshipBreakdown;
        data["hasFDReasonMedicalRelatedIssue"] = this.hasFDReasonMedicalRelatedIssue;
        data["hasFDReasonGambling"] = this.hasFDReasonGambling;
        data["hasFDReasonInsolvencyOfCoSignor"] = this.hasFDReasonInsolvencyOfCoSignor;
        data["hasFDReasonLitigationIssues"] = this.hasFDReasonLitigationIssues;
        data["hasFDReasonDrugAlcoholAddicition"] = this.hasFDReasonDrugAlcoholAddicition;
        data["hasFDReasonOther"] = this.hasFDReasonOther;
        data["specifiedFDReason"] = this.specifiedFDReason;
        data["reasonForNeedingFinancialHelp"] = this.reasonForNeedingFinancialHelp;
        data["numberOfPersonsInHousehold"] = this.numberOfPersonsInHousehold;
        data["hasDependants"] = this.hasDependants;
        data["hasPreviousInsolvency"] = this.hasPreviousInsolvency;
        data["hasSpousePreviousInsolvency"] = this.hasSpousePreviousInsolvency;
        return data;
    }
}

export interface IAppFormPersonalInfoUpdatedFieldsDto {
    firstName?: boolean;
    middleName?: boolean;
    lastName?: boolean;
    akaFirstName?: boolean;
    akaMiddleName?: boolean;
    akaLastName?: boolean;
    birthDate?: boolean;
    sin?: boolean;
    maritalStatusId?: boolean;
    marriageDate?: boolean;
    educationLevelId?: boolean;
    spouseFirstName?: boolean;
    spouseMiddleName?: boolean;
    spouseLastName?: boolean;
    spouseAkaFirstName?: boolean;
    spouseAkaMiddleName?: boolean;
    spouseAkaLastName?: boolean;
    spouseBirthDate?: boolean;
    spouseSIN?: boolean;
    spouseEducationLevelId?: boolean;
    isJointFile?: boolean;
    additionalNotes?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    residenceDate?: boolean;
    mainPhoneTypeId?: boolean;
    mainPhoneNumber?: boolean;
    emailAddress?: boolean;
    isSpouseAddressSame?: boolean;
    spouseAddress?: boolean;
    spouseStreetNumber?: boolean;
    spouseStreetName?: boolean;
    spouseUnit?: boolean;
    spouseCity?: boolean;
    spousePostalCode?: boolean;
    spouseProvinceId?: boolean;
    spouseCountryId?: boolean;
    spouseResidenceDate?: boolean;
    spouseMainPhoneTypeId?: boolean;
    spouseMainPhoneNumber?: boolean;
    spouseEmailAddress?: boolean;
    isEmployedPastTwoYears?: boolean;
    isReceivedEmploymentInsurancePastTwoYears?: boolean;
    isSpouseEmployedPastTwoYears?: boolean;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean;
    hasFDReasonOverExtensionOfCredit?: boolean;
    hasFDReasonInconsistentEmployment?: boolean;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMismanagementOfFinances?: boolean;
    hasFDReasonReductionInIncome?: boolean;
    hasFDReasonJobLoss?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonMedicalRelatedIssue?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonInsolvencyOfCoSignor?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: boolean;
    reasonForNeedingFinancialHelp?: boolean;
    numberOfPersonsInHousehold?: boolean;
    hasDependants?: boolean;
    hasPreviousInsolvency?: boolean;
    hasSpousePreviousInsolvency?: boolean;
}

export class AppFormQuestionnaireBusinessUpdatedFieldsDto implements IAppFormQuestionnaireBusinessUpdatedFieldsDto {
    businessName?: boolean;
    businessAddress?: boolean;
    businessStreetNumber?: boolean;
    businessStreetName?: boolean;
    businessUnit?: boolean;
    businessCity?: boolean;
    businessPostalCode?: boolean;
    businessProvinceId?: boolean;
    businessCountryId?: boolean;
    businessOwnershipTypeId?: boolean;
    businessTypeId?: boolean;
    isDirector?: boolean;
    nameOfPartnersOrDirectors?: boolean;
    startDate?: boolean;
    dateOperationsCeased?: boolean;
    isCorporationBankrupt?: boolean;
    hasEmployeesOrSubContractors?: boolean;
    isOwingWagesToEmployees?: boolean;
    isOwingSourceDeductionOnWages?: boolean;
    otherDetails?: boolean;

    constructor(data?: IAppFormQuestionnaireBusinessUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.businessAddress = _data["businessAddress"];
            this.businessStreetNumber = _data["businessStreetNumber"];
            this.businessStreetName = _data["businessStreetName"];
            this.businessUnit = _data["businessUnit"];
            this.businessCity = _data["businessCity"];
            this.businessPostalCode = _data["businessPostalCode"];
            this.businessProvinceId = _data["businessProvinceId"];
            this.businessCountryId = _data["businessCountryId"];
            this.businessOwnershipTypeId = _data["businessOwnershipTypeId"];
            this.businessTypeId = _data["businessTypeId"];
            this.isDirector = _data["isDirector"];
            this.nameOfPartnersOrDirectors = _data["nameOfPartnersOrDirectors"];
            this.startDate = _data["startDate"];
            this.dateOperationsCeased = _data["dateOperationsCeased"];
            this.isCorporationBankrupt = _data["isCorporationBankrupt"];
            this.hasEmployeesOrSubContractors = _data["hasEmployeesOrSubContractors"];
            this.isOwingWagesToEmployees = _data["isOwingWagesToEmployees"];
            this.isOwingSourceDeductionOnWages = _data["isOwingSourceDeductionOnWages"];
            this.otherDetails = _data["otherDetails"];
        }
    }

    static fromJS(data: any): AppFormQuestionnaireBusinessUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireBusinessUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["businessAddress"] = this.businessAddress;
        data["businessStreetNumber"] = this.businessStreetNumber;
        data["businessStreetName"] = this.businessStreetName;
        data["businessUnit"] = this.businessUnit;
        data["businessCity"] = this.businessCity;
        data["businessPostalCode"] = this.businessPostalCode;
        data["businessProvinceId"] = this.businessProvinceId;
        data["businessCountryId"] = this.businessCountryId;
        data["businessOwnershipTypeId"] = this.businessOwnershipTypeId;
        data["businessTypeId"] = this.businessTypeId;
        data["isDirector"] = this.isDirector;
        data["nameOfPartnersOrDirectors"] = this.nameOfPartnersOrDirectors;
        data["startDate"] = this.startDate;
        data["dateOperationsCeased"] = this.dateOperationsCeased;
        data["isCorporationBankrupt"] = this.isCorporationBankrupt;
        data["hasEmployeesOrSubContractors"] = this.hasEmployeesOrSubContractors;
        data["isOwingWagesToEmployees"] = this.isOwingWagesToEmployees;
        data["isOwingSourceDeductionOnWages"] = this.isOwingSourceDeductionOnWages;
        data["otherDetails"] = this.otherDetails;
        return data;
    }
}

export interface IAppFormQuestionnaireBusinessUpdatedFieldsDto {
    businessName?: boolean;
    businessAddress?: boolean;
    businessStreetNumber?: boolean;
    businessStreetName?: boolean;
    businessUnit?: boolean;
    businessCity?: boolean;
    businessPostalCode?: boolean;
    businessProvinceId?: boolean;
    businessCountryId?: boolean;
    businessOwnershipTypeId?: boolean;
    businessTypeId?: boolean;
    isDirector?: boolean;
    nameOfPartnersOrDirectors?: boolean;
    startDate?: boolean;
    dateOperationsCeased?: boolean;
    isCorporationBankrupt?: boolean;
    hasEmployeesOrSubContractors?: boolean;
    isOwingWagesToEmployees?: boolean;
    isOwingSourceDeductionOnWages?: boolean;
    otherDetails?: boolean;
}

export class AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto implements IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto {
    isBySpouse?: boolean;
    lendersName?: boolean;
    lendersAddress?: boolean;
    lendersStreetNumber?: boolean;
    lendersStreetName?: boolean;
    lendersUnit?: boolean;
    lendersCity?: boolean;
    lendersPostalCode?: boolean;
    lendersProvinceId?: boolean;
    lendersCountryId?: boolean;
    borrowersName?: boolean;
    borrowersAddress?: boolean;
    borrowersStreetNumber?: boolean;
    borrowersStreetName?: boolean;
    borrowersUnit?: boolean;
    borrowersCity?: boolean;
    borrowersPostalCode?: boolean;
    borrowersProvinceId?: boolean;
    borrowersCountryId?: boolean;

    constructor(data?: IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBySpouse = _data["isBySpouse"];
            this.lendersName = _data["lendersName"];
            this.lendersAddress = _data["lendersAddress"];
            this.lendersStreetNumber = _data["lendersStreetNumber"];
            this.lendersStreetName = _data["lendersStreetName"];
            this.lendersUnit = _data["lendersUnit"];
            this.lendersCity = _data["lendersCity"];
            this.lendersPostalCode = _data["lendersPostalCode"];
            this.lendersProvinceId = _data["lendersProvinceId"];
            this.lendersCountryId = _data["lendersCountryId"];
            this.borrowersName = _data["borrowersName"];
            this.borrowersAddress = _data["borrowersAddress"];
            this.borrowersStreetNumber = _data["borrowersStreetNumber"];
            this.borrowersStreetName = _data["borrowersStreetName"];
            this.borrowersUnit = _data["borrowersUnit"];
            this.borrowersCity = _data["borrowersCity"];
            this.borrowersPostalCode = _data["borrowersPostalCode"];
            this.borrowersProvinceId = _data["borrowersProvinceId"];
            this.borrowersCountryId = _data["borrowersCountryId"];
        }
    }

    static fromJS(data: any): AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBySpouse"] = this.isBySpouse;
        data["lendersName"] = this.lendersName;
        data["lendersAddress"] = this.lendersAddress;
        data["lendersStreetNumber"] = this.lendersStreetNumber;
        data["lendersStreetName"] = this.lendersStreetName;
        data["lendersUnit"] = this.lendersUnit;
        data["lendersCity"] = this.lendersCity;
        data["lendersPostalCode"] = this.lendersPostalCode;
        data["lendersProvinceId"] = this.lendersProvinceId;
        data["lendersCountryId"] = this.lendersCountryId;
        data["borrowersName"] = this.borrowersName;
        data["borrowersAddress"] = this.borrowersAddress;
        data["borrowersStreetNumber"] = this.borrowersStreetNumber;
        data["borrowersStreetName"] = this.borrowersStreetName;
        data["borrowersUnit"] = this.borrowersUnit;
        data["borrowersCity"] = this.borrowersCity;
        data["borrowersPostalCode"] = this.borrowersPostalCode;
        data["borrowersProvinceId"] = this.borrowersProvinceId;
        data["borrowersCountryId"] = this.borrowersCountryId;
        return data;
    }
}

export interface IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto {
    isBySpouse?: boolean;
    lendersName?: boolean;
    lendersAddress?: boolean;
    lendersStreetNumber?: boolean;
    lendersStreetName?: boolean;
    lendersUnit?: boolean;
    lendersCity?: boolean;
    lendersPostalCode?: boolean;
    lendersProvinceId?: boolean;
    lendersCountryId?: boolean;
    borrowersName?: boolean;
    borrowersAddress?: boolean;
    borrowersStreetNumber?: boolean;
    borrowersStreetName?: boolean;
    borrowersUnit?: boolean;
    borrowersCity?: boolean;
    borrowersPostalCode?: boolean;
    borrowersProvinceId?: boolean;
    borrowersCountryId?: boolean;
}

export class AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto implements IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto {
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;

    constructor(data?: IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSpouse = _data["isSpouse"];
            this.surname = _data["surname"];
            this.givenName = _data["givenName"];
            this.firmName = _data["firmName"];
            this.firmAddress = _data["firmAddress"];
            this.addressUnit = _data["addressUnit"];
            this.totalAmountPaidToDate = _data["totalAmountPaidToDate"];
            this.totalRemainingAmountToBePaid = _data["totalRemainingAmountToBePaid"];
        }
    }

    static fromJS(data: any): AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSpouse"] = this.isSpouse;
        data["surname"] = this.surname;
        data["givenName"] = this.givenName;
        data["firmName"] = this.firmName;
        data["firmAddress"] = this.firmAddress;
        data["addressUnit"] = this.addressUnit;
        data["totalAmountPaidToDate"] = this.totalAmountPaidToDate;
        data["totalRemainingAmountToBePaid"] = this.totalRemainingAmountToBePaid;
        return data;
    }
}

export interface IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto {
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
}

export class AppFormQuestionnaireUpdatedFieldsDto implements IAppFormQuestionnaireUpdatedFieldsDto {
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean;
    debtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isDebtFromRecognizanceOfBailBond?: boolean;
    debtFromRecognizanceOfBailBondDetails?: boolean;
    isDebtFromAlimony?: boolean;
    debtFromAlimonyDetails?: boolean;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean;
    debtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isDebtFromFraud?: boolean;
    debtFromFraudDetails?: boolean;
    isDebtFromEmbezzlement?: boolean;
    debtFromEmbezzlementDetails?: boolean;
    isDebtFromMisappropriation?: boolean;
    debtFromMisappropriationDetails?: boolean;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isDebtFromStudentLoansOutstanding?: boolean;
    debtFromStudentLoansOutstandingDetails?: boolean;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean;
    spouseDebtFromRecognizanceOfBailBondDetails?: boolean;
    isSpouseDebtFromAlimony?: boolean;
    spouseDebtFromAlimonyDetails?: boolean;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isSpouseDebtFromFraud?: boolean;
    spouseDebtFromFraudDetails?: boolean;
    isSpouseDebtFromEmbezzlement?: boolean;
    spouseDebtFromEmbezzlementDetails?: boolean;
    isSpouseDebtFromMisappropriation?: boolean;
    spouseDebtFromMisappropriationDetails?: boolean;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isSpouseDebtFromStudentLoansOutstanding?: boolean;
    spouseDebtFromStudentLoansOutstandingDetails?: boolean;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    hasCoSignedOrGuaranteedLoan?: boolean;
    hasMadeExessPaymentsPast12Months?: boolean;
    hasMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasMadeArragementsToContinuePayingCreditors?: boolean;
    hasMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails?: boolean;
    hasSpouseMadeExessPaymentsPast12Months?: boolean;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasOwnedBusinessPast5Years?: boolean;
    doesBusinessAccountForHalfOfDebt?: boolean;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean;
    spouseNAICSCode?: string | undefined;
    isConsentChecked?: boolean;
    consentDate?: boolean;

    constructor(data?: IAppFormQuestionnaireUpdatedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMarried = _data["isMarried"];
            this.isDebtFromFineOrPenaltyImposedByCourt = _data["isDebtFromFineOrPenaltyImposedByCourt"];
            this.debtFromFineOrPenaltyImposedByCourtDetails = _data["debtFromFineOrPenaltyImposedByCourtDetails"];
            this.isDebtFromRecognizanceOfBailBond = _data["isDebtFromRecognizanceOfBailBond"];
            this.debtFromRecognizanceOfBailBondDetails = _data["debtFromRecognizanceOfBailBondDetails"];
            this.isDebtFromAlimony = _data["isDebtFromAlimony"];
            this.debtFromAlimonyDetails = _data["debtFromAlimonyDetails"];
            this.isDebtFromMaintenanceOfAffiliationOrder = _data["isDebtFromMaintenanceOfAffiliationOrder"];
            this.debtFromMaintenanceOfAffiliationOrderDetails = _data["debtFromMaintenanceOfAffiliationOrderDetails"];
            this.isDebtFromMaintenanceOfSupportOfSeparatedFamily = _data["isDebtFromMaintenanceOfSupportOfSeparatedFamily"];
            this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails = _data["debtFromMaintenanceOfSupportOfSeparatedFamilyDetails"];
            this.isDebtFromFraud = _data["isDebtFromFraud"];
            this.debtFromFraudDetails = _data["debtFromFraudDetails"];
            this.isDebtFromEmbezzlement = _data["isDebtFromEmbezzlement"];
            this.debtFromEmbezzlementDetails = _data["debtFromEmbezzlementDetails"];
            this.isDebtFromMisappropriation = _data["isDebtFromMisappropriation"];
            this.debtFromMisappropriationDetails = _data["debtFromMisappropriationDetails"];
            this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity = _data["isDebtFromDefalcationWhileActingInAFiduciaryCapacity"];
            this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails = _data["debtFromDefalcationWhileActingInAFiduciaryCapacityDetails"];
            this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud = _data["isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"];
            this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails = _data["debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"];
            this.isDebtFromStudentLoansOutstanding = _data["isDebtFromStudentLoansOutstanding"];
            this.debtFromStudentLoansOutstandingDetails = _data["debtFromStudentLoansOutstandingDetails"];
            this.debtFromStudentLoansOutstandingDateCeasedBeingStudent = _data["debtFromStudentLoansOutstandingDateCeasedBeingStudent"];
            this.isSpouseDebtFromFineOrPenaltyImposedByCourt = _data["isSpouseDebtFromFineOrPenaltyImposedByCourt"];
            this.spouseDebtFromFineOrPenaltyImposedByCourtDetails = _data["spouseDebtFromFineOrPenaltyImposedByCourtDetails"];
            this.isSpouseDebtFromRecognizanceOfBailBond = _data["isSpouseDebtFromRecognizanceOfBailBond"];
            this.spouseDebtFromRecognizanceOfBailBondDetails = _data["spouseDebtFromRecognizanceOfBailBondDetails"];
            this.isSpouseDebtFromAlimony = _data["isSpouseDebtFromAlimony"];
            this.spouseDebtFromAlimonyDetails = _data["spouseDebtFromAlimonyDetails"];
            this.isSpouseDebtFromMaintenanceOfAffiliationOrder = _data["isSpouseDebtFromMaintenanceOfAffiliationOrder"];
            this.spouseDebtFromMaintenanceOfAffiliationOrderDetails = _data["spouseDebtFromMaintenanceOfAffiliationOrderDetails"];
            this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily = _data["isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily"];
            this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails = _data["spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails"];
            this.isSpouseDebtFromFraud = _data["isSpouseDebtFromFraud"];
            this.spouseDebtFromFraudDetails = _data["spouseDebtFromFraudDetails"];
            this.isSpouseDebtFromEmbezzlement = _data["isSpouseDebtFromEmbezzlement"];
            this.spouseDebtFromEmbezzlementDetails = _data["spouseDebtFromEmbezzlementDetails"];
            this.isSpouseDebtFromMisappropriation = _data["isSpouseDebtFromMisappropriation"];
            this.spouseDebtFromMisappropriationDetails = _data["spouseDebtFromMisappropriationDetails"];
            this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity = _data["isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity"];
            this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails = _data["spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails"];
            this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud = _data["isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"];
            this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails = _data["spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"];
            this.isSpouseDebtFromStudentLoansOutstanding = _data["isSpouseDebtFromStudentLoansOutstanding"];
            this.spouseDebtFromStudentLoansOutstandingDetails = _data["spouseDebtFromStudentLoansOutstandingDetails"];
            this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent = _data["spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent"];
            this.hasCoSignedOrGuaranteedLoan = _data["hasCoSignedOrGuaranteedLoan"];
            this.hasMadeExessPaymentsPast12Months = _data["hasMadeExessPaymentsPast12Months"];
            this.hasMadeExessPaymentsPast12MonthsDetails = _data["hasMadeExessPaymentsPast12MonthsDetails"];
            this.hasAssetsSiezedOrGarnishedPast12Months = _data["hasAssetsSiezedOrGarnishedPast12Months"];
            this.hasAssetsSiezedOrGarnishedPast12MonthsDetail = _data["hasAssetsSiezedOrGarnishedPast12MonthsDetail"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"];
            this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime = _data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"];
            this.hasGivenGiftsOver500WhileInsolventPast5Years = _data["hasGivenGiftsOver500WhileInsolventPast5Years"];
            this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails = _data["hasGivenGiftsOver500WhileInsolventPast5YearsDetails"];
            this.isExpectedToReceiveNonIncomeFundsNext12Months = _data["isExpectedToReceiveNonIncomeFundsNext12Months"];
            this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails = _data["isExpectedToReceiveNonIncomeFundsNext12MonthsDetails"];
            this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty = _data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"];
            this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails = _data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"];
            this.hasMadeArragementsToContinuePayingCreditors = _data["hasMadeArragementsToContinuePayingCreditors"];
            this.hasMadeArragementsToContinuePayingCreditorsDetails = _data["hasMadeArragementsToContinuePayingCreditorsDetails"];
            this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months = _data["hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months"];
            this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails = _data["hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails"];
            this.hasSpouseMadeExessPaymentsPast12Months = _data["hasSpouseMadeExessPaymentsPast12Months"];
            this.hasSpouseMadeExessPaymentsPast12MonthsDetails = _data["hasSpouseMadeExessPaymentsPast12MonthsDetails"];
            this.hasSpouseAssetsSiezedOrGarnishedPast12Months = _data["hasSpouseAssetsSiezedOrGarnishedPast12Months"];
            this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail = _data["hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"];
            this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime = _data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"];
            this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years = _data["hasSpouseGivenGiftsOver500WhileInsolventPast5Years"];
            this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails = _data["hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails"];
            this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months = _data["isSpouseExpectedToReceiveNonIncomeFundsNext12Months"];
            this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails = _data["isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails"];
            this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty = _data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"];
            this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails = _data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"];
            this.hasSpouseMadeArragementsToContinuePayingCreditors = _data["hasSpouseMadeArragementsToContinuePayingCreditors"];
            this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails = _data["hasSpouseMadeArragementsToContinuePayingCreditorsDetails"];
            this.hasOwnedBusinessPast5Years = _data["hasOwnedBusinessPast5Years"];
            this.doesBusinessAccountForHalfOfDebt = _data["doesBusinessAccountForHalfOfDebt"];
            this.naicsCode = _data["naicsCode"];
            this.hasSpouseOwnedBusinessPast5Years = _data["hasSpouseOwnedBusinessPast5Years"];
            this.doesSpouseBusinessAccountForHalfOfDebt = _data["doesSpouseBusinessAccountForHalfOfDebt"];
            this.spouseNAICSCode = _data["spouseNAICSCode"];
            this.isConsentChecked = _data["isConsentChecked"];
            this.consentDate = _data["consentDate"];
        }
    }

    static fromJS(data: any): AppFormQuestionnaireUpdatedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppFormQuestionnaireUpdatedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMarried"] = this.isMarried;
        data["isDebtFromFineOrPenaltyImposedByCourt"] = this.isDebtFromFineOrPenaltyImposedByCourt;
        data["debtFromFineOrPenaltyImposedByCourtDetails"] = this.debtFromFineOrPenaltyImposedByCourtDetails;
        data["isDebtFromRecognizanceOfBailBond"] = this.isDebtFromRecognizanceOfBailBond;
        data["debtFromRecognizanceOfBailBondDetails"] = this.debtFromRecognizanceOfBailBondDetails;
        data["isDebtFromAlimony"] = this.isDebtFromAlimony;
        data["debtFromAlimonyDetails"] = this.debtFromAlimonyDetails;
        data["isDebtFromMaintenanceOfAffiliationOrder"] = this.isDebtFromMaintenanceOfAffiliationOrder;
        data["debtFromMaintenanceOfAffiliationOrderDetails"] = this.debtFromMaintenanceOfAffiliationOrderDetails;
        data["isDebtFromMaintenanceOfSupportOfSeparatedFamily"] = this.isDebtFromMaintenanceOfSupportOfSeparatedFamily;
        data["debtFromMaintenanceOfSupportOfSeparatedFamilyDetails"] = this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
        data["isDebtFromFraud"] = this.isDebtFromFraud;
        data["debtFromFraudDetails"] = this.debtFromFraudDetails;
        data["isDebtFromEmbezzlement"] = this.isDebtFromEmbezzlement;
        data["debtFromEmbezzlementDetails"] = this.debtFromEmbezzlementDetails;
        data["isDebtFromMisappropriation"] = this.isDebtFromMisappropriation;
        data["debtFromMisappropriationDetails"] = this.debtFromMisappropriationDetails;
        data["isDebtFromDefalcationWhileActingInAFiduciaryCapacity"] = this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity;
        data["debtFromDefalcationWhileActingInAFiduciaryCapacityDetails"] = this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
        data["isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"] = this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
        data["debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"] = this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
        data["isDebtFromStudentLoansOutstanding"] = this.isDebtFromStudentLoansOutstanding;
        data["debtFromStudentLoansOutstandingDetails"] = this.debtFromStudentLoansOutstandingDetails;
        data["debtFromStudentLoansOutstandingDateCeasedBeingStudent"] = this.debtFromStudentLoansOutstandingDateCeasedBeingStudent;
        data["isSpouseDebtFromFineOrPenaltyImposedByCourt"] = this.isSpouseDebtFromFineOrPenaltyImposedByCourt;
        data["spouseDebtFromFineOrPenaltyImposedByCourtDetails"] = this.spouseDebtFromFineOrPenaltyImposedByCourtDetails;
        data["isSpouseDebtFromRecognizanceOfBailBond"] = this.isSpouseDebtFromRecognizanceOfBailBond;
        data["spouseDebtFromRecognizanceOfBailBondDetails"] = this.spouseDebtFromRecognizanceOfBailBondDetails;
        data["isSpouseDebtFromAlimony"] = this.isSpouseDebtFromAlimony;
        data["spouseDebtFromAlimonyDetails"] = this.spouseDebtFromAlimonyDetails;
        data["isSpouseDebtFromMaintenanceOfAffiliationOrder"] = this.isSpouseDebtFromMaintenanceOfAffiliationOrder;
        data["spouseDebtFromMaintenanceOfAffiliationOrderDetails"] = this.spouseDebtFromMaintenanceOfAffiliationOrderDetails;
        data["isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily"] = this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily;
        data["spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails"] = this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
        data["isSpouseDebtFromFraud"] = this.isSpouseDebtFromFraud;
        data["spouseDebtFromFraudDetails"] = this.spouseDebtFromFraudDetails;
        data["isSpouseDebtFromEmbezzlement"] = this.isSpouseDebtFromEmbezzlement;
        data["spouseDebtFromEmbezzlementDetails"] = this.spouseDebtFromEmbezzlementDetails;
        data["isSpouseDebtFromMisappropriation"] = this.isSpouseDebtFromMisappropriation;
        data["spouseDebtFromMisappropriationDetails"] = this.spouseDebtFromMisappropriationDetails;
        data["isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity"] = this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity;
        data["spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails"] = this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
        data["isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud"] = this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
        data["spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails"] = this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
        data["isSpouseDebtFromStudentLoansOutstanding"] = this.isSpouseDebtFromStudentLoansOutstanding;
        data["spouseDebtFromStudentLoansOutstandingDetails"] = this.spouseDebtFromStudentLoansOutstandingDetails;
        data["spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent"] = this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent;
        data["hasCoSignedOrGuaranteedLoan"] = this.hasCoSignedOrGuaranteedLoan;
        data["hasMadeExessPaymentsPast12Months"] = this.hasMadeExessPaymentsPast12Months;
        data["hasMadeExessPaymentsPast12MonthsDetails"] = this.hasMadeExessPaymentsPast12MonthsDetails;
        data["hasAssetsSiezedOrGarnishedPast12Months"] = this.hasAssetsSiezedOrGarnishedPast12Months;
        data["hasAssetsSiezedOrGarnishedPast12MonthsDetail"] = this.hasAssetsSiezedOrGarnishedPast12MonthsDetail;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
        data["hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"] = this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
        data["hasGivenGiftsOver500WhileInsolventPast5Years"] = this.hasGivenGiftsOver500WhileInsolventPast5Years;
        data["hasGivenGiftsOver500WhileInsolventPast5YearsDetails"] = this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails;
        data["isExpectedToReceiveNonIncomeFundsNext12Months"] = this.isExpectedToReceiveNonIncomeFundsNext12Months;
        data["isExpectedToReceiveNonIncomeFundsNext12MonthsDetails"] = this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
        data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"] = this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
        data["hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"] = this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
        data["hasMadeArragementsToContinuePayingCreditors"] = this.hasMadeArragementsToContinuePayingCreditors;
        data["hasMadeArragementsToContinuePayingCreditorsDetails"] = this.hasMadeArragementsToContinuePayingCreditorsDetails;
        data["hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months"] = this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months;
        data["hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails"] = this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails;
        data["hasSpouseMadeExessPaymentsPast12Months"] = this.hasSpouseMadeExessPaymentsPast12Months;
        data["hasSpouseMadeExessPaymentsPast12MonthsDetails"] = this.hasSpouseMadeExessPaymentsPast12MonthsDetails;
        data["hasSpouseAssetsSiezedOrGarnishedPast12Months"] = this.hasSpouseAssetsSiezedOrGarnishedPast12Months;
        data["hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail"] = this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
        data["hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime"] = this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
        data["hasSpouseGivenGiftsOver500WhileInsolventPast5Years"] = this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years;
        data["hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails"] = this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails;
        data["isSpouseExpectedToReceiveNonIncomeFundsNext12Months"] = this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months;
        data["isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails"] = this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
        data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty"] = this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
        data["hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails"] = this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
        data["hasSpouseMadeArragementsToContinuePayingCreditors"] = this.hasSpouseMadeArragementsToContinuePayingCreditors;
        data["hasSpouseMadeArragementsToContinuePayingCreditorsDetails"] = this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails;
        data["hasOwnedBusinessPast5Years"] = this.hasOwnedBusinessPast5Years;
        data["doesBusinessAccountForHalfOfDebt"] = this.doesBusinessAccountForHalfOfDebt;
        data["naicsCode"] = this.naicsCode;
        data["hasSpouseOwnedBusinessPast5Years"] = this.hasSpouseOwnedBusinessPast5Years;
        data["doesSpouseBusinessAccountForHalfOfDebt"] = this.doesSpouseBusinessAccountForHalfOfDebt;
        data["spouseNAICSCode"] = this.spouseNAICSCode;
        data["isConsentChecked"] = this.isConsentChecked;
        data["consentDate"] = this.consentDate;
        return data;
    }
}

export interface IAppFormQuestionnaireUpdatedFieldsDto {
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean;
    debtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isDebtFromRecognizanceOfBailBond?: boolean;
    debtFromRecognizanceOfBailBondDetails?: boolean;
    isDebtFromAlimony?: boolean;
    debtFromAlimonyDetails?: boolean;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean;
    debtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isDebtFromFraud?: boolean;
    debtFromFraudDetails?: boolean;
    isDebtFromEmbezzlement?: boolean;
    debtFromEmbezzlementDetails?: boolean;
    isDebtFromMisappropriation?: boolean;
    debtFromMisappropriationDetails?: boolean;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isDebtFromStudentLoansOutstanding?: boolean;
    debtFromStudentLoansOutstandingDetails?: boolean;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean;
    spouseDebtFromRecognizanceOfBailBondDetails?: boolean;
    isSpouseDebtFromAlimony?: boolean;
    spouseDebtFromAlimonyDetails?: boolean;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isSpouseDebtFromFraud?: boolean;
    spouseDebtFromFraudDetails?: boolean;
    isSpouseDebtFromEmbezzlement?: boolean;
    spouseDebtFromEmbezzlementDetails?: boolean;
    isSpouseDebtFromMisappropriation?: boolean;
    spouseDebtFromMisappropriationDetails?: boolean;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isSpouseDebtFromStudentLoansOutstanding?: boolean;
    spouseDebtFromStudentLoansOutstandingDetails?: boolean;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    hasCoSignedOrGuaranteedLoan?: boolean;
    hasMadeExessPaymentsPast12Months?: boolean;
    hasMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasMadeArragementsToContinuePayingCreditors?: boolean;
    hasMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails?: boolean;
    hasSpouseMadeExessPaymentsPast12Months?: boolean;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasOwnedBusinessPast5Years?: boolean;
    doesBusinessAccountForHalfOfDebt?: boolean;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean;
    spouseNAICSCode?: string | undefined;
    isConsentChecked?: boolean;
    consentDate?: boolean;
}

export class AppSMSTemplateDto implements IAppSMSTemplateDto {
    id?: string;
    name?: string | undefined;
    body?: string | undefined;

    constructor(data?: IAppSMSTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): AppSMSTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSMSTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["body"] = this.body;
        return data;
    }
}

export interface IAppSMSTemplateDto {
    id?: string;
    name?: string | undefined;
    body?: string | undefined;
}

export class AppTaskActionClaimUpdateDto implements IAppTaskActionClaimUpdateDto {
    id!: string;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    isMergeCreditorEmail?: boolean | undefined;
    teamId?: string | undefined;
    alerts?: AlertCreateDto;
    isRedundant?: boolean | undefined;

    constructor(data?: IAppTaskActionClaimUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.creditorName = _data["creditorName"];
            this.accountNumber = _data["accountNumber"];
            this.isMergeCreditorEmail = _data["isMergeCreditorEmail"];
            this.teamId = _data["teamId"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
            this.isRedundant = _data["isRedundant"];
        }
    }

    static fromJS(data: any): AppTaskActionClaimUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionClaimUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["creditorName"] = this.creditorName;
        data["accountNumber"] = this.accountNumber;
        data["isMergeCreditorEmail"] = this.isMergeCreditorEmail;
        data["teamId"] = this.teamId;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        data["isRedundant"] = this.isRedundant;
        return data;
    }
}

export interface IAppTaskActionClaimUpdateDto {
    id: string;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    isMergeCreditorEmail?: boolean | undefined;
    teamId?: string | undefined;
    alerts?: AlertCreateDto;
    isRedundant?: boolean | undefined;
}

export class AppTaskActionCreateDto implements IAppTaskActionCreateDto {
    appTaskActionNameId!: string;
    description?: string | undefined;
    followUpDate!: moment.Moment;
    openDate!: moment.Moment;
    closeDate?: moment.Moment | undefined;
    appTaskId!: string;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;

    constructor(data?: IAppTaskActionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appTaskActionNameId = _data["appTaskActionNameId"];
            this.description = _data["description"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.openDate = _data["openDate"] ? moment(_data["openDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.appTaskId = _data["appTaskId"];
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedTeamId = _data["assignedTeamId"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskActionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appTaskActionNameId"] = this.appTaskActionNameId;
        data["description"] = this.description;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["appTaskId"] = this.appTaskId;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedTeamId"] = this.assignedTeamId;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskActionCreateDto {
    appTaskActionNameId: string;
    description?: string | undefined;
    followUpDate: moment.Moment;
    openDate: moment.Moment;
    closeDate?: moment.Moment | undefined;
    appTaskId: string;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
}

export class AppTaskActionDto implements IAppTaskActionDto {
    id?: string;
    description?: string | undefined;
    followUpDate?: moment.Moment;
    openDate?: moment.Moment;
    closeDate?: moment.Moment | undefined;
    assignedAgentId?: string | undefined;
    assignedAgentName?: string | undefined;
    assignedTeamId?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedName?: string | undefined;
    appActionNameId?: string;
    appTaskActionName?: string | undefined;
    appTaskActionNameEnumValue?: AppTaskActionNameEnum;
    appActionStatusId?: string;
    appTaskActionStatusName?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;
    appTaskId?: string;
    appTaskName?: string | undefined;
    createdById?: string;
    createdByName?: string | undefined;
    receivedOn?: moment.Moment | undefined;
    fileId?: string;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
    extractedEstateNumber?: string | undefined;
    extractedAccountNumber?: string | undefined;
    extractedSINNumber?: string | undefined;
    extractedDebtorName?: string | undefined;
    extractedFiledAmount?: number | undefined;
    extractedCreditorName?: string | undefined;
    extractedInsolvencyDate?: moment.Moment | undefined;
    extractedInsolvencyDateRaw?: string | undefined;
    isMergeCreditorEmail?: boolean | undefined;
    linkedClaimFileId?: string | undefined;
    linkedIncomeExpenseSubmissionId?: string | undefined;
    linkedTaxReturnSubmissionIds?: string[] | undefined;
    searchedFileId?: string | undefined;
    numberOfHouseHold?: number | undefined;
    selectedIncomeExpensePeriodId?: number | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriodIds?: number[] | undefined;

    constructor(data?: IAppTaskActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.openDate = _data["openDate"] ? moment(_data["openDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedAgentName = _data["assignedAgentName"];
            this.assignedTeamId = _data["assignedTeamId"];
            this.assignedTeamName = _data["assignedTeamName"];
            this.assignedName = _data["assignedName"];
            this.appActionNameId = _data["appActionNameId"];
            this.appTaskActionName = _data["appTaskActionName"];
            this.appTaskActionNameEnumValue = _data["appTaskActionNameEnumValue"];
            this.appActionStatusId = _data["appActionStatusId"];
            this.appTaskActionStatusName = _data["appTaskActionStatusName"];
            this.appTaskActionStatus = _data["appTaskActionStatus"];
            this.appTaskId = _data["appTaskId"];
            this.appTaskName = _data["appTaskName"];
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.receivedOn = _data["receivedOn"] ? moment(_data["receivedOn"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
            this.importedEmailSubject = _data["importedEmailSubject"];
            this.importedEmailBody = _data["importedEmailBody"];
            this.importedEmailRecipientEmailAddress = _data["importedEmailRecipientEmailAddress"];
            this.importedEmailRecipientName = _data["importedEmailRecipientName"];
            this.importedEmailSenderEmailAddress = _data["importedEmailSenderEmailAddress"];
            this.importedEmailSenderName = _data["importedEmailSenderName"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
            this.extractedEstateNumber = _data["extractedEstateNumber"];
            this.extractedAccountNumber = _data["extractedAccountNumber"];
            this.extractedSINNumber = _data["extractedSINNumber"];
            this.extractedDebtorName = _data["extractedDebtorName"];
            this.extractedFiledAmount = _data["extractedFiledAmount"];
            this.extractedCreditorName = _data["extractedCreditorName"];
            this.extractedInsolvencyDate = _data["extractedInsolvencyDate"] ? moment(_data["extractedInsolvencyDate"].toString()) : <any>undefined;
            this.extractedInsolvencyDateRaw = _data["extractedInsolvencyDateRaw"];
            this.isMergeCreditorEmail = _data["isMergeCreditorEmail"];
            this.linkedClaimFileId = _data["linkedClaimFileId"];
            this.linkedIncomeExpenseSubmissionId = _data["linkedIncomeExpenseSubmissionId"];
            if (Array.isArray(_data["linkedTaxReturnSubmissionIds"])) {
                this.linkedTaxReturnSubmissionIds = [] as any;
                for (let item of _data["linkedTaxReturnSubmissionIds"])
                    this.linkedTaxReturnSubmissionIds!.push(item);
            }
            this.searchedFileId = _data["searchedFileId"];
            this.numberOfHouseHold = _data["numberOfHouseHold"];
            this.selectedIncomeExpensePeriodId = _data["selectedIncomeExpensePeriodId"];
            this.submission = _data["submission"];
            if (Array.isArray(_data["taxReturnPeriodIds"])) {
                this.taxReturnPeriodIds = [] as any;
                for (let item of _data["taxReturnPeriodIds"])
                    this.taxReturnPeriodIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedAgentName"] = this.assignedAgentName;
        data["assignedTeamId"] = this.assignedTeamId;
        data["assignedTeamName"] = this.assignedTeamName;
        data["assignedName"] = this.assignedName;
        data["appActionNameId"] = this.appActionNameId;
        data["appTaskActionName"] = this.appTaskActionName;
        data["appTaskActionNameEnumValue"] = this.appTaskActionNameEnumValue;
        data["appActionStatusId"] = this.appActionStatusId;
        data["appTaskActionStatusName"] = this.appTaskActionStatusName;
        data["appTaskActionStatus"] = this.appTaskActionStatus;
        data["appTaskId"] = this.appTaskId;
        data["appTaskName"] = this.appTaskName;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["receivedOn"] = this.receivedOn ? this.receivedOn.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        data["importedEmailSubject"] = this.importedEmailSubject;
        data["importedEmailBody"] = this.importedEmailBody;
        data["importedEmailRecipientEmailAddress"] = this.importedEmailRecipientEmailAddress;
        data["importedEmailRecipientName"] = this.importedEmailRecipientName;
        data["importedEmailSenderEmailAddress"] = this.importedEmailSenderEmailAddress;
        data["importedEmailSenderName"] = this.importedEmailSenderName;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        data["extractedEstateNumber"] = this.extractedEstateNumber;
        data["extractedAccountNumber"] = this.extractedAccountNumber;
        data["extractedSINNumber"] = this.extractedSINNumber;
        data["extractedDebtorName"] = this.extractedDebtorName;
        data["extractedFiledAmount"] = this.extractedFiledAmount;
        data["extractedCreditorName"] = this.extractedCreditorName;
        data["extractedInsolvencyDate"] = this.extractedInsolvencyDate ? this.extractedInsolvencyDate.toISOString() : <any>undefined;
        data["extractedInsolvencyDateRaw"] = this.extractedInsolvencyDateRaw;
        data["isMergeCreditorEmail"] = this.isMergeCreditorEmail;
        data["linkedClaimFileId"] = this.linkedClaimFileId;
        data["linkedIncomeExpenseSubmissionId"] = this.linkedIncomeExpenseSubmissionId;
        if (Array.isArray(this.linkedTaxReturnSubmissionIds)) {
            data["linkedTaxReturnSubmissionIds"] = [];
            for (let item of this.linkedTaxReturnSubmissionIds)
                data["linkedTaxReturnSubmissionIds"].push(item);
        }
        data["searchedFileId"] = this.searchedFileId;
        data["numberOfHouseHold"] = this.numberOfHouseHold;
        data["selectedIncomeExpensePeriodId"] = this.selectedIncomeExpensePeriodId;
        data["submission"] = this.submission;
        if (Array.isArray(this.taxReturnPeriodIds)) {
            data["taxReturnPeriodIds"] = [];
            for (let item of this.taxReturnPeriodIds)
                data["taxReturnPeriodIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskActionDto {
    id?: string;
    description?: string | undefined;
    followUpDate?: moment.Moment;
    openDate?: moment.Moment;
    closeDate?: moment.Moment | undefined;
    assignedAgentId?: string | undefined;
    assignedAgentName?: string | undefined;
    assignedTeamId?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedName?: string | undefined;
    appActionNameId?: string;
    appTaskActionName?: string | undefined;
    appTaskActionNameEnumValue?: AppTaskActionNameEnum;
    appActionStatusId?: string;
    appTaskActionStatusName?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;
    appTaskId?: string;
    appTaskName?: string | undefined;
    createdById?: string;
    createdByName?: string | undefined;
    receivedOn?: moment.Moment | undefined;
    fileId?: string;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
    extractedEstateNumber?: string | undefined;
    extractedAccountNumber?: string | undefined;
    extractedSINNumber?: string | undefined;
    extractedDebtorName?: string | undefined;
    extractedFiledAmount?: number | undefined;
    extractedCreditorName?: string | undefined;
    extractedInsolvencyDate?: moment.Moment | undefined;
    extractedInsolvencyDateRaw?: string | undefined;
    isMergeCreditorEmail?: boolean | undefined;
    linkedClaimFileId?: string | undefined;
    linkedIncomeExpenseSubmissionId?: string | undefined;
    linkedTaxReturnSubmissionIds?: string[] | undefined;
    searchedFileId?: string | undefined;
    numberOfHouseHold?: number | undefined;
    selectedIncomeExpensePeriodId?: number | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriodIds?: number[] | undefined;
}

export class AppTaskActionIncomeExpenseUpdateDto implements IAppTaskActionIncomeExpenseUpdateDto {
    id!: string;
    searchedFileId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    numberOfHouseHold?: number | undefined;
    selectedIncomeExpensePeriodId?: number | undefined;
    isRedundant?: boolean | undefined;
    alerts?: AlertCreateDto;

    constructor(data?: IAppTaskActionIncomeExpenseUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchedFileId = _data["searchedFileId"];
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.numberOfHouseHold = _data["numberOfHouseHold"];
            this.selectedIncomeExpensePeriodId = _data["selectedIncomeExpensePeriodId"];
            this.isRedundant = _data["isRedundant"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppTaskActionIncomeExpenseUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionIncomeExpenseUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchedFileId"] = this.searchedFileId;
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["numberOfHouseHold"] = this.numberOfHouseHold;
        data["selectedIncomeExpensePeriodId"] = this.selectedIncomeExpensePeriodId;
        data["isRedundant"] = this.isRedundant;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppTaskActionIncomeExpenseUpdateDto {
    id: string;
    searchedFileId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    numberOfHouseHold?: number | undefined;
    selectedIncomeExpensePeriodId?: number | undefined;
    isRedundant?: boolean | undefined;
    alerts?: AlertCreateDto;
}

export class AppTaskActionNavigationDto implements IAppTaskActionNavigationDto {
    id?: string;
    previousItemId?: string | undefined;
    nextItemId?: string | undefined;

    constructor(data?: IAppTaskActionNavigationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.previousItemId = _data["previousItemId"];
            this.nextItemId = _data["nextItemId"];
        }
    }

    static fromJS(data: any): AppTaskActionNavigationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionNavigationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousItemId"] = this.previousItemId;
        data["nextItemId"] = this.nextItemId;
        return data;
    }
}

export interface IAppTaskActionNavigationDto {
    id?: string;
    previousItemId?: string | undefined;
    nextItemId?: string | undefined;
}

export class AppTaskActionTaxReturnUpdateDto implements IAppTaskActionTaxReturnUpdateDto {
    id!: string;
    searchedFileId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriodIds?: number[] | undefined;
    isRedundant?: boolean | undefined;
    alerts?: AlertCreateDto;

    constructor(data?: IAppTaskActionTaxReturnUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchedFileId = _data["searchedFileId"];
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.submission = _data["submission"];
            if (Array.isArray(_data["taxReturnPeriodIds"])) {
                this.taxReturnPeriodIds = [] as any;
                for (let item of _data["taxReturnPeriodIds"])
                    this.taxReturnPeriodIds!.push(item);
            }
            this.isRedundant = _data["isRedundant"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppTaskActionTaxReturnUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionTaxReturnUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchedFileId"] = this.searchedFileId;
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["submission"] = this.submission;
        if (Array.isArray(this.taxReturnPeriodIds)) {
            data["taxReturnPeriodIds"] = [];
            for (let item of this.taxReturnPeriodIds)
                data["taxReturnPeriodIds"].push(item);
        }
        data["isRedundant"] = this.isRedundant;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAppTaskActionTaxReturnUpdateDto {
    id: string;
    searchedFileId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriodIds?: number[] | undefined;
    isRedundant?: boolean | undefined;
    alerts?: AlertCreateDto;
}

export class AppTaskActionUpdateDto implements IAppTaskActionUpdateDto {
    description?: string | undefined;
    followUpDate!: moment.Moment;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;
    attachedDocumentIds?: string[] | undefined;

    constructor(data?: IAppTaskActionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedTeamId = _data["assignedTeamId"];
            this.appTaskActionStatus = _data["appTaskActionStatus"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskActionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedTeamId"] = this.assignedTeamId;
        data["appTaskActionStatus"] = this.appTaskActionStatus;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskActionUpdateDto {
    description?: string | undefined;
    followUpDate: moment.Moment;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;
    attachedDocumentIds?: string[] | undefined;
}

export class AppTaskActionUpdateManyDto implements IAppTaskActionUpdateManyDto {
    ids?: string[] | undefined;
    appTaskActionStatusId?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;

    constructor(data?: IAppTaskActionUpdateManyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.appTaskActionStatusId = _data["appTaskActionStatusId"];
            this.appTaskActionStatus = _data["appTaskActionStatus"];
        }
    }

    static fromJS(data: any): AppTaskActionUpdateManyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskActionUpdateManyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["appTaskActionStatusId"] = this.appTaskActionStatusId;
        data["appTaskActionStatus"] = this.appTaskActionStatus;
        return data;
    }
}

export interface IAppTaskActionUpdateManyDto {
    ids?: string[] | undefined;
    appTaskActionStatusId?: string | undefined;
    appTaskActionStatus?: AppTaskActionStatusEnum;
}

export class AppTaskAndTaskActionCreateDto implements IAppTaskAndTaskActionCreateDto {
    fileId?: string;
    agentId?: string | undefined;
    teamTypeEnum?: TeamTypeEnum;
    fileProcessEnum?: FileProcessEnum;
    taskNameEnum?: AppTaskNameEnum;
    taskActionEnum?: AppTaskActionNameEnum;
    taskDescription?: string | undefined;
    actionDescription?: string | undefined;
    useExistingTaskIfNotComplete?: boolean;

    constructor(data?: IAppTaskAndTaskActionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.agentId = _data["agentId"];
            this.teamTypeEnum = _data["teamTypeEnum"];
            this.fileProcessEnum = _data["fileProcessEnum"];
            this.taskNameEnum = _data["taskNameEnum"];
            this.taskActionEnum = _data["taskActionEnum"];
            this.taskDescription = _data["taskDescription"];
            this.actionDescription = _data["actionDescription"];
            this.useExistingTaskIfNotComplete = _data["useExistingTaskIfNotComplete"];
        }
    }

    static fromJS(data: any): AppTaskAndTaskActionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskAndTaskActionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["agentId"] = this.agentId;
        data["teamTypeEnum"] = this.teamTypeEnum;
        data["fileProcessEnum"] = this.fileProcessEnum;
        data["taskNameEnum"] = this.taskNameEnum;
        data["taskActionEnum"] = this.taskActionEnum;
        data["taskDescription"] = this.taskDescription;
        data["actionDescription"] = this.actionDescription;
        data["useExistingTaskIfNotComplete"] = this.useExistingTaskIfNotComplete;
        return data;
    }
}

export interface IAppTaskAndTaskActionCreateDto {
    fileId?: string;
    agentId?: string | undefined;
    teamTypeEnum?: TeamTypeEnum;
    fileProcessEnum?: FileProcessEnum;
    taskNameEnum?: AppTaskNameEnum;
    taskActionEnum?: AppTaskActionNameEnum;
    taskDescription?: string | undefined;
    actionDescription?: string | undefined;
    useExistingTaskIfNotComplete?: boolean;
}

export class AppTaskCreateDto implements IAppTaskCreateDto {
    fileId?: string;
    fileProcessId!: string;
    description?: string | undefined;
    openDate!: moment.Moment;
    closeDate?: moment.Moment | undefined;
    appTaskNameId!: string;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;

    constructor(data?: IAppTaskCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileProcessId = _data["fileProcessId"];
            this.description = _data["description"];
            this.openDate = _data["openDate"] ? moment(_data["openDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.appTaskNameId = _data["appTaskNameId"];
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedTeamId = _data["assignedTeamId"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileProcessId"] = this.fileProcessId;
        data["description"] = this.description;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["appTaskNameId"] = this.appTaskNameId;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedTeamId"] = this.assignedTeamId;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskCreateDto {
    fileId?: string;
    fileProcessId: string;
    description?: string | undefined;
    openDate: moment.Moment;
    closeDate?: moment.Moment | undefined;
    appTaskNameId: string;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
}

export class AppTaskDto implements IAppTaskDto {
    id?: string;
    description?: string | undefined;
    openDate?: moment.Moment;
    openDays?: number | undefined;
    closeDate?: moment.Moment | undefined;
    appTaskNameId?: string;
    appTaskName?: string | undefined;
    appTaskStatusId?: string;
    appTaskStatus?: string | undefined;
    assignedAgentId?: string | undefined;
    assignedAgentName?: string | undefined;
    assignedTeamId?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedName?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    fileStageId?: string | undefined;
    fileStageName?: string | undefined;
    estateNumber?: string | undefined;
    fileProcessId?: string;
    fileProcessName?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    isPriority?: boolean;
    hasPendingTaskActions?: boolean;
    attachedDocumentIds?: string[] | undefined;

    constructor(data?: IAppTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.openDate = _data["openDate"] ? moment(_data["openDate"].toString()) : <any>undefined;
            this.openDays = _data["openDays"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.appTaskNameId = _data["appTaskNameId"];
            this.appTaskName = _data["appTaskName"];
            this.appTaskStatusId = _data["appTaskStatusId"];
            this.appTaskStatus = _data["appTaskStatus"];
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedAgentName = _data["assignedAgentName"];
            this.assignedTeamId = _data["assignedTeamId"];
            this.assignedTeamName = _data["assignedTeamName"];
            this.assignedName = _data["assignedName"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileStageId = _data["fileStageId"];
            this.fileStageName = _data["fileStageName"];
            this.estateNumber = _data["estateNumber"];
            this.fileProcessId = _data["fileProcessId"];
            this.fileProcessName = _data["fileProcessName"];
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.isPriority = _data["isPriority"];
            this.hasPendingTaskActions = _data["hasPendingTaskActions"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : <any>undefined;
        data["openDays"] = this.openDays;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["appTaskNameId"] = this.appTaskNameId;
        data["appTaskName"] = this.appTaskName;
        data["appTaskStatusId"] = this.appTaskStatusId;
        data["appTaskStatus"] = this.appTaskStatus;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedAgentName"] = this.assignedAgentName;
        data["assignedTeamId"] = this.assignedTeamId;
        data["assignedTeamName"] = this.assignedTeamName;
        data["assignedName"] = this.assignedName;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileStageId"] = this.fileStageId;
        data["fileStageName"] = this.fileStageName;
        data["estateNumber"] = this.estateNumber;
        data["fileProcessId"] = this.fileProcessId;
        data["fileProcessName"] = this.fileProcessName;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["isPriority"] = this.isPriority;
        data["hasPendingTaskActions"] = this.hasPendingTaskActions;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskDto {
    id?: string;
    description?: string | undefined;
    openDate?: moment.Moment;
    openDays?: number | undefined;
    closeDate?: moment.Moment | undefined;
    appTaskNameId?: string;
    appTaskName?: string | undefined;
    appTaskStatusId?: string;
    appTaskStatus?: string | undefined;
    assignedAgentId?: string | undefined;
    assignedAgentName?: string | undefined;
    assignedTeamId?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedName?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    fileStageId?: string | undefined;
    fileStageName?: string | undefined;
    estateNumber?: string | undefined;
    fileProcessId?: string;
    fileProcessName?: string | undefined;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    isPriority?: boolean;
    hasPendingTaskActions?: boolean;
    attachedDocumentIds?: string[] | undefined;
}

export class AppTaskUpdateDto implements IAppTaskUpdateDto {
    description?: string | undefined;
    appTaskStatus?: AppTaskStatusEnum;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;

    constructor(data?: IAppTaskUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.appTaskStatus = _data["appTaskStatus"];
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedTeamId = _data["assignedTeamId"];
            if (Array.isArray(_data["attachedDocumentIds"])) {
                this.attachedDocumentIds = [] as any;
                for (let item of _data["attachedDocumentIds"])
                    this.attachedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppTaskUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["appTaskStatus"] = this.appTaskStatus;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedTeamId"] = this.assignedTeamId;
        if (Array.isArray(this.attachedDocumentIds)) {
            data["attachedDocumentIds"] = [];
            for (let item of this.attachedDocumentIds)
                data["attachedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IAppTaskUpdateDto {
    description?: string | undefined;
    appTaskStatus?: AppTaskStatusEnum;
    assignedAgentId?: string | undefined;
    assignedTeamId?: string | undefined;
    attachedDocumentIds?: string[] | undefined;
}

export class AppTaskUpdateManyDto implements IAppTaskUpdateManyDto {
    ids?: string[] | undefined;
    appTaskStatusId?: string | undefined;
    appTaskStatus?: AppTaskStatusEnum;

    constructor(data?: IAppTaskUpdateManyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.appTaskStatusId = _data["appTaskStatusId"];
            this.appTaskStatus = _data["appTaskStatus"];
        }
    }

    static fromJS(data: any): AppTaskUpdateManyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskUpdateManyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["appTaskStatusId"] = this.appTaskStatusId;
        data["appTaskStatus"] = this.appTaskStatus;
        return data;
    }
}

export interface IAppTaskUpdateManyDto {
    ids?: string[] | undefined;
    appTaskStatusId?: string | undefined;
    appTaskStatus?: AppTaskStatusEnum;
}

export class GetAppTasksInput implements IGetAppTasksInput {
    maxResultCount?: number;
    skipCount?: number;
    sorting?: string | undefined;
    appTaskId?: string | undefined;
    appTaskIds?: string[] | undefined;
    filterText?: string | undefined;
    description?: string | undefined;
    openDateMin?: moment.Moment | undefined;
    openDateMax?: moment.Moment | undefined;
    closeDateMin?: moment.Moment | undefined;
    closeDateMax?: moment.Moment | undefined;
    assignedAgentIds?: string[] | undefined;
    assignedTeamIds?: string[] | undefined;
    appTaskNames?: AppTaskNameEnum[] | undefined;
    appTaskStatuses?: AppTaskStatusEnum[] | undefined;
    fileId?: string | undefined;
    fileStages?: FileStageEnum[] | undefined;
    fileProcesses?: FileProcessEnum[] | undefined;

    constructor(data?: IGetAppTasksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.appTaskId = _data["appTaskId"];
            if (Array.isArray(_data["appTaskIds"])) {
                this.appTaskIds = [] as any;
                for (let item of _data["appTaskIds"])
                    this.appTaskIds!.push(item);
            }
            this.filterText = _data["filterText"];
            this.description = _data["description"];
            this.openDateMin = _data["openDateMin"] ? moment(_data["openDateMin"].toString()) : <any>undefined;
            this.openDateMax = _data["openDateMax"] ? moment(_data["openDateMax"].toString()) : <any>undefined;
            this.closeDateMin = _data["closeDateMin"] ? moment(_data["closeDateMin"].toString()) : <any>undefined;
            this.closeDateMax = _data["closeDateMax"] ? moment(_data["closeDateMax"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignedAgentIds"])) {
                this.assignedAgentIds = [] as any;
                for (let item of _data["assignedAgentIds"])
                    this.assignedAgentIds!.push(item);
            }
            if (Array.isArray(_data["assignedTeamIds"])) {
                this.assignedTeamIds = [] as any;
                for (let item of _data["assignedTeamIds"])
                    this.assignedTeamIds!.push(item);
            }
            if (Array.isArray(_data["appTaskNames"])) {
                this.appTaskNames = [] as any;
                for (let item of _data["appTaskNames"])
                    this.appTaskNames!.push(item);
            }
            if (Array.isArray(_data["appTaskStatuses"])) {
                this.appTaskStatuses = [] as any;
                for (let item of _data["appTaskStatuses"])
                    this.appTaskStatuses!.push(item);
            }
            this.fileId = _data["fileId"];
            if (Array.isArray(_data["fileStages"])) {
                this.fileStages = [] as any;
                for (let item of _data["fileStages"])
                    this.fileStages!.push(item);
            }
            if (Array.isArray(_data["fileProcesses"])) {
                this.fileProcesses = [] as any;
                for (let item of _data["fileProcesses"])
                    this.fileProcesses!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAppTasksInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppTasksInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["appTaskId"] = this.appTaskId;
        if (Array.isArray(this.appTaskIds)) {
            data["appTaskIds"] = [];
            for (let item of this.appTaskIds)
                data["appTaskIds"].push(item);
        }
        data["filterText"] = this.filterText;
        data["description"] = this.description;
        data["openDateMin"] = this.openDateMin ? this.openDateMin.toISOString() : <any>undefined;
        data["openDateMax"] = this.openDateMax ? this.openDateMax.toISOString() : <any>undefined;
        data["closeDateMin"] = this.closeDateMin ? this.closeDateMin.toISOString() : <any>undefined;
        data["closeDateMax"] = this.closeDateMax ? this.closeDateMax.toISOString() : <any>undefined;
        if (Array.isArray(this.assignedAgentIds)) {
            data["assignedAgentIds"] = [];
            for (let item of this.assignedAgentIds)
                data["assignedAgentIds"].push(item);
        }
        if (Array.isArray(this.assignedTeamIds)) {
            data["assignedTeamIds"] = [];
            for (let item of this.assignedTeamIds)
                data["assignedTeamIds"].push(item);
        }
        if (Array.isArray(this.appTaskNames)) {
            data["appTaskNames"] = [];
            for (let item of this.appTaskNames)
                data["appTaskNames"].push(item);
        }
        if (Array.isArray(this.appTaskStatuses)) {
            data["appTaskStatuses"] = [];
            for (let item of this.appTaskStatuses)
                data["appTaskStatuses"].push(item);
        }
        data["fileId"] = this.fileId;
        if (Array.isArray(this.fileStages)) {
            data["fileStages"] = [];
            for (let item of this.fileStages)
                data["fileStages"].push(item);
        }
        if (Array.isArray(this.fileProcesses)) {
            data["fileProcesses"] = [];
            for (let item of this.fileProcesses)
                data["fileProcesses"].push(item);
        }
        return data;
    }
}

export interface IGetAppTasksInput {
    maxResultCount?: number;
    skipCount?: number;
    sorting?: string | undefined;
    appTaskId?: string | undefined;
    appTaskIds?: string[] | undefined;
    filterText?: string | undefined;
    description?: string | undefined;
    openDateMin?: moment.Moment | undefined;
    openDateMax?: moment.Moment | undefined;
    closeDateMin?: moment.Moment | undefined;
    closeDateMax?: moment.Moment | undefined;
    assignedAgentIds?: string[] | undefined;
    assignedTeamIds?: string[] | undefined;
    appTaskNames?: AppTaskNameEnum[] | undefined;
    appTaskStatuses?: AppTaskStatusEnum[] | undefined;
    fileId?: string | undefined;
    fileStages?: FileStageEnum[] | undefined;
    fileProcesses?: FileProcessEnum[] | undefined;
}

export class AdminInfoAssetRealizationDto implements IAdminInfoAssetRealizationDto {
    assetRealizationProcessStatus?: FileProcessStatusEnum;
    completedAllClaims?: boolean;

    constructor(data?: IAdminInfoAssetRealizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetRealizationProcessStatus = _data["assetRealizationProcessStatus"];
            this.completedAllClaims = _data["completedAllClaims"];
        }
    }

    static fromJS(data: any): AdminInfoAssetRealizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoAssetRealizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetRealizationProcessStatus"] = this.assetRealizationProcessStatus;
        data["completedAllClaims"] = this.completedAllClaims;
        return data;
    }
}

export interface IAdminInfoAssetRealizationDto {
    assetRealizationProcessStatus?: FileProcessStatusEnum;
    completedAllClaims?: boolean;
}

export class AdminInfoAssetRealizationUpdateDto implements IAdminInfoAssetRealizationUpdateDto {
    assetRealizationProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoAssetRealizationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetRealizationProcessStatus = _data["assetRealizationProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoAssetRealizationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoAssetRealizationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetRealizationProcessStatus"] = this.assetRealizationProcessStatus;
        return data;
    }
}

export interface IAdminInfoAssetRealizationUpdateDto {
    assetRealizationProcessStatus?: FileProcessStatusEnum;
}

export class AdminInfoClaimsDto implements IAdminInfoClaimsDto {
    claimsProcessStatus?: FileProcessStatusEnum;
    completedAllClaims?: boolean;

    constructor(data?: IAdminInfoClaimsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimsProcessStatus = _data["claimsProcessStatus"];
            this.completedAllClaims = _data["completedAllClaims"];
        }
    }

    static fromJS(data: any): AdminInfoClaimsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoClaimsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimsProcessStatus"] = this.claimsProcessStatus;
        data["completedAllClaims"] = this.completedAllClaims;
        return data;
    }
}

export interface IAdminInfoClaimsDto {
    claimsProcessStatus?: FileProcessStatusEnum;
    completedAllClaims?: boolean;
}

export class AdminInfoClaimsUpdateDto implements IAdminInfoClaimsUpdateDto {
    claimsProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoClaimsUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimsProcessStatus = _data["claimsProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoClaimsUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoClaimsUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimsProcessStatus"] = this.claimsProcessStatus;
        return data;
    }
}

export interface IAdminInfoClaimsUpdateDto {
    claimsProcessStatus?: FileProcessStatusEnum;
}

export class AdminInfoCounsellingDto implements IAdminInfoCounsellingDto {
    counsellingStatus?: FileProcessStatusDto;
    sessions?: AdminInfoCounsellingSessionDto[] | undefined;

    constructor(data?: IAdminInfoCounsellingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counsellingStatus = _data["counsellingStatus"] ? FileProcessStatusDto.fromJS(_data["counsellingStatus"]) : <any>undefined;
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(AdminInfoCounsellingSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminInfoCounsellingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counsellingStatus"] = this.counsellingStatus ? this.counsellingStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdminInfoCounsellingDto {
    counsellingStatus?: FileProcessStatusDto;
    sessions?: AdminInfoCounsellingSessionDto[] | undefined;
}

export class AdminInfoCounsellingManualSessionCreateDto implements IAdminInfoCounsellingManualSessionCreateDto {
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    isManuallyCompleted?: boolean;
    manualCompletionDate?: moment.Moment | undefined;

    constructor(data?: IAdminInfoCounsellingManualSessionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ascendMethodOfDeliveryId = _data["ascendMethodOfDeliveryId"];
            this.ascendCounsellingTypeId = _data["ascendCounsellingTypeId"];
            this.isManuallyCompleted = _data["isManuallyCompleted"];
            this.manualCompletionDate = _data["manualCompletionDate"] ? moment(_data["manualCompletionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminInfoCounsellingManualSessionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingManualSessionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ascendMethodOfDeliveryId"] = this.ascendMethodOfDeliveryId;
        data["ascendCounsellingTypeId"] = this.ascendCounsellingTypeId;
        data["isManuallyCompleted"] = this.isManuallyCompleted;
        data["manualCompletionDate"] = this.manualCompletionDate ? this.manualCompletionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdminInfoCounsellingManualSessionCreateDto {
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    isManuallyCompleted?: boolean;
    manualCompletionDate?: moment.Moment | undefined;
}

export class AdminInfoCounsellingSessionCreateDto implements IAdminInfoCounsellingSessionCreateDto {
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean | undefined;
    relatedDebtorId?: string | undefined;
    appointmentInfo?: BookAppointmentInput;

    constructor(data?: IAdminInfoCounsellingSessionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionNumber = _data["sessionNumber"];
            this.ascendMethodOfDeliveryId = _data["ascendMethodOfDeliveryId"];
            this.ascendCounsellingTypeId = _data["ascendCounsellingTypeId"];
            this.includeRelatedDebtor = _data["includeRelatedDebtor"];
            this.relatedDebtorId = _data["relatedDebtorId"];
            this.appointmentInfo = _data["appointmentInfo"] ? BookAppointmentInput.fromJS(_data["appointmentInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminInfoCounsellingSessionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingSessionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionNumber"] = this.sessionNumber;
        data["ascendMethodOfDeliveryId"] = this.ascendMethodOfDeliveryId;
        data["ascendCounsellingTypeId"] = this.ascendCounsellingTypeId;
        data["includeRelatedDebtor"] = this.includeRelatedDebtor;
        data["relatedDebtorId"] = this.relatedDebtorId;
        data["appointmentInfo"] = this.appointmentInfo ? this.appointmentInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdminInfoCounsellingSessionCreateDto {
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean | undefined;
    relatedDebtorId?: string | undefined;
    appointmentInfo?: BookAppointmentInput;
}

export class AdminInfoCounsellingSessionDto implements IAdminInfoCounsellingSessionDto {
    id?: string;
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean;
    relatedDebtorId?: string | undefined;
    appointment?: AppointmentDto;
    isManualEntry?: boolean;
    isManuallyCompleted?: boolean | undefined;
    manualCompletionDate?: moment.Moment | undefined;

    constructor(data?: IAdminInfoCounsellingSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionNumber = _data["sessionNumber"];
            this.ascendMethodOfDeliveryId = _data["ascendMethodOfDeliveryId"];
            this.ascendCounsellingTypeId = _data["ascendCounsellingTypeId"];
            this.includeRelatedDebtor = _data["includeRelatedDebtor"];
            this.relatedDebtorId = _data["relatedDebtorId"];
            this.appointment = _data["appointment"] ? AppointmentDto.fromJS(_data["appointment"]) : <any>undefined;
            this.isManualEntry = _data["isManualEntry"];
            this.isManuallyCompleted = _data["isManuallyCompleted"];
            this.manualCompletionDate = _data["manualCompletionDate"] ? moment(_data["manualCompletionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminInfoCounsellingSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionNumber"] = this.sessionNumber;
        data["ascendMethodOfDeliveryId"] = this.ascendMethodOfDeliveryId;
        data["ascendCounsellingTypeId"] = this.ascendCounsellingTypeId;
        data["includeRelatedDebtor"] = this.includeRelatedDebtor;
        data["relatedDebtorId"] = this.relatedDebtorId;
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>undefined;
        data["isManualEntry"] = this.isManualEntry;
        data["isManuallyCompleted"] = this.isManuallyCompleted;
        data["manualCompletionDate"] = this.manualCompletionDate ? this.manualCompletionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdminInfoCounsellingSessionDto {
    id?: string;
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean;
    relatedDebtorId?: string | undefined;
    appointment?: AppointmentDto;
    isManualEntry?: boolean;
    isManuallyCompleted?: boolean | undefined;
    manualCompletionDate?: moment.Moment | undefined;
}

export class AdminInfoCounsellingSessionUpdateDto implements IAdminInfoCounsellingSessionUpdateDto {
    id?: string;
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean | undefined;
    relatedDebtorId?: string | undefined;
    appointmentId?: string | undefined;
    appointmentStatus?: AppointmentStatusEnum;
    appointmentDateTime?: moment.Moment | undefined;
    officeLocationId?: string | undefined;
    meetingTypeId?: string | undefined;
    agentId?: string | undefined;
    confirmDeleteSessionInAscend?: boolean | undefined;
    duration?: number | undefined;

    constructor(data?: IAdminInfoCounsellingSessionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionNumber = _data["sessionNumber"];
            this.ascendMethodOfDeliveryId = _data["ascendMethodOfDeliveryId"];
            this.ascendCounsellingTypeId = _data["ascendCounsellingTypeId"];
            this.includeRelatedDebtor = _data["includeRelatedDebtor"];
            this.relatedDebtorId = _data["relatedDebtorId"];
            this.appointmentId = _data["appointmentId"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.officeLocationId = _data["officeLocationId"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.agentId = _data["agentId"];
            this.confirmDeleteSessionInAscend = _data["confirmDeleteSessionInAscend"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): AdminInfoCounsellingSessionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingSessionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionNumber"] = this.sessionNumber;
        data["ascendMethodOfDeliveryId"] = this.ascendMethodOfDeliveryId;
        data["ascendCounsellingTypeId"] = this.ascendCounsellingTypeId;
        data["includeRelatedDebtor"] = this.includeRelatedDebtor;
        data["relatedDebtorId"] = this.relatedDebtorId;
        data["appointmentId"] = this.appointmentId;
        data["appointmentStatus"] = this.appointmentStatus;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["officeLocationId"] = this.officeLocationId;
        data["meetingTypeId"] = this.meetingTypeId;
        data["agentId"] = this.agentId;
        data["confirmDeleteSessionInAscend"] = this.confirmDeleteSessionInAscend;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IAdminInfoCounsellingSessionUpdateDto {
    id?: string;
    sessionNumber?: number;
    ascendMethodOfDeliveryId?: MethodOfDeliveryEnum;
    ascendCounsellingTypeId?: CounsellingSessionTypeEnum;
    includeRelatedDebtor?: boolean | undefined;
    relatedDebtorId?: string | undefined;
    appointmentId?: string | undefined;
    appointmentStatus?: AppointmentStatusEnum;
    appointmentDateTime?: moment.Moment | undefined;
    officeLocationId?: string | undefined;
    meetingTypeId?: string | undefined;
    agentId?: string | undefined;
    confirmDeleteSessionInAscend?: boolean | undefined;
    duration?: number | undefined;
}

export class AdminInfoCounsellingUpdateDto implements IAdminInfoCounsellingUpdateDto {
    status?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoCounsellingUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AdminInfoCounsellingUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoCounsellingUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IAdminInfoCounsellingUpdateDto {
    status?: FileProcessStatusEnum;
}

export class AdminInfoDischargeDto implements IAdminInfoDischargeDto {
    dischargeProcessStatus?: FileProcessStatusEnum;
    totalDue?: number;
    totalPayments?: number;
    isProcessAllowedToBeCompleted?: boolean;

    constructor(data?: IAdminInfoDischargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dischargeProcessStatus = _data["dischargeProcessStatus"];
            this.totalDue = _data["totalDue"];
            this.totalPayments = _data["totalPayments"];
            this.isProcessAllowedToBeCompleted = _data["isProcessAllowedToBeCompleted"];
        }
    }

    static fromJS(data: any): AdminInfoDischargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoDischargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dischargeProcessStatus"] = this.dischargeProcessStatus;
        data["totalDue"] = this.totalDue;
        data["totalPayments"] = this.totalPayments;
        data["isProcessAllowedToBeCompleted"] = this.isProcessAllowedToBeCompleted;
        return data;
    }
}

export interface IAdminInfoDischargeDto {
    dischargeProcessStatus?: FileProcessStatusEnum;
    totalDue?: number;
    totalPayments?: number;
    isProcessAllowedToBeCompleted?: boolean;
}

export class AdminInfoDischargeUpdateDto implements IAdminInfoDischargeUpdateDto {
    dischargeProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoDischargeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dischargeProcessStatus = _data["dischargeProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoDischargeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoDischargeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dischargeProcessStatus"] = this.dischargeProcessStatus;
        return data;
    }
}

export interface IAdminInfoDischargeUpdateDto {
    dischargeProcessStatus?: FileProcessStatusEnum;
}

export class AdminInfoFileProcessStatusDto implements IAdminInfoFileProcessStatusDto {
    fileId?: string;
    generalStatus?: boolean;
    signupStatus?: FileProcessStatusEnum;
    counsellingStatus?: FileProcessStatusEnum;
    claimsStatus?: FileProcessStatusEnum;
    assetRealisationStatus?: FileProcessStatusEnum;
    bankingStatus?: FileProcessStatusEnum;
    incomeExpenseStatus?: FileProcessStatusEnum;
    taxReturnStatus?: FileProcessStatusEnum;
    dischargeStatus?: FileProcessStatusEnum;
    receiptsandDisbursementStatus?: FileProcessStatusEnum;
    proposalStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoFileProcessStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.generalStatus = _data["generalStatus"];
            this.signupStatus = _data["signupStatus"];
            this.counsellingStatus = _data["counsellingStatus"];
            this.claimsStatus = _data["claimsStatus"];
            this.assetRealisationStatus = _data["assetRealisationStatus"];
            this.bankingStatus = _data["bankingStatus"];
            this.incomeExpenseStatus = _data["incomeExpenseStatus"];
            this.taxReturnStatus = _data["taxReturnStatus"];
            this.dischargeStatus = _data["dischargeStatus"];
            this.receiptsandDisbursementStatus = _data["receiptsandDisbursementStatus"];
            this.proposalStatus = _data["proposalStatus"];
        }
    }

    static fromJS(data: any): AdminInfoFileProcessStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoFileProcessStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["generalStatus"] = this.generalStatus;
        data["signupStatus"] = this.signupStatus;
        data["counsellingStatus"] = this.counsellingStatus;
        data["claimsStatus"] = this.claimsStatus;
        data["assetRealisationStatus"] = this.assetRealisationStatus;
        data["bankingStatus"] = this.bankingStatus;
        data["incomeExpenseStatus"] = this.incomeExpenseStatus;
        data["taxReturnStatus"] = this.taxReturnStatus;
        data["dischargeStatus"] = this.dischargeStatus;
        data["receiptsandDisbursementStatus"] = this.receiptsandDisbursementStatus;
        data["proposalStatus"] = this.proposalStatus;
        return data;
    }
}

export interface IAdminInfoFileProcessStatusDto {
    fileId?: string;
    generalStatus?: boolean;
    signupStatus?: FileProcessStatusEnum;
    counsellingStatus?: FileProcessStatusEnum;
    claimsStatus?: FileProcessStatusEnum;
    assetRealisationStatus?: FileProcessStatusEnum;
    bankingStatus?: FileProcessStatusEnum;
    incomeExpenseStatus?: FileProcessStatusEnum;
    taxReturnStatus?: FileProcessStatusEnum;
    dischargeStatus?: FileProcessStatusEnum;
    receiptsandDisbursementStatus?: FileProcessStatusEnum;
    proposalStatus?: FileProcessStatusEnum;
}

export class AdminInfoGeneralDto implements IAdminInfoGeneralDto {
    id?: string;
    agent?: AgentDto;
    estateAdministrator?: AgentDto;
    trustee?: AgentDto;
    interviewer?: AgentDto;
    filingType?: FilingTypeDto;
    serviceLocation?: OfficeLocationDto;
    trusteeOffice?: OfficeLocationDto;
    fileName?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    estateNumber?: string | undefined;
    bankruptcyDuration?: string | undefined;
    signupStatus?: FileProcessStatusDto;

    constructor(data?: IAdminInfoGeneralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : <any>undefined;
            this.estateAdministrator = _data["estateAdministrator"] ? AgentDto.fromJS(_data["estateAdministrator"]) : <any>undefined;
            this.trustee = _data["trustee"] ? AgentDto.fromJS(_data["trustee"]) : <any>undefined;
            this.interviewer = _data["interviewer"] ? AgentDto.fromJS(_data["interviewer"]) : <any>undefined;
            this.filingType = _data["filingType"] ? FilingTypeDto.fromJS(_data["filingType"]) : <any>undefined;
            this.serviceLocation = _data["serviceLocation"] ? OfficeLocationDto.fromJS(_data["serviceLocation"]) : <any>undefined;
            this.trusteeOffice = _data["trusteeOffice"] ? OfficeLocationDto.fromJS(_data["trusteeOffice"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.insolvencyDate = _data["insolvencyDate"] ? moment(_data["insolvencyDate"].toString()) : <any>undefined;
            this.estateNumber = _data["estateNumber"];
            this.bankruptcyDuration = _data["bankruptcyDuration"];
            this.signupStatus = _data["signupStatus"] ? FileProcessStatusDto.fromJS(_data["signupStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminInfoGeneralDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoGeneralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["estateAdministrator"] = this.estateAdministrator ? this.estateAdministrator.toJSON() : <any>undefined;
        data["trustee"] = this.trustee ? this.trustee.toJSON() : <any>undefined;
        data["interviewer"] = this.interviewer ? this.interviewer.toJSON() : <any>undefined;
        data["filingType"] = this.filingType ? this.filingType.toJSON() : <any>undefined;
        data["serviceLocation"] = this.serviceLocation ? this.serviceLocation.toJSON() : <any>undefined;
        data["trusteeOffice"] = this.trusteeOffice ? this.trusteeOffice.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["insolvencyDate"] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
        data["estateNumber"] = this.estateNumber;
        data["bankruptcyDuration"] = this.bankruptcyDuration;
        data["signupStatus"] = this.signupStatus ? this.signupStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdminInfoGeneralDto {
    id?: string;
    agent?: AgentDto;
    estateAdministrator?: AgentDto;
    trustee?: AgentDto;
    interviewer?: AgentDto;
    filingType?: FilingTypeDto;
    serviceLocation?: OfficeLocationDto;
    trusteeOffice?: OfficeLocationDto;
    fileName?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    estateNumber?: string | undefined;
    bankruptcyDuration?: string | undefined;
    signupStatus?: FileProcessStatusDto;
}

export class AdminInfoGeneralUpdateDto implements IAdminInfoGeneralUpdateDto {
    filingType?: FilingTypeEnum;
    agentId?: string | undefined;
    estateAdministratorId?: string | undefined;
    trusteeId?: string | undefined;
    interviewerId?: string | undefined;
    serviceLocationId?: string | undefined;
    trusteeOfficeId?: string | undefined;

    constructor(data?: IAdminInfoGeneralUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filingType = _data["filingType"];
            this.agentId = _data["agentId"];
            this.estateAdministratorId = _data["estateAdministratorId"];
            this.trusteeId = _data["trusteeId"];
            this.interviewerId = _data["interviewerId"];
            this.serviceLocationId = _data["serviceLocationId"];
            this.trusteeOfficeId = _data["trusteeOfficeId"];
        }
    }

    static fromJS(data: any): AdminInfoGeneralUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoGeneralUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filingType"] = this.filingType;
        data["agentId"] = this.agentId;
        data["estateAdministratorId"] = this.estateAdministratorId;
        data["trusteeId"] = this.trusteeId;
        data["interviewerId"] = this.interviewerId;
        data["serviceLocationId"] = this.serviceLocationId;
        data["trusteeOfficeId"] = this.trusteeOfficeId;
        return data;
    }
}

export interface IAdminInfoGeneralUpdateDto {
    filingType?: FilingTypeEnum;
    agentId?: string | undefined;
    estateAdministratorId?: string | undefined;
    trusteeId?: string | undefined;
    interviewerId?: string | undefined;
    serviceLocationId?: string | undefined;
    trusteeOfficeId?: string | undefined;
}

export class AdminInfoIncomeExpenseDto implements IAdminInfoIncomeExpenseDto {
    incomeExpenseProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoIncomeExpenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomeExpenseProcessStatus = _data["incomeExpenseProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoIncomeExpenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoIncomeExpenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeExpenseProcessStatus"] = this.incomeExpenseProcessStatus;
        return data;
    }
}

export interface IAdminInfoIncomeExpenseDto {
    incomeExpenseProcessStatus?: FileProcessStatusEnum;
}

export class AdminInfoReceiptsDisbursementsUpdateDto implements IAdminInfoReceiptsDisbursementsUpdateDto {
    receiptDisbursementProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoReceiptsDisbursementsUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptDisbursementProcessStatus = _data["receiptDisbursementProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoReceiptsDisbursementsUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoReceiptsDisbursementsUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptDisbursementProcessStatus"] = this.receiptDisbursementProcessStatus;
        return data;
    }
}

export interface IAdminInfoReceiptsDisbursementsUpdateDto {
    receiptDisbursementProcessStatus?: FileProcessStatusEnum;
}

export class AdminInfoSignupDto implements IAdminInfoSignupDto {
    status?: AppFormStatusEnum;
    readonly totalDebts?: number;
    totalSecuredDebts?: number;
    totalUnsecuredDebts?: number;
    isPPSASearchCompleted?: boolean;
    isInsolvencyNameSearchCompleted?: boolean;
    signupChecklistStatus?: ChecklistStatusEnum;
    signupStatus?: FileProcessStatusDto;
    isTrusteeEngagementAcceptance?: boolean;
    isTrusteeConflictCheck?: boolean;
    followupDate?: moment.Moment | undefined;
    counsellingSessionExistsInAscend?: boolean;

    constructor(data?: IAdminInfoSignupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            (<any>this).totalDebts = _data["totalDebts"];
            this.totalSecuredDebts = _data["totalSecuredDebts"];
            this.totalUnsecuredDebts = _data["totalUnsecuredDebts"];
            this.isPPSASearchCompleted = _data["isPPSASearchCompleted"];
            this.isInsolvencyNameSearchCompleted = _data["isInsolvencyNameSearchCompleted"];
            this.signupChecklistStatus = _data["signupChecklistStatus"];
            this.signupStatus = _data["signupStatus"] ? FileProcessStatusDto.fromJS(_data["signupStatus"]) : <any>undefined;
            this.isTrusteeEngagementAcceptance = _data["isTrusteeEngagementAcceptance"];
            this.isTrusteeConflictCheck = _data["isTrusteeConflictCheck"];
            this.followupDate = _data["followupDate"] ? moment(_data["followupDate"].toString()) : <any>undefined;
            this.counsellingSessionExistsInAscend = _data["counsellingSessionExistsInAscend"];
        }
    }

    static fromJS(data: any): AdminInfoSignupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoSignupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["totalDebts"] = this.totalDebts;
        data["totalSecuredDebts"] = this.totalSecuredDebts;
        data["totalUnsecuredDebts"] = this.totalUnsecuredDebts;
        data["isPPSASearchCompleted"] = this.isPPSASearchCompleted;
        data["isInsolvencyNameSearchCompleted"] = this.isInsolvencyNameSearchCompleted;
        data["signupChecklistStatus"] = this.signupChecklistStatus;
        data["signupStatus"] = this.signupStatus ? this.signupStatus.toJSON() : <any>undefined;
        data["isTrusteeEngagementAcceptance"] = this.isTrusteeEngagementAcceptance;
        data["isTrusteeConflictCheck"] = this.isTrusteeConflictCheck;
        data["followupDate"] = this.followupDate ? this.followupDate.toISOString() : <any>undefined;
        data["counsellingSessionExistsInAscend"] = this.counsellingSessionExistsInAscend;
        return data;
    }
}

export interface IAdminInfoSignupDto {
    status?: AppFormStatusEnum;
    totalDebts?: number;
    totalSecuredDebts?: number;
    totalUnsecuredDebts?: number;
    isPPSASearchCompleted?: boolean;
    isInsolvencyNameSearchCompleted?: boolean;
    signupChecklistStatus?: ChecklistStatusEnum;
    signupStatus?: FileProcessStatusDto;
    isTrusteeEngagementAcceptance?: boolean;
    isTrusteeConflictCheck?: boolean;
    followupDate?: moment.Moment | undefined;
    counsellingSessionExistsInAscend?: boolean;
}

export class AdminInfoSignupPublicDto implements IAdminInfoSignupPublicDto {
    fileId?: string;
    preSignupProgress?: PreSignupProgressEnum;

    constructor(data?: IAdminInfoSignupPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.preSignupProgress = _data["preSignupProgress"];
        }
    }

    static fromJS(data: any): AdminInfoSignupPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoSignupPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["preSignupProgress"] = this.preSignupProgress;
        return data;
    }
}

export interface IAdminInfoSignupPublicDto {
    fileId?: string;
    preSignupProgress?: PreSignupProgressEnum;
}

export class AdminInfoSignupUpdateDto implements IAdminInfoSignupUpdateDto {
    isPPSASearchComplete?: boolean;
    isInsolvencyNameSearchComplete?: boolean;
    signupStatus?: FileProcessStatusEnum;
    followupDate?: moment.Moment | undefined;
    confirmUpdateStatusInProgress?: boolean | undefined;

    constructor(data?: IAdminInfoSignupUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPPSASearchComplete = _data["isPPSASearchComplete"];
            this.isInsolvencyNameSearchComplete = _data["isInsolvencyNameSearchComplete"];
            this.signupStatus = _data["signupStatus"];
            this.followupDate = _data["followupDate"] ? moment(_data["followupDate"].toString()) : <any>undefined;
            this.confirmUpdateStatusInProgress = _data["confirmUpdateStatusInProgress"];
        }
    }

    static fromJS(data: any): AdminInfoSignupUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoSignupUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPPSASearchComplete"] = this.isPPSASearchComplete;
        data["isInsolvencyNameSearchComplete"] = this.isInsolvencyNameSearchComplete;
        data["signupStatus"] = this.signupStatus;
        data["followupDate"] = this.followupDate ? this.followupDate.toISOString() : <any>undefined;
        data["confirmUpdateStatusInProgress"] = this.confirmUpdateStatusInProgress;
        return data;
    }
}

export interface IAdminInfoSignupUpdateDto {
    isPPSASearchComplete?: boolean;
    isInsolvencyNameSearchComplete?: boolean;
    signupStatus?: FileProcessStatusEnum;
    followupDate?: moment.Moment | undefined;
    confirmUpdateStatusInProgress?: boolean | undefined;
}

export class AdminInfoTaxReturnUpdateDto implements IAdminInfoTaxReturnUpdateDto {
    taxReturnProcessStatus?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoTaxReturnUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxReturnProcessStatus = _data["taxReturnProcessStatus"];
        }
    }

    static fromJS(data: any): AdminInfoTaxReturnUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoTaxReturnUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxReturnProcessStatus"] = this.taxReturnProcessStatus;
        return data;
    }
}

export interface IAdminInfoTaxReturnUpdateDto {
    taxReturnProcessStatus?: FileProcessStatusEnum;
}

export class ApplicationFileDto implements IApplicationFileDto {
    id?: string;
    applicationFileName?: string | undefined;
    debtorName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    filingTypeEnum?: FilingTypeEnum;
    serviceLocationId?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: FileStageDto;
    descendantFileId?: string | undefined;
    descendantFileType?: AppFileDescendantType;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    migratedFileStage?: FileStageEnum;
    isDuplicate?: boolean | undefined;
    insolvencyDate?: moment.Moment | undefined;
    bankruptcyDuration?: string | undefined;
    copiedFromFileId?: string | undefined;

    constructor(data?: IApplicationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationFileName = _data["applicationFileName"];
            this.debtorName = _data["debtorName"];
            this.estateNumber = _data["estateNumber"];
            this.filingType = _data["filingType"];
            this.filingTypeEnum = _data["filingTypeEnum"];
            this.serviceLocationId = _data["serviceLocationId"];
            this.serviceLocation = _data["serviceLocation"];
            this.agentName = _data["agentName"];
            this.estateAdministrator = _data["estateAdministrator"];
            this.trustee = _data["trustee"];
            this.fileStage = _data["fileStage"] ? FileStageDto.fromJS(_data["fileStage"]) : <any>undefined;
            this.descendantFileId = _data["descendantFileId"];
            this.descendantFileType = _data["descendantFileType"];
            this.courtName = _data["courtName"];
            this.courtNumber = _data["courtNumber"];
            this.isLocked = _data["isLocked"];
            this.isAppFormLocked = _data["isAppFormLocked"];
            this.isMigrated = _data["isMigrated"];
            this.migratedFileStage = _data["migratedFileStage"];
            this.isDuplicate = _data["isDuplicate"];
            this.insolvencyDate = _data["insolvencyDate"] ? moment(_data["insolvencyDate"].toString()) : <any>undefined;
            this.bankruptcyDuration = _data["bankruptcyDuration"];
            this.copiedFromFileId = _data["copiedFromFileId"];
        }
    }

    static fromJS(data: any): ApplicationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationFileName"] = this.applicationFileName;
        data["debtorName"] = this.debtorName;
        data["estateNumber"] = this.estateNumber;
        data["filingType"] = this.filingType;
        data["filingTypeEnum"] = this.filingTypeEnum;
        data["serviceLocationId"] = this.serviceLocationId;
        data["serviceLocation"] = this.serviceLocation;
        data["agentName"] = this.agentName;
        data["estateAdministrator"] = this.estateAdministrator;
        data["trustee"] = this.trustee;
        data["fileStage"] = this.fileStage ? this.fileStage.toJSON() : <any>undefined;
        data["descendantFileId"] = this.descendantFileId;
        data["descendantFileType"] = this.descendantFileType;
        data["courtName"] = this.courtName;
        data["courtNumber"] = this.courtNumber;
        data["isLocked"] = this.isLocked;
        data["isAppFormLocked"] = this.isAppFormLocked;
        data["isMigrated"] = this.isMigrated;
        data["migratedFileStage"] = this.migratedFileStage;
        data["isDuplicate"] = this.isDuplicate;
        data["insolvencyDate"] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
        data["bankruptcyDuration"] = this.bankruptcyDuration;
        data["copiedFromFileId"] = this.copiedFromFileId;
        return data;
    }
}

export interface IApplicationFileDto {
    id?: string;
    applicationFileName?: string | undefined;
    debtorName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    filingTypeEnum?: FilingTypeEnum;
    serviceLocationId?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: FileStageDto;
    descendantFileId?: string | undefined;
    descendantFileType?: AppFileDescendantType;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    migratedFileStage?: FileStageEnum;
    isDuplicate?: boolean | undefined;
    insolvencyDate?: moment.Moment | undefined;
    bankruptcyDuration?: string | undefined;
    copiedFromFileId?: string | undefined;
}

export class FileProcessStatusDto implements IFileProcessStatusDto {
    id?: string;
    fileId?: string;
    fileProcess?: FileProcessDto;
    status?: FileProcessStatusEnum;

    constructor(data?: IFileProcessStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.fileProcess = _data["fileProcess"] ? FileProcessDto.fromJS(_data["fileProcess"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileProcessStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileProcessStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["fileProcess"] = this.fileProcess ? this.fileProcess.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileProcessStatusDto {
    id?: string;
    fileId?: string;
    fileProcess?: FileProcessDto;
    status?: FileProcessStatusEnum;
}

export class FileSearchOutputDto implements IFileSearchOutputDto {
    fileId?: string;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;

    constructor(data?: IFileSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.insolvencyDate = _data["insolvencyDate"] ? moment(_data["insolvencyDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["insolvencyDate"] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileSearchOutputDto {
    fileId?: string;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
}

export class FileStageDto implements IFileStageDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileStageEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFileStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileStageDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileStageEnum;
    code?: string | undefined;
    name?: string | undefined;
}

export class FilingTypeDto implements IFilingTypeDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IFilingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FilingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFilingTypeDto {
    id?: string;
    name?: string | undefined;
}

export class QuickActionsConfigDto implements IQuickActionsConfigDto {
    canReceiveEmail?: boolean;
    canReceiveSMS?: boolean;

    constructor(data?: IQuickActionsConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canReceiveEmail = _data["canReceiveEmail"];
            this.canReceiveSMS = _data["canReceiveSMS"];
        }
    }

    static fromJS(data: any): QuickActionsConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickActionsConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canReceiveEmail"] = this.canReceiveEmail;
        data["canReceiveSMS"] = this.canReceiveSMS;
        return data;
    }
}

export interface IQuickActionsConfigDto {
    canReceiveEmail?: boolean;
    canReceiveSMS?: boolean;
}

export class ReadOnlyFieldsDto implements IReadOnlyFieldsDto {
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: string | undefined;

    constructor(data?: IReadOnlyFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.estateNumber = _data["estateNumber"];
            this.filingType = _data["filingType"];
            this.serviceLocation = _data["serviceLocation"];
            this.agentName = _data["agentName"];
            this.estateAdministrator = _data["estateAdministrator"];
            this.trustee = _data["trustee"];
            this.fileStage = _data["fileStage"];
        }
    }

    static fromJS(data: any): ReadOnlyFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadOnlyFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["estateNumber"] = this.estateNumber;
        data["filingType"] = this.filingType;
        data["serviceLocation"] = this.serviceLocation;
        data["agentName"] = this.agentName;
        data["estateAdministrator"] = this.estateAdministrator;
        data["trustee"] = this.trustee;
        data["fileStage"] = this.fileStage;
        return data;
    }
}

export interface IReadOnlyFieldsDto {
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: string | undefined;
}

export class AppointmentDefaultDurationDto implements IAppointmentDefaultDurationDto {
    defaultDuration?: number;

    constructor(data?: IAppointmentDefaultDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultDuration = _data["defaultDuration"];
        }
    }

    static fromJS(data: any): AppointmentDefaultDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDefaultDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultDuration"] = this.defaultDuration;
        return data;
    }
}

export interface IAppointmentDefaultDurationDto {
    defaultDuration?: number;
}

export class AppointmentDetailsDto implements IAppointmentDetailsDto {
    initialAppointments?: InitialAppointmentsDto;
    appointmentId?: string;
    fileId?: string;
    appointmentDateTime?: moment.Moment;
    meetingTypeId?: string;
    officeLocationId?: string;
    appointmentTypeId?: string;
    agentId?: string;
    appointmentStatusId?: string;
    isWalkIn?: boolean;

    constructor(data?: IAppointmentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialAppointments = _data["initialAppointments"] ? InitialAppointmentsDto.fromJS(_data["initialAppointments"]) : <any>undefined;
            this.appointmentId = _data["appointmentId"];
            this.fileId = _data["fileId"];
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.meetingTypeId = _data["meetingTypeId"];
            this.officeLocationId = _data["officeLocationId"];
            this.appointmentTypeId = _data["appointmentTypeId"];
            this.agentId = _data["agentId"];
            this.appointmentStatusId = _data["appointmentStatusId"];
            this.isWalkIn = _data["isWalkIn"];
        }
    }

    static fromJS(data: any): AppointmentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialAppointments"] = this.initialAppointments ? this.initialAppointments.toJSON() : <any>undefined;
        data["appointmentId"] = this.appointmentId;
        data["fileId"] = this.fileId;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["meetingTypeId"] = this.meetingTypeId;
        data["officeLocationId"] = this.officeLocationId;
        data["appointmentTypeId"] = this.appointmentTypeId;
        data["agentId"] = this.agentId;
        data["appointmentStatusId"] = this.appointmentStatusId;
        data["isWalkIn"] = this.isWalkIn;
        return data;
    }
}

export interface IAppointmentDetailsDto {
    initialAppointments?: InitialAppointmentsDto;
    appointmentId?: string;
    fileId?: string;
    appointmentDateTime?: moment.Moment;
    meetingTypeId?: string;
    officeLocationId?: string;
    appointmentTypeId?: string;
    agentId?: string;
    appointmentStatusId?: string;
    isWalkIn?: boolean;
}

export class AppointmentDto implements IAppointmentDto {
    id?: string;
    fileId?: string;
    meetingType?: MeetingTypeDto;
    appointmentType?: AppointmentTypeDto;
    appointmentStatus?: AppointmentStatusDto;
    appointmentDate?: moment.Moment;
    appointmentEndDate?: moment.Moment | undefined;
    completedDate?: moment.Moment | undefined;
    agent?: AgentDto;
    isWalkIn?: boolean;
    officeLocationId?: string | undefined;
    appointmentDate_DebtorLocal?: string | undefined;

    constructor(data?: IAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.meetingType = _data["meetingType"] ? MeetingTypeDto.fromJS(_data["meetingType"]) : <any>undefined;
            this.appointmentType = _data["appointmentType"] ? AppointmentTypeDto.fromJS(_data["appointmentType"]) : <any>undefined;
            this.appointmentStatus = _data["appointmentStatus"] ? AppointmentStatusDto.fromJS(_data["appointmentStatus"]) : <any>undefined;
            this.appointmentDate = _data["appointmentDate"] ? moment(_data["appointmentDate"].toString()) : <any>undefined;
            this.appointmentEndDate = _data["appointmentEndDate"] ? moment(_data["appointmentEndDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? moment(_data["completedDate"].toString()) : <any>undefined;
            this.agent = _data["agent"] ? AgentDto.fromJS(_data["agent"]) : <any>undefined;
            this.isWalkIn = _data["isWalkIn"];
            this.officeLocationId = _data["officeLocationId"];
            this.appointmentDate_DebtorLocal = _data["appointmentDate_DebtorLocal"];
        }
    }

    static fromJS(data: any): AppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["meetingType"] = this.meetingType ? this.meetingType.toJSON() : <any>undefined;
        data["appointmentType"] = this.appointmentType ? this.appointmentType.toJSON() : <any>undefined;
        data["appointmentStatus"] = this.appointmentStatus ? this.appointmentStatus.toJSON() : <any>undefined;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["appointmentEndDate"] = this.appointmentEndDate ? this.appointmentEndDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["isWalkIn"] = this.isWalkIn;
        data["officeLocationId"] = this.officeLocationId;
        data["appointmentDate_DebtorLocal"] = this.appointmentDate_DebtorLocal;
        return data;
    }
}

export interface IAppointmentDto {
    id?: string;
    fileId?: string;
    meetingType?: MeetingTypeDto;
    appointmentType?: AppointmentTypeDto;
    appointmentStatus?: AppointmentStatusDto;
    appointmentDate?: moment.Moment;
    appointmentEndDate?: moment.Moment | undefined;
    completedDate?: moment.Moment | undefined;
    agent?: AgentDto;
    isWalkIn?: boolean;
    officeLocationId?: string | undefined;
    appointmentDate_DebtorLocal?: string | undefined;
}

export class AppointmentInfoDto implements IAppointmentInfoDto {
    id?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    officeAddress?: string | undefined;
    officeLocationId?: string | undefined;
    startDateTimeLocal?: moment.Moment;
    timeZoneCode?: string | undefined;
    duration?: number;
    meetingTypeId?: string;
    appointmentTypeId?: string;
    appointmentStatusId?: string;
    agentId?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;

    constructor(data?: IAppointmentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.officeAddress = _data["officeAddress"];
            this.officeLocationId = _data["officeLocationId"];
            this.startDateTimeLocal = _data["startDateTimeLocal"] ? moment(_data["startDateTimeLocal"].toString()) : <any>undefined;
            this.timeZoneCode = _data["timeZoneCode"];
            this.duration = _data["duration"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.appointmentTypeId = _data["appointmentTypeId"];
            this.appointmentStatusId = _data["appointmentStatusId"];
            this.agentId = _data["agentId"];
            this.appointmentType = _data["appointmentType"];
            this.agentName = _data["agentName"];
            this.meetingType = _data["meetingType"];
            this.appointmentStatus = _data["appointmentStatus"];
        }
    }

    static fromJS(data: any): AppointmentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["officeAddress"] = this.officeAddress;
        data["officeLocationId"] = this.officeLocationId;
        data["startDateTimeLocal"] = this.startDateTimeLocal ? this.startDateTimeLocal.toISOString() : <any>undefined;
        data["timeZoneCode"] = this.timeZoneCode;
        data["duration"] = this.duration;
        data["meetingTypeId"] = this.meetingTypeId;
        data["appointmentTypeId"] = this.appointmentTypeId;
        data["appointmentStatusId"] = this.appointmentStatusId;
        data["agentId"] = this.agentId;
        data["appointmentType"] = this.appointmentType;
        data["agentName"] = this.agentName;
        data["meetingType"] = this.meetingType;
        data["appointmentStatus"] = this.appointmentStatus;
        return data;
    }
}

export interface IAppointmentInfoDto {
    id?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    officeAddress?: string | undefined;
    officeLocationId?: string | undefined;
    startDateTimeLocal?: moment.Moment;
    timeZoneCode?: string | undefined;
    duration?: number;
    meetingTypeId?: string;
    appointmentTypeId?: string;
    appointmentStatusId?: string;
    agentId?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;
}

export class AppointmentStatusDto implements IAppointmentStatusDto {
    orderNumber?: number;
    enumValue?: AppointmentStatusEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAppointmentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppointmentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppointmentStatusDto {
    orderNumber?: number;
    enumValue?: AppointmentStatusEnum;
    code?: string | undefined;
    name?: string | undefined;
}

export class AppointmentTimeSlotDto implements IAppointmentTimeSlotDto {
    time?: moment.Moment;
    utcTime?: moment.Moment;
    appointmentDuration?: number;
    timeZone?: LookupDto;
    debtorPreferredLanguage?: string | undefined;
    availableAgents?: AvailableAgentDto[] | undefined;

    constructor(data?: IAppointmentTimeSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            this.utcTime = _data["utcTime"] ? moment(_data["utcTime"].toString()) : <any>undefined;
            this.appointmentDuration = _data["appointmentDuration"];
            this.timeZone = _data["timeZone"] ? LookupDto.fromJS(_data["timeZone"]) : <any>undefined;
            this.debtorPreferredLanguage = _data["debtorPreferredLanguage"];
            if (Array.isArray(_data["availableAgents"])) {
                this.availableAgents = [] as any;
                for (let item of _data["availableAgents"])
                    this.availableAgents!.push(AvailableAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppointmentTimeSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentTimeSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["utcTime"] = this.utcTime ? this.utcTime.toISOString() : <any>undefined;
        data["appointmentDuration"] = this.appointmentDuration;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        data["debtorPreferredLanguage"] = this.debtorPreferredLanguage;
        if (Array.isArray(this.availableAgents)) {
            data["availableAgents"] = [];
            for (let item of this.availableAgents)
                data["availableAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppointmentTimeSlotDto {
    time?: moment.Moment;
    utcTime?: moment.Moment;
    appointmentDuration?: number;
    timeZone?: LookupDto;
    debtorPreferredLanguage?: string | undefined;
    availableAgents?: AvailableAgentDto[] | undefined;
}

export class AppointmentTypeDto implements IAppointmentTypeDto {
    orderNumber?: number;
    enumValue?: AppointmentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAppointmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppointmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppointmentTypeDto {
    orderNumber?: number;
    enumValue?: AppointmentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;
}

export class AvailableAgentDto implements IAvailableAgentDto {
    agentId?: string;
    meetingTypes?: LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    azObjectId?: string | undefined;
    noOfPDSAppointmentsForDay?: number;
    weeklyAverageOfPDSAppointments?: number;
    emailAddress?: string | undefined;
    meetingNote?: string | undefined;
    preferredLanguage?: string | undefined;

    constructor(data?: IAvailableAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["meetingTypes"])) {
                this.meetingTypes = [] as any;
                for (let item of _data["meetingTypes"])
                    this.meetingTypes!.push(LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.azObjectId = _data["azObjectId"];
            this.noOfPDSAppointmentsForDay = _data["noOfPDSAppointmentsForDay"];
            this.weeklyAverageOfPDSAppointments = _data["weeklyAverageOfPDSAppointments"];
            this.emailAddress = _data["emailAddress"];
            this.meetingNote = _data["meetingNote"];
            this.preferredLanguage = _data["preferredLanguage"];
        }
    }

    static fromJS(data: any): AvailableAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        if (Array.isArray(this.meetingTypes)) {
            data["meetingTypes"] = [];
            for (let item of this.meetingTypes)
                data["meetingTypes"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["azObjectId"] = this.azObjectId;
        data["noOfPDSAppointmentsForDay"] = this.noOfPDSAppointmentsForDay;
        data["weeklyAverageOfPDSAppointments"] = this.weeklyAverageOfPDSAppointments;
        data["emailAddress"] = this.emailAddress;
        data["meetingNote"] = this.meetingNote;
        data["preferredLanguage"] = this.preferredLanguage;
        return data;
    }
}

export interface IAvailableAgentDto {
    agentId?: string;
    meetingTypes?: LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    azObjectId?: string | undefined;
    noOfPDSAppointmentsForDay?: number;
    weeklyAverageOfPDSAppointments?: number;
    emailAddress?: string | undefined;
    meetingNote?: string | undefined;
    preferredLanguage?: string | undefined;
}

export class AvailableTimeSlotsDto implements IAvailableTimeSlotsDto {
    timeZone?: string | undefined;
    timeSlots?: moment.Moment[] | undefined;

    constructor(data?: IAvailableTimeSlotsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["timeSlots"])) {
                this.timeSlots = [] as any;
                for (let item of _data["timeSlots"])
                    this.timeSlots!.push(moment(item));
            }
        }
    }

    static fromJS(data: any): AvailableTimeSlotsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableTimeSlotsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.timeSlots)) {
            data["timeSlots"] = [];
            for (let item of this.timeSlots)
                data["timeSlots"].push(item.toISOString());
        }
        return data;
    }
}

export interface IAvailableTimeSlotsDto {
    timeZone?: string | undefined;
    timeSlots?: moment.Moment[] | undefined;
}

export class BookAppointmentInput implements IBookAppointmentInput {
    fileId?: string;
    appointmentDateTime?: moment.Moment;
    meetingTypeId?: string;
    officeLocationId?: string;
    appointmentTypeId?: string;
    agentId?: string;
    duration?: number;
    isWalkIn?: boolean;

    constructor(data?: IBookAppointmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.meetingTypeId = _data["meetingTypeId"];
            this.officeLocationId = _data["officeLocationId"];
            this.appointmentTypeId = _data["appointmentTypeId"];
            this.agentId = _data["agentId"];
            this.duration = _data["duration"];
            this.isWalkIn = _data["isWalkIn"];
        }
    }

    static fromJS(data: any): BookAppointmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new BookAppointmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["meetingTypeId"] = this.meetingTypeId;
        data["officeLocationId"] = this.officeLocationId;
        data["appointmentTypeId"] = this.appointmentTypeId;
        data["agentId"] = this.agentId;
        data["duration"] = this.duration;
        data["isWalkIn"] = this.isWalkIn;
        return data;
    }
}

export interface IBookAppointmentInput {
    fileId?: string;
    appointmentDateTime?: moment.Moment;
    meetingTypeId?: string;
    officeLocationId?: string;
    appointmentTypeId?: string;
    agentId?: string;
    duration?: number;
    isWalkIn?: boolean;
}

export class BookAppointmentInputPublicDto implements IBookAppointmentInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;

    constructor(data?: IBookAppointmentInputPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.meetingTypeEnum = _data["meetingTypeEnum"];
            this.officeLocationId = _data["officeLocationId"];
        }
    }

    static fromJS(data: any): BookAppointmentInputPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookAppointmentInputPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["meetingTypeEnum"] = this.meetingTypeEnum;
        data["officeLocationId"] = this.officeLocationId;
        return data;
    }
}

export interface IBookAppointmentInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
}

export class BookInitialAppointmenInputPublicDto implements IBookInitialAppointmenInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
    agentId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
    isEmailPhoneEnabled?: boolean;
    isPreferedLanguageEnglish?: boolean;
    url?: string | undefined;

    constructor(data?: IBookInitialAppointmenInputPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.meetingTypeEnum = _data["meetingTypeEnum"];
            this.officeLocationId = _data["officeLocationId"];
            this.agentId = _data["agentId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.referralSourceTypeId = _data["referralSourceTypeId"];
            this.referralDetails = _data["referralDetails"];
            this.isEmailPhoneEnabled = _data["isEmailPhoneEnabled"];
            this.isPreferedLanguageEnglish = _data["isPreferedLanguageEnglish"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BookInitialAppointmenInputPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookInitialAppointmenInputPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["meetingTypeEnum"] = this.meetingTypeEnum;
        data["officeLocationId"] = this.officeLocationId;
        data["agentId"] = this.agentId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["referralSourceTypeId"] = this.referralSourceTypeId;
        data["referralDetails"] = this.referralDetails;
        data["isEmailPhoneEnabled"] = this.isEmailPhoneEnabled;
        data["isPreferedLanguageEnglish"] = this.isPreferedLanguageEnglish;
        data["url"] = this.url;
        return data;
    }
}

export interface IBookInitialAppointmenInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
    agentId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
    isEmailPhoneEnabled?: boolean;
    isPreferedLanguageEnglish?: boolean;
    url?: string | undefined;
}

export class EditAppointmentInput implements IEditAppointmentInput {
    appointmentId?: string;
    appointmentStatusId?: string;
    appointmentDateTime?: moment.Moment;
    officeLocationId?: string;
    meetingTypeId?: string;
    agentId?: string;
    duration?: number;

    constructor(data?: IEditAppointmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.appointmentStatusId = _data["appointmentStatusId"];
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.officeLocationId = _data["officeLocationId"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.agentId = _data["agentId"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): EditAppointmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppointmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["appointmentStatusId"] = this.appointmentStatusId;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["officeLocationId"] = this.officeLocationId;
        data["meetingTypeId"] = this.meetingTypeId;
        data["agentId"] = this.agentId;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IEditAppointmentInput {
    appointmentId?: string;
    appointmentStatusId?: string;
    appointmentDateTime?: moment.Moment;
    officeLocationId?: string;
    meetingTypeId?: string;
    agentId?: string;
    duration?: number;
}

export class InitialAppointmentsDto implements IInitialAppointmentsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    appointmentTypes?: LookupDto[] | undefined;
    officeLocations?: OfficeLocationDto[] | undefined;
    earliestAvailableDate?: moment.Moment;
    appointmentTimeSlots?: AppointmentTimeSlotDto[] | undefined;
    appointmentDetails?: AppointmentDetailsDto;

    constructor(data?: IInitialAppointmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["appointmentTypes"])) {
                this.appointmentTypes = [] as any;
                for (let item of _data["appointmentTypes"])
                    this.appointmentTypes!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["officeLocations"])) {
                this.officeLocations = [] as any;
                for (let item of _data["officeLocations"])
                    this.officeLocations!.push(OfficeLocationDto.fromJS(item));
            }
            this.earliestAvailableDate = _data["earliestAvailableDate"] ? moment(_data["earliestAvailableDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["appointmentTimeSlots"])) {
                this.appointmentTimeSlots = [] as any;
                for (let item of _data["appointmentTimeSlots"])
                    this.appointmentTimeSlots!.push(AppointmentTimeSlotDto.fromJS(item));
            }
            this.appointmentDetails = _data["appointmentDetails"] ? AppointmentDetailsDto.fromJS(_data["appointmentDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InitialAppointmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitialAppointmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.appointmentTypes)) {
            data["appointmentTypes"] = [];
            for (let item of this.appointmentTypes)
                data["appointmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.officeLocations)) {
            data["officeLocations"] = [];
            for (let item of this.officeLocations)
                data["officeLocations"].push(item.toJSON());
        }
        data["earliestAvailableDate"] = this.earliestAvailableDate ? this.earliestAvailableDate.toISOString() : <any>undefined;
        if (Array.isArray(this.appointmentTimeSlots)) {
            data["appointmentTimeSlots"] = [];
            for (let item of this.appointmentTimeSlots)
                data["appointmentTimeSlots"].push(item.toJSON());
        }
        data["appointmentDetails"] = this.appointmentDetails ? this.appointmentDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInitialAppointmentsDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    appointmentTypes?: LookupDto[] | undefined;
    officeLocations?: OfficeLocationDto[] | undefined;
    earliestAvailableDate?: moment.Moment;
    appointmentTimeSlots?: AppointmentTimeSlotDto[] | undefined;
    appointmentDetails?: AppointmentDetailsDto;
}

export class MeetingTypeDto implements IMeetingTypeDto {
    orderNumber?: number;
    enumValue?: MeetingTypeEnum;
    code?: string | undefined;
    name?: string | undefined;
    enabled?: boolean;

    constructor(data?: IMeetingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): MeetingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IMeetingTypeDto {
    orderNumber?: number;
    enumValue?: MeetingTypeEnum;
    code?: string | undefined;
    name?: string | undefined;
    enabled?: boolean;
}

export class ReserveAppointmentDto implements IReserveAppointmentDto {
    dateTime?: moment.Moment;
    officeLocationId?: string;
    isPreferedLanguageEnglish?: boolean;
    meetingTypeEnum?: MeetingTypeEnum;
    agentIds?: string[] | undefined;

    constructor(data?: IReserveAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.officeLocationId = _data["officeLocationId"];
            this.isPreferedLanguageEnglish = _data["isPreferedLanguageEnglish"];
            this.meetingTypeEnum = _data["meetingTypeEnum"];
            if (Array.isArray(_data["agentIds"])) {
                this.agentIds = [] as any;
                for (let item of _data["agentIds"])
                    this.agentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReserveAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReserveAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["officeLocationId"] = this.officeLocationId;
        data["isPreferedLanguageEnglish"] = this.isPreferedLanguageEnglish;
        data["meetingTypeEnum"] = this.meetingTypeEnum;
        if (Array.isArray(this.agentIds)) {
            data["agentIds"] = [];
            for (let item of this.agentIds)
                data["agentIds"].push(item);
        }
        return data;
    }
}

export interface IReserveAppointmentDto {
    dateTime?: moment.Moment;
    officeLocationId?: string;
    isPreferedLanguageEnglish?: boolean;
    meetingTypeEnum?: MeetingTypeEnum;
    agentIds?: string[] | undefined;
}

export class UpdateAppointmentPublicDto implements IUpdateAppointmentPublicDto {
    appointmentId?: string;
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;

    constructor(data?: IUpdateAppointmentPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.meetingTypeEnum = _data["meetingTypeEnum"];
            this.officeLocationId = _data["officeLocationId"];
        }
    }

    static fromJS(data: any): UpdateAppointmentPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["meetingTypeEnum"] = this.meetingTypeEnum;
        data["officeLocationId"] = this.officeLocationId;
        return data;
    }
}

export interface IUpdateAppointmentPublicDto {
    appointmentId?: string;
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
}

export class ViewAppointmentsResultDto implements IViewAppointmentsResultDto {
    fileName?: string | undefined;
    fileId?: string;
    appointmentId?: string;
    appointmentStartTime?: moment.Moment;
    appointmentEndTime?: moment.Moment;
    officeLocation?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;
    address?: string | undefined;

    constructor(data?: IViewAppointmentsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileId = _data["fileId"];
            this.appointmentId = _data["appointmentId"];
            this.appointmentStartTime = _data["appointmentStartTime"] ? moment(_data["appointmentStartTime"].toString()) : <any>undefined;
            this.appointmentEndTime = _data["appointmentEndTime"] ? moment(_data["appointmentEndTime"].toString()) : <any>undefined;
            this.officeLocation = _data["officeLocation"];
            this.appointmentType = _data["appointmentType"];
            this.agentName = _data["agentName"];
            this.meetingType = _data["meetingType"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): ViewAppointmentsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewAppointmentsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileId"] = this.fileId;
        data["appointmentId"] = this.appointmentId;
        data["appointmentStartTime"] = this.appointmentStartTime ? this.appointmentStartTime.toISOString() : <any>undefined;
        data["appointmentEndTime"] = this.appointmentEndTime ? this.appointmentEndTime.toISOString() : <any>undefined;
        data["officeLocation"] = this.officeLocation;
        data["appointmentType"] = this.appointmentType;
        data["agentName"] = this.agentName;
        data["meetingType"] = this.meetingType;
        data["appointmentStatus"] = this.appointmentStatus;
        data["address"] = this.address;
        return data;
    }
}

export interface IViewAppointmentsResultDto {
    fileName?: string | undefined;
    fileId?: string;
    appointmentId?: string;
    appointmentStartTime?: moment.Moment;
    appointmentEndTime?: moment.Moment;
    officeLocation?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;
    address?: string | undefined;
}

export class AdminInfoBankingDto implements IAdminInfoBankingDto {
    bankingProcessStatus?: FileProcessStatusEnum;
    activePadInformation?: string | undefined;
    pendingChangeRequestId?: string | undefined;

    constructor(data?: IAdminInfoBankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankingProcessStatus = _data["bankingProcessStatus"];
            this.activePadInformation = _data["activePadInformation"];
            this.pendingChangeRequestId = _data["pendingChangeRequestId"];
        }
    }

    static fromJS(data: any): AdminInfoBankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoBankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankingProcessStatus"] = this.bankingProcessStatus;
        data["activePadInformation"] = this.activePadInformation;
        data["pendingChangeRequestId"] = this.pendingChangeRequestId;
        return data;
    }
}

export interface IAdminInfoBankingDto {
    bankingProcessStatus?: FileProcessStatusEnum;
    activePadInformation?: string | undefined;
    pendingChangeRequestId?: string | undefined;
}

export class BalanceInfoDto implements IBalanceInfoDto {
    startingBalance?: number;
    paidBalance?: number;

    constructor(data?: IBalanceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startingBalance = _data["startingBalance"];
            this.paidBalance = _data["paidBalance"];
        }
    }

    static fromJS(data: any): BalanceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startingBalance"] = this.startingBalance;
        data["paidBalance"] = this.paidBalance;
        return data;
    }
}

export interface IBalanceInfoDto {
    startingBalance?: number;
    paidBalance?: number;
}

export class PADInfoChangeRequestCreateDto implements IPADInfoChangeRequestCreateDto {
    reviewStatus?: PADRequestReviewStatusEnum;
    rejectionReason?: string | undefined;
    agentId?: string | undefined;
    customerId?: string | undefined;
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;

    constructor(data?: IPADInfoChangeRequestCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewStatus = _data["reviewStatus"];
            this.rejectionReason = _data["rejectionReason"];
            this.agentId = _data["agentId"];
            this.customerId = _data["customerId"];
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.accountNumber = _data["accountNumber"];
            this.transitNumber = _data["transitNumber"];
            this.branchNumber = _data["branchNumber"];
        }
    }

    static fromJS(data: any): PADInfoChangeRequestCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADInfoChangeRequestCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewStatus"] = this.reviewStatus;
        data["rejectionReason"] = this.rejectionReason;
        data["agentId"] = this.agentId;
        data["customerId"] = this.customerId;
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["accountNumber"] = this.accountNumber;
        data["transitNumber"] = this.transitNumber;
        data["branchNumber"] = this.branchNumber;
        return data;
    }
}

export interface IPADInfoChangeRequestCreateDto {
    reviewStatus?: PADRequestReviewStatusEnum;
    rejectionReason?: string | undefined;
    agentId?: string | undefined;
    customerId?: string | undefined;
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
}

export class PADInfoChangeRequestCreatePublicDto implements IPADInfoChangeRequestCreatePublicDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IPADInfoChangeRequestCreatePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.accountNumber = _data["accountNumber"];
            this.transitNumber = _data["transitNumber"];
            this.branchNumber = _data["branchNumber"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PADInfoChangeRequestCreatePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADInfoChangeRequestCreatePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["accountNumber"] = this.accountNumber;
        data["transitNumber"] = this.transitNumber;
        data["branchNumber"] = this.branchNumber;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IPADInfoChangeRequestCreatePublicDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    documentIds?: string[] | undefined;
}

export class PADInfoChangeRequestDto implements IPADInfoChangeRequestDto {
    id?: string;
    reviewStatus?: PADRequestReviewStatusEnum;
    rejectionReason?: string | undefined;
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    updatedBy?: string | undefined;
    updateOn?: moment.Moment | undefined;
    requestedBy?: string | undefined;
    requestedOn?: moment.Moment | undefined;

    constructor(data?: IPADInfoChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reviewStatus = _data["reviewStatus"];
            this.rejectionReason = _data["rejectionReason"];
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.accountNumber = _data["accountNumber"];
            this.transitNumber = _data["transitNumber"];
            this.branchNumber = _data["branchNumber"];
            this.updatedBy = _data["updatedBy"];
            this.updateOn = _data["updateOn"] ? moment(_data["updateOn"].toString()) : <any>undefined;
            this.requestedBy = _data["requestedBy"];
            this.requestedOn = _data["requestedOn"] ? moment(_data["requestedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PADInfoChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADInfoChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reviewStatus"] = this.reviewStatus;
        data["rejectionReason"] = this.rejectionReason;
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["accountNumber"] = this.accountNumber;
        data["transitNumber"] = this.transitNumber;
        data["branchNumber"] = this.branchNumber;
        data["updatedBy"] = this.updatedBy;
        data["updateOn"] = this.updateOn ? this.updateOn.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPADInfoChangeRequestDto {
    id?: string;
    reviewStatus?: PADRequestReviewStatusEnum;
    rejectionReason?: string | undefined;
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    updatedBy?: string | undefined;
    updateOn?: moment.Moment | undefined;
    requestedBy?: string | undefined;
    requestedOn?: moment.Moment | undefined;
}

export class PADInfoChangeRequestUpdateDto implements IPADInfoChangeRequestUpdateDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;

    constructor(data?: IPADInfoChangeRequestUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.accountNumber = _data["accountNumber"];
            this.transitNumber = _data["transitNumber"];
            this.branchNumber = _data["branchNumber"];
        }
    }

    static fromJS(data: any): PADInfoChangeRequestUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADInfoChangeRequestUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["accountNumber"] = this.accountNumber;
        data["transitNumber"] = this.transitNumber;
        data["branchNumber"] = this.branchNumber;
        return data;
    }
}

export interface IPADInfoChangeRequestUpdateDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
}

export class PADScheduleDto implements IPADScheduleDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    externalPadScheduleId?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    deposited?: number;
    isDeposited?: boolean;
    isPending?: boolean;
    paymentStatus?: PADSchedulePaymentStatusEnum;
    agrNo?: number;
    hasReceipts?: boolean;

    constructor(data?: IPADScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.holdUntil = _data["holdUntil"] ? moment(_data["holdUntil"].toString()) : <any>undefined;
            this.holdReason = _data["holdReason"];
            this.externalPadScheduleId = _data["externalPadScheduleId"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.no = _data["no"];
            this.amount = _data["amount"];
            this.deposited = _data["deposited"];
            this.isDeposited = _data["isDeposited"];
            this.isPending = _data["isPending"];
            this.paymentStatus = _data["paymentStatus"];
            this.agrNo = _data["agrNo"];
            this.hasReceipts = _data["hasReceipts"];
        }
    }

    static fromJS(data: any): PADScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["holdUntil"] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
        data["holdReason"] = this.holdReason;
        data["externalPadScheduleId"] = this.externalPadScheduleId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["no"] = this.no;
        data["amount"] = this.amount;
        data["deposited"] = this.deposited;
        data["isDeposited"] = this.isDeposited;
        data["isPending"] = this.isPending;
        data["paymentStatus"] = this.paymentStatus;
        data["agrNo"] = this.agrNo;
        data["hasReceipts"] = this.hasReceipts;
        return data;
    }
}

export interface IPADScheduleDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    externalPadScheduleId?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    deposited?: number;
    isDeposited?: boolean;
    isPending?: boolean;
    paymentStatus?: PADSchedulePaymentStatusEnum;
    agrNo?: number;
    hasReceipts?: boolean;
}

export class PADScheduleHistoryDto implements IPADScheduleHistoryDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    rejectionReason?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    status?: string | undefined;
    agrNo?: number;
    updatedBy?: string | undefined;
    updatedOn?: moment.Moment | undefined;
    requestedBy?: string | undefined;
    requestedOn?: moment.Moment | undefined;

    constructor(data?: IPADScheduleHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.holdUntil = _data["holdUntil"] ? moment(_data["holdUntil"].toString()) : <any>undefined;
            this.holdReason = _data["holdReason"];
            this.rejectionReason = _data["rejectionReason"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.no = _data["no"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.agrNo = _data["agrNo"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.requestedBy = _data["requestedBy"];
            this.requestedOn = _data["requestedOn"] ? moment(_data["requestedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PADScheduleHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADScheduleHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["holdUntil"] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
        data["holdReason"] = this.holdReason;
        data["rejectionReason"] = this.rejectionReason;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["no"] = this.no;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["agrNo"] = this.agrNo;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPADScheduleHistoryDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    rejectionReason?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    status?: string | undefined;
    agrNo?: number;
    updatedBy?: string | undefined;
    updatedOn?: moment.Moment | undefined;
    requestedBy?: string | undefined;
    requestedOn?: moment.Moment | undefined;
}

export class PADScheduleUpdateDto implements IPADScheduleUpdateDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    rejectionReason?: string | undefined;

    constructor(data?: IPADScheduleUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.holdUntil = _data["holdUntil"] ? moment(_data["holdUntil"].toString()) : <any>undefined;
            this.holdReason = _data["holdReason"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): PADScheduleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADScheduleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["holdUntil"] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
        data["holdReason"] = this.holdReason;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IPADScheduleUpdateDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    rejectionReason?: string | undefined;
}

export class PADScheduleUpdatePublicDto implements IPADScheduleUpdatePublicDto {
    id?: string;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    state?: PADScheduleStateEnum;

    constructor(data?: IPADScheduleUpdatePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.holdUntil = _data["holdUntil"] ? moment(_data["holdUntil"].toString()) : <any>undefined;
            this.holdReason = _data["holdReason"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PADScheduleUpdatePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PADScheduleUpdatePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["holdUntil"] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
        data["holdReason"] = this.holdReason;
        data["state"] = this.state;
        return data;
    }
}

export interface IPADScheduleUpdatePublicDto {
    id?: string;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    state?: PADScheduleStateEnum;
}

export class PadScheduleSelectListItemDto implements IPadScheduleSelectListItemDto {
    id?: string;
    dueDate?: moment.Moment | undefined;
    voucherNumber?: string | undefined;
    amountDue?: number;

    constructor(data?: IPadScheduleSelectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.voucherNumber = _data["voucherNumber"];
            this.amountDue = _data["amountDue"];
        }
    }

    static fromJS(data: any): PadScheduleSelectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PadScheduleSelectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["voucherNumber"] = this.voucherNumber;
        data["amountDue"] = this.amountDue;
        return data;
    }
}

export interface IPadScheduleSelectListItemDto {
    id?: string;
    dueDate?: moment.Moment | undefined;
    voucherNumber?: string | undefined;
    amountDue?: number;
}

export class PublicPADInfoDto implements IPublicPADInfoDto {
    accountOwner?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    userCanSendChangeRequest?: boolean;

    constructor(data?: IPublicPADInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountOwner = _data["accountOwner"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankTransitNumber = _data["bankTransitNumber"];
            this.bankBranchNumber = _data["bankBranchNumber"];
            this.userCanSendChangeRequest = _data["userCanSendChangeRequest"];
        }
    }

    static fromJS(data: any): PublicPADInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPADInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountOwner"] = this.accountOwner;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankTransitNumber"] = this.bankTransitNumber;
        data["bankBranchNumber"] = this.bankBranchNumber;
        data["userCanSendChangeRequest"] = this.userCanSendChangeRequest;
        return data;
    }
}

export interface IPublicPADInfoDto {
    accountOwner?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    userCanSendChangeRequest?: boolean;
}

export class ChecklistProgressDto implements IChecklistProgressDto {
    readonly checklistId?: string;
    readonly title?: string | undefined;
    readonly fileId?: string;
    checklistStatus?: ChecklistStatusEnum;
    checklistType?: ChecklistTypeEnum;
    readonly ordernumber?: number;
    readonly totalItems?: number;
    readonly totalComplete?: number;
    readonly totalIncomplete?: number;

    constructor(data?: IChecklistProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).checklistId = _data["checklistId"];
            (<any>this).title = _data["title"];
            (<any>this).fileId = _data["fileId"];
            this.checklistStatus = _data["checklistStatus"];
            this.checklistType = _data["checklistType"];
            (<any>this).ordernumber = _data["ordernumber"];
            (<any>this).totalItems = _data["totalItems"];
            (<any>this).totalComplete = _data["totalComplete"];
            (<any>this).totalIncomplete = _data["totalIncomplete"];
        }
    }

    static fromJS(data: any): ChecklistProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistId"] = this.checklistId;
        data["title"] = this.title;
        data["fileId"] = this.fileId;
        data["checklistStatus"] = this.checklistStatus;
        data["checklistType"] = this.checklistType;
        data["ordernumber"] = this.ordernumber;
        data["totalItems"] = this.totalItems;
        data["totalComplete"] = this.totalComplete;
        data["totalIncomplete"] = this.totalIncomplete;
        return data;
    }
}

export interface IChecklistProgressDto {
    checklistId?: string;
    title?: string | undefined;
    fileId?: string;
    checklistStatus?: ChecklistStatusEnum;
    checklistType?: ChecklistTypeEnum;
    ordernumber?: number;
    totalItems?: number;
    totalComplete?: number;
    totalIncomplete?: number;
}

export class ChecklistDto implements IChecklistDto {
    id?: string;
    title?: string | undefined;
    filingType?: FilingTypeDto;
    assetId?: string | undefined;
    checklistType?: ChecklistTypeEnum;
    checklistStatus?: ChecklistStatusEnum;
    checklistItems?: ChecklistItemDto[] | undefined;

    constructor(data?: IChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.filingType = _data["filingType"] ? FilingTypeDto.fromJS(_data["filingType"]) : <any>undefined;
            this.assetId = _data["assetId"];
            this.checklistType = _data["checklistType"];
            this.checklistStatus = _data["checklistStatus"];
            if (Array.isArray(_data["checklistItems"])) {
                this.checklistItems = [] as any;
                for (let item of _data["checklistItems"])
                    this.checklistItems!.push(ChecklistItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["filingType"] = this.filingType ? this.filingType.toJSON() : <any>undefined;
        data["assetId"] = this.assetId;
        data["checklistType"] = this.checklistType;
        data["checklistStatus"] = this.checklistStatus;
        if (Array.isArray(this.checklistItems)) {
            data["checklistItems"] = [];
            for (let item of this.checklistItems)
                data["checklistItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistDto {
    id?: string;
    title?: string | undefined;
    filingType?: FilingTypeDto;
    assetId?: string | undefined;
    checklistType?: ChecklistTypeEnum;
    checklistStatus?: ChecklistStatusEnum;
    checklistItems?: ChecklistItemDto[] | undefined;
}

export class ChecklistItemDto implements IChecklistItemDto {
    id?: string;
    label?: string | undefined;
    isChecked?: boolean;
    isNotApplicable?: boolean;

    constructor(data?: IChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.isChecked = _data["isChecked"];
            this.isNotApplicable = _data["isNotApplicable"];
        }
    }

    static fromJS(data: any): ChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["isChecked"] = this.isChecked;
        data["isNotApplicable"] = this.isNotApplicable;
        return data;
    }
}

export interface IChecklistItemDto {
    id?: string;
    label?: string | undefined;
    isChecked?: boolean;
    isNotApplicable?: boolean;
}

export class ChecklistItemUpdateDto implements IChecklistItemUpdateDto {
    id?: string;
    isChecked?: boolean;
    isNotApplicable?: boolean;

    constructor(data?: IChecklistItemUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isChecked = _data["isChecked"];
            this.isNotApplicable = _data["isNotApplicable"];
        }
    }

    static fromJS(data: any): ChecklistItemUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistItemUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isChecked"] = this.isChecked;
        data["isNotApplicable"] = this.isNotApplicable;
        return data;
    }
}

export interface IChecklistItemUpdateDto {
    id?: string;
    isChecked?: boolean;
    isNotApplicable?: boolean;
}

export class ChecklistUpdateDto implements IChecklistUpdateDto {
    id?: string;
    assetId?: string | undefined;
    checklistStatus?: ChecklistStatusEnum;
    checklistItems?: ChecklistItemUpdateDto[] | undefined;

    constructor(data?: IChecklistUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.checklistStatus = _data["checklistStatus"];
            if (Array.isArray(_data["checklistItems"])) {
                this.checklistItems = [] as any;
                for (let item of _data["checklistItems"])
                    this.checklistItems!.push(ChecklistItemUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["checklistStatus"] = this.checklistStatus;
        if (Array.isArray(this.checklistItems)) {
            data["checklistItems"] = [];
            for (let item of this.checklistItems)
                data["checklistItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistUpdateDto {
    id?: string;
    assetId?: string | undefined;
    checklistStatus?: ChecklistStatusEnum;
    checklistItems?: ChecklistItemUpdateDto[] | undefined;
}

export class AlertCreateDto implements IAlertCreateDto {
    agentIds?: string[] | undefined;
    teamIds?: string[] | undefined;
    note?: string | undefined;

    constructor(data?: IAlertCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agentIds"])) {
                this.agentIds = [] as any;
                for (let item of _data["agentIds"])
                    this.agentIds!.push(item);
            }
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AlertCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agentIds)) {
            data["agentIds"] = [];
            for (let item of this.agentIds)
                data["agentIds"].push(item);
        }
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        data["note"] = this.note;
        return data;
    }
}

export interface IAlertCreateDto {
    agentIds?: string[] | undefined;
    teamIds?: string[] | undefined;
    note?: string | undefined;
}

export class ClaimFileDetailDto implements IClaimFileDetailDto {
    id?: string;
    fileId?: string | undefined;
    state?: ClaimFileStateEnum;
    isSecured?: boolean;
    result?: ClaimFileStatusEnum;
    isDiscrepancy?: boolean | undefined;
    emailTemplateId?: string | undefined;
    claimStatus?: string | undefined;
    unsecuredSOAAmount?: number;
    securedSOAAmount?: number;
    externalFiledAmount?: number;
    externalVote?: ClaimVote;
    externalVoteOther?: string | undefined;
    externalIsMeetingRequested?: boolean | undefined;
    externalVotedBy?: ClaimVotedBy;
    externalVotedByOther?: string | undefined;
    filedAmount?: number;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isMeetingRequestedOther?: string | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    receivedOn?: moment.Moment;
    documentIds?: string[] | undefined;
    checklistDocumentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: ClaimFileInfoDto;

    constructor(data?: IClaimFileDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.state = _data["state"];
            this.isSecured = _data["isSecured"];
            this.result = _data["result"];
            this.isDiscrepancy = _data["isDiscrepancy"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.claimStatus = _data["claimStatus"];
            this.unsecuredSOAAmount = _data["unsecuredSOAAmount"];
            this.securedSOAAmount = _data["securedSOAAmount"];
            this.externalFiledAmount = _data["externalFiledAmount"];
            this.externalVote = _data["externalVote"];
            this.externalVoteOther = _data["externalVoteOther"];
            this.externalIsMeetingRequested = _data["externalIsMeetingRequested"];
            this.externalVotedBy = _data["externalVotedBy"];
            this.externalVotedByOther = _data["externalVotedByOther"];
            this.filedAmount = _data["filedAmount"];
            this.votedBy = _data["votedBy"];
            this.vote = _data["vote"];
            this.isMeetingRequested = _data["isMeetingRequested"];
            this.isMeetingRequestedOther = _data["isMeetingRequestedOther"];
            this.isClaimAmountMatching = _data["isClaimAmountMatching"];
            this.isSecurityAgreementAvailable = _data["isSecurityAgreementAvailable"];
            this.isSecurityRegistrationAvailable = _data["isSecurityRegistrationAvailable"];
            this.isRegistrationDescriptionMatching = _data["isRegistrationDescriptionMatching"];
            this.securityRegistrationDate = _data["securityRegistrationDate"] ? moment(_data["securityRegistrationDate"].toString()) : <any>undefined;
            this.isThereAnEquity = _data["isThereAnEquity"];
            this.is170ReportRequested = _data["is170ReportRequested"];
            this.receivedOn = _data["receivedOn"] ? moment(_data["receivedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["checklistDocumentIds"])) {
                this.checklistDocumentIds = [] as any;
                for (let item of _data["checklistDocumentIds"])
                    this.checklistDocumentIds!.push(item);
            }
            this.importedEmailSubject = _data["importedEmailSubject"];
            this.importedEmailBody = _data["importedEmailBody"];
            this.importedEmailRecipientEmailAddress = _data["importedEmailRecipientEmailAddress"];
            this.importedEmailRecipientName = _data["importedEmailRecipientName"];
            this.importedEmailSenderEmailAddress = _data["importedEmailSenderEmailAddress"];
            this.importedEmailSenderName = _data["importedEmailSenderName"];
            this.info = _data["info"] ? ClaimFileInfoDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimFileDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimFileDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["state"] = this.state;
        data["isSecured"] = this.isSecured;
        data["result"] = this.result;
        data["isDiscrepancy"] = this.isDiscrepancy;
        data["emailTemplateId"] = this.emailTemplateId;
        data["claimStatus"] = this.claimStatus;
        data["unsecuredSOAAmount"] = this.unsecuredSOAAmount;
        data["securedSOAAmount"] = this.securedSOAAmount;
        data["externalFiledAmount"] = this.externalFiledAmount;
        data["externalVote"] = this.externalVote;
        data["externalVoteOther"] = this.externalVoteOther;
        data["externalIsMeetingRequested"] = this.externalIsMeetingRequested;
        data["externalVotedBy"] = this.externalVotedBy;
        data["externalVotedByOther"] = this.externalVotedByOther;
        data["filedAmount"] = this.filedAmount;
        data["votedBy"] = this.votedBy;
        data["vote"] = this.vote;
        data["isMeetingRequested"] = this.isMeetingRequested;
        data["isMeetingRequestedOther"] = this.isMeetingRequestedOther;
        data["isClaimAmountMatching"] = this.isClaimAmountMatching;
        data["isSecurityAgreementAvailable"] = this.isSecurityAgreementAvailable;
        data["isSecurityRegistrationAvailable"] = this.isSecurityRegistrationAvailable;
        data["isRegistrationDescriptionMatching"] = this.isRegistrationDescriptionMatching;
        data["securityRegistrationDate"] = this.securityRegistrationDate ? this.securityRegistrationDate.toISOString() : <any>undefined;
        data["isThereAnEquity"] = this.isThereAnEquity;
        data["is170ReportRequested"] = this.is170ReportRequested;
        data["receivedOn"] = this.receivedOn ? this.receivedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.checklistDocumentIds)) {
            data["checklistDocumentIds"] = [];
            for (let item of this.checklistDocumentIds)
                data["checklistDocumentIds"].push(item);
        }
        data["importedEmailSubject"] = this.importedEmailSubject;
        data["importedEmailBody"] = this.importedEmailBody;
        data["importedEmailRecipientEmailAddress"] = this.importedEmailRecipientEmailAddress;
        data["importedEmailRecipientName"] = this.importedEmailRecipientName;
        data["importedEmailSenderEmailAddress"] = this.importedEmailSenderEmailAddress;
        data["importedEmailSenderName"] = this.importedEmailSenderName;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimFileDetailDto {
    id?: string;
    fileId?: string | undefined;
    state?: ClaimFileStateEnum;
    isSecured?: boolean;
    result?: ClaimFileStatusEnum;
    isDiscrepancy?: boolean | undefined;
    emailTemplateId?: string | undefined;
    claimStatus?: string | undefined;
    unsecuredSOAAmount?: number;
    securedSOAAmount?: number;
    externalFiledAmount?: number;
    externalVote?: ClaimVote;
    externalVoteOther?: string | undefined;
    externalIsMeetingRequested?: boolean | undefined;
    externalVotedBy?: ClaimVotedBy;
    externalVotedByOther?: string | undefined;
    filedAmount?: number;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isMeetingRequestedOther?: string | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    receivedOn?: moment.Moment;
    documentIds?: string[] | undefined;
    checklistDocumentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: ClaimFileInfoDto;
}

export class ClaimFileDto implements IClaimFileDto {
    id?: string;
    claimProcessStatus?: FileProcessStatusDto;
    state?: ClaimFileStateEnum;
    status?: ClaimFileStatusEnum;
    assignedAgent?: AgentDto;
    fileId?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    receivedOn?: moment.Moment;
    filedAmount?: number;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isDiscrepancy?: boolean | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    documentIds?: string[] | undefined;
    checklistDocumentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    liabilityClaim?: LiabilityClaimDto;

    constructor(data?: IClaimFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claimProcessStatus = _data["claimProcessStatus"] ? FileProcessStatusDto.fromJS(_data["claimProcessStatus"]) : <any>undefined;
            this.state = _data["state"];
            this.status = _data["status"];
            this.assignedAgent = _data["assignedAgent"] ? AgentDto.fromJS(_data["assignedAgent"]) : <any>undefined;
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.description = _data["description"];
            this.receivedOn = _data["receivedOn"] ? moment(_data["receivedOn"].toString()) : <any>undefined;
            this.filedAmount = _data["filedAmount"];
            this.votedBy = _data["votedBy"];
            this.vote = _data["vote"];
            this.isMeetingRequested = _data["isMeetingRequested"];
            this.isDiscrepancy = _data["isDiscrepancy"];
            this.isClaimAmountMatching = _data["isClaimAmountMatching"];
            this.isSecurityAgreementAvailable = _data["isSecurityAgreementAvailable"];
            this.isSecurityRegistrationAvailable = _data["isSecurityRegistrationAvailable"];
            this.isRegistrationDescriptionMatching = _data["isRegistrationDescriptionMatching"];
            this.securityRegistrationDate = _data["securityRegistrationDate"] ? moment(_data["securityRegistrationDate"].toString()) : <any>undefined;
            this.isThereAnEquity = _data["isThereAnEquity"];
            this.is170ReportRequested = _data["is170ReportRequested"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["checklistDocumentIds"])) {
                this.checklistDocumentIds = [] as any;
                for (let item of _data["checklistDocumentIds"])
                    this.checklistDocumentIds!.push(item);
            }
            this.importedEmailSubject = _data["importedEmailSubject"];
            this.importedEmailBody = _data["importedEmailBody"];
            this.importedEmailRecipientEmailAddress = _data["importedEmailRecipientEmailAddress"];
            this.importedEmailRecipientName = _data["importedEmailRecipientName"];
            this.importedEmailSenderEmailAddress = _data["importedEmailSenderEmailAddress"];
            this.importedEmailSenderName = _data["importedEmailSenderName"];
            this.liabilityClaim = _data["liabilityClaim"] ? LiabilityClaimDto.fromJS(_data["liabilityClaim"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claimProcessStatus"] = this.claimProcessStatus ? this.claimProcessStatus.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["status"] = this.status;
        data["assignedAgent"] = this.assignedAgent ? this.assignedAgent.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["description"] = this.description;
        data["receivedOn"] = this.receivedOn ? this.receivedOn.toISOString() : <any>undefined;
        data["filedAmount"] = this.filedAmount;
        data["votedBy"] = this.votedBy;
        data["vote"] = this.vote;
        data["isMeetingRequested"] = this.isMeetingRequested;
        data["isDiscrepancy"] = this.isDiscrepancy;
        data["isClaimAmountMatching"] = this.isClaimAmountMatching;
        data["isSecurityAgreementAvailable"] = this.isSecurityAgreementAvailable;
        data["isSecurityRegistrationAvailable"] = this.isSecurityRegistrationAvailable;
        data["isRegistrationDescriptionMatching"] = this.isRegistrationDescriptionMatching;
        data["securityRegistrationDate"] = this.securityRegistrationDate ? this.securityRegistrationDate.toISOString() : <any>undefined;
        data["isThereAnEquity"] = this.isThereAnEquity;
        data["is170ReportRequested"] = this.is170ReportRequested;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.checklistDocumentIds)) {
            data["checklistDocumentIds"] = [];
            for (let item of this.checklistDocumentIds)
                data["checklistDocumentIds"].push(item);
        }
        data["importedEmailSubject"] = this.importedEmailSubject;
        data["importedEmailBody"] = this.importedEmailBody;
        data["importedEmailRecipientEmailAddress"] = this.importedEmailRecipientEmailAddress;
        data["importedEmailRecipientName"] = this.importedEmailRecipientName;
        data["importedEmailSenderEmailAddress"] = this.importedEmailSenderEmailAddress;
        data["importedEmailSenderName"] = this.importedEmailSenderName;
        data["liabilityClaim"] = this.liabilityClaim ? this.liabilityClaim.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClaimFileDto {
    id?: string;
    claimProcessStatus?: FileProcessStatusDto;
    state?: ClaimFileStateEnum;
    status?: ClaimFileStatusEnum;
    assignedAgent?: AgentDto;
    fileId?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    receivedOn?: moment.Moment;
    filedAmount?: number;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isDiscrepancy?: boolean | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    documentIds?: string[] | undefined;
    checklistDocumentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    liabilityClaim?: LiabilityClaimDto;
}

export class ClaimFileInfoDto implements IClaimFileInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    mergeCreditorEmail?: boolean;
    fileName?: string | undefined;

    constructor(data?: IClaimFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.creditorName = _data["creditorName"];
            this.accountNumber = _data["accountNumber"];
            this.mergeCreditorEmail = _data["mergeCreditorEmail"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ClaimFileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimFileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["creditorName"] = this.creditorName;
        data["accountNumber"] = this.accountNumber;
        data["mergeCreditorEmail"] = this.mergeCreditorEmail;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IClaimFileInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    mergeCreditorEmail?: boolean;
    fileName?: string | undefined;
}

export class ClaimFileLinkInputDto implements IClaimFileLinkInputDto {
    isForSecuredClaim?: boolean;
    appTaskActionId?: string;
    externalLiabilityClaimId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    isMergeCreditorEmail?: boolean;
    markAsActive?: boolean | undefined;

    constructor(data?: IClaimFileLinkInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isForSecuredClaim = _data["isForSecuredClaim"];
            this.appTaskActionId = _data["appTaskActionId"];
            this.externalLiabilityClaimId = _data["externalLiabilityClaimId"];
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.creditorName = _data["creditorName"];
            this.accountNumber = _data["accountNumber"];
            this.isMergeCreditorEmail = _data["isMergeCreditorEmail"];
            this.markAsActive = _data["markAsActive"];
        }
    }

    static fromJS(data: any): ClaimFileLinkInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimFileLinkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isForSecuredClaim"] = this.isForSecuredClaim;
        data["appTaskActionId"] = this.appTaskActionId;
        data["externalLiabilityClaimId"] = this.externalLiabilityClaimId;
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["creditorName"] = this.creditorName;
        data["accountNumber"] = this.accountNumber;
        data["isMergeCreditorEmail"] = this.isMergeCreditorEmail;
        data["markAsActive"] = this.markAsActive;
        return data;
    }
}

export interface IClaimFileLinkInputDto {
    isForSecuredClaim?: boolean;
    appTaskActionId?: string;
    externalLiabilityClaimId?: string | undefined;
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    creditorName?: string | undefined;
    accountNumber?: string | undefined;
    isMergeCreditorEmail?: boolean;
    markAsActive?: boolean | undefined;
}

export class ClaimFileUpdateDto implements IClaimFileUpdateDto {
    isComplete?: boolean;
    state?: ClaimFileStateEnum;
    result?: ClaimFileStatusEnum;
    discrepancy?: boolean | undefined;
    creditorEmailTemplateId?: string | undefined;
    filedAmount?: number | undefined;
    soa?: number | undefined;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isMeetingRequestedOther?: string | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    isConfirmedToComplete?: boolean | undefined;
    alerts?: AlertCreateDto;
    checkListDocumentIds?: string[] | undefined;

    constructor(data?: IClaimFileUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplete = _data["isComplete"];
            this.state = _data["state"];
            this.result = _data["result"];
            this.discrepancy = _data["discrepancy"];
            this.creditorEmailTemplateId = _data["creditorEmailTemplateId"];
            this.filedAmount = _data["filedAmount"];
            this.soa = _data["soa"];
            this.votedBy = _data["votedBy"];
            this.vote = _data["vote"];
            this.isMeetingRequested = _data["isMeetingRequested"];
            this.isMeetingRequestedOther = _data["isMeetingRequestedOther"];
            this.isClaimAmountMatching = _data["isClaimAmountMatching"];
            this.isSecurityAgreementAvailable = _data["isSecurityAgreementAvailable"];
            this.isSecurityRegistrationAvailable = _data["isSecurityRegistrationAvailable"];
            this.isRegistrationDescriptionMatching = _data["isRegistrationDescriptionMatching"];
            this.securityRegistrationDate = _data["securityRegistrationDate"] ? moment(_data["securityRegistrationDate"].toString()) : <any>undefined;
            this.isThereAnEquity = _data["isThereAnEquity"];
            this.is170ReportRequested = _data["is170ReportRequested"];
            this.isConfirmedToComplete = _data["isConfirmedToComplete"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
            if (Array.isArray(_data["checkListDocumentIds"])) {
                this.checkListDocumentIds = [] as any;
                for (let item of _data["checkListDocumentIds"])
                    this.checkListDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ClaimFileUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimFileUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplete"] = this.isComplete;
        data["state"] = this.state;
        data["result"] = this.result;
        data["discrepancy"] = this.discrepancy;
        data["creditorEmailTemplateId"] = this.creditorEmailTemplateId;
        data["filedAmount"] = this.filedAmount;
        data["soa"] = this.soa;
        data["votedBy"] = this.votedBy;
        data["vote"] = this.vote;
        data["isMeetingRequested"] = this.isMeetingRequested;
        data["isMeetingRequestedOther"] = this.isMeetingRequestedOther;
        data["isClaimAmountMatching"] = this.isClaimAmountMatching;
        data["isSecurityAgreementAvailable"] = this.isSecurityAgreementAvailable;
        data["isSecurityRegistrationAvailable"] = this.isSecurityRegistrationAvailable;
        data["isRegistrationDescriptionMatching"] = this.isRegistrationDescriptionMatching;
        data["securityRegistrationDate"] = this.securityRegistrationDate ? this.securityRegistrationDate.toISOString() : <any>undefined;
        data["isThereAnEquity"] = this.isThereAnEquity;
        data["is170ReportRequested"] = this.is170ReportRequested;
        data["isConfirmedToComplete"] = this.isConfirmedToComplete;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        if (Array.isArray(this.checkListDocumentIds)) {
            data["checkListDocumentIds"] = [];
            for (let item of this.checkListDocumentIds)
                data["checkListDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IClaimFileUpdateDto {
    isComplete?: boolean;
    state?: ClaimFileStateEnum;
    result?: ClaimFileStatusEnum;
    discrepancy?: boolean | undefined;
    creditorEmailTemplateId?: string | undefined;
    filedAmount?: number | undefined;
    soa?: number | undefined;
    votedBy?: string | undefined;
    vote?: string | undefined;
    isMeetingRequested?: boolean | undefined;
    isMeetingRequestedOther?: string | undefined;
    isClaimAmountMatching?: boolean | undefined;
    isSecurityAgreementAvailable?: boolean | undefined;
    isSecurityRegistrationAvailable?: boolean | undefined;
    isRegistrationDescriptionMatching?: boolean | undefined;
    securityRegistrationDate?: moment.Moment | undefined;
    isThereAnEquity?: boolean | undefined;
    is170ReportRequested?: boolean | undefined;
    isConfirmedToComplete?: boolean | undefined;
    alerts?: AlertCreateDto;
    checkListDocumentIds?: string[] | undefined;
}

export class ClientPhoneDto implements IClientPhoneDto {
    id?: string;
    phoneTypeId?: string;
    phoneNumber?: string | undefined;
    doNotContact?: boolean;
    doNotSMS?: boolean;
    isDeleted?: boolean;

    constructor(data?: IClientPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneTypeId = _data["phoneTypeId"];
            this.phoneNumber = _data["phoneNumber"];
            this.doNotContact = _data["doNotContact"];
            this.doNotSMS = _data["doNotSMS"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ClientPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneTypeId"] = this.phoneTypeId;
        data["phoneNumber"] = this.phoneNumber;
        data["doNotContact"] = this.doNotContact;
        data["doNotSMS"] = this.doNotSMS;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IClientPhoneDto {
    id?: string;
    phoneTypeId?: string;
    phoneNumber?: string | undefined;
    doNotContact?: boolean;
    doNotSMS?: boolean;
    isDeleted?: boolean;
}

export class ClientResultsDto implements IClientResultsDto {
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    clientStatus?: string | undefined;
    createdOn?: moment.Moment;
    followUpDate?: moment.Moment | undefined;
    files?: FileResultsDto[] | undefined;

    constructor(data?: IClientResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.clientStatus = _data["clientStatus"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileResultsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["clientStatus"] = this.clientStatus;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientResultsDto {
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    clientStatus?: string | undefined;
    createdOn?: moment.Moment;
    followUpDate?: moment.Moment | undefined;
    files?: FileResultsDto[] | undefined;
}

export class CreateDuplicateProspectDto implements ICreateDuplicateProspectDto {
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: ICreateDuplicateProspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): CreateDuplicateProspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDuplicateProspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ICreateDuplicateProspectDto {
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export class DebtorPasswordUpdatePublicDto implements IDebtorPasswordUpdatePublicDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: IDebtorPasswordUpdatePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): DebtorPasswordUpdatePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorPasswordUpdatePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IDebtorPasswordUpdatePublicDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
}

export class DebtorProfileDto implements IDebtorProfileDto {
    fileId?: string;
    clientId?: string;
    isFileStagePostSignup?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    canResetPassword?: boolean;
    enableClientLogin?: boolean;
    enablePortalNotifications?: boolean;
    address?: string | undefined;
    unit?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    mainPhoneDoNotContact?: boolean;
    mainPhoneDoNotSMS?: boolean;
    emailAddress?: string | undefined;
    doNotEmail?: boolean;
    alternatePhoneNumbers?: ClientPhoneDto[] | undefined;
    intakeSourceId?: string | undefined;
    referralSource?: ReferralSourceDto;
    referralSourceTypeId?: string | undefined;
    referralDetails?: string | undefined;
    notes?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    canCreateNewApplication?: boolean;
    preferredLanguageId?: string | undefined;
    descendantFileId?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    copiedFromFileId?: string | undefined;
    receiveEmailConsent?: boolean | undefined;

    constructor(data?: IDebtorProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.clientId = _data["clientId"];
            this.isFileStagePostSignup = _data["isFileStagePostSignup"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.canResetPassword = _data["canResetPassword"];
            this.enableClientLogin = _data["enableClientLogin"];
            this.enablePortalNotifications = _data["enablePortalNotifications"];
            this.address = _data["address"];
            this.unit = _data["unit"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.city = _data["city"];
            this.cityTypeId = _data["cityTypeId"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.mainPhoneDoNotContact = _data["mainPhoneDoNotContact"];
            this.mainPhoneDoNotSMS = _data["mainPhoneDoNotSMS"];
            this.emailAddress = _data["emailAddress"];
            this.doNotEmail = _data["doNotEmail"];
            if (Array.isArray(_data["alternatePhoneNumbers"])) {
                this.alternatePhoneNumbers = [] as any;
                for (let item of _data["alternatePhoneNumbers"])
                    this.alternatePhoneNumbers!.push(ClientPhoneDto.fromJS(item));
            }
            this.intakeSourceId = _data["intakeSourceId"];
            this.referralSource = _data["referralSource"] ? ReferralSourceDto.fromJS(_data["referralSource"]) : <any>undefined;
            this.referralSourceTypeId = _data["referralSourceTypeId"];
            this.referralDetails = _data["referralDetails"];
            this.notes = _data["notes"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.canCreateNewApplication = _data["canCreateNewApplication"];
            this.preferredLanguageId = _data["preferredLanguageId"];
            this.descendantFileId = _data["descendantFileId"];
            this.isLocked = _data["isLocked"];
            this.isAppFormLocked = _data["isAppFormLocked"];
            this.isMigrated = _data["isMigrated"];
            this.isDuplicate = _data["isDuplicate"];
            this.isRegisteredToClientPortal = _data["isRegisteredToClientPortal"];
            this.copiedFromFileId = _data["copiedFromFileId"];
            this.receiveEmailConsent = _data["receiveEmailConsent"];
        }
    }

    static fromJS(data: any): DebtorProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["clientId"] = this.clientId;
        data["isFileStagePostSignup"] = this.isFileStagePostSignup;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["canResetPassword"] = this.canResetPassword;
        data["enableClientLogin"] = this.enableClientLogin;
        data["enablePortalNotifications"] = this.enablePortalNotifications;
        data["address"] = this.address;
        data["unit"] = this.unit;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["city"] = this.city;
        data["cityTypeId"] = this.cityTypeId;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["mainPhoneDoNotContact"] = this.mainPhoneDoNotContact;
        data["mainPhoneDoNotSMS"] = this.mainPhoneDoNotSMS;
        data["emailAddress"] = this.emailAddress;
        data["doNotEmail"] = this.doNotEmail;
        if (Array.isArray(this.alternatePhoneNumbers)) {
            data["alternatePhoneNumbers"] = [];
            for (let item of this.alternatePhoneNumbers)
                data["alternatePhoneNumbers"].push(item.toJSON());
        }
        data["intakeSourceId"] = this.intakeSourceId;
        data["referralSource"] = this.referralSource ? this.referralSource.toJSON() : <any>undefined;
        data["referralSourceTypeId"] = this.referralSourceTypeId;
        data["referralDetails"] = this.referralDetails;
        data["notes"] = this.notes;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        data["canCreateNewApplication"] = this.canCreateNewApplication;
        data["preferredLanguageId"] = this.preferredLanguageId;
        data["descendantFileId"] = this.descendantFileId;
        data["isLocked"] = this.isLocked;
        data["isAppFormLocked"] = this.isAppFormLocked;
        data["isMigrated"] = this.isMigrated;
        data["isDuplicate"] = this.isDuplicate;
        data["isRegisteredToClientPortal"] = this.isRegisteredToClientPortal;
        data["copiedFromFileId"] = this.copiedFromFileId;
        data["receiveEmailConsent"] = this.receiveEmailConsent;
        return data;
    }
}

export interface IDebtorProfileDto {
    fileId?: string;
    clientId?: string;
    isFileStagePostSignup?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    canResetPassword?: boolean;
    enableClientLogin?: boolean;
    enablePortalNotifications?: boolean;
    address?: string | undefined;
    unit?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    mainPhoneDoNotContact?: boolean;
    mainPhoneDoNotSMS?: boolean;
    emailAddress?: string | undefined;
    doNotEmail?: boolean;
    alternatePhoneNumbers?: ClientPhoneDto[] | undefined;
    intakeSourceId?: string | undefined;
    referralSource?: ReferralSourceDto;
    referralSourceTypeId?: string | undefined;
    referralDetails?: string | undefined;
    notes?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    canCreateNewApplication?: boolean;
    preferredLanguageId?: string | undefined;
    descendantFileId?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    copiedFromFileId?: string | undefined;
    receiveEmailConsent?: boolean | undefined;
}

export class DebtorProfileHeaderDto implements IDebtorProfileHeaderDto {
    createdDate?: moment.Moment;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: LookupReadOnlyDto;

    constructor(data?: IDebtorProfileHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.agent = _data["agent"];
            this.estateAdministrator = _data["estateAdministrator"];
            this.trustee = _data["trustee"];
            this.stage = _data["stage"] ? LookupReadOnlyDto.fromJS(_data["stage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DebtorProfileHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorProfileHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["agent"] = this.agent;
        data["estateAdministrator"] = this.estateAdministrator;
        data["trustee"] = this.trustee;
        data["stage"] = this.stage ? this.stage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDebtorProfileHeaderDto {
    createdDate?: moment.Moment;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: LookupReadOnlyDto;
}

export class DebtorProfilePageDto implements IDebtorProfilePageDto {
    header?: DebtorProfileHeaderDto;
    profile?: DebtorProfileDto;

    constructor(data?: IDebtorProfilePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? DebtorProfileHeaderDto.fromJS(_data["header"]) : <any>undefined;
            this.profile = _data["profile"] ? DebtorProfileDto.fromJS(_data["profile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DebtorProfilePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorProfilePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDebtorProfilePageDto {
    header?: DebtorProfileHeaderDto;
    profile?: DebtorProfileDto;
}

export class DebtorProfileUpdatePublicDto implements IDebtorProfileUpdatePublicDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;

    constructor(data?: IDebtorProfileUpdatePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
        }
    }

    static fromJS(data: any): DebtorProfileUpdatePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorProfileUpdatePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        return data;
    }
}

export interface IDebtorProfileUpdatePublicDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
}

export class DebtorSearchResultsDto implements IDebtorSearchResultsDto {
    clients?: ClientResultsDto[] | undefined;
    totalRecords?: number;

    constructor(data?: IDebtorSearchResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientResultsDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): DebtorSearchResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorSearchResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IDebtorSearchResultsDto {
    clients?: ClientResultsDto[] | undefined;
    totalRecords?: number;
}

export class DebtorSettingsPublicUpdateDto implements IDebtorSettingsPublicUpdateDto {
    isAllowedEmailNotifications?: boolean;
    isAllowedSMSNotifications?: boolean;

    constructor(data?: IDebtorSettingsPublicUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAllowedEmailNotifications = _data["isAllowedEmailNotifications"];
            this.isAllowedSMSNotifications = _data["isAllowedSMSNotifications"];
        }
    }

    static fromJS(data: any): DebtorSettingsPublicUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorSettingsPublicUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAllowedEmailNotifications"] = this.isAllowedEmailNotifications;
        data["isAllowedSMSNotifications"] = this.isAllowedSMSNotifications;
        return data;
    }
}

export interface IDebtorSettingsPublicUpdateDto {
    isAllowedEmailNotifications?: boolean;
    isAllowedSMSNotifications?: boolean;
}

export class DuplicateClientDto implements IDuplicateClientDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    address?: string | undefined;
    stage?: string | undefined;
    isMatchingFirstName?: boolean;
    isMatchingLastName?: boolean;
    isMatchingPhoneNumber?: boolean;
    isMatchingEmailAddress?: boolean;
    isConfirmedDuplicate?: boolean;

    constructor(data?: IDuplicateClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fileName = _data["fileName"];
            this.estateNumber = _data["estateNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.address = _data["address"];
            this.stage = _data["stage"];
            this.isMatchingFirstName = _data["isMatchingFirstName"];
            this.isMatchingLastName = _data["isMatchingLastName"];
            this.isMatchingPhoneNumber = _data["isMatchingPhoneNumber"];
            this.isMatchingEmailAddress = _data["isMatchingEmailAddress"];
            this.isConfirmedDuplicate = _data["isConfirmedDuplicate"];
        }
    }

    static fromJS(data: any): DuplicateClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fileName"] = this.fileName;
        data["estateNumber"] = this.estateNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["address"] = this.address;
        data["stage"] = this.stage;
        data["isMatchingFirstName"] = this.isMatchingFirstName;
        data["isMatchingLastName"] = this.isMatchingLastName;
        data["isMatchingPhoneNumber"] = this.isMatchingPhoneNumber;
        data["isMatchingEmailAddress"] = this.isMatchingEmailAddress;
        data["isConfirmedDuplicate"] = this.isConfirmedDuplicate;
        return data;
    }
}

export interface IDuplicateClientDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    address?: string | undefined;
    stage?: string | undefined;
    isMatchingFirstName?: boolean;
    isMatchingLastName?: boolean;
    isMatchingPhoneNumber?: boolean;
    isMatchingEmailAddress?: boolean;
    isConfirmedDuplicate?: boolean;
}

export class FileResultsDto implements IFileResultsDto {
    fileId?: string;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: string | undefined;
    createdOn?: moment.Moment;

    constructor(data?: IFileResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.estateNumber = _data["estateNumber"];
            this.filingType = _data["filingType"];
            this.serviceLocation = _data["serviceLocation"];
            this.estateAdministrator = _data["estateAdministrator"];
            this.trustee = _data["trustee"];
            this.stage = _data["stage"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["estateNumber"] = this.estateNumber;
        data["filingType"] = this.filingType;
        data["serviceLocation"] = this.serviceLocation;
        data["estateAdministrator"] = this.estateAdministrator;
        data["trustee"] = this.trustee;
        data["stage"] = this.stage;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileResultsDto {
    fileId?: string;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: string | undefined;
    createdOn?: moment.Moment;
}

export class PersonalDetailsDto implements IPersonalDetailsDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    preferredLanguageId?: string | undefined;

    constructor(data?: IPersonalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.preferredLanguageId = _data["preferredLanguageId"];
        }
    }

    static fromJS(data: any): PersonalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
        data["preferredLanguageId"] = this.preferredLanguageId;
        return data;
    }
}

export interface IPersonalDetailsDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    preferredLanguageId?: string | undefined;
}

export class ReferralSourceDto implements IReferralSourceDto {
    id?: string;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;

    constructor(data?: IReferralSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralSourceTypeId = _data["referralSourceTypeId"];
            this.referralDetails = _data["referralDetails"];
        }
    }

    static fromJS(data: any): ReferralSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralSourceTypeId"] = this.referralSourceTypeId;
        data["referralDetails"] = this.referralDetails;
        return data;
    }
}

export interface IReferralSourceDto {
    id?: string;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
}

export class GoogleApiKeyDto implements IGoogleApiKeyDto {
    apiKey?: string | undefined;

    constructor(data?: IGoogleApiKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): GoogleApiKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleApiKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IGoogleApiKeyDto {
    apiKey?: string | undefined;
}

export class PDFTronKeyDto implements IPDFTronKeyDto {
    key?: string | undefined;

    constructor(data?: IPDFTronKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): PDFTronKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PDFTronKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        return data;
    }
}

export interface IPDFTronKeyDto {
    key?: string | undefined;
}

export class VerifyReCaptchaTokenDto implements IVerifyReCaptchaTokenDto {
    token?: string | undefined;

    constructor(data?: IVerifyReCaptchaTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyReCaptchaTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyReCaptchaTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IVerifyReCaptchaTokenDto {
    token?: string | undefined;
}

export class ContactStaffDto implements IContactStaffDto {
    teamId?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;

    constructor(data?: IContactStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.subject = _data["subject"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["subject"] = this.subject;
        data["message"] = this.message;
        return data;
    }
}

export interface IContactStaffDto {
    teamId?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
}

export class ContactSupportFormDto implements IContactSupportFormDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    inquiryType?: string | undefined;
    comments?: string | undefined;
    token?: string | undefined;

    constructor(data?: IContactSupportFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.inquiryType = _data["inquiryType"];
            this.comments = _data["comments"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ContactSupportFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSupportFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["inquiryType"] = this.inquiryType;
        data["comments"] = this.comments;
        data["token"] = this.token;
        return data;
    }
}

export interface IContactSupportFormDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    inquiryType?: string | undefined;
    comments?: string | undefined;
    token?: string | undefined;
}

export class CourtDetailsDto implements ICourtDetailsDto {
    externalCourtId?: string | undefined;
    courtNumber?: string | undefined;
    courtName?: string | undefined;
    courtCity?: string | undefined;
    trusteeIds?: string[] | undefined;
    status?: boolean | undefined;

    constructor(data?: ICourtDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalCourtId = _data["externalCourtId"];
            this.courtNumber = _data["courtNumber"];
            this.courtName = _data["courtName"];
            this.courtCity = _data["courtCity"];
            if (Array.isArray(_data["trusteeIds"])) {
                this.trusteeIds = [] as any;
                for (let item of _data["trusteeIds"])
                    this.trusteeIds!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CourtDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourtDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalCourtId"] = this.externalCourtId;
        data["courtNumber"] = this.courtNumber;
        data["courtName"] = this.courtName;
        data["courtCity"] = this.courtCity;
        if (Array.isArray(this.trusteeIds)) {
            data["trusteeIds"] = [];
            for (let item of this.trusteeIds)
                data["trusteeIds"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface ICourtDetailsDto {
    externalCourtId?: string | undefined;
    courtNumber?: string | undefined;
    courtName?: string | undefined;
    courtCity?: string | undefined;
    trusteeIds?: string[] | undefined;
    status?: boolean | undefined;
}

export class CourtDto implements ICourtDto {
    court?: CourtDetailsDto[] | undefined;

    constructor(data?: ICourtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["court"])) {
                this.court = [] as any;
                for (let item of _data["court"])
                    this.court!.push(CourtDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourtDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.court)) {
            data["court"] = [];
            for (let item of this.court)
                data["court"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICourtDto {
    court?: CourtDetailsDto[] | undefined;
}

export class CourtInputDetailsDto implements ICourtInputDetailsDto {
    trusteeIds?: string[] | undefined;
    externalCourtId?: string | undefined;
    status?: boolean;

    constructor(data?: ICourtInputDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trusteeIds"])) {
                this.trusteeIds = [] as any;
                for (let item of _data["trusteeIds"])
                    this.trusteeIds!.push(item);
            }
            this.externalCourtId = _data["externalCourtId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CourtInputDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourtInputDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trusteeIds)) {
            data["trusteeIds"] = [];
            for (let item of this.trusteeIds)
                data["trusteeIds"].push(item);
        }
        data["externalCourtId"] = this.externalCourtId;
        data["status"] = this.status;
        return data;
    }
}

export interface ICourtInputDetailsDto {
    trusteeIds?: string[] | undefined;
    externalCourtId?: string | undefined;
    status?: boolean;
}

export class DischargeCourtApperanceRequestCreateDto implements IDischargeCourtApperanceRequestCreateDto {
    id?: string;
    agentId?: string;
    comments?: string | undefined;

    constructor(data?: IDischargeCourtApperanceRequestCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DischargeCourtApperanceRequestCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DischargeCourtApperanceRequestCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDischargeCourtApperanceRequestCreateDto {
    id?: string;
    agentId?: string;
    comments?: string | undefined;
}

export class DischargeCourtApperanceResponseCreateDto implements IDischargeCourtApperanceResponseCreateDto {
    id?: string;
    response?: DischargeCourtAppearanceNotificationStatusEnum;
    comments?: string | undefined;

    constructor(data?: IDischargeCourtApperanceResponseCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.response = _data["response"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DischargeCourtApperanceResponseCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DischargeCourtApperanceResponseCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["response"] = this.response;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDischargeCourtApperanceResponseCreateDto {
    id?: string;
    response?: DischargeCourtAppearanceNotificationStatusEnum;
    comments?: string | undefined;
}

export class DischargeFilingDateUpdateDto implements IDischargeFilingDateUpdateDto {
    id?: string;
    date?: moment.Moment;
    documentPrefixCode?: string | undefined;

    constructor(data?: IDischargeFilingDateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.documentPrefixCode = _data["documentPrefixCode"];
        }
    }

    static fromJS(data: any): DischargeFilingDateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DischargeFilingDateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentPrefixCode"] = this.documentPrefixCode;
        return data;
    }
}

export interface IDischargeFilingDateUpdateDto {
    id?: string;
    date?: moment.Moment;
    documentPrefixCode?: string | undefined;
}

export class FileDischargeFormDto implements IFileDischargeFormDto {
    id?: string;
    thirtyDaysNotice?: boolean;
    dischargeType?: string | undefined;
    hadOpposition?: boolean;
    is170ChecklistUploaded?: boolean;
    is170ChecklistShared?: boolean;
    is170ReportUploaded?: boolean;
    filingDate170Report?: moment.Moment | undefined;
    is170ReportShared?: boolean;
    isDischargeCertificateUploaded?: boolean;
    isDischargeCertificateShared?: boolean;
    isOppositionLetterUploaded?: boolean;
    isOppositionLetterShared?: boolean;
    isForm80Uploaded?: boolean;
    isForm80Shared?: boolean;
    hasPossibleMediation?: boolean;
    hasInitiateCourtDischarge?: boolean;
    mediationStatus?: DischargeMediationStatusEnum;
    modeOfMediation?: DischargeMediationModeEnum;
    isForm63Shared?: boolean;
    isForm63Uploaded?: boolean;
    isSignedAgreementShared?: boolean;
    isSignedAgreementUploaded?: boolean;
    courtDischargeStatus?: CourtDischargeStatusEnum;
    isRecommendationLetterUploaded?: boolean;
    isRecommendationLetterShared?: boolean;
    isConditionalOrderUploaded?: boolean;
    isConditionalOrderShared?: boolean;
    isChequeRequisitionUploaded?: boolean;
    courtAppearanceNotificationStatus?: DischargeCourtAppearanceNotificationStatusEnum;
    complianceNotificationStatus?: DischargeComplianceNotificationStatusEnum;
    oppositionComments?: string | undefined;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;

    constructor(data?: IFileDischargeFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.thirtyDaysNotice = _data["thirtyDaysNotice"];
            this.dischargeType = _data["dischargeType"];
            this.hadOpposition = _data["hadOpposition"];
            this.is170ChecklistUploaded = _data["is170ChecklistUploaded"];
            this.is170ChecklistShared = _data["is170ChecklistShared"];
            this.is170ReportUploaded = _data["is170ReportUploaded"];
            this.filingDate170Report = _data["filingDate170Report"] ? moment(_data["filingDate170Report"].toString()) : <any>undefined;
            this.is170ReportShared = _data["is170ReportShared"];
            this.isDischargeCertificateUploaded = _data["isDischargeCertificateUploaded"];
            this.isDischargeCertificateShared = _data["isDischargeCertificateShared"];
            this.isOppositionLetterUploaded = _data["isOppositionLetterUploaded"];
            this.isOppositionLetterShared = _data["isOppositionLetterShared"];
            this.isForm80Uploaded = _data["isForm80Uploaded"];
            this.isForm80Shared = _data["isForm80Shared"];
            this.hasPossibleMediation = _data["hasPossibleMediation"];
            this.hasInitiateCourtDischarge = _data["hasInitiateCourtDischarge"];
            this.mediationStatus = _data["mediationStatus"];
            this.modeOfMediation = _data["modeOfMediation"];
            this.isForm63Shared = _data["isForm63Shared"];
            this.isForm63Uploaded = _data["isForm63Uploaded"];
            this.isSignedAgreementShared = _data["isSignedAgreementShared"];
            this.isSignedAgreementUploaded = _data["isSignedAgreementUploaded"];
            this.courtDischargeStatus = _data["courtDischargeStatus"];
            this.isRecommendationLetterUploaded = _data["isRecommendationLetterUploaded"];
            this.isRecommendationLetterShared = _data["isRecommendationLetterShared"];
            this.isConditionalOrderUploaded = _data["isConditionalOrderUploaded"];
            this.isConditionalOrderShared = _data["isConditionalOrderShared"];
            this.isChequeRequisitionUploaded = _data["isChequeRequisitionUploaded"];
            this.courtAppearanceNotificationStatus = _data["courtAppearanceNotificationStatus"];
            this.complianceNotificationStatus = _data["complianceNotificationStatus"];
            this.oppositionComments = _data["oppositionComments"];
            this.oppositionDeptorResponse = _data["oppositionDeptorResponse"];
            this.isOppositionLetterWithdrawn = _data["isOppositionLetterWithdrawn"];
            this.isOppositionLetterCompleted = _data["isOppositionLetterCompleted"];
        }
    }

    static fromJS(data: any): FileDischargeFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDischargeFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["thirtyDaysNotice"] = this.thirtyDaysNotice;
        data["dischargeType"] = this.dischargeType;
        data["hadOpposition"] = this.hadOpposition;
        data["is170ChecklistUploaded"] = this.is170ChecklistUploaded;
        data["is170ChecklistShared"] = this.is170ChecklistShared;
        data["is170ReportUploaded"] = this.is170ReportUploaded;
        data["filingDate170Report"] = this.filingDate170Report ? this.filingDate170Report.toISOString() : <any>undefined;
        data["is170ReportShared"] = this.is170ReportShared;
        data["isDischargeCertificateUploaded"] = this.isDischargeCertificateUploaded;
        data["isDischargeCertificateShared"] = this.isDischargeCertificateShared;
        data["isOppositionLetterUploaded"] = this.isOppositionLetterUploaded;
        data["isOppositionLetterShared"] = this.isOppositionLetterShared;
        data["isForm80Uploaded"] = this.isForm80Uploaded;
        data["isForm80Shared"] = this.isForm80Shared;
        data["hasPossibleMediation"] = this.hasPossibleMediation;
        data["hasInitiateCourtDischarge"] = this.hasInitiateCourtDischarge;
        data["mediationStatus"] = this.mediationStatus;
        data["modeOfMediation"] = this.modeOfMediation;
        data["isForm63Shared"] = this.isForm63Shared;
        data["isForm63Uploaded"] = this.isForm63Uploaded;
        data["isSignedAgreementShared"] = this.isSignedAgreementShared;
        data["isSignedAgreementUploaded"] = this.isSignedAgreementUploaded;
        data["courtDischargeStatus"] = this.courtDischargeStatus;
        data["isRecommendationLetterUploaded"] = this.isRecommendationLetterUploaded;
        data["isRecommendationLetterShared"] = this.isRecommendationLetterShared;
        data["isConditionalOrderUploaded"] = this.isConditionalOrderUploaded;
        data["isConditionalOrderShared"] = this.isConditionalOrderShared;
        data["isChequeRequisitionUploaded"] = this.isChequeRequisitionUploaded;
        data["courtAppearanceNotificationStatus"] = this.courtAppearanceNotificationStatus;
        data["complianceNotificationStatus"] = this.complianceNotificationStatus;
        data["oppositionComments"] = this.oppositionComments;
        data["oppositionDeptorResponse"] = this.oppositionDeptorResponse;
        data["isOppositionLetterWithdrawn"] = this.isOppositionLetterWithdrawn;
        data["isOppositionLetterCompleted"] = this.isOppositionLetterCompleted;
        return data;
    }
}

export interface IFileDischargeFormDto {
    id?: string;
    thirtyDaysNotice?: boolean;
    dischargeType?: string | undefined;
    hadOpposition?: boolean;
    is170ChecklistUploaded?: boolean;
    is170ChecklistShared?: boolean;
    is170ReportUploaded?: boolean;
    filingDate170Report?: moment.Moment | undefined;
    is170ReportShared?: boolean;
    isDischargeCertificateUploaded?: boolean;
    isDischargeCertificateShared?: boolean;
    isOppositionLetterUploaded?: boolean;
    isOppositionLetterShared?: boolean;
    isForm80Uploaded?: boolean;
    isForm80Shared?: boolean;
    hasPossibleMediation?: boolean;
    hasInitiateCourtDischarge?: boolean;
    mediationStatus?: DischargeMediationStatusEnum;
    modeOfMediation?: DischargeMediationModeEnum;
    isForm63Shared?: boolean;
    isForm63Uploaded?: boolean;
    isSignedAgreementShared?: boolean;
    isSignedAgreementUploaded?: boolean;
    courtDischargeStatus?: CourtDischargeStatusEnum;
    isRecommendationLetterUploaded?: boolean;
    isRecommendationLetterShared?: boolean;
    isConditionalOrderUploaded?: boolean;
    isConditionalOrderShared?: boolean;
    isChequeRequisitionUploaded?: boolean;
    courtAppearanceNotificationStatus?: DischargeCourtAppearanceNotificationStatusEnum;
    complianceNotificationStatus?: DischargeComplianceNotificationStatusEnum;
    oppositionComments?: string | undefined;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;
}

export class FileDischargeFormUpdateDto implements IFileDischargeFormUpdateDto {
    id?: string;
    hasPossibleMediation?: boolean;
    hasInitiateCourtDischarge?: boolean;
    mediationStatus?: DischargeMediationStatusEnum;
    modeOfMediation?: DischargeMediationModeEnum;

    constructor(data?: IFileDischargeFormUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasPossibleMediation = _data["hasPossibleMediation"];
            this.hasInitiateCourtDischarge = _data["hasInitiateCourtDischarge"];
            this.mediationStatus = _data["mediationStatus"];
            this.modeOfMediation = _data["modeOfMediation"];
        }
    }

    static fromJS(data: any): FileDischargeFormUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDischargeFormUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasPossibleMediation"] = this.hasPossibleMediation;
        data["hasInitiateCourtDischarge"] = this.hasInitiateCourtDischarge;
        data["mediationStatus"] = this.mediationStatus;
        data["modeOfMediation"] = this.modeOfMediation;
        return data;
    }
}

export interface IFileDischargeFormUpdateDto {
    id?: string;
    hasPossibleMediation?: boolean;
    hasInitiateCourtDischarge?: boolean;
    mediationStatus?: DischargeMediationStatusEnum;
    modeOfMediation?: DischargeMediationModeEnum;
}

export class OppositionLetterResponseDto implements IOppositionLetterResponseDto {
    fileId?: string;
    oppositionComments?: string | undefined;
    isOppositionLetterShared?: boolean | undefined;
    pendingProcesses?: FileProcessEnum[] | undefined;
    documentIds?: string[] | undefined;
    documents?: DocumentDto[] | undefined;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;

    constructor(data?: IOppositionLetterResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.oppositionComments = _data["oppositionComments"];
            this.isOppositionLetterShared = _data["isOppositionLetterShared"];
            if (Array.isArray(_data["pendingProcesses"])) {
                this.pendingProcesses = [] as any;
                for (let item of _data["pendingProcesses"])
                    this.pendingProcesses!.push(item);
            }
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.oppositionDeptorResponse = _data["oppositionDeptorResponse"];
            this.isOppositionLetterWithdrawn = _data["isOppositionLetterWithdrawn"];
            this.isOppositionLetterCompleted = _data["isOppositionLetterCompleted"];
        }
    }

    static fromJS(data: any): OppositionLetterResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OppositionLetterResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["oppositionComments"] = this.oppositionComments;
        data["isOppositionLetterShared"] = this.isOppositionLetterShared;
        if (Array.isArray(this.pendingProcesses)) {
            data["pendingProcesses"] = [];
            for (let item of this.pendingProcesses)
                data["pendingProcesses"].push(item);
        }
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["oppositionDeptorResponse"] = this.oppositionDeptorResponse;
        data["isOppositionLetterWithdrawn"] = this.isOppositionLetterWithdrawn;
        data["isOppositionLetterCompleted"] = this.isOppositionLetterCompleted;
        return data;
    }
}

export interface IOppositionLetterResponseDto {
    fileId?: string;
    oppositionComments?: string | undefined;
    isOppositionLetterShared?: boolean | undefined;
    pendingProcesses?: FileProcessEnum[] | undefined;
    documentIds?: string[] | undefined;
    documents?: DocumentDto[] | undefined;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;
}

export class OppositionLetterResponseUpdateDto implements IOppositionLetterResponseUpdateDto {
    fileId?: string;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;

    constructor(data?: IOppositionLetterResponseUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.oppositionDeptorResponse = _data["oppositionDeptorResponse"];
            this.isOppositionLetterWithdrawn = _data["isOppositionLetterWithdrawn"];
            this.isOppositionLetterCompleted = _data["isOppositionLetterCompleted"];
        }
    }

    static fromJS(data: any): OppositionLetterResponseUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OppositionLetterResponseUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["oppositionDeptorResponse"] = this.oppositionDeptorResponse;
        data["isOppositionLetterWithdrawn"] = this.isOppositionLetterWithdrawn;
        data["isOppositionLetterCompleted"] = this.isOppositionLetterCompleted;
        return data;
    }
}

export interface IOppositionLetterResponseUpdateDto {
    fileId?: string;
    oppositionDeptorResponse?: string | undefined;
    isOppositionLetterWithdrawn?: boolean | undefined;
    isOppositionLetterCompleted?: boolean | undefined;
}

export class OppositionLetterUpdateDto implements IOppositionLetterUpdateDto {
    fileId?: string;
    oppositionComments?: string | undefined;
    isOppositionLetterShared?: boolean | undefined;
    pendingProcesses?: FileProcessEnum[] | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IOppositionLetterUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.oppositionComments = _data["oppositionComments"];
            this.isOppositionLetterShared = _data["isOppositionLetterShared"];
            if (Array.isArray(_data["pendingProcesses"])) {
                this.pendingProcesses = [] as any;
                for (let item of _data["pendingProcesses"])
                    this.pendingProcesses!.push(item);
            }
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OppositionLetterUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OppositionLetterUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["oppositionComments"] = this.oppositionComments;
        data["isOppositionLetterShared"] = this.isOppositionLetterShared;
        if (Array.isArray(this.pendingProcesses)) {
            data["pendingProcesses"] = [];
            for (let item of this.pendingProcesses)
                data["pendingProcesses"].push(item);
        }
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IOppositionLetterUpdateDto {
    fileId?: string;
    oppositionComments?: string | undefined;
    isOppositionLetterShared?: boolean | undefined;
    pendingProcesses?: FileProcessEnum[] | undefined;
    documentIds?: string[] | undefined;
}

export class DocumentBundleDto implements IDocumentBundleDto {
    fileId?: string;
    documentFolderId?: string;
    documentPrefixId?: string;
    additionalInformation?: string | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IDocumentBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentFolderId = _data["documentFolderId"];
            this.documentPrefixId = _data["documentPrefixId"];
            this.additionalInformation = _data["additionalInformation"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentBundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentBundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentFolderId"] = this.documentFolderId;
        data["documentPrefixId"] = this.documentPrefixId;
        data["additionalInformation"] = this.additionalInformation;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IDocumentBundleDto {
    fileId?: string;
    documentFolderId?: string;
    documentPrefixId?: string;
    additionalInformation?: string | undefined;
    documentIds?: string[] | undefined;
}

export class DocumentCopyDto implements IDocumentCopyDto {
    destinationFileId?: string;

    constructor(data?: IDocumentCopyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationFileId = _data["destinationFileId"];
        }
    }

    static fromJS(data: any): DocumentCopyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCopyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationFileId"] = this.destinationFileId;
        return data;
    }
}

export interface IDocumentCopyDto {
    destinationFileId?: string;
}

export class DocumentDto implements IDocumentDto {
    id?: string;
    name?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentPrefixId?: string | undefined;
    documentPrefixName?: string | undefined;
    additionalInformation?: string | undefined;
    documentVerificationId?: string | undefined;
    verificationStatus?: DocumentVerificationStatusEnum;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;
    isVisible?: boolean;
    isSupportingDocumentReviewed?: boolean | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.documentFolderId = _data["documentFolderId"];
            this.documentFolderName = _data["documentFolderName"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            this.fileSizeInBytes = _data["fileSizeInBytes"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.documentPrefixId = _data["documentPrefixId"];
            this.documentPrefixName = _data["documentPrefixName"];
            this.additionalInformation = _data["additionalInformation"];
            this.documentVerificationId = _data["documentVerificationId"];
            this.verificationStatus = _data["verificationStatus"];
            this.isForSpouse = _data["isForSpouse"];
            this.businessName = _data["businessName"];
            this.isVisible = _data["isVisible"];
            this.isSupportingDocumentReviewed = _data["isSupportingDocumentReviewed"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["documentFolderId"] = this.documentFolderId;
        data["documentFolderName"] = this.documentFolderName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fileSizeInBytes"] = this.fileSizeInBytes;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["documentPrefixId"] = this.documentPrefixId;
        data["documentPrefixName"] = this.documentPrefixName;
        data["additionalInformation"] = this.additionalInformation;
        data["documentVerificationId"] = this.documentVerificationId;
        data["verificationStatus"] = this.verificationStatus;
        data["isForSpouse"] = this.isForSpouse;
        data["businessName"] = this.businessName;
        data["isVisible"] = this.isVisible;
        data["isSupportingDocumentReviewed"] = this.isSupportingDocumentReviewed;
        return data;
    }
}

export interface IDocumentDto {
    id?: string;
    name?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentPrefixId?: string | undefined;
    documentPrefixName?: string | undefined;
    additionalInformation?: string | undefined;
    documentVerificationId?: string | undefined;
    verificationStatus?: DocumentVerificationStatusEnum;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;
    isVisible?: boolean;
    isSupportingDocumentReviewed?: boolean | undefined;
}

export class DocumentVerificationCreateDto implements IDocumentVerificationCreateDto {
    documentId?: string;
    reviewers?: string[] | undefined;
    approvers?: string[] | undefined;
    signees?: string[] | undefined;
    isUrgent?: boolean;
    dueDate?: moment.Moment | undefined;
    comments?: string | undefined;

    constructor(data?: IDocumentVerificationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(item);
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(item);
            }
            if (Array.isArray(_data["signees"])) {
                this.signees = [] as any;
                for (let item of _data["signees"])
                    this.signees!.push(item);
            }
            this.isUrgent = _data["isUrgent"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DocumentVerificationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item);
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item);
        }
        if (Array.isArray(this.signees)) {
            data["signees"] = [];
            for (let item of this.signees)
                data["signees"].push(item);
        }
        data["isUrgent"] = this.isUrgent;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDocumentVerificationCreateDto {
    documentId?: string;
    reviewers?: string[] | undefined;
    approvers?: string[] | undefined;
    signees?: string[] | undefined;
    isUrgent?: boolean;
    dueDate?: moment.Moment | undefined;
    comments?: string | undefined;
}

export class DocumentVerificationDetailDto implements IDocumentVerificationDetailDto {
    id?: string;
    documentId?: string;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    documentPrefixId?: string;
    documentPrefixName?: string | undefined;
    documentPrefixFrenchName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentVerificationStatus?: DocumentVerificationStatusEnum;
    dueDate?: moment.Moment | undefined;
    isUrgent?: boolean;
    comments?: string | undefined;
    reviewers?: DocumentVerificationRoleDto[] | undefined;
    approvers?: DocumentVerificationRoleDto[] | undefined;
    signees?: DocumentVerificationRoleDto[] | undefined;

    constructor(data?: IDocumentVerificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.frenchName = _data["frenchName"];
            this.documentFolderId = _data["documentFolderId"];
            this.documentFolderName = _data["documentFolderName"];
            this.documentPrefixId = _data["documentPrefixId"];
            this.documentPrefixName = _data["documentPrefixName"];
            this.documentPrefixFrenchName = _data["documentPrefixFrenchName"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            this.fileSizeInBytes = _data["fileSizeInBytes"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.documentVerificationStatus = _data["documentVerificationStatus"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.isUrgent = _data["isUrgent"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["reviewers"])) {
                this.reviewers = [] as any;
                for (let item of _data["reviewers"])
                    this.reviewers!.push(DocumentVerificationRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(DocumentVerificationRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["signees"])) {
                this.signees = [] as any;
                for (let item of _data["signees"])
                    this.signees!.push(DocumentVerificationRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentVerificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["frenchName"] = this.frenchName;
        data["documentFolderId"] = this.documentFolderId;
        data["documentFolderName"] = this.documentFolderName;
        data["documentPrefixId"] = this.documentPrefixId;
        data["documentPrefixName"] = this.documentPrefixName;
        data["documentPrefixFrenchName"] = this.documentPrefixFrenchName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fileSizeInBytes"] = this.fileSizeInBytes;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["documentVerificationStatus"] = this.documentVerificationStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isUrgent"] = this.isUrgent;
        data["comments"] = this.comments;
        if (Array.isArray(this.reviewers)) {
            data["reviewers"] = [];
            for (let item of this.reviewers)
                data["reviewers"].push(item.toJSON());
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        if (Array.isArray(this.signees)) {
            data["signees"] = [];
            for (let item of this.signees)
                data["signees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentVerificationDetailDto {
    id?: string;
    documentId?: string;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    documentPrefixId?: string;
    documentPrefixName?: string | undefined;
    documentPrefixFrenchName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentVerificationStatus?: DocumentVerificationStatusEnum;
    dueDate?: moment.Moment | undefined;
    isUrgent?: boolean;
    comments?: string | undefined;
    reviewers?: DocumentVerificationRoleDto[] | undefined;
    approvers?: DocumentVerificationRoleDto[] | undefined;
    signees?: DocumentVerificationRoleDto[] | undefined;
}

export class DocumentVerificationDto implements IDocumentVerificationDto {
    id?: string;
    documentId?: string;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    documentPrefixId?: string;
    documentPrefixName?: string | undefined;
    documentPrefixFrenchName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentVerificationStatus?: DocumentVerificationStatusEnum;
    dueDate?: moment.Moment | undefined;
    isUrgent?: boolean;
    comments?: string | undefined;

    constructor(data?: IDocumentVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.frenchName = _data["frenchName"];
            this.documentFolderId = _data["documentFolderId"];
            this.documentFolderName = _data["documentFolderName"];
            this.documentPrefixId = _data["documentPrefixId"];
            this.documentPrefixName = _data["documentPrefixName"];
            this.documentPrefixFrenchName = _data["documentPrefixFrenchName"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            this.fileSizeInBytes = _data["fileSizeInBytes"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.documentVerificationStatus = _data["documentVerificationStatus"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.isUrgent = _data["isUrgent"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DocumentVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["frenchName"] = this.frenchName;
        data["documentFolderId"] = this.documentFolderId;
        data["documentFolderName"] = this.documentFolderName;
        data["documentPrefixId"] = this.documentPrefixId;
        data["documentPrefixName"] = this.documentPrefixName;
        data["documentPrefixFrenchName"] = this.documentPrefixFrenchName;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["fileSizeInBytes"] = this.fileSizeInBytes;
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["documentVerificationStatus"] = this.documentVerificationStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isUrgent"] = this.isUrgent;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDocumentVerificationDto {
    id?: string;
    documentId?: string;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    documentPrefixId?: string;
    documentPrefixName?: string | undefined;
    documentPrefixFrenchName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentVerificationStatus?: DocumentVerificationStatusEnum;
    dueDate?: moment.Moment | undefined;
    isUrgent?: boolean;
    comments?: string | undefined;
}

export class DocumentVerificationHistoryDto implements IDocumentVerificationHistoryDto {
    id?: string;
    documentName?: string | undefined;
    requestorName?: string | undefined;
    requestDate?: moment.Moment | undefined;
    verifierRole?: DocumentVerificationRoleTypeEnum;
    verifierName?: string | undefined;
    verificationDate?: moment.Moment | undefined;
    verificationResultEnum?: DocumentVerificationRoleResultEnum;

    constructor(data?: IDocumentVerificationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.requestorName = _data["requestorName"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.verifierRole = _data["verifierRole"];
            this.verifierName = _data["verifierName"];
            this.verificationDate = _data["verificationDate"] ? moment(_data["verificationDate"].toString()) : <any>undefined;
            this.verificationResultEnum = _data["verificationResultEnum"];
        }
    }

    static fromJS(data: any): DocumentVerificationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["requestorName"] = this.requestorName;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["verifierRole"] = this.verifierRole;
        data["verifierName"] = this.verifierName;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : <any>undefined;
        data["verificationResultEnum"] = this.verificationResultEnum;
        return data;
    }
}

export interface IDocumentVerificationHistoryDto {
    id?: string;
    documentName?: string | undefined;
    requestorName?: string | undefined;
    requestDate?: moment.Moment | undefined;
    verifierRole?: DocumentVerificationRoleTypeEnum;
    verifierName?: string | undefined;
    verificationDate?: moment.Moment | undefined;
    verificationResultEnum?: DocumentVerificationRoleResultEnum;
}

export class DocumentVerificationRoleDto implements IDocumentVerificationRoleDto {
    agentId?: string;
    agentName?: string | undefined;
    verificationRole?: DocumentVerificationRoleTypeEnum;
    sequenceOrderNumber?: number;
    verificationDate?: moment.Moment | undefined;
    verificationResult?: DocumentVerificationRoleResultEnum;

    constructor(data?: IDocumentVerificationRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.verificationRole = _data["verificationRole"];
            this.sequenceOrderNumber = _data["sequenceOrderNumber"];
            this.verificationDate = _data["verificationDate"] ? moment(_data["verificationDate"].toString()) : <any>undefined;
            this.verificationResult = _data["verificationResult"];
        }
    }

    static fromJS(data: any): DocumentVerificationRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["verificationRole"] = this.verificationRole;
        data["sequenceOrderNumber"] = this.sequenceOrderNumber;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : <any>undefined;
        data["verificationResult"] = this.verificationResult;
        return data;
    }
}

export interface IDocumentVerificationRoleDto {
    agentId?: string;
    agentName?: string | undefined;
    verificationRole?: DocumentVerificationRoleTypeEnum;
    sequenceOrderNumber?: number;
    verificationDate?: moment.Moment | undefined;
    verificationResult?: DocumentVerificationRoleResultEnum;
}

export class DocumentVerificationSubmitDto implements IDocumentVerificationSubmitDto {
    verificationRole?: DocumentVerificationRoleTypeEnum;
    verificationResult?: DocumentVerificationRoleResultEnum;
    comment?: string | undefined;

    constructor(data?: IDocumentVerificationSubmitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationRole = _data["verificationRole"];
            this.verificationResult = _data["verificationResult"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DocumentVerificationSubmitDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVerificationSubmitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationRole"] = this.verificationRole;
        data["verificationResult"] = this.verificationResult;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IDocumentVerificationSubmitDto {
    verificationRole?: DocumentVerificationRoleTypeEnum;
    verificationResult?: DocumentVerificationRoleResultEnum;
    comment?: string | undefined;
}

export class DocumentVersionDto implements IDocumentVersionDto {
    id?: string;
    documentId?: string;
    versionName?: string | undefined;
    versionFrenchName?: string | undefined;
    fileSizeInBytes?: number;
    modifiedDate?: moment.Moment | undefined;
    modifiedBy?: string | undefined;
    documentTypeId?: string;

    constructor(data?: IDocumentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.versionName = _data["versionName"];
            this.versionFrenchName = _data["versionFrenchName"];
            this.fileSizeInBytes = _data["fileSizeInBytes"];
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.documentTypeId = _data["documentTypeId"];
        }
    }

    static fromJS(data: any): DocumentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["versionName"] = this.versionName;
        data["versionFrenchName"] = this.versionFrenchName;
        data["fileSizeInBytes"] = this.fileSizeInBytes;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["documentTypeId"] = this.documentTypeId;
        return data;
    }
}

export interface IDocumentVersionDto {
    id?: string;
    documentId?: string;
    versionName?: string | undefined;
    versionFrenchName?: string | undefined;
    fileSizeInBytes?: number;
    modifiedDate?: moment.Moment | undefined;
    modifiedBy?: string | undefined;
    documentTypeId?: string;
}

export class EstimatedSecuredClaimsMortgage implements IEstimatedSecuredClaimsMortgage {
    mortgageValue?: number;

    constructor(data?: IEstimatedSecuredClaimsMortgage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mortgageValue = _data["mortgageValue"];
        }
    }

    static fromJS(data: any): EstimatedSecuredClaimsMortgage {
        data = typeof data === 'object' ? data : {};
        let result = new EstimatedSecuredClaimsMortgage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mortgageValue"] = this.mortgageValue;
        return data;
    }
}

export interface IEstimatedSecuredClaimsMortgage {
    mortgageValue?: number;
}

export class EstimatedSecuredClaimsPropertyTaxesArrears implements IEstimatedSecuredClaimsPropertyTaxesArrears {
    propertyTaxArrearsValues?: number;

    constructor(data?: IEstimatedSecuredClaimsPropertyTaxesArrears) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyTaxArrearsValues = _data["propertyTaxArrearsValues"];
        }
    }

    static fromJS(data: any): EstimatedSecuredClaimsPropertyTaxesArrears {
        data = typeof data === 'object' ? data : {};
        let result = new EstimatedSecuredClaimsPropertyTaxesArrears();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyTaxArrearsValues"] = this.propertyTaxArrearsValues;
        return data;
    }
}

export interface IEstimatedSecuredClaimsPropertyTaxesArrears {
    propertyTaxArrearsValues?: number;
}

export class FileAnalysisBankruptcyDetailDto implements IFileAnalysisBankruptcyDetailDto {
    id?: string;
    fileId?: string;
    ordinaryFee?: number | undefined;
    legalFee?: number | undefined;
    otherCosts?: number | undefined;
    isOtherCostsSubjectToTax?: boolean;
    stdMultipleForNunavut?: number | undefined;
    stdVoluntaryPayments?: number | undefined;
    allowableMonthlyNetIncome?: number;
    isOverrideMonthlyNetIncome?: boolean;

    constructor(data?: IFileAnalysisBankruptcyDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.ordinaryFee = _data["ordinaryFee"];
            this.legalFee = _data["legalFee"];
            this.otherCosts = _data["otherCosts"];
            this.isOtherCostsSubjectToTax = _data["isOtherCostsSubjectToTax"];
            this.stdMultipleForNunavut = _data["stdMultipleForNunavut"];
            this.stdVoluntaryPayments = _data["stdVoluntaryPayments"];
            this.allowableMonthlyNetIncome = _data["allowableMonthlyNetIncome"];
            this.isOverrideMonthlyNetIncome = _data["isOverrideMonthlyNetIncome"];
        }
    }

    static fromJS(data: any): FileAnalysisBankruptcyDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisBankruptcyDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["ordinaryFee"] = this.ordinaryFee;
        data["legalFee"] = this.legalFee;
        data["otherCosts"] = this.otherCosts;
        data["isOtherCostsSubjectToTax"] = this.isOtherCostsSubjectToTax;
        data["stdMultipleForNunavut"] = this.stdMultipleForNunavut;
        data["stdVoluntaryPayments"] = this.stdVoluntaryPayments;
        data["allowableMonthlyNetIncome"] = this.allowableMonthlyNetIncome;
        data["isOverrideMonthlyNetIncome"] = this.isOverrideMonthlyNetIncome;
        return data;
    }
}

export interface IFileAnalysisBankruptcyDetailDto {
    id?: string;
    fileId?: string;
    ordinaryFee?: number | undefined;
    legalFee?: number | undefined;
    otherCosts?: number | undefined;
    isOtherCostsSubjectToTax?: boolean;
    stdMultipleForNunavut?: number | undefined;
    stdVoluntaryPayments?: number | undefined;
    allowableMonthlyNetIncome?: number;
    isOverrideMonthlyNetIncome?: boolean;
}

export class FileAnalysisCalculationsDto implements IFileAnalysisCalculationsDto {
    fileAnalysisFeeProposalBankruptcyCalculations?: FileAnalysisFeeProposalBankruptcyDto;
    fileAnalysisSurplusIncomeCalculations?: FileAnalysisSurplusIncomeCalculationDto;
    fileAnalysisResultsCalculations?: FileAnalysisResultsCalculationsDto;
    fileAnalysisEstimatedRealizationCalculations?: FileAnalysisEstimatedRealizationsDto;
    form48Text?: string | undefined;

    constructor(data?: IFileAnalysisCalculationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileAnalysisFeeProposalBankruptcyCalculations = _data["fileAnalysisFeeProposalBankruptcyCalculations"] ? FileAnalysisFeeProposalBankruptcyDto.fromJS(_data["fileAnalysisFeeProposalBankruptcyCalculations"]) : <any>undefined;
            this.fileAnalysisSurplusIncomeCalculations = _data["fileAnalysisSurplusIncomeCalculations"] ? FileAnalysisSurplusIncomeCalculationDto.fromJS(_data["fileAnalysisSurplusIncomeCalculations"]) : <any>undefined;
            this.fileAnalysisResultsCalculations = _data["fileAnalysisResultsCalculations"] ? FileAnalysisResultsCalculationsDto.fromJS(_data["fileAnalysisResultsCalculations"]) : <any>undefined;
            this.fileAnalysisEstimatedRealizationCalculations = _data["fileAnalysisEstimatedRealizationCalculations"] ? FileAnalysisEstimatedRealizationsDto.fromJS(_data["fileAnalysisEstimatedRealizationCalculations"]) : <any>undefined;
            this.form48Text = _data["form48Text"];
        }
    }

    static fromJS(data: any): FileAnalysisCalculationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisCalculationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileAnalysisFeeProposalBankruptcyCalculations"] = this.fileAnalysisFeeProposalBankruptcyCalculations ? this.fileAnalysisFeeProposalBankruptcyCalculations.toJSON() : <any>undefined;
        data["fileAnalysisSurplusIncomeCalculations"] = this.fileAnalysisSurplusIncomeCalculations ? this.fileAnalysisSurplusIncomeCalculations.toJSON() : <any>undefined;
        data["fileAnalysisResultsCalculations"] = this.fileAnalysisResultsCalculations ? this.fileAnalysisResultsCalculations.toJSON() : <any>undefined;
        data["fileAnalysisEstimatedRealizationCalculations"] = this.fileAnalysisEstimatedRealizationCalculations ? this.fileAnalysisEstimatedRealizationCalculations.toJSON() : <any>undefined;
        data["form48Text"] = this.form48Text;
        return data;
    }
}

export interface IFileAnalysisCalculationsDto {
    fileAnalysisFeeProposalBankruptcyCalculations?: FileAnalysisFeeProposalBankruptcyDto;
    fileAnalysisSurplusIncomeCalculations?: FileAnalysisSurplusIncomeCalculationDto;
    fileAnalysisResultsCalculations?: FileAnalysisResultsCalculationsDto;
    fileAnalysisEstimatedRealizationCalculations?: FileAnalysisEstimatedRealizationsDto;
    form48Text?: string | undefined;
}

export class FileAnalysisDebtsCreditorsDto implements IFileAnalysisDebtsCreditorsDto {
    fileId?: string;
    totalSecuredClaimsValue?: number;
    ascribedSecuredClaimsValue?: number;
    unsecuredPortionSecuredClaimsValue?: number;
    creditorsNotParticipatingProposalValue?: number;
    contigentDeferredLiabilitiesValue?: number;
    adjustmentToUnsecuredClaimsValue?: number;
    preferredCreditorsValue?: number;
    allUnsecuredCreditorsValue?: number;
    totalUnsecuredClaimsValue?: number;

    constructor(data?: IFileAnalysisDebtsCreditorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.totalSecuredClaimsValue = _data["totalSecuredClaimsValue"];
            this.ascribedSecuredClaimsValue = _data["ascribedSecuredClaimsValue"];
            this.unsecuredPortionSecuredClaimsValue = _data["unsecuredPortionSecuredClaimsValue"];
            this.creditorsNotParticipatingProposalValue = _data["creditorsNotParticipatingProposalValue"];
            this.contigentDeferredLiabilitiesValue = _data["contigentDeferredLiabilitiesValue"];
            this.adjustmentToUnsecuredClaimsValue = _data["adjustmentToUnsecuredClaimsValue"];
            this.preferredCreditorsValue = _data["preferredCreditorsValue"];
            this.allUnsecuredCreditorsValue = _data["allUnsecuredCreditorsValue"];
            this.totalUnsecuredClaimsValue = _data["totalUnsecuredClaimsValue"];
        }
    }

    static fromJS(data: any): FileAnalysisDebtsCreditorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisDebtsCreditorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["totalSecuredClaimsValue"] = this.totalSecuredClaimsValue;
        data["ascribedSecuredClaimsValue"] = this.ascribedSecuredClaimsValue;
        data["unsecuredPortionSecuredClaimsValue"] = this.unsecuredPortionSecuredClaimsValue;
        data["creditorsNotParticipatingProposalValue"] = this.creditorsNotParticipatingProposalValue;
        data["contigentDeferredLiabilitiesValue"] = this.contigentDeferredLiabilitiesValue;
        data["adjustmentToUnsecuredClaimsValue"] = this.adjustmentToUnsecuredClaimsValue;
        data["preferredCreditorsValue"] = this.preferredCreditorsValue;
        data["allUnsecuredCreditorsValue"] = this.allUnsecuredCreditorsValue;
        data["totalUnsecuredClaimsValue"] = this.totalUnsecuredClaimsValue;
        return data;
    }
}

export interface IFileAnalysisDebtsCreditorsDto {
    fileId?: string;
    totalSecuredClaimsValue?: number;
    ascribedSecuredClaimsValue?: number;
    unsecuredPortionSecuredClaimsValue?: number;
    creditorsNotParticipatingProposalValue?: number;
    contigentDeferredLiabilitiesValue?: number;
    adjustmentToUnsecuredClaimsValue?: number;
    preferredCreditorsValue?: number;
    allUnsecuredCreditorsValue?: number;
    totalUnsecuredClaimsValue?: number;
}

export class FileAnalysisEstimatedRealizationsBankruptcyDto implements IFileAnalysisEstimatedRealizationsBankruptcyDto {
    bankruptcyTypeEnum?: BankruptcyTypeEnum;
    bankruptcyType?: string | undefined;
    furniture?: string | undefined;
    personalEffects?: string | undefined;
    cashOnHand?: number;
    policiesPensionsRRSPTotal?: number;
    securitiesTotal?: number;
    realEstateTotals?: FileAnalysisEstimatedRealizationsRealEstateDto[] | undefined;
    motorVehiclesTotal?: number;
    recreationalEquipmentTotal?: number;
    taxRefundsAssetsTotal?: number;
    impactToRecoveryTotal?: number;
    toolsOfTradeTotal?: number;
    huntingFishingFarmingTotal?: number;
    surplusIncomeContributions?: number;
    otherContributionsByDebtor?: number;
    estimatedReceipts?: number;
    filingFee?: number;
    administrativeDisbursements?: number;
    administratorTrusteeFee?: number;
    legalFee?: number;
    otherCostInOrdinaryBankruptcy?: number;
    gst?: number;
    estimatedDisbursements?: number;
    estimatedAmountAvailableForDisbursements?: number;
    estimatedClaimsOfPreferredCreditors?: number;
    estimatedClaimsOfOrdinaryCreditors?: number;
    estimatedClaimsOfSecuredCreditors?: number;
    superintendentsLevy?: number;
    dividendToPreferredCreditors?: number;
    dividendToOrdinaryCreditors?: number;
    dividendToSecuredCreditors?: number;
    totalDividendAndLevy?: number;
    estimatedDistributionToPreferredCreditors?: number;
    estimatedDistributionToOrdinaryCreditors?: number;
    estimatedDistributionToSecuredCreditors?: number;
    allocationAmountAvailablePreferredCreditors?: number;
    allocationAmountAvailableOrdinaryCreditors?: number;
    allocationAmountAvailableSecuredCreditors?: number;
    excessFunds?: number;
    allocationAmountAvailableTotal?: number;

    constructor(data?: IFileAnalysisEstimatedRealizationsBankruptcyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankruptcyTypeEnum = _data["bankruptcyTypeEnum"];
            this.bankruptcyType = _data["bankruptcyType"];
            this.furniture = _data["furniture"];
            this.personalEffects = _data["personalEffects"];
            this.cashOnHand = _data["cashOnHand"];
            this.policiesPensionsRRSPTotal = _data["policiesPensionsRRSPTotal"];
            this.securitiesTotal = _data["securitiesTotal"];
            if (Array.isArray(_data["realEstateTotals"])) {
                this.realEstateTotals = [] as any;
                for (let item of _data["realEstateTotals"])
                    this.realEstateTotals!.push(FileAnalysisEstimatedRealizationsRealEstateDto.fromJS(item));
            }
            this.motorVehiclesTotal = _data["motorVehiclesTotal"];
            this.recreationalEquipmentTotal = _data["recreationalEquipmentTotal"];
            this.taxRefundsAssetsTotal = _data["taxRefundsAssetsTotal"];
            this.impactToRecoveryTotal = _data["impactToRecoveryTotal"];
            this.toolsOfTradeTotal = _data["toolsOfTradeTotal"];
            this.huntingFishingFarmingTotal = _data["huntingFishingFarmingTotal"];
            this.surplusIncomeContributions = _data["surplusIncomeContributions"];
            this.otherContributionsByDebtor = _data["otherContributionsByDebtor"];
            this.estimatedReceipts = _data["estimatedReceipts"];
            this.filingFee = _data["filingFee"];
            this.administrativeDisbursements = _data["administrativeDisbursements"];
            this.administratorTrusteeFee = _data["administratorTrusteeFee"];
            this.legalFee = _data["legalFee"];
            this.otherCostInOrdinaryBankruptcy = _data["otherCostInOrdinaryBankruptcy"];
            this.gst = _data["gst"];
            this.estimatedDisbursements = _data["estimatedDisbursements"];
            this.estimatedAmountAvailableForDisbursements = _data["estimatedAmountAvailableForDisbursements"];
            this.estimatedClaimsOfPreferredCreditors = _data["estimatedClaimsOfPreferredCreditors"];
            this.estimatedClaimsOfOrdinaryCreditors = _data["estimatedClaimsOfOrdinaryCreditors"];
            this.estimatedClaimsOfSecuredCreditors = _data["estimatedClaimsOfSecuredCreditors"];
            this.superintendentsLevy = _data["superintendentsLevy"];
            this.dividendToPreferredCreditors = _data["dividendToPreferredCreditors"];
            this.dividendToOrdinaryCreditors = _data["dividendToOrdinaryCreditors"];
            this.dividendToSecuredCreditors = _data["dividendToSecuredCreditors"];
            this.totalDividendAndLevy = _data["totalDividendAndLevy"];
            this.estimatedDistributionToPreferredCreditors = _data["estimatedDistributionToPreferredCreditors"];
            this.estimatedDistributionToOrdinaryCreditors = _data["estimatedDistributionToOrdinaryCreditors"];
            this.estimatedDistributionToSecuredCreditors = _data["estimatedDistributionToSecuredCreditors"];
            this.allocationAmountAvailablePreferredCreditors = _data["allocationAmountAvailablePreferredCreditors"];
            this.allocationAmountAvailableOrdinaryCreditors = _data["allocationAmountAvailableOrdinaryCreditors"];
            this.allocationAmountAvailableSecuredCreditors = _data["allocationAmountAvailableSecuredCreditors"];
            this.excessFunds = _data["excessFunds"];
            this.allocationAmountAvailableTotal = _data["allocationAmountAvailableTotal"];
        }
    }

    static fromJS(data: any): FileAnalysisEstimatedRealizationsBankruptcyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisEstimatedRealizationsBankruptcyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankruptcyTypeEnum"] = this.bankruptcyTypeEnum;
        data["bankruptcyType"] = this.bankruptcyType;
        data["furniture"] = this.furniture;
        data["personalEffects"] = this.personalEffects;
        data["cashOnHand"] = this.cashOnHand;
        data["policiesPensionsRRSPTotal"] = this.policiesPensionsRRSPTotal;
        data["securitiesTotal"] = this.securitiesTotal;
        if (Array.isArray(this.realEstateTotals)) {
            data["realEstateTotals"] = [];
            for (let item of this.realEstateTotals)
                data["realEstateTotals"].push(item.toJSON());
        }
        data["motorVehiclesTotal"] = this.motorVehiclesTotal;
        data["recreationalEquipmentTotal"] = this.recreationalEquipmentTotal;
        data["taxRefundsAssetsTotal"] = this.taxRefundsAssetsTotal;
        data["impactToRecoveryTotal"] = this.impactToRecoveryTotal;
        data["toolsOfTradeTotal"] = this.toolsOfTradeTotal;
        data["huntingFishingFarmingTotal"] = this.huntingFishingFarmingTotal;
        data["surplusIncomeContributions"] = this.surplusIncomeContributions;
        data["otherContributionsByDebtor"] = this.otherContributionsByDebtor;
        data["estimatedReceipts"] = this.estimatedReceipts;
        data["filingFee"] = this.filingFee;
        data["administrativeDisbursements"] = this.administrativeDisbursements;
        data["administratorTrusteeFee"] = this.administratorTrusteeFee;
        data["legalFee"] = this.legalFee;
        data["otherCostInOrdinaryBankruptcy"] = this.otherCostInOrdinaryBankruptcy;
        data["gst"] = this.gst;
        data["estimatedDisbursements"] = this.estimatedDisbursements;
        data["estimatedAmountAvailableForDisbursements"] = this.estimatedAmountAvailableForDisbursements;
        data["estimatedClaimsOfPreferredCreditors"] = this.estimatedClaimsOfPreferredCreditors;
        data["estimatedClaimsOfOrdinaryCreditors"] = this.estimatedClaimsOfOrdinaryCreditors;
        data["estimatedClaimsOfSecuredCreditors"] = this.estimatedClaimsOfSecuredCreditors;
        data["superintendentsLevy"] = this.superintendentsLevy;
        data["dividendToPreferredCreditors"] = this.dividendToPreferredCreditors;
        data["dividendToOrdinaryCreditors"] = this.dividendToOrdinaryCreditors;
        data["dividendToSecuredCreditors"] = this.dividendToSecuredCreditors;
        data["totalDividendAndLevy"] = this.totalDividendAndLevy;
        data["estimatedDistributionToPreferredCreditors"] = this.estimatedDistributionToPreferredCreditors;
        data["estimatedDistributionToOrdinaryCreditors"] = this.estimatedDistributionToOrdinaryCreditors;
        data["estimatedDistributionToSecuredCreditors"] = this.estimatedDistributionToSecuredCreditors;
        data["allocationAmountAvailablePreferredCreditors"] = this.allocationAmountAvailablePreferredCreditors;
        data["allocationAmountAvailableOrdinaryCreditors"] = this.allocationAmountAvailableOrdinaryCreditors;
        data["allocationAmountAvailableSecuredCreditors"] = this.allocationAmountAvailableSecuredCreditors;
        data["excessFunds"] = this.excessFunds;
        data["allocationAmountAvailableTotal"] = this.allocationAmountAvailableTotal;
        return data;
    }
}

export interface IFileAnalysisEstimatedRealizationsBankruptcyDto {
    bankruptcyTypeEnum?: BankruptcyTypeEnum;
    bankruptcyType?: string | undefined;
    furniture?: string | undefined;
    personalEffects?: string | undefined;
    cashOnHand?: number;
    policiesPensionsRRSPTotal?: number;
    securitiesTotal?: number;
    realEstateTotals?: FileAnalysisEstimatedRealizationsRealEstateDto[] | undefined;
    motorVehiclesTotal?: number;
    recreationalEquipmentTotal?: number;
    taxRefundsAssetsTotal?: number;
    impactToRecoveryTotal?: number;
    toolsOfTradeTotal?: number;
    huntingFishingFarmingTotal?: number;
    surplusIncomeContributions?: number;
    otherContributionsByDebtor?: number;
    estimatedReceipts?: number;
    filingFee?: number;
    administrativeDisbursements?: number;
    administratorTrusteeFee?: number;
    legalFee?: number;
    otherCostInOrdinaryBankruptcy?: number;
    gst?: number;
    estimatedDisbursements?: number;
    estimatedAmountAvailableForDisbursements?: number;
    estimatedClaimsOfPreferredCreditors?: number;
    estimatedClaimsOfOrdinaryCreditors?: number;
    estimatedClaimsOfSecuredCreditors?: number;
    superintendentsLevy?: number;
    dividendToPreferredCreditors?: number;
    dividendToOrdinaryCreditors?: number;
    dividendToSecuredCreditors?: number;
    totalDividendAndLevy?: number;
    estimatedDistributionToPreferredCreditors?: number;
    estimatedDistributionToOrdinaryCreditors?: number;
    estimatedDistributionToSecuredCreditors?: number;
    allocationAmountAvailablePreferredCreditors?: number;
    allocationAmountAvailableOrdinaryCreditors?: number;
    allocationAmountAvailableSecuredCreditors?: number;
    excessFunds?: number;
    allocationAmountAvailableTotal?: number;
}

export class FileAnalysisEstimatedRealizationsDto implements IFileAnalysisEstimatedRealizationsDto {
    bankruptcy?: FileAnalysisEstimatedRealizationsBankruptcyDto;
    proposal?: FileAnalysisEstimatedRealizationsProposalDto;

    constructor(data?: IFileAnalysisEstimatedRealizationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankruptcy = _data["bankruptcy"] ? FileAnalysisEstimatedRealizationsBankruptcyDto.fromJS(_data["bankruptcy"]) : <any>undefined;
            this.proposal = _data["proposal"] ? FileAnalysisEstimatedRealizationsProposalDto.fromJS(_data["proposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileAnalysisEstimatedRealizationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisEstimatedRealizationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankruptcy"] = this.bankruptcy ? this.bankruptcy.toJSON() : <any>undefined;
        data["proposal"] = this.proposal ? this.proposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileAnalysisEstimatedRealizationsDto {
    bankruptcy?: FileAnalysisEstimatedRealizationsBankruptcyDto;
    proposal?: FileAnalysisEstimatedRealizationsProposalDto;
}

export class FileAnalysisEstimatedRealizationsProposalDto implements IFileAnalysisEstimatedRealizationsProposalDto {
    proposalTypeEnum?: ProposalTypeEnum;
    proposalType?: string | undefined;
    totalProposalPayments?: number;
    estimatedReceipts?: number;
    filingFee?: number;
    administrativeDisbursements?: number;
    administratorTrusteeFee?: number;
    legalFee?: number;
    otherCostInOrdinaryBankruptcy?: number;
    taxTypeLabel?: string | undefined;
    gst?: number;
    estimatedDisbursements?: number;
    estimatedAmountAvailableForDisbursements?: number;
    estimatedClaimsOfPreferredCreditors?: number;
    estimatedClaimsOfOrdinaryCreditors?: number;
    estimatedClaimsOfSecuredCreditors?: number;
    superintendentsLevy?: number;
    dividendToPreferredCreditors?: number;
    dividendToOrdinaryCreditors?: number;
    dividendToSecuredCreditors?: number;
    totalDividendAndLevy?: number;
    estimatedDistributionToPreferredCreditors?: number;
    estimatedDistributionToOrdinaryCreditors?: number;
    estimatedDistributionToSecuredCreditors?: number;
    allocationAmountAvailablePreferredCreditors?: number;
    allocationAmountAvailableOrdinaryCreditors?: number;
    allocationAmountAvailableSecuredCreditors?: number;
    excessFunds?: number;
    allocationAmountAvailableTotal?: number;

    constructor(data?: IFileAnalysisEstimatedRealizationsProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalTypeEnum = _data["proposalTypeEnum"];
            this.proposalType = _data["proposalType"];
            this.totalProposalPayments = _data["totalProposalPayments"];
            this.estimatedReceipts = _data["estimatedReceipts"];
            this.filingFee = _data["filingFee"];
            this.administrativeDisbursements = _data["administrativeDisbursements"];
            this.administratorTrusteeFee = _data["administratorTrusteeFee"];
            this.legalFee = _data["legalFee"];
            this.otherCostInOrdinaryBankruptcy = _data["otherCostInOrdinaryBankruptcy"];
            this.taxTypeLabel = _data["taxTypeLabel"];
            this.gst = _data["gst"];
            this.estimatedDisbursements = _data["estimatedDisbursements"];
            this.estimatedAmountAvailableForDisbursements = _data["estimatedAmountAvailableForDisbursements"];
            this.estimatedClaimsOfPreferredCreditors = _data["estimatedClaimsOfPreferredCreditors"];
            this.estimatedClaimsOfOrdinaryCreditors = _data["estimatedClaimsOfOrdinaryCreditors"];
            this.estimatedClaimsOfSecuredCreditors = _data["estimatedClaimsOfSecuredCreditors"];
            this.superintendentsLevy = _data["superintendentsLevy"];
            this.dividendToPreferredCreditors = _data["dividendToPreferredCreditors"];
            this.dividendToOrdinaryCreditors = _data["dividendToOrdinaryCreditors"];
            this.dividendToSecuredCreditors = _data["dividendToSecuredCreditors"];
            this.totalDividendAndLevy = _data["totalDividendAndLevy"];
            this.estimatedDistributionToPreferredCreditors = _data["estimatedDistributionToPreferredCreditors"];
            this.estimatedDistributionToOrdinaryCreditors = _data["estimatedDistributionToOrdinaryCreditors"];
            this.estimatedDistributionToSecuredCreditors = _data["estimatedDistributionToSecuredCreditors"];
            this.allocationAmountAvailablePreferredCreditors = _data["allocationAmountAvailablePreferredCreditors"];
            this.allocationAmountAvailableOrdinaryCreditors = _data["allocationAmountAvailableOrdinaryCreditors"];
            this.allocationAmountAvailableSecuredCreditors = _data["allocationAmountAvailableSecuredCreditors"];
            this.excessFunds = _data["excessFunds"];
            this.allocationAmountAvailableTotal = _data["allocationAmountAvailableTotal"];
        }
    }

    static fromJS(data: any): FileAnalysisEstimatedRealizationsProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisEstimatedRealizationsProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalTypeEnum"] = this.proposalTypeEnum;
        data["proposalType"] = this.proposalType;
        data["totalProposalPayments"] = this.totalProposalPayments;
        data["estimatedReceipts"] = this.estimatedReceipts;
        data["filingFee"] = this.filingFee;
        data["administrativeDisbursements"] = this.administrativeDisbursements;
        data["administratorTrusteeFee"] = this.administratorTrusteeFee;
        data["legalFee"] = this.legalFee;
        data["otherCostInOrdinaryBankruptcy"] = this.otherCostInOrdinaryBankruptcy;
        data["taxTypeLabel"] = this.taxTypeLabel;
        data["gst"] = this.gst;
        data["estimatedDisbursements"] = this.estimatedDisbursements;
        data["estimatedAmountAvailableForDisbursements"] = this.estimatedAmountAvailableForDisbursements;
        data["estimatedClaimsOfPreferredCreditors"] = this.estimatedClaimsOfPreferredCreditors;
        data["estimatedClaimsOfOrdinaryCreditors"] = this.estimatedClaimsOfOrdinaryCreditors;
        data["estimatedClaimsOfSecuredCreditors"] = this.estimatedClaimsOfSecuredCreditors;
        data["superintendentsLevy"] = this.superintendentsLevy;
        data["dividendToPreferredCreditors"] = this.dividendToPreferredCreditors;
        data["dividendToOrdinaryCreditors"] = this.dividendToOrdinaryCreditors;
        data["dividendToSecuredCreditors"] = this.dividendToSecuredCreditors;
        data["totalDividendAndLevy"] = this.totalDividendAndLevy;
        data["estimatedDistributionToPreferredCreditors"] = this.estimatedDistributionToPreferredCreditors;
        data["estimatedDistributionToOrdinaryCreditors"] = this.estimatedDistributionToOrdinaryCreditors;
        data["estimatedDistributionToSecuredCreditors"] = this.estimatedDistributionToSecuredCreditors;
        data["allocationAmountAvailablePreferredCreditors"] = this.allocationAmountAvailablePreferredCreditors;
        data["allocationAmountAvailableOrdinaryCreditors"] = this.allocationAmountAvailableOrdinaryCreditors;
        data["allocationAmountAvailableSecuredCreditors"] = this.allocationAmountAvailableSecuredCreditors;
        data["excessFunds"] = this.excessFunds;
        data["allocationAmountAvailableTotal"] = this.allocationAmountAvailableTotal;
        return data;
    }
}

export interface IFileAnalysisEstimatedRealizationsProposalDto {
    proposalTypeEnum?: ProposalTypeEnum;
    proposalType?: string | undefined;
    totalProposalPayments?: number;
    estimatedReceipts?: number;
    filingFee?: number;
    administrativeDisbursements?: number;
    administratorTrusteeFee?: number;
    legalFee?: number;
    otherCostInOrdinaryBankruptcy?: number;
    taxTypeLabel?: string | undefined;
    gst?: number;
    estimatedDisbursements?: number;
    estimatedAmountAvailableForDisbursements?: number;
    estimatedClaimsOfPreferredCreditors?: number;
    estimatedClaimsOfOrdinaryCreditors?: number;
    estimatedClaimsOfSecuredCreditors?: number;
    superintendentsLevy?: number;
    dividendToPreferredCreditors?: number;
    dividendToOrdinaryCreditors?: number;
    dividendToSecuredCreditors?: number;
    totalDividendAndLevy?: number;
    estimatedDistributionToPreferredCreditors?: number;
    estimatedDistributionToOrdinaryCreditors?: number;
    estimatedDistributionToSecuredCreditors?: number;
    allocationAmountAvailablePreferredCreditors?: number;
    allocationAmountAvailableOrdinaryCreditors?: number;
    allocationAmountAvailableSecuredCreditors?: number;
    excessFunds?: number;
    allocationAmountAvailableTotal?: number;
}

export class FileAnalysisEstimatedRealizationsRealEstateDto implements IFileAnalysisEstimatedRealizationsRealEstateDto {
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    isPrincipalResidence?: boolean;
    realEstateTotal?: number;

    constructor(data?: IFileAnalysisEstimatedRealizationsRealEstateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.realEstateTotal = _data["realEstateTotal"];
        }
    }

    static fromJS(data: any): FileAnalysisEstimatedRealizationsRealEstateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisEstimatedRealizationsRealEstateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["realEstateTotal"] = this.realEstateTotal;
        return data;
    }
}

export interface IFileAnalysisEstimatedRealizationsRealEstateDto {
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    isPrincipalResidence?: boolean;
    realEstateTotal?: number;
}

export class FileAnalysisFeeDivisionProposalDto implements IFileAnalysisFeeDivisionProposalDto {
    counsellingFee?: number;
    onFilingOfProposalFee?: number;
    onApprovalDeemedApprovalFee?: number;
    distributionReceipts?: number;
    distributionFilingFee?: number;
    distributionCounsellingFee?: number;
    distributionOnFiling?: number;
    distributionOnApprovalDeemedApproval?: number;
    gstOnFee?: number;
    distributionTotal?: number;
    amount15Percent?: number;
    trusteeFeeBeforeGST?: number;

    constructor(data?: IFileAnalysisFeeDivisionProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counsellingFee = _data["counsellingFee"];
            this.onFilingOfProposalFee = _data["onFilingOfProposalFee"];
            this.onApprovalDeemedApprovalFee = _data["onApprovalDeemedApprovalFee"];
            this.distributionReceipts = _data["distributionReceipts"];
            this.distributionFilingFee = _data["distributionFilingFee"];
            this.distributionCounsellingFee = _data["distributionCounsellingFee"];
            this.distributionOnFiling = _data["distributionOnFiling"];
            this.distributionOnApprovalDeemedApproval = _data["distributionOnApprovalDeemedApproval"];
            this.gstOnFee = _data["gstOnFee"];
            this.distributionTotal = _data["distributionTotal"];
            this.amount15Percent = _data["amount15Percent"];
            this.trusteeFeeBeforeGST = _data["trusteeFeeBeforeGST"];
        }
    }

    static fromJS(data: any): FileAnalysisFeeDivisionProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisFeeDivisionProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counsellingFee"] = this.counsellingFee;
        data["onFilingOfProposalFee"] = this.onFilingOfProposalFee;
        data["onApprovalDeemedApprovalFee"] = this.onApprovalDeemedApprovalFee;
        data["distributionReceipts"] = this.distributionReceipts;
        data["distributionFilingFee"] = this.distributionFilingFee;
        data["distributionCounsellingFee"] = this.distributionCounsellingFee;
        data["distributionOnFiling"] = this.distributionOnFiling;
        data["distributionOnApprovalDeemedApproval"] = this.distributionOnApprovalDeemedApproval;
        data["gstOnFee"] = this.gstOnFee;
        data["distributionTotal"] = this.distributionTotal;
        data["amount15Percent"] = this.amount15Percent;
        data["trusteeFeeBeforeGST"] = this.trusteeFeeBeforeGST;
        return data;
    }
}

export interface IFileAnalysisFeeDivisionProposalDto {
    counsellingFee?: number;
    onFilingOfProposalFee?: number;
    onApprovalDeemedApprovalFee?: number;
    distributionReceipts?: number;
    distributionFilingFee?: number;
    distributionCounsellingFee?: number;
    distributionOnFiling?: number;
    distributionOnApprovalDeemedApproval?: number;
    gstOnFee?: number;
    distributionTotal?: number;
    amount15Percent?: number;
    trusteeFeeBeforeGST?: number;
}

export class FileAnalysisFeeInAConsumerProposalDto implements IFileAnalysisFeeInAConsumerProposalDto {
    counsellingFee?: number;
    onFilingOfProposalFee?: number;
    onApprovalDeemedApprovalFee?: number;
    distributionReceipts?: number;
    distributionFilingFee?: number;
    distributionCounsellingFee?: number;
    distributionOnFiling?: number;
    distributionOnApprovalDeemedApproval?: number;
    gstOnFee?: number;
    distributionTotal?: number;
    twentyPercentAmount?: number;
    trusteeFee?: number;

    constructor(data?: IFileAnalysisFeeInAConsumerProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counsellingFee = _data["counsellingFee"];
            this.onFilingOfProposalFee = _data["onFilingOfProposalFee"];
            this.onApprovalDeemedApprovalFee = _data["onApprovalDeemedApprovalFee"];
            this.distributionReceipts = _data["distributionReceipts"];
            this.distributionFilingFee = _data["distributionFilingFee"];
            this.distributionCounsellingFee = _data["distributionCounsellingFee"];
            this.distributionOnFiling = _data["distributionOnFiling"];
            this.distributionOnApprovalDeemedApproval = _data["distributionOnApprovalDeemedApproval"];
            this.gstOnFee = _data["gstOnFee"];
            this.distributionTotal = _data["distributionTotal"];
            this.twentyPercentAmount = _data["twentyPercentAmount"];
            this.trusteeFee = _data["trusteeFee"];
        }
    }

    static fromJS(data: any): FileAnalysisFeeInAConsumerProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisFeeInAConsumerProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counsellingFee"] = this.counsellingFee;
        data["onFilingOfProposalFee"] = this.onFilingOfProposalFee;
        data["onApprovalDeemedApprovalFee"] = this.onApprovalDeemedApprovalFee;
        data["distributionReceipts"] = this.distributionReceipts;
        data["distributionFilingFee"] = this.distributionFilingFee;
        data["distributionCounsellingFee"] = this.distributionCounsellingFee;
        data["distributionOnFiling"] = this.distributionOnFiling;
        data["distributionOnApprovalDeemedApproval"] = this.distributionOnApprovalDeemedApproval;
        data["gstOnFee"] = this.gstOnFee;
        data["distributionTotal"] = this.distributionTotal;
        data["twentyPercentAmount"] = this.twentyPercentAmount;
        data["trusteeFee"] = this.trusteeFee;
        return data;
    }
}

export interface IFileAnalysisFeeInAConsumerProposalDto {
    counsellingFee?: number;
    onFilingOfProposalFee?: number;
    onApprovalDeemedApprovalFee?: number;
    distributionReceipts?: number;
    distributionFilingFee?: number;
    distributionCounsellingFee?: number;
    distributionOnFiling?: number;
    distributionOnApprovalDeemedApproval?: number;
    gstOnFee?: number;
    distributionTotal?: number;
    twentyPercentAmount?: number;
    trusteeFee?: number;
}

export class FileAnalysisFeeInASummaryBankruptcyDto implements IFileAnalysisFeeInASummaryBankruptcyDto {
    estimatedReceiptsDebtor?: number;
    counsellingFeeDebtor?: number;
    trusteeFeeFirst975Debtor?: number;
    trusteeFeeNext2000Debtor?: number;
    trusteeFeeBalanceDebtor?: number;
    trusteeFeeBeforeGSTDebtor?: number;
    filingFeeDebtor?: number;
    estimatedReceiptsSpouse?: number;
    filingFeeSpouse?: number;

    constructor(data?: IFileAnalysisFeeInASummaryBankruptcyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedReceiptsDebtor = _data["estimatedReceiptsDebtor"];
            this.counsellingFeeDebtor = _data["counsellingFeeDebtor"];
            this.trusteeFeeFirst975Debtor = _data["trusteeFeeFirst975Debtor"];
            this.trusteeFeeNext2000Debtor = _data["trusteeFeeNext2000Debtor"];
            this.trusteeFeeBalanceDebtor = _data["trusteeFeeBalanceDebtor"];
            this.trusteeFeeBeforeGSTDebtor = _data["trusteeFeeBeforeGSTDebtor"];
            this.filingFeeDebtor = _data["filingFeeDebtor"];
            this.estimatedReceiptsSpouse = _data["estimatedReceiptsSpouse"];
            this.filingFeeSpouse = _data["filingFeeSpouse"];
        }
    }

    static fromJS(data: any): FileAnalysisFeeInASummaryBankruptcyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisFeeInASummaryBankruptcyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedReceiptsDebtor"] = this.estimatedReceiptsDebtor;
        data["counsellingFeeDebtor"] = this.counsellingFeeDebtor;
        data["trusteeFeeFirst975Debtor"] = this.trusteeFeeFirst975Debtor;
        data["trusteeFeeNext2000Debtor"] = this.trusteeFeeNext2000Debtor;
        data["trusteeFeeBalanceDebtor"] = this.trusteeFeeBalanceDebtor;
        data["trusteeFeeBeforeGSTDebtor"] = this.trusteeFeeBeforeGSTDebtor;
        data["filingFeeDebtor"] = this.filingFeeDebtor;
        data["estimatedReceiptsSpouse"] = this.estimatedReceiptsSpouse;
        data["filingFeeSpouse"] = this.filingFeeSpouse;
        return data;
    }
}

export interface IFileAnalysisFeeInASummaryBankruptcyDto {
    estimatedReceiptsDebtor?: number;
    counsellingFeeDebtor?: number;
    trusteeFeeFirst975Debtor?: number;
    trusteeFeeNext2000Debtor?: number;
    trusteeFeeBalanceDebtor?: number;
    trusteeFeeBeforeGSTDebtor?: number;
    filingFeeDebtor?: number;
    estimatedReceiptsSpouse?: number;
    filingFeeSpouse?: number;
}

export class FileAnalysisFeeOrdinaryBankruptcyDto implements IFileAnalysisFeeOrdinaryBankruptcyDto {
    counsellingFee?: number;
    trusteeFee?: number;
    trusteeFeeBeforeGST?: number;
    filingFee?: number;

    constructor(data?: IFileAnalysisFeeOrdinaryBankruptcyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.counsellingFee = _data["counsellingFee"];
            this.trusteeFee = _data["trusteeFee"];
            this.trusteeFeeBeforeGST = _data["trusteeFeeBeforeGST"];
            this.filingFee = _data["filingFee"];
        }
    }

    static fromJS(data: any): FileAnalysisFeeOrdinaryBankruptcyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisFeeOrdinaryBankruptcyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counsellingFee"] = this.counsellingFee;
        data["trusteeFee"] = this.trusteeFee;
        data["trusteeFeeBeforeGST"] = this.trusteeFeeBeforeGST;
        data["filingFee"] = this.filingFee;
        return data;
    }
}

export interface IFileAnalysisFeeOrdinaryBankruptcyDto {
    counsellingFee?: number;
    trusteeFee?: number;
    trusteeFeeBeforeGST?: number;
    filingFee?: number;
}

export class FileAnalysisFeeProposalBankruptcyDto implements IFileAnalysisFeeProposalBankruptcyDto {
    fileAnalysisFeeInAConsumerProposal?: FileAnalysisFeeInAConsumerProposalDto;
    fileAnalysisFeeInASummaryBankruptcy?: FileAnalysisFeeInASummaryBankruptcyDto;
    fileAnalysisFeeInAOrdinaryBankruptcy?: FileAnalysisFeeOrdinaryBankruptcyDto;
    fileAnalysisFeeInADivisionProposal?: FileAnalysisFeeDivisionProposalDto;

    constructor(data?: IFileAnalysisFeeProposalBankruptcyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileAnalysisFeeInAConsumerProposal = _data["fileAnalysisFeeInAConsumerProposal"] ? FileAnalysisFeeInAConsumerProposalDto.fromJS(_data["fileAnalysisFeeInAConsumerProposal"]) : <any>undefined;
            this.fileAnalysisFeeInASummaryBankruptcy = _data["fileAnalysisFeeInASummaryBankruptcy"] ? FileAnalysisFeeInASummaryBankruptcyDto.fromJS(_data["fileAnalysisFeeInASummaryBankruptcy"]) : <any>undefined;
            this.fileAnalysisFeeInAOrdinaryBankruptcy = _data["fileAnalysisFeeInAOrdinaryBankruptcy"] ? FileAnalysisFeeOrdinaryBankruptcyDto.fromJS(_data["fileAnalysisFeeInAOrdinaryBankruptcy"]) : <any>undefined;
            this.fileAnalysisFeeInADivisionProposal = _data["fileAnalysisFeeInADivisionProposal"] ? FileAnalysisFeeDivisionProposalDto.fromJS(_data["fileAnalysisFeeInADivisionProposal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileAnalysisFeeProposalBankruptcyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisFeeProposalBankruptcyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileAnalysisFeeInAConsumerProposal"] = this.fileAnalysisFeeInAConsumerProposal ? this.fileAnalysisFeeInAConsumerProposal.toJSON() : <any>undefined;
        data["fileAnalysisFeeInASummaryBankruptcy"] = this.fileAnalysisFeeInASummaryBankruptcy ? this.fileAnalysisFeeInASummaryBankruptcy.toJSON() : <any>undefined;
        data["fileAnalysisFeeInAOrdinaryBankruptcy"] = this.fileAnalysisFeeInAOrdinaryBankruptcy ? this.fileAnalysisFeeInAOrdinaryBankruptcy.toJSON() : <any>undefined;
        data["fileAnalysisFeeInADivisionProposal"] = this.fileAnalysisFeeInADivisionProposal ? this.fileAnalysisFeeInADivisionProposal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileAnalysisFeeProposalBankruptcyDto {
    fileAnalysisFeeInAConsumerProposal?: FileAnalysisFeeInAConsumerProposalDto;
    fileAnalysisFeeInASummaryBankruptcy?: FileAnalysisFeeInASummaryBankruptcyDto;
    fileAnalysisFeeInAOrdinaryBankruptcy?: FileAnalysisFeeOrdinaryBankruptcyDto;
    fileAnalysisFeeInADivisionProposal?: FileAnalysisFeeDivisionProposalDto;
}

export class FileAnalysisHuntingFishingFarmingAssetDetailsDto implements IFileAnalysisHuntingFishingFarmingAssetDetailsDto {
    estimatedValue?: number;
    personalExemption?: number;
    huntingFishingFarmingRealization?: number | undefined;

    constructor(data?: IFileAnalysisHuntingFishingFarmingAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedValue = _data["estimatedValue"];
            this.personalExemption = _data["personalExemption"];
            this.huntingFishingFarmingRealization = _data["huntingFishingFarmingRealization"];
        }
    }

    static fromJS(data: any): FileAnalysisHuntingFishingFarmingAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisHuntingFishingFarmingAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedValue"] = this.estimatedValue;
        data["personalExemption"] = this.personalExemption;
        data["huntingFishingFarmingRealization"] = this.huntingFishingFarmingRealization;
        return data;
    }
}

export interface IFileAnalysisHuntingFishingFarmingAssetDetailsDto {
    estimatedValue?: number;
    personalExemption?: number;
    huntingFishingFarmingRealization?: number | undefined;
}

export class FileAnalysisInvestmentAssetDetails implements IFileAnalysisInvestmentAssetDetails {
    investmentExemptOrNone?: string | undefined;
    investmentName?: string | undefined;
    currentMarketValue?: number;
    estimatedTaxOnDisposition?: number;
    estimatedEquity?: number;
    debtorsInterest?: number;

    constructor(data?: IFileAnalysisInvestmentAssetDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investmentExemptOrNone = _data["investmentExemptOrNone"];
            this.investmentName = _data["investmentName"];
            this.currentMarketValue = _data["currentMarketValue"];
            this.estimatedTaxOnDisposition = _data["estimatedTaxOnDisposition"];
            this.estimatedEquity = _data["estimatedEquity"];
            this.debtorsInterest = _data["debtorsInterest"];
        }
    }

    static fromJS(data: any): FileAnalysisInvestmentAssetDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisInvestmentAssetDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investmentExemptOrNone"] = this.investmentExemptOrNone;
        data["investmentName"] = this.investmentName;
        data["currentMarketValue"] = this.currentMarketValue;
        data["estimatedTaxOnDisposition"] = this.estimatedTaxOnDisposition;
        data["estimatedEquity"] = this.estimatedEquity;
        data["debtorsInterest"] = this.debtorsInterest;
        return data;
    }
}

export interface IFileAnalysisInvestmentAssetDetails {
    investmentExemptOrNone?: string | undefined;
    investmentName?: string | undefined;
    currentMarketValue?: number;
    estimatedTaxOnDisposition?: number;
    estimatedEquity?: number;
    debtorsInterest?: number;
}

export class FileAnalysisMotorVehiclesAssetDetailsDto implements IFileAnalysisMotorVehiclesAssetDetailsDto {
    make?: string | undefined;
    model?: string | undefined;
    estimatedValue?: number;
    outstandingLoanLease?: number;
    valueAfterDebts?: number;
    personalExemption?: number;
    estimatedEquity?: number;

    constructor(data?: IFileAnalysisMotorVehiclesAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.make = _data["make"];
            this.model = _data["model"];
            this.estimatedValue = _data["estimatedValue"];
            this.outstandingLoanLease = _data["outstandingLoanLease"];
            this.valueAfterDebts = _data["valueAfterDebts"];
            this.personalExemption = _data["personalExemption"];
            this.estimatedEquity = _data["estimatedEquity"];
        }
    }

    static fromJS(data: any): FileAnalysisMotorVehiclesAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisMotorVehiclesAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["make"] = this.make;
        data["model"] = this.model;
        data["estimatedValue"] = this.estimatedValue;
        data["outstandingLoanLease"] = this.outstandingLoanLease;
        data["valueAfterDebts"] = this.valueAfterDebts;
        data["personalExemption"] = this.personalExemption;
        data["estimatedEquity"] = this.estimatedEquity;
        return data;
    }
}

export interface IFileAnalysisMotorVehiclesAssetDetailsDto {
    make?: string | undefined;
    model?: string | undefined;
    estimatedValue?: number;
    outstandingLoanLease?: number;
    valueAfterDebts?: number;
    personalExemption?: number;
    estimatedEquity?: number;
}

export class FileAnalysisNWTerritoryMultiplesConfigurationDto implements IFileAnalysisNWTerritoryMultiplesConfigurationDto {
    id?: string;
    orderNumber?: number;
    enumValue?: NWTerritoryCommunityNameEnum;
    communityName?: string | undefined;
    multiple?: number;

    constructor(data?: IFileAnalysisNWTerritoryMultiplesConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.communityName = _data["communityName"];
            this.multiple = _data["multiple"];
        }
    }

    static fromJS(data: any): FileAnalysisNWTerritoryMultiplesConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisNWTerritoryMultiplesConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["communityName"] = this.communityName;
        data["multiple"] = this.multiple;
        return data;
    }
}

export interface IFileAnalysisNWTerritoryMultiplesConfigurationDto {
    id?: string;
    orderNumber?: number;
    enumValue?: NWTerritoryCommunityNameEnum;
    communityName?: string | undefined;
    multiple?: number;
}

export class FileAnalysisNWTerritoryMultiplesConfigurationInputDto implements IFileAnalysisNWTerritoryMultiplesConfigurationInputDto {
    id?: string;
    multiple?: number;

    constructor(data?: IFileAnalysisNWTerritoryMultiplesConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.multiple = _data["multiple"];
        }
    }

    static fromJS(data: any): FileAnalysisNWTerritoryMultiplesConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisNWTerritoryMultiplesConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["multiple"] = this.multiple;
        return data;
    }
}

export interface IFileAnalysisNWTerritoryMultiplesConfigurationInputDto {
    id?: string;
    multiple?: number;
}

export class FileAnalysisOSBFilingAndOtherFeeConfigurationDto implements IFileAnalysisOSBFilingAndOtherFeeConfigurationDto {
    id?: string;
    orderNumber?: number;
    enumValue?: OSBAndOtherFeeTypeEnum;
    feeType?: string | undefined;
    amount?: number;

    constructor(data?: IFileAnalysisOSBFilingAndOtherFeeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.feeType = _data["feeType"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FileAnalysisOSBFilingAndOtherFeeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisOSBFilingAndOtherFeeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["feeType"] = this.feeType;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFileAnalysisOSBFilingAndOtherFeeConfigurationDto {
    id?: string;
    orderNumber?: number;
    enumValue?: OSBAndOtherFeeTypeEnum;
    feeType?: string | undefined;
    amount?: number;
}

export class FileAnalysisOSBFilingAndOtherFeeConfigurationInputDto implements IFileAnalysisOSBFilingAndOtherFeeConfigurationInputDto {
    id?: string;
    amount?: number;

    constructor(data?: IFileAnalysisOSBFilingAndOtherFeeConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FileAnalysisOSBFilingAndOtherFeeConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisOSBFilingAndOtherFeeConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFileAnalysisOSBFilingAndOtherFeeConfigurationInputDto {
    id?: string;
    amount?: number;
}

export class FileAnalysisProposalDetailDto implements IFileAnalysisProposalDetailDto {
    id?: string;
    fileId?: string;
    initialDepositAmount?: number | undefined;
    lumpSumAmount?: number | undefined;
    administratorTrusteeFeeSubjectToTaxes?: boolean;
    adminConsumerProposalEnum?: AdminConsumerProposalEnum;
    adminConsumerProposalId?: string | undefined;
    monthlyPaymentDetails?: FileAnalysisProposalMonthlyPaymentDetailDto[] | undefined;
    proposalPaymentsTotal?: number | undefined;
    proposalContribution?: number | undefined;

    constructor(data?: IFileAnalysisProposalDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.initialDepositAmount = _data["initialDepositAmount"];
            this.lumpSumAmount = _data["lumpSumAmount"];
            this.administratorTrusteeFeeSubjectToTaxes = _data["administratorTrusteeFeeSubjectToTaxes"];
            this.adminConsumerProposalEnum = _data["adminConsumerProposalEnum"];
            this.adminConsumerProposalId = _data["adminConsumerProposalId"];
            if (Array.isArray(_data["monthlyPaymentDetails"])) {
                this.monthlyPaymentDetails = [] as any;
                for (let item of _data["monthlyPaymentDetails"])
                    this.monthlyPaymentDetails!.push(FileAnalysisProposalMonthlyPaymentDetailDto.fromJS(item));
            }
            this.proposalPaymentsTotal = _data["proposalPaymentsTotal"];
            this.proposalContribution = _data["proposalContribution"];
        }
    }

    static fromJS(data: any): FileAnalysisProposalDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisProposalDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["initialDepositAmount"] = this.initialDepositAmount;
        data["lumpSumAmount"] = this.lumpSumAmount;
        data["administratorTrusteeFeeSubjectToTaxes"] = this.administratorTrusteeFeeSubjectToTaxes;
        data["adminConsumerProposalEnum"] = this.adminConsumerProposalEnum;
        data["adminConsumerProposalId"] = this.adminConsumerProposalId;
        if (Array.isArray(this.monthlyPaymentDetails)) {
            data["monthlyPaymentDetails"] = [];
            for (let item of this.monthlyPaymentDetails)
                data["monthlyPaymentDetails"].push(item.toJSON());
        }
        data["proposalPaymentsTotal"] = this.proposalPaymentsTotal;
        data["proposalContribution"] = this.proposalContribution;
        return data;
    }
}

export interface IFileAnalysisProposalDetailDto {
    id?: string;
    fileId?: string;
    initialDepositAmount?: number | undefined;
    lumpSumAmount?: number | undefined;
    administratorTrusteeFeeSubjectToTaxes?: boolean;
    adminConsumerProposalEnum?: AdminConsumerProposalEnum;
    adminConsumerProposalId?: string | undefined;
    monthlyPaymentDetails?: FileAnalysisProposalMonthlyPaymentDetailDto[] | undefined;
    proposalPaymentsTotal?: number | undefined;
    proposalContribution?: number | undefined;
}

export class FileAnalysisProposalDetailInputDto implements IFileAnalysisProposalDetailInputDto {
    fileId?: string;
    initialDepositAmount?: number;
    lumpSumAmount?: number;
    administratorTrusteeFeeSubjectToTaxes?: boolean;
    adminConsumerProposalId?: string | undefined;
    monthlyPaymentDetails?: FileAnalysisProposalMonthlyPaymentDetailDto[] | undefined;

    constructor(data?: IFileAnalysisProposalDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.initialDepositAmount = _data["initialDepositAmount"];
            this.lumpSumAmount = _data["lumpSumAmount"];
            this.administratorTrusteeFeeSubjectToTaxes = _data["administratorTrusteeFeeSubjectToTaxes"];
            this.adminConsumerProposalId = _data["adminConsumerProposalId"];
            if (Array.isArray(_data["monthlyPaymentDetails"])) {
                this.monthlyPaymentDetails = [] as any;
                for (let item of _data["monthlyPaymentDetails"])
                    this.monthlyPaymentDetails!.push(FileAnalysisProposalMonthlyPaymentDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileAnalysisProposalDetailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisProposalDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["initialDepositAmount"] = this.initialDepositAmount;
        data["lumpSumAmount"] = this.lumpSumAmount;
        data["administratorTrusteeFeeSubjectToTaxes"] = this.administratorTrusteeFeeSubjectToTaxes;
        data["adminConsumerProposalId"] = this.adminConsumerProposalId;
        if (Array.isArray(this.monthlyPaymentDetails)) {
            data["monthlyPaymentDetails"] = [];
            for (let item of this.monthlyPaymentDetails)
                data["monthlyPaymentDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileAnalysisProposalDetailInputDto {
    fileId?: string;
    initialDepositAmount?: number;
    lumpSumAmount?: number;
    administratorTrusteeFeeSubjectToTaxes?: boolean;
    adminConsumerProposalId?: string | undefined;
    monthlyPaymentDetails?: FileAnalysisProposalMonthlyPaymentDetailDto[] | undefined;
}

export class FileAnalysisProposalMonthlyPaymentDetailDto implements IFileAnalysisProposalMonthlyPaymentDetailDto {
    id?: string;
    monthlyPaymentMonths?: number | undefined;
    monthlyPaymentAmount?: number | undefined;
    readonly monthlyPaymentsTotal?: number | undefined;

    constructor(data?: IFileAnalysisProposalMonthlyPaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.monthlyPaymentMonths = _data["monthlyPaymentMonths"];
            this.monthlyPaymentAmount = _data["monthlyPaymentAmount"];
            (<any>this).monthlyPaymentsTotal = _data["monthlyPaymentsTotal"];
        }
    }

    static fromJS(data: any): FileAnalysisProposalMonthlyPaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisProposalMonthlyPaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monthlyPaymentMonths"] = this.monthlyPaymentMonths;
        data["monthlyPaymentAmount"] = this.monthlyPaymentAmount;
        data["monthlyPaymentsTotal"] = this.monthlyPaymentsTotal;
        return data;
    }
}

export interface IFileAnalysisProposalMonthlyPaymentDetailDto {
    id?: string;
    monthlyPaymentMonths?: number | undefined;
    monthlyPaymentAmount?: number | undefined;
    monthlyPaymentsTotal?: number | undefined;
}

export class FileAnalysisProvincialExemptionsTaxRateConfigurationDto implements IFileAnalysisProvincialExemptionsTaxRateConfigurationDto {
    id?: string;
    orderNumber?: number;
    provinceId?: string;
    provinceCode?: string | undefined;
    provinceName?: string | undefined;
    vehicleAmount?: string | undefined;
    residenceAmount?: string | undefined;
    fileAnalysisResidenceAppliesName?: string | undefined;
    fileAnalysisResidenceAvailabilityName?: string | undefined;
    householdAmount?: string | undefined;
    huntingFishingFarmingAmount?: string | undefined;
    toolsAmount?: string | undefined;
    fileAnalysisRESPName?: string | undefined;
    fileAnalysisRRSPName?: string | undefined;
    taxRate?: number;
    fileAnalysisTaxTypeName?: string | undefined;

    constructor(data?: IFileAnalysisProvincialExemptionsTaxRateConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.provinceId = _data["provinceId"];
            this.provinceCode = _data["provinceCode"];
            this.provinceName = _data["provinceName"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.residenceAmount = _data["residenceAmount"];
            this.fileAnalysisResidenceAppliesName = _data["fileAnalysisResidenceAppliesName"];
            this.fileAnalysisResidenceAvailabilityName = _data["fileAnalysisResidenceAvailabilityName"];
            this.householdAmount = _data["householdAmount"];
            this.huntingFishingFarmingAmount = _data["huntingFishingFarmingAmount"];
            this.toolsAmount = _data["toolsAmount"];
            this.fileAnalysisRESPName = _data["fileAnalysisRESPName"];
            this.fileAnalysisRRSPName = _data["fileAnalysisRRSPName"];
            this.taxRate = _data["taxRate"];
            this.fileAnalysisTaxTypeName = _data["fileAnalysisTaxTypeName"];
        }
    }

    static fromJS(data: any): FileAnalysisProvincialExemptionsTaxRateConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisProvincialExemptionsTaxRateConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["provinceId"] = this.provinceId;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["vehicleAmount"] = this.vehicleAmount;
        data["residenceAmount"] = this.residenceAmount;
        data["fileAnalysisResidenceAppliesName"] = this.fileAnalysisResidenceAppliesName;
        data["fileAnalysisResidenceAvailabilityName"] = this.fileAnalysisResidenceAvailabilityName;
        data["householdAmount"] = this.householdAmount;
        data["huntingFishingFarmingAmount"] = this.huntingFishingFarmingAmount;
        data["toolsAmount"] = this.toolsAmount;
        data["fileAnalysisRESPName"] = this.fileAnalysisRESPName;
        data["fileAnalysisRRSPName"] = this.fileAnalysisRRSPName;
        data["taxRate"] = this.taxRate;
        data["fileAnalysisTaxTypeName"] = this.fileAnalysisTaxTypeName;
        return data;
    }
}

export interface IFileAnalysisProvincialExemptionsTaxRateConfigurationDto {
    id?: string;
    orderNumber?: number;
    provinceId?: string;
    provinceCode?: string | undefined;
    provinceName?: string | undefined;
    vehicleAmount?: string | undefined;
    residenceAmount?: string | undefined;
    fileAnalysisResidenceAppliesName?: string | undefined;
    fileAnalysisResidenceAvailabilityName?: string | undefined;
    householdAmount?: string | undefined;
    huntingFishingFarmingAmount?: string | undefined;
    toolsAmount?: string | undefined;
    fileAnalysisRESPName?: string | undefined;
    fileAnalysisRRSPName?: string | undefined;
    taxRate?: number;
    fileAnalysisTaxTypeName?: string | undefined;
}

export class FileAnalysisProvincialExemptionsTaxRateConfigurationInputDto implements IFileAnalysisProvincialExemptionsTaxRateConfigurationInputDto {
    id?: string;
    isAllOtherBC?: boolean;
    vehicleAmount?: number | undefined;
    isUnlimitedVehicleAmount?: boolean;
    residenceAmount?: number | undefined;
    isUnlimitedResidenceAmount?: boolean;
    fileAnalysisResidenceAppliesId?: string | undefined;
    fileAnalysisResidenceAvailabilityId?: string | undefined;
    householdAmount?: number | undefined;
    isUnlimitedHouseholdAmount?: boolean;
    huntingFishingFarmingAmount?: number | undefined;
    isUnlimitedHuntingFishingFarmingAmount?: boolean;
    toolsAmount?: number | undefined;
    isUnlimitedToolsAmount?: boolean;
    fileAnalysisRESPId?: string | undefined;
    fileAnalysisRRSPId?: string | undefined;
    taxRate?: number;
    fileAnalysisTaxTypeId?: string | undefined;

    constructor(data?: IFileAnalysisProvincialExemptionsTaxRateConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAllOtherBC = _data["isAllOtherBC"];
            this.vehicleAmount = _data["vehicleAmount"];
            this.isUnlimitedVehicleAmount = _data["isUnlimitedVehicleAmount"];
            this.residenceAmount = _data["residenceAmount"];
            this.isUnlimitedResidenceAmount = _data["isUnlimitedResidenceAmount"];
            this.fileAnalysisResidenceAppliesId = _data["fileAnalysisResidenceAppliesId"];
            this.fileAnalysisResidenceAvailabilityId = _data["fileAnalysisResidenceAvailabilityId"];
            this.householdAmount = _data["householdAmount"];
            this.isUnlimitedHouseholdAmount = _data["isUnlimitedHouseholdAmount"];
            this.huntingFishingFarmingAmount = _data["huntingFishingFarmingAmount"];
            this.isUnlimitedHuntingFishingFarmingAmount = _data["isUnlimitedHuntingFishingFarmingAmount"];
            this.toolsAmount = _data["toolsAmount"];
            this.isUnlimitedToolsAmount = _data["isUnlimitedToolsAmount"];
            this.fileAnalysisRESPId = _data["fileAnalysisRESPId"];
            this.fileAnalysisRRSPId = _data["fileAnalysisRRSPId"];
            this.taxRate = _data["taxRate"];
            this.fileAnalysisTaxTypeId = _data["fileAnalysisTaxTypeId"];
        }
    }

    static fromJS(data: any): FileAnalysisProvincialExemptionsTaxRateConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisProvincialExemptionsTaxRateConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAllOtherBC"] = this.isAllOtherBC;
        data["vehicleAmount"] = this.vehicleAmount;
        data["isUnlimitedVehicleAmount"] = this.isUnlimitedVehicleAmount;
        data["residenceAmount"] = this.residenceAmount;
        data["isUnlimitedResidenceAmount"] = this.isUnlimitedResidenceAmount;
        data["fileAnalysisResidenceAppliesId"] = this.fileAnalysisResidenceAppliesId;
        data["fileAnalysisResidenceAvailabilityId"] = this.fileAnalysisResidenceAvailabilityId;
        data["householdAmount"] = this.householdAmount;
        data["isUnlimitedHouseholdAmount"] = this.isUnlimitedHouseholdAmount;
        data["huntingFishingFarmingAmount"] = this.huntingFishingFarmingAmount;
        data["isUnlimitedHuntingFishingFarmingAmount"] = this.isUnlimitedHuntingFishingFarmingAmount;
        data["toolsAmount"] = this.toolsAmount;
        data["isUnlimitedToolsAmount"] = this.isUnlimitedToolsAmount;
        data["fileAnalysisRESPId"] = this.fileAnalysisRESPId;
        data["fileAnalysisRRSPId"] = this.fileAnalysisRRSPId;
        data["taxRate"] = this.taxRate;
        data["fileAnalysisTaxTypeId"] = this.fileAnalysisTaxTypeId;
        return data;
    }
}

export interface IFileAnalysisProvincialExemptionsTaxRateConfigurationInputDto {
    id?: string;
    isAllOtherBC?: boolean;
    vehicleAmount?: number | undefined;
    isUnlimitedVehicleAmount?: boolean;
    residenceAmount?: number | undefined;
    isUnlimitedResidenceAmount?: boolean;
    fileAnalysisResidenceAppliesId?: string | undefined;
    fileAnalysisResidenceAvailabilityId?: string | undefined;
    householdAmount?: number | undefined;
    isUnlimitedHouseholdAmount?: boolean;
    huntingFishingFarmingAmount?: number | undefined;
    isUnlimitedHuntingFishingFarmingAmount?: boolean;
    toolsAmount?: number | undefined;
    isUnlimitedToolsAmount?: boolean;
    fileAnalysisRESPId?: string | undefined;
    fileAnalysisRRSPId?: string | undefined;
    taxRate?: number;
    fileAnalysisTaxTypeId?: string | undefined;
}

export class FileAnalysisRDSPAssetDetailsDto implements IFileAnalysisRDSPAssetDetailsDto {
    rdspExemptOrNone?: string | undefined;
    rdspName?: string | undefined;
    currentMarketValue?: number;
    contributionLast12Months?: number;
    withholdingTaxRate?: number;
    withholdingTax?: number;
    netRealizableValue?: number;

    constructor(data?: IFileAnalysisRDSPAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdspExemptOrNone = _data["rdspExemptOrNone"];
            this.rdspName = _data["rdspName"];
            this.currentMarketValue = _data["currentMarketValue"];
            this.contributionLast12Months = _data["contributionLast12Months"];
            this.withholdingTaxRate = _data["withholdingTaxRate"];
            this.withholdingTax = _data["withholdingTax"];
            this.netRealizableValue = _data["netRealizableValue"];
        }
    }

    static fromJS(data: any): FileAnalysisRDSPAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRDSPAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdspExemptOrNone"] = this.rdspExemptOrNone;
        data["rdspName"] = this.rdspName;
        data["currentMarketValue"] = this.currentMarketValue;
        data["contributionLast12Months"] = this.contributionLast12Months;
        data["withholdingTaxRate"] = this.withholdingTaxRate;
        data["withholdingTax"] = this.withholdingTax;
        data["netRealizableValue"] = this.netRealizableValue;
        return data;
    }
}

export interface IFileAnalysisRDSPAssetDetailsDto {
    rdspExemptOrNone?: string | undefined;
    rdspName?: string | undefined;
    currentMarketValue?: number;
    contributionLast12Months?: number;
    withholdingTaxRate?: number;
    withholdingTax?: number;
    netRealizableValue?: number;
}

export class FileAnalysisRESPAssetDetailsDto implements IFileAnalysisRESPAssetDetailsDto {
    respExemptOrNone?: string | undefined;
    respName?: string | undefined;
    currentMarketValue?: number;
    grantToBeRepaid?: number;
    valueAfterGrants?: number;
    costToCollapseRESP?: number;
    estimatedEquity?: number;
    debtorsInterest?: number;

    constructor(data?: IFileAnalysisRESPAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respExemptOrNone = _data["respExemptOrNone"];
            this.respName = _data["respName"];
            this.currentMarketValue = _data["currentMarketValue"];
            this.grantToBeRepaid = _data["grantToBeRepaid"];
            this.valueAfterGrants = _data["valueAfterGrants"];
            this.costToCollapseRESP = _data["costToCollapseRESP"];
            this.estimatedEquity = _data["estimatedEquity"];
            this.debtorsInterest = _data["debtorsInterest"];
        }
    }

    static fromJS(data: any): FileAnalysisRESPAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRESPAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respExemptOrNone"] = this.respExemptOrNone;
        data["respName"] = this.respName;
        data["currentMarketValue"] = this.currentMarketValue;
        data["grantToBeRepaid"] = this.grantToBeRepaid;
        data["valueAfterGrants"] = this.valueAfterGrants;
        data["costToCollapseRESP"] = this.costToCollapseRESP;
        data["estimatedEquity"] = this.estimatedEquity;
        data["debtorsInterest"] = this.debtorsInterest;
        return data;
    }
}

export interface IFileAnalysisRESPAssetDetailsDto {
    respExemptOrNone?: string | undefined;
    respName?: string | undefined;
    currentMarketValue?: number;
    grantToBeRepaid?: number;
    valueAfterGrants?: number;
    costToCollapseRESP?: number;
    estimatedEquity?: number;
    debtorsInterest?: number;
}

export class FileAnalysisRRSPAssetDetailsDto implements IFileAnalysisRRSPAssetDetailsDto {
    rrspExemptOrNone?: string | undefined;
    rrspName?: string | undefined;
    currentMarketValue?: number;
    contributionLast12Months?: number;
    withholdingTaxRate?: number;
    withholdingTax?: number;
    netRealizableValue?: number;

    constructor(data?: IFileAnalysisRRSPAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rrspExemptOrNone = _data["rrspExemptOrNone"];
            this.rrspName = _data["rrspName"];
            this.currentMarketValue = _data["currentMarketValue"];
            this.contributionLast12Months = _data["contributionLast12Months"];
            this.withholdingTaxRate = _data["withholdingTaxRate"];
            this.withholdingTax = _data["withholdingTax"];
            this.netRealizableValue = _data["netRealizableValue"];
        }
    }

    static fromJS(data: any): FileAnalysisRRSPAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRRSPAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rrspExemptOrNone"] = this.rrspExemptOrNone;
        data["rrspName"] = this.rrspName;
        data["currentMarketValue"] = this.currentMarketValue;
        data["contributionLast12Months"] = this.contributionLast12Months;
        data["withholdingTaxRate"] = this.withholdingTaxRate;
        data["withholdingTax"] = this.withholdingTax;
        data["netRealizableValue"] = this.netRealizableValue;
        return data;
    }
}

export interface IFileAnalysisRRSPAssetDetailsDto {
    rrspExemptOrNone?: string | undefined;
    rrspName?: string | undefined;
    currentMarketValue?: number;
    contributionLast12Months?: number;
    withholdingTaxRate?: number;
    withholdingTax?: number;
    netRealizableValue?: number;
}

export class FileAnalysisRealEstateAssetDetailsDto implements IFileAnalysisRealEstateAssetDetailsDto {
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    isPrincipalResidence?: boolean;
    estimatedMarketValue?: number;
    estimatedRealEstateCommission?: number;
    estimatedLegalCosts?: number;
    estimatedAvailableBeforeSecuredClaims?: number;
    mortgageValues?: EstimatedSecuredClaimsMortgage[] | undefined;
    propertyTaxesArrearsValues?: EstimatedSecuredClaimsPropertyTaxesArrears[] | undefined;
    totalEstimatedSecuredClaims?: number;
    estimatedEquity?: number;
    provincialExemptionHousehold?: number;
    estimatedEquityAboveAllowedExemptionClaims?: number;
    debtorsOwnershipInterest?: number;
    debtorsEstimatedEquityBeforeExemption?: number;
    provincialExemptionIndividual?: number;
    debtorsEstimatedEquity?: number;

    constructor(data?: IFileAnalysisRealEstateAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.isPrincipalResidence = _data["isPrincipalResidence"];
            this.estimatedMarketValue = _data["estimatedMarketValue"];
            this.estimatedRealEstateCommission = _data["estimatedRealEstateCommission"];
            this.estimatedLegalCosts = _data["estimatedLegalCosts"];
            this.estimatedAvailableBeforeSecuredClaims = _data["estimatedAvailableBeforeSecuredClaims"];
            if (Array.isArray(_data["mortgageValues"])) {
                this.mortgageValues = [] as any;
                for (let item of _data["mortgageValues"])
                    this.mortgageValues!.push(EstimatedSecuredClaimsMortgage.fromJS(item));
            }
            if (Array.isArray(_data["propertyTaxesArrearsValues"])) {
                this.propertyTaxesArrearsValues = [] as any;
                for (let item of _data["propertyTaxesArrearsValues"])
                    this.propertyTaxesArrearsValues!.push(EstimatedSecuredClaimsPropertyTaxesArrears.fromJS(item));
            }
            this.totalEstimatedSecuredClaims = _data["totalEstimatedSecuredClaims"];
            this.estimatedEquity = _data["estimatedEquity"];
            this.provincialExemptionHousehold = _data["provincialExemptionHousehold"];
            this.estimatedEquityAboveAllowedExemptionClaims = _data["estimatedEquityAboveAllowedExemptionClaims"];
            this.debtorsOwnershipInterest = _data["debtorsOwnershipInterest"];
            this.debtorsEstimatedEquityBeforeExemption = _data["debtorsEstimatedEquityBeforeExemption"];
            this.provincialExemptionIndividual = _data["provincialExemptionIndividual"];
            this.debtorsEstimatedEquity = _data["debtorsEstimatedEquity"];
        }
    }

    static fromJS(data: any): FileAnalysisRealEstateAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRealEstateAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["isPrincipalResidence"] = this.isPrincipalResidence;
        data["estimatedMarketValue"] = this.estimatedMarketValue;
        data["estimatedRealEstateCommission"] = this.estimatedRealEstateCommission;
        data["estimatedLegalCosts"] = this.estimatedLegalCosts;
        data["estimatedAvailableBeforeSecuredClaims"] = this.estimatedAvailableBeforeSecuredClaims;
        if (Array.isArray(this.mortgageValues)) {
            data["mortgageValues"] = [];
            for (let item of this.mortgageValues)
                data["mortgageValues"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyTaxesArrearsValues)) {
            data["propertyTaxesArrearsValues"] = [];
            for (let item of this.propertyTaxesArrearsValues)
                data["propertyTaxesArrearsValues"].push(item.toJSON());
        }
        data["totalEstimatedSecuredClaims"] = this.totalEstimatedSecuredClaims;
        data["estimatedEquity"] = this.estimatedEquity;
        data["provincialExemptionHousehold"] = this.provincialExemptionHousehold;
        data["estimatedEquityAboveAllowedExemptionClaims"] = this.estimatedEquityAboveAllowedExemptionClaims;
        data["debtorsOwnershipInterest"] = this.debtorsOwnershipInterest;
        data["debtorsEstimatedEquityBeforeExemption"] = this.debtorsEstimatedEquityBeforeExemption;
        data["provincialExemptionIndividual"] = this.provincialExemptionIndividual;
        data["debtorsEstimatedEquity"] = this.debtorsEstimatedEquity;
        return data;
    }
}

export interface IFileAnalysisRealEstateAssetDetailsDto {
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    isPrincipalResidence?: boolean;
    estimatedMarketValue?: number;
    estimatedRealEstateCommission?: number;
    estimatedLegalCosts?: number;
    estimatedAvailableBeforeSecuredClaims?: number;
    mortgageValues?: EstimatedSecuredClaimsMortgage[] | undefined;
    propertyTaxesArrearsValues?: EstimatedSecuredClaimsPropertyTaxesArrears[] | undefined;
    totalEstimatedSecuredClaims?: number;
    estimatedEquity?: number;
    provincialExemptionHousehold?: number;
    estimatedEquityAboveAllowedExemptionClaims?: number;
    debtorsOwnershipInterest?: number;
    debtorsEstimatedEquityBeforeExemption?: number;
    provincialExemptionIndividual?: number;
    debtorsEstimatedEquity?: number;
}

export class FileAnalysisRealEstateFeeConfigurationDto implements IFileAnalysisRealEstateFeeConfigurationDto {
    id?: string;
    provinceId?: string;
    provinceCode?: string | undefined;
    provinceName?: string | undefined;
    orderNumber?: number;
    commissionPercentage?: number;
    over100kCommissionPercentage?: number | undefined;
    legalFee?: number;

    constructor(data?: IFileAnalysisRealEstateFeeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provinceId = _data["provinceId"];
            this.provinceCode = _data["provinceCode"];
            this.provinceName = _data["provinceName"];
            this.orderNumber = _data["orderNumber"];
            this.commissionPercentage = _data["commissionPercentage"];
            this.over100kCommissionPercentage = _data["over100kCommissionPercentage"];
            this.legalFee = _data["legalFee"];
        }
    }

    static fromJS(data: any): FileAnalysisRealEstateFeeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRealEstateFeeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provinceId"] = this.provinceId;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["orderNumber"] = this.orderNumber;
        data["commissionPercentage"] = this.commissionPercentage;
        data["over100kCommissionPercentage"] = this.over100kCommissionPercentage;
        data["legalFee"] = this.legalFee;
        return data;
    }
}

export interface IFileAnalysisRealEstateFeeConfigurationDto {
    id?: string;
    provinceId?: string;
    provinceCode?: string | undefined;
    provinceName?: string | undefined;
    orderNumber?: number;
    commissionPercentage?: number;
    over100kCommissionPercentage?: number | undefined;
    legalFee?: number;
}

export class FileAnalysisRealEstateFeeConfigurationInputDto implements IFileAnalysisRealEstateFeeConfigurationInputDto {
    id?: string;
    commissionPercentage?: number;
    over100kCommissionPercentage?: number | undefined;
    legalFee?: number;

    constructor(data?: IFileAnalysisRealEstateFeeConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commissionPercentage = _data["commissionPercentage"];
            this.over100kCommissionPercentage = _data["over100kCommissionPercentage"];
            this.legalFee = _data["legalFee"];
        }
    }

    static fromJS(data: any): FileAnalysisRealEstateFeeConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRealEstateFeeConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commissionPercentage"] = this.commissionPercentage;
        data["over100kCommissionPercentage"] = this.over100kCommissionPercentage;
        data["legalFee"] = this.legalFee;
        return data;
    }
}

export interface IFileAnalysisRealEstateFeeConfigurationInputDto {
    id?: string;
    commissionPercentage?: number;
    over100kCommissionPercentage?: number | undefined;
    legalFee?: number;
}

export class FileAnalysisRecreationalEquipmentAssetDetailsDto implements IFileAnalysisRecreationalEquipmentAssetDetailsDto {
    description?: string | undefined;
    marketValue?: number;
    outstandingLoanLease?: number;
    estimatedEquity?: number;
    basisOfValue?: string | undefined;

    constructor(data?: IFileAnalysisRecreationalEquipmentAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.marketValue = _data["marketValue"];
            this.outstandingLoanLease = _data["outstandingLoanLease"];
            this.estimatedEquity = _data["estimatedEquity"];
            this.basisOfValue = _data["basisOfValue"];
        }
    }

    static fromJS(data: any): FileAnalysisRecreationalEquipmentAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisRecreationalEquipmentAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["marketValue"] = this.marketValue;
        data["outstandingLoanLease"] = this.outstandingLoanLease;
        data["estimatedEquity"] = this.estimatedEquity;
        data["basisOfValue"] = this.basisOfValue;
        return data;
    }
}

export interface IFileAnalysisRecreationalEquipmentAssetDetailsDto {
    description?: string | undefined;
    marketValue?: number;
    outstandingLoanLease?: number;
    estimatedEquity?: number;
    basisOfValue?: string | undefined;
}

export class FileAnalysisResultsCalculationsDto implements IFileAnalysisResultsCalculationsDto {
    cashOnHandBalance?: number;
    csvLifePoliciesEnum?: ResultCalculationsFieldValueEnum;
    csvLifePolicies?: string | undefined;
    csvLifePoliciesSum?: number;
    pensionsEnum?: ResultCalculationsFieldValueEnum;
    pensions?: string | undefined;
    pensionsSum?: number;
    respEnum?: ResultCalculationsFieldValueEnum;
    resPs?: string | undefined;
    respSum?: number;
    resPsDetails?: FileAnalysisRESPAssetDetailsDto[] | undefined;
    respSumTotal?: number;
    rrspEnum?: ResultCalculationsFieldValueEnum;
    rrsPs?: string | undefined;
    rrspSum?: number;
    rrspDetails?: FileAnalysisRRSPAssetDetailsDto[] | undefined;
    rrspNetRealizableValueTotal?: number;
    rdspEnum?: ResultCalculationsFieldValueEnum;
    rdsPs?: string | undefined;
    rdspSum?: number;
    rdspDetails?: FileAnalysisRDSPAssetDetailsDto[] | undefined;
    rdspNetRealizableValueTotal?: number;
    policiesPensionsRRSPEnum?: ResultCalculationsFieldValueEnum;
    policiesPensionsRRSP?: string | undefined;
    policiesPensionsRRSPTotal?: number;
    investmentDetails?: FileAnalysisInvestmentAssetDetails[] | undefined;
    investmentsTotal?: number;
    realEstateDetails?: FileAnalysisRealEstateAssetDetailsDto[] | undefined;
    motorVehicleDetails?: FileAnalysisMotorVehiclesAssetDetailsDto[] | undefined;
    motorVehiclesTotal?: number;
    recreationalEquipmentDetails?: FileAnalysisRecreationalEquipmentAssetDetailsDto[] | undefined;
    recreationalEquipmentTotal?: number;
    toolsOfTradeDetails?: FileAnalysisToolsOfTradeAssetDetailsDto;
    huntingFishingFarmingDetails?: FileAnalysisHuntingFishingFarmingAssetDetailsDto;
    taxRefundsAssetValue?: number;
    otherTotalRealization?: number;

    constructor(data?: IFileAnalysisResultsCalculationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashOnHandBalance = _data["cashOnHandBalance"];
            this.csvLifePoliciesEnum = _data["csvLifePoliciesEnum"];
            this.csvLifePolicies = _data["csvLifePolicies"];
            this.csvLifePoliciesSum = _data["csvLifePoliciesSum"];
            this.pensionsEnum = _data["pensionsEnum"];
            this.pensions = _data["pensions"];
            this.pensionsSum = _data["pensionsSum"];
            this.respEnum = _data["respEnum"];
            this.resPs = _data["resPs"];
            this.respSum = _data["respSum"];
            if (Array.isArray(_data["resPsDetails"])) {
                this.resPsDetails = [] as any;
                for (let item of _data["resPsDetails"])
                    this.resPsDetails!.push(FileAnalysisRESPAssetDetailsDto.fromJS(item));
            }
            this.respSumTotal = _data["respSumTotal"];
            this.rrspEnum = _data["rrspEnum"];
            this.rrsPs = _data["rrsPs"];
            this.rrspSum = _data["rrspSum"];
            if (Array.isArray(_data["rrspDetails"])) {
                this.rrspDetails = [] as any;
                for (let item of _data["rrspDetails"])
                    this.rrspDetails!.push(FileAnalysisRRSPAssetDetailsDto.fromJS(item));
            }
            this.rrspNetRealizableValueTotal = _data["rrspNetRealizableValueTotal"];
            this.rdspEnum = _data["rdspEnum"];
            this.rdsPs = _data["rdsPs"];
            this.rdspSum = _data["rdspSum"];
            if (Array.isArray(_data["rdspDetails"])) {
                this.rdspDetails = [] as any;
                for (let item of _data["rdspDetails"])
                    this.rdspDetails!.push(FileAnalysisRDSPAssetDetailsDto.fromJS(item));
            }
            this.rdspNetRealizableValueTotal = _data["rdspNetRealizableValueTotal"];
            this.policiesPensionsRRSPEnum = _data["policiesPensionsRRSPEnum"];
            this.policiesPensionsRRSP = _data["policiesPensionsRRSP"];
            this.policiesPensionsRRSPTotal = _data["policiesPensionsRRSPTotal"];
            if (Array.isArray(_data["investmentDetails"])) {
                this.investmentDetails = [] as any;
                for (let item of _data["investmentDetails"])
                    this.investmentDetails!.push(FileAnalysisInvestmentAssetDetails.fromJS(item));
            }
            this.investmentsTotal = _data["investmentsTotal"];
            if (Array.isArray(_data["realEstateDetails"])) {
                this.realEstateDetails = [] as any;
                for (let item of _data["realEstateDetails"])
                    this.realEstateDetails!.push(FileAnalysisRealEstateAssetDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["motorVehicleDetails"])) {
                this.motorVehicleDetails = [] as any;
                for (let item of _data["motorVehicleDetails"])
                    this.motorVehicleDetails!.push(FileAnalysisMotorVehiclesAssetDetailsDto.fromJS(item));
            }
            this.motorVehiclesTotal = _data["motorVehiclesTotal"];
            if (Array.isArray(_data["recreationalEquipmentDetails"])) {
                this.recreationalEquipmentDetails = [] as any;
                for (let item of _data["recreationalEquipmentDetails"])
                    this.recreationalEquipmentDetails!.push(FileAnalysisRecreationalEquipmentAssetDetailsDto.fromJS(item));
            }
            this.recreationalEquipmentTotal = _data["recreationalEquipmentTotal"];
            this.toolsOfTradeDetails = _data["toolsOfTradeDetails"] ? FileAnalysisToolsOfTradeAssetDetailsDto.fromJS(_data["toolsOfTradeDetails"]) : <any>undefined;
            this.huntingFishingFarmingDetails = _data["huntingFishingFarmingDetails"] ? FileAnalysisHuntingFishingFarmingAssetDetailsDto.fromJS(_data["huntingFishingFarmingDetails"]) : <any>undefined;
            this.taxRefundsAssetValue = _data["taxRefundsAssetValue"];
            this.otherTotalRealization = _data["otherTotalRealization"];
        }
    }

    static fromJS(data: any): FileAnalysisResultsCalculationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisResultsCalculationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashOnHandBalance"] = this.cashOnHandBalance;
        data["csvLifePoliciesEnum"] = this.csvLifePoliciesEnum;
        data["csvLifePolicies"] = this.csvLifePolicies;
        data["csvLifePoliciesSum"] = this.csvLifePoliciesSum;
        data["pensionsEnum"] = this.pensionsEnum;
        data["pensions"] = this.pensions;
        data["pensionsSum"] = this.pensionsSum;
        data["respEnum"] = this.respEnum;
        data["resPs"] = this.resPs;
        data["respSum"] = this.respSum;
        if (Array.isArray(this.resPsDetails)) {
            data["resPsDetails"] = [];
            for (let item of this.resPsDetails)
                data["resPsDetails"].push(item.toJSON());
        }
        data["respSumTotal"] = this.respSumTotal;
        data["rrspEnum"] = this.rrspEnum;
        data["rrsPs"] = this.rrsPs;
        data["rrspSum"] = this.rrspSum;
        if (Array.isArray(this.rrspDetails)) {
            data["rrspDetails"] = [];
            for (let item of this.rrspDetails)
                data["rrspDetails"].push(item.toJSON());
        }
        data["rrspNetRealizableValueTotal"] = this.rrspNetRealizableValueTotal;
        data["rdspEnum"] = this.rdspEnum;
        data["rdsPs"] = this.rdsPs;
        data["rdspSum"] = this.rdspSum;
        if (Array.isArray(this.rdspDetails)) {
            data["rdspDetails"] = [];
            for (let item of this.rdspDetails)
                data["rdspDetails"].push(item.toJSON());
        }
        data["rdspNetRealizableValueTotal"] = this.rdspNetRealizableValueTotal;
        data["policiesPensionsRRSPEnum"] = this.policiesPensionsRRSPEnum;
        data["policiesPensionsRRSP"] = this.policiesPensionsRRSP;
        data["policiesPensionsRRSPTotal"] = this.policiesPensionsRRSPTotal;
        if (Array.isArray(this.investmentDetails)) {
            data["investmentDetails"] = [];
            for (let item of this.investmentDetails)
                data["investmentDetails"].push(item.toJSON());
        }
        data["investmentsTotal"] = this.investmentsTotal;
        if (Array.isArray(this.realEstateDetails)) {
            data["realEstateDetails"] = [];
            for (let item of this.realEstateDetails)
                data["realEstateDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.motorVehicleDetails)) {
            data["motorVehicleDetails"] = [];
            for (let item of this.motorVehicleDetails)
                data["motorVehicleDetails"].push(item.toJSON());
        }
        data["motorVehiclesTotal"] = this.motorVehiclesTotal;
        if (Array.isArray(this.recreationalEquipmentDetails)) {
            data["recreationalEquipmentDetails"] = [];
            for (let item of this.recreationalEquipmentDetails)
                data["recreationalEquipmentDetails"].push(item.toJSON());
        }
        data["recreationalEquipmentTotal"] = this.recreationalEquipmentTotal;
        data["toolsOfTradeDetails"] = this.toolsOfTradeDetails ? this.toolsOfTradeDetails.toJSON() : <any>undefined;
        data["huntingFishingFarmingDetails"] = this.huntingFishingFarmingDetails ? this.huntingFishingFarmingDetails.toJSON() : <any>undefined;
        data["taxRefundsAssetValue"] = this.taxRefundsAssetValue;
        data["otherTotalRealization"] = this.otherTotalRealization;
        return data;
    }
}

export interface IFileAnalysisResultsCalculationsDto {
    cashOnHandBalance?: number;
    csvLifePoliciesEnum?: ResultCalculationsFieldValueEnum;
    csvLifePolicies?: string | undefined;
    csvLifePoliciesSum?: number;
    pensionsEnum?: ResultCalculationsFieldValueEnum;
    pensions?: string | undefined;
    pensionsSum?: number;
    respEnum?: ResultCalculationsFieldValueEnum;
    resPs?: string | undefined;
    respSum?: number;
    resPsDetails?: FileAnalysisRESPAssetDetailsDto[] | undefined;
    respSumTotal?: number;
    rrspEnum?: ResultCalculationsFieldValueEnum;
    rrsPs?: string | undefined;
    rrspSum?: number;
    rrspDetails?: FileAnalysisRRSPAssetDetailsDto[] | undefined;
    rrspNetRealizableValueTotal?: number;
    rdspEnum?: ResultCalculationsFieldValueEnum;
    rdsPs?: string | undefined;
    rdspSum?: number;
    rdspDetails?: FileAnalysisRDSPAssetDetailsDto[] | undefined;
    rdspNetRealizableValueTotal?: number;
    policiesPensionsRRSPEnum?: ResultCalculationsFieldValueEnum;
    policiesPensionsRRSP?: string | undefined;
    policiesPensionsRRSPTotal?: number;
    investmentDetails?: FileAnalysisInvestmentAssetDetails[] | undefined;
    investmentsTotal?: number;
    realEstateDetails?: FileAnalysisRealEstateAssetDetailsDto[] | undefined;
    motorVehicleDetails?: FileAnalysisMotorVehiclesAssetDetailsDto[] | undefined;
    motorVehiclesTotal?: number;
    recreationalEquipmentDetails?: FileAnalysisRecreationalEquipmentAssetDetailsDto[] | undefined;
    recreationalEquipmentTotal?: number;
    toolsOfTradeDetails?: FileAnalysisToolsOfTradeAssetDetailsDto;
    huntingFishingFarmingDetails?: FileAnalysisHuntingFishingFarmingAssetDetailsDto;
    taxRefundsAssetValue?: number;
    otherTotalRealization?: number;
}

export class FileAnalysisSurplusIncomeCalculationDto implements IFileAnalysisSurplusIncomeCalculationDto {
    monthlyNetIncomeApplicant?: number;
    monthlyNetIncomeSpouse?: number;
    monthlyNetIncomeOther?: number;
    monthlyNonDiscretionaryExpensesApplicant?: number;
    monthlyNonDiscretionaryExpensesSpouse?: number;
    monthlyNonDiscretionaryExpensesOther?: number;
    monthlyNetIncomeUsedInCalcApplicant?: number;
    monthlyNetIncomeUsedInCalcSpouse?: number;
    monthlyNetIncomeUsedInCalcOther?: number;
    readonly monthlyNetIncomeTotal?: number;
    readonly monthlyNonDiscretionaryExpensesTotal?: number;
    monthlyNetIncomeUsedInCalcTotal?: number;
    monthlyNetIncomeUsedInCalcApplicantPercentage?: number;
    monthlyNetIncomeUsedInCalcSpousePercentage?: number;
    monthlyNetIncomeUsedInCalcOtherPercentage?: number;
    monthlyNetIncomeUsedInCalcTotalPercentage?: number;
    numberOfPersonsInHousehold?: number | undefined;
    readonly monthlyNetIncomeUsedInSurplusIncomeCalcTotal?: number;
    allowableMonthlyNetIncome?: number;
    totalMonthlySurplus?: number;
    totalMonthlySurplusApplicant?: number;
    totalMonthlySurplusSpouse?: number;
    readonly totalMonthlySurplusOther?: number;
    readonly totalMonthlySurplusTotal?: number;
    monthlyPaymentRequiredApplicant?: number;
    monthlyPaymentRequiredSpouse?: number;
    monthlyPaymentRequiredSpouseText?: string | undefined;
    readonly monthlyPaymentRequiredOther?: string | undefined;
    monthlyPaymentRequiredTotal?: number;
    noOfMonthlyPaymentsApplicant?: number;
    noOfMonthlyPaymentsSpouse?: number;
    noOfMonthlyPaymentsSpouseText?: string | undefined;
    surplusIncomeContributionApplicant?: number;
    surplusIncomeContributionSpouse?: number;
    surplusIncomeContributionSpouseText?: string | undefined;
    readonly surplusIncomeContributionOther?: string | undefined;
    surplusIncomeContributionTotal?: number;
    spouseRefusedCheckText?: string | undefined;

    constructor(data?: IFileAnalysisSurplusIncomeCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyNetIncomeApplicant = _data["monthlyNetIncomeApplicant"];
            this.monthlyNetIncomeSpouse = _data["monthlyNetIncomeSpouse"];
            this.monthlyNetIncomeOther = _data["monthlyNetIncomeOther"];
            this.monthlyNonDiscretionaryExpensesApplicant = _data["monthlyNonDiscretionaryExpensesApplicant"];
            this.monthlyNonDiscretionaryExpensesSpouse = _data["monthlyNonDiscretionaryExpensesSpouse"];
            this.monthlyNonDiscretionaryExpensesOther = _data["monthlyNonDiscretionaryExpensesOther"];
            this.monthlyNetIncomeUsedInCalcApplicant = _data["monthlyNetIncomeUsedInCalcApplicant"];
            this.monthlyNetIncomeUsedInCalcSpouse = _data["monthlyNetIncomeUsedInCalcSpouse"];
            this.monthlyNetIncomeUsedInCalcOther = _data["monthlyNetIncomeUsedInCalcOther"];
            (<any>this).monthlyNetIncomeTotal = _data["monthlyNetIncomeTotal"];
            (<any>this).monthlyNonDiscretionaryExpensesTotal = _data["monthlyNonDiscretionaryExpensesTotal"];
            this.monthlyNetIncomeUsedInCalcTotal = _data["monthlyNetIncomeUsedInCalcTotal"];
            this.monthlyNetIncomeUsedInCalcApplicantPercentage = _data["monthlyNetIncomeUsedInCalcApplicantPercentage"];
            this.monthlyNetIncomeUsedInCalcSpousePercentage = _data["monthlyNetIncomeUsedInCalcSpousePercentage"];
            this.monthlyNetIncomeUsedInCalcOtherPercentage = _data["monthlyNetIncomeUsedInCalcOtherPercentage"];
            this.monthlyNetIncomeUsedInCalcTotalPercentage = _data["monthlyNetIncomeUsedInCalcTotalPercentage"];
            this.numberOfPersonsInHousehold = _data["numberOfPersonsInHousehold"];
            (<any>this).monthlyNetIncomeUsedInSurplusIncomeCalcTotal = _data["monthlyNetIncomeUsedInSurplusIncomeCalcTotal"];
            this.allowableMonthlyNetIncome = _data["allowableMonthlyNetIncome"];
            this.totalMonthlySurplus = _data["totalMonthlySurplus"];
            this.totalMonthlySurplusApplicant = _data["totalMonthlySurplusApplicant"];
            this.totalMonthlySurplusSpouse = _data["totalMonthlySurplusSpouse"];
            (<any>this).totalMonthlySurplusOther = _data["totalMonthlySurplusOther"];
            (<any>this).totalMonthlySurplusTotal = _data["totalMonthlySurplusTotal"];
            this.monthlyPaymentRequiredApplicant = _data["monthlyPaymentRequiredApplicant"];
            this.monthlyPaymentRequiredSpouse = _data["monthlyPaymentRequiredSpouse"];
            this.monthlyPaymentRequiredSpouseText = _data["monthlyPaymentRequiredSpouseText"];
            (<any>this).monthlyPaymentRequiredOther = _data["monthlyPaymentRequiredOther"];
            this.monthlyPaymentRequiredTotal = _data["monthlyPaymentRequiredTotal"];
            this.noOfMonthlyPaymentsApplicant = _data["noOfMonthlyPaymentsApplicant"];
            this.noOfMonthlyPaymentsSpouse = _data["noOfMonthlyPaymentsSpouse"];
            this.noOfMonthlyPaymentsSpouseText = _data["noOfMonthlyPaymentsSpouseText"];
            this.surplusIncomeContributionApplicant = _data["surplusIncomeContributionApplicant"];
            this.surplusIncomeContributionSpouse = _data["surplusIncomeContributionSpouse"];
            this.surplusIncomeContributionSpouseText = _data["surplusIncomeContributionSpouseText"];
            (<any>this).surplusIncomeContributionOther = _data["surplusIncomeContributionOther"];
            this.surplusIncomeContributionTotal = _data["surplusIncomeContributionTotal"];
            this.spouseRefusedCheckText = _data["spouseRefusedCheckText"];
        }
    }

    static fromJS(data: any): FileAnalysisSurplusIncomeCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisSurplusIncomeCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyNetIncomeApplicant"] = this.monthlyNetIncomeApplicant;
        data["monthlyNetIncomeSpouse"] = this.monthlyNetIncomeSpouse;
        data["monthlyNetIncomeOther"] = this.monthlyNetIncomeOther;
        data["monthlyNonDiscretionaryExpensesApplicant"] = this.monthlyNonDiscretionaryExpensesApplicant;
        data["monthlyNonDiscretionaryExpensesSpouse"] = this.monthlyNonDiscretionaryExpensesSpouse;
        data["monthlyNonDiscretionaryExpensesOther"] = this.monthlyNonDiscretionaryExpensesOther;
        data["monthlyNetIncomeUsedInCalcApplicant"] = this.monthlyNetIncomeUsedInCalcApplicant;
        data["monthlyNetIncomeUsedInCalcSpouse"] = this.monthlyNetIncomeUsedInCalcSpouse;
        data["monthlyNetIncomeUsedInCalcOther"] = this.monthlyNetIncomeUsedInCalcOther;
        data["monthlyNetIncomeTotal"] = this.monthlyNetIncomeTotal;
        data["monthlyNonDiscretionaryExpensesTotal"] = this.monthlyNonDiscretionaryExpensesTotal;
        data["monthlyNetIncomeUsedInCalcTotal"] = this.monthlyNetIncomeUsedInCalcTotal;
        data["monthlyNetIncomeUsedInCalcApplicantPercentage"] = this.monthlyNetIncomeUsedInCalcApplicantPercentage;
        data["monthlyNetIncomeUsedInCalcSpousePercentage"] = this.monthlyNetIncomeUsedInCalcSpousePercentage;
        data["monthlyNetIncomeUsedInCalcOtherPercentage"] = this.monthlyNetIncomeUsedInCalcOtherPercentage;
        data["monthlyNetIncomeUsedInCalcTotalPercentage"] = this.monthlyNetIncomeUsedInCalcTotalPercentage;
        data["numberOfPersonsInHousehold"] = this.numberOfPersonsInHousehold;
        data["monthlyNetIncomeUsedInSurplusIncomeCalcTotal"] = this.monthlyNetIncomeUsedInSurplusIncomeCalcTotal;
        data["allowableMonthlyNetIncome"] = this.allowableMonthlyNetIncome;
        data["totalMonthlySurplus"] = this.totalMonthlySurplus;
        data["totalMonthlySurplusApplicant"] = this.totalMonthlySurplusApplicant;
        data["totalMonthlySurplusSpouse"] = this.totalMonthlySurplusSpouse;
        data["totalMonthlySurplusOther"] = this.totalMonthlySurplusOther;
        data["totalMonthlySurplusTotal"] = this.totalMonthlySurplusTotal;
        data["monthlyPaymentRequiredApplicant"] = this.monthlyPaymentRequiredApplicant;
        data["monthlyPaymentRequiredSpouse"] = this.monthlyPaymentRequiredSpouse;
        data["monthlyPaymentRequiredSpouseText"] = this.monthlyPaymentRequiredSpouseText;
        data["monthlyPaymentRequiredOther"] = this.monthlyPaymentRequiredOther;
        data["monthlyPaymentRequiredTotal"] = this.monthlyPaymentRequiredTotal;
        data["noOfMonthlyPaymentsApplicant"] = this.noOfMonthlyPaymentsApplicant;
        data["noOfMonthlyPaymentsSpouse"] = this.noOfMonthlyPaymentsSpouse;
        data["noOfMonthlyPaymentsSpouseText"] = this.noOfMonthlyPaymentsSpouseText;
        data["surplusIncomeContributionApplicant"] = this.surplusIncomeContributionApplicant;
        data["surplusIncomeContributionSpouse"] = this.surplusIncomeContributionSpouse;
        data["surplusIncomeContributionSpouseText"] = this.surplusIncomeContributionSpouseText;
        data["surplusIncomeContributionOther"] = this.surplusIncomeContributionOther;
        data["surplusIncomeContributionTotal"] = this.surplusIncomeContributionTotal;
        data["spouseRefusedCheckText"] = this.spouseRefusedCheckText;
        return data;
    }
}

export interface IFileAnalysisSurplusIncomeCalculationDto {
    monthlyNetIncomeApplicant?: number;
    monthlyNetIncomeSpouse?: number;
    monthlyNetIncomeOther?: number;
    monthlyNonDiscretionaryExpensesApplicant?: number;
    monthlyNonDiscretionaryExpensesSpouse?: number;
    monthlyNonDiscretionaryExpensesOther?: number;
    monthlyNetIncomeUsedInCalcApplicant?: number;
    monthlyNetIncomeUsedInCalcSpouse?: number;
    monthlyNetIncomeUsedInCalcOther?: number;
    monthlyNetIncomeTotal?: number;
    monthlyNonDiscretionaryExpensesTotal?: number;
    monthlyNetIncomeUsedInCalcTotal?: number;
    monthlyNetIncomeUsedInCalcApplicantPercentage?: number;
    monthlyNetIncomeUsedInCalcSpousePercentage?: number;
    monthlyNetIncomeUsedInCalcOtherPercentage?: number;
    monthlyNetIncomeUsedInCalcTotalPercentage?: number;
    numberOfPersonsInHousehold?: number | undefined;
    monthlyNetIncomeUsedInSurplusIncomeCalcTotal?: number;
    allowableMonthlyNetIncome?: number;
    totalMonthlySurplus?: number;
    totalMonthlySurplusApplicant?: number;
    totalMonthlySurplusSpouse?: number;
    totalMonthlySurplusOther?: number;
    totalMonthlySurplusTotal?: number;
    monthlyPaymentRequiredApplicant?: number;
    monthlyPaymentRequiredSpouse?: number;
    monthlyPaymentRequiredSpouseText?: string | undefined;
    monthlyPaymentRequiredOther?: string | undefined;
    monthlyPaymentRequiredTotal?: number;
    noOfMonthlyPaymentsApplicant?: number;
    noOfMonthlyPaymentsSpouse?: number;
    noOfMonthlyPaymentsSpouseText?: string | undefined;
    surplusIncomeContributionApplicant?: number;
    surplusIncomeContributionSpouse?: number;
    surplusIncomeContributionSpouseText?: string | undefined;
    surplusIncomeContributionOther?: string | undefined;
    surplusIncomeContributionTotal?: number;
    spouseRefusedCheckText?: string | undefined;
}

export class FileAnalysisSurplusIncomeConfigurationDto implements IFileAnalysisSurplusIncomeConfigurationDto {
    id?: string;
    orderNumber?: number;
    noOfPersons?: number;
    standardAmount?: number;

    constructor(data?: IFileAnalysisSurplusIncomeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.noOfPersons = _data["noOfPersons"];
            this.standardAmount = _data["standardAmount"];
        }
    }

    static fromJS(data: any): FileAnalysisSurplusIncomeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisSurplusIncomeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["noOfPersons"] = this.noOfPersons;
        data["standardAmount"] = this.standardAmount;
        return data;
    }
}

export interface IFileAnalysisSurplusIncomeConfigurationDto {
    id?: string;
    orderNumber?: number;
    noOfPersons?: number;
    standardAmount?: number;
}

export class FileAnalysisSurplusIncomeConfigurationInputDto implements IFileAnalysisSurplusIncomeConfigurationInputDto {
    id?: string;
    standardAmount?: number;

    constructor(data?: IFileAnalysisSurplusIncomeConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.standardAmount = _data["standardAmount"];
        }
    }

    static fromJS(data: any): FileAnalysisSurplusIncomeConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisSurplusIncomeConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["standardAmount"] = this.standardAmount;
        return data;
    }
}

export interface IFileAnalysisSurplusIncomeConfigurationInputDto {
    id?: string;
    standardAmount?: number;
}

export class FileAnalysisSurplusIncomeDto implements IFileAnalysisSurplusIncomeDto {
    monthlyNetIncomeApplicant?: number;
    monthlyNetIncomeSpouse?: number;
    monthlyNetIncomeOther?: number;
    monthlyNonDiscretionaryExpensesApplicant?: number;
    monthlyNonDiscretionaryExpensesSpouse?: number;
    monthlyNonDiscretionaryExpensesOther?: number;
    isSpouseRefusedToProvideIncomeData?: boolean;

    constructor(data?: IFileAnalysisSurplusIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyNetIncomeApplicant = _data["monthlyNetIncomeApplicant"];
            this.monthlyNetIncomeSpouse = _data["monthlyNetIncomeSpouse"];
            this.monthlyNetIncomeOther = _data["monthlyNetIncomeOther"];
            this.monthlyNonDiscretionaryExpensesApplicant = _data["monthlyNonDiscretionaryExpensesApplicant"];
            this.monthlyNonDiscretionaryExpensesSpouse = _data["monthlyNonDiscretionaryExpensesSpouse"];
            this.monthlyNonDiscretionaryExpensesOther = _data["monthlyNonDiscretionaryExpensesOther"];
            this.isSpouseRefusedToProvideIncomeData = _data["isSpouseRefusedToProvideIncomeData"];
        }
    }

    static fromJS(data: any): FileAnalysisSurplusIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisSurplusIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyNetIncomeApplicant"] = this.monthlyNetIncomeApplicant;
        data["monthlyNetIncomeSpouse"] = this.monthlyNetIncomeSpouse;
        data["monthlyNetIncomeOther"] = this.monthlyNetIncomeOther;
        data["monthlyNonDiscretionaryExpensesApplicant"] = this.monthlyNonDiscretionaryExpensesApplicant;
        data["monthlyNonDiscretionaryExpensesSpouse"] = this.monthlyNonDiscretionaryExpensesSpouse;
        data["monthlyNonDiscretionaryExpensesOther"] = this.monthlyNonDiscretionaryExpensesOther;
        data["isSpouseRefusedToProvideIncomeData"] = this.isSpouseRefusedToProvideIncomeData;
        return data;
    }
}

export interface IFileAnalysisSurplusIncomeDto {
    monthlyNetIncomeApplicant?: number;
    monthlyNetIncomeSpouse?: number;
    monthlyNetIncomeOther?: number;
    monthlyNonDiscretionaryExpensesApplicant?: number;
    monthlyNonDiscretionaryExpensesSpouse?: number;
    monthlyNonDiscretionaryExpensesOther?: number;
    isSpouseRefusedToProvideIncomeData?: boolean;
}

export class FileAnalysisToolsOfTradeAssetDetailsDto implements IFileAnalysisToolsOfTradeAssetDetailsDto {
    estimatedValue?: number;
    personalExemption?: number;
    toolsOfTradeRealization?: number | undefined;

    constructor(data?: IFileAnalysisToolsOfTradeAssetDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedValue = _data["estimatedValue"];
            this.personalExemption = _data["personalExemption"];
            this.toolsOfTradeRealization = _data["toolsOfTradeRealization"];
        }
    }

    static fromJS(data: any): FileAnalysisToolsOfTradeAssetDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisToolsOfTradeAssetDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedValue"] = this.estimatedValue;
        data["personalExemption"] = this.personalExemption;
        data["toolsOfTradeRealization"] = this.toolsOfTradeRealization;
        return data;
    }
}

export interface IFileAnalysisToolsOfTradeAssetDetailsDto {
    estimatedValue?: number;
    personalExemption?: number;
    toolsOfTradeRealization?: number | undefined;
}

export class FileAnalysisTrusteeReportDetailDto implements IFileAnalysisTrusteeReportDetailDto {
    id?: string;
    fileId?: string;
    isGiftsConveyances?: boolean;
    giftsConveyancesNotes?: string | undefined;
    giftsConveyancesRecoveryImpact?: number | undefined;
    giftsConveyancesAdjUnsecuredClaims?: number | undefined;
    isAnyDefects?: boolean;
    anyDefectsNotes?: string | undefined;
    anyDefectsRecoveryImpact?: number | undefined;
    anyDefectsAdjUnsecuredClaims?: number | undefined;
    isSecuredShortfall?: boolean;
    isSecuredShortfallParticipate?: boolean;
    isContingentUnliquidatedClaims?: boolean;
    isCoSignGuaranteed?: boolean;
    isCoSingGuaranteedContinue?: boolean;
    isAffectRecovery?: boolean;
    affectRecoveryNotes?: string | undefined;
    affectRecoveryImpactToRecovery?: number | undefined;
    affectRecoveryAdjUnsecuredClaims?: number | undefined;

    constructor(data?: IFileAnalysisTrusteeReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.isGiftsConveyances = _data["isGiftsConveyances"];
            this.giftsConveyancesNotes = _data["giftsConveyancesNotes"];
            this.giftsConveyancesRecoveryImpact = _data["giftsConveyancesRecoveryImpact"];
            this.giftsConveyancesAdjUnsecuredClaims = _data["giftsConveyancesAdjUnsecuredClaims"];
            this.isAnyDefects = _data["isAnyDefects"];
            this.anyDefectsNotes = _data["anyDefectsNotes"];
            this.anyDefectsRecoveryImpact = _data["anyDefectsRecoveryImpact"];
            this.anyDefectsAdjUnsecuredClaims = _data["anyDefectsAdjUnsecuredClaims"];
            this.isSecuredShortfall = _data["isSecuredShortfall"];
            this.isSecuredShortfallParticipate = _data["isSecuredShortfallParticipate"];
            this.isContingentUnliquidatedClaims = _data["isContingentUnliquidatedClaims"];
            this.isCoSignGuaranteed = _data["isCoSignGuaranteed"];
            this.isCoSingGuaranteedContinue = _data["isCoSingGuaranteedContinue"];
            this.isAffectRecovery = _data["isAffectRecovery"];
            this.affectRecoveryNotes = _data["affectRecoveryNotes"];
            this.affectRecoveryImpactToRecovery = _data["affectRecoveryImpactToRecovery"];
            this.affectRecoveryAdjUnsecuredClaims = _data["affectRecoveryAdjUnsecuredClaims"];
        }
    }

    static fromJS(data: any): FileAnalysisTrusteeReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAnalysisTrusteeReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["isGiftsConveyances"] = this.isGiftsConveyances;
        data["giftsConveyancesNotes"] = this.giftsConveyancesNotes;
        data["giftsConveyancesRecoveryImpact"] = this.giftsConveyancesRecoveryImpact;
        data["giftsConveyancesAdjUnsecuredClaims"] = this.giftsConveyancesAdjUnsecuredClaims;
        data["isAnyDefects"] = this.isAnyDefects;
        data["anyDefectsNotes"] = this.anyDefectsNotes;
        data["anyDefectsRecoveryImpact"] = this.anyDefectsRecoveryImpact;
        data["anyDefectsAdjUnsecuredClaims"] = this.anyDefectsAdjUnsecuredClaims;
        data["isSecuredShortfall"] = this.isSecuredShortfall;
        data["isSecuredShortfallParticipate"] = this.isSecuredShortfallParticipate;
        data["isContingentUnliquidatedClaims"] = this.isContingentUnliquidatedClaims;
        data["isCoSignGuaranteed"] = this.isCoSignGuaranteed;
        data["isCoSingGuaranteedContinue"] = this.isCoSingGuaranteedContinue;
        data["isAffectRecovery"] = this.isAffectRecovery;
        data["affectRecoveryNotes"] = this.affectRecoveryNotes;
        data["affectRecoveryImpactToRecovery"] = this.affectRecoveryImpactToRecovery;
        data["affectRecoveryAdjUnsecuredClaims"] = this.affectRecoveryAdjUnsecuredClaims;
        return data;
    }
}

export interface IFileAnalysisTrusteeReportDetailDto {
    id?: string;
    fileId?: string;
    isGiftsConveyances?: boolean;
    giftsConveyancesNotes?: string | undefined;
    giftsConveyancesRecoveryImpact?: number | undefined;
    giftsConveyancesAdjUnsecuredClaims?: number | undefined;
    isAnyDefects?: boolean;
    anyDefectsNotes?: string | undefined;
    anyDefectsRecoveryImpact?: number | undefined;
    anyDefectsAdjUnsecuredClaims?: number | undefined;
    isSecuredShortfall?: boolean;
    isSecuredShortfallParticipate?: boolean;
    isContingentUnliquidatedClaims?: boolean;
    isCoSignGuaranteed?: boolean;
    isCoSingGuaranteedContinue?: boolean;
    isAffectRecovery?: boolean;
    affectRecoveryNotes?: string | undefined;
    affectRecoveryImpactToRecovery?: number | undefined;
    affectRecoveryAdjUnsecuredClaims?: number | undefined;
}

export class FileProcessDto implements IFileProcessDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileProcessEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFileProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileProcessDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileProcessEnum;
    code?: string | undefined;
    name?: string | undefined;
}

export class AdminInfoBankingUpdateDto implements IAdminInfoBankingUpdateDto {
    status?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoBankingUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AdminInfoBankingUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoBankingUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IAdminInfoBankingUpdateDto {
    status?: FileProcessStatusEnum;
}

export class AdminInfoIncomeExpenseUpdateDto implements IAdminInfoIncomeExpenseUpdateDto {
    status?: FileProcessStatusEnum;

    constructor(data?: IAdminInfoIncomeExpenseUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AdminInfoIncomeExpenseUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoIncomeExpenseUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IAdminInfoIncomeExpenseUpdateDto {
    status?: FileProcessStatusEnum;
}

export class ExpenseSubmissionDetailDto implements IExpenseSubmissionDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IExpenseSubmissionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInitial = _data["isInitial"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseDescriptionId = _data["expenseDescriptionId"];
            this.specifiedDescription = _data["specifiedDescription"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
            this.isMissingDocuments = _data["isMissingDocuments"];
        }
    }

    static fromJS(data: any): ExpenseSubmissionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSubmissionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInitial"] = this.isInitial;
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseDescriptionId"] = this.expenseDescriptionId;
        data["specifiedDescription"] = this.specifiedDescription;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        data["isMissingDocuments"] = this.isMissingDocuments;
        return data;
    }
}

export interface IExpenseSubmissionDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isMissingDocuments?: boolean;
}

export class ExpenseSubmissionDto implements IExpenseSubmissionDto {
    fileId?: string;
    isMarried?: boolean;
    expenseDetails?: ExpenseSubmissionDetailDto[] | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IExpenseSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            if (Array.isArray(_data["expenseDetails"])) {
                this.expenseDetails = [] as any;
                for (let item of _data["expenseDetails"])
                    this.expenseDetails!.push(ExpenseSubmissionDetailDto.fromJS(item));
            }
            this.isMissingDocuments = _data["isMissingDocuments"];
        }
    }

    static fromJS(data: any): ExpenseSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        if (Array.isArray(this.expenseDetails)) {
            data["expenseDetails"] = [];
            for (let item of this.expenseDetails)
                data["expenseDetails"].push(item.toJSON());
        }
        data["isMissingDocuments"] = this.isMissingDocuments;
        return data;
    }
}

export interface IExpenseSubmissionDto {
    fileId?: string;
    isMarried?: boolean;
    expenseDetails?: ExpenseSubmissionDetailDto[] | undefined;
    isMissingDocuments?: boolean;
}

export class ExpenseSubmissionItemCreateDto implements IExpenseSubmissionItemCreateDto {
    expenseTypeId?: string;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;

    constructor(data?: IExpenseSubmissionItemCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeId = _data["expenseTypeId"];
            this.expenseDescriptionId = _data["expenseDescriptionId"];
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
            this.otherDescription = _data["otherDescription"];
        }
    }

    static fromJS(data: any): ExpenseSubmissionItemCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSubmissionItemCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeId"] = this.expenseTypeId;
        data["expenseDescriptionId"] = this.expenseDescriptionId;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        data["otherDescription"] = this.otherDescription;
        return data;
    }
}

export interface IExpenseSubmissionItemCreateDto {
    expenseTypeId?: string;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
}

export class ExpenseSubmissionItemPublicDto implements IExpenseSubmissionItemPublicDto {
    id?: string | undefined;
    expenseType?: LookupDto;
    expenseDescription?: LookupDto;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IExpenseSubmissionItemPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expenseType = _data["expenseType"] ? LookupDto.fromJS(_data["expenseType"]) : <any>undefined;
            this.expenseDescription = _data["expenseDescription"] ? LookupDto.fromJS(_data["expenseDescription"]) : <any>undefined;
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
            this.otherDescription = _data["otherDescription"];
            this.isMissingDocuments = _data["isMissingDocuments"];
        }
    }

    static fromJS(data: any): ExpenseSubmissionItemPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSubmissionItemPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        data["expenseDescription"] = this.expenseDescription ? this.expenseDescription.toJSON() : <any>undefined;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        data["otherDescription"] = this.otherDescription;
        data["isMissingDocuments"] = this.isMissingDocuments;
        return data;
    }
}

export interface IExpenseSubmissionItemPublicDto {
    id?: string | undefined;
    expenseType?: LookupDto;
    expenseDescription?: LookupDto;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
    isMissingDocuments?: boolean;
}

export class ExpenseSubmissionItemUpsertDto implements IExpenseSubmissionItemUpsertDto {
    id?: string | undefined;
    expenseType?: ExpenseTypeEnum;
    expenseDescription?: ExpenseDescriptionEnum;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;

    constructor(data?: IExpenseSubmissionItemUpsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expenseType = _data["expenseType"];
            this.expenseDescription = _data["expenseDescription"];
            this.expenseDescriptionId = _data["expenseDescriptionId"];
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
            this.otherDescription = _data["otherDescription"];
        }
    }

    static fromJS(data: any): ExpenseSubmissionItemUpsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSubmissionItemUpsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseType"] = this.expenseType;
        data["expenseDescription"] = this.expenseDescription;
        data["expenseDescriptionId"] = this.expenseDescriptionId;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        data["otherDescription"] = this.otherDescription;
        return data;
    }
}

export interface IExpenseSubmissionItemUpsertDto {
    id?: string | undefined;
    expenseType?: ExpenseTypeEnum;
    expenseDescription?: ExpenseDescriptionEnum;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
}

export class IncomeExpenseInfoDto implements IIncomeExpenseInfoDto {
    superintendentStandard?: number;
    isStandard?: boolean;
    bankruptIncome?: number;
    spouseIncome?: number;
    otherIncome?: number;
    nonDiscretionaryExpenses?: number;
    availableFamilyIncome?: number;
    totalMonthlySurplus?: number;
    bankruptPortion?: number;
    percentageOfSurplus?: number;
    bankruptPortionOfSurplus?: number;
    bankruptNetSurplus?: number;
    calculatedSurplusPayment?: number;

    constructor(data?: IIncomeExpenseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superintendentStandard = _data["superintendentStandard"];
            this.isStandard = _data["isStandard"];
            this.bankruptIncome = _data["bankruptIncome"];
            this.spouseIncome = _data["spouseIncome"];
            this.otherIncome = _data["otherIncome"];
            this.nonDiscretionaryExpenses = _data["nonDiscretionaryExpenses"];
            this.availableFamilyIncome = _data["availableFamilyIncome"];
            this.totalMonthlySurplus = _data["totalMonthlySurplus"];
            this.bankruptPortion = _data["bankruptPortion"];
            this.percentageOfSurplus = _data["percentageOfSurplus"];
            this.bankruptPortionOfSurplus = _data["bankruptPortionOfSurplus"];
            this.bankruptNetSurplus = _data["bankruptNetSurplus"];
            this.calculatedSurplusPayment = _data["calculatedSurplusPayment"];
        }
    }

    static fromJS(data: any): IncomeExpenseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superintendentStandard"] = this.superintendentStandard;
        data["isStandard"] = this.isStandard;
        data["bankruptIncome"] = this.bankruptIncome;
        data["spouseIncome"] = this.spouseIncome;
        data["otherIncome"] = this.otherIncome;
        data["nonDiscretionaryExpenses"] = this.nonDiscretionaryExpenses;
        data["availableFamilyIncome"] = this.availableFamilyIncome;
        data["totalMonthlySurplus"] = this.totalMonthlySurplus;
        data["bankruptPortion"] = this.bankruptPortion;
        data["percentageOfSurplus"] = this.percentageOfSurplus;
        data["bankruptPortionOfSurplus"] = this.bankruptPortionOfSurplus;
        data["bankruptNetSurplus"] = this.bankruptNetSurplus;
        data["calculatedSurplusPayment"] = this.calculatedSurplusPayment;
        return data;
    }
}

export interface IIncomeExpenseInfoDto {
    superintendentStandard?: number;
    isStandard?: boolean;
    bankruptIncome?: number;
    spouseIncome?: number;
    otherIncome?: number;
    nonDiscretionaryExpenses?: number;
    availableFamilyIncome?: number;
    totalMonthlySurplus?: number;
    bankruptPortion?: number;
    percentageOfSurplus?: number;
    bankruptPortionOfSurplus?: number;
    bankruptNetSurplus?: number;
    calculatedSurplusPayment?: number;
}

export class IncomeExpenseSubmissionCreatePublicDto implements IIncomeExpenseSubmissionCreatePublicDto {
    numberOfHousehold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    incomeItems?: IncomeSubmissionItemCreateDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemCreateDto[] | undefined;

    constructor(data?: IIncomeExpenseSubmissionCreatePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfHousehold = _data["numberOfHousehold"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.externalIeSubmissionPeriodId = _data["externalIeSubmissionPeriodId"];
            if (Array.isArray(_data["incomeItems"])) {
                this.incomeItems = [] as any;
                for (let item of _data["incomeItems"])
                    this.incomeItems!.push(IncomeSubmissionItemCreateDto.fromJS(item));
            }
            if (Array.isArray(_data["expenseItems"])) {
                this.expenseItems = [] as any;
                for (let item of _data["expenseItems"])
                    this.expenseItems!.push(ExpenseSubmissionItemCreateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionCreatePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionCreatePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfHousehold"] = this.numberOfHousehold;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["externalIeSubmissionPeriodId"] = this.externalIeSubmissionPeriodId;
        if (Array.isArray(this.incomeItems)) {
            data["incomeItems"] = [];
            for (let item of this.incomeItems)
                data["incomeItems"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseItems)) {
            data["expenseItems"] = [];
            for (let item of this.expenseItems)
                data["expenseItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncomeExpenseSubmissionCreatePublicDto {
    numberOfHousehold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    incomeItems?: IncomeSubmissionItemCreateDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemCreateDto[] | undefined;
}

export class IncomeExpenseSubmissionDetailsDto implements IIncomeExpenseSubmissionDetailsDto {
    id?: string;
    fileId?: string;
    state?: IncomeExpenseSubmissionStateEnum;
    result?: IncomeExpenseSubmissionStatusEnum;
    hasMissingInformation?: boolean | undefined;
    hasDiscrepancy?: boolean | undefined;
    isAmendmentRequired?: boolean | undefined;
    comments?: string | undefined;
    superintendentStandard?: number | undefined;
    superintendentType?: SuperintendentTypeEnum;
    calculatedSurplusPayment?: number | undefined;
    estimatedSurplusPayment?: number | undefined;
    documentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto;

    constructor(data?: IIncomeExpenseSubmissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.state = _data["state"];
            this.result = _data["result"];
            this.hasMissingInformation = _data["hasMissingInformation"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
            this.isAmendmentRequired = _data["isAmendmentRequired"];
            this.comments = _data["comments"];
            this.superintendentStandard = _data["superintendentStandard"];
            this.superintendentType = _data["superintendentType"];
            this.calculatedSurplusPayment = _data["calculatedSurplusPayment"];
            this.estimatedSurplusPayment = _data["estimatedSurplusPayment"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.importedEmailSubject = _data["importedEmailSubject"];
            this.importedEmailBody = _data["importedEmailBody"];
            this.importedEmailRecipientEmailAddress = _data["importedEmailRecipientEmailAddress"];
            this.importedEmailRecipientName = _data["importedEmailRecipientName"];
            this.importedEmailSenderEmailAddress = _data["importedEmailSenderEmailAddress"];
            this.importedEmailSenderName = _data["importedEmailSenderName"];
            this.info = _data["info"] ? IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["state"] = this.state;
        data["result"] = this.result;
        data["hasMissingInformation"] = this.hasMissingInformation;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        data["isAmendmentRequired"] = this.isAmendmentRequired;
        data["comments"] = this.comments;
        data["superintendentStandard"] = this.superintendentStandard;
        data["superintendentType"] = this.superintendentType;
        data["calculatedSurplusPayment"] = this.calculatedSurplusPayment;
        data["estimatedSurplusPayment"] = this.estimatedSurplusPayment;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["importedEmailSubject"] = this.importedEmailSubject;
        data["importedEmailBody"] = this.importedEmailBody;
        data["importedEmailRecipientEmailAddress"] = this.importedEmailRecipientEmailAddress;
        data["importedEmailRecipientName"] = this.importedEmailRecipientName;
        data["importedEmailSenderEmailAddress"] = this.importedEmailSenderEmailAddress;
        data["importedEmailSenderName"] = this.importedEmailSenderName;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncomeExpenseSubmissionDetailsDto {
    id?: string;
    fileId?: string;
    state?: IncomeExpenseSubmissionStateEnum;
    result?: IncomeExpenseSubmissionStatusEnum;
    hasMissingInformation?: boolean | undefined;
    hasDiscrepancy?: boolean | undefined;
    isAmendmentRequired?: boolean | undefined;
    comments?: string | undefined;
    superintendentStandard?: number | undefined;
    superintendentType?: SuperintendentTypeEnum;
    calculatedSurplusPayment?: number | undefined;
    estimatedSurplusPayment?: number | undefined;
    documentIds?: string[] | undefined;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto;
}

export class IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto implements IIncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    numberOfHousehold?: number;
    fileName?: string | undefined;
    selectIE?: string | undefined;

    constructor(data?: IIncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.numberOfHousehold = _data["numberOfHousehold"];
            this.fileName = _data["fileName"];
            this.selectIE = _data["selectIE"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["numberOfHousehold"] = this.numberOfHousehold;
        data["fileName"] = this.fileName;
        data["selectIE"] = this.selectIE;
        return data;
    }
}

export interface IIncomeExpenseSubmissionDetailsDto_IncomeExpenseSubmissionInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    numberOfHousehold?: number;
    fileName?: string | undefined;
    selectIE?: string | undefined;
}

export class IncomeExpenseSubmissionDto implements IIncomeExpenseSubmissionDto {
    id?: string;
    fileId?: string;
    spouseRefusedIncomeData?: boolean;
    receivedDate?: moment.Moment;
    calculatedSurplusPayment?: number;
    assignedAgentId?: string;
    assignedAgentName?: string | undefined;
    status?: IncomeExpenseSubmissionStatusEnum;
    state?: IncomeExpenseSubmissionStateEnum;
    periodStatus?: IncomeExpensePeriodStatusEnum;
    externalIeSubmissionPeriodId?: string | undefined;
    hasDiscrepancy?: boolean | undefined;

    constructor(data?: IIncomeExpenseSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.spouseRefusedIncomeData = _data["spouseRefusedIncomeData"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.calculatedSurplusPayment = _data["calculatedSurplusPayment"];
            this.assignedAgentId = _data["assignedAgentId"];
            this.assignedAgentName = _data["assignedAgentName"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.periodStatus = _data["periodStatus"];
            this.externalIeSubmissionPeriodId = _data["externalIeSubmissionPeriodId"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["spouseRefusedIncomeData"] = this.spouseRefusedIncomeData;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["calculatedSurplusPayment"] = this.calculatedSurplusPayment;
        data["assignedAgentId"] = this.assignedAgentId;
        data["assignedAgentName"] = this.assignedAgentName;
        data["status"] = this.status;
        data["state"] = this.state;
        data["periodStatus"] = this.periodStatus;
        data["externalIeSubmissionPeriodId"] = this.externalIeSubmissionPeriodId;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        return data;
    }
}

export interface IIncomeExpenseSubmissionDto {
    id?: string;
    fileId?: string;
    spouseRefusedIncomeData?: boolean;
    receivedDate?: moment.Moment;
    calculatedSurplusPayment?: number;
    assignedAgentId?: string;
    assignedAgentName?: string | undefined;
    status?: IncomeExpenseSubmissionStatusEnum;
    state?: IncomeExpenseSubmissionStateEnum;
    periodStatus?: IncomeExpensePeriodStatusEnum;
    externalIeSubmissionPeriodId?: string | undefined;
    hasDiscrepancy?: boolean | undefined;
}

export class IncomeExpenseSubmissionLinkDto implements IIncomeExpenseSubmissionLinkDto {
    searchedFileId?: string | undefined;
    numberOfHousehold?: number | undefined;
    selectedIeScheduleId?: string | undefined;
    result?: IncomeExpenseSubmissionStatusEnum;
    markAsActive?: boolean | undefined;
    appTaskActionId?: string;

    constructor(data?: IIncomeExpenseSubmissionLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchedFileId = _data["searchedFileId"];
            this.numberOfHousehold = _data["numberOfHousehold"];
            this.selectedIeScheduleId = _data["selectedIeScheduleId"];
            this.result = _data["result"];
            this.markAsActive = _data["markAsActive"];
            this.appTaskActionId = _data["appTaskActionId"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchedFileId"] = this.searchedFileId;
        data["numberOfHousehold"] = this.numberOfHousehold;
        data["selectedIeScheduleId"] = this.selectedIeScheduleId;
        data["result"] = this.result;
        data["markAsActive"] = this.markAsActive;
        data["appTaskActionId"] = this.appTaskActionId;
        return data;
    }
}

export interface IIncomeExpenseSubmissionLinkDto {
    searchedFileId?: string | undefined;
    numberOfHousehold?: number | undefined;
    selectedIeScheduleId?: string | undefined;
    result?: IncomeExpenseSubmissionStatusEnum;
    markAsActive?: boolean | undefined;
    appTaskActionId?: string;
}

export class IncomeExpenseSubmissionPeriodDto implements IIncomeExpenseSubmissionPeriodDto {
    externalIeSubmissionPeriodId?: string | undefined;
    scheduleNumber?: number;
    period?: number;
    dueDate?: moment.Moment | undefined;
    estimatedSurplus?: number;
    comments?: string | undefined;
    status?: IncomeExpensePeriodStatusEnum;

    constructor(data?: IIncomeExpenseSubmissionPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIeSubmissionPeriodId = _data["externalIeSubmissionPeriodId"];
            this.scheduleNumber = _data["scheduleNumber"];
            this.period = _data["period"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.estimatedSurplus = _data["estimatedSurplus"];
            this.comments = _data["comments"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIeSubmissionPeriodId"] = this.externalIeSubmissionPeriodId;
        data["scheduleNumber"] = this.scheduleNumber;
        data["period"] = this.period;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["estimatedSurplus"] = this.estimatedSurplus;
        data["comments"] = this.comments;
        data["status"] = this.status;
        return data;
    }
}

export interface IIncomeExpenseSubmissionPeriodDto {
    externalIeSubmissionPeriodId?: string | undefined;
    scheduleNumber?: number;
    period?: number;
    dueDate?: moment.Moment | undefined;
    estimatedSurplus?: number;
    comments?: string | undefined;
    status?: IncomeExpensePeriodStatusEnum;
}

export class IncomeExpenseSubmissionPeriodListItemDto implements IIncomeExpenseSubmissionPeriodListItemDto {
    externalIeSubmissionPeriodId?: string | undefined;
    period?: string | undefined;

    constructor(data?: IIncomeExpenseSubmissionPeriodListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIeSubmissionPeriodId = _data["externalIeSubmissionPeriodId"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionPeriodListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionPeriodListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIeSubmissionPeriodId"] = this.externalIeSubmissionPeriodId;
        data["period"] = this.period;
        return data;
    }
}

export interface IIncomeExpenseSubmissionPeriodListItemDto {
    externalIeSubmissionPeriodId?: string | undefined;
    period?: string | undefined;
}

export class IncomeExpenseSubmissionPublicDto implements IIncomeExpenseSubmissionPublicDto {
    id?: string | undefined;
    numberOfHouseHold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    isChangeRequired?: boolean;
    commentsFromStaffPortal?: string | undefined;
    incomeItems?: IncomeSubmissionItemPublicDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemPublicDto[] | undefined;
    isNilIncomeBankStatementMissing?: boolean;

    constructor(data?: IIncomeExpenseSubmissionPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfHouseHold = _data["numberOfHouseHold"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.externalIeSubmissionPeriodId = _data["externalIeSubmissionPeriodId"];
            this.isChangeRequired = _data["isChangeRequired"];
            this.commentsFromStaffPortal = _data["commentsFromStaffPortal"];
            if (Array.isArray(_data["incomeItems"])) {
                this.incomeItems = [] as any;
                for (let item of _data["incomeItems"])
                    this.incomeItems!.push(IncomeSubmissionItemPublicDto.fromJS(item));
            }
            if (Array.isArray(_data["expenseItems"])) {
                this.expenseItems = [] as any;
                for (let item of _data["expenseItems"])
                    this.expenseItems!.push(ExpenseSubmissionItemPublicDto.fromJS(item));
            }
            this.isNilIncomeBankStatementMissing = _data["isNilIncomeBankStatementMissing"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfHouseHold"] = this.numberOfHouseHold;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["externalIeSubmissionPeriodId"] = this.externalIeSubmissionPeriodId;
        data["isChangeRequired"] = this.isChangeRequired;
        data["commentsFromStaffPortal"] = this.commentsFromStaffPortal;
        if (Array.isArray(this.incomeItems)) {
            data["incomeItems"] = [];
            for (let item of this.incomeItems)
                data["incomeItems"].push(item.toJSON());
        }
        if (Array.isArray(this.expenseItems)) {
            data["expenseItems"] = [];
            for (let item of this.expenseItems)
                data["expenseItems"].push(item.toJSON());
        }
        data["isNilIncomeBankStatementMissing"] = this.isNilIncomeBankStatementMissing;
        return data;
    }
}

export interface IIncomeExpenseSubmissionPublicDto {
    id?: string | undefined;
    numberOfHouseHold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    isChangeRequired?: boolean;
    commentsFromStaffPortal?: string | undefined;
    incomeItems?: IncomeSubmissionItemPublicDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemPublicDto[] | undefined;
    isNilIncomeBankStatementMissing?: boolean;
}

export class IncomeExpenseSubmissionUpdateDto implements IIncomeExpenseSubmissionUpdateDto {
    state?: IncomeExpenseSubmissionStateEnum;
    result?: IncomeExpenseSubmissionStatusEnum;
    hasMissingInformation?: boolean | undefined;
    hasDiscrepancy?: boolean | undefined;
    isAmendmentRequired?: boolean | undefined;
    commentsForClientPortal?: string | undefined;
    isMarkedAsComplete?: boolean;
    superintendentStandard?: number | undefined;
    bankruptIncome?: number | undefined;
    spouseIncome?: number | undefined;
    otherIncome?: number | undefined;
    nonDiscretionaryExpenses?: number | undefined;
    availableFamilyIncome?: number | undefined;
    totalMonthlySurplus?: number | undefined;
    bankruptPortion?: number | undefined;
    percentageOfSurplus?: number | undefined;
    bankruptPortionOfSurplus?: number | undefined;
    bankruptNetSurplus?: number | undefined;
    calculatedSurplusPayment?: number | undefined;
    estimatedSurplusPayment?: number | undefined;
    isIgnoreAndComplete?: boolean;
    alerts?: AlertCreateDto;
    superintendentType?: SuperintendentTypeEnum;

    constructor(data?: IIncomeExpenseSubmissionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.result = _data["result"];
            this.hasMissingInformation = _data["hasMissingInformation"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
            this.isAmendmentRequired = _data["isAmendmentRequired"];
            this.commentsForClientPortal = _data["commentsForClientPortal"];
            this.isMarkedAsComplete = _data["isMarkedAsComplete"];
            this.superintendentStandard = _data["superintendentStandard"];
            this.bankruptIncome = _data["bankruptIncome"];
            this.spouseIncome = _data["spouseIncome"];
            this.otherIncome = _data["otherIncome"];
            this.nonDiscretionaryExpenses = _data["nonDiscretionaryExpenses"];
            this.availableFamilyIncome = _data["availableFamilyIncome"];
            this.totalMonthlySurplus = _data["totalMonthlySurplus"];
            this.bankruptPortion = _data["bankruptPortion"];
            this.percentageOfSurplus = _data["percentageOfSurplus"];
            this.bankruptPortionOfSurplus = _data["bankruptPortionOfSurplus"];
            this.bankruptNetSurplus = _data["bankruptNetSurplus"];
            this.calculatedSurplusPayment = _data["calculatedSurplusPayment"];
            this.estimatedSurplusPayment = _data["estimatedSurplusPayment"];
            this.isIgnoreAndComplete = _data["isIgnoreAndComplete"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
            this.superintendentType = _data["superintendentType"];
        }
    }

    static fromJS(data: any): IncomeExpenseSubmissionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseSubmissionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["result"] = this.result;
        data["hasMissingInformation"] = this.hasMissingInformation;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        data["isAmendmentRequired"] = this.isAmendmentRequired;
        data["commentsForClientPortal"] = this.commentsForClientPortal;
        data["isMarkedAsComplete"] = this.isMarkedAsComplete;
        data["superintendentStandard"] = this.superintendentStandard;
        data["bankruptIncome"] = this.bankruptIncome;
        data["spouseIncome"] = this.spouseIncome;
        data["otherIncome"] = this.otherIncome;
        data["nonDiscretionaryExpenses"] = this.nonDiscretionaryExpenses;
        data["availableFamilyIncome"] = this.availableFamilyIncome;
        data["totalMonthlySurplus"] = this.totalMonthlySurplus;
        data["bankruptPortion"] = this.bankruptPortion;
        data["percentageOfSurplus"] = this.percentageOfSurplus;
        data["bankruptPortionOfSurplus"] = this.bankruptPortionOfSurplus;
        data["bankruptNetSurplus"] = this.bankruptNetSurplus;
        data["calculatedSurplusPayment"] = this.calculatedSurplusPayment;
        data["estimatedSurplusPayment"] = this.estimatedSurplusPayment;
        data["isIgnoreAndComplete"] = this.isIgnoreAndComplete;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        data["superintendentType"] = this.superintendentType;
        return data;
    }
}

export interface IIncomeExpenseSubmissionUpdateDto {
    state?: IncomeExpenseSubmissionStateEnum;
    result?: IncomeExpenseSubmissionStatusEnum;
    hasMissingInformation?: boolean | undefined;
    hasDiscrepancy?: boolean | undefined;
    isAmendmentRequired?: boolean | undefined;
    commentsForClientPortal?: string | undefined;
    isMarkedAsComplete?: boolean;
    superintendentStandard?: number | undefined;
    bankruptIncome?: number | undefined;
    spouseIncome?: number | undefined;
    otherIncome?: number | undefined;
    nonDiscretionaryExpenses?: number | undefined;
    availableFamilyIncome?: number | undefined;
    totalMonthlySurplus?: number | undefined;
    bankruptPortion?: number | undefined;
    percentageOfSurplus?: number | undefined;
    bankruptPortionOfSurplus?: number | undefined;
    bankruptNetSurplus?: number | undefined;
    calculatedSurplusPayment?: number | undefined;
    estimatedSurplusPayment?: number | undefined;
    isIgnoreAndComplete?: boolean;
    alerts?: AlertCreateDto;
    superintendentType?: SuperintendentTypeEnum;
}

export class IncomeSubmissionDetailDto implements IIncomeSubmissionDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;

    constructor(data?: IIncomeSubmissionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInitial = _data["isInitial"];
            this.incomeTypeId = _data["incomeTypeId"];
            this.description = _data["description"];
            this.applicantAmount = _data["applicantAmount"];
            this.spouseAmount = _data["spouseAmount"];
            this.otherHouseholdMemberAmount = _data["otherHouseholdMemberAmount"];
        }
    }

    static fromJS(data: any): IncomeSubmissionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeSubmissionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInitial"] = this.isInitial;
        data["incomeTypeId"] = this.incomeTypeId;
        data["description"] = this.description;
        data["applicantAmount"] = this.applicantAmount;
        data["spouseAmount"] = this.spouseAmount;
        data["otherHouseholdMemberAmount"] = this.otherHouseholdMemberAmount;
        return data;
    }
}

export interface IIncomeSubmissionDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
}

export class IncomeSubmissionDto implements IIncomeSubmissionDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    incomeDetails?: IncomeSubmissionDetailDto[] | undefined;

    constructor(data?: IIncomeSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isMarried = _data["isMarried"];
            this.isSpouseRefusedToProvideIncomeData = _data["isSpouseRefusedToProvideIncomeData"];
            if (Array.isArray(_data["incomeDetails"])) {
                this.incomeDetails = [] as any;
                for (let item of _data["incomeDetails"])
                    this.incomeDetails!.push(IncomeSubmissionDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncomeSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isMarried"] = this.isMarried;
        data["isSpouseRefusedToProvideIncomeData"] = this.isSpouseRefusedToProvideIncomeData;
        if (Array.isArray(this.incomeDetails)) {
            data["incomeDetails"] = [];
            for (let item of this.incomeDetails)
                data["incomeDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncomeSubmissionDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    incomeDetails?: IncomeSubmissionDetailDto[] | undefined;
}

export class IncomeSubmissionItemCreateDto implements IIncomeSubmissionItemCreateDto {
    incomeTypeId?: string;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;

    constructor(data?: IIncomeSubmissionItemCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomeTypeId = _data["incomeTypeId"];
            this.description = _data["description"];
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
        }
    }

    static fromJS(data: any): IncomeSubmissionItemCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeSubmissionItemCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeTypeId"] = this.incomeTypeId;
        data["description"] = this.description;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        return data;
    }
}

export interface IIncomeSubmissionItemCreateDto {
    incomeTypeId?: string;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
}

export class IncomeSubmissionItemPublicDto implements IIncomeSubmissionItemPublicDto {
    id?: string | undefined;
    incomeType?: LookupDto;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IIncomeSubmissionItemPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomeType = _data["incomeType"] ? LookupDto.fromJS(_data["incomeType"]) : <any>undefined;
            this.description = _data["description"];
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
            this.isMissingDocuments = _data["isMissingDocuments"];
        }
    }

    static fromJS(data: any): IncomeSubmissionItemPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeSubmissionItemPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomeType"] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        data["isMissingDocuments"] = this.isMissingDocuments;
        return data;
    }
}

export interface IIncomeSubmissionItemPublicDto {
    id?: string | undefined;
    incomeType?: LookupDto;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    isMissingDocuments?: boolean;
}

export class IncomeSubmissionItemUpsertDto implements IIncomeSubmissionItemUpsertDto {
    id?: string | undefined;
    incomeType?: IncomeTypeEnum;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;

    constructor(data?: IIncomeSubmissionItemUpsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incomeType = _data["incomeType"];
            this.description = _data["description"];
            this.amountApplicant = _data["amountApplicant"];
            this.amountSpouse = _data["amountSpouse"];
            this.amountOther = _data["amountOther"];
        }
    }

    static fromJS(data: any): IncomeSubmissionItemUpsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeSubmissionItemUpsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incomeType"] = this.incomeType;
        data["description"] = this.description;
        data["amountApplicant"] = this.amountApplicant;
        data["amountSpouse"] = this.amountSpouse;
        data["amountOther"] = this.amountOther;
        return data;
    }
}

export interface IIncomeSubmissionItemUpsertDto {
    id?: string | undefined;
    incomeType?: IncomeTypeEnum;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
}

export class MoveIncomeExpenseSubmissionPeriodDto implements IMoveIncomeExpenseSubmissionPeriodDto {
    newExternalIeSubmissionPeriodId!: string | undefined;

    constructor(data?: IMoveIncomeExpenseSubmissionPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newExternalIeSubmissionPeriodId = _data["newExternalIeSubmissionPeriodId"];
        }
    }

    static fromJS(data: any): MoveIncomeExpenseSubmissionPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveIncomeExpenseSubmissionPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newExternalIeSubmissionPeriodId"] = this.newExternalIeSubmissionPeriodId;
        return data;
    }
}

export interface IMoveIncomeExpenseSubmissionPeriodDto {
    newExternalIeSubmissionPeriodId: string | undefined;
}

export class UpdateSubmissionDocumentIdsDto implements IUpdateSubmissionDocumentIdsDto {
    documentIds?: string[] | undefined;

    constructor(data?: IUpdateSubmissionDocumentIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSubmissionDocumentIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubmissionDocumentIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSubmissionDocumentIdsDto {
    documentIds?: string[] | undefined;
}

export class ReportDataItemDto implements IReportDataItemDto {
    id?: string;
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneNumber?: string | undefined;
    postalCode?: string | undefined;
    receiveEmailConsent?: boolean | undefined;
    debtorCreationDate?: moment.Moment | undefined;
    webUrl?: string | undefined;
    estateNumber?: string | undefined;
    fileName?: string | undefined;
    appointmentCreationDateTime?: moment.Moment | undefined;
    appointmentDateTime?: moment.Moment | undefined;
    fileStageName?: string | undefined;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    interviewer?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    signupStatus?: string | undefined;
    signupCompletedDateTime?: moment.Moment | undefined;
    appointmentsCreatedBy?: string | undefined;
    appointmentsAssignedTo?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentType?: string | undefined;
    meetingType?: string | undefined;
    appointmentLocation?: string | undefined;
    referralSource?: string | undefined;
    referralSourceDetail?: string | undefined;
    referralSourcesAll?: string | undefined;
    intakeSource?: string | undefined;
    educationLevel?: string | undefined;
    province?: string | undefined;
    occupation?: string | undefined;
    filingReasons?: string | undefined;

    constructor(data?: IReportDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.postalCode = _data["postalCode"];
            this.receiveEmailConsent = _data["receiveEmailConsent"];
            this.debtorCreationDate = _data["debtorCreationDate"] ? moment(_data["debtorCreationDate"].toString()) : <any>undefined;
            this.webUrl = _data["webUrl"];
            this.estateNumber = _data["estateNumber"];
            this.fileName = _data["fileName"];
            this.appointmentCreationDateTime = _data["appointmentCreationDateTime"] ? moment(_data["appointmentCreationDateTime"].toString()) : <any>undefined;
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>undefined;
            this.fileStageName = _data["fileStageName"];
            this.agent = _data["agent"];
            this.estateAdministrator = _data["estateAdministrator"];
            this.trustee = _data["trustee"];
            this.interviewer = _data["interviewer"];
            this.filingType = _data["filingType"];
            this.serviceLocation = _data["serviceLocation"];
            this.signupStatus = _data["signupStatus"];
            this.signupCompletedDateTime = _data["signupCompletedDateTime"] ? moment(_data["signupCompletedDateTime"].toString()) : <any>undefined;
            this.appointmentsCreatedBy = _data["appointmentsCreatedBy"];
            this.appointmentsAssignedTo = _data["appointmentsAssignedTo"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.appointmentType = _data["appointmentType"];
            this.meetingType = _data["meetingType"];
            this.appointmentLocation = _data["appointmentLocation"];
            this.referralSource = _data["referralSource"];
            this.referralSourceDetail = _data["referralSourceDetail"];
            this.referralSourcesAll = _data["referralSourcesAll"];
            this.intakeSource = _data["intakeSource"];
            this.educationLevel = _data["educationLevel"];
            this.province = _data["province"];
            this.occupation = _data["occupation"];
            this.filingReasons = _data["filingReasons"];
        }
    }

    static fromJS(data: any): ReportDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["postalCode"] = this.postalCode;
        data["receiveEmailConsent"] = this.receiveEmailConsent;
        data["debtorCreationDate"] = this.debtorCreationDate ? this.debtorCreationDate.toISOString() : <any>undefined;
        data["webUrl"] = this.webUrl;
        data["estateNumber"] = this.estateNumber;
        data["fileName"] = this.fileName;
        data["appointmentCreationDateTime"] = this.appointmentCreationDateTime ? this.appointmentCreationDateTime.toISOString() : <any>undefined;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>undefined;
        data["fileStageName"] = this.fileStageName;
        data["agent"] = this.agent;
        data["estateAdministrator"] = this.estateAdministrator;
        data["trustee"] = this.trustee;
        data["interviewer"] = this.interviewer;
        data["filingType"] = this.filingType;
        data["serviceLocation"] = this.serviceLocation;
        data["signupStatus"] = this.signupStatus;
        data["signupCompletedDateTime"] = this.signupCompletedDateTime ? this.signupCompletedDateTime.toISOString() : <any>undefined;
        data["appointmentsCreatedBy"] = this.appointmentsCreatedBy;
        data["appointmentsAssignedTo"] = this.appointmentsAssignedTo;
        data["appointmentStatus"] = this.appointmentStatus;
        data["appointmentType"] = this.appointmentType;
        data["meetingType"] = this.meetingType;
        data["appointmentLocation"] = this.appointmentLocation;
        data["referralSource"] = this.referralSource;
        data["referralSourceDetail"] = this.referralSourceDetail;
        data["referralSourcesAll"] = this.referralSourcesAll;
        data["intakeSource"] = this.intakeSource;
        data["educationLevel"] = this.educationLevel;
        data["province"] = this.province;
        data["occupation"] = this.occupation;
        data["filingReasons"] = this.filingReasons;
        return data;
    }
}

export interface IReportDataItemDto {
    id?: string;
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneNumber?: string | undefined;
    postalCode?: string | undefined;
    receiveEmailConsent?: boolean | undefined;
    debtorCreationDate?: moment.Moment | undefined;
    webUrl?: string | undefined;
    estateNumber?: string | undefined;
    fileName?: string | undefined;
    appointmentCreationDateTime?: moment.Moment | undefined;
    appointmentDateTime?: moment.Moment | undefined;
    fileStageName?: string | undefined;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    interviewer?: string | undefined;
    filingType?: string | undefined;
    serviceLocation?: string | undefined;
    signupStatus?: string | undefined;
    signupCompletedDateTime?: moment.Moment | undefined;
    appointmentsCreatedBy?: string | undefined;
    appointmentsAssignedTo?: string | undefined;
    appointmentStatus?: string | undefined;
    appointmentType?: string | undefined;
    meetingType?: string | undefined;
    appointmentLocation?: string | undefined;
    referralSource?: string | undefined;
    referralSourceDetail?: string | undefined;
    referralSourcesAll?: string | undefined;
    intakeSource?: string | undefined;
    educationLevel?: string | undefined;
    province?: string | undefined;
    occupation?: string | undefined;
    filingReasons?: string | undefined;
}

export class NoteCreateDto implements INoteCreateDto {
    fileId!: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;
    content!: string | undefined;
    isPinned?: boolean;

    constructor(data?: INoteCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.documentVerificationId = _data["documentVerificationId"];
            this.content = _data["content"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): NoteCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["documentVerificationId"] = this.documentVerificationId;
        data["content"] = this.content;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface INoteCreateDto {
    fileId: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;
    content: string | undefined;
    isPinned?: boolean;
}

export class NoteDto implements INoteDto {
    id?: string;
    content?: string | undefined;
    isPinned?: boolean;
    creationTime?: moment.Moment;
    creatorId?: string;
    creatorName?: string | undefined;
    fileId?: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.isPinned = _data["isPinned"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
            this.creatorName = _data["creatorName"];
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.documentVerificationId = _data["documentVerificationId"];
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["isPinned"] = this.isPinned;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["creatorName"] = this.creatorName;
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["documentVerificationId"] = this.documentVerificationId;
        return data;
    }
}

export interface INoteDto {
    id?: string;
    content?: string | undefined;
    isPinned?: boolean;
    creationTime?: moment.Moment;
    creatorId?: string;
    creatorName?: string | undefined;
    fileId?: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;
}

export class NoteUpdateDto implements INoteUpdateDto {
    fileId!: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;
    content!: string | undefined;
    isPinned?: boolean | undefined;

    constructor(data?: INoteUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.documentVerificationId = _data["documentVerificationId"];
            this.content = _data["content"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): NoteUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["documentVerificationId"] = this.documentVerificationId;
        data["content"] = this.content;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface INoteUpdateDto {
    fileId: string;
    documentId?: string | undefined;
    documentVerificationId?: string | undefined;
    content: string | undefined;
    isPinned?: boolean | undefined;
}

export class NotificationDto implements INotificationDto {
    id?: string;
    isUnread?: boolean;
    url?: string | undefined;
    messageKey?: string | undefined;
    creationTime?: moment.Moment;
    contentParameters?: { [key: string]: string; } | undefined;
    urlParameters?: { [key: string]: string; } | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isUnread = _data["isUnread"];
            this.url = _data["url"];
            this.messageKey = _data["messageKey"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (_data["contentParameters"]) {
                this.contentParameters = {} as any;
                for (let key in _data["contentParameters"]) {
                    if (_data["contentParameters"].hasOwnProperty(key))
                        (<any>this.contentParameters)![key] = _data["contentParameters"][key];
                }
            }
            if (_data["urlParameters"]) {
                this.urlParameters = {} as any;
                for (let key in _data["urlParameters"]) {
                    if (_data["urlParameters"].hasOwnProperty(key))
                        (<any>this.urlParameters)![key] = _data["urlParameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isUnread"] = this.isUnread;
        data["url"] = this.url;
        data["messageKey"] = this.messageKey;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.contentParameters) {
            data["contentParameters"] = {};
            for (let key in this.contentParameters) {
                if (this.contentParameters.hasOwnProperty(key))
                    (<any>data["contentParameters"])[key] = (<any>this.contentParameters)[key];
            }
        }
        if (this.urlParameters) {
            data["urlParameters"] = {};
            for (let key in this.urlParameters) {
                if (this.urlParameters.hasOwnProperty(key))
                    (<any>data["urlParameters"])[key] = (<any>this.urlParameters)[key];
            }
        }
        return data;
    }
}

export interface INotificationDto {
    id?: string;
    isUnread?: boolean;
    url?: string | undefined;
    messageKey?: string | undefined;
    creationTime?: moment.Moment;
    contentParameters?: { [key: string]: string; } | undefined;
    urlParameters?: { [key: string]: string; } | undefined;
}

export class OfficeLocationCreateDto implements IOfficeLocationCreateDto {
    locationPrefix?: string | undefined;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    timeZoneId?: string;
    provinceId?: string;
    countryId?: string;
    officeRegionId?: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean | undefined;
    hours?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;

    constructor(data?: IOfficeLocationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationPrefix = _data["locationPrefix"];
            this.name = _data["name"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.timeZoneId = _data["timeZoneId"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.officeRegionId = _data["officeRegionId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isActive = _data["isActive"];
            this.hours = _data["hours"];
            this.isServiceLocation = _data["isServiceLocation"];
            this.isTrusteeOffice = _data["isTrusteeOffice"];
        }
    }

    static fromJS(data: any): OfficeLocationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeLocationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationPrefix"] = this.locationPrefix;
        data["name"] = this.name;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["timeZoneId"] = this.timeZoneId;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["officeRegionId"] = this.officeRegionId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isActive"] = this.isActive;
        data["hours"] = this.hours;
        data["isServiceLocation"] = this.isServiceLocation;
        data["isTrusteeOffice"] = this.isTrusteeOffice;
        return data;
    }
}

export interface IOfficeLocationCreateDto {
    locationPrefix?: string | undefined;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    timeZoneId?: string;
    provinceId?: string;
    countryId?: string;
    officeRegionId?: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean | undefined;
    hours?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;
}

export class OfficeLocationDto implements IOfficeLocationDto {
    id?: string;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    officeRegion?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean;
    hours?: string | undefined;
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    timeZoneCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    timeZoneId?: string | undefined;
    officeRegionId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;

    constructor(data?: IOfficeLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.officeRegion = _data["officeRegion"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isActive = _data["isActive"];
            this.hours = _data["hours"];
            this.locationCode = _data["locationCode"];
            this.locationPrefix = _data["locationPrefix"];
            this.timeZoneCode = _data["timeZoneCode"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.timeZoneId = _data["timeZoneId"];
            this.officeRegionId = _data["officeRegionId"];
            this.isServiceLocation = _data["isServiceLocation"];
            this.isTrusteeOffice = _data["isTrusteeOffice"];
        }
    }

    static fromJS(data: any): OfficeLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["country"] = this.country;
        data["officeRegion"] = this.officeRegion;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isActive"] = this.isActive;
        data["hours"] = this.hours;
        data["locationCode"] = this.locationCode;
        data["locationPrefix"] = this.locationPrefix;
        data["timeZoneCode"] = this.timeZoneCode;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["timeZoneId"] = this.timeZoneId;
        data["officeRegionId"] = this.officeRegionId;
        data["isServiceLocation"] = this.isServiceLocation;
        data["isTrusteeOffice"] = this.isTrusteeOffice;
        return data;
    }
}

export interface IOfficeLocationDto {
    id?: string;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    officeRegion?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean;
    hours?: string | undefined;
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    timeZoneCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    timeZoneId?: string | undefined;
    officeRegionId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;
}

export class OfficeLocationUpdateDto implements IOfficeLocationUpdateDto {
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    timeZoneId?: string;
    provinceId?: string;
    countryId?: string;
    officeRegionId?: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean | undefined;
    hours?: string | undefined;
    moveToOfficeLocationId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;

    constructor(data?: IOfficeLocationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationCode = _data["locationCode"];
            this.locationPrefix = _data["locationPrefix"];
            this.name = _data["name"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.timeZoneId = _data["timeZoneId"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.officeRegionId = _data["officeRegionId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isActive = _data["isActive"];
            this.hours = _data["hours"];
            this.moveToOfficeLocationId = _data["moveToOfficeLocationId"];
            this.isServiceLocation = _data["isServiceLocation"];
            this.isTrusteeOffice = _data["isTrusteeOffice"];
        }
    }

    static fromJS(data: any): OfficeLocationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeLocationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationCode"] = this.locationCode;
        data["locationPrefix"] = this.locationPrefix;
        data["name"] = this.name;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["timeZoneId"] = this.timeZoneId;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["officeRegionId"] = this.officeRegionId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isActive"] = this.isActive;
        data["hours"] = this.hours;
        data["moveToOfficeLocationId"] = this.moveToOfficeLocationId;
        data["isServiceLocation"] = this.isServiceLocation;
        data["isTrusteeOffice"] = this.isTrusteeOffice;
        return data;
    }
}

export interface IOfficeLocationUpdateDto {
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    timeZoneId?: string;
    provinceId?: string;
    countryId?: string;
    officeRegionId?: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean | undefined;
    hours?: string | undefined;
    moveToOfficeLocationId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;
}

export class PendingAuth0ChangeDto implements IPendingAuth0ChangeDto {
    id?: string;
    fileId?: string;
    fileName?: string | undefined;
    clientId?: string;
    clientName?: string | undefined;
    changeType?: Auth0ChangeTypeEnum;
    changeTypeDisplay?: string | undefined;
    requestedData?: string | undefined;
    reason?: string | undefined;
    status?: Auth0ChangeStatusEnum;
    statusDisplay?: string | undefined;
    reviewedBy?: string | undefined;
    reviewedAt?: moment.Moment | undefined;
    failureReason?: string | undefined;
    originalEmail?: string | undefined;
    creationTime?: moment.Moment;
    creatorId?: string | undefined;

    constructor(data?: IPendingAuth0ChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.changeType = _data["changeType"];
            this.changeTypeDisplay = _data["changeTypeDisplay"];
            this.requestedData = _data["requestedData"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
            this.reviewedBy = _data["reviewedBy"];
            this.reviewedAt = _data["reviewedAt"] ? moment(_data["reviewedAt"].toString()) : <any>undefined;
            this.failureReason = _data["failureReason"];
            this.originalEmail = _data["originalEmail"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
        }
    }

    static fromJS(data: any): PendingAuth0ChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingAuth0ChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["changeType"] = this.changeType;
        data["changeTypeDisplay"] = this.changeTypeDisplay;
        data["requestedData"] = this.requestedData;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        data["reviewedBy"] = this.reviewedBy;
        data["reviewedAt"] = this.reviewedAt ? this.reviewedAt.toISOString() : <any>undefined;
        data["failureReason"] = this.failureReason;
        data["originalEmail"] = this.originalEmail;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        return data;
    }
}

export interface IPendingAuth0ChangeDto {
    id?: string;
    fileId?: string;
    fileName?: string | undefined;
    clientId?: string;
    clientName?: string | undefined;
    changeType?: Auth0ChangeTypeEnum;
    changeTypeDisplay?: string | undefined;
    requestedData?: string | undefined;
    reason?: string | undefined;
    status?: Auth0ChangeStatusEnum;
    statusDisplay?: string | undefined;
    reviewedBy?: string | undefined;
    reviewedAt?: moment.Moment | undefined;
    failureReason?: string | undefined;
    originalEmail?: string | undefined;
    creationTime?: moment.Moment;
    creatorId?: string | undefined;
}

export class PendingAuth0ChangeListDto implements IPendingAuth0ChangeListDto {
    items?: PendingAuth0ChangeDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPendingAuth0ChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PendingAuth0ChangeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PendingAuth0ChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingAuth0ChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPendingAuth0ChangeListDto {
    items?: PendingAuth0ChangeDto[] | undefined;
    totalCount?: number;
}

export class ProposalCourtRevivalDto implements IProposalCourtRevivalDto {
    fileId?: string;
    documentId?: string;
    isRevived?: boolean | undefined;

    constructor(data?: IProposalCourtRevivalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.isRevived = _data["isRevived"];
        }
    }

    static fromJS(data: any): ProposalCourtRevivalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalCourtRevivalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["isRevived"] = this.isRevived;
        return data;
    }
}

export interface IProposalCourtRevivalDto {
    fileId?: string;
    documentId?: string;
    isRevived?: boolean | undefined;
}

export class ProposalFormFilingDto implements IProposalFormFilingDto {
    fileId?: string;
    documentId?: string | undefined;
    filingDate?: moment.Moment | undefined;

    constructor(data?: IProposalFormFilingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentId = _data["documentId"];
            this.filingDate = _data["filingDate"] ? moment(_data["filingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProposalFormFilingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalFormFilingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentId"] = this.documentId;
        data["filingDate"] = this.filingDate ? this.filingDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProposalFormFilingDto {
    fileId?: string;
    documentId?: string | undefined;
    filingDate?: moment.Moment | undefined;
}

export class ProposalFormFilingHistoryDto implements IProposalFormFilingHistoryDto {
    filingDate?: moment.Moment | undefined;
    updatedDate?: moment.Moment | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IProposalFormFilingHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filingDate = _data["filingDate"] ? moment(_data["filingDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ProposalFormFilingHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalFormFilingHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filingDate"] = this.filingDate ? this.filingDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IProposalFormFilingHistoryDto {
    filingDate?: moment.Moment | undefined;
    updatedDate?: moment.Moment | undefined;
    updatedBy?: string | undefined;
}

export class ProposalGraphDataDto implements IProposalGraphDataDto {
    voteForPercent?: number | undefined;
    voteAgainstPercent?: number | undefined;
    voteDidNotVotePercent?: number | undefined;
    meetingRequestedYesPercent?: number | undefined;
    meetingRequestedNoPercent?: number | undefined;
    meetingRequestedNotSelectedPercent?: number | undefined;

    constructor(data?: IProposalGraphDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voteForPercent = _data["voteForPercent"];
            this.voteAgainstPercent = _data["voteAgainstPercent"];
            this.voteDidNotVotePercent = _data["voteDidNotVotePercent"];
            this.meetingRequestedYesPercent = _data["meetingRequestedYesPercent"];
            this.meetingRequestedNoPercent = _data["meetingRequestedNoPercent"];
            this.meetingRequestedNotSelectedPercent = _data["meetingRequestedNotSelectedPercent"];
        }
    }

    static fromJS(data: any): ProposalGraphDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalGraphDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voteForPercent"] = this.voteForPercent;
        data["voteAgainstPercent"] = this.voteAgainstPercent;
        data["voteDidNotVotePercent"] = this.voteDidNotVotePercent;
        data["meetingRequestedYesPercent"] = this.meetingRequestedYesPercent;
        data["meetingRequestedNoPercent"] = this.meetingRequestedNoPercent;
        data["meetingRequestedNotSelectedPercent"] = this.meetingRequestedNotSelectedPercent;
        return data;
    }
}

export interface IProposalGraphDataDto {
    voteForPercent?: number | undefined;
    voteAgainstPercent?: number | undefined;
    voteDidNotVotePercent?: number | undefined;
    meetingRequestedYesPercent?: number | undefined;
    meetingRequestedNoPercent?: number | undefined;
    meetingRequestedNotSelectedPercent?: number | undefined;
}

export class ProposalInfoDto implements IProposalInfoDto {
    proposalProcessStatusId?: string;
    proposalProcessStatus?: string | undefined;
    proposalStateId?: string | undefined;
    paymentStatusId?: string | undefined;
    paymentStatusOptions?: LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[] | undefined;
    totalSOA?: number | undefined;
    totalClaim?: number | undefined;
    approvalStatus?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    courtApprovalDate?: moment.Moment | undefined;
    fourtyFifthDay?: moment.Moment | undefined;
    reviewDueDate?: moment.Moment | undefined;
    proposalStatus?: string | undefined;
    dateOfAnnulment?: moment.Moment | undefined;
    numWarnings?: number | undefined;
    hasBeenCourtRevival?: boolean;
    hasBeenDeemedAnnulled?: boolean;
    form56DocumentId?: string | undefined;
    form56FilingDate?: moment.Moment | undefined;
    hasBeenRevivalWarranted?: boolean;
    form93DocumentId?: string | undefined;
    form93FilingDate?: moment.Moment | undefined;
    hasBeenOpposed?: boolean;
    form95DocumentId?: string | undefined;
    form95FilingDate?: moment.Moment | undefined;
    hasBeenAutoRevival?: boolean;
    form96DocumentId?: string | undefined;
    form96FilingDate?: moment.Moment | undefined;
    courtRevived?: boolean;

    constructor(data?: IProposalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalProcessStatusId = _data["proposalProcessStatusId"];
            this.proposalProcessStatus = _data["proposalProcessStatus"];
            this.proposalStateId = _data["proposalStateId"];
            this.paymentStatusId = _data["paymentStatusId"];
            if (Array.isArray(_data["paymentStatusOptions"])) {
                this.paymentStatusOptions = [] as any;
                for (let item of _data["paymentStatusOptions"])
                    this.paymentStatusOptions!.push(LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            this.totalSOA = _data["totalSOA"];
            this.totalClaim = _data["totalClaim"];
            this.approvalStatus = _data["approvalStatus"];
            this.insolvencyDate = _data["insolvencyDate"] ? moment(_data["insolvencyDate"].toString()) : <any>undefined;
            this.courtApprovalDate = _data["courtApprovalDate"] ? moment(_data["courtApprovalDate"].toString()) : <any>undefined;
            this.fourtyFifthDay = _data["fourtyFifthDay"] ? moment(_data["fourtyFifthDay"].toString()) : <any>undefined;
            this.reviewDueDate = _data["reviewDueDate"] ? moment(_data["reviewDueDate"].toString()) : <any>undefined;
            this.proposalStatus = _data["proposalStatus"];
            this.dateOfAnnulment = _data["dateOfAnnulment"] ? moment(_data["dateOfAnnulment"].toString()) : <any>undefined;
            this.numWarnings = _data["numWarnings"];
            this.hasBeenCourtRevival = _data["hasBeenCourtRevival"];
            this.hasBeenDeemedAnnulled = _data["hasBeenDeemedAnnulled"];
            this.form56DocumentId = _data["form56DocumentId"];
            this.form56FilingDate = _data["form56FilingDate"] ? moment(_data["form56FilingDate"].toString()) : <any>undefined;
            this.hasBeenRevivalWarranted = _data["hasBeenRevivalWarranted"];
            this.form93DocumentId = _data["form93DocumentId"];
            this.form93FilingDate = _data["form93FilingDate"] ? moment(_data["form93FilingDate"].toString()) : <any>undefined;
            this.hasBeenOpposed = _data["hasBeenOpposed"];
            this.form95DocumentId = _data["form95DocumentId"];
            this.form95FilingDate = _data["form95FilingDate"] ? moment(_data["form95FilingDate"].toString()) : <any>undefined;
            this.hasBeenAutoRevival = _data["hasBeenAutoRevival"];
            this.form96DocumentId = _data["form96DocumentId"];
            this.form96FilingDate = _data["form96FilingDate"] ? moment(_data["form96FilingDate"].toString()) : <any>undefined;
            this.courtRevived = _data["courtRevived"];
        }
    }

    static fromJS(data: any): ProposalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalProcessStatusId"] = this.proposalProcessStatusId;
        data["proposalProcessStatus"] = this.proposalProcessStatus;
        data["proposalStateId"] = this.proposalStateId;
        data["paymentStatusId"] = this.paymentStatusId;
        if (Array.isArray(this.paymentStatusOptions)) {
            data["paymentStatusOptions"] = [];
            for (let item of this.paymentStatusOptions)
                data["paymentStatusOptions"].push(item.toJSON());
        }
        data["totalSOA"] = this.totalSOA;
        data["totalClaim"] = this.totalClaim;
        data["approvalStatus"] = this.approvalStatus;
        data["insolvencyDate"] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
        data["courtApprovalDate"] = this.courtApprovalDate ? this.courtApprovalDate.toISOString() : <any>undefined;
        data["fourtyFifthDay"] = this.fourtyFifthDay ? this.fourtyFifthDay.toISOString() : <any>undefined;
        data["reviewDueDate"] = this.reviewDueDate ? this.reviewDueDate.toISOString() : <any>undefined;
        data["proposalStatus"] = this.proposalStatus;
        data["dateOfAnnulment"] = this.dateOfAnnulment ? this.dateOfAnnulment.toISOString() : <any>undefined;
        data["numWarnings"] = this.numWarnings;
        data["hasBeenCourtRevival"] = this.hasBeenCourtRevival;
        data["hasBeenDeemedAnnulled"] = this.hasBeenDeemedAnnulled;
        data["form56DocumentId"] = this.form56DocumentId;
        data["form56FilingDate"] = this.form56FilingDate ? this.form56FilingDate.toISOString() : <any>undefined;
        data["hasBeenRevivalWarranted"] = this.hasBeenRevivalWarranted;
        data["form93DocumentId"] = this.form93DocumentId;
        data["form93FilingDate"] = this.form93FilingDate ? this.form93FilingDate.toISOString() : <any>undefined;
        data["hasBeenOpposed"] = this.hasBeenOpposed;
        data["form95DocumentId"] = this.form95DocumentId;
        data["form95FilingDate"] = this.form95FilingDate ? this.form95FilingDate.toISOString() : <any>undefined;
        data["hasBeenAutoRevival"] = this.hasBeenAutoRevival;
        data["form96DocumentId"] = this.form96DocumentId;
        data["form96FilingDate"] = this.form96FilingDate ? this.form96FilingDate.toISOString() : <any>undefined;
        data["courtRevived"] = this.courtRevived;
        return data;
    }
}

export interface IProposalInfoDto {
    proposalProcessStatusId?: string;
    proposalProcessStatus?: string | undefined;
    proposalStateId?: string | undefined;
    paymentStatusId?: string | undefined;
    paymentStatusOptions?: LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[] | undefined;
    totalSOA?: number | undefined;
    totalClaim?: number | undefined;
    approvalStatus?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    courtApprovalDate?: moment.Moment | undefined;
    fourtyFifthDay?: moment.Moment | undefined;
    reviewDueDate?: moment.Moment | undefined;
    proposalStatus?: string | undefined;
    dateOfAnnulment?: moment.Moment | undefined;
    numWarnings?: number | undefined;
    hasBeenCourtRevival?: boolean;
    hasBeenDeemedAnnulled?: boolean;
    form56DocumentId?: string | undefined;
    form56FilingDate?: moment.Moment | undefined;
    hasBeenRevivalWarranted?: boolean;
    form93DocumentId?: string | undefined;
    form93FilingDate?: moment.Moment | undefined;
    hasBeenOpposed?: boolean;
    form95DocumentId?: string | undefined;
    form95FilingDate?: moment.Moment | undefined;
    hasBeenAutoRevival?: boolean;
    form96DocumentId?: string | undefined;
    form96FilingDate?: moment.Moment | undefined;
    courtRevived?: boolean;
}

export class ProposalStatusUpdateDto implements IProposalStatusUpdateDto {
    fileId?: string;
    proposalProcessStatusId?: string;
    proposalStateId?: string | undefined;
    paymentStatusId?: string | undefined;

    constructor(data?: IProposalStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.proposalProcessStatusId = _data["proposalProcessStatusId"];
            this.proposalStateId = _data["proposalStateId"];
            this.paymentStatusId = _data["paymentStatusId"];
        }
    }

    static fromJS(data: any): ProposalStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProposalStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["proposalProcessStatusId"] = this.proposalProcessStatusId;
        data["proposalStateId"] = this.proposalStateId;
        data["paymentStatusId"] = this.paymentStatusId;
        return data;
    }
}

export interface IProposalStatusUpdateDto {
    fileId?: string;
    proposalProcessStatusId?: string;
    proposalStateId?: string | undefined;
    paymentStatusId?: string | undefined;
}

export class ReceiptCreateDto implements IReceiptCreateDto {
    fileId!: string;
    officeLocationId?: string;
    paymentDate?: moment.Moment | undefined;
    paymentAmount?: number;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;
    agentId?: string | undefined;

    constructor(data?: IReceiptCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.officeLocationId = _data["officeLocationId"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
            this.paymentMadeBy = _data["paymentMadeBy"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodDetail = _data["paymentMethodDetail"];
            this.cashPaymentDenominationCents = _data["cashPaymentDenominationCents"];
            this.cashPaymentDenominationOnes = _data["cashPaymentDenominationOnes"];
            this.cashPaymentDenominationTwos = _data["cashPaymentDenominationTwos"];
            this.cashPaymentDenominationFives = _data["cashPaymentDenominationFives"];
            this.cashPaymentDenominationTens = _data["cashPaymentDenominationTens"];
            this.cashPaymentDenominationTwenties = _data["cashPaymentDenominationTwenties"];
            this.cashPaymentDenominationFifties = _data["cashPaymentDenominationFifties"];
            this.cashPaymentDenominationHundreds = _data["cashPaymentDenominationHundreds"];
            this.postType = _data["postType"];
            this.receiptType = _data["receiptType"];
            this.padScheduleId = _data["padScheduleId"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): ReceiptCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["officeLocationId"] = this.officeLocationId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentMadeBy"] = this.paymentMadeBy;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodDetail"] = this.paymentMethodDetail;
        data["cashPaymentDenominationCents"] = this.cashPaymentDenominationCents;
        data["cashPaymentDenominationOnes"] = this.cashPaymentDenominationOnes;
        data["cashPaymentDenominationTwos"] = this.cashPaymentDenominationTwos;
        data["cashPaymentDenominationFives"] = this.cashPaymentDenominationFives;
        data["cashPaymentDenominationTens"] = this.cashPaymentDenominationTens;
        data["cashPaymentDenominationTwenties"] = this.cashPaymentDenominationTwenties;
        data["cashPaymentDenominationFifties"] = this.cashPaymentDenominationFifties;
        data["cashPaymentDenominationHundreds"] = this.cashPaymentDenominationHundreds;
        data["postType"] = this.postType;
        data["receiptType"] = this.receiptType;
        data["padScheduleId"] = this.padScheduleId;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IReceiptCreateDto {
    fileId: string;
    officeLocationId?: string;
    paymentDate?: moment.Moment | undefined;
    paymentAmount?: number;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;
    agentId?: string | undefined;
}

export class ReceiptDto implements IReceiptDto {
    id?: string;
    fileId?: string;
    debtorName?: string | undefined;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    per?: string | undefined;
    officeLocationId?: string;
    officeLocationName?: string | undefined;
    paymentAmount?: number | undefined;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    isVoided?: boolean;
    voidedDate?: moment.Moment | undefined;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;
    agentId?: string | undefined;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.debtorName = _data["debtorName"];
            this.receiptNumber = _data["receiptNumber"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.per = _data["per"];
            this.officeLocationId = _data["officeLocationId"];
            this.officeLocationName = _data["officeLocationName"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentMadeBy = _data["paymentMadeBy"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodDetail = _data["paymentMethodDetail"];
            this.cashPaymentDenominationCents = _data["cashPaymentDenominationCents"];
            this.cashPaymentDenominationOnes = _data["cashPaymentDenominationOnes"];
            this.cashPaymentDenominationTwos = _data["cashPaymentDenominationTwos"];
            this.cashPaymentDenominationFives = _data["cashPaymentDenominationFives"];
            this.cashPaymentDenominationTens = _data["cashPaymentDenominationTens"];
            this.cashPaymentDenominationTwenties = _data["cashPaymentDenominationTwenties"];
            this.cashPaymentDenominationFifties = _data["cashPaymentDenominationFifties"];
            this.cashPaymentDenominationHundreds = _data["cashPaymentDenominationHundreds"];
            this.postType = _data["postType"];
            this.isVoided = _data["isVoided"];
            this.voidedDate = _data["voidedDate"] ? moment(_data["voidedDate"].toString()) : <any>undefined;
            this.receiptType = _data["receiptType"];
            this.padScheduleId = _data["padScheduleId"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["debtorName"] = this.debtorName;
        data["receiptNumber"] = this.receiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["per"] = this.per;
        data["officeLocationId"] = this.officeLocationId;
        data["officeLocationName"] = this.officeLocationName;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentMadeBy"] = this.paymentMadeBy;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodDetail"] = this.paymentMethodDetail;
        data["cashPaymentDenominationCents"] = this.cashPaymentDenominationCents;
        data["cashPaymentDenominationOnes"] = this.cashPaymentDenominationOnes;
        data["cashPaymentDenominationTwos"] = this.cashPaymentDenominationTwos;
        data["cashPaymentDenominationFives"] = this.cashPaymentDenominationFives;
        data["cashPaymentDenominationTens"] = this.cashPaymentDenominationTens;
        data["cashPaymentDenominationTwenties"] = this.cashPaymentDenominationTwenties;
        data["cashPaymentDenominationFifties"] = this.cashPaymentDenominationFifties;
        data["cashPaymentDenominationHundreds"] = this.cashPaymentDenominationHundreds;
        data["postType"] = this.postType;
        data["isVoided"] = this.isVoided;
        data["voidedDate"] = this.voidedDate ? this.voidedDate.toISOString() : <any>undefined;
        data["receiptType"] = this.receiptType;
        data["padScheduleId"] = this.padScheduleId;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IReceiptDto {
    id?: string;
    fileId?: string;
    debtorName?: string | undefined;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    per?: string | undefined;
    officeLocationId?: string;
    officeLocationName?: string | undefined;
    paymentAmount?: number | undefined;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    isVoided?: boolean;
    voidedDate?: moment.Moment | undefined;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;
    agentId?: string | undefined;
}

export class ReceiptPublicDto implements IReceiptPublicDto {
    id?: string;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    paymentAmount?: number | undefined;

    constructor(data?: IReceiptPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receiptNumber = _data["receiptNumber"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): ReceiptPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receiptNumber"] = this.receiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IReceiptPublicDto {
    id?: string;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    paymentAmount?: number | undefined;
}

export class ReceiptUpdateDto implements IReceiptUpdateDto {
    fileId!: string;
    officeLocationId?: string;
    paymentDate?: moment.Moment | undefined;
    paymentAmount?: number;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;

    constructor(data?: IReceiptUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.officeLocationId = _data["officeLocationId"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
            this.paymentMadeBy = _data["paymentMadeBy"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodDetail = _data["paymentMethodDetail"];
            this.cashPaymentDenominationCents = _data["cashPaymentDenominationCents"];
            this.cashPaymentDenominationOnes = _data["cashPaymentDenominationOnes"];
            this.cashPaymentDenominationTwos = _data["cashPaymentDenominationTwos"];
            this.cashPaymentDenominationFives = _data["cashPaymentDenominationFives"];
            this.cashPaymentDenominationTens = _data["cashPaymentDenominationTens"];
            this.cashPaymentDenominationTwenties = _data["cashPaymentDenominationTwenties"];
            this.cashPaymentDenominationFifties = _data["cashPaymentDenominationFifties"];
            this.cashPaymentDenominationHundreds = _data["cashPaymentDenominationHundreds"];
            this.postType = _data["postType"];
            this.receiptType = _data["receiptType"];
            this.padScheduleId = _data["padScheduleId"];
        }
    }

    static fromJS(data: any): ReceiptUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["officeLocationId"] = this.officeLocationId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentMadeBy"] = this.paymentMadeBy;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodDetail"] = this.paymentMethodDetail;
        data["cashPaymentDenominationCents"] = this.cashPaymentDenominationCents;
        data["cashPaymentDenominationOnes"] = this.cashPaymentDenominationOnes;
        data["cashPaymentDenominationTwos"] = this.cashPaymentDenominationTwos;
        data["cashPaymentDenominationFives"] = this.cashPaymentDenominationFives;
        data["cashPaymentDenominationTens"] = this.cashPaymentDenominationTens;
        data["cashPaymentDenominationTwenties"] = this.cashPaymentDenominationTwenties;
        data["cashPaymentDenominationFifties"] = this.cashPaymentDenominationFifties;
        data["cashPaymentDenominationHundreds"] = this.cashPaymentDenominationHundreds;
        data["postType"] = this.postType;
        data["receiptType"] = this.receiptType;
        data["padScheduleId"] = this.padScheduleId;
        return data;
    }
}

export interface IReceiptUpdateDto {
    fileId: string;
    officeLocationId?: string;
    paymentDate?: moment.Moment | undefined;
    paymentAmount?: number;
    paymentMadeBy?: string | undefined;
    paymentMethod?: ReceiptPaymentMethodEnum;
    paymentMethodDetail?: string | undefined;
    cashPaymentDenominationCents?: number;
    cashPaymentDenominationOnes?: number;
    cashPaymentDenominationTwos?: number;
    cashPaymentDenominationFives?: number;
    cashPaymentDenominationTens?: number;
    cashPaymentDenominationTwenties?: number;
    cashPaymentDenominationFifties?: number;
    cashPaymentDenominationHundreds?: number;
    postType?: ReceiptPostTypeEnum;
    receiptType?: ReceiptTypeEnum;
    padScheduleId?: string | undefined;
}

export class AdminInfoReceiptsDisbursementsDto implements IAdminInfoReceiptsDisbursementsDto {
    receiptsDisbursementsProcessStatus?: FileProcessStatusEnum;
    isProcessAllowedToBeCompleted?: boolean;

    constructor(data?: IAdminInfoReceiptsDisbursementsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptsDisbursementsProcessStatus = _data["receiptsDisbursementsProcessStatus"];
            this.isProcessAllowedToBeCompleted = _data["isProcessAllowedToBeCompleted"];
        }
    }

    static fromJS(data: any): AdminInfoReceiptsDisbursementsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoReceiptsDisbursementsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptsDisbursementsProcessStatus"] = this.receiptsDisbursementsProcessStatus;
        data["isProcessAllowedToBeCompleted"] = this.isProcessAllowedToBeCompleted;
        return data;
    }
}

export interface IAdminInfoReceiptsDisbursementsDto {
    receiptsDisbursementsProcessStatus?: FileProcessStatusEnum;
    isProcessAllowedToBeCompleted?: boolean;
}

export class FileReceiptsDisbursementsFormDto implements IFileReceiptsDisbursementsFormDto {
    id?: string;
    thirtyDaysNotice?: boolean;
    isCertificateOfFullPerformanceUploaded?: boolean;
    isCertificateOfFullPerformanceShared?: boolean;
    certificateOfFullPerformanceFilingDate?: moment.Moment | undefined;
    isSRDReportUploaded?: boolean;
    isSRDReportShared?: boolean;
    srdReportFilingDate?: moment.Moment | undefined;
    isForm58Uploaded?: boolean;
    isForm58Shared?: boolean;
    form58FilingDate?: moment.Moment | undefined;
    isDividendChecklistUploaded?: boolean;
    isDividendChecklistShared?: boolean;
    isSRDChecklistUploaded?: boolean;
    isSRDChecklistShared?: boolean;
    isForm16Uploaded?: boolean;
    isForm16Shared?: boolean;
    form16FilingDate?: moment.Moment | undefined;
    isForm15Uploaded?: boolean;
    isForm15Shared?: boolean;
    form15FilingDate?: moment.Moment | undefined;
    isTrusteeDischarged?: boolean | undefined;
    isFileClosed?: boolean | undefined;

    constructor(data?: IFileReceiptsDisbursementsFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.thirtyDaysNotice = _data["thirtyDaysNotice"];
            this.isCertificateOfFullPerformanceUploaded = _data["isCertificateOfFullPerformanceUploaded"];
            this.isCertificateOfFullPerformanceShared = _data["isCertificateOfFullPerformanceShared"];
            this.certificateOfFullPerformanceFilingDate = _data["certificateOfFullPerformanceFilingDate"] ? moment(_data["certificateOfFullPerformanceFilingDate"].toString()) : <any>undefined;
            this.isSRDReportUploaded = _data["isSRDReportUploaded"];
            this.isSRDReportShared = _data["isSRDReportShared"];
            this.srdReportFilingDate = _data["srdReportFilingDate"] ? moment(_data["srdReportFilingDate"].toString()) : <any>undefined;
            this.isForm58Uploaded = _data["isForm58Uploaded"];
            this.isForm58Shared = _data["isForm58Shared"];
            this.form58FilingDate = _data["form58FilingDate"] ? moment(_data["form58FilingDate"].toString()) : <any>undefined;
            this.isDividendChecklistUploaded = _data["isDividendChecklistUploaded"];
            this.isDividendChecklistShared = _data["isDividendChecklistShared"];
            this.isSRDChecklistUploaded = _data["isSRDChecklistUploaded"];
            this.isSRDChecklistShared = _data["isSRDChecklistShared"];
            this.isForm16Uploaded = _data["isForm16Uploaded"];
            this.isForm16Shared = _data["isForm16Shared"];
            this.form16FilingDate = _data["form16FilingDate"] ? moment(_data["form16FilingDate"].toString()) : <any>undefined;
            this.isForm15Uploaded = _data["isForm15Uploaded"];
            this.isForm15Shared = _data["isForm15Shared"];
            this.form15FilingDate = _data["form15FilingDate"] ? moment(_data["form15FilingDate"].toString()) : <any>undefined;
            this.isTrusteeDischarged = _data["isTrusteeDischarged"];
            this.isFileClosed = _data["isFileClosed"];
        }
    }

    static fromJS(data: any): FileReceiptsDisbursementsFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReceiptsDisbursementsFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["thirtyDaysNotice"] = this.thirtyDaysNotice;
        data["isCertificateOfFullPerformanceUploaded"] = this.isCertificateOfFullPerformanceUploaded;
        data["isCertificateOfFullPerformanceShared"] = this.isCertificateOfFullPerformanceShared;
        data["certificateOfFullPerformanceFilingDate"] = this.certificateOfFullPerformanceFilingDate ? this.certificateOfFullPerformanceFilingDate.toISOString() : <any>undefined;
        data["isSRDReportUploaded"] = this.isSRDReportUploaded;
        data["isSRDReportShared"] = this.isSRDReportShared;
        data["srdReportFilingDate"] = this.srdReportFilingDate ? this.srdReportFilingDate.toISOString() : <any>undefined;
        data["isForm58Uploaded"] = this.isForm58Uploaded;
        data["isForm58Shared"] = this.isForm58Shared;
        data["form58FilingDate"] = this.form58FilingDate ? this.form58FilingDate.toISOString() : <any>undefined;
        data["isDividendChecklistUploaded"] = this.isDividendChecklistUploaded;
        data["isDividendChecklistShared"] = this.isDividendChecklistShared;
        data["isSRDChecklistUploaded"] = this.isSRDChecklistUploaded;
        data["isSRDChecklistShared"] = this.isSRDChecklistShared;
        data["isForm16Uploaded"] = this.isForm16Uploaded;
        data["isForm16Shared"] = this.isForm16Shared;
        data["form16FilingDate"] = this.form16FilingDate ? this.form16FilingDate.toISOString() : <any>undefined;
        data["isForm15Uploaded"] = this.isForm15Uploaded;
        data["isForm15Shared"] = this.isForm15Shared;
        data["form15FilingDate"] = this.form15FilingDate ? this.form15FilingDate.toISOString() : <any>undefined;
        data["isTrusteeDischarged"] = this.isTrusteeDischarged;
        data["isFileClosed"] = this.isFileClosed;
        return data;
    }
}

export interface IFileReceiptsDisbursementsFormDto {
    id?: string;
    thirtyDaysNotice?: boolean;
    isCertificateOfFullPerformanceUploaded?: boolean;
    isCertificateOfFullPerformanceShared?: boolean;
    certificateOfFullPerformanceFilingDate?: moment.Moment | undefined;
    isSRDReportUploaded?: boolean;
    isSRDReportShared?: boolean;
    srdReportFilingDate?: moment.Moment | undefined;
    isForm58Uploaded?: boolean;
    isForm58Shared?: boolean;
    form58FilingDate?: moment.Moment | undefined;
    isDividendChecklistUploaded?: boolean;
    isDividendChecklistShared?: boolean;
    isSRDChecklistUploaded?: boolean;
    isSRDChecklistShared?: boolean;
    isForm16Uploaded?: boolean;
    isForm16Shared?: boolean;
    form16FilingDate?: moment.Moment | undefined;
    isForm15Uploaded?: boolean;
    isForm15Shared?: boolean;
    form15FilingDate?: moment.Moment | undefined;
    isTrusteeDischarged?: boolean | undefined;
    isFileClosed?: boolean | undefined;
}

export class FileReceiptsDisbursementsFormUpdateDto implements IFileReceiptsDisbursementsFormUpdateDto {
    id?: string;
    isTrusteeDischarged?: boolean | undefined;
    isFileClosed?: boolean | undefined;

    constructor(data?: IFileReceiptsDisbursementsFormUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isTrusteeDischarged = _data["isTrusteeDischarged"];
            this.isFileClosed = _data["isFileClosed"];
        }
    }

    static fromJS(data: any): FileReceiptsDisbursementsFormUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileReceiptsDisbursementsFormUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isTrusteeDischarged"] = this.isTrusteeDischarged;
        data["isFileClosed"] = this.isFileClosed;
        return data;
    }
}

export interface IFileReceiptsDisbursementsFormUpdateDto {
    id?: string;
    isTrusteeDischarged?: boolean | undefined;
    isFileClosed?: boolean | undefined;
}

export class ReceiptsDisbursementsFilingDateUpdateDto implements IReceiptsDisbursementsFilingDateUpdateDto {
    id?: string;
    date?: moment.Moment;
    documentPrefixCode?: string | undefined;

    constructor(data?: IReceiptsDisbursementsFilingDateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.documentPrefixCode = _data["documentPrefixCode"];
        }
    }

    static fromJS(data: any): ReceiptsDisbursementsFilingDateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptsDisbursementsFilingDateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentPrefixCode"] = this.documentPrefixCode;
        return data;
    }
}

export interface IReceiptsDisbursementsFilingDateUpdateDto {
    id?: string;
    date?: moment.Moment;
    documentPrefixCode?: string | undefined;
}

export class DebtorConversionDto implements IDebtorConversionDto {
    office?: GroupByOfficeDto[] | undefined;
    estateAdmin?: GroupByEstateAdminDto[] | undefined;
    trustee?: GroupByTrusteeDto[] | undefined;

    constructor(data?: IDebtorConversionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["office"])) {
                this.office = [] as any;
                for (let item of _data["office"])
                    this.office!.push(GroupByOfficeDto.fromJS(item));
            }
            if (Array.isArray(_data["estateAdmin"])) {
                this.estateAdmin = [] as any;
                for (let item of _data["estateAdmin"])
                    this.estateAdmin!.push(GroupByEstateAdminDto.fromJS(item));
            }
            if (Array.isArray(_data["trustee"])) {
                this.trustee = [] as any;
                for (let item of _data["trustee"])
                    this.trustee!.push(GroupByTrusteeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DebtorConversionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorConversionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.office)) {
            data["office"] = [];
            for (let item of this.office)
                data["office"].push(item.toJSON());
        }
        if (Array.isArray(this.estateAdmin)) {
            data["estateAdmin"] = [];
            for (let item of this.estateAdmin)
                data["estateAdmin"].push(item.toJSON());
        }
        if (Array.isArray(this.trustee)) {
            data["trustee"] = [];
            for (let item of this.trustee)
                data["trustee"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDebtorConversionDto {
    office?: GroupByOfficeDto[] | undefined;
    estateAdmin?: GroupByEstateAdminDto[] | undefined;
    trustee?: GroupByTrusteeDto[] | undefined;
}

export class GroupByEstateAdminDto implements IGroupByEstateAdminDto {
    id?: string;
    estateAdmin?: string | undefined;
    office?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;

    constructor(data?: IGroupByEstateAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.estateAdmin = _data["estateAdmin"];
            this.office = _data["office"];
            this.numberofFiles = _data["numberofFiles"];
            this.pendingConfirmation = _data["pendingConfirmation"];
            this.pendingConfirmationConversionRate = _data["pendingConfirmationConversionRate"];
            this.filesSigned = _data["filesSigned"];
            this.filesSignedConversionRate = _data["filesSignedConversionRate"];
            this.signupInProgress = _data["signupInProgress"];
            this.signupInProgressConversionRate = _data["signupInProgressConversionRate"];
        }
    }

    static fromJS(data: any): GroupByEstateAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupByEstateAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["estateAdmin"] = this.estateAdmin;
        data["office"] = this.office;
        data["numberofFiles"] = this.numberofFiles;
        data["pendingConfirmation"] = this.pendingConfirmation;
        data["pendingConfirmationConversionRate"] = this.pendingConfirmationConversionRate;
        data["filesSigned"] = this.filesSigned;
        data["filesSignedConversionRate"] = this.filesSignedConversionRate;
        data["signupInProgress"] = this.signupInProgress;
        data["signupInProgressConversionRate"] = this.signupInProgressConversionRate;
        return data;
    }
}

export interface IGroupByEstateAdminDto {
    id?: string;
    estateAdmin?: string | undefined;
    office?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;
}

export class GroupByOfficeDto implements IGroupByOfficeDto {
    id?: string;
    office?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;

    constructor(data?: IGroupByOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.office = _data["office"];
            this.numberofFiles = _data["numberofFiles"];
            this.pendingConfirmation = _data["pendingConfirmation"];
            this.pendingConfirmationConversionRate = _data["pendingConfirmationConversionRate"];
            this.filesSigned = _data["filesSigned"];
            this.filesSignedConversionRate = _data["filesSignedConversionRate"];
            this.signupInProgress = _data["signupInProgress"];
            this.signupInProgressConversionRate = _data["signupInProgressConversionRate"];
        }
    }

    static fromJS(data: any): GroupByOfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupByOfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["office"] = this.office;
        data["numberofFiles"] = this.numberofFiles;
        data["pendingConfirmation"] = this.pendingConfirmation;
        data["pendingConfirmationConversionRate"] = this.pendingConfirmationConversionRate;
        data["filesSigned"] = this.filesSigned;
        data["filesSignedConversionRate"] = this.filesSignedConversionRate;
        data["signupInProgress"] = this.signupInProgress;
        data["signupInProgressConversionRate"] = this.signupInProgressConversionRate;
        return data;
    }
}

export interface IGroupByOfficeDto {
    id?: string;
    office?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;
}

export class GroupByTrusteeDto implements IGroupByTrusteeDto {
    id?: string;
    trustee?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;

    constructor(data?: IGroupByTrusteeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trustee = _data["trustee"];
            this.numberofFiles = _data["numberofFiles"];
            this.pendingConfirmation = _data["pendingConfirmation"];
            this.pendingConfirmationConversionRate = _data["pendingConfirmationConversionRate"];
            this.filesSigned = _data["filesSigned"];
            this.filesSignedConversionRate = _data["filesSignedConversionRate"];
            this.signupInProgress = _data["signupInProgress"];
            this.signupInProgressConversionRate = _data["signupInProgressConversionRate"];
        }
    }

    static fromJS(data: any): GroupByTrusteeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupByTrusteeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trustee"] = this.trustee;
        data["numberofFiles"] = this.numberofFiles;
        data["pendingConfirmation"] = this.pendingConfirmation;
        data["pendingConfirmationConversionRate"] = this.pendingConfirmationConversionRate;
        data["filesSigned"] = this.filesSigned;
        data["filesSignedConversionRate"] = this.filesSignedConversionRate;
        data["signupInProgress"] = this.signupInProgress;
        data["signupInProgressConversionRate"] = this.signupInProgressConversionRate;
        return data;
    }
}

export interface IGroupByTrusteeDto {
    id?: string;
    trustee?: string | undefined;
    numberofFiles?: number;
    pendingConfirmation?: number;
    pendingConfirmationConversionRate?: number;
    filesSigned?: number;
    filesSignedConversionRate?: number;
    signupInProgress?: number;
    signupInProgressConversionRate?: number;
}

export class PostAscendSyncStatusInputDto implements IPostAscendSyncStatusInputDto {
    syncId?: string | undefined;
    fileName?: string | undefined;
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IPostAscendSyncStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncId = _data["syncId"];
            this.fileName = _data["fileName"];
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PostAscendSyncStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostAscendSyncStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncId"] = this.syncId;
        data["fileName"] = this.fileName;
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPostAscendSyncStatusInputDto {
    syncId?: string | undefined;
    fileName?: string | undefined;
    isSuccess?: boolean;
    errorMessage?: string | undefined;
}

export class GetFilePhoneNumbersDto implements IGetFilePhoneNumbersDto {
    fileId?: string;
    filePhoneNumbers?: ClientPhoneDto[] | undefined;

    constructor(data?: IGetFilePhoneNumbersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            if (Array.isArray(_data["filePhoneNumbers"])) {
                this.filePhoneNumbers = [] as any;
                for (let item of _data["filePhoneNumbers"])
                    this.filePhoneNumbers!.push(ClientPhoneDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilePhoneNumbersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilePhoneNumbersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        if (Array.isArray(this.filePhoneNumbers)) {
            data["filePhoneNumbers"] = [];
            for (let item of this.filePhoneNumbers)
                data["filePhoneNumbers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilePhoneNumbersDto {
    fileId?: string;
    filePhoneNumbers?: ClientPhoneDto[] | undefined;
}

export class SMSAttributesDto implements ISMSAttributesDto {
    fileId?: string;
    phoneNumber?: string | undefined;
    smsBody?: string | undefined;
    messageTemplateBody?: string | undefined;
    templateId?: string | undefined;
    notificationKey?: string | undefined;

    constructor(data?: ISMSAttributesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.phoneNumber = _data["phoneNumber"];
            this.smsBody = _data["smsBody"];
            this.messageTemplateBody = _data["messageTemplateBody"];
            this.templateId = _data["templateId"];
            this.notificationKey = _data["notificationKey"];
        }
    }

    static fromJS(data: any): SMSAttributesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSAttributesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["phoneNumber"] = this.phoneNumber;
        data["smsBody"] = this.smsBody;
        data["messageTemplateBody"] = this.messageTemplateBody;
        data["templateId"] = this.templateId;
        data["notificationKey"] = this.notificationKey;
        return data;
    }
}

export interface ISMSAttributesDto {
    fileId?: string;
    phoneNumber?: string | undefined;
    smsBody?: string | undefined;
    messageTemplateBody?: string | undefined;
    templateId?: string | undefined;
    notificationKey?: string | undefined;
}

export class SmsResendDto implements ISmsResendDto {
    smsId?: string;

    constructor(data?: ISmsResendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsId = _data["smsId"];
        }
    }

    static fromJS(data: any): SmsResendDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsResendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsId"] = this.smsId;
        return data;
    }
}

export interface ISmsResendDto {
    smsId?: string;
}

export class ViewSMSResultDto implements IViewSMSResultDto {
    smsId?: string;
    smsBody?: string | undefined;
    sendDateTime?: moment.Moment;
    phoneNumber?: string | undefined;
    templateName?: string | undefined;

    constructor(data?: IViewSMSResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsId = _data["smsId"];
            this.smsBody = _data["smsBody"];
            this.sendDateTime = _data["sendDateTime"] ? moment(_data["sendDateTime"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): ViewSMSResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewSMSResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsId"] = this.smsId;
        data["smsBody"] = this.smsBody;
        data["sendDateTime"] = this.sendDateTime ? this.sendDateTime.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["templateName"] = this.templateName;
        return data;
    }
}

export interface IViewSMSResultDto {
    smsId?: string;
    smsBody?: string | undefined;
    sendDateTime?: moment.Moment;
    phoneNumber?: string | undefined;
    templateName?: string | undefined;
}

export class RequestDocumentDownloadCodeResultDto implements IRequestDocumentDownloadCodeResultDto {
    sent?: boolean;
    rateLimited?: boolean;
    cooldownSecondsRemaining?: number;
    expiresAt?: moment.Moment | undefined;

    constructor(data?: IRequestDocumentDownloadCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sent = _data["sent"];
            this.rateLimited = _data["rateLimited"];
            this.cooldownSecondsRemaining = _data["cooldownSecondsRemaining"];
            this.expiresAt = _data["expiresAt"] ? moment(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestDocumentDownloadCodeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDocumentDownloadCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["rateLimited"] = this.rateLimited;
        data["cooldownSecondsRemaining"] = this.cooldownSecondsRemaining;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestDocumentDownloadCodeResultDto {
    sent?: boolean;
    rateLimited?: boolean;
    cooldownSecondsRemaining?: number;
    expiresAt?: moment.Moment | undefined;
}

export class VerifyDocumentDownloadCodeInputDto implements IVerifyDocumentDownloadCodeInputDto {
    code!: string | undefined;

    constructor(data?: IVerifyDocumentDownloadCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyDocumentDownloadCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyDocumentDownloadCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifyDocumentDownloadCodeInputDto {
    code: string | undefined;
}

export class VerifyDocumentDownloadCodeResultDto implements IVerifyDocumentDownloadCodeResultDto {
    success?: boolean;
    token?: string | undefined;
    errorCode?: string | undefined;
    attemptsRemaining?: number;

    constructor(data?: IVerifyDocumentDownloadCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.token = _data["token"];
            this.errorCode = _data["errorCode"];
            this.attemptsRemaining = _data["attemptsRemaining"];
        }
    }

    static fromJS(data: any): VerifyDocumentDownloadCodeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyDocumentDownloadCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["token"] = this.token;
        data["errorCode"] = this.errorCode;
        data["attemptsRemaining"] = this.attemptsRemaining;
        return data;
    }
}

export interface IVerifyDocumentDownloadCodeResultDto {
    success?: boolean;
    token?: string | undefined;
    errorCode?: string | undefined;
    attemptsRemaining?: number;
}

export class AgentSignatureDto implements IAgentSignatureDto {
    id?: string;
    agentId?: string;
    signature?: string | undefined;
    signatureSize?: number;

    constructor(data?: IAgentSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agentId = _data["agentId"];
            this.signature = _data["signature"];
            this.signatureSize = _data["signatureSize"];
        }
    }

    static fromJS(data: any): AgentSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agentId"] = this.agentId;
        data["signature"] = this.signature;
        data["signatureSize"] = this.signatureSize;
        return data;
    }
}

export interface IAgentSignatureDto {
    id?: string;
    agentId?: string;
    signature?: string | undefined;
    signatureSize?: number;
}

export class SupportingDocumentApplicabilityOverrideDto implements ISupportingDocumentApplicabilityOverrideDto {
    fileId?: string;
    documentFolderId?: string;
    supportingDocumentApplicabilityOverrideItems?: SupportingDocumentApplicabilityOverrideItemDto[] | undefined;

    constructor(data?: ISupportingDocumentApplicabilityOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.documentFolderId = _data["documentFolderId"];
            if (Array.isArray(_data["supportingDocumentApplicabilityOverrideItems"])) {
                this.supportingDocumentApplicabilityOverrideItems = [] as any;
                for (let item of _data["supportingDocumentApplicabilityOverrideItems"])
                    this.supportingDocumentApplicabilityOverrideItems!.push(SupportingDocumentApplicabilityOverrideItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupportingDocumentApplicabilityOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentApplicabilityOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["documentFolderId"] = this.documentFolderId;
        if (Array.isArray(this.supportingDocumentApplicabilityOverrideItems)) {
            data["supportingDocumentApplicabilityOverrideItems"] = [];
            for (let item of this.supportingDocumentApplicabilityOverrideItems)
                data["supportingDocumentApplicabilityOverrideItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupportingDocumentApplicabilityOverrideDto {
    fileId?: string;
    documentFolderId?: string;
    supportingDocumentApplicabilityOverrideItems?: SupportingDocumentApplicabilityOverrideItemDto[] | undefined;
}

export class SupportingDocumentApplicabilityOverrideItemDto implements ISupportingDocumentApplicabilityOverrideItemDto {
    documentPrefixId?: string;
    overrideReason?: string | undefined;
    isDisabled?: boolean | undefined;

    constructor(data?: ISupportingDocumentApplicabilityOverrideItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentPrefixId = _data["documentPrefixId"];
            this.overrideReason = _data["overrideReason"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): SupportingDocumentApplicabilityOverrideItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentApplicabilityOverrideItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentPrefixId"] = this.documentPrefixId;
        data["overrideReason"] = this.overrideReason;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface ISupportingDocumentApplicabilityOverrideItemDto {
    documentPrefixId?: string;
    overrideReason?: string | undefined;
    isDisabled?: boolean | undefined;
}

export class SupportingDocumentDocumentPrefixDto implements ISupportingDocumentDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    frenchName?: string | undefined;
    documentPrefixCode?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;

    constructor(data?: ISupportingDocumentDocumentPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentPrefixName = _data["documentPrefixName"];
            this.frenchName = _data["frenchName"];
            this.documentPrefixCode = _data["documentPrefixCode"];
            this.isCustom = _data["isCustom"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SupportingDocumentDocumentPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentDocumentPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentPrefixName"] = this.documentPrefixName;
        data["frenchName"] = this.frenchName;
        data["documentPrefixCode"] = this.documentPrefixCode;
        data["isCustom"] = this.isCustom;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISupportingDocumentDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    frenchName?: string | undefined;
    documentPrefixCode?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;
}

export class SupportingDocumentDocumentReviewStatusUpdateDto implements ISupportingDocumentDocumentReviewStatusUpdateDto {
    documentId?: string;
    isReviewed?: boolean;

    constructor(data?: ISupportingDocumentDocumentReviewStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.isReviewed = _data["isReviewed"];
        }
    }

    static fromJS(data: any): SupportingDocumentDocumentReviewStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentDocumentReviewStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["isReviewed"] = this.isReviewed;
        return data;
    }
}

export interface ISupportingDocumentDocumentReviewStatusUpdateDto {
    documentId?: string;
    isReviewed?: boolean;
}

export class SupportingDocumentDocumentUpdateDto implements ISupportingDocumentDocumentUpdateDto {
    supportingDocumentId?: string;
    documentIds?: string[] | undefined;

    constructor(data?: ISupportingDocumentDocumentUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportingDocumentId = _data["supportingDocumentId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SupportingDocumentDocumentUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentDocumentUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportingDocumentId"] = this.supportingDocumentId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface ISupportingDocumentDocumentUpdateDto {
    supportingDocumentId?: string;
    documentIds?: string[] | undefined;
}

export class SupportingDocumentDto implements ISupportingDocumentDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentSize?: number | undefined;
    documentFormat?: string | undefined;
    documentId?: string;
    uploadDate?: moment.Moment | undefined;
    id?: string;
    supportingDocumentType?: SupportingDocumentType;
    documentPrefixes?: DocumentPrefixDto[] | undefined;
    supportingDocumentStatus?: SupportingDocumentStatusEnum;

    constructor(data?: ISupportingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data["detail"];
            this.documentName = _data["documentName"];
            this.frenchName = _data["frenchName"];
            this.documentSize = _data["documentSize"];
            this.documentFormat = _data["documentFormat"];
            this.documentId = _data["documentId"];
            this.uploadDate = _data["uploadDate"] ? moment(_data["uploadDate"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.supportingDocumentType = _data["supportingDocumentType"] ? SupportingDocumentType.fromJS(_data["supportingDocumentType"]) : <any>undefined;
            if (Array.isArray(_data["documentPrefixes"])) {
                this.documentPrefixes = [] as any;
                for (let item of _data["documentPrefixes"])
                    this.documentPrefixes!.push(DocumentPrefixDto.fromJS(item));
            }
            this.supportingDocumentStatus = _data["supportingDocumentStatus"];
        }
    }

    static fromJS(data: any): SupportingDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detail"] = this.detail;
        data["documentName"] = this.documentName;
        data["frenchName"] = this.frenchName;
        data["documentSize"] = this.documentSize;
        data["documentFormat"] = this.documentFormat;
        data["documentId"] = this.documentId;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["supportingDocumentType"] = this.supportingDocumentType ? this.supportingDocumentType.toJSON() : <any>undefined;
        if (Array.isArray(this.documentPrefixes)) {
            data["documentPrefixes"] = [];
            for (let item of this.documentPrefixes)
                data["documentPrefixes"].push(item.toJSON());
        }
        data["supportingDocumentStatus"] = this.supportingDocumentStatus;
        return data;
    }
}

export interface ISupportingDocumentDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentSize?: number | undefined;
    documentFormat?: string | undefined;
    documentId?: string;
    uploadDate?: moment.Moment | undefined;
    id?: string;
    supportingDocumentType?: SupportingDocumentType;
    documentPrefixes?: DocumentPrefixDto[] | undefined;
    supportingDocumentStatus?: SupportingDocumentStatusEnum;
}

export class SupportingDocumentStaffPortalDto implements ISupportingDocumentStaffPortalDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    id?: string;
    isOverriddenEnabled?: boolean | undefined;
    isOverridden?: boolean | undefined;
    overrideReason?: string | undefined;
    documentFolderCode?: string | undefined;
    documentFolderId?: string | undefined;
    documentPrefixes?: SupportingDocumentDocumentPrefixDto[] | undefined;
    documents?: DocumentDto[] | undefined;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;

    constructor(data?: ISupportingDocumentStaffPortalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data["detail"];
            this.documentName = _data["documentName"];
            this.frenchName = _data["frenchName"];
            this.id = _data["id"];
            this.isOverriddenEnabled = _data["isOverriddenEnabled"];
            this.isOverridden = _data["isOverridden"];
            this.overrideReason = _data["overrideReason"];
            this.documentFolderCode = _data["documentFolderCode"];
            this.documentFolderId = _data["documentFolderId"];
            if (Array.isArray(_data["documentPrefixes"])) {
                this.documentPrefixes = [] as any;
                for (let item of _data["documentPrefixes"])
                    this.documentPrefixes!.push(SupportingDocumentDocumentPrefixDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.isForSpouse = _data["isForSpouse"];
            this.businessName = _data["businessName"];
        }
    }

    static fromJS(data: any): SupportingDocumentStaffPortalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentStaffPortalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detail"] = this.detail;
        data["documentName"] = this.documentName;
        data["frenchName"] = this.frenchName;
        data["id"] = this.id;
        data["isOverriddenEnabled"] = this.isOverriddenEnabled;
        data["isOverridden"] = this.isOverridden;
        data["overrideReason"] = this.overrideReason;
        data["documentFolderCode"] = this.documentFolderCode;
        data["documentFolderId"] = this.documentFolderId;
        if (Array.isArray(this.documentPrefixes)) {
            data["documentPrefixes"] = [];
            for (let item of this.documentPrefixes)
                data["documentPrefixes"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["isForSpouse"] = this.isForSpouse;
        data["businessName"] = this.businessName;
        return data;
    }
}

export interface ISupportingDocumentStaffPortalDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    id?: string;
    isOverriddenEnabled?: boolean | undefined;
    isOverridden?: boolean | undefined;
    overrideReason?: string | undefined;
    documentFolderCode?: string | undefined;
    documentFolderId?: string | undefined;
    documentPrefixes?: SupportingDocumentDocumentPrefixDto[] | undefined;
    documents?: DocumentDto[] | undefined;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;
}

export class SupportingDocumentStatusDto implements ISupportingDocumentStatusDto {
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;

    constructor(data?: ISupportingDocumentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportingDocumentStatus = _data["supportingDocumentStatus"];
            this.numberOfRequiredSupportingDocuments = _data["numberOfRequiredSupportingDocuments"];
            this.numberOfUploadedSupportingDocuments = _data["numberOfUploadedSupportingDocuments"];
        }
    }

    static fromJS(data: any): SupportingDocumentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportingDocumentStatus"] = this.supportingDocumentStatus;
        data["numberOfRequiredSupportingDocuments"] = this.numberOfRequiredSupportingDocuments;
        data["numberOfUploadedSupportingDocuments"] = this.numberOfUploadedSupportingDocuments;
        return data;
    }
}

export interface ISupportingDocumentStatusDto {
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;
}

export class UpdateOverrideStatusDto implements IUpdateOverrideStatusDto {
    supportingDocumentId?: string;
    isOverriden?: boolean;
    overrideReason?: string | undefined;

    constructor(data?: IUpdateOverrideStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportingDocumentId = _data["supportingDocumentId"];
            this.isOverriden = _data["isOverriden"];
            this.overrideReason = _data["overrideReason"];
        }
    }

    static fromJS(data: any): UpdateOverrideStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOverrideStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportingDocumentId"] = this.supportingDocumentId;
        data["isOverriden"] = this.isOverriden;
        data["overrideReason"] = this.overrideReason;
        return data;
    }
}

export interface IUpdateOverrideStatusDto {
    supportingDocumentId?: string;
    isOverriden?: boolean;
    overrideReason?: string | undefined;
}

export class AdminInfoTaxReturnDto implements IAdminInfoTaxReturnDto {
    taxReturnProcessStatus?: FileProcessStatusEnum;
    yearLastReturnFiled?: number | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: number | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    completedAllTaxReturnPeriods?: boolean;

    constructor(data?: IAdminInfoTaxReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxReturnProcessStatus = _data["taxReturnProcessStatus"];
            this.yearLastReturnFiled = _data["yearLastReturnFiled"];
            this.refundAmount = _data["refundAmount"];
            this.amountOwing = _data["amountOwing"];
            this.spouseYearLastReturnFiled = _data["spouseYearLastReturnFiled"];
            this.spouseRefundAmount = _data["spouseRefundAmount"];
            this.spouseAmountOwing = _data["spouseAmountOwing"];
            this.completedAllTaxReturnPeriods = _data["completedAllTaxReturnPeriods"];
        }
    }

    static fromJS(data: any): AdminInfoTaxReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminInfoTaxReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxReturnProcessStatus"] = this.taxReturnProcessStatus;
        data["yearLastReturnFiled"] = this.yearLastReturnFiled;
        data["refundAmount"] = this.refundAmount;
        data["amountOwing"] = this.amountOwing;
        data["spouseYearLastReturnFiled"] = this.spouseYearLastReturnFiled;
        data["spouseRefundAmount"] = this.spouseRefundAmount;
        data["spouseAmountOwing"] = this.spouseAmountOwing;
        data["completedAllTaxReturnPeriods"] = this.completedAllTaxReturnPeriods;
        return data;
    }
}

export interface IAdminInfoTaxReturnDto {
    taxReturnProcessStatus?: FileProcessStatusEnum;
    yearLastReturnFiled?: number | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: number | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    completedAllTaxReturnPeriods?: boolean;
}

export class TaxPeriodDto implements ITaxPeriodDto {
    externalTaxReturnId?: string | undefined;
    taxPeriod?: string | undefined;

    constructor(data?: ITaxPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalTaxReturnId = _data["externalTaxReturnId"];
            this.taxPeriod = _data["taxPeriod"];
        }
    }

    static fromJS(data: any): TaxPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalTaxReturnId"] = this.externalTaxReturnId;
        data["taxPeriod"] = this.taxPeriod;
        return data;
    }
}

export interface ITaxPeriodDto {
    externalTaxReturnId?: string | undefined;
    taxPeriod?: string | undefined;
}

export class TaxReturnPeriodListItemDto implements ITaxReturnPeriodListItemDto {
    id?: string;
    externalTaxReturnId?: string | undefined;
    taxPeriod?: string | undefined;
    sourceType?: string | undefined;
    amountEstimated?: number | undefined;
    amountDeposited?: number | undefined;
    taxStatus?: TaxStatusEnum;
    ascendStatus?: string | undefined;
    dispositionType?: string | undefined;
    isComplete?: boolean | undefined;

    constructor(data?: ITaxReturnPeriodListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalTaxReturnId = _data["externalTaxReturnId"];
            this.taxPeriod = _data["taxPeriod"];
            this.sourceType = _data["sourceType"];
            this.amountEstimated = _data["amountEstimated"];
            this.amountDeposited = _data["amountDeposited"];
            this.taxStatus = _data["taxStatus"];
            this.ascendStatus = _data["ascendStatus"];
            this.dispositionType = _data["dispositionType"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): TaxReturnPeriodListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnPeriodListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalTaxReturnId"] = this.externalTaxReturnId;
        data["taxPeriod"] = this.taxPeriod;
        data["sourceType"] = this.sourceType;
        data["amountEstimated"] = this.amountEstimated;
        data["amountDeposited"] = this.amountDeposited;
        data["taxStatus"] = this.taxStatus;
        data["ascendStatus"] = this.ascendStatus;
        data["dispositionType"] = this.dispositionType;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface ITaxReturnPeriodListItemDto {
    id?: string;
    externalTaxReturnId?: string | undefined;
    taxPeriod?: string | undefined;
    sourceType?: string | undefined;
    amountEstimated?: number | undefined;
    amountDeposited?: number | undefined;
    taxStatus?: TaxStatusEnum;
    ascendStatus?: string | undefined;
    dispositionType?: string | undefined;
    isComplete?: boolean | undefined;
}

export class TaxReturnSubmissionDetailDto implements ITaxReturnSubmissionDetailDto {
    id?: string;
    fileId?: string;
    state?: TaxReturnSubmissionStateEnum;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    hasAdditionalProcess?: boolean | undefined;
    additionalProcessInstructions?: string | undefined;
    commentsForClientPortal?: string | undefined;
    filedDate?: moment.Moment | undefined;
    reminderDate?: moment.Moment | undefined;
    estimatedAmount?: number | undefined;
    source?: TaxReturnSubmissionSourceEnum;
    assessmentDate?: moment.Moment | undefined;
    ascendTaxReturnStatus?: string | undefined;
    disposition?: string | undefined;
    dispositionDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    receivedDate?: moment.Moment;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: TaxReturnSubmissionInfoDto;

    constructor(data?: ITaxReturnSubmissionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.state = _data["state"];
            this.result = _data["result"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
            this.hasAdditionalProcess = _data["hasAdditionalProcess"];
            this.additionalProcessInstructions = _data["additionalProcessInstructions"];
            this.commentsForClientPortal = _data["commentsForClientPortal"];
            this.filedDate = _data["filedDate"] ? moment(_data["filedDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? moment(_data["reminderDate"].toString()) : <any>undefined;
            this.estimatedAmount = _data["estimatedAmount"];
            this.source = _data["source"];
            this.assessmentDate = _data["assessmentDate"] ? moment(_data["assessmentDate"].toString()) : <any>undefined;
            this.ascendTaxReturnStatus = _data["ascendTaxReturnStatus"];
            this.disposition = _data["disposition"];
            this.dispositionDate = _data["dispositionDate"] ? moment(_data["dispositionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.importedEmailSubject = _data["importedEmailSubject"];
            this.importedEmailBody = _data["importedEmailBody"];
            this.importedEmailRecipientEmailAddress = _data["importedEmailRecipientEmailAddress"];
            this.importedEmailRecipientName = _data["importedEmailRecipientName"];
            this.importedEmailSenderEmailAddress = _data["importedEmailSenderEmailAddress"];
            this.importedEmailSenderName = _data["importedEmailSenderName"];
            this.info = _data["info"] ? TaxReturnSubmissionInfoDto.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxReturnSubmissionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["state"] = this.state;
        data["result"] = this.result;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        data["hasAdditionalProcess"] = this.hasAdditionalProcess;
        data["additionalProcessInstructions"] = this.additionalProcessInstructions;
        data["commentsForClientPortal"] = this.commentsForClientPortal;
        data["filedDate"] = this.filedDate ? this.filedDate.toISOString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toISOString() : <any>undefined;
        data["estimatedAmount"] = this.estimatedAmount;
        data["source"] = this.source;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["ascendTaxReturnStatus"] = this.ascendTaxReturnStatus;
        data["disposition"] = this.disposition;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["importedEmailSubject"] = this.importedEmailSubject;
        data["importedEmailBody"] = this.importedEmailBody;
        data["importedEmailRecipientEmailAddress"] = this.importedEmailRecipientEmailAddress;
        data["importedEmailRecipientName"] = this.importedEmailRecipientName;
        data["importedEmailSenderEmailAddress"] = this.importedEmailSenderEmailAddress;
        data["importedEmailSenderName"] = this.importedEmailSenderName;
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaxReturnSubmissionDetailDto {
    id?: string;
    fileId?: string;
    state?: TaxReturnSubmissionStateEnum;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    hasAdditionalProcess?: boolean | undefined;
    additionalProcessInstructions?: string | undefined;
    commentsForClientPortal?: string | undefined;
    filedDate?: moment.Moment | undefined;
    reminderDate?: moment.Moment | undefined;
    estimatedAmount?: number | undefined;
    source?: TaxReturnSubmissionSourceEnum;
    assessmentDate?: moment.Moment | undefined;
    ascendTaxReturnStatus?: string | undefined;
    disposition?: string | undefined;
    dispositionDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    receivedDate?: moment.Moment;
    importedEmailSubject?: string | undefined;
    importedEmailBody?: string | undefined;
    importedEmailRecipientEmailAddress?: string | undefined;
    importedEmailRecipientName?: string | undefined;
    importedEmailSenderEmailAddress?: string | undefined;
    importedEmailSenderName?: string | undefined;
    info?: TaxReturnSubmissionInfoDto;
}

export class TaxReturnSubmissionInfoDto implements ITaxReturnSubmissionInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxPeriod?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: ITaxReturnSubmissionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estateNumber = _data["estateNumber"];
            this.sin = _data["sin"];
            this.debtorName = _data["debtorName"];
            this.dateOfInsolvency = _data["dateOfInsolvency"] ? moment(_data["dateOfInsolvency"].toString()) : <any>undefined;
            this.submission = _data["submission"];
            this.taxPeriod = _data["taxPeriod"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): TaxReturnSubmissionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estateNumber"] = this.estateNumber;
        data["sin"] = this.sin;
        data["debtorName"] = this.debtorName;
        data["dateOfInsolvency"] = this.dateOfInsolvency ? this.dateOfInsolvency.toISOString() : <any>undefined;
        data["submission"] = this.submission;
        data["taxPeriod"] = this.taxPeriod;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ITaxReturnSubmissionInfoDto {
    estateNumber?: string | undefined;
    sin?: string | undefined;
    debtorName?: string | undefined;
    dateOfInsolvency?: moment.Moment | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxPeriod?: string | undefined;
    fileName?: string | undefined;
}

export class TaxReturnSubmissionLinkDto implements ITaxReturnSubmissionLinkDto {
    appTaskActionId?: string;
    searchedFileId?: string | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriods?: TaxReturnSubmissionPeriodLinkDto[] | undefined;

    constructor(data?: ITaxReturnSubmissionLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appTaskActionId = _data["appTaskActionId"];
            this.searchedFileId = _data["searchedFileId"];
            this.submission = _data["submission"];
            if (Array.isArray(_data["taxReturnPeriods"])) {
                this.taxReturnPeriods = [] as any;
                for (let item of _data["taxReturnPeriods"])
                    this.taxReturnPeriods!.push(TaxReturnSubmissionPeriodLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxReturnSubmissionLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appTaskActionId"] = this.appTaskActionId;
        data["searchedFileId"] = this.searchedFileId;
        data["submission"] = this.submission;
        if (Array.isArray(this.taxReturnPeriods)) {
            data["taxReturnPeriods"] = [];
            for (let item of this.taxReturnPeriods)
                data["taxReturnPeriods"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaxReturnSubmissionLinkDto {
    appTaskActionId?: string;
    searchedFileId?: string | undefined;
    submission?: TaxReturnSubmissionTypeEnum;
    taxReturnPeriods?: TaxReturnSubmissionPeriodLinkDto[] | undefined;
}

export class TaxReturnSubmissionListItemDto implements ITaxReturnSubmissionListItemDto {
    id?: string;
    receivedDate?: moment.Moment;
    assignedTo?: string | undefined;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    state?: TaxReturnSubmissionStateEnum;

    constructor(data?: ITaxReturnSubmissionListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.assignedTo = _data["assignedTo"];
            this.result = _data["result"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): TaxReturnSubmissionListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["assignedTo"] = this.assignedTo;
        data["result"] = this.result;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        data["state"] = this.state;
        return data;
    }
}

export interface ITaxReturnSubmissionListItemDto {
    id?: string;
    receivedDate?: moment.Moment;
    assignedTo?: string | undefined;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    state?: TaxReturnSubmissionStateEnum;
}

export class TaxReturnSubmissionPeriodLinkDto implements ITaxReturnSubmissionPeriodLinkDto {
    externalTaxReturnId?: string | undefined;
    isMarkAsActive?: boolean | undefined;
    taxPeriod?: string | undefined;

    constructor(data?: ITaxReturnSubmissionPeriodLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalTaxReturnId = _data["externalTaxReturnId"];
            this.isMarkAsActive = _data["isMarkAsActive"];
            this.taxPeriod = _data["taxPeriod"];
        }
    }

    static fromJS(data: any): TaxReturnSubmissionPeriodLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionPeriodLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalTaxReturnId"] = this.externalTaxReturnId;
        data["isMarkAsActive"] = this.isMarkAsActive;
        data["taxPeriod"] = this.taxPeriod;
        return data;
    }
}

export interface ITaxReturnSubmissionPeriodLinkDto {
    externalTaxReturnId?: string | undefined;
    isMarkAsActive?: boolean | undefined;
    taxPeriod?: string | undefined;
}

export class TaxReturnSubmissionUpdateDto implements ITaxReturnSubmissionUpdateDto {
    id!: string;
    filedDate?: moment.Moment | undefined;
    reminderDate?: moment.Moment | undefined;
    source?: TaxReturnSubmissionSourceEnum;
    assessmentDate?: moment.Moment | undefined;
    ascendTaxReturnStatus?: string | undefined;
    disposition?: string | undefined;
    dispositionDate?: moment.Moment | undefined;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    hasAdditionalProcess?: boolean | undefined;
    additionalProcessInstructions?: string | undefined;
    commentsForClientPortal?: string | undefined;
    isComplete?: boolean;
    estimatedAmount?: number | undefined;
    alerts?: AlertCreateDto;

    constructor(data?: ITaxReturnSubmissionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filedDate = _data["filedDate"] ? moment(_data["filedDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? moment(_data["reminderDate"].toString()) : <any>undefined;
            this.source = _data["source"];
            this.assessmentDate = _data["assessmentDate"] ? moment(_data["assessmentDate"].toString()) : <any>undefined;
            this.ascendTaxReturnStatus = _data["ascendTaxReturnStatus"];
            this.disposition = _data["disposition"];
            this.dispositionDate = _data["dispositionDate"] ? moment(_data["dispositionDate"].toString()) : <any>undefined;
            this.result = _data["result"];
            this.hasDiscrepancy = _data["hasDiscrepancy"];
            this.hasAdditionalProcess = _data["hasAdditionalProcess"];
            this.additionalProcessInstructions = _data["additionalProcessInstructions"];
            this.commentsForClientPortal = _data["commentsForClientPortal"];
            this.isComplete = _data["isComplete"];
            this.estimatedAmount = _data["estimatedAmount"];
            this.alerts = _data["alerts"] ? AlertCreateDto.fromJS(_data["alerts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxReturnSubmissionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSubmissionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filedDate"] = this.filedDate ? this.filedDate.toISOString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["assessmentDate"] = this.assessmentDate ? this.assessmentDate.toISOString() : <any>undefined;
        data["ascendTaxReturnStatus"] = this.ascendTaxReturnStatus;
        data["disposition"] = this.disposition;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : <any>undefined;
        data["result"] = this.result;
        data["hasDiscrepancy"] = this.hasDiscrepancy;
        data["hasAdditionalProcess"] = this.hasAdditionalProcess;
        data["additionalProcessInstructions"] = this.additionalProcessInstructions;
        data["commentsForClientPortal"] = this.commentsForClientPortal;
        data["isComplete"] = this.isComplete;
        data["estimatedAmount"] = this.estimatedAmount;
        data["alerts"] = this.alerts ? this.alerts.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaxReturnSubmissionUpdateDto {
    id: string;
    filedDate?: moment.Moment | undefined;
    reminderDate?: moment.Moment | undefined;
    source?: TaxReturnSubmissionSourceEnum;
    assessmentDate?: moment.Moment | undefined;
    ascendTaxReturnStatus?: string | undefined;
    disposition?: string | undefined;
    dispositionDate?: moment.Moment | undefined;
    result?: TaxReturnSubmissionStatusEnum;
    hasDiscrepancy?: boolean | undefined;
    hasAdditionalProcess?: boolean | undefined;
    additionalProcessInstructions?: string | undefined;
    commentsForClientPortal?: string | undefined;
    isComplete?: boolean;
    estimatedAmount?: number | undefined;
    alerts?: AlertCreateDto;
}

export class ProfileInfoDto implements IProfileInfoDto {
    name?: string | undefined;
    email?: string | undefined;
    roles?: (string | undefined)[] | undefined;
    teams?: (string | undefined)[] | undefined;

    constructor(data?: IProfileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item);
        }
        return data;
    }
}

export interface IProfileInfoDto {
    name?: string | undefined;
    email?: string | undefined;
    roles?: (string | undefined)[] | undefined;
    teams?: (string | undefined)[] | undefined;
}

export class CreditReportHistoryAddressDto implements ICreditReportHistoryAddressDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    addressType?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    prov?: string | undefined;
    postal?: string | undefined;
    dateReported?: moment.Moment;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.addressType = _data["addressType"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.prov = _data["prov"];
            this.postal = _data["postal"];
            this.dateReported = _data["dateReported"] ? moment(_data["dateReported"].toString()) : <any>undefined;
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["addressType"] = this.addressType;
        data["street"] = this.street;
        data["city"] = this.city;
        data["prov"] = this.prov;
        data["postal"] = this.postal;
        data["dateReported"] = this.dateReported ? this.dateReported.toISOString() : <any>undefined;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryAddressDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    addressType?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    prov?: string | undefined;
    postal?: string | undefined;
    dateReported?: moment.Moment;
    imported?: boolean;
}

export class CreditReportHistoryAlertDto implements ICreditReportHistoryAlertDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    code?: number;
    text?: string | undefined;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.code = _data["code"];
            this.text = _data["text"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["code"] = this.code;
        data["text"] = this.text;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryAlertDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    code?: number;
    text?: string | undefined;
    imported?: boolean;
}

export class CreditReportHistoryDto implements ICreditReportHistoryDto {
    fileId?: string;
    id?: string;
    clientId?: string;
    onFileDate?: moment.Moment;
    sin?: string | undefined;
    birthDate?: moment.Moment | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    imported?: boolean;
    creator?: string | undefined;
    creatorFirstName?: string | undefined;
    creatorLastName?: string | undefined;
    readonly creatorName?: string | undefined;

    constructor(data?: ICreditReportHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.onFileDate = _data["onFileDate"] ? moment(_data["onFileDate"].toString()) : <any>undefined;
            this.sin = _data["sin"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imported = _data["imported"];
            this.creator = _data["creator"];
            this.creatorFirstName = _data["creatorFirstName"];
            this.creatorLastName = _data["creatorLastName"];
            (<any>this).creatorName = _data["creatorName"];
        }
    }

    static fromJS(data: any): CreditReportHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["onFileDate"] = this.onFileDate ? this.onFileDate.toISOString() : <any>undefined;
        data["sin"] = this.sin;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imported"] = this.imported;
        data["creator"] = this.creator;
        data["creatorFirstName"] = this.creatorFirstName;
        data["creatorLastName"] = this.creatorLastName;
        data["creatorName"] = this.creatorName;
        return data;
    }
}

export interface ICreditReportHistoryDto {
    fileId?: string;
    id?: string;
    clientId?: string;
    onFileDate?: moment.Moment;
    sin?: string | undefined;
    birthDate?: moment.Moment | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    imported?: boolean;
    creator?: string | undefined;
    creatorFirstName?: string | undefined;
    creatorLastName?: string | undefined;
    creatorName?: string | undefined;
}

export class CreditReportHistoryMessageDto implements ICreditReportHistoryMessageDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    code?: string | undefined;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.code = _data["code"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["code"] = this.code;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryMessageDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    code?: string | undefined;
    imported?: boolean;
}

export class CreditReportHistoryNameDto implements ICreditReportHistoryNameDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    nameType?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.nameType = _data["nameType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["nameType"] = this.nameType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryNameDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    nameType?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    imported?: boolean;
}

export class CreditReportHistoryPhoneDto implements ICreditReportHistoryPhoneDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    phoneType?: string | undefined;
    number?: string | undefined;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.phoneType = _data["phoneType"];
            this.number = _data["number"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["phoneType"] = this.phoneType;
        data["number"] = this.number;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryPhoneDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    phoneType?: string | undefined;
    number?: string | undefined;
    imported?: boolean;
}

export class CreditReportHistoryProductScoreDto implements ICreditReportHistoryProductScoreDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    product?: string | undefined;
    score?: string | undefined;
    scoreDerogatoryAlert?: string | undefined;
    factor1?: string | undefined;
    factor2?: string | undefined;
    factor3?: string | undefined;
    factor4?: string | undefined;
    factor5?: string | undefined;
    scoreCard?: string | undefined;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryProductScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.product = _data["product"];
            this.score = _data["score"];
            this.scoreDerogatoryAlert = _data["scoreDerogatoryAlert"];
            this.factor1 = _data["factor1"];
            this.factor2 = _data["factor2"];
            this.factor3 = _data["factor3"];
            this.factor4 = _data["factor4"];
            this.factor5 = _data["factor5"];
            this.scoreCard = _data["scoreCard"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryProductScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryProductScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["product"] = this.product;
        data["score"] = this.score;
        data["scoreDerogatoryAlert"] = this.scoreDerogatoryAlert;
        data["factor1"] = this.factor1;
        data["factor2"] = this.factor2;
        data["factor3"] = this.factor3;
        data["factor4"] = this.factor4;
        data["factor5"] = this.factor5;
        data["scoreCard"] = this.scoreCard;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryProductScoreDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    product?: string | undefined;
    score?: string | undefined;
    scoreDerogatoryAlert?: string | undefined;
    factor1?: string | undefined;
    factor2?: string | undefined;
    factor3?: string | undefined;
    factor4?: string | undefined;
    factor5?: string | undefined;
    scoreCard?: string | undefined;
    imported?: boolean;
}

export class CreditReportHistoryTradeDto implements ICreditReportHistoryTradeDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    memberCode?: string | undefined;
    memberName?: string | undefined;
    type?: string | undefined;
    account?: string | undefined;
    joint?: string | undefined;
    dateOpened?: moment.Moment;
    dateRevised?: moment.Moment | undefined;
    dateLastActivity?: moment.Moment | undefined;
    mop?: string | undefined;
    mannerOfPaymentDescription?: string | undefined;
    balance?: number;
    highCredit?: string | undefined;
    creditLimit?: number;
    frequency?: string | undefined;
    payment?: number;
    pastDue?: number;
    paymentPatternStartDate?: moment.Moment | undefined;
    paymentPattern?: string | undefined;
    monthsReviewed?: number;
    plus30?: number;
    plus60?: number;
    plus90?: number;
    imported?: boolean;

    constructor(data?: ICreditReportHistoryTradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.creditReportHistoryId = _data["creditReportHistoryId"];
            this.memberCode = _data["memberCode"];
            this.memberName = _data["memberName"];
            this.type = _data["type"];
            this.account = _data["account"];
            this.joint = _data["joint"];
            this.dateOpened = _data["dateOpened"] ? moment(_data["dateOpened"].toString()) : <any>undefined;
            this.dateRevised = _data["dateRevised"] ? moment(_data["dateRevised"].toString()) : <any>undefined;
            this.dateLastActivity = _data["dateLastActivity"] ? moment(_data["dateLastActivity"].toString()) : <any>undefined;
            this.mop = _data["mop"];
            this.mannerOfPaymentDescription = _data["mannerOfPaymentDescription"];
            this.balance = _data["balance"];
            this.highCredit = _data["highCredit"];
            this.creditLimit = _data["creditLimit"];
            this.frequency = _data["frequency"];
            this.payment = _data["payment"];
            this.pastDue = _data["pastDue"];
            this.paymentPatternStartDate = _data["paymentPatternStartDate"] ? moment(_data["paymentPatternStartDate"].toString()) : <any>undefined;
            this.paymentPattern = _data["paymentPattern"];
            this.monthsReviewed = _data["monthsReviewed"];
            this.plus30 = _data["plus30"];
            this.plus60 = _data["plus60"];
            this.plus90 = _data["plus90"];
            this.imported = _data["imported"];
        }
    }

    static fromJS(data: any): CreditReportHistoryTradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportHistoryTradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["creditReportHistoryId"] = this.creditReportHistoryId;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["type"] = this.type;
        data["account"] = this.account;
        data["joint"] = this.joint;
        data["dateOpened"] = this.dateOpened ? this.dateOpened.toISOString() : <any>undefined;
        data["dateRevised"] = this.dateRevised ? this.dateRevised.toISOString() : <any>undefined;
        data["dateLastActivity"] = this.dateLastActivity ? this.dateLastActivity.toISOString() : <any>undefined;
        data["mop"] = this.mop;
        data["mannerOfPaymentDescription"] = this.mannerOfPaymentDescription;
        data["balance"] = this.balance;
        data["highCredit"] = this.highCredit;
        data["creditLimit"] = this.creditLimit;
        data["frequency"] = this.frequency;
        data["payment"] = this.payment;
        data["pastDue"] = this.pastDue;
        data["paymentPatternStartDate"] = this.paymentPatternStartDate ? this.paymentPatternStartDate.toISOString() : <any>undefined;
        data["paymentPattern"] = this.paymentPattern;
        data["monthsReviewed"] = this.monthsReviewed;
        data["plus30"] = this.plus30;
        data["plus60"] = this.plus60;
        data["plus90"] = this.plus90;
        data["imported"] = this.imported;
        return data;
    }
}

export interface ICreditReportHistoryTradeDto {
    fileId?: string;
    id?: string;
    creditReportHistoryId?: string;
    memberCode?: string | undefined;
    memberName?: string | undefined;
    type?: string | undefined;
    account?: string | undefined;
    joint?: string | undefined;
    dateOpened?: moment.Moment;
    dateRevised?: moment.Moment | undefined;
    dateLastActivity?: moment.Moment | undefined;
    mop?: string | undefined;
    mannerOfPaymentDescription?: string | undefined;
    balance?: number;
    highCredit?: string | undefined;
    creditLimit?: number;
    frequency?: string | undefined;
    payment?: number;
    pastDue?: number;
    paymentPatternStartDate?: moment.Moment | undefined;
    paymentPattern?: string | undefined;
    monthsReviewed?: number;
    plus30?: number;
    plus60?: number;
    plus90?: number;
    imported?: boolean;
}

export class CreditReportRequestDto implements ICreditReportRequestDto {
    fileId?: string;
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: moment.Moment;
    sin?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    previousAddresses?: CreditReportRequestPrevAddress[] | undefined;
    residenceDate?: moment.Moment;
    userConsent?: boolean;

    constructor(data?: ICreditReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sin = _data["sin"];
            this.emailAddress = _data["emailAddress"];
            this.mainPhoneTypeId = _data["mainPhoneTypeId"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            if (Array.isArray(_data["previousAddresses"])) {
                this.previousAddresses = [] as any;
                for (let item of _data["previousAddresses"])
                    this.previousAddresses!.push(CreditReportRequestPrevAddress.fromJS(item));
            }
            this.residenceDate = _data["residenceDate"] ? moment(_data["residenceDate"].toString()) : <any>undefined;
            this.userConsent = _data["userConsent"];
        }
    }

    static fromJS(data: any): CreditReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sin"] = this.sin;
        data["emailAddress"] = this.emailAddress;
        data["mainPhoneTypeId"] = this.mainPhoneTypeId;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        if (Array.isArray(this.previousAddresses)) {
            data["previousAddresses"] = [];
            for (let item of this.previousAddresses)
                data["previousAddresses"].push(item.toJSON());
        }
        data["residenceDate"] = this.residenceDate ? this.residenceDate.toISOString() : <any>undefined;
        data["userConsent"] = this.userConsent;
        return data;
    }
}

export interface ICreditReportRequestDto {
    fileId?: string;
    clientId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: moment.Moment;
    sin?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    previousAddresses?: CreditReportRequestPrevAddress[] | undefined;
    residenceDate?: moment.Moment;
    userConsent?: boolean;
}

export class CreditReportRequestPrevAddress implements ICreditReportRequestPrevAddress {
    addressId?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    address?: string | undefined;

    constructor(data?: ICreditReportRequestPrevAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.unit = _data["unit"];
            this.city = _data["city"];
            this.provinceId = _data["provinceId"];
            this.countryId = _data["countryId"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): CreditReportRequestPrevAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreditReportRequestPrevAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["unit"] = this.unit;
        data["city"] = this.city;
        data["provinceId"] = this.provinceId;
        data["countryId"] = this.countryId;
        data["address"] = this.address;
        return data;
    }
}

export interface ICreditReportRequestPrevAddress {
    addressId?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    address?: string | undefined;
}

export class SupportingDocumentType implements ISupportingDocumentType {
    readonly id?: string;
    orderNumber?: number;
    enumValue?: SupportingDocumentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISupportingDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SupportingDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ISupportingDocumentType {
    id?: string;
    orderNumber?: number;
    enumValue?: SupportingDocumentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;
}

export class AssetDto implements IAssetDto {
    externalEntityId?: string | undefined;
    assetType?: AssetType;
    assetTypeOther?: string | undefined;
    dispositionType?: DispositionType;
    dispositionTypeOther?: string | undefined;
    description?: string | undefined;
    estimatedAmount?: number;
    exemptAmount?: number;
    realizableAmount?: number;
    realizedAmount?: number;
    securedAmount?: number | undefined;
    originalCostAmount?: number | undefined;
    isFullyRealized?: boolean | undefined;
    isExempt?: boolean | undefined;
    isSecured?: boolean | undefined;
    isTaxes?: boolean | undefined;
    isSold?: boolean | undefined;
    ifRepurchase?: boolean | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalEntityId = _data["externalEntityId"];
            this.assetType = _data["assetType"];
            this.assetTypeOther = _data["assetTypeOther"];
            this.dispositionType = _data["dispositionType"];
            this.dispositionTypeOther = _data["dispositionTypeOther"];
            this.description = _data["description"];
            this.estimatedAmount = _data["estimatedAmount"];
            this.exemptAmount = _data["exemptAmount"];
            this.realizableAmount = _data["realizableAmount"];
            this.realizedAmount = _data["realizedAmount"];
            this.securedAmount = _data["securedAmount"];
            this.originalCostAmount = _data["originalCostAmount"];
            this.isFullyRealized = _data["isFullyRealized"];
            this.isExempt = _data["isExempt"];
            this.isSecured = _data["isSecured"];
            this.isTaxes = _data["isTaxes"];
            this.isSold = _data["isSold"];
            this.ifRepurchase = _data["ifRepurchase"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalEntityId"] = this.externalEntityId;
        data["assetType"] = this.assetType;
        data["assetTypeOther"] = this.assetTypeOther;
        data["dispositionType"] = this.dispositionType;
        data["dispositionTypeOther"] = this.dispositionTypeOther;
        data["description"] = this.description;
        data["estimatedAmount"] = this.estimatedAmount;
        data["exemptAmount"] = this.exemptAmount;
        data["realizableAmount"] = this.realizableAmount;
        data["realizedAmount"] = this.realizedAmount;
        data["securedAmount"] = this.securedAmount;
        data["originalCostAmount"] = this.originalCostAmount;
        data["isFullyRealized"] = this.isFullyRealized;
        data["isExempt"] = this.isExempt;
        data["isSecured"] = this.isSecured;
        data["isTaxes"] = this.isTaxes;
        data["isSold"] = this.isSold;
        data["ifRepurchase"] = this.ifRepurchase;
        return data;
    }
}

export interface IAssetDto {
    externalEntityId?: string | undefined;
    assetType?: AssetType;
    assetTypeOther?: string | undefined;
    dispositionType?: DispositionType;
    dispositionTypeOther?: string | undefined;
    description?: string | undefined;
    estimatedAmount?: number;
    exemptAmount?: number;
    realizableAmount?: number;
    realizedAmount?: number;
    securedAmount?: number | undefined;
    originalCostAmount?: number | undefined;
    isFullyRealized?: boolean | undefined;
    isExempt?: boolean | undefined;
    isSecured?: boolean | undefined;
    isTaxes?: boolean | undefined;
    isSold?: boolean | undefined;
    ifRepurchase?: boolean | undefined;
}

export enum AssetType {
    Other = 0,
    CashOnHand = 1,
    RealProperty = 2,
    Furniture = 3,
    PersonalEffects = 4,
    Policies_RRSPs = 5,
    Securities = 6,
    MotorVehicles = 7,
    RecreationalEquipment = 8,
    Taxes = 9,
    BusinessAssets = 10,
    PromissoryNotes = 11,
    DebtsDue = 12,
}

export enum DispositionType {
    Other = 0,
    Exempt = 1,
    Disposed = 2,
    AssessmentReceived = 3,
    BalanceOwing = 4,
    ContinuePayments = 5,
    Disallowance = 6,
    FullDisallowance = 7,
    NilValue = 8,
    NoEquity = 9,
    NotDisposed = 10,
    NotSeizable = 11,
    PartialDisallowance = 12,
    RealizedInFull = 13,
    RedeemedByTrustee = 14,
    ReleasedToSecuredCreditor = 15,
    Refunded = 16,
    ReturnedToDebtor = 17,
    Setoff = 18,
    UnableToRealize = 19,
    RegisteredOnTitle = 20,
    PowerOfSale = 21,
}

export class CourtOfficeDto implements ICourtOfficeDto {
    externalEntityId?: string | undefined;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    city?: string | undefined;
    readonly displayName?: string | undefined;

    constructor(data?: ICourtOfficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalEntityId = _data["externalEntityId"];
            this.courtName = _data["courtName"];
            this.courtNumber = _data["courtNumber"];
            this.city = _data["city"];
            (<any>this).displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CourtOfficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourtOfficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalEntityId"] = this.externalEntityId;
        data["courtName"] = this.courtName;
        data["courtNumber"] = this.courtNumber;
        data["city"] = this.city;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICourtOfficeDto {
    externalEntityId?: string | undefined;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    city?: string | undefined;
    displayName?: string | undefined;
}

export class CreditorDto implements ICreditorDto {
    externalEntityId?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    isActive?: boolean;
    creditorType?: CreditorType;
    creditorTypeOther?: string | undefined;
    liabilityType?: LiabilityType;
    liabilityTypeOther?: string | undefined;

    constructor(data?: ICreditorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalEntityId = _data["externalEntityId"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.isActive = _data["isActive"];
            this.creditorType = _data["creditorType"];
            this.creditorTypeOther = _data["creditorTypeOther"];
            this.liabilityType = _data["liabilityType"];
            this.liabilityTypeOther = _data["liabilityTypeOther"];
        }
    }

    static fromJS(data: any): CreditorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalEntityId"] = this.externalEntityId;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["isActive"] = this.isActive;
        data["creditorType"] = this.creditorType;
        data["creditorTypeOther"] = this.creditorTypeOther;
        data["liabilityType"] = this.liabilityType;
        data["liabilityTypeOther"] = this.liabilityTypeOther;
        return data;
    }
}

export interface ICreditorDto {
    externalEntityId?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    isActive?: boolean;
    creditorType?: CreditorType;
    creditorTypeOther?: string | undefined;
    liabilityType?: LiabilityType;
    liabilityTypeOther?: string | undefined;
}

export enum CreditorType {
    Other = 0,
    Common = 1,
    National = 2,
    NationalHeadOffice = 3,
    NationalCreditManager = 4,
    Unique = 5,
    Individual = 6,
    CommonCreditorHeadOffice = 7,
}

export enum LiabilityType {
    Other = 0,
    Mortgage = 1,
    BankLoan = 2,
    FinanceLoan = 3,
    CreditCardsBank = 4,
    CreditCardsOther = 5,
    Taxes = 6,
    StudentLoans = 7,
    FromIndividuals = 8,
}

export class DebtorFileDto implements IDebtorFileDto {
    externalEntityId?: string | undefined;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    sin?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    estateStatus?: EstateStatus;
    estateStatusOther?: string | undefined;
    proposalStatus?: ProposalStatus;
    proposalStatusOther?: string | undefined;
    readonly proposalStatusDisplayName?: string | undefined;
    dischargeType?: DischargeType;
    dischargeTypeOther?: string | undefined;
    readonly dischargeTypeDisplayName?: string | undefined;
    dischargeDate?: moment.Moment | undefined;
    courtCaseNumber?: string | undefined;
    totalAvailableAmount?: number | undefined;
    totalDueAmount?: number | undefined;
    totalPaymentAmount?: number | undefined;
    is30DaysNoticeAvailable?: boolean | undefined;
    paymentsBehind?: number | undefined;
    bankruptcyNoticeDate?: moment.Moment | undefined;
    proposalNoticeToCreditorsDate?: moment.Moment | undefined;
    courtOffice?: CourtOfficeDto;

    constructor(data?: IDebtorFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalEntityId = _data["externalEntityId"];
            this.fileName = _data["fileName"];
            this.estateNumber = _data["estateNumber"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.sin = _data["sin"];
            this.insolvencyDate = _data["insolvencyDate"] ? moment(_data["insolvencyDate"].toString()) : <any>undefined;
            this.estateStatus = _data["estateStatus"];
            this.estateStatusOther = _data["estateStatusOther"];
            this.proposalStatus = _data["proposalStatus"];
            this.proposalStatusOther = _data["proposalStatusOther"];
            (<any>this).proposalStatusDisplayName = _data["proposalStatusDisplayName"];
            this.dischargeType = _data["dischargeType"];
            this.dischargeTypeOther = _data["dischargeTypeOther"];
            (<any>this).dischargeTypeDisplayName = _data["dischargeTypeDisplayName"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : <any>undefined;
            this.courtCaseNumber = _data["courtCaseNumber"];
            this.totalAvailableAmount = _data["totalAvailableAmount"];
            this.totalDueAmount = _data["totalDueAmount"];
            this.totalPaymentAmount = _data["totalPaymentAmount"];
            this.is30DaysNoticeAvailable = _data["is30DaysNoticeAvailable"];
            this.paymentsBehind = _data["paymentsBehind"];
            this.bankruptcyNoticeDate = _data["bankruptcyNoticeDate"] ? moment(_data["bankruptcyNoticeDate"].toString()) : <any>undefined;
            this.proposalNoticeToCreditorsDate = _data["proposalNoticeToCreditorsDate"] ? moment(_data["proposalNoticeToCreditorsDate"].toString()) : <any>undefined;
            this.courtOffice = _data["courtOffice"] ? CourtOfficeDto.fromJS(_data["courtOffice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DebtorFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalEntityId"] = this.externalEntityId;
        data["fileName"] = this.fileName;
        data["estateNumber"] = this.estateNumber;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["sin"] = this.sin;
        data["insolvencyDate"] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
        data["estateStatus"] = this.estateStatus;
        data["estateStatusOther"] = this.estateStatusOther;
        data["proposalStatus"] = this.proposalStatus;
        data["proposalStatusOther"] = this.proposalStatusOther;
        data["proposalStatusDisplayName"] = this.proposalStatusDisplayName;
        data["dischargeType"] = this.dischargeType;
        data["dischargeTypeOther"] = this.dischargeTypeOther;
        data["dischargeTypeDisplayName"] = this.dischargeTypeDisplayName;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["courtCaseNumber"] = this.courtCaseNumber;
        data["totalAvailableAmount"] = this.totalAvailableAmount;
        data["totalDueAmount"] = this.totalDueAmount;
        data["totalPaymentAmount"] = this.totalPaymentAmount;
        data["is30DaysNoticeAvailable"] = this.is30DaysNoticeAvailable;
        data["paymentsBehind"] = this.paymentsBehind;
        data["bankruptcyNoticeDate"] = this.bankruptcyNoticeDate ? this.bankruptcyNoticeDate.toISOString() : <any>undefined;
        data["proposalNoticeToCreditorsDate"] = this.proposalNoticeToCreditorsDate ? this.proposalNoticeToCreditorsDate.toISOString() : <any>undefined;
        data["courtOffice"] = this.courtOffice ? this.courtOffice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDebtorFileDto {
    externalEntityId?: string | undefined;
    fileName?: string | undefined;
    estateNumber?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    sin?: string | undefined;
    insolvencyDate?: moment.Moment | undefined;
    estateStatus?: EstateStatus;
    estateStatusOther?: string | undefined;
    proposalStatus?: ProposalStatus;
    proposalStatusOther?: string | undefined;
    proposalStatusDisplayName?: string | undefined;
    dischargeType?: DischargeType;
    dischargeTypeOther?: string | undefined;
    dischargeTypeDisplayName?: string | undefined;
    dischargeDate?: moment.Moment | undefined;
    courtCaseNumber?: string | undefined;
    totalAvailableAmount?: number | undefined;
    totalDueAmount?: number | undefined;
    totalPaymentAmount?: number | undefined;
    is30DaysNoticeAvailable?: boolean | undefined;
    paymentsBehind?: number | undefined;
    bankruptcyNoticeDate?: moment.Moment | undefined;
    proposalNoticeToCreditorsDate?: moment.Moment | undefined;
    courtOffice?: CourtOfficeDto;
}

export enum DischargeType {
    Other = 0,
    Automatic = 1,
    Opposition = 2,
    Conditional = 3,
    AbsoluteDischarge = 4,
    DischargeSuspended = 5,
    HearingSet = 6,
    Refused = 7,
    AdjournedSineDie = 8,
    AbsoluteAfterConditional = 9,
    AbsoluteAfterSuspended = 10,
    Failed = 11,
    Cancelled = 12,
    Deceased = 13,
    TrusteeConditionsMet = 14,
    NoOrder = 15,
    Conditional_CourtOrdered = 16,
    Conditional_AgreedUpon = 17,
    Annulled = 18,
    MediationConditionsMet = 19,
    MediationRequested = 20,
}

export enum EstateStatus {
    Other = 0,
    Active = 1,
    Inactive = 2,
    Completed = 3,
    Discharged = 4,
    AdministrationCompleted = 5,
    RandD_Supplemental = 6,
    RandD_ForComment = 7,
}

export enum ProposalStatus {
    Other = 0,
    Ongoing = 1,
    AnnulledByCourt = 2,
    CourtApprovalRefused = 3,
    CreditorAcceptanceRejected = 4,
    DeemedAnnulled = 5,
    FullPerformance = 6,
    Withdrawn = 7,
}

export enum ClaimStatus {
    Other = 0,
    Admitted = 1,
    NotProved = 2,
    Disallowed = 3,
    SecuredAssetReleased = 4,
    Withdrawn = 5,
    Contingent = 6,
    PartiallyDisallowed = 7,
}

export enum ClaimType {
    Other = 0,
    Unsecured = 1,
    Secured = 2,
}

export enum ClaimVote {
    Other = 0,
    For = 1,
    Against = 2,
}

export enum ClaimVotedBy {
    Other = 0,
    Letter = 1,
    Proxy = 2,
}

export class LiabilityClaimDto implements ILiabilityClaimDto {
    externalEntityId?: string | undefined;
    debtorFile?: DebtorFileDto;
    creditor?: CreditorDto;
    claimType?: ClaimType;
    claimTypeOther?: string | undefined;
    claimStatus?: ClaimStatus;
    claimStatusOther?: string | undefined;
    readonly claimStatusDisplayName?: string | undefined;
    accountNumber?: string | undefined;
    unsecuredSoaAmount?: number | undefined;
    securedSoaAmount?: number | undefined;
    liabilityType?: LiabilityType;
    liabilityTypeOther?: string | undefined;
    filedAmount?: number | undefined;
    isLetterSent?: boolean;
    isCompleted?: boolean;
    isMeetingRequested?: boolean | undefined;
    is170ReportRequested?: boolean;
    votedBy?: ClaimVotedBy;
    votedByOther?: string | undefined;
    vote?: ClaimVote;
    voteOther?: string | undefined;

    constructor(data?: ILiabilityClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalEntityId = _data["externalEntityId"];
            this.debtorFile = _data["debtorFile"] ? DebtorFileDto.fromJS(_data["debtorFile"]) : <any>undefined;
            this.creditor = _data["creditor"] ? CreditorDto.fromJS(_data["creditor"]) : <any>undefined;
            this.claimType = _data["claimType"];
            this.claimTypeOther = _data["claimTypeOther"];
            this.claimStatus = _data["claimStatus"];
            this.claimStatusOther = _data["claimStatusOther"];
            (<any>this).claimStatusDisplayName = _data["claimStatusDisplayName"];
            this.accountNumber = _data["accountNumber"];
            this.unsecuredSoaAmount = _data["unsecuredSoaAmount"];
            this.securedSoaAmount = _data["securedSoaAmount"];
            this.liabilityType = _data["liabilityType"];
            this.liabilityTypeOther = _data["liabilityTypeOther"];
            this.filedAmount = _data["filedAmount"];
            this.isLetterSent = _data["isLetterSent"];
            this.isCompleted = _data["isCompleted"];
            this.isMeetingRequested = _data["isMeetingRequested"];
            this.is170ReportRequested = _data["is170ReportRequested"];
            this.votedBy = _data["votedBy"];
            this.votedByOther = _data["votedByOther"];
            this.vote = _data["vote"];
            this.voteOther = _data["voteOther"];
        }
    }

    static fromJS(data: any): LiabilityClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiabilityClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalEntityId"] = this.externalEntityId;
        data["debtorFile"] = this.debtorFile ? this.debtorFile.toJSON() : <any>undefined;
        data["creditor"] = this.creditor ? this.creditor.toJSON() : <any>undefined;
        data["claimType"] = this.claimType;
        data["claimTypeOther"] = this.claimTypeOther;
        data["claimStatus"] = this.claimStatus;
        data["claimStatusOther"] = this.claimStatusOther;
        data["claimStatusDisplayName"] = this.claimStatusDisplayName;
        data["accountNumber"] = this.accountNumber;
        data["unsecuredSoaAmount"] = this.unsecuredSoaAmount;
        data["securedSoaAmount"] = this.securedSoaAmount;
        data["liabilityType"] = this.liabilityType;
        data["liabilityTypeOther"] = this.liabilityTypeOther;
        data["filedAmount"] = this.filedAmount;
        data["isLetterSent"] = this.isLetterSent;
        data["isCompleted"] = this.isCompleted;
        data["isMeetingRequested"] = this.isMeetingRequested;
        data["is170ReportRequested"] = this.is170ReportRequested;
        data["votedBy"] = this.votedBy;
        data["votedByOther"] = this.votedByOther;
        data["vote"] = this.vote;
        data["voteOther"] = this.voteOther;
        return data;
    }
}

export interface ILiabilityClaimDto {
    externalEntityId?: string | undefined;
    debtorFile?: DebtorFileDto;
    creditor?: CreditorDto;
    claimType?: ClaimType;
    claimTypeOther?: string | undefined;
    claimStatus?: ClaimStatus;
    claimStatusOther?: string | undefined;
    claimStatusDisplayName?: string | undefined;
    accountNumber?: string | undefined;
    unsecuredSoaAmount?: number | undefined;
    securedSoaAmount?: number | undefined;
    liabilityType?: LiabilityType;
    liabilityTypeOther?: string | undefined;
    filedAmount?: number | undefined;
    isLetterSent?: boolean;
    isCompleted?: boolean;
    isMeetingRequested?: boolean | undefined;
    is170ReportRequested?: boolean;
    votedBy?: ClaimVotedBy;
    votedByOther?: string | undefined;
    vote?: ClaimVote;
    voteOther?: string | undefined;
}

export enum FieldIdentifier {
    None = 0,
    FirstName = 1,
    MiddleName = 2,
    LastName = 3,
    DateOfBirth = 4,
    PreferredLanguage = 5,
    EmailAddress = 6,
    PhoneType = 7,
    PhoneNumber = 8,
    AlternatePhoneType = 9,
    AlternatePhoneNumber = 10,
    StreetNumber = 11,
    StreetName = 12,
    Unit = 13,
    City = 14,
    PostalCode = 15,
    Province = 16,
    Country = 17,
    IntakeSource = 18,
    ReferralSource = 19,
    SMSTemplateId = 20,
    SMSDetail = 21,
    SMSTemplateName = 22,
    SMSTemplateBody = 23,
    ConfirmDeleteFromAscend = 24,
    SessionCompletionInfo = 25,
    PaymentAmount = 26,
    ConfirmTransitionSignupInProgress = 27,
}

export class LookupDto implements ILookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AdminConsumerProposalEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfAdminConsumerProposalEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AdminConsumerProposalEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AppointmentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AppointmentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDebtOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDebtOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BankruptcyDischargeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BankruptcyDischargeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CityTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CityTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CreditorTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CreditorTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DebtDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DebtDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DocumentFolderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DocumentFolderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: EducationLevelEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: EducationLevelEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: GenderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: GenderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IncomeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IncomeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IndustryEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IndustryEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: InsolvencyTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: InsolvencyTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: LTPCodeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: LTPCodeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MaritalStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MaritalStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MeetingTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MeetingTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MessageTemplateTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfMessageTemplateTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MessageTemplateTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalPaymentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfProposalPaymentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalPaymentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalProcessStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfProposalProcessStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalProcessStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalStateEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfProposalStateEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ProposalStateEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: RESPRRSPEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: RESPRRSPEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ReasonForPreferredEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ReasonForPreferredEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAppliesToEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAppliesToEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAvailableEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAvailableEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null implements ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: TaxTypesEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: TaxTypesEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ILookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_2OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ILookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    id?: string | undefined;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
        }
    }

    static fromJS(data: any): LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        return data;
    }
}

export interface ILookupDto_2OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    id?: string | undefined;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
}

export class LookupReadOnlyDto implements ILookupReadOnlyDto {
    orderNumber?: number;
    enumValue?: number;
    code?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    localizationString?: string | undefined;

    constructor(data?: ILookupReadOnlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.enumValue = _data["enumValue"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.localizationString = _data["localizationString"];
        }
    }

    static fromJS(data: any): LookupReadOnlyDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupReadOnlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["enumValue"] = this.enumValue;
        data["code"] = this.code;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["localizationString"] = this.localizationString;
        return data;
    }
}

export interface ILookupReadOnlyDto {
    orderNumber?: number;
    enumValue?: number;
    code?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    localizationString?: string | undefined;
}

export class PhoneTypeLookupDto implements IPhoneTypeLookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: PhoneTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
    canSMS?: boolean;

    constructor(data?: IPhoneTypeLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.frenchName = _data["frenchName"];
            this.enumValue = _data["enumValue"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.localizationString = _data["localizationString"];
            this.descriptionLocalizationString = _data["descriptionLocalizationString"];
            this.canSMS = _data["canSMS"];
        }
    }

    static fromJS(data: any): PhoneTypeLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneTypeLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["code"] = this.code;
        data["name"] = this.name;
        data["frenchName"] = this.frenchName;
        data["enumValue"] = this.enumValue;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["localizationString"] = this.localizationString;
        data["descriptionLocalizationString"] = this.descriptionLocalizationString;
        data["canSMS"] = this.canSMS;
        return data;
    }
}

export interface IPhoneTypeLookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: PhoneTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
    canSMS?: boolean;
}

export class Message implements IMessage {
    fieldIdentifier?: FieldIdentifier;
    relatedEntityId?: string | undefined;
    fieldValue?: string | undefined;
    exceptionMessage?: string | undefined;
    body?: string | undefined;
    messageType?: ResultMessageType;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldIdentifier = _data["fieldIdentifier"];
            this.relatedEntityId = _data["relatedEntityId"];
            this.fieldValue = _data["fieldValue"];
            this.exceptionMessage = _data["exceptionMessage"];
            this.body = _data["body"];
            this.messageType = _data["messageType"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldIdentifier"] = this.fieldIdentifier;
        data["relatedEntityId"] = this.relatedEntityId;
        data["fieldValue"] = this.fieldValue;
        data["exceptionMessage"] = this.exceptionMessage;
        data["body"] = this.body;
        data["messageType"] = this.messageType;
        return data;
    }
}

export interface IMessage {
    fieldIdentifier?: FieldIdentifier;
    relatedEntityId?: string | undefined;
    fieldValue?: string | undefined;
    exceptionMessage?: string | undefined;
    body?: string | undefined;
    messageType?: ResultMessageType;
}

export enum Result {
    Successful = 0,
    Failed = 3,
}

export enum ResultMessageType {
    Success = 0,
    Warning = 1,
    Confirm = 2,
    Error = 3,
    Info = 4,
}

export class SaveResult implements ISaveResult {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    readonly hasConfirm?: boolean;
    readonly hasWarnings?: boolean;
    readonly hasErrors?: boolean;
    result?: Result;

    constructor(data?: ISaveResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["returnIds"])) {
                this.returnIds = [] as any;
                for (let item of _data["returnIds"])
                    this.returnIds!.push(item);
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            (<any>this).hasConfirm = _data["hasConfirm"];
            (<any>this).hasWarnings = _data["hasWarnings"];
            (<any>this).hasErrors = _data["hasErrors"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): SaveResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnId"] = this.returnId;
        if (Array.isArray(this.returnIds)) {
            data["returnIds"] = [];
            for (let item of this.returnIds)
                data["returnIds"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["hasConfirm"] = this.hasConfirm;
        data["hasWarnings"] = this.hasWarnings;
        data["hasErrors"] = this.hasErrors;
        data["result"] = this.result;
        return data;
    }
}

export interface ISaveResult {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    hasConfirm?: boolean;
    hasWarnings?: boolean;
    hasErrors?: boolean;
    result?: Result;
}

export class SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e implements ISaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    readonly hasConfirm?: boolean;
    readonly hasWarnings?: boolean;
    readonly hasErrors?: boolean;
    result?: Result;
    data?: TaxReturnSubmissionPeriodLinkDto[] | undefined;

    constructor(data?: ISaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["returnIds"])) {
                this.returnIds = [] as any;
                for (let item of _data["returnIds"])
                    this.returnIds!.push(item);
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            (<any>this).hasConfirm = _data["hasConfirm"];
            (<any>this).hasWarnings = _data["hasWarnings"];
            (<any>this).hasErrors = _data["hasErrors"];
            this.result = _data["result"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TaxReturnSubmissionPeriodLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnId"] = this.returnId;
        if (Array.isArray(this.returnIds)) {
            data["returnIds"] = [];
            for (let item of this.returnIds)
                data["returnIds"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["hasConfirm"] = this.hasConfirm;
        data["hasWarnings"] = this.hasWarnings;
        data["hasErrors"] = this.hasErrors;
        data["result"] = this.result;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveResult_1OfOfList_1OfOfTaxReturnSubmissionPeriodLinkDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    hasConfirm?: boolean;
    hasWarnings?: boolean;
    hasErrors?: boolean;
    result?: Result;
    data?: TaxReturnSubmissionPeriodLinkDto[] | undefined;
}

export class SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements ISearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    returnId?: string;
    messages?: Message[] | undefined;
    data?: FileSearchOutputDto;
    readonly hasConfirm?: boolean;
    readonly hasWarnings?: boolean;
    readonly hasErrors?: boolean;
    result?: Result;

    constructor(data?: ISearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            this.data = _data["data"] ? FileSearchOutputDto.fromJS(_data["data"]) : <any>undefined;
            (<any>this).hasConfirm = _data["hasConfirm"];
            (<any>this).hasWarnings = _data["hasWarnings"];
            (<any>this).hasErrors = _data["hasErrors"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnId"] = this.returnId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["hasConfirm"] = this.hasConfirm;
        data["hasWarnings"] = this.hasWarnings;
        data["hasErrors"] = this.hasErrors;
        data["result"] = this.result;
        return data;
    }
}

export interface ISearchResult_1OfOfFileSearchOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    returnId?: string;
    messages?: Message[] | undefined;
    data?: FileSearchOutputDto;
    hasConfirm?: boolean;
    hasWarnings?: boolean;
    hasErrors?: boolean;
    result?: Result;
}

export class SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements ISearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    returnId?: string;
    messages?: Message[] | undefined;
    data?: LiabilityClaimDto;
    readonly hasConfirm?: boolean;
    readonly hasWarnings?: boolean;
    readonly hasErrors?: boolean;
    result?: Result;

    constructor(data?: ISearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            this.data = _data["data"] ? LiabilityClaimDto.fromJS(_data["data"]) : <any>undefined;
            (<any>this).hasConfirm = _data["hasConfirm"];
            (<any>this).hasWarnings = _data["hasWarnings"];
            (<any>this).hasErrors = _data["hasErrors"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnId"] = this.returnId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["hasConfirm"] = this.hasConfirm;
        data["hasWarnings"] = this.hasWarnings;
        data["hasErrors"] = this.hasErrors;
        data["result"] = this.result;
        return data;
    }
}

export interface ISearchResult_1OfOfLiabilityClaimDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    returnId?: string;
    messages?: Message[] | undefined;
    data?: LiabilityClaimDto;
    hasConfirm?: boolean;
    hasWarnings?: boolean;
    hasErrors?: boolean;
    result?: Result;
}

export enum AdminConsumerProposalEnum {
    AcceptProposal = 0,
    DoNotAcceptProposal = 1,
    NoRecommendation = 2,
}

export enum AnswerEnum {
    Yes = 0,
    No = 1,
    PreferNotToAnswer = 2,
}

export enum AppFileDescendantType {
    Duplicate = 1,
    New = 2,
}

export enum AppFormStatusEnum {
    NotStarted = 0,
    Incomplete = 1,
    Incomplete_Review = 2,
    ReadyForReview = 3,
    Reviewed = 4,
    Complete = 5,
}

export enum AppTaskActionNameEnum {
    CallMade_Attempt_1 = 0,
    CallMade_Attempt_2 = 1,
    CallMade_Attempt_3 = 2,
    CallMade_Attempt_4 = 3,
    EmailSent_Attempt_1 = 4,
    EmailSent_Attempt_2 = 5,
    EmailSent_Attempt_3 = 6,
    EmailSent_Attempt_4 = 7,
    DidNotAttend = 8,
    Attended = 9,
    ClaimReceived = 10,
    CallReceived = 11,
    EmailReceived = 12,
    WebformRequest = 13,
    AppointmentScheduled = 14,
    AppointmentRescheduled = 15,
    NoShow = 16,
    Trustee_EngagementAcceptanceAndRiskAssessment = 17,
    Trustee_RiskManagement = 18,
    ReviewSent = 19,
    ReviewAccepted = 20,
    ReviewRejected = 21,
    ApprovalSent = 22,
    ApprovalAccepted = 23,
    ApprovalRejected = 24,
    SignSent = 25,
    SignAccepted = 26,
    SignRejected = 27,
    PendingReview = 28,
    PendingApproval = 29,
    PendingSign = 30,
    SecuredClaim = 31,
    ClaimAlertPendingReview = 32,
    NewIandESubmission = 35,
    IandEMissedSubmission = 36,
    TaxReturnsAddedFromAscend = 37,
    TaxReturnsNOANextProcess = 38,
    NewTaxReturnSubmission = 39,
    PADInfoUpdateRequest = 41,
    ChequePadHoldRequest = 42,
    ChequePADHoldNotification = 43,
    HoldRequestedReminder = 44,
    OnHoldReminder = 45,
    Process170Pending = 46,
    OppositionResponseReceived = 47,
    WithdrawOpposition = 48,
    CourtAppearanceAccepted = 49,
    CourtAppearanceRejected = 50,
    CourtDischargePending = 51,
    PostMediationMonitor = 52,
    MediationFailed = 53,
    ComplianceReview = 54,
    CourtFeesChequeRequest = 55,
    CourtAppearanceRequested = 56,
    TaxReturnAlert = 57,
    InterimDividendScheduled = 58,
    TrusteeDischargePending = 59,
    ProposalAccepted = 60,
    CourtRevivalRequested = 61,
    PaymentArrearWarning = 62,
    MeetingWithCreditorsCompleted = 63,
    IncomeExpenseAlert = 64,
    NewIandEUpload = 65,
    NewTaxReturnUpload = 66,
    MeetingWithCreditorsAccepted = 67,
    ProcessDividendPayment = 68,
    CertificateofFullPerformance = 69,
    DividendChecklistApproved = 71,
    DividendChecklistRejected = 72,
    DividendChecklistSigned = 73,
    DividendChecklistPendngReview = 74,
    SrdChecklistApproved_Proposal = 75,
    SrdChecklistRejected_Proposal = 76,
    SrdChecklistSigned_Proposal = 77,
    SrdChecklistPendingReview_Proposal = 78,
    SrdChecklistApproved_Bankruptcy = 79,
    SrdChecklistRejected_Bankruptcy = 80,
    SrdChecklistSigned_Bankruptcy = 81,
    SrdChecklistPendingReview_Bankruptcy = 82,
    PadInfoUpdateNotification = 83,
    ProposalRevivalRequested = 84,
    ProposalNonRevivalFinalSRD = 85,
    ProposalNonRevivalNotification = 86,
    CourtRevivalCompleted = 87,
    AssetReviewRequired = 88,
    GSTHSTRefundPending = 89,
    DischargeCertificatePending = 90,
    MediationPending = 91,
    OppositionFollowUp = 92,
    OppositionCourtDischargePending = 93,
    RecommendationPending = 94,
    ConditionalSixtyDayWarning = 95,
    ReadyforClosure = 96,
    SurplusPaymentCheck = 97,
    TaxReturnNOAReminder = 98,
    TaxReturnListAdded = 99,
    ApprovalStatusMeetingRequested = 100,
    ProposalPending = 101,
    ReviewRevival = 102,
    PaymentArrearDeemedAnnulled = 103,
    TwentyFiveDayCheckDeemedAnnulled = 104,
    PendingCertificateofFullPerformance = 105,
    ClaimAlert = 106,
    MeetingWithCreditors = 107,
    ApprovalStatusApproved = 108,
    FollowUp = 109,
    PADInfoUpdateNotification = 110,
    CourtDateReview = 111,
    CreditorNoticeNotSent = 112,
    AmendmentRequired = 113,
    UnsecuredClaim = 114,
    AppointmentRequested = 115,
    ClientPortalMessage = 116,
    ClientPortalUpload = 117,
    TaxT1Adjustment = 118,
    TaxInBank = 119,
    TaxNOANORAReview = 120,
    TaxInquiry = 121,
    ChequeRequisition = 122,
    DividendInquiry = 123,
    RequestToRecoverFunds = 124,
    RequestForCourtFee = 125,
    PADSetupInitial = 126,
    PADSetupUpdate = 127,
    BankReconciliationReport = 128,
    InterimDividend = 129,
    UrgentRequest = 130,
    FinalOrdinaryDivisionI = 131,
    FinalSummary = 132,
    FinalProposal = 133,
    FinalSupplemental = 134,
    CourtUndischargedBankruptInquiry = 135,
    CourtDischargeReview = 136,
    CourtLetterRequested = 137,
    CourtDiv1CourtApprovalRequired = 138,
    CourtRevivalRequired = 139,
    CourtTaxationRequired = 140,
    CourtTrusteeDischargeRequired = 141,
    CourtFileStatusUpdate = 142,
    CourtCourtOrder = 143,
    CourtNoOrderDispositionSheet = 144,
    CourtForm81 = 145,
    DischargeReview = 146,
    FollowUpAssetReview = 147,
    SessionRequired_1st = 148,
    SessionRequired_2nd = 149,
    CreditBureauInquiry = 150,
    StatusLetterStudentLoanLetter = 151,
    Process170Urgent = 152,
    Other = -1,
}

export enum AppTaskActionStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    Other = -1,
}

export enum AppTaskNameEnum {
    NewProspect = 0,
    FollowUpProspect = 1,
    Appointment = 2,
    SignUp = 3,
    FollowUp = 4,
    POC = 5,
    IaEReceived = 6,
    TaxReturnReceived = 7,
    DocumentReview = 8,
    DocumentApproval = 9,
    DocumentSign = 10,
    DocumentVerification = 11,
    SecuredClaim = 12,
    ClaimAlert = 13,
    IandESubmission = 16,
    IandEMissedSubmission = 17,
    TaxReturns = 18,
    TaxReturnSubmission = 19,
    PADInfoUpdateRequest = 21,
    ChequePadHoldRequest = 22,
    ChequePADHoldNotification = 23,
    HoldRequestedReminder = 24,
    OnHoldReminder = 25,
    Process170Pending = 26,
    CourtDischargePending = 27,
    CourtFeesChequeRequest = 28,
    CourtAppearanceRequested = 29,
    TaxReturnAlert = 30,
    InterimDividendScheduled = 31,
    TrusteeDischargePending = 32,
    ProposalUpdate = 33,
    CourtRevivalRequested = 34,
    CreditorNoticeNotSent = 35,
    PaymentArrearWarning = 36,
    IncomeExpenseAlert = 37,
    IandEUpload = 38,
    TaxReturnUpload = 39,
    AppointmentInitialConsultation = 40,
    AppointmentFollowUpConsultation = 41,
    AppointmentCounselling_1st = 42,
    AppointmentCounselling_2nd = 43,
    AppointmentCounselling_3rd = 44,
    AppointmentMeetingWithCreditors = 45,
    ProposalRevivalRequested = 46,
    ProposalNonRevivalFinalSRD = 47,
    ProposalNonRevivalNotification = 48,
    WebformRequest = 49,
    AssetReviewRequired = 50,
    FollowUpClaim = 51,
    FollowUpDischarge = 52,
    FollowUpBanking = 53,
    FollowUpIandE = 54,
    FollowUpTaxReturn = 55,
    FollowUpProposal = 56,
    FollowUpReceiptsDisbursements = 57,
    FollowUpCounselling = 58,
    FollowUpSigned = 59,
    PADInfoUpdateNotification = 60,
    GSTHSTRefundPending = 61,
    ReadyforClosure = 62,
    SurplusPaymentCheck = 63,
    ReviewRevival = 64,
    PaymentArrearDeemedAnnulled = 65,
    TwentyFiveDayCheckDeemedAnnulled = 66,
    ProcessDividendPayment = 67,
    PendingCertificateofFullPerformance = 68,
    MeetingWithCreditors = 70,
    AppointmentFollowUp = 71,
    ClientPortalMessage = 72,
    ClientPortalUpload = 73,
    TaxT1Adjustment = 74,
    TaxInBank = 75,
    TaxNOANORAReview = 76,
    TaxInquiry = 77,
    ChequeRequisition = 78,
    DividendInquiry = 79,
    RequestToRecoverFunds = 80,
    RequestForCourtFee = 81,
    PADSetupInitial = 82,
    PADSetupUpdate = 83,
    BankReconciliationReport = 84,
    InterimDividend = 85,
    UrgentRequest = 86,
    FinalOrdinaryDivisionI = 87,
    FinalSummary = 88,
    FinalProposal = 89,
    FinalSupplemental = 90,
    CourtUndischargedBankruptInquiry = 91,
    CourtDischargeReview = 92,
    CourtLetterRequested = 93,
    CourtDiv1CourtApprovalRequired = 94,
    CourtRevivalRequired = 95,
    CourtTaxationRequired = 96,
    CourtTrusteeDischargeRequired = 97,
    CourtFileStatusUpdate = 98,
    CourtCourtOrder = 99,
    CourtNoOrderDispositionSheet = 100,
    CourtForm81 = 101,
    DischargeReview = 102,
    FollowUpAssetReview = 103,
    UrgentSessionRequired = 104,
    CreditBureauInquiry = 105,
    StatusLetterStudentLoanLetter = 106,
    Process170Urgent = 107,
    Other = -1,
}

export enum AppTaskStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    Other = -1,
}

export enum AppointmentStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    NoShow = 3,
    Unknown = -1,
}

export enum AppointmentTimeRangeEnum {
    Any = 0,
    Morning = 1,
    Afternoon = 2,
    Evening = 3,
}

export enum AppointmentTypeEnum {
    InitialConsultation = 0,
    FollowUpConsultation = 1,
    Counselling_1st = 2,
    Counselling_2nd = 3,
    Counselling_3rd = 4,
    MeetingWithCreditors = 5,
    Unknown = -1,
}

export enum AssetDebtOwnershipTypeEnum {
    Applicant = 0,
    Spouse = 1,
    Joint = 2,
}

export enum AssetDescriptionEnum {
    Cash = 0,
    GIC = 1,
    Savings = 2,
    TFSA = 3,
    Other_CashOrSavings = 4,
    HouseholdFurnitureAndEffects = 5,
    Other_Furniture = 6,
    Jewelry = 7,
    PersonalEffects = 8,
    Other_PersonalEffects = 9,
    LifeInsurance = 10,
    RRSP = 11,
    RRIF = 12,
    LIRA = 13,
    RESP = 14,
    Shares = 15,
    Bonds = 16,
    Investments = 17,
    CoopShares = 18,
    CreditUnionShares = 19,
    RDSP = 20,
    Pension = 21,
    Other_InvestmentsOrPolicies = 22,
    House = 23,
    Condo = 24,
    Land = 25,
    Cottage = 26,
    Other_RealEstate = 27,
    Automobile = 28,
    Boat = 31,
    Trailer = 32,
    Camper = 33,
    ATV = 34,
    Other_RecreationalEquipment = 35,
    TaxRefund = 36,
    ToolsOfTrade = 37,
    HuntingTools = 38,
    FishingTools = 39,
    FarmingTools = 40,
    Motorcycle_MotorVehicles = 41,
    Snowmobile_MotorVehicles = 42,
    Other_MotorVehicles = 43,
}

export enum AssetTypeEnum {
    CashOrSavings = 0,
    Furniture = 1,
    PersonalEffects = 2,
    InvestmentsOrPolicies = 3,
    RealEstate = 4,
    MotorVehicles = 5,
    RecreationalEquipment = 6,
    TaxRefund = 7,
    Other = 8,
}

export enum AssignSignatureStatusEnum {
    CreateNewSignatureSuccess = 1,
    AssignExistingSignatureSuccess = 2,
    AssignSignatureFailure = 3,
}

export enum Auth0ChangeStatusEnum {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    Failed = 3,
    Unknown = -1,
}

export enum Auth0ChangeTypeEnum {
    EmailUpdate = 0,
    LanguageUpdate = 1,
    AccountCreation = 2,
    Unknown = -1,
}

export enum BankruptcyDischargeTypeEnum {
    AbsoluteAfterConditional = 0,
    AbsoluteAfterSuspended = 1,
    AbsoluteDischarge = 2,
    AdjournedSineDie = 3,
    Annulled = 4,
    Automatic = 5,
    Automatic1stNoSI = 6,
    Automatic1stWithSI = 7,
    Automatic2ndNoSI = 8,
    Automatic2ndWithSI = 9,
    Cancelled = 10,
    Conditional = 11,
    ConditionalAgreedUpon = 12,
    ConditionalCourtOrdered = 13,
    Deceased = 14,
    DischargeSuspended = 15,
    Failed = 16,
    HearingSet = 17,
    MediationConditionsMet = 18,
    MediationRequested = 19,
    NoOrder = 20,
    Opposition = 21,
    Refused = 22,
    TrusteeConditionsMet = 23,
}

export enum BankruptcyTypeEnum {
    Ordinary = 0,
    SummaryJoint = 1,
    SummaryIndividual = 2,
    NotJointOrdinary = 3,
}

export enum BusinessOwnershipTypeEnum {
    Cooperative = 0,
    Corporation = 1,
    LimitedLiabilityCompany = 2,
    Partnership = 3,
    SoleProprietorship = 4,
}

export enum BusinessTypeEnum {
    AccommodationAndFoodServices = 0,
    AdministrativeAndSupportWasteManagementAndRemediationServices = 1,
    AgricultureForestryFishingAndHunting = 2,
    ArtsEntertainmentAndRecreation = 3,
    Construction = 4,
    EducationalServices = 5,
    FinanceAndInsurance = 6,
    HealthCareAndSocialAssistance = 7,
    InformationAndCulturalIndustries = 8,
    ManagementOfCompaniesAndEnterprises = 9,
    Manufacturing = 10,
    MiningQuarryingAndOilAndGasExtraction = 11,
    OtherServices = 12,
    ProfessionalScientificAndTechnicalServices = 13,
    PublicAdministration = 14,
    RealEstateAndRentalAndLeasing = 15,
    RetailTrade = 16,
    TransportationAndWarehousing = 17,
    Utilities = 18,
    Wholesale = 19,
}

export enum ChecklistStatusEnum {
    Pending = 1,
    Incomplete = 2,
    Complete = 3,
}

export enum ChecklistTypeEnum {
    BankruptcySignupDocuments = 1,
    ConsumerProposalSignupDocuments = 2,
    Asset = 21,
    Claim = 22,
    Report170 = 41,
    FinalSrdSA = 61,
    FinalSrdCP = 62,
    ConsumerProposal45DayReview = 81,
    ConsumerProposalDividend = 82,
}

export enum CityTypeEnum {
    City = 0,
    Community = 1,
    County = 2,
    District = 3,
    Hamlet = 4,
    Municipalite = 5,
    Municipality = 6,
    RegonalMunicipality = 7,
    Reserve = 8,
    ResortMunicipality = 9,
    State = 10,
    Town = 11,
    Township = 12,
    UnincorporatedArea = 13,
    Village = 14,
    Ville = 15,
}

export enum ClaimFileStateEnum {
    Inactive = 0,
    Active = 1,
    Duplicate = 2,
    Complete = 3,
}

export enum ClaimFileStatusEnum {
    Admitted = 0,
    NotProved = 1,
    Disallowed = 2,
    AdminCompleted = 3,
    AmountDiscrepancy = 4,
    AmountPostInsolvencyDate = 5,
    BankruptcyHighwayConfirmations = 6,
    CalculationVerification = 7,
    Correspondence = 8,
    CreditorsSignatureMissing = 9,
    DateDiscrepancy = 10,
    Deficiency = 11,
    DuplicateClaim = 12,
    FCTClaim = 13,
    FileClosed = 14,
    InsufficientToAdmit = 15,
    MergeTag = 16,
    MissingScheduleA = 17,
    NameDiscrepancy = 18,
    RequestsForAdditionalInformation = 19,
    RightToPriority = 20,
    SecuredClaimsForward = 21,
    StatuteBarred = 22,
    Unsecured = 23,
    UnsecuredReview = 24,
    AssetDisposed = 25,
    InsufficientToProcessSecured = 26,
    LienRemoval = 27,
    MissingSecurityAgreementSecured = 28,
    MissingSecurityDetails = 29,
    MissingSecurityRegistration = 30,
    Property = 31,
    RightToPrioritySecured = 32,
    Secured = 33,
    SecuredReview = 34,
    Withdrawn = 35,
}

export enum ClaimFileStatusGroupEnum {
    UnsecuredClaims = 0,
    SecuredClaims = 1,
}

export enum CounsellingSessionTypeEnum {
    Individual = 1,
    Group = 2,
}

export enum CourtDischargeStatusEnum {
    Monitor = 0,
    MediationFailed = 1,
    Opposition = 2,
}

export enum CreditorTypeEnum {
    Secured = 0,
    Unsecured = 1,
    DeemedTrust = 2,
    Deferred = 3,
    Contingent = 4,
    Preferred = 5,
    Property = 6,
}

export enum DebtDescriptionEnum {
    AutoLoan = 0,
    CreditCard = 1,
    LineOfCredit = 2,
    Mortgage = 3,
    Overdraft = 4,
    PaydayLoan = 5,
    PersonalLoan = 6,
    StudentLoan = 7,
    Taxes = 8,
    CreditReportCollection = 9,
    CreditReportTrade = 10,
    CreditReportRegisteredItem = 11,
    Other = 12,
}

export enum DischargeComplianceNotificationStatusEnum {
    Pending = 0,
    Complete = 1,
}

export enum DischargeCourtAppearanceNotificationStatusEnum {
    Pending = 0,
    Requested = 1,
    Accepted = 2,
    Rejected = 3,
}

export enum DischargeMediationModeEnum {
    Email = 0,
    Phone = 1,
    InPerson = 2,
}

export enum DischargeMediationStatusEnum {
    Successful = 1,
    Unsuccessful = 2,
}

export enum DocumentFolderEnum {
    Assets = 1,
    Claims = 2,
    Correspondence = 3,
    Discharge = 4,
    Lead = 5,
    SurplusIE = 6,
    Banking = 7,
    Taxes = 8,
    ClientUpload = 9,
}

export enum DocumentPrefixContextEnum {
    Form56Upload = 1,
    Form93Upload = 2,
    Form95Upload = 4,
    Form96Upload = 8,
    ProposalChecklist = 16,
    ProposalCourtRevival = 32,
}

export enum DocumentTypeEnum {
    PDF = 1,
    DOCX = 2,
    DOC = 3,
    XLSX = 4,
    XLS = 5,
    CSV = 6,
    PPT = 7,
    PPTX = 8,
    MSG = 9,
    JPG = 10,
    JPEG = 11,
    BMP = 12,
    PNG = 13,
    GIF = 14,
    HEIC = 15,
    AVIF = 16,
    TIFF = 17,
    WEBP = 18,
    Unknown = -1,
}

export enum DocumentVerificationRoleResultEnum {
    Pending = 0,
    Accept = 1,
    Reject = 2,
}

export enum DocumentVerificationRoleTypeEnum {
    Reviewer = 0,
    Approver = 1,
    Signee = 2,
}

export enum DocumentVerificationStatusEnum {
    Pending = 0,
    PartiallyCompleted = 1,
    Completed = 2,
    Rejected = 3,
}

export enum EducationLevelEnum {
    ZeroToEightYears = 0,
    SomeHighSchool = 1,
    HighSchoolDiploma = 2,
    SomePostSecondary = 3,
    PostSecondaryCertificateOrDiploma = 4,
    UniversityDegree = 5,
    Unknown = 6,
    IPreferNotToAnswer = 7,
}

export enum ExpenseDescriptionEnum {
    ChildSupportPayments = 0,
    SpousalSupportPayments = 1,
    ChildCare = 2,
    MedicalOrDentalOrPrescription = 3,
    FinesOrPenaltiesImposedByCourt = 4,
    AsAConditionOfEmployment = 5,
    DebtsWhereStayHasBeenLifted = 6,
    Other_NonDiscretionary = 7,
    RentOrMortgageOrHypothec = 8,
    PropertyTaxesOrCondoFees = 9,
    HeatOrGasOrOil = 10,
    TelephoneOrCellPhone = 11,
    CableOrStreamingServices = 12,
    Electricity = 13,
    Water = 14,
    Furniture = 15,
    Other_Housing = 16,
    FoodOrGrocery = 17,
    LaundryOrDryCleaning = 18,
    GroomingOrToiletries = 19,
    Clothing = 20,
    Other_Living = 21,
    CarLeaseOrFinancePayments = 22,
    RepairOrMaintenanceOrGas = 23,
    PublicTransportation = 24,
    Other_Transportation = 25,
    TobaccoOrVapingOrCannabis = 26,
    Alcohol = 27,
    MealsOrRestaurants = 28,
    EntertainmentOrSports = 29,
    GiftsOrCharitableDonations = 30,
    Allowances = 31,
    Other_Personal = 32,
    Vehicle = 33,
    Home = 34,
    FurnitureOrContents = 35,
    LifeInsurance = 36,
    Other_Insurance = 37,
    ProposalPayments = 38,
    BankruptcyPayments = 39,
    ToSecuredCreditors = 40,
    Other_Payments = 41,
    Prescriptions = 42,
    Dental = 43,
    Other_Medical = 44,
    ToProviderOfFinancialAdvice = 45,
    ToTheEstate = 46,
    Internet = 47,
    VehicleInsurnceOrRegistration = 48,
}

export enum ExpenseTypeEnum {
    NonDiscretionary = 0,
    Housing = 1,
    Living = 2,
    Transportation = 3,
    Personal = 4,
    Insurance = 5,
    Payments = 6,
    Medical = 7,
}

export enum FileProcessEnum {
    Prospect = 0,
    SignUp = 1,
    Counselling = 2,
    Claims = 3,
    Asset = 4,
    Preferences = 5,
    IandE = 6,
    TaxReturn = 7,
    Banking = 8,
    DebtorDischarge = 9,
    TrusteeDischarge = 10,
    Day45Review = 11,
    MeetingWithCreditors = 12,
    DocumentVerification = 13,
    WebformRequest = 14,
    Closed = 15,
    Court = 16,
    Unknown = -1,
}

export enum FileProcessStatusEnum {
    Complete = 1,
    Incomplete = 2,
    InProgress = 3,
    Pending = 4,
    Exception = 5,
}

export enum FileStageEnum {
    NewProspect = 0,
    PreSignup = 1,
    Signed = 2,
    FileInProcess = 3,
    Closed = 4,
    Annulled = 5,
    Transferred = 6,
    StatusChanged = 7,
}

export enum FilingTypeEnum {
    Ordinary = 0,
    Summary = 1,
    DivisionI = 2,
    DivisionII = 3,
}

export enum GenderEnum {
    Male = 0,
    Female = 1,
    Other = 2,
    PreferNotToAnswer = 3,
}

export enum IncomeExpenseMarkAsReviewTypeEnum {
    Both = 0,
    Income = 1,
    Expense = 2,
}

export enum IncomeExpensePeriodStatusEnum {
    Pending = 0,
    Received = 1,
    Completed = 2,
    MissingInformation = 3,
    DiscrepancyNotice = 4,
    AmendmentRequired = 5,
}

export enum IncomeExpenseSubmissionStateEnum {
    Inactive = 0,
    Active = 1,
}

export enum IncomeExpenseSubmissionStatusEnum {
    Admitted = 0,
    NotAdmitted = 1,
}

export enum IncomeTypeEnum {
    EmploymentIncome = 0,
    PensionOrAnnuities = 1,
    ChildSupport = 2,
    SpousalSupport = 3,
    EmploymentInsuranceBenefits = 4,
    SocialAssistance = 5,
    SelfEmploymentIncome = 6,
    ChildTaxBenefit = 7,
    Other = 8,
    RentalIncome = 9,
    GovernmentBenefits = 10,
    OtherBenefits = 11,
}

export enum IndustryEnum {
    Healthcare = 0,
    Education = 1,
    InformationTechnology = 2,
    Engineering = 3,
    Finance = 4,
    SalesAndMarketing = 5,
    Legal = 6,
    ArtsAndMedia = 7,
    Hospitality = 8,
    ConstructionAndTrades = 9,
    Transportation = 10,
    Manufacturing = 11,
    Retail = 12,
    Government = 13,
    ScienceAndResearch = 14,
    SocialServices = 15,
    Agriculture = 16,
    RealEstate = 17,
    HumanResources = 18,
    CustomerService = 19,
    Security = 20,
    SportsAndRecreation = 21,
    SelfEmployed = 22,
    Student = 23,
    Other = 24,
}

export enum InsolvencyTypeEnum {
    Bankruptcy = 0,
    Proposal = 1,
}

export enum LTPCodeEnum {
    Other = 0,
    BankLoansExceptRealPropertyMortgage = 1,
    CreditCardsBankOrTrustCompany = 2,
    CreditCardsOther = 3,
    FinanceCompanyLoans = 4,
    LoansFromIndividuals = 5,
    RealPropertyMortgage = 6,
    StudenLoans = 7,
    GovernmentTaxes = 8,
    CreditCardsStores = 9,
    TaxesFederal = 10,
    PaydayLoans = 11,
    Utilities = 12,
    FuturePaymentsOtherFinancialAdvisors = 13,
}

export enum LanguageEnum {
    English = 1,
    French = 2,
    BiLingual = 3,
}

export enum MaritalStatusEnum {
    Married = 0,
    Single = 1,
    Divorced = 2,
    CommonLaw = 3,
    Widowed = 4,
    Separated = 5,
}

export enum MeetingTypeEnum {
    InPerson = 0,
    Phone = 1,
    Unknown = -1,
}

export enum MessageTemplateTypeEnum {
    Email = 0,
    Sms = 1,
}

export enum MethodOfDeliveryEnum {
    InPerson = 1,
    Phone = 2,
    Video = 3,
}

export enum NWTerritoryCommunityNameEnum {
    Aklavik = 0,
    ColvilleLake = 1,
    Deline = 2,
    FortGoodHope = 3,
    FortLiard = 4,
    FortMcPherson = 5,
    FortProvidence = 6,
    FortResolution = 7,
    FortSimpson = 8,
    FortSmith = 9,
    HayRiver = 10,
    Holman = 11,
    Inuvik = 12,
    JeanMarieRiver = 13,
    Kakisa = 14,
    Lutselke = 15,
    NahannieButte = 16,
    NotApplicable = 17,
    NormalWells = 18,
    Paulatuk = 19,
    RaeLakes = 20,
    RaeEdzo = 21,
    SachsHarbour = 22,
    Tsiigehtchic = 23,
    Tuktoyaktuk = 24,
    Tulita = 25,
    WhaTi = 26,
    Wrigley = 27,
    Yellowknife = 28,
}

export enum OSBAndOtherFeeTypeEnum {
    FilingFeeSummarySingle = 0,
    FilingFeeSummarySinglePreviousPB = 1,
    FilingFeeOrdinaryPrimaryPartnership = 2,
    FilingFeeProposalDivisionISinglePrimaryJoint = 3,
    FilingFeeProposalDivisionIISinglePrimaryJoint = 4,
    CounsellingFees = 5,
    DivisionIIOnFilingofProposal = 6,
    DivisionIIOnApprovalDeemedApproval = 7,
    DivisionIOnFilingofProposal = 8,
    DivisionIOnApprovalDeemedApprovalunder100k = 9,
    DivisionIOnApprovalDeemedApprovalover100k = 10,
    DivisionICounsellingFees = 11,
}

export enum PADRequestReviewStatusEnum {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
}

export enum PADSchedulePaymentStatusEnum {
    NotDeposited = 0,
    Deposited = 1,
    Pending = 2,
}

export enum PADScheduleStateEnum {
    Active = 0,
    HoldRequested = 1,
    OnHold = 2,
    RequestRejected = 3,
    Canceled = 4,
}

export enum PhoneTypeEnum {
    Mobile = 0,
    Home = 1,
    Work = 2,
    Fax = 3,
}

export enum PreSignupProgressEnum {
    NotStarted = 0,
    InitialConsultation = 1,
    GatherDocuments = 2,
    SignUp = 3,
    FileInProgress = 4,
}

export enum ProposalPaymentStatusEnum {
    CourtRevival = 0,
    Completed = 1,
    WarningIssued = 2,
    AutoRevived = 3,
    DeemedAnnulled = 4,
    RevivalWarranted = 5,
    Opposed = 6,
    RevivalRequested = 7,
    NonRevival = 8,
}

export enum ProposalProcessStatusEnum {
    Pending = 0,
    InProgress = 1,
    Completed = 2,
}

export enum ProposalStateEnum {
    Accepted = 0,
    Rejected = 1,
    Withdrawn = 2,
}

export enum ProposalTypeEnum {
    ConsumerProposal = 0,
    DivisionI = 1,
}

export enum RESPRRSPEnum {
    Exempt = 0,
}

export enum ReasonForPreferredEnum {
    A = 0,
    B = 1,
    C = 2,
    D = 3,
    D1 = 4,
    E = 5,
    F = 6,
    G = 7,
    H = 8,
    I = 9,
    J = 10,
}

export enum ReceiptPaymentMethodEnum {
    Cash = 100,
    Cheque = 200,
    Other = 500,
}

export enum ReceiptPostTypeEnum {
    Estate = 100,
    Holding = 200,
    PrefilingAccount = 400,
}

export enum ReceiptTypeEnum {
    General = 1,
    Scheduled = 2,
}

export enum ResidenceAppliesToEnum {
    Household = 0,
    Individual = 1,
}

export enum ResidenceAvailableEnum {
    Always = 0,
    Limited = 1,
}

export enum ResultCalculationsFieldValueEnum {
    None = 0,
    Exempt = 1,
    NotApplicable = 2,
    SumOfValues = 3,
}

export enum SortingFieldEnum {
    Id = 0,
    FirstName = 1,
    MiddleName = 2,
    LastName = 3,
    PhoneNumber = 4,
    EmailAddress = 5,
    Status = 6,
    CreationTime = 7,
}

export enum SuperintendentTypeEnum {
    Standard = 0,
    Custom = 1,
}

export enum SupportingDocumentStatusEnum {
    Pending = 0,
    Uploaded = 1,
    Reviewed = 2,
}

export enum SupportingDocumentTypeEnum {
    ID = 0,
    ID_Spouse = 1,
    Asset = 2,
    Income = 3,
    Expense = 4,
    IncomeTax = 5,
    IncomeTax_Spouse = 6,
    BankingInfo = 7,
    Business = 8,
    NilIncomeBankStatement = 9,
}

export enum TaxReturnSubmissionSourceEnum {
    Debtor = 0,
    Spouse = 1,
    Other = 2,
}

export enum TaxReturnSubmissionStateEnum {
    Inactive = 0,
    Active = 1,
    Duplicate = 2,
    Complete = 3,
}

export enum TaxReturnSubmissionStatusEnum {
    Admitted = 0,
    NotAdmitted = 1,
    ReturnFiled = 2,
    WaitingOnInformation = 3,
    InProgress = 4,
}

export enum TaxReturnSubmissionTypeEnum {
    NOA = 0,
    TaxReturnFiling = 1,
}

export enum TaxStatusEnum {
    PendingTaxReturn = 0,
    ReceivedTaxReturn = 1,
    PendingNOA = 2,
    ReceivedNOA = 3,
    Completed = 4,
}

export enum TaxTypesEnum {
    GST = 0,
    HST = 1,
    GSTQST = 2,
}

export enum TeamTypeEnum {
    POC_CPC = 0,
    Asset_CPC = 1,
    IandE_CPC = 2,
    Tax_CPC = 3,
    Banking_CPC = 4,
    Court_CPC = 5,
    Report_170_CPC = 6,
    Proposal_CPC = 7,
    SRD_CPC = 8,
    Trustee = 9,
    FLA = 10,
    Agent = 11,
    Counselling_POD = 12,
}

export class PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentPrefixDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentPrefixDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfDocumentPrefixDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentPrefixDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: HolidayDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HolidayDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfHolidayDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: HolidayDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: MessageTemplateDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MessageTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfMessageTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: MessageTemplateDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: WorkflowTemplateDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WorkflowTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfWorkflowTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: WorkflowTemplateDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AgentDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AgentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAgentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AgentDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: TeamDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TeamDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: TeamDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppEmailTemplateDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppEmailTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAppEmailTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppEmailTemplateDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppEmailDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppEmailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAppEmailDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppEmailDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppTaskActionDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppTaskActionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAppTaskActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppTaskActionDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppTaskDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppTaskDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAppTaskDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppTaskDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ApplicationFileDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfApplicationFileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ApplicationFileDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppointmentInfoDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppointmentInfoDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppointmentInfoDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentVerificationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentVerificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfDocumentVerificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentVerificationDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentVersionDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentVersionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfDocumentVersionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentVersionDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NoteDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfNoteDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NoteDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NotificationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NotificationDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: OfficeLocationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OfficeLocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: OfficeLocationDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ReceiptDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReceiptDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfReceiptDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: ReceiptDto[] | undefined;
    totalCount?: number;
}

export class PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: SupportingDocumentDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SupportingDocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: SupportingDocumentDto[] | undefined;
    totalCount?: number;
}

export class ApplicationAuthConfigurationDto implements IApplicationAuthConfigurationDto {
    grantedPolicies?: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationAuthConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["grantedPolicies"]) {
                this.grantedPolicies = {} as any;
                for (let key in _data["grantedPolicies"]) {
                    if (_data["grantedPolicies"].hasOwnProperty(key))
                        (<any>this.grantedPolicies)![key] = _data["grantedPolicies"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationAuthConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAuthConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grantedPolicies) {
            data["grantedPolicies"] = {};
            for (let key in this.grantedPolicies) {
                if (this.grantedPolicies.hasOwnProperty(key))
                    (<any>data["grantedPolicies"])[key] = (<any>this.grantedPolicies)[key];
            }
        }
        return data;
    }
}

export interface IApplicationAuthConfigurationDto {
    grantedPolicies?: { [key: string]: boolean; } | undefined;
}

export class ApplicationConfigurationDto implements IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    globalFeatures?: ApplicationGlobalFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;
    extraProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IApplicationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localization = _data["localization"] ? ApplicationLocalizationConfigurationDto.fromJS(_data["localization"]) : <any>undefined;
            this.auth = _data["auth"] ? ApplicationAuthConfigurationDto.fromJS(_data["auth"]) : <any>undefined;
            this.setting = _data["setting"] ? ApplicationSettingConfigurationDto.fromJS(_data["setting"]) : <any>undefined;
            this.currentUser = _data["currentUser"] ? CurrentUserDto.fromJS(_data["currentUser"]) : <any>undefined;
            this.features = _data["features"] ? ApplicationFeatureConfigurationDto.fromJS(_data["features"]) : <any>undefined;
            this.globalFeatures = _data["globalFeatures"] ? ApplicationGlobalFeatureConfigurationDto.fromJS(_data["globalFeatures"]) : <any>undefined;
            this.multiTenancy = _data["multiTenancy"] ? MultiTenancyInfoDto.fromJS(_data["multiTenancy"]) : <any>undefined;
            this.currentTenant = _data["currentTenant"] ? CurrentTenantDto.fromJS(_data["currentTenant"]) : <any>undefined;
            this.timing = _data["timing"] ? TimingDto.fromJS(_data["timing"]) : <any>undefined;
            this.clock = _data["clock"] ? ClockDto.fromJS(_data["clock"]) : <any>undefined;
            this.objectExtensions = _data["objectExtensions"] ? ObjectExtensionsDto.fromJS(_data["objectExtensions"]) : <any>undefined;
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["globalFeatures"] = this.globalFeatures ? this.globalFeatures.toJSON() : <any>undefined;
        data["multiTenancy"] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
        data["currentTenant"] = this.currentTenant ? this.currentTenant.toJSON() : <any>undefined;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["objectExtensions"] = this.objectExtensions ? this.objectExtensions.toJSON() : <any>undefined;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        return data;
    }
}

export interface IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    globalFeatures?: ApplicationGlobalFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;
    extraProperties?: { [key: string]: any; } | undefined;
}

export class ApplicationFeatureConfigurationDto implements IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IApplicationFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }
}

export interface IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; } | undefined;
}

export class ApplicationGlobalFeatureConfigurationDto implements IApplicationGlobalFeatureConfigurationDto {
    enabledFeatures?: (string | undefined)[] | undefined;

    constructor(data?: IApplicationGlobalFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledFeatures"])) {
                this.enabledFeatures = [] as any;
                for (let item of _data["enabledFeatures"])
                    this.enabledFeatures!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationGlobalFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationGlobalFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledFeatures)) {
            data["enabledFeatures"] = [];
            for (let item of this.enabledFeatures)
                data["enabledFeatures"].push(item);
        }
        return data;
    }
}

export interface IApplicationGlobalFeatureConfigurationDto {
    enabledFeatures?: (string | undefined)[] | undefined;
}

export class ApplicationLocalizationConfigurationDto implements IApplicationLocalizationConfigurationDto {
    values?: { [key: string]: { [key: string]: string; }; } | undefined;
    resources?: { [key: string]: ApplicationLocalizationResourceDto; } | undefined;
    languages?: LanguageInfo[] | undefined;
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; } | undefined;
    languageFilesMap?: { [key: string]: NameValue[]; } | undefined;

    constructor(data?: IApplicationLocalizationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key] !== undefined ? _data["values"][key] : {};
                }
            }
            if (_data["resources"]) {
                this.resources = {} as any;
                for (let key in _data["resources"]) {
                    if (_data["resources"].hasOwnProperty(key))
                        (<any>this.resources)![key] = _data["resources"][key] ? ApplicationLocalizationResourceDto.fromJS(_data["resources"][key]) : new ApplicationLocalizationResourceDto();
                }
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageInfo.fromJS(item));
            }
            this.currentCulture = _data["currentCulture"] ? CurrentCultureDto.fromJS(_data["currentCulture"]) : <any>undefined;
            this.defaultResourceName = _data["defaultResourceName"];
            if (_data["languagesMap"]) {
                this.languagesMap = {} as any;
                for (let key in _data["languagesMap"]) {
                    if (_data["languagesMap"].hasOwnProperty(key))
                        (<any>this.languagesMap)![key] = _data["languagesMap"][key] ? _data["languagesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
            if (_data["languageFilesMap"]) {
                this.languageFilesMap = {} as any;
                for (let key in _data["languageFilesMap"]) {
                    if (_data["languageFilesMap"].hasOwnProperty(key))
                        (<any>this.languageFilesMap)![key] = _data["languageFilesMap"][key] ? _data["languageFilesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationLocalizationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        if (this.resources) {
            data["resources"] = {};
            for (let key in this.resources) {
                if (this.resources.hasOwnProperty(key))
                    (<any>data["resources"])[key] = this.resources[key] ? this.resources[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        data["defaultResourceName"] = this.defaultResourceName;
        if (this.languagesMap) {
            data["languagesMap"] = {};
            for (let key in this.languagesMap) {
                if (this.languagesMap.hasOwnProperty(key))
                    (<any>data["languagesMap"])[key] = (<any>this.languagesMap)[key];
            }
        }
        if (this.languageFilesMap) {
            data["languageFilesMap"] = {};
            for (let key in this.languageFilesMap) {
                if (this.languageFilesMap.hasOwnProperty(key))
                    (<any>data["languageFilesMap"])[key] = (<any>this.languageFilesMap)[key];
            }
        }
        return data;
    }
}

export interface IApplicationLocalizationConfigurationDto {
    values?: { [key: string]: { [key: string]: string; }; } | undefined;
    resources?: { [key: string]: ApplicationLocalizationResourceDto; } | undefined;
    languages?: LanguageInfo[] | undefined;
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; } | undefined;
    languageFilesMap?: { [key: string]: NameValue[]; } | undefined;
}

export class ApplicationLocalizationDto implements IApplicationLocalizationDto {
    resources?: { [key: string]: ApplicationLocalizationResourceDto; } | undefined;
    currentCulture?: CurrentCultureDto;

    constructor(data?: IApplicationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["resources"]) {
                this.resources = {} as any;
                for (let key in _data["resources"]) {
                    if (_data["resources"].hasOwnProperty(key))
                        (<any>this.resources)![key] = _data["resources"][key] ? ApplicationLocalizationResourceDto.fromJS(_data["resources"][key]) : new ApplicationLocalizationResourceDto();
                }
            }
            this.currentCulture = _data["currentCulture"] ? CurrentCultureDto.fromJS(_data["currentCulture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.resources) {
            data["resources"] = {};
            for (let key in this.resources) {
                if (this.resources.hasOwnProperty(key))
                    (<any>data["resources"])[key] = this.resources[key] ? this.resources[key].toJSON() : <any>undefined;
            }
        }
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationLocalizationDto {
    resources?: { [key: string]: ApplicationLocalizationResourceDto; } | undefined;
    currentCulture?: CurrentCultureDto;
}

export class ApplicationLocalizationResourceDto implements IApplicationLocalizationResourceDto {
    texts?: { [key: string]: string; } | undefined;
    baseResources?: (string | undefined)[] | undefined;

    constructor(data?: IApplicationLocalizationResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["texts"]) {
                this.texts = {} as any;
                for (let key in _data["texts"]) {
                    if (_data["texts"].hasOwnProperty(key))
                        (<any>this.texts)![key] = _data["texts"][key];
                }
            }
            if (Array.isArray(_data["baseResources"])) {
                this.baseResources = [] as any;
                for (let item of _data["baseResources"])
                    this.baseResources!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationLocalizationResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.texts) {
            data["texts"] = {};
            for (let key in this.texts) {
                if (this.texts.hasOwnProperty(key))
                    (<any>data["texts"])[key] = (<any>this.texts)[key];
            }
        }
        if (Array.isArray(this.baseResources)) {
            data["baseResources"] = [];
            for (let item of this.baseResources)
                data["baseResources"].push(item);
        }
        return data;
    }
}

export interface IApplicationLocalizationResourceDto {
    texts?: { [key: string]: string; } | undefined;
    baseResources?: (string | undefined)[] | undefined;
}

export class ApplicationSettingConfigurationDto implements IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IApplicationSettingConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationSettingConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettingConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }
}

export interface IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; } | undefined;
}

export class ClockDto implements IClockDto {
    kind?: string | undefined;

    constructor(data?: IClockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): ClockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        return data;
    }
}

export interface IClockDto {
    kind?: string | undefined;
}

export class CurrentCultureDto implements ICurrentCultureDto {
    displayName?: string | undefined;
    englishName?: string | undefined;
    threeLetterIsoLanguageName?: string | undefined;
    twoLetterIsoLanguageName?: string | undefined;
    isRightToLeft?: boolean;
    cultureName?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    dateTimeFormat?: DateTimeFormatDto;

    constructor(data?: ICurrentCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.englishName = _data["englishName"];
            this.threeLetterIsoLanguageName = _data["threeLetterIsoLanguageName"];
            this.twoLetterIsoLanguageName = _data["twoLetterIsoLanguageName"];
            this.isRightToLeft = _data["isRightToLeft"];
            this.cultureName = _data["cultureName"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.dateTimeFormat = _data["dateTimeFormat"] ? DateTimeFormatDto.fromJS(_data["dateTimeFormat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["englishName"] = this.englishName;
        data["threeLetterIsoLanguageName"] = this.threeLetterIsoLanguageName;
        data["twoLetterIsoLanguageName"] = this.twoLetterIsoLanguageName;
        data["isRightToLeft"] = this.isRightToLeft;
        data["cultureName"] = this.cultureName;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["dateTimeFormat"] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurrentCultureDto {
    displayName?: string | undefined;
    englishName?: string | undefined;
    threeLetterIsoLanguageName?: string | undefined;
    twoLetterIsoLanguageName?: string | undefined;
    isRightToLeft?: boolean;
    cultureName?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    dateTimeFormat?: DateTimeFormatDto;
}

export class CurrentUserDto implements ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    impersonatorUserId?: string | undefined;
    impersonatorTenantId?: string | undefined;
    impersonatorUserName?: string | undefined;
    impersonatorTenantName?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: (string | undefined)[] | undefined;
    sessionId?: string | undefined;

    constructor(data?: ICurrentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserName = _data["impersonatorUserName"];
            this.impersonatorTenantName = _data["impersonatorTenantName"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surName = _data["surName"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): CurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserName"] = this.impersonatorUserName;
        data["impersonatorTenantName"] = this.impersonatorTenantName;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    impersonatorUserId?: string | undefined;
    impersonatorTenantId?: string | undefined;
    impersonatorUserName?: string | undefined;
    impersonatorTenantName?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: (string | undefined)[] | undefined;
    sessionId?: string | undefined;
}

export class DateTimeFormatDto implements IDateTimeFormatDto {
    calendarAlgorithmType?: string | undefined;
    dateTimeFormatLong?: string | undefined;
    shortDatePattern?: string | undefined;
    fullDateTimePattern?: string | undefined;
    dateSeparator?: string | undefined;
    shortTimePattern?: string | undefined;
    longTimePattern?: string | undefined;

    constructor(data?: IDateTimeFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarAlgorithmType = _data["calendarAlgorithmType"];
            this.dateTimeFormatLong = _data["dateTimeFormatLong"];
            this.shortDatePattern = _data["shortDatePattern"];
            this.fullDateTimePattern = _data["fullDateTimePattern"];
            this.dateSeparator = _data["dateSeparator"];
            this.shortTimePattern = _data["shortTimePattern"];
            this.longTimePattern = _data["longTimePattern"];
        }
    }

    static fromJS(data: any): DateTimeFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarAlgorithmType"] = this.calendarAlgorithmType;
        data["dateTimeFormatLong"] = this.dateTimeFormatLong;
        data["shortDatePattern"] = this.shortDatePattern;
        data["fullDateTimePattern"] = this.fullDateTimePattern;
        data["dateSeparator"] = this.dateSeparator;
        data["shortTimePattern"] = this.shortTimePattern;
        data["longTimePattern"] = this.longTimePattern;
        return data;
    }
}

export interface IDateTimeFormatDto {
    calendarAlgorithmType?: string | undefined;
    dateTimeFormatLong?: string | undefined;
    shortDatePattern?: string | undefined;
    fullDateTimePattern?: string | undefined;
    dateSeparator?: string | undefined;
    shortTimePattern?: string | undefined;
    longTimePattern?: string | undefined;
}

export class IanaTimeZone implements IIanaTimeZone {
    timeZoneName?: string | undefined;

    constructor(data?: IIanaTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneName = _data["timeZoneName"];
        }
    }

    static fromJS(data: any): IanaTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new IanaTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneName"] = this.timeZoneName;
        return data;
    }
}

export interface IIanaTimeZone {
    timeZoneName?: string | undefined;
}

export class EntityExtensionDto implements IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;

    constructor(data?: IEntityExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] ? ExtensionPropertyDto.fromJS(_data["properties"][key]) : new ExtensionPropertyDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): EntityExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] ? this.properties[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        return data;
    }
}

export interface IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;
}

export class ExtensionEnumDto implements IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[] | undefined;
    localizationResource?: string | undefined;

    constructor(data?: IExtensionEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ExtensionEnumFieldDto.fromJS(item));
            }
            this.localizationResource = _data["localizationResource"];
        }
    }

    static fromJS(data: any): ExtensionEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["localizationResource"] = this.localizationResource;
        return data;
    }
}

export interface IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[] | undefined;
    localizationResource?: string | undefined;
}

export class ExtensionEnumFieldDto implements IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;

    constructor(data?: IExtensionEnumFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExtensionEnumFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;
}

export class ExtensionPropertyApiCreateDto implements IExtensionPropertyApiCreateDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiCreateDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyApiDto implements IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;

    constructor(data?: IExtensionPropertyApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onGet = _data["onGet"] ? ExtensionPropertyApiGetDto.fromJS(_data["onGet"]) : <any>undefined;
            this.onCreate = _data["onCreate"] ? ExtensionPropertyApiCreateDto.fromJS(_data["onCreate"]) : <any>undefined;
            this.onUpdate = _data["onUpdate"] ? ExtensionPropertyApiUpdateDto.fromJS(_data["onUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onGet"] = this.onGet ? this.onGet.toJSON() : <any>undefined;
        data["onCreate"] = this.onCreate ? this.onCreate.toJSON() : <any>undefined;
        data["onUpdate"] = this.onUpdate ? this.onUpdate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;
}

export class ExtensionPropertyApiGetDto implements IExtensionPropertyApiGetDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiGetDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyApiUpdateDto implements IExtensionPropertyApiUpdateDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiUpdateDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyAttributeDto implements IExtensionPropertyAttributeDto {
    typeSimple?: string | undefined;
    config?: { [key: string]: any; } | undefined;

    constructor(data?: IExtensionPropertyAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeSimple = _data["typeSimple"];
            if (_data["config"]) {
                this.config = {} as any;
                for (let key in _data["config"]) {
                    if (_data["config"].hasOwnProperty(key))
                        (<any>this.config)![key] = _data["config"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExtensionPropertyAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeSimple"] = this.typeSimple;
        if (this.config) {
            data["config"] = {};
            for (let key in this.config) {
                if (this.config.hasOwnProperty(key))
                    (<any>data["config"])[key] = (<any>this.config)[key];
            }
        }
        return data;
    }
}

export interface IExtensionPropertyAttributeDto {
    typeSimple?: string | undefined;
    config?: { [key: string]: any; } | undefined;
}

export class ExtensionPropertyDto implements IExtensionPropertyDto {
    type?: string | undefined;
    typeSimple?: string | undefined;
    displayName?: LocalizableStringDto;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    policy?: ExtensionPropertyPolicyDto;
    attributes?: ExtensionPropertyAttributeDto[] | undefined;
    configuration?: { [key: string]: any; } | undefined;
    defaultValue?: any | undefined;

    constructor(data?: IExtensionPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.displayName = _data["displayName"] ? LocalizableStringDto.fromJS(_data["displayName"]) : <any>undefined;
            this.api = _data["api"] ? ExtensionPropertyApiDto.fromJS(_data["api"]) : <any>undefined;
            this.ui = _data["ui"] ? ExtensionPropertyUiDto.fromJS(_data["ui"]) : <any>undefined;
            this.policy = _data["policy"] ? ExtensionPropertyPolicyDto.fromJS(_data["policy"]) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ExtensionPropertyAttributeDto.fromJS(item));
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ExtensionPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["displayName"] = this.displayName ? this.displayName.toJSON() : <any>undefined;
        data["api"] = this.api ? this.api.toJSON() : <any>undefined;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IExtensionPropertyDto {
    type?: string | undefined;
    typeSimple?: string | undefined;
    displayName?: LocalizableStringDto;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    policy?: ExtensionPropertyPolicyDto;
    attributes?: ExtensionPropertyAttributeDto[] | undefined;
    configuration?: { [key: string]: any; } | undefined;
    defaultValue?: any | undefined;
}

export class ExtensionPropertyFeaturePolicyDto implements IExtensionPropertyFeaturePolicyDto {
    features?: (string | undefined)[] | undefined;
    requiresAll?: boolean;

    constructor(data?: IExtensionPropertyFeaturePolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.requiresAll = _data["requiresAll"];
        }
    }

    static fromJS(data: any): ExtensionPropertyFeaturePolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyFeaturePolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["requiresAll"] = this.requiresAll;
        return data;
    }
}

export interface IExtensionPropertyFeaturePolicyDto {
    features?: (string | undefined)[] | undefined;
    requiresAll?: boolean;
}

export class ExtensionPropertyGlobalFeaturePolicyDto implements IExtensionPropertyGlobalFeaturePolicyDto {
    features?: (string | undefined)[] | undefined;
    requiresAll?: boolean;

    constructor(data?: IExtensionPropertyGlobalFeaturePolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.requiresAll = _data["requiresAll"];
        }
    }

    static fromJS(data: any): ExtensionPropertyGlobalFeaturePolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyGlobalFeaturePolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["requiresAll"] = this.requiresAll;
        return data;
    }
}

export interface IExtensionPropertyGlobalFeaturePolicyDto {
    features?: (string | undefined)[] | undefined;
    requiresAll?: boolean;
}

export class ExtensionPropertyPermissionPolicyDto implements IExtensionPropertyPermissionPolicyDto {
    permissionNames?: (string | undefined)[] | undefined;
    requiresAll?: boolean;

    constructor(data?: IExtensionPropertyPermissionPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissionNames"])) {
                this.permissionNames = [] as any;
                for (let item of _data["permissionNames"])
                    this.permissionNames!.push(item);
            }
            this.requiresAll = _data["requiresAll"];
        }
    }

    static fromJS(data: any): ExtensionPropertyPermissionPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyPermissionPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissionNames)) {
            data["permissionNames"] = [];
            for (let item of this.permissionNames)
                data["permissionNames"].push(item);
        }
        data["requiresAll"] = this.requiresAll;
        return data;
    }
}

export interface IExtensionPropertyPermissionPolicyDto {
    permissionNames?: (string | undefined)[] | undefined;
    requiresAll?: boolean;
}

export class ExtensionPropertyPolicyDto implements IExtensionPropertyPolicyDto {
    globalFeatures?: ExtensionPropertyGlobalFeaturePolicyDto;
    features?: ExtensionPropertyFeaturePolicyDto;
    permissions?: ExtensionPropertyPermissionPolicyDto;

    constructor(data?: IExtensionPropertyPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalFeatures = _data["globalFeatures"] ? ExtensionPropertyGlobalFeaturePolicyDto.fromJS(_data["globalFeatures"]) : <any>undefined;
            this.features = _data["features"] ? ExtensionPropertyFeaturePolicyDto.fromJS(_data["features"]) : <any>undefined;
            this.permissions = _data["permissions"] ? ExtensionPropertyPermissionPolicyDto.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalFeatures"] = this.globalFeatures ? this.globalFeatures.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionPropertyPolicyDto {
    globalFeatures?: ExtensionPropertyGlobalFeaturePolicyDto;
    features?: ExtensionPropertyFeaturePolicyDto;
    permissions?: ExtensionPropertyPermissionPolicyDto;
}

export class ExtensionPropertyUiDto implements IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;

    constructor(data?: IExtensionPropertyUiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onTable = _data["onTable"] ? ExtensionPropertyUiTableDto.fromJS(_data["onTable"]) : <any>undefined;
            this.onCreateForm = _data["onCreateForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onCreateForm"]) : <any>undefined;
            this.onEditForm = _data["onEditForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onEditForm"]) : <any>undefined;
            this.lookup = _data["lookup"] ? ExtensionPropertyUiLookupDto.fromJS(_data["lookup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyUiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onTable"] = this.onTable ? this.onTable.toJSON() : <any>undefined;
        data["onCreateForm"] = this.onCreateForm ? this.onCreateForm.toJSON() : <any>undefined;
        data["onEditForm"] = this.onEditForm ? this.onEditForm.toJSON() : <any>undefined;
        data["lookup"] = this.lookup ? this.lookup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;
}

export class ExtensionPropertyUiFormDto implements IExtensionPropertyUiFormDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IExtensionPropertyUiFormDto {
    isVisible?: boolean;
}

export class ExtensionPropertyUiLookupDto implements IExtensionPropertyUiLookupDto {
    url?: string | undefined;
    resultListPropertyName?: string | undefined;
    displayPropertyName?: string | undefined;
    valuePropertyName?: string | undefined;
    filterParamName?: string | undefined;

    constructor(data?: IExtensionPropertyUiLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.resultListPropertyName = _data["resultListPropertyName"];
            this.displayPropertyName = _data["displayPropertyName"];
            this.valuePropertyName = _data["valuePropertyName"];
            this.filterParamName = _data["filterParamName"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["resultListPropertyName"] = this.resultListPropertyName;
        data["displayPropertyName"] = this.displayPropertyName;
        data["valuePropertyName"] = this.valuePropertyName;
        data["filterParamName"] = this.filterParamName;
        return data;
    }
}

export interface IExtensionPropertyUiLookupDto {
    url?: string | undefined;
    resultListPropertyName?: string | undefined;
    displayPropertyName?: string | undefined;
    valuePropertyName?: string | undefined;
    filterParamName?: string | undefined;
}

export class ExtensionPropertyUiTableDto implements IExtensionPropertyUiTableDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IExtensionPropertyUiTableDto {
    isVisible?: boolean;
}

export class LocalizableStringDto implements ILocalizableStringDto {
    name?: string | undefined;
    resource?: string | undefined;

    constructor(data?: ILocalizableStringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): LocalizableStringDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableStringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resource"] = this.resource;
        return data;
    }
}

export interface ILocalizableStringDto {
    name?: string | undefined;
    resource?: string | undefined;
}

export class ModuleExtensionDto implements IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;

    constructor(data?: IModuleExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["entities"]) {
                this.entities = {} as any;
                for (let key in _data["entities"]) {
                    if (_data["entities"].hasOwnProperty(key))
                        (<any>this.entities)![key] = _data["entities"][key] ? EntityExtensionDto.fromJS(_data["entities"][key]) : new EntityExtensionDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): ModuleExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entities) {
            data["entities"] = {};
            for (let key in this.entities) {
                if (this.entities.hasOwnProperty(key))
                    (<any>data["entities"])[key] = this.entities[key] ? this.entities[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        return data;
    }
}

export interface IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;
}

export class ObjectExtensionsDto implements IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; } | undefined;
    enums?: { [key: string]: ExtensionEnumDto; } | undefined;

    constructor(data?: IObjectExtensionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleExtensionDto.fromJS(_data["modules"][key]) : new ModuleExtensionDto();
                }
            }
            if (_data["enums"]) {
                this.enums = {} as any;
                for (let key in _data["enums"]) {
                    if (_data["enums"].hasOwnProperty(key))
                        (<any>this.enums)![key] = _data["enums"][key] ? ExtensionEnumDto.fromJS(_data["enums"][key]) : new ExtensionEnumDto();
                }
            }
        }
    }

    static fromJS(data: any): ObjectExtensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectExtensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.enums) {
            data["enums"] = {};
            for (let key in this.enums) {
                if (this.enums.hasOwnProperty(key))
                    (<any>data["enums"])[key] = this.enums[key] ? this.enums[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; } | undefined;
    enums?: { [key: string]: ExtensionEnumDto; } | undefined;
}

export class TimeZone implements ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iana = _data["iana"] ? IanaTimeZone.fromJS(_data["iana"]) : <any>undefined;
            this.windows = _data["windows"] ? WindowsTimeZone.fromJS(_data["windows"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iana"] = this.iana ? this.iana.toJSON() : <any>undefined;
        data["windows"] = this.windows ? this.windows.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;
}

export class TimingDto implements ITimingDto {
    timeZone?: TimeZone;

    constructor(data?: ITimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"] ? TimeZone.fromJS(_data["timeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimingDto {
    timeZone?: TimeZone;
}

export class WindowsTimeZone implements IWindowsTimeZone {
    timeZoneId?: string | undefined;

    constructor(data?: IWindowsTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): WindowsTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new WindowsTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface IWindowsTimeZone {
    timeZoneId?: string | undefined;
}

export class CurrentTenantDto implements ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;

    constructor(data?: ICurrentTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): CurrentTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;
}

export class MultiTenancyInfoDto implements IMultiTenancyInfoDto {
    isEnabled?: boolean;

    constructor(data?: IMultiTenancyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): MultiTenancyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenancyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IMultiTenancyInfoDto {
    isEnabled?: boolean;
}

export class ActionApiDescriptionModel implements IActionApiDescriptionModel {
    uniqueName?: string | undefined;
    name?: string | undefined;
    httpMethod?: string | undefined;
    url?: string | undefined;
    supportedVersions?: (string | undefined)[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    parameters?: ParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;
    allowAnonymous?: boolean | undefined;
    implementFrom?: string | undefined;

    constructor(data?: IActionApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueName = _data["uniqueName"];
            this.name = _data["name"];
            this.httpMethod = _data["httpMethod"];
            this.url = _data["url"];
            if (Array.isArray(_data["supportedVersions"])) {
                this.supportedVersions = [] as any;
                for (let item of _data["supportedVersions"])
                    this.supportedVersions!.push(item);
            }
            if (Array.isArray(_data["parametersOnMethod"])) {
                this.parametersOnMethod = [] as any;
                for (let item of _data["parametersOnMethod"])
                    this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterApiDescriptionModel.fromJS(item));
            }
            this.returnValue = _data["returnValue"] ? ReturnValueApiDescriptionModel.fromJS(_data["returnValue"]) : <any>undefined;
            this.allowAnonymous = _data["allowAnonymous"];
            this.implementFrom = _data["implementFrom"];
        }
    }

    static fromJS(data: any): ActionApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueName"] = this.uniqueName;
        data["name"] = this.name;
        data["httpMethod"] = this.httpMethod;
        data["url"] = this.url;
        if (Array.isArray(this.supportedVersions)) {
            data["supportedVersions"] = [];
            for (let item of this.supportedVersions)
                data["supportedVersions"].push(item);
        }
        if (Array.isArray(this.parametersOnMethod)) {
            data["parametersOnMethod"] = [];
            for (let item of this.parametersOnMethod)
                data["parametersOnMethod"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["returnValue"] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
        data["allowAnonymous"] = this.allowAnonymous;
        data["implementFrom"] = this.implementFrom;
        return data;
    }
}

export interface IActionApiDescriptionModel {
    uniqueName?: string | undefined;
    name?: string | undefined;
    httpMethod?: string | undefined;
    url?: string | undefined;
    supportedVersions?: (string | undefined)[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    parameters?: ParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;
    allowAnonymous?: boolean | undefined;
    implementFrom?: string | undefined;
}

export class ApplicationApiDescriptionModel implements IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; } | undefined;
    types?: { [key: string]: TypeApiDescriptionModel; } | undefined;

    constructor(data?: IApplicationApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleApiDescriptionModel.fromJS(_data["modules"][key]) : new ModuleApiDescriptionModel();
                }
            }
            if (_data["types"]) {
                this.types = {} as any;
                for (let key in _data["types"]) {
                    if (_data["types"].hasOwnProperty(key))
                        (<any>this.types)![key] = _data["types"][key] ? TypeApiDescriptionModel.fromJS(_data["types"][key]) : new TypeApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ApplicationApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.types) {
            data["types"] = {};
            for (let key in this.types) {
                if (this.types.hasOwnProperty(key))
                    (<any>data["types"])[key] = this.types[key] ? this.types[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; } | undefined;
    types?: { [key: string]: TypeApiDescriptionModel; } | undefined;
}

export class ControllerApiDescriptionModel implements IControllerApiDescriptionModel {
    controllerName?: string | undefined;
    controllerGroupName?: string | undefined;
    isRemoteService?: boolean;
    isIntegrationService?: boolean;
    apiVersion?: string | undefined;
    type?: string | undefined;
    interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
    actions?: { [key: string]: ActionApiDescriptionModel; } | undefined;

    constructor(data?: IControllerApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controllerName = _data["controllerName"];
            this.controllerGroupName = _data["controllerGroupName"];
            this.isRemoteService = _data["isRemoteService"];
            this.isIntegrationService = _data["isIntegrationService"];
            this.apiVersion = _data["apiVersion"];
            this.type = _data["type"];
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(ControllerInterfaceApiDescriptionModel.fromJS(item));
            }
            if (_data["actions"]) {
                this.actions = {} as any;
                for (let key in _data["actions"]) {
                    if (_data["actions"].hasOwnProperty(key))
                        (<any>this.actions)![key] = _data["actions"][key] ? ActionApiDescriptionModel.fromJS(_data["actions"][key]) : new ActionApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ControllerApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerName"] = this.controllerName;
        data["controllerGroupName"] = this.controllerGroupName;
        data["isRemoteService"] = this.isRemoteService;
        data["isIntegrationService"] = this.isIntegrationService;
        data["apiVersion"] = this.apiVersion;
        data["type"] = this.type;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        if (this.actions) {
            data["actions"] = {};
            for (let key in this.actions) {
                if (this.actions.hasOwnProperty(key))
                    (<any>data["actions"])[key] = this.actions[key] ? this.actions[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IControllerApiDescriptionModel {
    controllerName?: string | undefined;
    controllerGroupName?: string | undefined;
    isRemoteService?: boolean;
    isIntegrationService?: boolean;
    apiVersion?: string | undefined;
    type?: string | undefined;
    interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
    actions?: { [key: string]: ActionApiDescriptionModel; } | undefined;
}

export class ControllerInterfaceApiDescriptionModel implements IControllerInterfaceApiDescriptionModel {
    type?: string | undefined;
    name?: string | undefined;
    methods?: InterfaceMethodApiDescriptionModel[] | undefined;

    constructor(data?: IControllerInterfaceApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            if (Array.isArray(_data["methods"])) {
                this.methods = [] as any;
                for (let item of _data["methods"])
                    this.methods!.push(InterfaceMethodApiDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControllerInterfaceApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerInterfaceApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        if (Array.isArray(this.methods)) {
            data["methods"] = [];
            for (let item of this.methods)
                data["methods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IControllerInterfaceApiDescriptionModel {
    type?: string | undefined;
    name?: string | undefined;
    methods?: InterfaceMethodApiDescriptionModel[] | undefined;
}

export class InterfaceMethodApiDescriptionModel implements IInterfaceMethodApiDescriptionModel {
    name?: string | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;

    constructor(data?: IInterfaceMethodApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parametersOnMethod"])) {
                this.parametersOnMethod = [] as any;
                for (let item of _data["parametersOnMethod"])
                    this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
            }
            this.returnValue = _data["returnValue"] ? ReturnValueApiDescriptionModel.fromJS(_data["returnValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InterfaceMethodApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceMethodApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parametersOnMethod)) {
            data["parametersOnMethod"] = [];
            for (let item of this.parametersOnMethod)
                data["parametersOnMethod"].push(item.toJSON());
        }
        data["returnValue"] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInterfaceMethodApiDescriptionModel {
    name?: string | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;
}

export class MethodParameterApiDescriptionModel implements IMethodParameterApiDescriptionModel {
    name?: string | undefined;
    typeAsString?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;

    constructor(data?: IMethodParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeAsString = _data["typeAsString"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): MethodParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MethodParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeAsString"] = this.typeAsString;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IMethodParameterApiDescriptionModel {
    name?: string | undefined;
    typeAsString?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
}

export class ModuleApiDescriptionModel implements IModuleApiDescriptionModel {
    rootPath?: string | undefined;
    remoteServiceName?: string | undefined;
    controllers?: { [key: string]: ControllerApiDescriptionModel; } | undefined;

    constructor(data?: IModuleApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootPath = _data["rootPath"];
            this.remoteServiceName = _data["remoteServiceName"];
            if (_data["controllers"]) {
                this.controllers = {} as any;
                for (let key in _data["controllers"]) {
                    if (_data["controllers"].hasOwnProperty(key))
                        (<any>this.controllers)![key] = _data["controllers"][key] ? ControllerApiDescriptionModel.fromJS(_data["controllers"][key]) : new ControllerApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ModuleApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootPath"] = this.rootPath;
        data["remoteServiceName"] = this.remoteServiceName;
        if (this.controllers) {
            data["controllers"] = {};
            for (let key in this.controllers) {
                if (this.controllers.hasOwnProperty(key))
                    (<any>data["controllers"])[key] = this.controllers[key] ? this.controllers[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IModuleApiDescriptionModel {
    rootPath?: string | undefined;
    remoteServiceName?: string | undefined;
    controllers?: { [key: string]: ControllerApiDescriptionModel; } | undefined;
}

export class ParameterApiDescriptionModel implements IParameterApiDescriptionModel {
    nameOnMethod?: string | undefined;
    name?: string | undefined;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: (string | undefined)[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;

    constructor(data?: IParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameOnMethod = _data["nameOnMethod"];
            this.name = _data["name"];
            this.jsonName = _data["jsonName"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["constraintTypes"])) {
                this.constraintTypes = [] as any;
                for (let item of _data["constraintTypes"])
                    this.constraintTypes!.push(item);
            }
            this.bindingSourceId = _data["bindingSourceId"];
            this.descriptorName = _data["descriptorName"];
        }
    }

    static fromJS(data: any): ParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameOnMethod"] = this.nameOnMethod;
        data["name"] = this.name;
        data["jsonName"] = this.jsonName;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.constraintTypes)) {
            data["constraintTypes"] = [];
            for (let item of this.constraintTypes)
                data["constraintTypes"].push(item);
        }
        data["bindingSourceId"] = this.bindingSourceId;
        data["descriptorName"] = this.descriptorName;
        return data;
    }
}

export interface IParameterApiDescriptionModel {
    nameOnMethod?: string | undefined;
    name?: string | undefined;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: (string | undefined)[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;
}

export class PropertyApiDescriptionModel implements IPropertyApiDescriptionModel {
    name?: string | undefined;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isRequired?: boolean;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    regex?: string | undefined;
    isNullable?: boolean;

    constructor(data?: IPropertyApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jsonName = _data["jsonName"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isRequired = _data["isRequired"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.regex = _data["regex"];
            this.isNullable = _data["isNullable"];
        }
    }

    static fromJS(data: any): PropertyApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jsonName"] = this.jsonName;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isRequired"] = this.isRequired;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["regex"] = this.regex;
        data["isNullable"] = this.isNullable;
        return data;
    }
}

export interface IPropertyApiDescriptionModel {
    name?: string | undefined;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isRequired?: boolean;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    regex?: string | undefined;
    isNullable?: boolean;
}

export class ReturnValueApiDescriptionModel implements IReturnValueApiDescriptionModel {
    type?: string | undefined;
    typeSimple?: string | undefined;

    constructor(data?: IReturnValueApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
        }
    }

    static fromJS(data: any): ReturnValueApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnValueApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        return data;
    }
}

export interface IReturnValueApiDescriptionModel {
    type?: string | undefined;
    typeSimple?: string | undefined;
}

export class TypeApiDescriptionModel implements ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: (string | undefined)[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: (string | undefined)[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;

    constructor(data?: ITypeApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseType = _data["baseType"];
            this.isEnum = _data["isEnum"];
            if (Array.isArray(_data["enumNames"])) {
                this.enumNames = [] as any;
                for (let item of _data["enumNames"])
                    this.enumNames!.push(item);
            }
            if (Array.isArray(_data["enumValues"])) {
                this.enumValues = [] as any;
                for (let item of _data["enumValues"])
                    this.enumValues!.push(item);
            }
            if (Array.isArray(_data["genericArguments"])) {
                this.genericArguments = [] as any;
                for (let item of _data["genericArguments"])
                    this.genericArguments!.push(item);
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyApiDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypeApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseType"] = this.baseType;
        data["isEnum"] = this.isEnum;
        if (Array.isArray(this.enumNames)) {
            data["enumNames"] = [];
            for (let item of this.enumNames)
                data["enumNames"].push(item);
        }
        if (Array.isArray(this.enumValues)) {
            data["enumValues"] = [];
            for (let item of this.enumValues)
                data["enumValues"].push(item);
        }
        if (Array.isArray(this.genericArguments)) {
            data["genericArguments"] = [];
            for (let item of this.genericArguments)
                data["genericArguments"].push(item);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: (string | undefined)[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: (string | undefined)[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;
}

export class RemoteServiceErrorInfo implements IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;

    constructor(data?: IRemoteServiceErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(RemoteServiceValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteServiceErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;
}

export class RemoteServiceErrorResponse implements IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;

    constructor(data?: IRemoteServiceErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? RemoteServiceErrorInfo.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoteServiceErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;
}

export class RemoteServiceValidationErrorInfo implements IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: (string | undefined)[] | undefined;

    constructor(data?: IRemoteServiceValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): RemoteServiceValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: (string | undefined)[] | undefined;
}

export class LanguageInfo implements ILanguageInfo {
    cultureName?: string | undefined;
    uiCultureName?: string | undefined;
    displayName?: string | undefined;
    readonly twoLetterISOLanguageName?: string | undefined;

    constructor(data?: ILanguageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureName = _data["cultureName"];
            this.uiCultureName = _data["uiCultureName"];
            this.displayName = _data["displayName"];
            (<any>this).twoLetterISOLanguageName = _data["twoLetterISOLanguageName"];
        }
    }

    static fromJS(data: any): LanguageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureName"] = this.cultureName;
        data["uiCultureName"] = this.uiCultureName;
        data["displayName"] = this.displayName;
        data["twoLetterISOLanguageName"] = this.twoLetterISOLanguageName;
        return data;
    }
}

export interface ILanguageInfo {
    cultureName?: string | undefined;
    uiCultureName?: string | undefined;
    displayName?: string | undefined;
    twoLetterISOLanguageName?: string | undefined;
}

export class NameValue implements INameValue {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name?: string | undefined;
    value?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

}